var _defineProperty = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _assertThisInitialized = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _construct = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/construct");

var _regeneratorRuntime = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _get = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _toConsumableArray = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Proyectos\\Solanas\\backend\\solanas-backend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

/*!
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t) {
  t.en = Object.assign(t.en || {}, {
    a: "Cannot upload file:",
    b: "Image toolbar",
    c: "Table toolbar",
    d: "Italic",
    e: "Choose heading",
    f: "Heading",
    g: "Insert image or file",
    h: "Block quote",
    i: "image widget",
    j: "Insert image",
    k: "Increase indent",
    l: "Decrease indent",
    m: "Insert table",
    n: "Header column",
    o: "Insert column left",
    p: "Insert column right",
    q: "Delete column",
    r: "Column",
    s: "Header row",
    t: "Insert row below",
    u: "Insert row above",
    v: "Delete row",
    w: "Row",
    x: "Merge cell up",
    y: "Merge cell right",
    z: "Merge cell down",
    aa: "Merge cell left",
    ab: "Split cell vertically",
    ac: "Split cell horizontally",
    ad: "Merge cells",
    ae: "Numbered List",
    af: "Bulleted List",
    ag: "Bold",
    ah: "Full size image",
    ai: "Side image",
    aj: "Left aligned image",
    ak: "Centered image",
    al: "Right aligned image",
    am: "Enter image caption",
    an: "Upload failed",
    ao: "Insert media",
    ap: "The URL must not be empty.",
    aq: "This media URL is not supported.",
    ar: "media widget",
    as: "Link",
    at: "Could not obtain resized image URL.",
    au: "Selecting resized image failed",
    av: "Could not insert image at the current position.",
    aw: "Inserting image failed",
    ax: "Widget toolbar",
    ay: "Upload in progress",
    az: "Open in a new tab",
    ba: "Downloadable",
    bb: "Unlink",
    bc: "Edit link",
    bd: "Open link in new tab",
    be: "This link has no URL",
    bf: "Save",
    bg: "Cancel",
    bh: "Paste the media URL in the input.",
    bi: "Tip: Paste the URL into the content to embed faster.",
    bj: "Media URL",
    bk: "Link URL",
    bl: "Rich Text Editor",
    bm: "Dropdown toolbar",
    bn: "%0 of %1",
    bo: "Previous",
    bp: "Next",
    bq: "Editor toolbar",
    br: "Show more items",
    bs: "Undo",
    bt: "Redo",
    bu: "Rich Text Editor, %0",
    bv: "Change image text alternative",
    bw: "Paragraph",
    bx: "Heading 1",
    by: "Heading 2",
    bz: "Heading 3",
    ca: "Heading 4",
    cb: "Heading 5",
    cc: "Heading 6",
    cd: "Text alternative"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ClassicEditor = e() : t.ClassicEditor = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var o = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(i, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 90);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return o;
    }), n.d(e, "a", function () {
      return r;
    });
    var i = "https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html";

    var o =
    /*#__PURE__*/
    function (_Error) {
      _inherits(o, _Error);

      function o(t, e, n) {
        var _this;

        _classCallCheck(this, o);

        t = r(t), n && (t += " " + JSON.stringify(n)), _this = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, t)), _this.name = "CKEditorError", _this.context = e, _this.data = n;
        return _this;
      }

      _createClass(o, [{
        key: "is",
        value: function is(t) {
          return "CKEditorError" === t;
        }
      }], [{
        key: "rethrowUnexpectedError",
        value: function rethrowUnexpectedError(t, e) {
          if (t.is && t.is("CKEditorError")) throw t;
          var n = new o(t.message, e);
          throw n.stack = t.stack, n;
        }
      }]);

      return o;
    }(_wrapNativeSuper(Error));

    function r(t) {
      var e = t.match(/^([^:]+):/);
      return e ? t + " Read more: ".concat(i, "#error-").concat(e[1], "\n") : t;
    }
  }, function (t, e, n) {
    "use strict";

    var i,
        o = {},
        r = function r() {
      return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
    },
        s = function () {
      var t = {};
      return function (e) {
        if (void 0 === t[e]) {
          var n = document.querySelector(e);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }();

    function a(t, e) {
      for (var n = [], i = {}, o = 0; o < t.length; o++) {
        var r = t[o],
            s = e.base ? r[0] + e.base : r[0],
            a = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        i[s] ? i[s].parts.push(a) : n.push(i[s] = {
          id: s,
          parts: [a]
        });
      }

      return n;
    }

    function c(t, e) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n],
            r = o[i.id],
            s = 0;

        if (r) {
          for (r.refs++; s < r.parts.length; s++) {
            r.parts[s](i.parts[s]);
          }

          for (; s < i.parts.length; s++) {
            r.parts.push(p(i.parts[s], e));
          }
        } else {
          for (var a = []; s < i.parts.length; s++) {
            a.push(p(i.parts[s], e));
          }

          o[i.id] = {
            id: i.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function l(t) {
      var e = document.createElement("style");

      if (void 0 === t.attributes.nonce) {
        var i = n.nc;
        i && (t.attributes.nonce = i);
      }

      if (Object.keys(t.attributes).forEach(function (n) {
        e.setAttribute(n, t.attributes[n]);
      }), "function" == typeof t.insert) t.insert(e);else {
        var o = s(t.insert || "head");
        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(e);
      }
      return e;
    }

    var d,
        h = (d = [], function (t, e) {
      return d[t] = e, d.filter(Boolean).join("\n");
    });

    function u(t, e, n, i) {
      var o = n ? "" : i.css;
      if (t.styleSheet) t.styleSheet.cssText = h(e, o);else {
        var r = document.createTextNode(o),
            s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
      }
    }

    function f(t, e, n) {
      var i = n.css,
          o = n.media,
          r = n.sourceMap;
      if (o && t.setAttribute("media", o), r && btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), t.styleSheet) t.styleSheet.cssText = i;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }

        t.appendChild(document.createTextNode(i));
      }
    }

    var g = null,
        m = 0;

    function p(t, e) {
      var n, i, o;

      if (e.singleton) {
        var r = m++;
        n = g || (g = l(e)), i = u.bind(null, n, r, !1), o = u.bind(null, n, r, !0);
      } else n = l(e), i = f.bind(null, n, e), o = function o() {
        !function (t) {
          if (null === t.parentNode) return !1;
          t.parentNode.removeChild(t);
        }(n);
      };

      return i(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          i(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      (e = e || {}).attributes = "object" == typeof e.attributes ? e.attributes : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = r());
      var n = a(t, e);
      return c(n, e), function (t) {
        for (var i = [], r = 0; r < n.length; r++) {
          var s = n[r],
              l = o[s.id];
          l && (l.refs--, i.push(l));
        }

        t && c(a(t, e), e);

        for (var d = 0; d < i.length; d++) {
          var h = i[d];

          if (0 === h.refs) {
            for (var u = 0; u < h.parts.length; u++) {
              h.parts[u]();
            }

            delete o[h.id];
          }
        }
      };
    };
  },, function (t, e, n) {
    "use strict";

    var i = n(7),
        o = "object" == typeof self && self && self.Object === Object && self,
        r = i.a || o || Function("return this")();
    e.a = r;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(7),
          o = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = o && "object" == typeof t && t && !t.nodeType && t,
          s = r && r.exports === o && i.a.process,
          a = function () {
        try {
          var t = r && r.require && r.require("util").types;

          return t || s && s.binding && s.binding("util");
        } catch (t) {}
      }();

      e.a = a;
    }).call(this, n(8)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(3),
          o = n(11),
          r = "object" == typeof exports && exports && !exports.nodeType && exports,
          s = r && "object" == typeof t && t && !t.nodeType && t,
          a = s && s.exports === r ? i.a.Buffer : void 0,
          c = (a ? a.isBuffer : void 0) || o.a;
      e.a = c;
    }).call(this, n(8)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var e = n(0);
      var i = "object" == typeof window ? window : t;
      if (i.CKEDITOR_VERSION) throw new e.b("ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.", null);
      i.CKEDITOR_VERSION = "16.0.0";
    }).call(this, n(9));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(9));
  }, function (t, e) {
    t.exports = function (t) {
      if (!t.webpackPolyfill) {
        var e = Object.create(t);
        e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), Object.defineProperty(e, "exports", {
          enumerable: !0
        }), e.webpackPolyfill = 1;
      }

      return e;
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    var i = n(69);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e, n) {
    "use strict";

    e.a = function () {
      return !1;
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(3),
          o = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = o && "object" == typeof t && t && !t.nodeType && t,
          s = r && r.exports === o ? i.a.Buffer : void 0,
          a = s ? s.allocUnsafe : void 0;

      e.a = function (t, e) {
        if (e) return t.slice();
        var n = t.length,
            i = a ? a(n) : new t.constructor(n);
        return t.copy(i), i;
      };
    }).call(this, n(8)(t));
  }, function (t, e, n) {
    var i = n(14);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}";
  }, function (t, e, n) {
    var i = n(16);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border:#1f89e5;--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}";
  }, function (t, e, n) {
    var i = n(18);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}";
  }, function (t, e, n) {
    var i = n(20);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}";
  }, function (t, e, n) {
    var i = n(22);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}";
  }, function (t, e, n) {
    var i = n(24);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}";
  }, function (t, e, n) {
    var i = n(26);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}";
  }, function (t, e, n) {
    var i = n(28);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}';
  }, function (t, e, n) {
    var i = n(30);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(-1*var(--ck-spacing-small));margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}";
  }, function (t, e, n) {
    var i = n(32);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}";
  }, function (t, e, n) {
    var i = n(34);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:1.3846153847em}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(-1*var(--ck-switch-button-translation)))}";
  }, function (t, e, n) {
    var i = n(36);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}";
  }, function (t, e, n) {
    var i = n(38);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}";
  }, function (t, e, n) {
    var i = n(40);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar>.ck-toolbar__items>*{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar>.ck-toolbar__items>*,.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;margin-top:0;margin-bottom:0;background:var(--ck-color-toolbar-border)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__grouped-dropdown,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{padding-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__items>*,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__items>*{margin-left:var(--ck-spacing-small);margin-right:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__items>:last-child,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__items>:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__grouped-dropdown,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{padding-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__items>:last-child,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__items>:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{margin-right:var(--ck-spacing-small)}";
  }, function (t, e, n) {
    var i = n(42);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}";
  }, function (t, e, n) {
    var i = n(44);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}";
  }, function (t, e, n) {
    var i = n(46);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}";
  }, function (t, e, n) {
    var i = n(48);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle:hover,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-read-only .ck-widget{--ck-widget-outline-thickness:0}";
  }, function (t, e, n) {
    var i = n(50);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-labeled-input .ck-labeled-input__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-input .ck-labeled-input__status_error{color:var(--ck-color-base-error)}";
  }, function (t, e, n) {
    var i = n(52);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .2s ease-in-out,border .2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}";
  }, function (t, e, n) {
    var i = n(54);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-input{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-input{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}[dir=ltr] .ck.ck-text-alternative-form>:not(:first-child),[dir=rtl] .ck.ck-text-alternative-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-text-alternative-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(56);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}';
  }, function (t, e, n) {
    var i = n(58);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}";
  }, function (t, e, n) {
    var i = n(60);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}";
  }, function (t, e, n) {
    var i = n(62);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image>img{display:block;margin:0 auto;max-width:100%;min-width:50px}";
  }, function (t, e, n) {
    var i = n(64);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
  }, function (t, e, n) {
    var i = n(66);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
  }, function (t, e, n) {
    var i = n(68);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
  }, function (t, e) {
    t.exports = ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}";
  }, function (t, e, n) {
    var i = n(71);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}";
  }, function (t, e, n) {
    var i = n(73);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-align-center,.ck-content .image-style-align-left,.ck-content .image-style-align-right,.ck-content .image-style-side{max-width:50%}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}";
  }, function (t, e, n) {
    var i = n(75);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-input{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}[dir=ltr] .ck.ck-link-form>:not(:first-child),[dir=rtl] .ck.ck-link-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}";
  }, function (t, e, n) {
    var i = n(77);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(79);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c8,#b900b4,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
  }, function (t, e, n) {
    var i = n(81);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-input{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-input{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}[dir=ltr] .ck.ck-media-form>:not(:first-child),[dir=rtl] .ck.ck-media-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-input .ck-labeled-input__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-media-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-media-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-media-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(83);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}";
  }, function (t, e, n) {
    var i = n(85);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-color-table-focused-cell-background:#f5fafe}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}";
  }, function (t, e, n) {
    var i = n(87);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}";
  }, function (t, e, n) {
    var i = n(89);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border-color:#d9d9d9}.ck-content .table table th{font-weight:700;background:#fafafa}";
  }, function (t, e, n) {
    "use strict";

    var _marked =
    /*#__PURE__*/
    _regeneratorRuntime.mark(ec),
        _marked2 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(nc),
        _marked3 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(Ld);

    n.r(e);
    var i = n(3),
        o = i.a.Symbol,
        r = Object.prototype,
        s = r.hasOwnProperty,
        a = r.toString,
        c = o ? o.toStringTag : void 0;

    var l = function l(t) {
      var e = s.call(t, c),
          n = t[c];

      try {
        t[c] = void 0;
        var i = !0;
      } catch (t) {}

      var o = a.call(t);
      return i && (e ? t[c] = n : delete t[c]), o;
    },
        d = Object.prototype.toString;

    var h = function h(t) {
      return d.call(t);
    },
        u = "[object Null]",
        f = "[object Undefined]",
        g = o ? o.toStringTag : void 0;

    var m = function m(t) {
      return null == t ? void 0 === t ? f : u : g && g in Object(t) ? l(t) : h(t);
    };

    var p = function p(t, e) {
      return function (n) {
        return t(e(n));
      };
    },
        b = p(Object.getPrototypeOf, Object);

    var w = function w(t) {
      return null != t && "object" == typeof t;
    },
        k = "[object Object]",
        _ = Function.prototype,
        v = Object.prototype,
        y = _.toString,
        x = v.hasOwnProperty,
        A = y.call(Object);

    var T = function T(t) {
      if (!w(t) || m(t) != k) return !1;
      var e = b(t);
      if (null === e) return !0;
      var n = x.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && y.call(n) == A;
    };

    var C = function C() {
      this.__data__ = [], this.size = 0;
    };

    var P = function P(t, e) {
      return t === e || t != t && e != e;
    };

    var S = function S(t, e) {
      for (var n = t.length; n--;) {
        if (P(t[n][0], e)) return n;
      }

      return -1;
    },
        M = Array.prototype.splice;

    var E = function E(t) {
      var e = this.__data__,
          n = S(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : M.call(e, n, 1), --this.size, !0);
    };

    var I = function I(t) {
      var e = this.__data__,
          n = S(e, t);
      return n < 0 ? void 0 : e[n][1];
    };

    var N = function N(t) {
      return S(this.__data__, t) > -1;
    };

    var O = function O(t, e) {
      var n = this.__data__,
          i = S(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    };

    function R(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    R.prototype.clear = C, R.prototype.delete = E, R.prototype.get = I, R.prototype.has = N, R.prototype.set = O;
    var D = R;

    var L = function L() {
      this.__data__ = new D(), this.size = 0;
    };

    var j = function j(t) {
      var e = this.__data__,
          n = e.delete(t);
      return this.size = e.size, n;
    };

    var V = function V(t) {
      return this.__data__.get(t);
    };

    var z = function z(t) {
      return this.__data__.has(t);
    };

    var B = function B(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    },
        F = "[object AsyncFunction]",
        U = "[object Function]",
        H = "[object GeneratorFunction]",
        q = "[object Proxy]";

    var W,
        Y = function Y(t) {
      if (!B(t)) return !1;
      var e = m(t);
      return e == U || e == H || e == F || e == q;
    },
        $ = i.a["__core-js_shared__"],
        G = (W = /[^.]+$/.exec($ && $.keys && $.keys.IE_PROTO || "")) ? "Symbol(src)_1." + W : "";

    var Q = function Q(t) {
      return !!G && G in t;
    },
        K = Function.prototype.toString;

    var J = function J(t) {
      if (null != t) {
        try {
          return K.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    },
        Z = /^\[object .+?Constructor\]$/,
        X = Function.prototype,
        tt = Object.prototype,
        et = X.toString,
        nt = tt.hasOwnProperty,
        it = RegExp("^" + et.call(nt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    var ot = function ot(t) {
      return !(!B(t) || Q(t)) && (Y(t) ? it : Z).test(J(t));
    };

    var rt = function rt(t, e) {
      return null == t ? void 0 : t[e];
    };

    var st = function st(t, e) {
      var n = rt(t, e);
      return ot(n) ? n : void 0;
    },
        at = st(i.a, "Map"),
        ct = st(Object, "create");

    var lt = function lt() {
      this.__data__ = ct ? ct(null) : {}, this.size = 0;
    };

    var dt = function dt(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    },
        ht = "__lodash_hash_undefined__",
        ut = Object.prototype.hasOwnProperty;

    var ft = function ft(t) {
      var e = this.__data__;

      if (ct) {
        var n = e[t];
        return n === ht ? void 0 : n;
      }

      return ut.call(e, t) ? e[t] : void 0;
    },
        gt = Object.prototype.hasOwnProperty;

    var mt = function mt(t) {
      var e = this.__data__;
      return ct ? void 0 !== e[t] : gt.call(e, t);
    },
        pt = "__lodash_hash_undefined__";

    var bt = function bt(t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = ct && void 0 === e ? pt : e, this;
    };

    function wt(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    wt.prototype.clear = lt, wt.prototype.delete = dt, wt.prototype.get = ft, wt.prototype.has = mt, wt.prototype.set = bt;
    var kt = wt;

    var _t = function _t() {
      this.size = 0, this.__data__ = {
        hash: new kt(),
        map: new (at || D)(),
        string: new kt()
      };
    };

    var vt = function vt(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };

    var yt = function yt(t, e) {
      var n = t.__data__;
      return vt(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };

    var xt = function xt(t) {
      var e = yt(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };

    var At = function At(t) {
      return yt(this, t).get(t);
    };

    var Tt = function Tt(t) {
      return yt(this, t).has(t);
    };

    var Ct = function Ct(t, e) {
      var n = yt(this, t),
          i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    };

    function Pt(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    Pt.prototype.clear = _t, Pt.prototype.delete = xt, Pt.prototype.get = At, Pt.prototype.has = Tt, Pt.prototype.set = Ct;
    var St = Pt,
        Mt = 200;

    var Et = function Et(t, e) {
      var n = this.__data__;

      if (n instanceof D) {
        var i = n.__data__;
        if (!at || i.length < Mt - 1) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new St(i);
      }

      return n.set(t, e), this.size = n.size, this;
    };

    function It(t) {
      var e = this.__data__ = new D(t);
      this.size = e.size;
    }

    It.prototype.clear = L, It.prototype.delete = j, It.prototype.get = V, It.prototype.has = z, It.prototype.set = Et;
    var Nt = It;

    var Ot = function Ot(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i && !1 !== e(t[n], n, t);) {
        ;
      }

      return t;
    },
        Rt = function () {
      try {
        var t = st(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    var Dt = function Dt(t, e, n) {
      "__proto__" == e && Rt ? Rt(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    },
        Lt = Object.prototype.hasOwnProperty;

    var jt = function jt(t, e, n) {
      var i = t[e];
      Lt.call(t, e) && P(i, n) && (void 0 !== n || e in t) || Dt(t, e, n);
    };

    var Vt = function Vt(t, e, n, i) {
      var o = !n;
      n || (n = {});

      for (var r = -1, s = e.length; ++r < s;) {
        var a = e[r],
            c = i ? i(n[a], t[a], a, n, t) : void 0;
        void 0 === c && (c = t[a]), o ? Dt(n, a, c) : jt(n, a, c);
      }

      return n;
    };

    var zt = function zt(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) {
        i[n] = e(n);
      }

      return i;
    },
        Bt = "[object Arguments]";

    var Ft = function Ft(t) {
      return w(t) && m(t) == Bt;
    },
        Ut = Object.prototype,
        Ht = Ut.hasOwnProperty,
        qt = Ut.propertyIsEnumerable,
        Wt = Ft(function () {
      return arguments;
    }()) ? Ft : function (t) {
      return w(t) && Ht.call(t, "callee") && !qt.call(t, "callee");
    },
        Yt = Array.isArray,
        $t = n(5),
        Gt = 9007199254740991,
        Qt = /^(?:0|[1-9]\d*)$/;

    var Kt = function Kt(t, e) {
      var n = typeof t;
      return !!(e = null == e ? Gt : e) && ("number" == n || "symbol" != n && Qt.test(t)) && t > -1 && t % 1 == 0 && t < e;
    },
        Jt = 9007199254740991;

    var Zt = function Zt(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= Jt;
    },
        Xt = {};

    Xt["[object Float32Array]"] = Xt["[object Float64Array]"] = Xt["[object Int8Array]"] = Xt["[object Int16Array]"] = Xt["[object Int32Array]"] = Xt["[object Uint8Array]"] = Xt["[object Uint8ClampedArray]"] = Xt["[object Uint16Array]"] = Xt["[object Uint32Array]"] = !0, Xt["[object Arguments]"] = Xt["[object Array]"] = Xt["[object ArrayBuffer]"] = Xt["[object Boolean]"] = Xt["[object DataView]"] = Xt["[object Date]"] = Xt["[object Error]"] = Xt["[object Function]"] = Xt["[object Map]"] = Xt["[object Number]"] = Xt["[object Object]"] = Xt["[object RegExp]"] = Xt["[object Set]"] = Xt["[object String]"] = Xt["[object WeakMap]"] = !1;

    var te = function te(t) {
      return w(t) && Zt(t.length) && !!Xt[m(t)];
    };

    var ee = function ee(t) {
      return function (e) {
        return t(e);
      };
    },
        ne = n(4),
        ie = ne.a && ne.a.isTypedArray,
        oe = ie ? ee(ie) : te,
        re = Object.prototype.hasOwnProperty;

    var se = function se(t, e) {
      var n = Yt(t),
          i = !n && Wt(t),
          o = !n && !i && Object($t.a)(t),
          r = !n && !i && !o && oe(t),
          s = n || i || o || r,
          a = s ? zt(t.length, String) : [],
          c = a.length;

      for (var l in t) {
        !e && !re.call(t, l) || s && ("length" == l || o && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || Kt(l, c)) || a.push(l);
      }

      return a;
    },
        ae = Object.prototype;

    var ce = function ce(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || ae);
    },
        le = p(Object.keys, Object),
        de = Object.prototype.hasOwnProperty;

    var he = function he(t) {
      if (!ce(t)) return le(t);
      var e = [];

      for (var n in Object(t)) {
        de.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    };

    var ue = function ue(t) {
      return null != t && Zt(t.length) && !Y(t);
    };

    var fe = function fe(t) {
      return ue(t) ? se(t) : he(t);
    };

    var ge = function ge(t, e) {
      return t && Vt(e, fe(e), t);
    };

    var me = function me(t) {
      var e = [];
      if (null != t) for (var n in Object(t)) {
        e.push(n);
      }
      return e;
    },
        pe = Object.prototype.hasOwnProperty;

    var be = function be(t) {
      if (!B(t)) return me(t);
      var e = ce(t),
          n = [];

      for (var i in t) {
        ("constructor" != i || !e && pe.call(t, i)) && n.push(i);
      }

      return n;
    };

    var we = function we(t) {
      return ue(t) ? se(t, !0) : be(t);
    };

    var ke = function ke(t, e) {
      return t && Vt(e, we(e), t);
    },
        _e = n(12);

    var ve = function ve(t, e) {
      var n = -1,
          i = t.length;

      for (e || (e = Array(i)); ++n < i;) {
        e[n] = t[n];
      }

      return e;
    };

    var ye = function ye(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = 0, r = []; ++n < i;) {
        var s = t[n];
        e(s, n, t) && (r[o++] = s);
      }

      return r;
    };

    var xe = function xe() {
      return [];
    },
        Ae = Object.prototype.propertyIsEnumerable,
        Te = Object.getOwnPropertySymbols,
        Ce = Te ? function (t) {
      return null == t ? [] : (t = Object(t), ye(Te(t), function (e) {
        return Ae.call(t, e);
      }));
    } : xe;

    var Pe = function Pe(t, e) {
      return Vt(t, Ce(t), e);
    };

    var Se = function Se(t, e) {
      for (var n = -1, i = e.length, o = t.length; ++n < i;) {
        t[o + n] = e[n];
      }

      return t;
    },
        Me = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) {
        Se(e, Ce(t)), t = b(t);
      }

      return e;
    } : xe;

    var Ee = function Ee(t, e) {
      return Vt(t, Me(t), e);
    };

    var Ie = function Ie(t, e, n) {
      var i = e(t);
      return Yt(t) ? i : Se(i, n(t));
    };

    var Ne = function Ne(t) {
      return Ie(t, fe, Ce);
    };

    var Oe = function Oe(t) {
      return Ie(t, we, Me);
    },
        Re = st(i.a, "DataView"),
        De = st(i.a, "Promise"),
        Le = st(i.a, "Set"),
        je = st(i.a, "WeakMap"),
        Ve = J(Re),
        ze = J(at),
        Be = J(De),
        Fe = J(Le),
        Ue = J(je),
        He = m;

    (Re && "[object DataView]" != He(new Re(new ArrayBuffer(1))) || at && "[object Map]" != He(new at()) || De && "[object Promise]" != He(De.resolve()) || Le && "[object Set]" != He(new Le()) || je && "[object WeakMap]" != He(new je())) && (He = function He(t) {
      var e = m(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          i = n ? J(n) : "";
      if (i) switch (i) {
        case Ve:
          return "[object DataView]";

        case ze:
          return "[object Map]";

        case Be:
          return "[object Promise]";

        case Fe:
          return "[object Set]";

        case Ue:
          return "[object WeakMap]";
      }
      return e;
    });
    var qe = He,
        We = Object.prototype.hasOwnProperty;

    var Ye = function Ye(t) {
      var e = t.length,
          n = new t.constructor(e);
      return e && "string" == typeof t[0] && We.call(t, "index") && (n.index = t.index, n.input = t.input), n;
    },
        $e = i.a.Uint8Array;

    var Ge = function Ge(t) {
      var e = new t.constructor(t.byteLength);
      return new $e(e).set(new $e(t)), e;
    };

    var Qe = function Qe(t, e) {
      var n = e ? Ge(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    },
        Ke = /\w*$/;

    var Je = function Je(t) {
      var e = new t.constructor(t.source, Ke.exec(t));
      return e.lastIndex = t.lastIndex, e;
    },
        Ze = o ? o.prototype : void 0,
        Xe = Ze ? Ze.valueOf : void 0;

    var tn = function tn(t) {
      return Xe ? Object(Xe.call(t)) : {};
    };

    var en = function en(t, e) {
      var n = e ? Ge(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    },
        nn = "[object Boolean]",
        on = "[object Date]",
        rn = "[object Map]",
        sn = "[object Number]",
        an = "[object RegExp]",
        cn = "[object Set]",
        ln = "[object String]",
        dn = "[object Symbol]",
        hn = "[object ArrayBuffer]",
        un = "[object DataView]",
        fn = "[object Float32Array]",
        gn = "[object Float64Array]",
        mn = "[object Int8Array]",
        pn = "[object Int16Array]",
        bn = "[object Int32Array]",
        wn = "[object Uint8Array]",
        kn = "[object Uint8ClampedArray]",
        _n = "[object Uint16Array]",
        vn = "[object Uint32Array]";

    var yn = function yn(t, e, n) {
      var i = t.constructor;

      switch (e) {
        case hn:
          return Ge(t);

        case nn:
        case on:
          return new i(+t);

        case un:
          return Qe(t, n);

        case fn:
        case gn:
        case mn:
        case pn:
        case bn:
        case wn:
        case kn:
        case _n:
        case vn:
          return en(t, n);

        case rn:
          return new i();

        case sn:
        case ln:
          return new i(t);

        case an:
          return Je(t);

        case cn:
          return new i();

        case dn:
          return tn(t);
      }
    },
        xn = Object.create,
        An = function () {
      function t() {}

      return function (e) {
        if (!B(e)) return {};
        if (xn) return xn(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();

    var Tn = function Tn(t) {
      return "function" != typeof t.constructor || ce(t) ? {} : An(b(t));
    },
        Cn = "[object Map]";

    var Pn = function Pn(t) {
      return w(t) && qe(t) == Cn;
    },
        Sn = ne.a && ne.a.isMap,
        Mn = Sn ? ee(Sn) : Pn,
        En = "[object Set]";

    var In = function In(t) {
      return w(t) && qe(t) == En;
    },
        Nn = ne.a && ne.a.isSet,
        On = Nn ? ee(Nn) : In,
        Rn = 1,
        Dn = 2,
        Ln = 4,
        jn = "[object Arguments]",
        Vn = "[object Function]",
        zn = "[object GeneratorFunction]",
        Bn = "[object Object]",
        Fn = {};

    Fn[jn] = Fn["[object Array]"] = Fn["[object ArrayBuffer]"] = Fn["[object DataView]"] = Fn["[object Boolean]"] = Fn["[object Date]"] = Fn["[object Float32Array]"] = Fn["[object Float64Array]"] = Fn["[object Int8Array]"] = Fn["[object Int16Array]"] = Fn["[object Int32Array]"] = Fn["[object Map]"] = Fn["[object Number]"] = Fn[Bn] = Fn["[object RegExp]"] = Fn["[object Set]"] = Fn["[object String]"] = Fn["[object Symbol]"] = Fn["[object Uint8Array]"] = Fn["[object Uint8ClampedArray]"] = Fn["[object Uint16Array]"] = Fn["[object Uint32Array]"] = !0, Fn["[object Error]"] = Fn[Vn] = Fn["[object WeakMap]"] = !1;

    var Un = function t(e, n, i, o, r, s) {
      var a,
          c = n & Rn,
          l = n & Dn,
          d = n & Ln;
      if (i && (a = r ? i(e, o, r, s) : i(e)), void 0 !== a) return a;
      if (!B(e)) return e;
      var h = Yt(e);

      if (h) {
        if (a = Ye(e), !c) return ve(e, a);
      } else {
        var u = qe(e),
            f = u == Vn || u == zn;
        if (Object($t.a)(e)) return Object(_e.a)(e, c);

        if (u == Bn || u == jn || f && !r) {
          if (a = l || f ? {} : Tn(e), !c) return l ? Ee(e, ke(a, e)) : Pe(e, ge(a, e));
        } else {
          if (!Fn[u]) return r ? e : {};
          a = yn(e, u, c);
        }
      }

      s || (s = new Nt());
      var g = s.get(e);
      if (g) return g;
      s.set(e, a), On(e) ? e.forEach(function (o) {
        a.add(t(o, n, i, o, e, s));
      }) : Mn(e) && e.forEach(function (o, r) {
        a.set(r, t(o, n, i, r, e, s));
      });
      var m = d ? l ? Oe : Ne : l ? keysIn : fe,
          p = h ? void 0 : m(e);
      return Ot(p || e, function (o, r) {
        p && (o = e[r = o]), jt(a, r, t(o, n, i, r, e, s));
      }), a;
    },
        Hn = 1,
        qn = 4;

    var Wn = function Wn(t, e) {
      return Un(t, Hn | qn, e = "function" == typeof e ? e : void 0);
    };

    var Yn = function Yn(t) {
      return w(t) && 1 === t.nodeType && !T(t);
    };

    var $n =
    /*#__PURE__*/
    function () {
      function $n(t, e) {
        _classCallCheck(this, $n);

        this._config = {}, e && this.define(e), t && this._setObjectToTarget(this._config, t);
      }

      _createClass($n, [{
        key: "set",
        value: function set(t, e) {
          this._setToTarget(this._config, t, e);
        }
      }, {
        key: "define",
        value: function define(t, e) {
          this._setToTarget(this._config, t, e, !0);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._getFromSource(this._config, t);
        }
      }, {
        key: "_setToTarget",
        value: function _setToTarget(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (T(e)) return void this._setObjectToTarget(t, e, i);
          var o = e.split(".");
          e = o.pop();
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _e2 = _step.value;
              T(t[_e2]) || (t[_e2] = {}), t = t[_e2];
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (T(n)) return T(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, i);
          i && void 0 !== t[e] || (t[e] = n);
        }
      }, {
        key: "_getFromSource",
        value: function _getFromSource(t, e) {
          var n = e.split(".");
          e = n.pop();
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = n[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _e3 = _step2.value;

              if (!T(t[_e3])) {
                t = null;
                break;
              }

              t = t[_e3];
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          return t ? function (t) {
            return Wn(t, Gn);
          }(t[e]) : void 0;
        }
      }, {
        key: "_setObjectToTarget",
        value: function _setObjectToTarget(t, e, n) {
          var _this2 = this;

          Object.keys(e).forEach(function (i) {
            _this2._setToTarget(t, i, e[i], n);
          });
        }
      }]);

      return $n;
    }();

    function Gn(t) {
      return Yn(t) ? t : void 0;
    }

    var Qn = n(0);

    var Kn = function Kn() {
      return function t() {
        t.called = !0;
      };
    };

    var Jn = function Jn(t, e) {
      _classCallCheck(this, Jn);

      this.source = t, this.name = e, this.path = [], this.stop = Kn(), this.off = Kn();
    };

    function Zn() {
      var t = "e";

      for (var _e4 = 0; _e4 < 8; _e4++) {
        t += Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
      }

      return t;
    }

    var Xn = {
      get: function get(t) {
        return "number" != typeof t ? this[t] || this.normal : t;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    n(6);
    var ti = Symbol("listeningTo"),
        ei = Symbol("emitterId");
    var ni = {
      on: function on(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.listenTo(this, t, e, n);
      },
      once: function once(t, e, n) {
        var i = !1;
        this.listenTo(this, t, function (t) {
          for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            n[_key - 1] = arguments[_key];
          }

          i || (i = !0, t.off(), e.call.apply(e, [this, t].concat(n)));
        }, n);
      },
      off: function off(t, e) {
        this.stopListening(this, t, e);
      },
      listenTo: function listenTo(t, e, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var o, r;
        this[ti] || (this[ti] = {});
        var s = this[ti];
        oi(t) || ii(t);
        var a = oi(t);
        (o = s[a]) || (o = s[a] = {
          emitter: t,
          callbacks: {}
        }), (r = o.callbacks[e]) || (r = o.callbacks[e] = []), r.push(n), function (t, e) {
          var n = ri(t);
          if (n[e]) return;
          var i = e,
              o = null;
          var r = [];

          for (; "" !== i && !n[i];) {
            n[i] = {
              callbacks: [],
              childEvents: []
            }, r.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
          }

          if ("" !== i) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = r[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _t2 = _step3.value;
                _t2.callbacks = n[i].callbacks.slice();
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            n[i].childEvents.push(o);
          }
        }(t, e);
        var c = si(t, e),
            l = Xn.get(i.priority),
            d = {
          callback: n,
          priority: l
        };
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = c[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _t3 = _step4.value;

            var _e5 = !1;

            for (var _n2 = 0; _n2 < _t3.length; _n2++) {
              if (_t3[_n2].priority < l) {
                _t3.splice(_n2, 0, d), _e5 = !0;
                break;
              }
            }

            _e5 || _t3.push(d);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      },
      stopListening: function stopListening(t, e, n) {
        var i = this[ti];
        var o = t && oi(t);
        var r = i && o && i[o],
            s = r && e && r.callbacks[e];
        if (!(!i || t && !r || e && !s)) if (n) ci(t, e, n);else if (s) {
          for (; n = s.pop();) {
            ci(t, e, n);
          }

          delete r.callbacks[e];
        } else if (r) {
          for (e in r.callbacks) {
            this.stopListening(t, e);
          }

          delete i[o];
        } else {
          for (o in i) {
            this.stopListening(i[o].emitter);
          }

          delete this[ti];
        }
      },
      fire: function fire(t) {
        try {
          var _n3 = t instanceof Jn ? t : new Jn(this, t),
              _i2 = _n3.name;

          var _o2 = function t(e, n) {
            var i;
            if (!e._events || !(i = e._events[n]) || !i.callbacks.length) return n.indexOf(":") > -1 ? t(e, n.substr(0, n.lastIndexOf(":"))) : null;
            return i.callbacks;
          }(this, _i2);

          for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            e[_key2 - 1] = arguments[_key2];
          }

          if (_n3.path.push(this), _o2) {
            var _t4 = [_n3].concat(e);

            _o2 = Array.from(_o2);

            for (var _e6 = 0; _e6 < _o2.length && (_o2[_e6].callback.apply(this, _t4), _n3.off.called && (delete _n3.off.called, ci(this, _i2, _o2[_e6].callback)), !_n3.stop.called); _e6++) {
              ;
            }
          }

          if (this._delegations) {
            var _t5 = this._delegations.get(_i2),
                _o3 = this._delegations.get("*");

            _t5 && ai(_t5, _n3, e), _o3 && ai(_o3, _n3, e);
          }

          return _n3.return;
        } catch (t) {
          Qn.b.rethrowUnexpectedError(t, this);
        }
      },
      delegate: function delegate() {
        var _this3 = this;

        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }

        return {
          to: function to(e, n) {
            _this3._delegations || (_this3._delegations = new Map()), t.forEach(function (t) {
              var i = _this3._delegations.get(t);

              i ? i.set(e, n) : _this3._delegations.set(t, new Map([[e, n]]));
            });
          }
        };
      },
      stopDelegating: function stopDelegating(t, e) {
        if (this._delegations) if (t) {
          if (e) {
            var _n4 = this._delegations.get(t);

            _n4 && _n4.delete(e);
          } else this._delegations.delete(t);
        } else this._delegations.clear();
      }
    };

    function ii(t, e) {
      t[ei] || (t[ei] = e || Zn());
    }

    function oi(t) {
      return t[ei];
    }

    function ri(t) {
      return t._events || Object.defineProperty(t, "_events", {
        value: {}
      }), t._events;
    }

    function si(t, e) {
      var n = ri(t)[e];
      if (!n) return [];
      var i = [n.callbacks];

      for (var _e7 = 0; _e7 < n.childEvents.length; _e7++) {
        var _o4 = si(t, n.childEvents[_e7]);

        i = i.concat(_o4);
      }

      return i;
    }

    function ai(t, e, n) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = t[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref3 = _step5.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var _i3 = _ref2[0];
          var _o5 = _ref2[1];
          _o5 ? "function" == typeof _o5 && (_o5 = _o5(e.name)) : _o5 = e.name;

          var _t6 = new Jn(e.source, _o5);

          _t6.path = _toConsumableArray(e.path), _i3.fire.apply(_i3, [_t6].concat(_toConsumableArray(n)));
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }

    function ci(t, e, n) {
      var i = si(t, e);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = i[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _t7 = _step6.value;

          for (var _e8 = 0; _e8 < _t7.length; _e8++) {
            _t7[_e8].callback == n && (_t7.splice(_e8, 1), _e8--);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }

    function li(t) {
      for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        e[_key4 - 1] = arguments[_key4];
      }

      e.forEach(function (e) {
        Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(function (n) {
          if (n in t.prototype) return;
          var i = Object.getOwnPropertyDescriptor(e, n);
          i.enumerable = !1, Object.defineProperty(t.prototype, n, i);
        });
      });
    }

    function di(t, e) {
      var n = Math.min(t.length, e.length);

      for (var _i4 = 0; _i4 < n; _i4++) {
        if (t[_i4] != e[_i4]) return _i4;
      }

      return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
    }

    var hi = 4;

    var ui = function ui(t) {
      return Un(t, hi);
    };

    var fi =
    /*#__PURE__*/
    function () {
      function fi() {
        _classCallCheck(this, fi);

        this.parent = null;
      }

      _createClass(fi, [{
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;

          for (; e.parent;) {
            t.unshift(e.index), e = e.parent;
          }

          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
              i = t.getAncestors(e);
          var o = 0;

          for (; n[o] == i[o] && n[o];) {
            o++;
          }

          return 0 === o ? null : n[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
              n = t.getPath(),
              i = di(e, n);

          switch (i) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return e[i] < n[i];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e), this.parent && this.parent._fireChange(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = ui(this);
          return delete t.parent, t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" == t || "view:node" == t;
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (-1 == (t = this.parent.getChildIndex(this))) throw new Qn.b("view-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;

          for (; t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "document",
        get: function get() {
          return this.parent instanceof fi ? this.parent.document : null;
        }
      }]);

      return fi;
    }();

    li(fi, ni);

    var gi =
    /*#__PURE__*/
    function (_fi) {
      _inherits(gi, _fi);

      function gi(t) {
        var _this4;

        _classCallCheck(this, gi);

        _this4 = _possibleConstructorReturn(this, _getPrototypeOf(gi).call(this)), _this4._textData = t;
        return _this4;
      }

      _createClass(gi, [{
        key: "is",
        value: function is(t) {
          return "text" == t || "view:text" == t || _get(_getPrototypeOf(gi.prototype), "is", this).call(this, t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return t instanceof gi && (this === t || this.data === t.data);
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new gi(this.data);
        }
      }, {
        key: "data",
        get: function get() {
          return this._textData;
        }
      }, {
        key: "_data",
        get: function get() {
          return this.data;
        },
        set: function set(t) {
          this._fireChange("text", this), this._textData = t;
        }
      }]);

      return gi;
    }(fi);

    var mi =
    /*#__PURE__*/
    function () {
      function mi(t, e, n) {
        _classCallCheck(this, mi);

        if (this.textNode = t, e < 0 || e > t.data.length) throw new Qn.b("view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
        if (n < 0 || e + n > t.data.length) throw new Qn.b("view-textproxy-wrong-length: Given length value is incorrect.", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }

      _createClass(mi, [{
        key: "is",
        value: function is(t) {
          return "textProxy" == t || "view:textProxy" == t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this.textNode : this.parent;

          for (; null !== n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.data.length !== this.textNode.data.length;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);

      return mi;
    }();

    function pi(t) {
      var e = new Map();

      for (var _n5 in t) {
        e.set(_n5, t[_n5]);
      }

      return e;
    }

    function bi(t) {
      return !(!t || !t[Symbol.iterator]);
    }

    var wi =
    /*#__PURE__*/
    function () {
      function wi() {
        _classCallCheck(this, wi);

        this._patterns = [], this.add.apply(this, arguments);
      }

      _createClass(wi, [{
        key: "add",
        value: function add() {
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }

          for (var _i5 = 0, _t8 = t; _i5 < _t8.length; _i5++) {
            var _e9 = _t8[_i5];
            ("string" == typeof _e9 || _e9 instanceof RegExp) && (_e9 = {
              name: _e9
            }), _e9.classes && ("string" == typeof _e9.classes || _e9.classes instanceof RegExp) && (_e9.classes = [_e9.classes]), this._patterns.push(_e9);
          }
        }
      }, {
        key: "match",
        value: function match() {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }

          for (var _i6 = 0, _t9 = t; _i6 < _t9.length; _i6++) {
            var _e10 = _t9[_i6];
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = this._patterns[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var _t10 = _step7.value;

                var _n6 = ki(_e10, _t10);

                if (_n6) return {
                  element: _e10,
                  pattern: _t10,
                  match: _n6
                };
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }

          return null;
        }
      }, {
        key: "matchAll",
        value: function matchAll() {
          var e = [];

          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }

          for (var _i7 = 0, _t11 = t; _i7 < _t11.length; _i7++) {
            var _n7 = _t11[_i7];
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
              for (var _iterator8 = this._patterns[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var _t12 = _step8.value;

                var _i8 = ki(_n7, _t12);

                _i8 && e.push({
                  element: _n7,
                  pattern: _t12,
                  match: _i8
                });
              }
            } catch (err) {
              _didIteratorError8 = true;
              _iteratorError8 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                  _iterator8.return();
                }
              } finally {
                if (_didIteratorError8) {
                  throw _iteratorError8;
                }
              }
            }
          }

          return e.length > 0 ? e : null;
        }
      }, {
        key: "getElementName",
        value: function getElementName() {
          if (1 !== this._patterns.length) return null;
          var t = this._patterns[0],
              e = t.name;
          return "function" == typeof t || !e || e instanceof RegExp ? null : e;
        }
      }]);

      return wi;
    }();

    function ki(t, e) {
      if ("function" == typeof e) return e(t);
      var n = {};
      return e.name && (n.name = function (t, e) {
        if (t instanceof RegExp) return t.test(e);
        return t === e;
      }(e.name, t.name), !n.name) ? null : e.attributes && (n.attributes = function (t, e) {
        var n = [];

        for (var _i9 in t) {
          var _o6 = t[_i9];
          if (!e.hasAttribute(_i9)) return null;
          {
            var _t13 = e.getAttribute(_i9);

            if (!0 === _o6) n.push(_i9);else if (_o6 instanceof RegExp) {
              if (!_o6.test(_t13)) return null;
              n.push(_i9);
            } else {
              if (_t13 !== _o6) return null;
              n.push(_i9);
            }
          }
        }

        return n;
      }(e.attributes, t), !n.attributes) ? null : !(e.classes && (n.classes = function (t, e) {
        var n = [];
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = t[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var _i10 = _step9.value;

            if (_i10 instanceof RegExp) {
              var _t14 = e.getClassNames();

              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = _t14[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var _e11 = _step10.value;
                  _i10.test(_e11) && n.push(_e11);
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }

              if (0 === n.length) return null;
            } else {
              if (!e.hasClass(_i10)) return null;
              n.push(_i10);
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }

        return n;
      }(e.classes, t), !n.classes)) && !(e.styles && (n.styles = function (t, e) {
        var n = [];

        for (var _i11 in t) {
          var _o7 = t[_i11];
          if (!e.hasStyle(_i11)) return null;
          {
            var _t15 = e.getStyle(_i11);

            if (_o7 instanceof RegExp) {
              if (!_o7.test(_t15)) return null;
              n.push(_i11);
            } else {
              if (_t15 !== _o7) return null;
              n.push(_i11);
            }
          }
        }

        return n;
      }(e.styles, t), !n.styles)) && n;
    }

    var _i =
    /*#__PURE__*/
    function (_fi2) {
      _inherits(_i, _fi2);

      function _i(t, e, n) {
        var _this5;

        _classCallCheck(this, _i);

        if (_this5 = _possibleConstructorReturn(this, _getPrototypeOf(_i).call(this)), _this5.name = t, _this5._attrs = function (t) {
          t = T(t) ? pi(t) : new Map(t);
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = t[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var _ref6 = _step11.value;

              var _ref5 = _slicedToArray(_ref6, 2);

              var _e12 = _ref5[0];
              var _n8 = _ref5[1];
              null === _n8 ? t.delete(_e12) : "string" != typeof _n8 && t.set(_e12, String(_n8));
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }

          return t;
        }(e), _this5._children = [], n && _this5._insertChild(0, n), _this5._classes = new Set(), _this5._attrs.has("class")) {
          var _t16 = _this5._attrs.get("class");

          yi(_this5._classes, _t16), _this5._attrs.delete("class");
        }

        _this5._styles = new Map(), _this5._attrs.has("style") && (vi(_this5._styles, _this5._attrs.get("style")), _this5._attrs.delete("style")), _this5._customProperties = new Map();
        return _possibleConstructorReturn(_this5);
      }

      _createClass(_i, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "element" == n && e == this.name : "element" == n || n == this.name || _get(_getPrototypeOf(_i.prototype), "is", this).call(this, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getAttributeKeys",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = this._classes.size > 0;

                  if (!_context.t0) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return "class";

                case 4:
                  _context.t1 = this._styles.size > 0;

                  if (!_context.t1) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 8;
                  return "style";

                case 8:
                  return _context.delegateYield(this._attrs.keys(), "t2", 9);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, getAttributeKeys, this);
        })
      }, {
        key: "getAttributes",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributes() {
          return _regeneratorRuntime.wrap(function getAttributes$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.delegateYield(this._attrs.entries(), "t0", 1);

                case 1:
                  _context2.t1 = this._classes.size > 0;

                  if (!_context2.t1) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return ["class", this.getAttribute("class")];

                case 5:
                  _context2.t2 = this._styles.size > 0;

                  if (!_context2.t2) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 9;
                  return ["style", this.getAttribute("style")];

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, getAttributes, this);
        })
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          if ("class" == t) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;
          if ("style" != t) return this._attrs.get(t);

          if (this._styles.size > 0) {
            var _t17 = "";
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = this._styles[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var _ref9 = _step12.value;

                var _ref8 = _slicedToArray(_ref9, 2);

                var _e13 = _ref8[0];
                var _n9 = _ref8[1];
                _t17 += "".concat(_e13, ":").concat(_n9, ";");
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }

            return _t17;
          }
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return "class" == t ? this._classes.size > 0 : "style" == t ? this._styles.size > 0 : this._attrs.has(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (!(t instanceof _i)) return !1;
          if (this === t) return !0;
          if (this.name != t.name) return !1;
          if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = this._attrs[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var _ref14 = _step13.value;

              var _ref11 = _slicedToArray(_ref14, 2);

              var _e14 = _ref11[0];
              var _n10 = _ref11[1];
              if (!t._attrs.has(_e14) || t._attrs.get(_e14) !== _n10) return !1;
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }

          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = this._classes[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var _e15 = _step14.value;
              if (!t._classes.has(_e15)) return !1;
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }

          var _iteratorNormalCompletion15 = true;
          var _didIteratorError15 = false;
          var _iteratorError15 = undefined;

          try {
            for (var _iterator15 = this._styles[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
              var _ref15 = _step15.value;

              var _ref13 = _slicedToArray(_ref15, 2);

              var _e16 = _ref13[0];
              var _n11 = _ref13[1];
              if (!t._styles.has(_e16) || t._styles.get(_e16) !== _n11) return !1;
            }
          } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                _iterator15.return();
              }
            } finally {
              if (_didIteratorError15) {
                throw _iteratorError15;
              }
            }
          }

          return !0;
        }
      }, {
        key: "hasClass",
        value: function hasClass() {
          for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            t[_key8] = arguments[_key8];
          }

          for (var _i12 = 0, _t18 = t; _i12 < _t18.length; _i12++) {
            var _e17 = _t18[_i12];
            if (!this._classes.has(_e17)) return !1;
          }

          return !0;
        }
      }, {
        key: "getClassNames",
        value: function getClassNames() {
          return this._classes.keys();
        }
      }, {
        key: "getStyle",
        value: function getStyle(t) {
          return this._styles.get(t);
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          return this._styles.keys();
        }
      }, {
        key: "hasStyle",
        value: function hasStyle() {
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }

          for (var _i13 = 0, _t19 = t; _i13 < _t19.length; _i13++) {
            var _e18 = _t19[_i13];
            if (!this._styles.has(_e18)) return !1;
          }

          return !0;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor() {
          for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            t[_key10] = arguments[_key10];
          }

          var e = _construct(wi, t);

          var n = this.parent;

          for (; n;) {
            if (e.match(n)) return n;
            n = n.parent;
          }

          return null;
        }
      }, {
        key: "getCustomProperty",
        value: function getCustomProperty(t) {
          return this._customProperties.get(t);
        }
      }, {
        key: "getCustomProperties",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getCustomProperties() {
          return _regeneratorRuntime.wrap(function getCustomProperties$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.delegateYield(this._customProperties.entries(), "t0", 1);

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, getCustomProperties, this);
        })
      }, {
        key: "getIdentity",
        value: function getIdentity() {
          var t = Array.from(this._classes).sort().join(","),
              e = Array.from(this._styles).map(function (t) {
            return "".concat(t[0], ":").concat(t[1]);
          }).sort().join(";"),
              n = Array.from(this._attrs).map(function (t) {
            return "".concat(t[0], "=\"").concat(t[1], "\"");
          }).sort().join(" ");
          return this.name + ("" == t ? "" : " class=\"".concat(t, "\"")) + ("" == e ? "" : " style=\"".concat(e, "\"")) + ("" == n ? "" : " ".concat(n));
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = [];

          if (t) {
            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
              for (var _iterator16 = this.getChildren()[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                var _n12 = _step16.value;
                e.push(_n12._clone(t));
              }
            } catch (err) {
              _didIteratorError16 = true;
              _iteratorError16 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                  _iterator16.return();
                }
              } finally {
                if (_didIteratorError16) {
                  throw _iteratorError16;
                }
              }
            }
          }

          var n = new this.constructor(this.name, this._attrs, e);
          return n._classes = new Set(this._classes), n._styles = new Map(this._styles), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);

          var n = 0;

          var i = function (t) {
            if ("string" == typeof t) return [new gi(t)];
            bi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new gi(t) : t instanceof mi ? new gi(t.data) : t;
            });
          }(e);

          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = i[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var _e19 = _step17.value;
              null !== _e19.parent && _e19._remove(), _e19.parent = this, this._children.splice(t, 0, _e19), t++, n++;
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }

          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _n13 = t; _n13 < t + e; _n13++) {
            this._children[_n13].parent = null;
          }

          return this._children.splice(t, e);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          e = String(e), this._fireChange("attributes", this), "class" == t ? yi(this._classes, e) : "style" == t ? vi(this._styles, e) : this._attrs.set(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? this._styles.size > 0 && (this._styles.clear(), !0) : this._attrs.delete(t);
        }
      }, {
        key: "_addClass",
        value: function _addClass(t) {
          var _this6 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this6._classes.add(t);
          });
        }
      }, {
        key: "_removeClass",
        value: function _removeClass(t) {
          var _this7 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this7._classes.delete(t);
          });
        }
      }, {
        key: "_setStyle",
        value: function _setStyle(t, e) {
          if (this._fireChange("attributes", this), T(t)) {
            var _e20 = Object.keys(t);

            for (var _i14 = 0, _e21 = _e20; _i14 < _e21.length; _i14++) {
              var _n14 = _e21[_i14];

              this._styles.set(_n14, t[_n14]);
            }
          } else this._styles.set(t, e);
        }
      }, {
        key: "_removeStyle",
        value: function _removeStyle(t) {
          var _this8 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this8._styles.delete(t);
          });
        }
      }, {
        key: "_setCustomProperty",
        value: function _setCustomProperty(t, e) {
          this._customProperties.set(t, e);
        }
      }, {
        key: "_removeCustomProperty",
        value: function _removeCustomProperty(t) {
          return this._customProperties.delete(t);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this._children.length;
        }
      }]);

      return _i;
    }(fi);

    function vi(t, e) {
      var n = null,
          i = 0,
          o = 0,
          r = null;

      if (t.clear(), "" !== e) {
        ";" != e.charAt(e.length - 1) && (e += ";");

        for (var _s2 = 0; _s2 < e.length; _s2++) {
          var _a2 = e.charAt(_s2);

          if (null === n) switch (_a2) {
            case ":":
              r || (r = e.substr(i, _s2 - i), o = _s2 + 1);
              break;

            case '"':
            case "'":
              n = _a2;
              break;

            case ";":
              {
                var _n15 = e.substr(o, _s2 - o);

                r && t.set(r.trim(), _n15.trim()), r = null, i = _s2 + 1;
                break;
              }
          } else _a2 === n && (n = null);
        }
      }
    }

    function yi(t, e) {
      var n = e.split(/\s+/);
      t.clear(), n.forEach(function (e) {
        return t.add(e);
      });
    }

    var xi =
    /*#__PURE__*/
    function (_i15) {
      _inherits(xi, _i15);

      function xi(t, e, n) {
        var _this9;

        _classCallCheck(this, xi);

        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(xi).call(this, t, e, n)), _this9.getFillerOffset = Ai;
        return _this9;
      }

      _createClass(xi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t && t.replace(/^view:/, "");
          return e ? "containerElement" == n && e == this.name || _get(_getPrototypeOf(xi.prototype), "is", this).call(this, t, e) : "containerElement" == n || _get(_getPrototypeOf(xi.prototype), "is", this).call(this, t);
        }
      }]);

      return xi;
    }(_i);

    function Ai() {
      var t = _toConsumableArray(this.getChildren()),
          e = t[this.childCount - 1];

      if (e && e.is("element", "br")) return this.childCount;
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = t[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var _e22 = _step18.value;
          if (!_e22.is("uiElement")) return null;
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      return this.childCount;
    }

    var Ti = function Ti(t) {
      return t;
    };

    var Ci = function Ci(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, n[0]);

        case 2:
          return t.call(e, n[0], n[1]);

        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }

      return t.apply(e, n);
    },
        Pi = Math.max;

    var Si = function Si(t, e, n) {
      return e = Pi(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var i = arguments, o = -1, r = Pi(i.length - e, 0), s = Array(r); ++o < r;) {
          s[o] = i[e + o];
        }

        o = -1;

        for (var a = Array(e + 1); ++o < e;) {
          a[o] = i[o];
        }

        return a[e] = n(s), Ci(t, this, a);
      };
    };

    var Mi = function Mi(t) {
      return function () {
        return t;
      };
    },
        Ei = Rt ? function (t, e) {
      return Rt(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Mi(e),
        writable: !0
      });
    } : Ti,
        Ii = 800,
        Ni = 16,
        Oi = Date.now;

    var Ri = function (t) {
      var e = 0,
          n = 0;
      return function () {
        var i = Oi(),
            o = Ni - (i - n);

        if (n = i, o > 0) {
          if (++e >= Ii) return arguments[0];
        } else e = 0;

        return t.apply(void 0, arguments);
      };
    }(Ei);

    var Di = function Di(t, e) {
      return Ri(Si(t, e, Ti), t + "");
    };

    var Li = function Li(t, e, n) {
      if (!B(n)) return !1;
      var i = typeof e;
      return !!("number" == i ? ue(n) && Kt(e, n.length) : "string" == i && e in n) && P(n[e], t);
    };

    var ji = function (t) {
      return Di(function (e, n) {
        var i = -1,
            o = n.length,
            r = o > 1 ? n[o - 1] : void 0,
            s = o > 2 ? n[2] : void 0;

        for (r = t.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && Li(n[0], n[1], s) && (r = o < 3 ? void 0 : r, o = 1), e = Object(e); ++i < o;) {
          var a = n[i];
          a && t(e, a, i, r);
        }

        return e;
      });
    }(function (t, e) {
      Vt(e, we(e), t);
    });

    var Vi = Symbol("observableProperties"),
        zi = Symbol("boundObservables"),
        Bi = Symbol("boundProperties"),
        Fi = {
      set: function set(t, e) {
        var _this10 = this;

        if (B(t)) return void Object.keys(t).forEach(function (e) {
          _this10.set(e, t[e]);
        }, this);
        Hi(this);
        var n = this[Vi];
        if (t in this && !n.has(t)) throw new Qn.b("observable-set-cannot-override: Cannot override an existing property.", this);
        Object.defineProperty(this, t, {
          enumerable: !0,
          configurable: !0,
          get: function get() {
            return n.get(t);
          },
          set: function set(e) {
            var i = n.get(t);
            var o = this.fire("set:" + t, t, e, i);
            void 0 === o && (o = e), i === o && n.has(t) || (n.set(t, o), this.fire("change:" + t, t, o, i));
          }
        }), this[t] = e;
      },
      bind: function bind() {
        var _this11 = this;

        for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          t[_key11] = arguments[_key11];
        }

        if (!t.length || !Yi(t)) throw new Qn.b("observable-bind-wrong-properties: All properties must be strings.", this);
        if (new Set(t).size !== t.length) throw new Qn.b("observable-bind-duplicate-properties: Properties must be unique.", this);
        Hi(this);
        var e = this[Bi];
        t.forEach(function (t) {
          if (e.has(t)) throw new Qn.b("observable-bind-rebind: Cannot bind the same property more than once.", _this11);
        });
        var n = new Map();
        return t.forEach(function (t) {
          var i = {
            property: t,
            to: []
          };
          e.set(t, i), n.set(t, i);
        }), {
          to: qi,
          toMany: Wi,
          _observable: this,
          _bindProperties: t,
          _to: [],
          _bindings: n
        };
      },
      unbind: function unbind() {
        var _this12 = this;

        if (!(Vi in this)) return;
        var e = this[Bi],
            n = this[zi];

        for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          t[_key12] = arguments[_key12];
        }

        if (t.length) {
          if (!Yi(t)) throw new Qn.b("observable-unbind-wrong-properties: Properties must be strings.", this);
          t.forEach(function (t) {
            var i = e.get(t);
            if (!i) return;
            var o, r, s, a;
            i.to.forEach(function (t) {
              o = t[0], r = t[1], s = n.get(o), a = s[r], a.delete(i), a.size || delete s[r], Object.keys(s).length || (n.delete(o), _this12.stopListening(o, "change"));
            }), e.delete(t);
          });
        } else n.forEach(function (t, e) {
          _this12.stopListening(e, "change");
        }), n.clear(), e.clear();
      },
      decorate: function decorate(t) {
        var _this13 = this;

        var e = this[t];
        if (!e) throw new Qn.b("observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.", this, {
          object: this,
          methodName: t
        });
        this.on(t, function (t, n) {
          t.return = e.apply(_this13, n);
        }), this[t] = function () {
          for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            e[_key13] = arguments[_key13];
          }

          return this.fire(t, e);
        };
      }
    };
    ji(Fi, ni);
    var Ui = Fi;

    function Hi(t) {
      Vi in t || (Object.defineProperty(t, Vi, {
        value: new Map()
      }), Object.defineProperty(t, zi, {
        value: new Map()
      }), Object.defineProperty(t, Bi, {
        value: new Map()
      }));
    }

    function qi() {
      var _this14 = this;

      var e = function () {
        for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          t[_key14] = arguments[_key14];
        }

        if (!t.length) throw new Qn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
        var e = {
          to: []
        };
        var n;
        "function" == typeof t[t.length - 1] && (e.callback = t.pop());
        return t.forEach(function (t) {
          if ("string" == typeof t) n.properties.push(t);else {
            if ("object" != typeof t) throw new Qn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
            n = {
              observable: t,
              properties: []
            }, e.to.push(n);
          }
        }), e;
      }.apply(void 0, arguments),
          n = Array.from(this._bindings.keys()),
          i = n.length;

      if (!e.callback && e.to.length > 1) throw new Qn.b("observable-bind-to-no-callback: Binding multiple observables only possible with callback.", this);
      if (i > 1 && e.callback) throw new Qn.b("observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.", this);
      var o;
      e.to.forEach(function (t) {
        if (t.properties.length && t.properties.length !== i) throw new Qn.b("observable-bind-to-properties-length: The number of properties must match.", _this14);
        t.properties.length || (t.properties = _this14._bindProperties);
      }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), o = this._observable, this._to.forEach(function (t) {
        var e = o[zi];
        var n;
        e.get(t.observable) || o.listenTo(t.observable, "change", function (i, r) {
          n = e.get(t.observable)[r], n && n.forEach(function (t) {
            $i(o, t.property);
          });
        });
      }), function (t) {
        var e;

        t._bindings.forEach(function (n, i) {
          t._to.forEach(function (o) {
            e = o.properties[n.callback ? 0 : t._bindProperties.indexOf(i)], n.to.push([o.observable, e]), function (t, e, n, i) {
              var o = t[zi],
                  r = o.get(n),
                  s = r || {};
              s[i] || (s[i] = new Set());
              s[i].add(e), r || o.set(n, s);
            }(t._observable, n, o.observable, e);
          });
        });
      }(this), this._bindProperties.forEach(function (t) {
        $i(_this14._observable, t);
      });
    }

    function Wi(t, e, n) {
      if (this._bindings.size > 1) throw new Qn.b("observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().", this);
      this.to.apply(this, _toConsumableArray(function (t, e) {
        var n = t.map(function (t) {
          return [t, e];
        });
        return Array.prototype.concat.apply([], n);
      }(t, e)).concat([n]));
    }

    function Yi(t) {
      return t.every(function (t) {
        return "string" == typeof t;
      });
    }

    function $i(t, e) {
      var n = t[Bi].get(e);
      var i;
      n.callback ? i = n.callback.apply(t, n.to.map(function (t) {
        return t[0][t[1]];
      })) : (i = n.to[0], i = i[0][i[1]]), t.hasOwnProperty(e) ? t[e] = i : t.set(e, i);
    }

    var Gi = Symbol("document");

    var Qi =
    /*#__PURE__*/
    function (_xi) {
      _inherits(Qi, _xi);

      function Qi(t, e, n) {
        var _this15;

        _classCallCheck(this, Qi);

        _this15 = _possibleConstructorReturn(this, _getPrototypeOf(Qi).call(this, t, e, n)), _this15.set("isReadOnly", !1), _this15.set("isFocused", !1);
        return _this15;
      }

      _createClass(Qi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t && t.replace(/^view:/, "");
          return e ? "editableElement" == n && e == this.name || _get(_getPrototypeOf(Qi.prototype), "is", this).call(this, t, e) : "editableElement" == n || _get(_getPrototypeOf(Qi.prototype), "is", this).call(this, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "document",
        get: function get() {
          return this.getCustomProperty(Gi);
        }
      }, {
        key: "_document",
        set: function set(t) {
          var _this16 = this;

          if (this.getCustomProperty(Gi)) throw new Qn.b("view-editableelement-document-already-set: View document is already set.", this);
          this._setCustomProperty(Gi, t), this.bind("isReadOnly").to(t), this.bind("isFocused").to(t, "isFocused", function (e) {
            return e && t.selection.editableElement == _this16;
          }), this.listenTo(t.selection, "change", function () {
            _this16.isFocused = t.isFocused && t.selection.editableElement == _this16;
          });
        }
      }]);

      return Qi;
    }(xi);

    li(Qi, Ui);
    var Ki = Symbol("rootName");

    var Ji =
    /*#__PURE__*/
    function (_Qi) {
      _inherits(Ji, _Qi);

      function Ji(t) {
        var _this17;

        _classCallCheck(this, Ji);

        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Ji).call(this, t)), _this17.rootName = "main";
        return _this17;
      }

      _createClass(Ji, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "rootElement" == n && e == this.name || _get(_getPrototypeOf(Ji.prototype), "is", this).call(this, t, e) : "rootElement" == n || _get(_getPrototypeOf(Ji.prototype), "is", this).call(this, t);
        }
      }, {
        key: "rootName",
        get: function get() {
          return this.getCustomProperty(Ki);
        },
        set: function set(t) {
          this._setCustomProperty(Ki, t);
        }
      }, {
        key: "_name",
        set: function set(t) {
          this.name = t;
        }
      }]);

      return Ji;
    }(Qi);

    var Zi =
    /*#__PURE__*/
    function () {
      function Zi() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Zi);

        if (!t.boundaries && !t.startPosition) throw new Qn.b("view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
        if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new Qn.b("view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", t.startPosition, {
          direction: t.direction
        });
        this.boundaries = t.boundaries || null, t.startPosition ? this.position = Xi._createAt(t.startPosition) : this.position = Xi._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }

      _createClass(Zi, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, i;

          do {
            var _this$next;

            i = this.position, (_this$next = this.next(), e = _this$next.done, n = _this$next.value, _this$next);
          } while (!e && t(n));

          e || (this.position = i);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position.clone();
          var e = this.position,
              n = t.parent;
          if (null === n.parent && t.offset === n.childCount) return {
            done: !0
          };
          if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var i;

          if (n instanceof gi) {
            if (t.isAtEnd) return this.position = Xi._createAfter(n), this._next();
            i = n.data[t.offset];
          } else i = n.getChild(t.offset);

          if (i instanceof _i) return this.shallow ? t.offset++ : t = new Xi(i, 0), this.position = t, this._formatReturnValue("elementStart", i, e, t, 1);

          if (i instanceof gi) {
            if (this.singleCharacters) return t = new Xi(i, 0), this.position = t, this._next();
            {
              var _n16,
                  _o8 = i.data.length;

              return i == this._boundaryEndParent ? (_o8 = this.boundaries.end.offset, _n16 = new mi(i, 0, _o8), t = Xi._createAfter(_n16)) : (_n16 = new mi(i, 0, i.data.length), t.offset++), this.position = t, this._formatReturnValue("text", _n16, e, t, _o8);
            }
          }

          if ("string" == typeof i) {
            var _i16;

            if (this.singleCharacters) _i16 = 1;else {
              _i16 = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
            }

            var _o9 = new mi(n, t.offset, _i16);

            return t.offset += _i16, this.position = t, this._formatReturnValue("text", _o9, e, t, _i16);
          }

          return t = Xi._createAfter(n), this.position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position.clone();
          var e = this.position,
              n = t.parent;
          if (null === n.parent && 0 === t.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var i;

          if (n instanceof gi) {
            if (t.isAtStart) return this.position = Xi._createBefore(n), this._previous();
            i = n.data[t.offset - 1];
          } else i = n.getChild(t.offset - 1);

          if (i instanceof _i) return this.shallow ? (t.offset--, this.position = t, this._formatReturnValue("elementStart", i, e, t, 1)) : (t = new Xi(i, i.childCount), this.position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, e, t));

          if (i instanceof gi) {
            if (this.singleCharacters) return t = new Xi(i, i.data.length), this.position = t, this._previous();
            {
              var _n17,
                  _o10 = i.data.length;

              if (i == this._boundaryStartParent) {
                var _e23 = this.boundaries.start.offset;
                _n17 = new mi(i, _e23, i.data.length - _e23), _o10 = _n17.data.length, t = Xi._createBefore(_n17);
              } else _n17 = new mi(i, 0, i.data.length), t.offset--;

              return this.position = t, this._formatReturnValue("text", _n17, e, t, _o10);
            }
          }

          if ("string" == typeof i) {
            var _i17;

            if (this.singleCharacters) _i17 = 1;else {
              var _e24 = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;

              _i17 = t.offset - _e24;
            }
            t.offset -= _i17;

            var _o11 = new mi(n, t.offset, _i17);

            return this.position = t, this._formatReturnValue("text", _o11, e, t, _i17);
          }

          return t = Xi._createBefore(n), this.position = t, this._formatReturnValue("elementStart", n, e, t, 1);
        }
      }, {
        key: "_formatReturnValue",
        value: function _formatReturnValue(t, e, n, i, o) {
          return e instanceof mi && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = Xi._createAfter(e.textNode) : (i = Xi._createAfter(e.textNode), this.position = i)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = Xi._createBefore(e.textNode) : (i = Xi._createBefore(e.textNode), this.position = i))), {
            done: !1,
            value: {
              type: t,
              item: e,
              previousPosition: n,
              nextPosition: i,
              length: o
            }
          };
        }
      }]);

      return Zi;
    }();

    var Xi =
    /*#__PURE__*/
    function () {
      function Xi(t, e) {
        _classCallCheck(this, Xi);

        this.parent = t, this.offset = e;
      }

      _createClass(Xi, [{
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = Xi._createAt(this),
              n = e.offset + t;

          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new Zi(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
              n = t.getAncestors();
          var i = 0;

          for (; e[i] == n[i] && e[i];) {
            i++;
          }

          return 0 === i ? null : e[i - 1];
        }
      }, {
        key: "is",
        value: function is(t) {
          return "position" == t || "view:position" == t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset;
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root !== t.root) return "different";
          if (this.isEqual(t)) return "same";
          var e = this.parent.is("node") ? this.parent.getPath() : [],
              n = t.parent.is("node") ? t.parent.getPath() : [];
          e.push(this.offset), n.push(t.offset);
          var i = di(e, n);

          switch (i) {
            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return e[i] < n[i] ? "before" : "after";
          }
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.startPosition = this, new Zi(t);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Xi(this.parent, this.offset);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset) || null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          var t = this.parent.is("text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === t;
        }
      }, {
        key: "root",
        get: function get() {
          return this.parent.root;
        }
      }, {
        key: "editableElement",
        get: function get() {
          var t = this.parent;

          for (; !(t instanceof Qi);) {
            if (!t.parent) return null;
            t = t.parent;
          }

          return t;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          if (t instanceof Xi) return new this(t.parent, t.offset);
          {
            var _n18 = t;
            if ("end" == e) e = _n18.is("text") ? _n18.data.length : _n18.childCount;else {
              if ("before" == e) return this._createBefore(_n18);
              if ("after" == e) return this._createAfter(_n18);
              if (0 !== e && !e) throw new Qn.b("view-createPositionAt-offset-required: View#createPositionAt() requires the offset when the first parameter is a view item.", _n18);
            }
            return new Xi(_n18, e);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t) {
          if (t.is("textProxy")) return new Xi(t.textNode, t.offsetInText + t.data.length);
          if (!t.parent) throw new Qn.b("view-position-after-root: You can not make position after root.", t, {
            root: t
          });
          return new Xi(t.parent, t.index + 1);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t) {
          if (t.is("textProxy")) return new Xi(t.textNode, t.offsetInText);
          if (!t.parent) throw new Qn.b("view-position-before-root: You can not make position before root.", t, {
            root: t
          });
          return new Xi(t.parent, t.index);
        }
      }]);

      return Xi;
    }();

    var to =
    /*#__PURE__*/
    function () {
      function to(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, to);

        this.start = t.clone(), this.end = e ? e.clone() : t.clone();
      }

      _createClass(to, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.delegateYield(new Zi({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "getEnlarged",
        value: function getEnlarged() {
          var t = this.start.getLastMatchingPosition(eo, {
            direction: "backward"
          }),
              e = this.end.getLastMatchingPosition(eo);
          return t.parent.is("text") && t.isAtStart && (t = Xi._createBefore(t.parent)), e.parent.is("text") && e.isAtEnd && (e = Xi._createAfter(e.parent)), new to(t, e);
        }
      }, {
        key: "getTrimmed",
        value: function getTrimmed() {
          var t = this.start.getLastMatchingPosition(eo);
          if (t.isAfter(this.end) || t.isEqual(this.end)) return new to(t, t);
          var e = this.end.getLastMatchingPosition(eo, {
            direction: "backward"
          });
          var n = t.nodeAfter,
              i = e.nodeBefore;
          return n && n.is("text") && (t = new Xi(n, 0)), i && i.is("text") && (e = new Xi(i, i.data.length)), new to(t, e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
              i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && i;
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new to(this.start, t.start)), this.containsPosition(t.end) && e.push(new to(t.end, this.end))) : e.push(this.clone()), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e25 = this.start,
                _n19 = this.end;
            return this.containsPosition(t.start) && (_e25 = t.start), this.containsPosition(t.end) && (_n19 = t.end), new to(_e25, _n19);
          }

          return null;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new Zi(t);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new to(this.start, this.end);
        }
      }, {
        key: "getItems",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getItems() {
          var t,
              e,
              _iteratorNormalCompletion19,
              _didIteratorError19,
              _iteratorError19,
              _iterator19,
              _step19,
              _t20,
              _args5 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  t = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                  t.boundaries = this, t.ignoreElementEnd = !0;
                  e = new Zi(t);
                  _iteratorNormalCompletion19 = true;
                  _didIteratorError19 = false;
                  _iteratorError19 = undefined;
                  _context5.prev = 6;
                  _iterator19 = e[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done) {
                    _context5.next = 15;
                    break;
                  }

                  _t20 = _step19.value;
                  _context5.next = 12;
                  return _t20.item;

                case 12:
                  _iteratorNormalCompletion19 = true;
                  _context5.next = 8;
                  break;

                case 15:
                  _context5.next = 21;
                  break;

                case 17:
                  _context5.prev = 17;
                  _context5.t0 = _context5["catch"](6);
                  _didIteratorError19 = true;
                  _iteratorError19 = _context5.t0;

                case 21:
                  _context5.prev = 21;
                  _context5.prev = 22;

                  if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                    _iterator19.return();
                  }

                case 24:
                  _context5.prev = 24;

                  if (!_didIteratorError19) {
                    _context5.next = 27;
                    break;
                  }

                  throw _iteratorError19;

                case 27:
                  return _context5.finish(24);

                case 28:
                  return _context5.finish(21);

                case 29:
                case "end":
                  return _context5.stop();
              }
            }
          }, getItems, this, [[6, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "getPositions",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getPositions() {
          var t,
              e,
              _iteratorNormalCompletion20,
              _didIteratorError20,
              _iteratorError20,
              _iterator20,
              _step20,
              _t21,
              _args6 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  t = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                  t.boundaries = this;
                  e = new Zi(t);
                  _context6.next = 5;
                  return e.position;

                case 5:
                  _iteratorNormalCompletion20 = true;
                  _didIteratorError20 = false;
                  _iteratorError20 = undefined;
                  _context6.prev = 8;
                  _iterator20 = e[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
                    _context6.next = 17;
                    break;
                  }

                  _t21 = _step20.value;
                  _context6.next = 14;
                  return _t21.nextPosition;

                case 14:
                  _iteratorNormalCompletion20 = true;
                  _context6.next = 10;
                  break;

                case 17:
                  _context6.next = 23;
                  break;

                case 19:
                  _context6.prev = 19;
                  _context6.t0 = _context6["catch"](8);
                  _didIteratorError20 = true;
                  _iteratorError20 = _context6.t0;

                case 23:
                  _context6.prev = 23;
                  _context6.prev = 24;

                  if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
                    _iterator20.return();
                  }

                case 26:
                  _context6.prev = 26;

                  if (!_didIteratorError20) {
                    _context6.next = 29;
                    break;
                  }

                  throw _iteratorError20;

                case 29:
                  return _context6.finish(26);

                case 30:
                  return _context6.finish(23);

                case 31:
                case "end":
                  return _context6.stop();
              }
            }
          }, getPositions, this, [[8, 19, 23, 31], [24,, 26, 30]]);
        })
      }, {
        key: "is",
        value: function is(t) {
          return "range" == t || "view:range" == t;
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return this.start.parent === this.end.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromParentsAndOffsets",
        value: function _createFromParentsAndOffsets(t, e, n, i) {
          return new this(new Xi(t, e), new Xi(n, i));
        }
      }, {
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
              i = t.getShiftedBy(e);
          return e > 0 ? new this(n, i) : new this(i, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          var e = t.is("textProxy") ? t.offsetSize : 1;
          return this._createFromPositionAndShift(Xi._createBefore(t), e);
        }
      }]);

      return to;
    }();

    function eo(t) {
      return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
    }

    function no(t) {
      var e = 0;
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = t[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var _n20 = _step21.value;
          e++;
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      return e;
    }

    var io =
    /*#__PURE__*/
    function () {
      function io() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, io);

        this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(t, e, n);
      }

      _createClass(io, [{
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          var _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, _t22;

          return _regeneratorRuntime.wrap(function getRanges$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _iteratorNormalCompletion22 = true;
                  _didIteratorError22 = false;
                  _iteratorError22 = undefined;
                  _context7.prev = 3;
                  _iterator22 = this._ranges[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done) {
                    _context7.next = 12;
                    break;
                  }

                  _t22 = _step22.value;
                  _context7.next = 9;
                  return _t22.clone();

                case 9:
                  _iteratorNormalCompletion22 = true;
                  _context7.next = 5;
                  break;

                case 12:
                  _context7.next = 18;
                  break;

                case 14:
                  _context7.prev = 14;
                  _context7.t0 = _context7["catch"](3);
                  _didIteratorError22 = true;
                  _iteratorError22 = _context7.t0;

                case 18:
                  _context7.prev = 18;
                  _context7.prev = 19;

                  if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
                    _iterator22.return();
                  }

                case 21:
                  _context7.prev = 21;

                  if (!_didIteratorError22) {
                    _context7.next = 24;
                    break;
                  }

                  throw _iteratorError22;

                case 24:
                  return _context7.finish(21);

                case 25:
                  return _context7.finish(18);

                case 26:
                case "end":
                  return _context7.stop();
              }
            }
          }, getRanges, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iteratorNormalCompletion23 = true;
          var _didIteratorError23 = false;
          var _iteratorError23 = undefined;

          try {
            for (var _iterator23 = this._ranges[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
              var _e26 = _step23.value;
              t && !_e26.start.isBefore(t.start) || (t = _e26);
            }
          } catch (err) {
            _didIteratorError23 = true;
            _iteratorError23 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                _iterator23.return();
              }
            } finally {
              if (_didIteratorError23) {
                throw _iteratorError23;
              }
            }
          }

          return t ? t.clone() : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iteratorNormalCompletion24 = true;
          var _didIteratorError24 = false;
          var _iteratorError24 = undefined;

          try {
            for (var _iterator24 = this._ranges[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
              var _e27 = _step24.value;
              t && !_e27.end.isAfter(t.end) || (t = _e27);
            }
          } catch (err) {
            _didIteratorError24 = true;
            _iteratorError24 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
                _iterator24.return();
              }
            } finally {
              if (_didIteratorError24) {
                throw _iteratorError24;
              }
            }
          }

          return t ? t.clone() : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          if (this.isFake != t.isFake) return !1;
          if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
          var _iteratorNormalCompletion25 = true;
          var _didIteratorError25 = false;
          var _iteratorError25 = undefined;

          try {
            for (var _iterator25 = this._ranges[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
              var _e28 = _step25.value;

              var _n21 = !1;

              var _iteratorNormalCompletion26 = true;
              var _didIteratorError26 = false;
              var _iteratorError26 = undefined;

              try {
                for (var _iterator26 = t._ranges[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                  var _i18 = _step26.value;

                  if (_e28.isEqual(_i18)) {
                    _n21 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError26 = true;
                _iteratorError26 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
                    _iterator26.return();
                  }
                } finally {
                  if (_didIteratorError26) {
                    throw _iteratorError26;
                  }
                }
              }

              if (!_n21) return !1;
            }
          } catch (err) {
            _didIteratorError25 = true;
            _iteratorError25 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
                _iterator25.return();
              }
            } finally {
              if (_didIteratorError25) {
                throw _iteratorError25;
              }
            }
          }

          return !0;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (this.isBackward != t.isBackward) return !1;
          var e = no(this.getRanges());
          if (e != no(t.getRanges())) return !1;
          if (0 == e) return !0;
          var _iteratorNormalCompletion27 = true;
          var _didIteratorError27 = false;
          var _iteratorError27 = undefined;

          try {
            for (var _iterator27 = this.getRanges()[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
              var _e29 = _step27.value;
              _e29 = _e29.getTrimmed();

              var _n22 = !1;

              var _iteratorNormalCompletion28 = true;
              var _didIteratorError28 = false;
              var _iteratorError28 = undefined;

              try {
                for (var _iterator28 = t.getRanges()[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                  var _i19 = _step28.value;

                  if (_i19 = _i19.getTrimmed(), _e29.start.isEqual(_i19.start) && _e29.end.isEqual(_i19.end)) {
                    _n22 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError28 = true;
                _iteratorError28 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
                    _iterator28.return();
                  }
                } finally {
                  if (_didIteratorError28) {
                    throw _iteratorError28;
                  }
                }
              }

              if (!_n22) return !1;
            }
          } catch (err) {
            _didIteratorError27 = true;
            _iteratorError27 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
                _iterator27.return();
              }
            } finally {
              if (_didIteratorError27) {
                throw _iteratorError27;
              }
            }
          }

          return !0;
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (1 !== this.rangeCount) return null;
          var t = this.getFirstRange();
          var e = t.start.nodeAfter,
              n = t.end.nodeBefore;
          return t.start.parent.is("text") && t.start.isAtEnd && t.start.parent.nextSibling && (e = t.start.parent.nextSibling), t.end.parent.is("text") && t.end.isAtStart && t.end.parent.previousSibling && (n = t.end.parent.previousSibling), e instanceof _i && e == n ? e : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]), this._setFakeOptions(e);else if (t instanceof io || t instanceof oo) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
            fake: t.isFake,
            label: t.fakeSelectionLabel
          });else if (t instanceof to) this._setRanges([t], e && e.backward), this._setFakeOptions(e);else if (t instanceof Xi) this._setRanges([new to(t)]), this._setFakeOptions(e);else if (t instanceof fi) {
            var _i20 = !!n && !!n.backward;

            var _o12;

            if (void 0 === e) throw new Qn.b("view-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", this);
            _o12 = "in" == e ? to._createIn(t) : "on" == e ? to._createOn(t) : new to(Xi._createAt(t, e)), this._setRanges([_o12], _i20), this._setFakeOptions(n);
          } else {
            if (!bi(t)) throw new Qn.b("view-selection-setTo-not-selectable: Cannot set selection to given place.", this);
            this._setRanges(t, e && e.backward), this._setFakeOptions(e);
          }
          this.fire("change");
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new Qn.b("view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", this);

          var n = Xi._createAt(t, e);

          if ("same" == n.compareWith(this.focus)) return;
          var i = this.anchor;
          this._ranges.pop(), "before" == n.compareWith(i) ? this._addRange(new to(n, i), !0) : this._addRange(new to(i, n)), this.fire("change");
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "view:selection" == t;
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t = Array.from(t), this._ranges = [];
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = t[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var _e30 = _step29.value;

              this._addRange(_e30);
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }

          this._lastRangeBackward = !!e;
        }
      }, {
        key: "_setFakeOptions",
        value: function _setFakeOptions() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
        }
      }, {
        key: "_addRange",
        value: function _addRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (!(t instanceof to)) throw new Qn.b("view-selection-add-range-not-range: Selection range set to an object that is not an instance of view.Range", this);
          this._pushRange(t), this._lastRangeBackward = !!e;
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var _iteratorNormalCompletion30 = true;
          var _didIteratorError30 = false;
          var _iteratorError30 = undefined;

          try {
            for (var _iterator30 = this._ranges[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
              var _e31 = _step30.value;
              if (t.isIntersecting(_e31)) throw new Qn.b("view-selection-range-intersects: Trying to add a range that intersects with another range from selection.", this, {
                addedRange: t,
                intersectingRange: _e31
              });
            }
          } catch (err) {
            _didIteratorError30 = true;
            _iteratorError30 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
                _iterator30.return();
              }
            } finally {
              if (_didIteratorError30) {
                throw _iteratorError30;
              }
            }
          }

          this._ranges.push(new to(t.start, t.end));
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.end : t.start).clone();
        }
      }, {
        key: "focus",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.start : t.end).clone();
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this.rangeCount && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this.anchor ? this.anchor.editableElement : null;
        }
      }]);

      return io;
    }();

    li(io, ni);

    var oo =
    /*#__PURE__*/
    function () {
      function oo() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, oo);

        this._selection = new io(), this._selection.delegate("change").to(this), this._selection.setTo(t, e, n);
      }

      _createClass(oo, [{
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.delegateYield(this._selection.getRanges(), "t0", 1);

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this._selection.isEqual(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return this._selection.isSimilar(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "documentSelection" == t || "view:selection" == t || "view:documentSelection" == t;
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._selection.isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._selection.fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this._selection.editableElement;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }]);

      return oo;
    }();

    li(oo, ni);

    var ro =
    /*#__PURE__*/
    function () {
      function ro() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ro);

        this._items = [], this._itemMap = new Map(), this._idProperty = t.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [];
      }

      _createClass(ro, [{
        key: "add",
        value: function add(t, e) {
          var n;
          var i = this._idProperty;

          if (i in t) {
            if (n = t[i], "string" != typeof n) throw new Qn.b("collection-add-invalid-id", this);
            if (this.get(n)) throw new Qn.b("collection-add-item-already-exists", this);
          } else t[i] = n = Zn();

          if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new Qn.b("collection-add-item-invalid-index", this);
          return this._items.splice(e, 0, t), this._itemMap.set(n, t), this.fire("add", t, e), this;
        }
      }, {
        key: "get",
        value: function get(t) {
          var e;
          if ("string" == typeof t) e = this._itemMap.get(t);else {
            if ("number" != typeof t) throw new Qn.b("collection-get-invalid-arg: Index or id must be given.", this);
            e = this._items[t];
          }
          return e || null;
        }
      }, {
        key: "has",
        value: function has(t) {
          if ("string" == typeof t) return this._itemMap.has(t);
          {
            var _e32 = t[this._idProperty];
            return this._itemMap.has(_e32);
          }
        }
      }, {
        key: "getIndex",
        value: function getIndex(t) {
          var e;
          return e = "string" == typeof t ? this._itemMap.get(t) : t, this._items.indexOf(e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e,
              n,
              i,
              o = !1;
          var r = this._idProperty;
          if ("string" == typeof t ? (n = t, i = this._itemMap.get(n), o = !i, i && (e = this._items.indexOf(i))) : "number" == typeof t ? (e = t, i = this._items[e], o = !i, i && (n = i[r])) : (i = t, n = i[r], e = this._items.indexOf(i), o = -1 == e || !this._itemMap.get(n)), o) throw new Qn.b("collection-remove-404: Item not found.", this);
          this._items.splice(e, 1), this._itemMap.delete(n);

          var s = this._bindToInternalToExternalMap.get(i);

          return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(s), this.fire("remove", i, e), i;
        }
      }, {
        key: "map",
        value: function map(t, e) {
          return this._items.map(t, e);
        }
      }, {
        key: "find",
        value: function find(t, e) {
          return this._items.find(t, e);
        }
      }, {
        key: "filter",
        value: function filter(t, e) {
          return this._items.filter(t, e);
        }
      }, {
        key: "clear",
        value: function clear() {
          for (this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null); this.length;) {
            this.remove(0);
          }
        }
      }, {
        key: "bindTo",
        value: function bindTo(t) {
          var _this18 = this;

          if (this._bindToCollection) throw new Qn.b("collection-bind-to-rebind: The collection cannot be bound more than once.", this);
          return this._bindToCollection = t, {
            as: function as(t) {
              _this18._setUpBindToBinding(function (e) {
                return new t(e);
              });
            },
            using: function using(t) {
              "function" == typeof t ? _this18._setUpBindToBinding(function (e) {
                return t(e);
              }) : _this18._setUpBindToBinding(function (e) {
                return e[t];
              });
            }
          };
        }
      }, {
        key: "_setUpBindToBinding",
        value: function _setUpBindToBinding(t) {
          var _this19 = this;

          var e = this._bindToCollection,
              n = function n(_n24, i, o) {
            var r = e._bindToCollection == _this19,
                s = e._bindToInternalToExternalMap.get(i);

            if (r && s) _this19._bindToExternalToInternalMap.set(i, s), _this19._bindToInternalToExternalMap.set(s, i);else {
              var _n23 = t(i);

              if (!_n23) return void _this19._skippedIndexesFromExternal.push(o);
              var _r2 = o;
              var _iteratorNormalCompletion31 = true;
              var _didIteratorError31 = false;
              var _iteratorError31 = undefined;

              try {
                for (var _iterator31 = _this19._skippedIndexesFromExternal[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                  var _t24 = _step31.value;
                  o > _t24 && _r2--;
                }
              } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
                    _iterator31.return();
                  }
                } finally {
                  if (_didIteratorError31) {
                    throw _iteratorError31;
                  }
                }
              }

              var _iteratorNormalCompletion32 = true;
              var _didIteratorError32 = false;
              var _iteratorError32 = undefined;

              try {
                for (var _iterator32 = e._skippedIndexesFromExternal[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                  var _t25 = _step32.value;
                  _r2 >= _t25 && _r2++;
                }
              } catch (err) {
                _didIteratorError32 = true;
                _iteratorError32 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
                    _iterator32.return();
                  }
                } finally {
                  if (_didIteratorError32) {
                    throw _iteratorError32;
                  }
                }
              }

              _this19._bindToExternalToInternalMap.set(i, _n23), _this19._bindToInternalToExternalMap.set(_n23, i), _this19.add(_n23, _r2);

              for (var _t23 = 0; _t23 < e._skippedIndexesFromExternal.length; _t23++) {
                _r2 <= e._skippedIndexesFromExternal[_t23] && e._skippedIndexesFromExternal[_t23]++;
              }
            }
          };

          var _iteratorNormalCompletion33 = true;
          var _didIteratorError33 = false;
          var _iteratorError33 = undefined;

          try {
            for (var _iterator33 = e[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
              var _t26 = _step33.value;
              n(0, _t26, e.getIndex(_t26));
            }
          } catch (err) {
            _didIteratorError33 = true;
            _iteratorError33 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
                _iterator33.return();
              }
            } finally {
              if (_didIteratorError33) {
                throw _iteratorError33;
              }
            }
          }

          this.listenTo(e, "add", n), this.listenTo(e, "remove", function (t, e, n) {
            var i = _this19._bindToExternalToInternalMap.get(e);

            i && _this19.remove(i), _this19._skippedIndexesFromExternal = _this19._skippedIndexesFromExternal.reduce(function (t, e) {
              return n < e && t.push(e - 1), n > e && t.push(e), t;
            }, []);
          });
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._items[0] || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this.length - 1] || null;
        }
      }]);

      return ro;
    }();

    li(ro, ni);

    var so =
    /*#__PURE__*/
    function () {
      function so() {
        _classCallCheck(this, so);

        this.selection = new oo(), this.roots = new ro({
          idProperty: "rootName"
        }), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isComposing", !1), this._postFixers = new Set();
      }

      _createClass(so, [{
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.roots.map(function (t) {
            return t.destroy();
          }), this.stopListening();
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;

          do {
            var _iteratorNormalCompletion34 = true;
            var _didIteratorError34 = false;
            var _iteratorError34 = undefined;

            try {
              for (var _iterator34 = this._postFixers[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                var _n25 = _step34.value;
                if (e = _n25(t), e) break;
              }
            } catch (err) {
              _didIteratorError34 = true;
              _iteratorError34 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
                  _iterator34.return();
                }
              } finally {
                if (_didIteratorError34) {
                  throw _iteratorError34;
                }
              }
            }
          } while (e);
        }
      }]);

      return so;
    }();

    li(so, Ui);
    var ao = 10;

    var co =
    /*#__PURE__*/
    function (_i21) {
      _inherits(co, _i21);

      function co(t, e, n) {
        var _this20;

        _classCallCheck(this, co);

        _this20 = _possibleConstructorReturn(this, _getPrototypeOf(co).call(this, t, e, n)), _this20.getFillerOffset = lo, _this20._priority = ao, _this20._id = null, _this20._clonesGroup = null;
        return _this20;
      }

      _createClass(co, [{
        key: "getElementsWithSameId",
        value: function getElementsWithSameId() {
          if (null === this.id) throw new Qn.b("attribute-element-get-elements-with-same-id-no-id: Cannot get elements with the same id for an attribute element without id.", this);
          return new Set(this._clonesGroup);
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t && t.replace(/^view:/, "");
          return e ? "attributeElement" == n && e == this.name || _get(_getPrototypeOf(co.prototype), "is", this).call(this, t, e) : "attributeElement" == n || _get(_getPrototypeOf(co.prototype), "is", this).call(this, t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return null !== this.id || null !== t.id ? this.id === t.id : _get(_getPrototypeOf(co.prototype), "isSimilar", this).call(this, t) && this.priority == t.priority;
        }
      }, {
        key: "_clone",
        value: function _clone(t) {
          var e = _get(_getPrototypeOf(co.prototype), "_clone", this).call(this, t);

          return e._priority = this._priority, e._id = this._id, e;
        }
      }, {
        key: "priority",
        get: function get() {
          return this._priority;
        }
      }, {
        key: "id",
        get: function get() {
          return this._id;
        }
      }]);

      return co;
    }(_i);

    function lo() {
      if (ho(this)) return null;
      var t = this.parent;

      for (; t && t.is("attributeElement");) {
        if (ho(t) > 1) return null;
        t = t.parent;
      }

      return !t || ho(t) > 1 ? null : this.childCount;
    }

    function ho(t) {
      return Array.from(t.getChildren()).filter(function (t) {
        return !t.is("uiElement");
      }).length;
    }

    co.DEFAULT_PRIORITY = ao;

    var uo =
    /*#__PURE__*/
    function (_i22) {
      _inherits(uo, _i22);

      function uo(t, e, n) {
        var _this21;

        _classCallCheck(this, uo);

        _this21 = _possibleConstructorReturn(this, _getPrototypeOf(uo).call(this, t, e, n)), _this21.getFillerOffset = fo;
        return _this21;
      }

      _createClass(uo, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "emptyElement" == n && e == this.name || _get(_getPrototypeOf(uo.prototype), "is", this).call(this, t, e) : "emptyElement" == n || _get(_getPrototypeOf(uo.prototype), "is", this).call(this, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof fi || Array.from(e).length > 0)) throw new Qn.b("view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.", [this, e]);
        }
      }]);

      return uo;
    }(_i);

    function fo() {
      return null;
    }

    var go = navigator.userAgent.toLowerCase();
    var mo = {
      isMac: function (t) {
        return t.indexOf("macintosh") > -1;
      }(go),
      isEdge: function (t) {
        return !!t.match(/edge\/(\d+.?\d*)/);
      }(go),
      isGecko: function (t) {
        return !!t.match(/gecko\/\d+/);
      }(go),
      isSafari: function (t) {
        return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
      }(go),
      isAndroid: function (t) {
        return t.indexOf("android") > -1;
      }(go),
      features: {
        isRegExpUnicodePropertySupported: function () {
          var t = !1;

          try {
            t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
          } catch (t) {}

          return t;
        }()
      }
    };

    var po = {
      "⌘": "ctrl",
      "⇧": "shift",
      "⌥": "alt"
    },
        bo = {
      ctrl: "⌘",
      shift: "⇧",
      alt: "⌥"
    },
        wo = function () {
      var t = {
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        backspace: 8,
        delete: 46,
        enter: 13,
        space: 32,
        esc: 27,
        tab: 9,
        ctrl: 1114112,
        cmd: 1114112,
        shift: 2228224,
        alt: 4456448
      };

      for (var _e33 = 65; _e33 <= 90; _e33++) {
        var _n26 = String.fromCharCode(_e33);

        t[_n26.toLowerCase()] = _e33;
      }

      for (var _e34 = 48; _e34 <= 57; _e34++) {
        t[_e34 - 48] = _e34;
      }

      for (var _e35 = 112; _e35 <= 123; _e35++) {
        t["f" + (_e35 - 111)] = _e35;
      }

      return t;
    }();

    function ko(t) {
      var e;

      if ("string" == typeof t) {
        if (e = wo[t.toLowerCase()], !e) throw new Qn.b("keyboard-unknown-key: Unknown key name.", null, {
          key: t
        });
      } else e = t.keyCode + (t.altKey ? wo.alt : 0) + (t.ctrlKey ? wo.ctrl : 0) + (t.shiftKey ? wo.shift : 0);

      return e;
    }

    function _o(t) {
      return "string" == typeof t && (t = yo(t)), t.map(function (t) {
        return "string" == typeof t ? ko(t) : t;
      }).reduce(function (t, e) {
        return e + t;
      }, 0);
    }

    function vo(t) {
      return mo.isMac ? yo(t).map(function (t) {
        return bo[t.toLowerCase()] || t;
      }).reduce(function (t, e) {
        return t.slice(-1) in po ? t + e : t + "+" + e;
      }) : t;
    }

    function yo(t) {
      return t.split(/\s*\+\s*/);
    }

    var xo =
    /*#__PURE__*/
    function (_i23) {
      _inherits(xo, _i23);

      function xo(t, e, n) {
        var _this22;

        _classCallCheck(this, xo);

        _this22 = _possibleConstructorReturn(this, _getPrototypeOf(xo).call(this, t, e, n)), _this22.getFillerOffset = To;
        return _this22;
      }

      _createClass(xo, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "uiElement" == n && e == this.name || _get(_getPrototypeOf(xo.prototype), "is", this).call(this, t, e) : "uiElement" == n || _get(_getPrototypeOf(xo.prototype), "is", this).call(this, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof fi || Array.from(e).length > 0)) throw new Qn.b("view-uielement-cannot-add: Cannot add child nodes to UIElement instance.", this);
        }
      }, {
        key: "render",
        value: function render(t) {
          return this.toDomElement(t);
        }
      }, {
        key: "toDomElement",
        value: function toDomElement(t) {
          var e = t.createElement(this.name);
          var _iteratorNormalCompletion35 = true;
          var _didIteratorError35 = false;
          var _iteratorError35 = undefined;

          try {
            for (var _iterator35 = this.getAttributeKeys()[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
              var _t27 = _step35.value;
              e.setAttribute(_t27, this.getAttribute(_t27));
            }
          } catch (err) {
            _didIteratorError35 = true;
            _iteratorError35 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
                _iterator35.return();
              }
            } finally {
              if (_didIteratorError35) {
                throw _iteratorError35;
              }
            }
          }

          return e;
        }
      }]);

      return xo;
    }(_i);

    function Ao(t) {
      t.document.on("keydown", function (e, n) {
        return function (t, e, n) {
          if (e.keyCode == wo.arrowright) {
            var _t28 = e.domTarget.ownerDocument.defaultView.getSelection(),
                _i24 = 1 == _t28.rangeCount && _t28.getRangeAt(0).collapsed;

            if (_i24 || e.shiftKey) {
              var _e36 = _t28.focusNode,
                  _o13 = _t28.focusOffset,
                  _r3 = n.domPositionToView(_e36, _o13);

              if (null === _r3) return;

              var _s3 = !1;

              var _a3 = _r3.getLastMatchingPosition(function (t) {
                return t.item.is("uiElement") && (_s3 = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"));
              });

              if (_s3) {
                var _e37 = n.viewPositionToDom(_a3);

                _i24 ? _t28.collapse(_e37.parent, _e37.offset) : _t28.extend(_e37.parent, _e37.offset);
              }
            }
          }
        }(0, n, t.domConverter);
      });
    }

    function To() {
      return null;
    }

    var Co =
    /*#__PURE__*/
    function () {
      function Co(t) {
        _classCallCheck(this, Co);

        this._children = [], t && this._insertChild(0, t);
      }

      _createClass(Co, [{
        key: Symbol.iterator,
        value: function value() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" == t || "view:documentFragment" == t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);

          var n = 0;

          var i = function (t) {
            if ("string" == typeof t) return [new gi(t)];
            bi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new gi(t) : t instanceof mi ? new gi(t.data) : t;
            });
          }(e);

          var _iteratorNormalCompletion36 = true;
          var _didIteratorError36 = false;
          var _iteratorError36 = undefined;

          try {
            for (var _iterator36 = i[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
              var _e38 = _step36.value;
              null !== _e38.parent && _e38._remove(), _e38.parent = this, this._children.splice(t, 0, _e38), t++, n++;
            }
          } catch (err) {
            _didIteratorError36 = true;
            _iteratorError36 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
                _iterator36.return();
              }
            } finally {
              if (_didIteratorError36) {
                throw _iteratorError36;
              }
            }
          }

          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _n27 = t; _n27 < t + e; _n27++) {
            this._children[_n27].parent = null;
          }

          return this._children.splice(t, e);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }]);

      return Co;
    }();

    li(Co, ni);

    var Po =
    /*#__PURE__*/
    function () {
      function Po(t) {
        _classCallCheck(this, Po);

        this.document = t, this._cloneGroups = new Map();
      }

      _createClass(Po, [{
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this.document.selection._setFocus(t, e);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new gi(t);
        }
      }, {
        key: "createAttributeElement",
        value: function createAttributeElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = new co(t, e);
          return n.priority && (i._priority = n.priority), n.id && (i._id = n.id), i;
        }
      }, {
        key: "createContainerElement",
        value: function createContainerElement(t, e) {
          return new xi(t, e);
        }
      }, {
        key: "createEditableElement",
        value: function createEditableElement(t, e) {
          var n = new Qi(t, e);
          return n._document = this.document, n;
        }
      }, {
        key: "createEmptyElement",
        value: function createEmptyElement(t, e) {
          return new uo(t, e);
        }
      }, {
        key: "createUIElement",
        value: function createUIElement(t, e, n) {
          var i = new xo(t, e);
          return n && (i.render = n), i;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          T(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "breakAttributes",
        value: function breakAttributes(t) {
          return t instanceof Xi ? this._breakAttributes(t) : this._breakAttributesRange(t);
        }
      }, {
        key: "breakContainer",
        value: function breakContainer(t) {
          var e = t.parent;
          if (!e.is("containerElement")) throw new Qn.b("view-writer-break-non-container-element: Trying to break an element which is not a container element.", this.document);
          if (!e.parent) throw new Qn.b("view-writer-break-root: Trying to break root element.", this.document);
          if (t.isAtStart) return Xi._createBefore(e);

          if (!t.isAtEnd) {
            var _n28 = e._clone(!1);

            this.insert(Xi._createAfter(e), _n28);

            var _i25 = new to(t, Xi._createAt(e, "end")),
                _o14 = new Xi(_n28, 0);

            this.move(_i25, _o14);
          }

          return Xi._createAfter(e);
        }
      }, {
        key: "mergeAttributes",
        value: function mergeAttributes(t) {
          var e = t.offset,
              n = t.parent;
          if (n.is("text")) return t;

          if (n.is("attributeElement") && 0 === n.childCount) {
            var _t29 = n.parent,
                _e39 = n.index;
            return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Xi(_t29, _e39));
          }

          var i = n.getChild(e - 1),
              o = n.getChild(e);
          if (!i || !o) return t;
          if (i.is("text") && o.is("text")) return No(i, o);

          if (i.is("attributeElement") && o.is("attributeElement") && i.isSimilar(o)) {
            var _t30 = i.childCount;
            return i._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new Xi(i, _t30));
          }

          return t;
        }
      }, {
        key: "mergeContainers",
        value: function mergeContainers(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new Qn.b("view-writer-merge-containers-invalid-position: Element before and after given position cannot be merged.", this.document);
          var i = e.getChild(e.childCount - 1),
              o = i instanceof gi ? Xi._createAt(i, "end") : Xi._createAt(e, "end");
          return this.move(to._createIn(n), Xi._createAt(e, "end")), this.remove(to._createOn(n)), o;
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          (function t(e, n) {
            var _iteratorNormalCompletion37 = true;
            var _didIteratorError37 = false;
            var _iteratorError37 = undefined;

            try {
              var _loop = function _loop() {
                var i = _step37.value;
                if (!Oo.some(function (t) {
                  return i instanceof t;
                })) throw new Qn.b("view-writer-insert-invalid-node", n);
                i.is("text") || t(i.getChildren(), n);
              };

              for (var _iterator37 = e[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                _loop();
              }
            } catch (err) {
              _didIteratorError37 = true;
              _iteratorError37 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
                  _iterator37.return();
                }
              } finally {
                if (_didIteratorError37) {
                  throw _iteratorError37;
                }
              }
            }
          })(e = bi(e) ? _toConsumableArray(e) : [e], this.document);

          var n = So(t);
          if (!n) throw new Qn.b("view-writer-invalid-position-container", this.document);

          var i = this._breakAttributes(t, !0),
              o = n._insertChild(i.offset, e);

          var _iteratorNormalCompletion38 = true;
          var _didIteratorError38 = false;
          var _iteratorError38 = undefined;

          try {
            for (var _iterator38 = e[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
              var _t32 = _step38.value;

              this._addToClonedElementsGroup(_t32);
            }
          } catch (err) {
            _didIteratorError38 = true;
            _iteratorError38 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
                _iterator38.return();
              }
            } finally {
              if (_didIteratorError38) {
                throw _iteratorError38;
              }
            }
          }

          var r = i.getShiftedBy(o),
              s = this.mergeAttributes(i);
          if (0 === o) return new to(s, s);
          {
            s.isEqual(i) || r.offset--;

            var _t31 = this.mergeAttributes(r);

            return new to(s, _t31);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t instanceof to ? t : to._createOn(t);
          if (Do(e, this.document), e.isCollapsed) return new Co();

          var _this$_breakAttribute = this._breakAttributesRange(e, !0),
              n = _this$_breakAttribute.start,
              i = _this$_breakAttribute.end,
              o = n.parent,
              r = i.offset - n.offset,
              s = o._removeChildren(n.offset, r);

          var _iteratorNormalCompletion39 = true;
          var _didIteratorError39 = false;
          var _iteratorError39 = undefined;

          try {
            for (var _iterator39 = s[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
              var _t33 = _step39.value;

              this._removeFromClonedElementsGroup(_t33);
            }
          } catch (err) {
            _didIteratorError39 = true;
            _iteratorError39 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion39 && _iterator39.return != null) {
                _iterator39.return();
              }
            } finally {
              if (_didIteratorError39) {
                throw _iteratorError39;
              }
            }
          }

          var a = this.mergeAttributes(n);
          return e.start = a, e.end = a.clone(), new Co(s);
        }
      }, {
        key: "clear",
        value: function clear(t, e) {
          Do(t, this.document);
          var n = t.getWalker({
            direction: "backward",
            ignoreElementEnd: !0
          });
          var _iteratorNormalCompletion40 = true;
          var _didIteratorError40 = false;
          var _iteratorError40 = undefined;

          try {
            for (var _iterator40 = n[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
              var _i26 = _step40.value;
              var _n29 = _i26.item;

              var _o15 = void 0;

              if (_n29.is("element") && e.isSimilar(_n29)) _o15 = to._createOn(_n29);else if (!_i26.nextPosition.isAfter(t.start) && _n29.is("textProxy")) {
                var _t34 = _n29.getAncestors().find(function (t) {
                  return t.is("element") && e.isSimilar(t);
                });

                _t34 && (_o15 = to._createIn(_t34));
              }
              _o15 && (_o15.end.isAfter(t.end) && (_o15.end = t.end), _o15.start.isBefore(t.start) && (_o15.start = t.start), this.remove(_o15));
            }
          } catch (err) {
            _didIteratorError40 = true;
            _iteratorError40 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion40 && _iterator40.return != null) {
                _iterator40.return();
              }
            } finally {
              if (_didIteratorError40) {
                throw _iteratorError40;
              }
            }
          }
        }
      }, {
        key: "move",
        value: function move(t, e) {
          var n;

          if (e.isAfter(t.end)) {
            var _i27 = (e = this._breakAttributes(e, !0)).parent,
                _o16 = _i27.childCount;

            t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += _i27.childCount - _o16;
          } else n = this.remove(t);

          return this.insert(e, n);
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (!(e instanceof co)) throw new Qn.b("view-writer-wrap-invalid-attribute", this.document);

          if (Do(t, this.document), t.isCollapsed) {
            var _i28 = t.start;
            _i28.parent.is("element") && (n = _i28.parent, !Array.from(n.getChildren()).some(function (t) {
              return !t.is("uiElement");
            })) && (_i28 = _i28.getLastMatchingPosition(function (t) {
              return t.item.is("uiElement");
            })), _i28 = this._wrapPosition(_i28, e);
            var _o17 = this.document.selection;
            return _o17.isCollapsed && _o17.getFirstPosition().isEqual(t.start) && this.setSelection(_i28), new to(_i28);
          }

          return this._wrapRange(t, e);
          var n;
        }
      }, {
        key: "unwrap",
        value: function unwrap(t, e) {
          if (!(e instanceof co)) throw new Qn.b("view-writer-unwrap-invalid-attribute", this.document);
          if (Do(t, this.document), t.isCollapsed) return t;

          var _this$_breakAttribute2 = this._breakAttributesRange(t, !0),
              n = _this$_breakAttribute2.start,
              i = _this$_breakAttribute2.end,
              o = n.parent,
              r = this._unwrapChildren(o, n.offset, i.offset, e),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new to(s, a);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new xi(t, e.getAttributes());
          return this.insert(Xi._createAfter(e), n), this.move(to._createIn(e), Xi._createAt(n, 0)), this.remove(to._createOn(e)), n;
        }
      }, {
        key: "clearClonedElementsGroup",
        value: function clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Xi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Xi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Xi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new to(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return to._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return to._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new io(t, e, n);
        }
      }, {
        key: "_wrapChildren",
        value: function _wrapChildren(t, e, n, i) {
          var o = e;
          var r = [];

          for (; o < n;) {
            var _e40 = t.getChild(o),
                _n30 = _e40.is("text"),
                _s4 = _e40.is("attributeElement"),
                _a4 = _e40.is("emptyElement"),
                _c2 = _e40.is("uiElement");

            if (_s4 && this._wrapAttributeElement(i, _e40)) r.push(new Xi(t, o));else if (_n30 || _a4 || _c2 || _s4 && Mo(i, _e40)) {
              var _n31 = i._clone();

              _e40._remove(), _n31._appendChild(_e40), t._insertChild(o, _n31), this._addToClonedElementsGroup(_n31), r.push(new Xi(t, o));
            } else _s4 && this._wrapChildren(_e40, 0, _e40.childCount, i);
            o++;
          }

          var s = 0;

          for (var _i29 = 0, _r4 = r; _i29 < _r4.length; _i29++) {
            var _t35 = _r4[_i29];
            if (_t35.offset -= s, _t35.offset == e) continue;
            this.mergeAttributes(_t35).isEqual(_t35) || (s++, n--);
          }

          return to._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_unwrapChildren",
        value: function _unwrapChildren(t, e, n, i) {
          var o = e;
          var r = [];

          for (; o < n;) {
            var _e41 = t.getChild(o);

            if (_e41.is("attributeElement")) {
              if (_e41.isSimilar(i)) {
                var _i30 = _e41.getChildren(),
                    _s5 = _e41.childCount;

                _e41._remove(), t._insertChild(o, _i30), this._removeFromClonedElementsGroup(_e41), r.push(new Xi(t, o), new Xi(t, o + _s5)), o += _s5, n += _s5 - 1;
              } else this._unwrapAttributeElement(i, _e41) ? (r.push(new Xi(t, o), new Xi(t, o + 1)), o++) : (this._unwrapChildren(_e41, 0, _e41.childCount, i), o++);
            } else o++;
          }

          var s = 0;

          for (var _i31 = 0, _r5 = r; _i31 < _r5.length; _i31++) {
            var _t36 = _r5[_i31];
            if (_t36.offset -= s, _t36.offset == e || _t36.offset == n) continue;
            this.mergeAttributes(_t36).isEqual(_t36) || (s++, n--);
          }

          return to._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_wrapRange",
        value: function _wrapRange(t, e) {
          var _this$_breakAttribute3 = this._breakAttributesRange(t, !0),
              n = _this$_breakAttribute3.start,
              i = _this$_breakAttribute3.end,
              o = n.parent,
              r = this._wrapChildren(o, n.offset, i.offset, e),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new to(s, a);
        }
      }, {
        key: "_wrapPosition",
        value: function _wrapPosition(t, e) {
          if (e.isSimilar(t.parent)) return Eo(t.clone());
          t.parent.is("text") && (t = Io(t));
          var n = this.createAttributeElement();
          n._priority = Number.POSITIVE_INFINITY, n.isSimilar = function () {
            return !1;
          }, t.parent._insertChild(t.offset, n);
          var i = new to(t, t.getShiftedBy(1));
          this.wrap(i, e);
          var o = new Xi(n.parent, n.index);

          n._remove();

          var r = o.nodeBefore,
              s = o.nodeAfter;
          return r instanceof gi && s instanceof gi ? No(r, s) : Eo(o);
        }
      }, {
        key: "_wrapAttributeElement",
        value: function _wrapAttributeElement(t, e) {
          if (!Lo(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;
          var _iteratorNormalCompletion41 = true;
          var _didIteratorError41 = false;
          var _iteratorError41 = undefined;

          try {
            for (var _iterator41 = t.getAttributeKeys()[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
              var _n32 = _step41.value;
              if ("class" !== _n32 && "style" !== _n32 && e.hasAttribute(_n32) && e.getAttribute(_n32) !== t.getAttribute(_n32)) return !1;
            }
          } catch (err) {
            _didIteratorError41 = true;
            _iteratorError41 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion41 && _iterator41.return != null) {
                _iterator41.return();
              }
            } finally {
              if (_didIteratorError41) {
                throw _iteratorError41;
              }
            }
          }

          var _iteratorNormalCompletion42 = true;
          var _didIteratorError42 = false;
          var _iteratorError42 = undefined;

          try {
            for (var _iterator42 = t.getStyleNames()[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
              var _n33 = _step42.value;
              if (e.hasStyle(_n33) && e.getStyle(_n33) !== t.getStyle(_n33)) return !1;
            }
          } catch (err) {
            _didIteratorError42 = true;
            _iteratorError42 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion42 && _iterator42.return != null) {
                _iterator42.return();
              }
            } finally {
              if (_didIteratorError42) {
                throw _iteratorError42;
              }
            }
          }

          var _iteratorNormalCompletion43 = true;
          var _didIteratorError43 = false;
          var _iteratorError43 = undefined;

          try {
            for (var _iterator43 = t.getAttributeKeys()[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
              var _n34 = _step43.value;
              "class" !== _n34 && "style" !== _n34 && (e.hasAttribute(_n34) || this.setAttribute(_n34, t.getAttribute(_n34), e));
            }
          } catch (err) {
            _didIteratorError43 = true;
            _iteratorError43 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion43 && _iterator43.return != null) {
                _iterator43.return();
              }
            } finally {
              if (_didIteratorError43) {
                throw _iteratorError43;
              }
            }
          }

          var _iteratorNormalCompletion44 = true;
          var _didIteratorError44 = false;
          var _iteratorError44 = undefined;

          try {
            for (var _iterator44 = t.getStyleNames()[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
              var _n35 = _step44.value;
              e.hasStyle(_n35) || this.setStyle(_n35, t.getStyle(_n35), e);
            }
          } catch (err) {
            _didIteratorError44 = true;
            _iteratorError44 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion44 && _iterator44.return != null) {
                _iterator44.return();
              }
            } finally {
              if (_didIteratorError44) {
                throw _iteratorError44;
              }
            }
          }

          var _iteratorNormalCompletion45 = true;
          var _didIteratorError45 = false;
          var _iteratorError45 = undefined;

          try {
            for (var _iterator45 = t.getClassNames()[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
              var _n36 = _step45.value;
              e.hasClass(_n36) || this.addClass(_n36, e);
            }
          } catch (err) {
            _didIteratorError45 = true;
            _iteratorError45 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion45 && _iterator45.return != null) {
                _iterator45.return();
              }
            } finally {
              if (_didIteratorError45) {
                throw _iteratorError45;
              }
            }
          }

          return !0;
        }
      }, {
        key: "_unwrapAttributeElement",
        value: function _unwrapAttributeElement(t, e) {
          if (!Lo(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;
          var _iteratorNormalCompletion46 = true;
          var _didIteratorError46 = false;
          var _iteratorError46 = undefined;

          try {
            for (var _iterator46 = t.getAttributeKeys()[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
              var _n37 = _step46.value;
              if ("class" !== _n37 && "style" !== _n37 && (!e.hasAttribute(_n37) || e.getAttribute(_n37) !== t.getAttribute(_n37))) return !1;
            }
          } catch (err) {
            _didIteratorError46 = true;
            _iteratorError46 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion46 && _iterator46.return != null) {
                _iterator46.return();
              }
            } finally {
              if (_didIteratorError46) {
                throw _iteratorError46;
              }
            }
          }

          if (!e.hasClass.apply(e, _toConsumableArray(t.getClassNames()))) return !1;
          var _iteratorNormalCompletion47 = true;
          var _didIteratorError47 = false;
          var _iteratorError47 = undefined;

          try {
            for (var _iterator47 = t.getStyleNames()[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
              var _n38 = _step47.value;
              if (!e.hasStyle(_n38) || e.getStyle(_n38) !== t.getStyle(_n38)) return !1;
            }
          } catch (err) {
            _didIteratorError47 = true;
            _iteratorError47 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion47 && _iterator47.return != null) {
                _iterator47.return();
              }
            } finally {
              if (_didIteratorError47) {
                throw _iteratorError47;
              }
            }
          }

          var _iteratorNormalCompletion48 = true;
          var _didIteratorError48 = false;
          var _iteratorError48 = undefined;

          try {
            for (var _iterator48 = t.getAttributeKeys()[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
              var _n39 = _step48.value;
              "class" !== _n39 && "style" !== _n39 && this.removeAttribute(_n39, e);
            }
          } catch (err) {
            _didIteratorError48 = true;
            _iteratorError48 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion48 && _iterator48.return != null) {
                _iterator48.return();
              }
            } finally {
              if (_didIteratorError48) {
                throw _iteratorError48;
              }
            }
          }

          return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
        }
      }, {
        key: "_breakAttributesRange",
        value: function _breakAttributesRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.start,
              i = t.end;

          if (Do(t, this.document), t.isCollapsed) {
            var _n40 = this._breakAttributes(t.start, e);

            return new to(_n40, _n40);
          }

          var o = this._breakAttributes(i, e),
              r = o.parent.childCount,
              s = this._breakAttributes(n, e);

          return o.offset += o.parent.childCount - r, new to(s, o);
        }
      }, {
        key: "_breakAttributes",
        value: function _breakAttributes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.offset,
              i = t.parent;
          if (t.parent.is("emptyElement")) throw new Qn.b("view-writer-cannot-break-empty-element", this.document);
          if (t.parent.is("uiElement")) throw new Qn.b("view-writer-cannot-break-ui-element", this.document);
          if (!e && i.is("text") && Ro(i.parent)) return t.clone();
          if (Ro(i)) return t.clone();
          if (i.is("text")) return this._breakAttributes(Io(t), e);

          if (n == i.childCount) {
            var _t37 = new Xi(i.parent, i.index + 1);

            return this._breakAttributes(_t37, e);
          }

          if (0 === n) {
            var _t38 = new Xi(i.parent, i.index);

            return this._breakAttributes(_t38, e);
          }

          {
            var _t39 = i.index + 1,
                _o18 = i._clone();

            i.parent._insertChild(_t39, _o18), this._addToClonedElementsGroup(_o18);

            var _r6 = i.childCount - n,
                _s6 = i._removeChildren(n, _r6);

            _o18._appendChild(_s6);

            var _a5 = new Xi(i.parent, _t39);

            return this._breakAttributes(_a5, e);
          }
        }
      }, {
        key: "_addToClonedElementsGroup",
        value: function _addToClonedElementsGroup(t) {
          if (!t.root.is("rootElement")) return;

          if (t.is("element")) {
            var _iteratorNormalCompletion49 = true;
            var _didIteratorError49 = false;
            var _iteratorError49 = undefined;

            try {
              for (var _iterator49 = t.getChildren()[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
                var _e42 = _step49.value;

                this._addToClonedElementsGroup(_e42);
              }
            } catch (err) {
              _didIteratorError49 = true;
              _iteratorError49 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion49 && _iterator49.return != null) {
                  _iterator49.return();
                }
              } finally {
                if (_didIteratorError49) {
                  throw _iteratorError49;
                }
              }
            }
          }

          var e = t.id;
          if (!e) return;

          var n = this._cloneGroups.get(e);

          n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
        }
      }, {
        key: "_removeFromClonedElementsGroup",
        value: function _removeFromClonedElementsGroup(t) {
          if (t.is("element")) {
            var _iteratorNormalCompletion50 = true;
            var _didIteratorError50 = false;
            var _iteratorError50 = undefined;

            try {
              for (var _iterator50 = t.getChildren()[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
                var _e43 = _step50.value;

                this._removeFromClonedElementsGroup(_e43);
              }
            } catch (err) {
              _didIteratorError50 = true;
              _iteratorError50 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion50 && _iterator50.return != null) {
                  _iterator50.return();
                }
              } finally {
                if (_didIteratorError50) {
                  throw _iteratorError50;
                }
              }
            }
          }

          var e = t.id;
          if (!e) return;

          var n = this._cloneGroups.get(e);

          n && n.delete(t);
        }
      }]);

      return Po;
    }();

    function So(t) {
      var e = t.parent;

      for (; !Ro(e);) {
        if (!e) return;
        e = e.parent;
      }

      return e;
    }

    function Mo(t, e) {
      return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
    }

    function Eo(t) {
      var e = t.nodeBefore;
      if (e && e.is("text")) return new Xi(e, e.data.length);
      var n = t.nodeAfter;
      return n && n.is("text") ? new Xi(n, 0) : t;
    }

    function Io(t) {
      if (t.offset == t.parent.data.length) return new Xi(t.parent.parent, t.parent.index + 1);
      if (0 === t.offset) return new Xi(t.parent.parent, t.parent.index);
      var e = t.parent.data.slice(t.offset);
      return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new gi(e)), new Xi(t.parent.parent, t.parent.index + 1);
    }

    function No(t, e) {
      var n = t.data.length;
      return t._data += e.data, e._remove(), new Xi(t, n);
    }

    var Oo = [gi, co, xi, uo, xo];

    function Ro(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }

    function Do(t, e) {
      var n = So(t.start),
          i = So(t.end);
      if (!n || !i || n !== i) throw new Qn.b("view-writer-invalid-range-container", e);
    }

    function Lo(t, e) {
      return null === t.id && null === e.id;
    }

    function jo(t) {
      return "[object Text]" == Object.prototype.toString.call(t);
    }

    var Vo = function Vo(t) {
      return t.createTextNode(" ");
    },
        zo = function zo(t) {
      var e = t.createElement("br");
      return e.dataset.ckeFiller = !0, e;
    },
        Bo = 7,
        Fo = function () {
      var t = "";

      for (var _e44 = 0; _e44 < Bo; _e44++) {
        t += "​";
      }

      return t;
    }();

    function Uo(t) {
      return jo(t) && t.data.substr(0, Bo) === Fo;
    }

    function Ho(t) {
      return t.data.length == Bo && Uo(t);
    }

    function qo(t) {
      return Uo(t) ? t.data.slice(Bo) : t.data;
    }

    function Wo(t, e) {
      if (e.keyCode == wo.arrowleft) {
        var _t40 = e.domTarget.ownerDocument.defaultView.getSelection();

        if (1 == _t40.rangeCount && _t40.getRangeAt(0).collapsed) {
          var _e45 = _t40.getRangeAt(0).startContainer,
              _n41 = _t40.getRangeAt(0).startOffset;

          Uo(_e45) && _n41 <= Bo && _t40.collapse(_e45, 0);
        }
      }
    }

    function Yo(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      n = n || function (t, e) {
        return t === e;
      }, Array.isArray(t) || (t = Array.from(t)), Array.isArray(e) || (e = Array.from(e));

      var o = function (t, e, n) {
        var i = $o(t, e, n);
        if (-1 === i) return {
          firstIndex: -1,
          lastIndexOld: -1,
          lastIndexNew: -1
        };
        var o = Go(t, i),
            r = Go(e, i),
            s = $o(o, r, n),
            a = t.length - s,
            c = e.length - s;
        return {
          firstIndex: i,
          lastIndexOld: a,
          lastIndexNew: c
        };
      }(t, e, n);

      return i ? function (t, e) {
        var n = t.firstIndex,
            i = t.lastIndexOld,
            o = t.lastIndexNew;
        if (-1 === n) return Array(e).fill("equal");
        var r = [];
        n > 0 && (r = r.concat(Array(n).fill("equal")));
        o - n > 0 && (r = r.concat(Array(o - n).fill("insert")));
        i - n > 0 && (r = r.concat(Array(i - n).fill("delete")));
        o < e && (r = r.concat(Array(e - o).fill("equal")));
        return r;
      }(o, e.length) : function (t, e) {
        var n = [],
            i = e.firstIndex,
            o = e.lastIndexOld,
            r = e.lastIndexNew;
        r - i > 0 && n.push({
          index: i,
          type: "insert",
          values: t.slice(i, r)
        });
        o - i > 0 && n.push({
          index: i + (r - i),
          type: "delete",
          howMany: o - i
        });
        return n;
      }(e, o);
    }

    function $o(t, e, n) {
      for (var _i32 = 0; _i32 < Math.max(t.length, e.length); _i32++) {
        if (void 0 === t[_i32] || void 0 === e[_i32] || !n(t[_i32], e[_i32])) return _i32;
      }

      return -1;
    }

    function Go(t, e) {
      return t.slice(e).reverse();
    }

    function Qo(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };

      var i = t.length,
          o = e.length;
      if (i > 200 || o > 200 || i + o > 300) return Qo.fastDiff(t, e, n, !0);
      var r, s;

      if (o < i) {
        var _n42 = t;
        t = e, e = _n42, r = "delete", s = "insert";
      } else r = "insert", s = "delete";

      var a = t.length,
          c = e.length,
          l = c - a,
          d = {},
          h = {};

      function u(i) {
        var o = (void 0 !== h[i - 1] ? h[i - 1] : -1) + 1,
            l = void 0 !== h[i + 1] ? h[i + 1] : -1,
            u = o > l ? -1 : 1;
        d[i + u] && (d[i] = d[i + u].slice(0)), d[i] || (d[i] = []), d[i].push(o > l ? r : s);
        var f = Math.max(o, l),
            g = f - i;

        for (; g < a && f < c && n(t[g], e[f]);) {
          g++, f++, d[i].push("equal");
        }

        return f;
      }

      var f,
          g = 0;

      do {
        for (f = -g; f < l; f++) {
          h[f] = u(f);
        }

        for (f = l + g; f > l; f--) {
          h[f] = u(f);
        }

        h[l] = u(l), g++;
      } while (h[l] !== c);

      return d[l].slice(1);
    }

    function Ko(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }

    function Jo(t) {
      var e = t.parentNode;
      e && e.removeChild(t);
    }

    function Zo(t) {
      if (t) {
        if (t.defaultView) return t instanceof t.defaultView.Document;
        if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
      }

      return !1;
    }

    Qo.fastDiff = Yo;

    var Xo =
    /*#__PURE__*/
    function () {
      function Xo(t, e) {
        _classCallCheck(this, Xo);

        this.domDocuments = new Set(), this.domConverter = t, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = e, this.isFocused = !1, this._inlineFiller = null, this._fakeSelectionContainer = null;
      }

      _createClass(Xo, [{
        key: "markToSync",
        value: function markToSync(t, e) {
          if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
            if (!this.domConverter.mapViewToDom(e)) return;
            if ("attributes" === t) this.markedAttributes.add(e);else {
              if ("children" !== t) throw new Qn.b("view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.", this);
              this.markedChildren.add(e);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var t;
          var _iteratorNormalCompletion51 = true;
          var _didIteratorError51 = false;
          var _iteratorError51 = undefined;

          try {
            for (var _iterator51 = this.markedChildren[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
              var _t41 = _step51.value;

              this._updateChildrenMappings(_t41);
            }
          } catch (err) {
            _didIteratorError51 = true;
            _iteratorError51 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion51 && _iterator51.return != null) {
                _iterator51.return();
              }
            } finally {
              if (_didIteratorError51) {
                throw _iteratorError51;
              }
            }
          }

          this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent));
          var _iteratorNormalCompletion52 = true;
          var _didIteratorError52 = false;
          var _iteratorError52 = undefined;

          try {
            for (var _iterator52 = this.markedAttributes[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
              var _t42 = _step52.value;

              this._updateAttrs(_t42);
            }
          } catch (err) {
            _didIteratorError52 = true;
            _iteratorError52 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion52 && _iterator52.return != null) {
                _iterator52.return();
              }
            } finally {
              if (_didIteratorError52) {
                throw _iteratorError52;
              }
            }
          }

          var _iteratorNormalCompletion53 = true;
          var _didIteratorError53 = false;
          var _iteratorError53 = undefined;

          try {
            for (var _iterator53 = this.markedChildren[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
              var _e47 = _step53.value;

              this._updateChildren(_e47, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _didIteratorError53 = true;
            _iteratorError53 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion53 && _iterator53.return != null) {
                _iterator53.return();
              }
            } finally {
              if (_didIteratorError53) {
                throw _iteratorError53;
              }
            }
          }

          var _iteratorNormalCompletion54 = true;
          var _didIteratorError54 = false;
          var _iteratorError54 = undefined;

          try {
            for (var _iterator54 = this.markedTexts[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
              var _e48 = _step54.value;
              !this.markedChildren.has(_e48.parent) && this.domConverter.mapViewToDom(_e48.parent) && this._updateText(_e48, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _didIteratorError54 = true;
            _iteratorError54 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion54 && _iterator54.return != null) {
                _iterator54.return();
              }
            } finally {
              if (_didIteratorError54) {
                throw _iteratorError54;
              }
            }
          }

          if (t) {
            var _e46 = this.domConverter.viewPositionToDom(t),
                _n43 = _e46.parent.ownerDocument;

            Uo(_e46.parent) ? this._inlineFiller = _e46.parent : this._inlineFiller = tr(_n43, _e46.parent, _e46.offset);
          } else this._inlineFiller = null;

          this._updateSelection(), this._updateFocus(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
      }, {
        key: "_updateChildrenMappings",
        value: function _updateChildrenMappings(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;

          var n = this.domConverter.mapViewToDom(t).childNodes,
              i = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
            withChildren: !1
          })),
              o = this._diffNodeLists(n, i),
              r = this._findReplaceActions(o, n, i);

          if (-1 !== r.indexOf("replace")) {
            var _e49 = {
              equal: 0,
              insert: 0,
              delete: 0
            };
            var _iteratorNormalCompletion55 = true;
            var _didIteratorError55 = false;
            var _iteratorError55 = undefined;

            try {
              for (var _iterator55 = r[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
                var _o19 = _step55.value;

                if ("replace" === _o19) {
                  var _o20 = _e49.equal + _e49.insert,
                      _r7 = _e49.equal + _e49.delete,
                      _s7 = t.getChild(_o20);

                  _s7 && !_s7.is("uiElement") && this._updateElementMappings(_s7, n[_r7]), Jo(i[_o20]), _e49.equal++;
                } else _e49[_o19]++;
              }
            } catch (err) {
              _didIteratorError55 = true;
              _iteratorError55 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion55 && _iterator55.return != null) {
                  _iterator55.return();
                }
              } finally {
                if (_didIteratorError55) {
                  throw _iteratorError55;
                }
              }
            }
          }
        }
      }, {
        key: "_updateElementMappings",
        value: function _updateElementMappings(t, e) {
          this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
        }
      }, {
        key: "_getInlineFillerPosition",
        value: function _getInlineFillerPosition() {
          var t = this.selection.getFirstPosition();
          return t.parent.is("text") ? Xi._createBefore(this.selection.getFirstPosition().parent) : t;
        }
      }, {
        key: "_isSelectionInInlineFiller",
        value: function _isSelectionInInlineFiller() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
              e = this.domConverter.viewPositionToDom(t);
          return !!(e && jo(e.parent) && Uo(e.parent));
        }
      }, {
        key: "_removeInlineFiller",
        value: function _removeInlineFiller() {
          var t = this._inlineFiller;
          if (!Uo(t)) throw new Qn.b("view-renderer-filler-was-lost: The inline filler node was lost.", this);
          Ho(t) ? t.parentNode.removeChild(t) : t.data = t.data.substr(Bo), this._inlineFiller = null;
        }
      }, {
        key: "_needsInlineFillerAtSelection",
        value: function _needsInlineFillerAtSelection() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
              e = t.parent,
              n = t.offset;
          if (!this.domConverter.mapViewToDom(e.root)) return !1;
          if (!e.is("element")) return !1;
          if (!function (t) {
            if ("false" == t.getAttribute("contenteditable")) return !1;
            var e = t.findAncestor(function (t) {
              return t.hasAttribute("contenteditable");
            });
            return !e || "true" == e.getAttribute("contenteditable");
          }(e)) return !1;
          if (n === e.getFillerOffset()) return !1;
          var i = t.nodeBefore,
              o = t.nodeAfter;
          return !(i instanceof gi || o instanceof gi);
        }
      }, {
        key: "_updateText",
        value: function _updateText(t, e) {
          var n = this.domConverter.findCorrespondingDomText(t),
              i = this.domConverter.viewToDom(t, n.ownerDocument),
              o = n.data;
          var r = i.data;
          var s = e.inlineFillerPosition;

          if (s && s.parent == t.parent && s.offset == t.index && (r = Fo + r), o != r) {
            var _t43 = Yo(o, r);

            var _iteratorNormalCompletion56 = true;
            var _didIteratorError56 = false;
            var _iteratorError56 = undefined;

            try {
              for (var _iterator56 = _t43[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
                var _e50 = _step56.value;
                "insert" === _e50.type ? n.insertData(_e50.index, _e50.values.join("")) : n.deleteData(_e50.index, _e50.howMany);
              }
            } catch (err) {
              _didIteratorError56 = true;
              _iteratorError56 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion56 && _iterator56.return != null) {
                  _iterator56.return();
                }
              } finally {
                if (_didIteratorError56) {
                  throw _iteratorError56;
                }
              }
            }
          }
        }
      }, {
        key: "_updateAttrs",
        value: function _updateAttrs(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;
          var n = Array.from(e.attributes).map(function (t) {
            return t.name;
          }),
              i = t.getAttributeKeys();
          var _iteratorNormalCompletion57 = true;
          var _didIteratorError57 = false;
          var _iteratorError57 = undefined;

          try {
            for (var _iterator57 = i[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
              var _n44 = _step57.value;
              e.setAttribute(_n44, t.getAttribute(_n44));
            }
          } catch (err) {
            _didIteratorError57 = true;
            _iteratorError57 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion57 && _iterator57.return != null) {
                _iterator57.return();
              }
            } finally {
              if (_didIteratorError57) {
                throw _iteratorError57;
              }
            }
          }

          var _iteratorNormalCompletion58 = true;
          var _didIteratorError58 = false;
          var _iteratorError58 = undefined;

          try {
            for (var _iterator58 = n[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
              var _i33 = _step58.value;
              t.hasAttribute(_i33) || e.removeAttribute(_i33);
            }
          } catch (err) {
            _didIteratorError58 = true;
            _iteratorError58 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion58 && _iterator58.return != null) {
                _iterator58.return();
              }
            } finally {
              if (_didIteratorError58) {
                throw _iteratorError58;
              }
            }
          }
        }
      }, {
        key: "_updateChildren",
        value: function _updateChildren(t, e) {
          var n = this.domConverter.mapViewToDom(t);
          if (!n) return;
          var i = e.inlineFillerPosition,
              o = this.domConverter.mapViewToDom(t).childNodes,
              r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, {
            bind: !0,
            inlineFillerPosition: i
          }));
          i && i.parent === t && tr(n.ownerDocument, r, i.offset);

          var s = this._diffNodeLists(o, r);

          var a = 0;
          var c = new Set();
          var _iteratorNormalCompletion59 = true;
          var _didIteratorError59 = false;
          var _iteratorError59 = undefined;

          try {
            for (var _iterator59 = s[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
              var _t44 = _step59.value;
              "insert" === _t44 ? (Ko(n, a, r[a]), a++) : "delete" === _t44 ? (c.add(o[a]), Jo(o[a])) : (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
            }
          } catch (err) {
            _didIteratorError59 = true;
            _iteratorError59 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion59 && _iterator59.return != null) {
                _iterator59.return();
              }
            } finally {
              if (_didIteratorError59) {
                throw _iteratorError59;
              }
            }
          }

          var _iteratorNormalCompletion60 = true;
          var _didIteratorError60 = false;
          var _iteratorError60 = undefined;

          try {
            for (var _iterator60 = c[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
              var _t45 = _step60.value;
              _t45.parentNode || this.domConverter.unbindDomElement(_t45);
            }
          } catch (err) {
            _didIteratorError60 = true;
            _iteratorError60 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion60 && _iterator60.return != null) {
                _iterator60.return();
              }
            } finally {
              if (_didIteratorError60) {
                throw _iteratorError60;
              }
            }
          }
        }
      }, {
        key: "_diffNodeLists",
        value: function _diffNodeLists(t, e) {
          return Qo(t = function (t, e) {
            var n = Array.from(t);
            if (0 == n.length || !e) return n;
            n[n.length - 1] == e && n.pop();
            return n;
          }(t, this._fakeSelectionContainer), e, nr.bind(null, this.domConverter));
        }
      }, {
        key: "_findReplaceActions",
        value: function _findReplaceActions(t, e, n) {
          if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
          var i = [],
              o = [],
              r = [];
          var s = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          var _iteratorNormalCompletion61 = true;
          var _didIteratorError61 = false;
          var _iteratorError61 = undefined;

          try {
            for (var _iterator61 = t[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
              var _a6 = _step61.value;
              "insert" === _a6 ? r.push(n[s.equal + s.insert]) : "delete" === _a6 ? o.push(e[s.equal + s.delete]) : (i = i.concat(Qo(o, r, er).map(function (t) {
                return "equal" === t ? "replace" : t;
              })), i.push("equal"), o = [], r = []), s[_a6]++;
            }
          } catch (err) {
            _didIteratorError61 = true;
            _iteratorError61 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion61 && _iterator61.return != null) {
                _iterator61.return();
              }
            } finally {
              if (_didIteratorError61) {
                throw _iteratorError61;
              }
            }
          }

          return i.concat(Qo(o, r, er).map(function (t) {
            return "equal" === t ? "replace" : t;
          }));
        }
      }, {
        key: "_markDescendantTextToSync",
        value: function _markDescendantTextToSync(t) {
          if (t) if (t.is("text")) this.markedTexts.add(t);else if (t.is("element")) {
            var _iteratorNormalCompletion62 = true;
            var _didIteratorError62 = false;
            var _iteratorError62 = undefined;

            try {
              for (var _iterator62 = t.getChildren()[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
                var _e51 = _step62.value;

                this._markDescendantTextToSync(_e51);
              }
            } catch (err) {
              _didIteratorError62 = true;
              _iteratorError62 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion62 && _iterator62.return != null) {
                  _iterator62.return();
                }
              } finally {
                if (_didIteratorError62) {
                  throw _iteratorError62;
                }
              }
            }
          }
        }
      }, {
        key: "_updateSelection",
        value: function _updateSelection() {
          if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
          var t = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : (this._removeFakeSelection(), this._updateDomSelection(t)));
        }
      }, {
        key: "_updateFakeSelection",
        value: function _updateFakeSelection(t) {
          var e = t.ownerDocument;
          this._fakeSelectionContainer || (this._fakeSelectionContainer = function (t) {
            var e = t.createElement("div");
            return Object.assign(e.style, {
              position: "fixed",
              top: 0,
              left: "-9999px",
              width: "42px"
            }), e.textContent = " ", e;
          }(e));
          var n = this._fakeSelectionContainer;
          if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(t)) return;
          n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
          var i = e.getSelection(),
              o = e.createRange();
          i.removeAllRanges(), o.selectNodeContents(n), i.addRange(o);
        }
      }, {
        key: "_updateDomSelection",
        value: function _updateDomSelection(t) {
          var e = t.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(e)) return;
          var n = this.domConverter.viewPositionToDom(this.selection.anchor),
              i = this.domConverter.viewPositionToDom(this.selection.focus);
          t.focus(), e.collapse(n.parent, n.offset), e.extend(i.parent, i.offset), mo.isGecko && function (t, e) {
            var n = t.parent;
            if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) return;
            var i = n.childNodes[t.offset];
            i && "BR" == i.tagName && e.addRange(e.getRangeAt(0));
          }(i, e);
        }
      }, {
        key: "_domSelectionNeedsUpdate",
        value: function _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
          var e = t && this.domConverter.domSelectionToView(t);
          return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
        }
      }, {
        key: "_fakeSelectionNeedsUpdate",
        value: function _fakeSelectionNeedsUpdate(t) {
          var e = this._fakeSelectionContainer,
              n = t.ownerDocument.getSelection();
          return !e || e.parentElement !== t || n.anchorNode !== e && !e.contains(n.anchorNode) || e.textContent !== this.selection.fakeSelectionLabel;
        }
      }, {
        key: "_removeDomSelection",
        value: function _removeDomSelection() {
          var _iteratorNormalCompletion63 = true;
          var _didIteratorError63 = false;
          var _iteratorError63 = undefined;

          try {
            for (var _iterator63 = this.domDocuments[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
              var _t46 = _step63.value;

              if (_t46.getSelection().rangeCount) {
                var _e52 = _t46.activeElement,
                    _n45 = this.domConverter.mapDomToView(_e52);

                _e52 && _n45 && _t46.getSelection().removeAllRanges();
              }
            }
          } catch (err) {
            _didIteratorError63 = true;
            _iteratorError63 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion63 && _iterator63.return != null) {
                _iterator63.return();
              }
            } finally {
              if (_didIteratorError63) {
                throw _iteratorError63;
              }
            }
          }
        }
      }, {
        key: "_removeFakeSelection",
        value: function _removeFakeSelection() {
          var t = this._fakeSelectionContainer;
          t && t.remove();
        }
      }, {
        key: "_updateFocus",
        value: function _updateFocus() {
          if (this.isFocused) {
            var _t47 = this.selection.editableElement;
            _t47 && this.domConverter.focus(_t47);
          }
        }
      }]);

      return Xo;
    }();

    function tr(t, e, n) {
      var i = e instanceof Array ? e : e.childNodes,
          o = i[n];
      if (jo(o)) return o.data = Fo + o.data, o;
      {
        var _o21 = t.createTextNode(Fo);

        return Array.isArray(e) ? i.splice(n, 0, _o21) : Ko(e, n, _o21), _o21;
      }
    }

    function er(t, e) {
      return Zo(t) && Zo(e) && !jo(t) && !jo(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }

    function nr(t, e, n) {
      return e === n || (jo(e) && jo(n) ? e.data === n.data : !(!t.isBlockFiller(e) || !t.isBlockFiller(n)));
    }

    li(Xo, Ui);
    var ir = {
      window: window,
      document: document
    };

    function or(t) {
      var e = 0;

      for (; t.previousSibling;) {
        t = t.previousSibling, e++;
      }

      return e;
    }

    function rr(t) {
      var e = [];

      for (; t && t.nodeType != Node.DOCUMENT_NODE;) {
        e.unshift(t), t = t.parentNode;
      }

      return e;
    }

    var sr = zo(document);

    var ar =
    /*#__PURE__*/
    function () {
      function ar() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ar);

        this.blockFillerMode = t.blockFillerMode || "br", this.preElements = ["pre"], this.blockElements = ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6", "li", "dd", "dt", "figcaption"], this._blockFiller = "br" == this.blockFillerMode ? zo : Vo, this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap();
      }

      _createClass(ar, [{
        key: "bindFakeSelection",
        value: function bindFakeSelection(t, e) {
          this._fakeSelectionMapping.set(t, new io(e));
        }
      }, {
        key: "fakeSelectionToView",
        value: function fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t);
        }
      }, {
        key: "bindElements",
        value: function bindElements(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "unbindDomElement",
        value: function unbindDomElement(t) {
          var e = this._domToViewMapping.get(t);

          if (e) {
            this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);

            for (var _i34 = 0, _Array$from = Array.from(t.childNodes); _i34 < _Array$from.length; _i34++) {
              var _e53 = _Array$from[_i34];
              this.unbindDomElement(_e53);
            }
          }
        }
      }, {
        key: "bindDocumentFragments",
        value: function bindDocumentFragments(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "viewToDom",
        value: function viewToDom(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if (t.is("text")) {
            var _n46 = this._processDataFromViewText(t);

            return e.createTextNode(_n46);
          }

          {
            if (this.mapViewToDom(t)) return this.mapViewToDom(t);

            var _i35;

            if (t.is("documentFragment")) _i35 = e.createDocumentFragment(), n.bind && this.bindDocumentFragments(_i35, t);else {
              if (t.is("uiElement")) return _i35 = t.render(e), n.bind && this.bindElements(_i35, t), _i35;
              _i35 = t.hasAttribute("xmlns") ? e.createElementNS(t.getAttribute("xmlns"), t.name) : e.createElement(t.name), n.bind && this.bindElements(_i35, t);
              var _iteratorNormalCompletion64 = true;
              var _didIteratorError64 = false;
              var _iteratorError64 = undefined;

              try {
                for (var _iterator64 = t.getAttributeKeys()[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
                  var _e54 = _step64.value;

                  _i35.setAttribute(_e54, t.getAttribute(_e54));
                }
              } catch (err) {
                _didIteratorError64 = true;
                _iteratorError64 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion64 && _iterator64.return != null) {
                    _iterator64.return();
                  }
                } finally {
                  if (_didIteratorError64) {
                    throw _iteratorError64;
                  }
                }
              }
            }

            if (n.withChildren || void 0 === n.withChildren) {
              var _iteratorNormalCompletion65 = true;
              var _didIteratorError65 = false;
              var _iteratorError65 = undefined;

              try {
                for (var _iterator65 = this.viewChildrenToDom(t, e, n)[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
                  var _o22 = _step65.value;

                  _i35.appendChild(_o22);
                }
              } catch (err) {
                _didIteratorError65 = true;
                _iteratorError65 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion65 && _iterator65.return != null) {
                    _iterator65.return();
                  }
                } finally {
                  if (_didIteratorError65) {
                    throw _iteratorError65;
                  }
                }
              }
            }

            return _i35;
          }
        }
      }, {
        key: "viewChildrenToDom",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function viewChildrenToDom(t, e) {
          var n,
              i,
              o,
              _iteratorNormalCompletion66,
              _didIteratorError66,
              _iteratorError66,
              _iterator66,
              _step66,
              _r8,
              _args9 = arguments;

          return _regeneratorRuntime.wrap(function viewChildrenToDom$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  n = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
                  i = t.getFillerOffset && t.getFillerOffset();
                  o = 0;
                  _iteratorNormalCompletion66 = true;
                  _didIteratorError66 = false;
                  _iteratorError66 = undefined;
                  _context9.prev = 6;
                  _iterator66 = t.getChildren()[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done) {
                    _context9.next = 20;
                    break;
                  }

                  _r8 = _step66.value;
                  _context9.t0 = i === o;

                  if (!_context9.t0) {
                    _context9.next = 14;
                    break;
                  }

                  _context9.next = 14;
                  return this._blockFiller(e);

                case 14:
                  _context9.next = 16;
                  return this.viewToDom(_r8, e, n);

                case 16:
                  o++;

                case 17:
                  _iteratorNormalCompletion66 = true;
                  _context9.next = 8;
                  break;

                case 20:
                  _context9.next = 26;
                  break;

                case 22:
                  _context9.prev = 22;
                  _context9.t1 = _context9["catch"](6);
                  _didIteratorError66 = true;
                  _iteratorError66 = _context9.t1;

                case 26:
                  _context9.prev = 26;
                  _context9.prev = 27;

                  if (!_iteratorNormalCompletion66 && _iterator66.return != null) {
                    _iterator66.return();
                  }

                case 29:
                  _context9.prev = 29;

                  if (!_didIteratorError66) {
                    _context9.next = 32;
                    break;
                  }

                  throw _iteratorError66;

                case 32:
                  return _context9.finish(29);

                case 33:
                  return _context9.finish(26);

                case 34:
                  _context9.t2 = i === o;

                  if (!_context9.t2) {
                    _context9.next = 38;
                    break;
                  }

                  _context9.next = 38;
                  return this._blockFiller(e);

                case 38:
                case "end":
                  return _context9.stop();
              }
            }
          }, viewChildrenToDom, this, [[6, 22, 26, 34], [27,, 29, 33]]);
        })
      }, {
        key: "viewRangeToDom",
        value: function viewRangeToDom(t) {
          var e = this.viewPositionToDom(t.start),
              n = this.viewPositionToDom(t.end),
              i = document.createRange();
          return i.setStart(e.parent, e.offset), i.setEnd(n.parent, n.offset), i;
        }
      }, {
        key: "viewPositionToDom",
        value: function viewPositionToDom(t) {
          var e = t.parent;

          if (e.is("text")) {
            var _n47 = this.findCorrespondingDomText(e);

            if (!_n47) return null;
            var _i36 = t.offset;
            return Uo(_n47) && (_i36 += Bo), {
              parent: _n47,
              offset: _i36
            };
          }

          {
            var _n48, _i37, _o23;

            if (0 === t.offset) {
              if (_n48 = this.mapViewToDom(e), !_n48) return null;
              _o23 = _n48.childNodes[0];
            } else {
              var _e55 = t.nodeBefore;
              if (_i37 = _e55.is("text") ? this.findCorrespondingDomText(_e55) : this.mapViewToDom(t.nodeBefore), !_i37) return null;
              _n48 = _i37.parentNode, _o23 = _i37.nextSibling;
            }

            if (jo(_o23) && Uo(_o23)) return {
              parent: _o23,
              offset: Bo
            };
            return {
              parent: _n48,
              offset: _i37 ? or(_i37) + 1 : 0
            };
          }
        }
      }, {
        key: "domToView",
        value: function domToView(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (this.isBlockFiller(t, this.blockFillerMode)) return null;
          var n = this.getParentUIElement(t, this._domToViewMapping);
          if (n) return n;

          if (jo(t)) {
            if (Ho(t)) return null;
            {
              var _e56 = this._processDataFromDomText(t);

              return "" === _e56 ? null : new gi(_e56);
            }
          }

          if (this.isComment(t)) return null;
          {
            if (this.mapDomToView(t)) return this.mapDomToView(t);

            var _n49;

            if (this.isDocumentFragment(t)) _n49 = new Co(), e.bind && this.bindDocumentFragments(t, _n49);else {
              var _i38 = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();

              _n49 = new _i(_i38), e.bind && this.bindElements(t, _n49);
              var _o24 = t.attributes;

              for (var _t48 = _o24.length - 1; _t48 >= 0; _t48--) {
                _n49._setAttribute(_o24[_t48].name, _o24[_t48].value);
              }
            }

            if (e.withChildren || void 0 === e.withChildren) {
              var _iteratorNormalCompletion67 = true;
              var _didIteratorError67 = false;
              var _iteratorError67 = undefined;

              try {
                for (var _iterator67 = this.domChildrenToView(t, e)[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
                  var _i39 = _step67.value;

                  _n49._appendChild(_i39);
                }
              } catch (err) {
                _didIteratorError67 = true;
                _iteratorError67 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion67 && _iterator67.return != null) {
                    _iterator67.return();
                  }
                } finally {
                  if (_didIteratorError67) {
                    throw _iteratorError67;
                  }
                }
              }
            }

            return _n49;
          }
        }
      }, {
        key: "domChildrenToView",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function domChildrenToView(t) {
          var e,
              _n50,
              _i40,
              _o25,
              _args10 = arguments;

          return _regeneratorRuntime.wrap(function domChildrenToView$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  e = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
                  _n50 = 0;

                case 2:
                  if (!(_n50 < t.childNodes.length)) {
                    _context10.next = 11;
                    break;
                  }

                  _i40 = t.childNodes[_n50], _o25 = this.domToView(_i40, e);
                  _context10.t0 = null !== _o25;

                  if (!_context10.t0) {
                    _context10.next = 8;
                    break;
                  }

                  _context10.next = 8;
                  return _o25;

                case 8:
                  _n50++;
                  _context10.next = 2;
                  break;

                case 11:
                case "end":
                  return _context10.stop();
              }
            }
          }, domChildrenToView, this);
        })
      }, {
        key: "domSelectionToView",
        value: function domSelectionToView(t) {
          if (1 === t.rangeCount) {
            var _e57 = t.getRangeAt(0).startContainer;
            jo(_e57) && (_e57 = _e57.parentNode);

            var _n51 = this.fakeSelectionToView(_e57);

            if (_n51) return _n51;
          }

          var e = this.isDomSelectionBackward(t),
              n = [];

          for (var _e58 = 0; _e58 < t.rangeCount; _e58++) {
            var _i41 = t.getRangeAt(_e58),
                _o26 = this.domRangeToView(_i41);

            _o26 && n.push(_o26);
          }

          return new io(n, {
            backward: e
          });
        }
      }, {
        key: "domRangeToView",
        value: function domRangeToView(t) {
          var e = this.domPositionToView(t.startContainer, t.startOffset),
              n = this.domPositionToView(t.endContainer, t.endOffset);
          return e && n ? new to(e, n) : null;
        }
      }, {
        key: "domPositionToView",
        value: function domPositionToView(t, e) {
          if (this.isBlockFiller(t, this.blockFillerMode)) return this.domPositionToView(t.parentNode, or(t));
          var n = this.mapDomToView(t);
          if (n && n.is("uiElement")) return Xi._createBefore(n);

          if (jo(t)) {
            if (Ho(t)) return this.domPositionToView(t.parentNode, or(t));

            var _n52 = this.findCorrespondingViewText(t);

            var _i42 = e;
            return _n52 ? (Uo(t) && (_i42 -= Bo, _i42 = _i42 < 0 ? 0 : _i42), new Xi(_n52, _i42)) : null;
          }

          if (0 === e) {
            var _e59 = this.mapDomToView(t);

            if (_e59) return new Xi(_e59, 0);
          } else {
            var _n53 = t.childNodes[e - 1],
                _i43 = jo(_n53) ? this.findCorrespondingViewText(_n53) : this.mapDomToView(_n53);

            if (_i43 && _i43.parent) return new Xi(_i43.parent, _i43.index + 1);
          }

          return null;
        }
      }, {
        key: "mapDomToView",
        value: function mapDomToView(t) {
          return this.getParentUIElement(t) || this._domToViewMapping.get(t);
        }
      }, {
        key: "findCorrespondingViewText",
        value: function findCorrespondingViewText(t) {
          if (Ho(t)) return null;
          var e = this.getParentUIElement(t);
          if (e) return e;
          var n = t.previousSibling;

          if (n) {
            if (!this.isElement(n)) return null;

            var _t49 = this.mapDomToView(n);

            if (_t49) {
              return _t49.nextSibling instanceof gi ? _t49.nextSibling : null;
            }
          } else {
            var _e60 = this.mapDomToView(t.parentNode);

            if (_e60) {
              var _t50 = _e60.getChild(0);

              return _t50 instanceof gi ? _t50 : null;
            }
          }

          return null;
        }
      }, {
        key: "mapViewToDom",
        value: function mapViewToDom(t) {
          return this._viewToDomMapping.get(t);
        }
      }, {
        key: "findCorrespondingDomText",
        value: function findCorrespondingDomText(t) {
          var e = t.previousSibling;
          return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
        }
      }, {
        key: "focus",
        value: function focus(t) {
          var e = this.mapViewToDom(t);

          if (e && e.ownerDocument.activeElement !== e) {
            var _ir$window = ir.window,
                _t51 = _ir$window.scrollX,
                _n54 = _ir$window.scrollY,
                _i44 = [];
            lr(e, function (t) {
              var e = t.scrollLeft,
                  n = t.scrollTop;

              _i44.push([e, n]);
            }), e.focus(), lr(e, function (t) {
              var _i44$shift = _i44.shift(),
                  _i44$shift2 = _slicedToArray(_i44$shift, 2),
                  e = _i44$shift2[0],
                  n = _i44$shift2[1];

              t.scrollLeft = e, t.scrollTop = n;
            }), ir.window.scrollTo(_t51, _n54);
          }
        }
      }, {
        key: "isElement",
        value: function isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE;
        }
      }, {
        key: "isDocumentFragment",
        value: function isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
      }, {
        key: "isComment",
        value: function isComment(t) {
          return t && t.nodeType == Node.COMMENT_NODE;
        }
      }, {
        key: "isBlockFiller",
        value: function isBlockFiller(t) {
          return "br" == this.blockFillerMode ? t.isEqualNode(sr) : !("BR" !== t.tagName || !dr(t, this.blockElements) || 1 !== t.parentNode.childNodes.length) || function (t, e) {
            return jo(t) && " " == t.data && dr(t, e) && 1 === t.parentNode.childNodes.length;
          }(t, this.blockElements);
        }
      }, {
        key: "isDomSelectionBackward",
        value: function isDomSelectionBackward(t) {
          if (t.isCollapsed) return !1;
          var e = document.createRange();
          e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
          var n = e.collapsed;
          return e.detach(), n;
        }
      }, {
        key: "getParentUIElement",
        value: function getParentUIElement(t) {
          var e = rr(t);

          for (e.pop(); e.length;) {
            var _t52 = e.pop(),
                _n55 = this._domToViewMapping.get(_t52);

            if (_n55 && _n55.is("uiElement")) return _n55;
          }

          return null;
        }
      }, {
        key: "isDomSelectionCorrect",
        value: function isDomSelectionCorrect(t) {
          return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
        }
      }, {
        key: "_isDomSelectionPositionCorrect",
        value: function _isDomSelectionPositionCorrect(t, e) {
          if (jo(t) && Uo(t) && e < Bo) return !1;
          if (this.isElement(t) && Uo(t.childNodes[e])) return !1;
          var n = this.mapDomToView(t);
          return !n || !n.is("uiElement");
        }
      }, {
        key: "_processDataFromViewText",
        value: function _processDataFromViewText(t) {
          var _this23 = this;

          var e = t.data;
          if (t.getAncestors().some(function (t) {
            return _this23.preElements.includes(t.name);
          })) return e;

          if (" " == e.charAt(0)) {
            var _n56 = this._getTouchingViewTextNode(t, !1);

            !(_n56 && this._nodeEndsWithSpace(_n56)) && _n56 || (e = " " + e.substr(1));
          }

          if (" " == e.charAt(e.length - 1)) {
            var _n57 = this._getTouchingViewTextNode(t, !0);

            " " != e.charAt(e.length - 2) && _n57 && " " != _n57.data.charAt(0) || (e = e.substr(0, e.length - 1) + " ");
          }

          return e.replace(/ {2}/g, "  ");
        }
      }, {
        key: "_nodeEndsWithSpace",
        value: function _nodeEndsWithSpace(t) {
          var _this24 = this;

          if (t.getAncestors().some(function (t) {
            return _this24.preElements.includes(t.name);
          })) return !1;

          var e = this._processDataFromViewText(t);

          return " " == e.charAt(e.length - 1);
        }
      }, {
        key: "_processDataFromDomText",
        value: function _processDataFromDomText(t) {
          var e = t.data;
          if (cr(t, this.preElements)) return qo(t);
          e = e.replace(/[ \n\t\r]{1,}/g, " ");

          var n = this._getTouchingInlineDomNode(t, !1),
              i = this._getTouchingInlineDomNode(t, !0),
              o = this._checkShouldLeftTrimDomText(n),
              r = this._checkShouldRightTrimDomText(t, i);

          return o && (e = e.replace(/^ /, "")), r && (e = e.replace(/ $/, "")), e = qo(new Text(e)), e = e.replace(/ \u00A0/g, "  "), (/( |\u00A0)\u00A0$/.test(e) || !i || i.data && " " == i.data.charAt(0)) && (e = e.replace(/\u00A0$/, " ")), o && (e = e.replace(/^\u00A0/, " ")), e;
        }
      }, {
        key: "_checkShouldLeftTrimDomText",
        value: function _checkShouldLeftTrimDomText(t) {
          return !t || !!Yn(t) || /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1));
        }
      }, {
        key: "_checkShouldRightTrimDomText",
        value: function _checkShouldRightTrimDomText(t, e) {
          return !e && !Uo(t);
        }
      }, {
        key: "_getTouchingViewTextNode",
        value: function _getTouchingViewTextNode(t, e) {
          var n = new Zi({
            startPosition: e ? Xi._createAfter(t) : Xi._createBefore(t),
            direction: e ? "forward" : "backward"
          });
          var _iteratorNormalCompletion68 = true;
          var _didIteratorError68 = false;
          var _iteratorError68 = undefined;

          try {
            for (var _iterator68 = n[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
              var _t53 = _step68.value;
              if (_t53.item.is("containerElement")) return null;
              if (_t53.item.is("br")) return null;
              if (_t53.item.is("textProxy")) return _t53.item;
            }
          } catch (err) {
            _didIteratorError68 = true;
            _iteratorError68 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion68 && _iterator68.return != null) {
                _iterator68.return();
              }
            } finally {
              if (_didIteratorError68) {
                throw _iteratorError68;
              }
            }
          }

          return null;
        }
      }, {
        key: "_getTouchingInlineDomNode",
        value: function _getTouchingInlineDomNode(t, e) {
          if (!t.parentNode) return null;
          var n = e ? "nextNode" : "previousNode",
              i = t.ownerDocument,
              o = rr(t)[0],
              r = i.createTreeWalker(o, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
            acceptNode: function acceptNode(t) {
              return jo(t) ? NodeFilter.FILTER_ACCEPT : "BR" == t.tagName ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          });
          r.currentNode = t;
          var s = r[n]();

          if (null !== s) {
            var _e61 = function (t, e) {
              var n = rr(t),
                  i = rr(e);
              var o = 0;

              for (; n[o] == i[o] && n[o];) {
                o++;
              }

              return 0 === o ? null : n[o - 1];
            }(t, s);

            if (_e61 && !cr(t, this.blockElements, _e61) && !cr(s, this.blockElements, _e61)) return s;
          }

          return null;
        }
      }]);

      return ar;
    }();

    function cr(t, e, n) {
      var i = rr(t);
      return n && (i = i.slice(i.indexOf(n) + 1)), i.some(function (t) {
        return t.tagName && e.includes(t.tagName.toLowerCase());
      });
    }

    function lr(t, e) {
      for (; t && t != ir.document;) {
        e(t), t = t.parentNode;
      }
    }

    function dr(t, e) {
      var n = t.parentNode;
      return n && n.tagName && e.includes(n.tagName.toLowerCase());
    }

    function hr(t) {
      var e = Object.prototype.toString.apply(t);
      return "[object Window]" == e || "[object global]" == e;
    }

    var ur = ji({}, ni, {
      listenTo: function listenTo(t) {
        var _ni$listenTo;

        for (var _len15 = arguments.length, e = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
          e[_key15 - 1] = arguments[_key15];
        }

        if (Zo(t) || hr(t)) {
          var _n58 = this._getProxyEmitter(t) || new fr(t);

          _n58.attach.apply(_n58, e), t = _n58;
        }

        (_ni$listenTo = ni.listenTo).call.apply(_ni$listenTo, [this, t].concat(e));
      },
      stopListening: function stopListening(t, e, n) {
        if (Zo(t) || hr(t)) {
          var _e62 = this._getProxyEmitter(t);

          if (!_e62) return;
          t = _e62;
        }

        ni.stopListening.call(this, t, e, n), t instanceof fr && t.detach(e);
      },
      _getProxyEmitter: function _getProxyEmitter(t) {
        return e = this, n = gr(t), e[ti] && e[ti][n] ? e[ti][n].emitter : null;
        var e, n;
      }
    });

    var fr = function fr(t) {
      _classCallCheck(this, fr);

      ii(this, gr(t)), this._domNode = t;
    };

    function gr(t) {
      return t["data-ck-expando"] || (t["data-ck-expando"] = Zn());
    }

    ji(fr.prototype, ni, {
      attach: function attach(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (this._domListeners && this._domListeners[t]) return;

        var i = this._createDomListener(t, !!n.useCapture);

        this._domNode.addEventListener(t, i, !!n.useCapture), this._domListeners || (this._domListeners = {}), this._domListeners[t] = i;
      },
      detach: function detach(t) {
        var e;
        !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
      },
      _createDomListener: function _createDomListener(t, e) {
        var _this25 = this;

        var n = function n(e) {
          _this25.fire(t, e);
        };

        return n.removeListener = function () {
          _this25._domNode.removeEventListener(t, n, e), delete _this25._domListeners[t];
        }, n;
      }
    });

    var mr =
    /*#__PURE__*/
    function () {
      function mr(t) {
        _classCallCheck(this, mr);

        this.view = t, this.document = t.document, this.isEnabled = !1;
      }

      _createClass(mr, [{
        key: "enable",
        value: function enable() {
          this.isEnabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.disable(), this.stopListening();
        }
      }]);

      return mr;
    }();

    li(mr, ur);
    var pr = "__lodash_hash_undefined__";

    var br = function br(t) {
      return this.__data__.set(t, pr), this;
    };

    var wr = function wr(t) {
      return this.__data__.has(t);
    };

    function kr(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new St(); ++e < n;) {
        this.add(t[e]);
      }
    }

    kr.prototype.add = kr.prototype.push = br, kr.prototype.has = wr;
    var _r = kr;

    var vr = function vr(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };

    var yr = function yr(t, e) {
      return t.has(e);
    },
        xr = 1,
        Ar = 2;

    var Tr = function Tr(t, e, n, i, o, r) {
      var s = n & xr,
          a = t.length,
          c = e.length;
      if (a != c && !(s && c > a)) return !1;
      var l = r.get(t);
      if (l && r.get(e)) return l == e;
      var d = -1,
          h = !0,
          u = n & Ar ? new _r() : void 0;

      for (r.set(t, e), r.set(e, t); ++d < a;) {
        var f = t[d],
            g = e[d];
        if (i) var m = s ? i(g, f, d, e, t, r) : i(f, g, d, t, e, r);

        if (void 0 !== m) {
          if (m) continue;
          h = !1;
          break;
        }

        if (u) {
          if (!vr(e, function (t, e) {
            if (!yr(u, e) && (f === t || o(f, t, n, i, r))) return u.push(e);
          })) {
            h = !1;
            break;
          }
        } else if (f !== g && !o(f, g, n, i, r)) {
          h = !1;
          break;
        }
      }

      return r.delete(t), r.delete(e), h;
    };

    var Cr = function Cr(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, i) {
        n[++e] = [i, t];
      }), n;
    };

    var Pr = function Pr(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    },
        Sr = 1,
        Mr = 2,
        Er = "[object Boolean]",
        Ir = "[object Date]",
        Nr = "[object Error]",
        Or = "[object Map]",
        Rr = "[object Number]",
        Dr = "[object RegExp]",
        Lr = "[object Set]",
        jr = "[object String]",
        Vr = "[object Symbol]",
        zr = "[object ArrayBuffer]",
        Br = "[object DataView]",
        Fr = o ? o.prototype : void 0,
        Ur = Fr ? Fr.valueOf : void 0;

    var Hr = function Hr(t, e, n, i, o, r, s) {
      switch (n) {
        case Br:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case zr:
          return !(t.byteLength != e.byteLength || !r(new $e(t), new $e(e)));

        case Er:
        case Ir:
        case Rr:
          return P(+t, +e);

        case Nr:
          return t.name == e.name && t.message == e.message;

        case Dr:
        case jr:
          return t == e + "";

        case Or:
          var a = Cr;

        case Lr:
          var c = i & Sr;
          if (a || (a = Pr), t.size != e.size && !c) return !1;
          var l = s.get(t);
          if (l) return l == e;
          i |= Mr, s.set(t, e);
          var d = Tr(a(t), a(e), i, o, r, s);
          return s.delete(t), d;

        case Vr:
          if (Ur) return Ur.call(t) == Ur.call(e);
      }

      return !1;
    },
        qr = 1,
        Wr = Object.prototype.hasOwnProperty;

    var Yr = function Yr(t, e, n, i, o, r) {
      var s = n & qr,
          a = Ne(t),
          c = a.length;
      if (c != Ne(e).length && !s) return !1;

      for (var l = c; l--;) {
        var d = a[l];
        if (!(s ? d in e : Wr.call(e, d))) return !1;
      }

      var h = r.get(t);
      if (h && r.get(e)) return h == e;
      var u = !0;
      r.set(t, e), r.set(e, t);

      for (var f = s; ++l < c;) {
        var g = t[d = a[l]],
            m = e[d];
        if (i) var p = s ? i(m, g, d, e, t, r) : i(g, m, d, t, e, r);

        if (!(void 0 === p ? g === m || o(g, m, n, i, r) : p)) {
          u = !1;
          break;
        }

        f || (f = "constructor" == d);
      }

      if (u && !f) {
        var b = t.constructor,
            w = e.constructor;
        b != w && "constructor" in t && "constructor" in e && !("function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w) && (u = !1);
      }

      return r.delete(t), r.delete(e), u;
    },
        $r = 1,
        Gr = "[object Arguments]",
        Qr = "[object Array]",
        Kr = "[object Object]",
        Jr = Object.prototype.hasOwnProperty;

    var Zr = function Zr(t, e, n, i, o, r) {
      var s = Yt(t),
          a = Yt(e),
          c = s ? Qr : qe(t),
          l = a ? Qr : qe(e),
          d = (c = c == Gr ? Kr : c) == Kr,
          h = (l = l == Gr ? Kr : l) == Kr,
          u = c == l;

      if (u && Object($t.a)(t)) {
        if (!Object($t.a)(e)) return !1;
        s = !0, d = !1;
      }

      if (u && !d) return r || (r = new Nt()), s || oe(t) ? Tr(t, e, n, i, o, r) : Hr(t, e, c, n, i, o, r);

      if (!(n & $r)) {
        var f = d && Jr.call(t, "__wrapped__"),
            g = h && Jr.call(e, "__wrapped__");

        if (f || g) {
          var m = f ? t.value() : t,
              p = g ? e.value() : e;
          return r || (r = new Nt()), o(m, p, n, i, r);
        }
      }

      return !!u && (r || (r = new Nt()), Yr(t, e, n, i, o, r));
    };

    var Xr = function t(e, n, i, o, r) {
      return e === n || (null == e || null == n || !w(e) && !w(n) ? e != e && n != n : Zr(e, n, i, o, t, r));
    };

    var ts = function ts(t, e, n) {
      var i = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
      return void 0 === i ? Xr(t, e, void 0, n) : !!i;
    };

    var es =
    /*#__PURE__*/
    function (_mr) {
      _inherits(es, _mr);

      function es(t) {
        var _this26;

        _classCallCheck(this, es);

        _this26 = _possibleConstructorReturn(this, _getPrototypeOf(es).call(this, t)), _this26._config = {
          childList: !0,
          characterData: !0,
          characterDataOldValue: !0,
          subtree: !0
        }, _this26.domConverter = t.domConverter, _this26.renderer = t._renderer, _this26._domElements = [], _this26._mutationObserver = new window.MutationObserver(_this26._onMutations.bind(_assertThisInitialized(_this26)));
        return _this26;
      }

      _createClass(es, [{
        key: "flush",
        value: function flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
      }, {
        key: "observe",
        value: function observe(t) {
          this._domElements.push(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
        }
      }, {
        key: "enable",
        value: function enable() {
          _get(_getPrototypeOf(es.prototype), "enable", this).call(this);

          var _iteratorNormalCompletion69 = true;
          var _didIteratorError69 = false;
          var _iteratorError69 = undefined;

          try {
            for (var _iterator69 = this._domElements[Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
              var _t54 = _step69.value;

              this._mutationObserver.observe(_t54, this._config);
            }
          } catch (err) {
            _didIteratorError69 = true;
            _iteratorError69 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion69 && _iterator69.return != null) {
                _iterator69.return();
              }
            } finally {
              if (_didIteratorError69) {
                throw _iteratorError69;
              }
            }
          }
        }
      }, {
        key: "disable",
        value: function disable() {
          _get(_getPrototypeOf(es.prototype), "disable", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(es.prototype), "destroy", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "_onMutations",
        value: function _onMutations(t) {
          if (0 === t.length) return;
          var e = this.domConverter,
              n = new Map(),
              i = new Set();
          var _iteratorNormalCompletion70 = true;
          var _didIteratorError70 = false;
          var _iteratorError70 = undefined;

          try {
            for (var _iterator70 = t[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
              var _n60 = _step70.value;

              if ("childList" === _n60.type) {
                var _t56 = e.mapDomToView(_n60.target);

                if (_t56 && _t56.is("uiElement")) continue;
                _t56 && !this._isBogusBrMutation(_n60) && i.add(_t56);
              }
            }
          } catch (err) {
            _didIteratorError70 = true;
            _iteratorError70 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion70 && _iterator70.return != null) {
                _iterator70.return();
              }
            } finally {
              if (_didIteratorError70) {
                throw _iteratorError70;
              }
            }
          }

          var _iteratorNormalCompletion71 = true;
          var _didIteratorError71 = false;
          var _iteratorError71 = undefined;

          try {
            for (var _iterator71 = t[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
              var _o27 = _step71.value;

              var _t57 = e.mapDomToView(_o27.target);

              if ((!_t57 || !_t57.is("uiElement")) && "characterData" === _o27.type) {
                var _t58 = e.findCorrespondingViewText(_o27.target);

                _t58 && !i.has(_t58.parent) ? n.set(_t58, {
                  type: "text",
                  oldText: _t58.data,
                  newText: qo(_o27.target),
                  node: _t58
                }) : !_t58 && Uo(_o27.target) && i.add(e.mapDomToView(_o27.target.parentNode));
              }
            }
          } catch (err) {
            _didIteratorError71 = true;
            _iteratorError71 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion71 && _iterator71.return != null) {
                _iterator71.return();
              }
            } finally {
              if (_didIteratorError71) {
                throw _iteratorError71;
              }
            }
          }

          var o = [];
          var _iteratorNormalCompletion72 = true;
          var _didIteratorError72 = false;
          var _iteratorError72 = undefined;

          try {
            for (var _iterator72 = n.values()[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
              var _t59 = _step72.value;
              this.renderer.markToSync("text", _t59.node), o.push(_t59);
            }
          } catch (err) {
            _didIteratorError72 = true;
            _iteratorError72 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion72 && _iterator72.return != null) {
                _iterator72.return();
              }
            } finally {
              if (_didIteratorError72) {
                throw _iteratorError72;
              }
            }
          }

          var _iteratorNormalCompletion73 = true;
          var _didIteratorError73 = false;
          var _iteratorError73 = undefined;

          try {
            for (var _iterator73 = i[Symbol.iterator](), _step73; !(_iteratorNormalCompletion73 = (_step73 = _iterator73.next()).done); _iteratorNormalCompletion73 = true) {
              var _t60 = _step73.value;

              var _n61 = e.mapViewToDom(_t60),
                  _i45 = Array.from(_t60.getChildren()),
                  _r9 = Array.from(e.domChildrenToView(_n61, {
                withChildren: !1
              }));

              ts(_i45, _r9, a) || (this.renderer.markToSync("children", _t60), o.push({
                type: "children",
                oldChildren: _i45,
                newChildren: _r9,
                node: _t60
              }));
            }
          } catch (err) {
            _didIteratorError73 = true;
            _iteratorError73 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion73 && _iterator73.return != null) {
                _iterator73.return();
              }
            } finally {
              if (_didIteratorError73) {
                throw _iteratorError73;
              }
            }
          }

          var r = t[0].target.ownerDocument.getSelection();
          var s = null;

          if (r && r.anchorNode) {
            var _t55 = e.domPositionToView(r.anchorNode, r.anchorOffset),
                _n59 = e.domPositionToView(r.focusNode, r.focusOffset);

            _t55 && _n59 && (s = new io(_t55), s.setFocus(_n59));
          }

          function a(t, e) {
            if (!Array.isArray(t)) return t === e || !(!t.is("text") || !e.is("text")) && t.data === e.data;
          }

          this.document.fire("mutations", o, s), this.view.forceRender();
        }
      }, {
        key: "_isBogusBrMutation",
        value: function _isBogusBrMutation(t) {
          var e = null;
          return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
            withChildren: !1
          })), e && e.is("element", "br");
        }
      }]);

      return es;
    }(mr);

    var ns =
    /*#__PURE__*/
    function () {
      function ns(t, e, n) {
        _classCallCheck(this, ns);

        this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, ji(this, n);
      }

      _createClass(ns, [{
        key: "preventDefault",
        value: function preventDefault() {
          this.domEvent.preventDefault();
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }, {
        key: "target",
        get: function get() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
      }]);

      return ns;
    }();

    var is =
    /*#__PURE__*/
    function (_mr2) {
      _inherits(is, _mr2);

      function is(t) {
        var _this27;

        _classCallCheck(this, is);

        _this27 = _possibleConstructorReturn(this, _getPrototypeOf(is).call(this, t)), _this27.useCapture = !1;
        return _this27;
      }

      _createClass(is, [{
        key: "observe",
        value: function observe(t) {
          var _this28 = this;

          ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (e) {
            _this28.listenTo(t, e, function (t, e) {
              _this28.isEnabled && _this28.onDomEvent(e);
            }, {
              useCapture: _this28.useCapture
            });
          });
        }
      }, {
        key: "fire",
        value: function fire(t, e, n) {
          this.isEnabled && this.document.fire(t, new ns(this.view, e, n));
        }
      }]);

      return is;
    }(mr);

    var os =
    /*#__PURE__*/
    function (_is) {
      _inherits(os, _is);

      function os(t) {
        var _this29;

        _classCallCheck(this, os);

        _this29 = _possibleConstructorReturn(this, _getPrototypeOf(os).call(this, t)), _this29.domEventType = ["keydown", "keyup"];
        return _this29;
      }

      _createClass(os, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t, {
            keyCode: t.keyCode,
            altKey: t.altKey,
            ctrlKey: t.ctrlKey || t.metaKey,
            shiftKey: t.shiftKey,

            get keystroke() {
              return ko(this);
            }

          });
        }
      }]);

      return os;
    }(is);

    var rs = function rs() {
      return i.a.Date.now();
    },
        ss = "[object Symbol]";

    var as = function as(t) {
      return "symbol" == typeof t || w(t) && m(t) == ss;
    },
        cs = NaN,
        ls = /^\s+|\s+$/g,
        ds = /^[-+]0x[0-9a-f]+$/i,
        hs = /^0b[01]+$/i,
        us = /^0o[0-7]+$/i,
        fs = parseInt;

    var gs = function gs(t) {
      if ("number" == typeof t) return t;
      if (as(t)) return cs;

      if (B(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = B(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(ls, "");
      var n = hs.test(t);
      return n || us.test(t) ? fs(t.slice(2), n ? 2 : 8) : ds.test(t) ? cs : +t;
    },
        ms = "Expected a function",
        ps = Math.max,
        bs = Math.min;

    var ws = function ws(t, e, n) {
      var i,
          o,
          r,
          s,
          a,
          c,
          l = 0,
          d = !1,
          h = !1,
          u = !0;
      if ("function" != typeof t) throw new TypeError(ms);

      function f(e) {
        var n = i,
            r = o;
        return i = o = void 0, l = e, s = t.apply(r, n);
      }

      function g(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || h && t - l >= r;
      }

      function m() {
        var t = rs();
        if (g(t)) return p(t);
        a = setTimeout(m, function (t) {
          var n = e - (t - c);
          return h ? bs(n, r - (t - l)) : n;
        }(t));
      }

      function p(t) {
        return a = void 0, u && i ? f(t) : (i = o = void 0, s);
      }

      function b() {
        var t = rs(),
            n = g(t);

        if (i = arguments, o = this, c = t, n) {
          if (void 0 === a) return function (t) {
            return l = t, a = setTimeout(m, e), d ? f(t) : s;
          }(c);
          if (h) return clearTimeout(a), a = setTimeout(m, e), f(c);
        }

        return void 0 === a && (a = setTimeout(m, e)), s;
      }

      return e = gs(e) || 0, B(n) && (d = !!n.leading, r = (h = "maxWait" in n) ? ps(gs(n.maxWait) || 0, e) : r, u = "trailing" in n ? !!n.trailing : u), b.cancel = function () {
        void 0 !== a && clearTimeout(a), l = 0, i = c = o = a = void 0;
      }, b.flush = function () {
        return void 0 === a ? s : p(rs());
      }, b;
    };

    var ks =
    /*#__PURE__*/
    function (_mr3) {
      _inherits(ks, _mr3);

      function ks(t) {
        var _this30;

        _classCallCheck(this, ks);

        _this30 = _possibleConstructorReturn(this, _getPrototypeOf(ks).call(this, t)), _this30._fireSelectionChangeDoneDebounced = ws(function (t) {
          return _this30.document.fire("selectionChangeDone", t);
        }, 200);
        return _this30;
      }

      _createClass(ks, [{
        key: "observe",
        value: function observe() {
          var _this31 = this;

          var t = this.document;
          t.on("keydown", function (e, n) {
            t.selection.isFake && function (t) {
              return t == wo.arrowright || t == wo.arrowleft || t == wo.arrowup || t == wo.arrowdown;
            }(n.keyCode) && _this31.isEnabled && (n.preventDefault(), _this31._handleSelectionMove(n.keyCode));
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(ks.prototype), "destroy", this).call(this), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionMove",
        value: function _handleSelectionMove(t) {
          var e = this.document.selection,
              n = new io(e.getRanges(), {
            backward: e.isBackward,
            fake: !1
          });
          t != wo.arrowleft && t != wo.arrowup || n.setTo(n.getFirstPosition()), t != wo.arrowright && t != wo.arrowdown || n.setTo(n.getLastPosition());
          var i = {
            oldSelection: e,
            newSelection: n,
            domSelection: null
          };
          this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
        }
      }]);

      return ks;
    }(mr);

    var _s =
    /*#__PURE__*/
    function (_mr4) {
      _inherits(_s, _mr4);

      function _s(t) {
        var _this32;

        _classCallCheck(this, _s);

        _this32 = _possibleConstructorReturn(this, _getPrototypeOf(_s).call(this, t)), _this32.mutationObserver = t.getObserver(es), _this32.selection = _this32.document.selection, _this32.domConverter = t.domConverter, _this32._documents = new WeakSet(), _this32._fireSelectionChangeDoneDebounced = ws(function (t) {
          return _this32.document.fire("selectionChangeDone", t);
        }, 200), _this32._clearInfiniteLoopInterval = setInterval(function () {
          return _this32._clearInfiniteLoop();
        }, 1e3), _this32._loopbackCounter = 0;
        return _this32;
      }

      _createClass(_s, [{
        key: "observe",
        value: function observe(t) {
          var _this33 = this;

          var e = t.ownerDocument;
          this._documents.has(e) || (this.listenTo(e, "selectionchange", function () {
            _this33._handleSelectionChange(e);
          }), this._documents.add(e));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(_s.prototype), "destroy", this).call(this), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionChange",
        value: function _handleSelectionChange(t) {
          if (!this.isEnabled || !this.document.isFocused && !this.document.isReadOnly) return;
          this.mutationObserver.flush();
          var e = t.defaultView.getSelection(),
              n = this.domConverter.domSelectionToView(e);
          if (!(this.selection.isEqual(n) && this.domConverter.isDomSelectionCorrect(e) || ++this._loopbackCounter > 60)) if (this.selection.isSimilar(n)) this.view.forceRender();else {
            var _t61 = {
              oldSelection: this.selection,
              newSelection: n,
              domSelection: e
            };
            this.document.fire("selectionChange", _t61), this._fireSelectionChangeDoneDebounced(_t61);
          }
        }
      }, {
        key: "_clearInfiniteLoop",
        value: function _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }]);

      return _s;
    }(mr);

    var vs =
    /*#__PURE__*/
    function (_is2) {
      _inherits(vs, _is2);

      function vs(t) {
        var _this34;

        _classCallCheck(this, vs);

        _this34 = _possibleConstructorReturn(this, _getPrototypeOf(vs).call(this, t)), _this34.domEventType = ["focus", "blur"], _this34.useCapture = !0;
        var e = _this34.document;
        e.on("focus", function () {
          e.isFocused = !0, _this34._renderTimeoutId = setTimeout(function () {
            return t.forceRender();
          }, 50);
        }), e.on("blur", function (n, i) {
          var o = e.selection.editableElement;
          null !== o && o !== i.target || (e.isFocused = !1, t.forceRender());
        });
        return _this34;
      }

      _createClass(vs, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _get(_getPrototypeOf(vs.prototype), "destroy", this).call(this);
        }
      }]);

      return vs;
    }(is);

    var ys =
    /*#__PURE__*/
    function (_is3) {
      _inherits(ys, _is3);

      function ys(t) {
        var _this35;

        _classCallCheck(this, ys);

        _this35 = _possibleConstructorReturn(this, _getPrototypeOf(ys).call(this, t)), _this35.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        var e = _this35.document;
        e.on("compositionstart", function () {
          e.isComposing = !0;
        }), e.on("compositionend", function () {
          e.isComposing = !1;
        });
        return _this35;
      }

      _createClass(ys, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return ys;
    }(is);

    var xs =
    /*#__PURE__*/
    function (_is4) {
      _inherits(xs, _is4);

      function xs(t) {
        var _this36;

        _classCallCheck(this, xs);

        _this36 = _possibleConstructorReturn(this, _getPrototypeOf(xs).call(this, t)), _this36.domEventType = ["beforeinput"];
        return _this36;
      }

      _createClass(xs, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return xs;
    }(is);

    function As(t) {
      return "[object Range]" == Object.prototype.toString.apply(t);
    }

    function Ts(t) {
      var e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }

    var Cs = ["top", "right", "bottom", "left", "width", "height"];

    var Ps =
    /*#__PURE__*/
    function () {
      function Ps(t) {
        _classCallCheck(this, Ps);

        var e = As(t);
        if (Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: !0,
          enumerable: !1
        }), Yn(t) || e) Ss(this, e ? Ps.getDomRangeRects(t)[0] : t.getBoundingClientRect());else if (hr(t)) {
          var _e63 = t.innerWidth,
              _n62 = t.innerHeight;
          Ss(this, {
            top: 0,
            right: _e63,
            bottom: _n62,
            left: 0,
            width: _e63,
            height: _n62
          });
        } else Ss(this, t);
      }

      _createClass(Ps, [{
        key: "clone",
        value: function clone() {
          return new Ps(this);
        }
      }, {
        key: "moveTo",
        value: function moveTo(t, e) {
          return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
        }
      }, {
        key: "moveBy",
        value: function moveBy(t, e) {
          return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          var e = {
            top: Math.max(this.top, t.top),
            right: Math.min(this.right, t.right),
            bottom: Math.min(this.bottom, t.bottom),
            left: Math.max(this.left, t.left)
          };
          return e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0 ? null : new Ps(e);
        }
      }, {
        key: "getIntersectionArea",
        value: function getIntersectionArea(t) {
          var e = this.getIntersection(t);
          return e ? e.getArea() : 0;
        }
      }, {
        key: "getArea",
        value: function getArea() {
          return this.width * this.height;
        }
      }, {
        key: "getVisible",
        value: function getVisible() {
          var t = this._source;
          var e = this.clone();

          if (!Ms(t)) {
            var _n63 = t.parentNode || t.commonAncestorContainer;

            for (; _n63 && !Ms(_n63);) {
              var _t62 = new Ps(_n63),
                  _i46 = e.getIntersection(_t62);

              if (!_i46) return null;
              _i46.getArea() < e.getArea() && (e = _i46), _n63 = _n63.parentNode;
            }
          }

          return e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          var _iteratorNormalCompletion74 = true;
          var _didIteratorError74 = false;
          var _iteratorError74 = undefined;

          try {
            for (var _iterator74 = Cs[Symbol.iterator](), _step74; !(_iteratorNormalCompletion74 = (_step74 = _iterator74.next()).done); _iteratorNormalCompletion74 = true) {
              var _e64 = _step74.value;
              if (this[_e64] !== t[_e64]) return !1;
            }
          } catch (err) {
            _didIteratorError74 = true;
            _iteratorError74 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion74 && _iterator74.return != null) {
                _iterator74.return();
              }
            } finally {
              if (_didIteratorError74) {
                throw _iteratorError74;
              }
            }
          }

          return !0;
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var e = this.getIntersection(t);
          return !(!e || !e.isEqual(t));
        }
      }, {
        key: "excludeScrollbarsAndBorders",
        value: function excludeScrollbarsAndBorders() {
          var t = this._source;
          var e, n, i;
          if (hr(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight, i = t.getComputedStyle(t.document.documentElement).direction;else {
            var _o28 = Ts(this._source);

            e = t.offsetWidth - t.clientWidth - _o28.left - _o28.right, n = t.offsetHeight - t.clientHeight - _o28.top - _o28.bottom, i = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += _o28.left, this.top += _o28.top, this.right -= _o28.right, this.bottom -= _o28.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
          }
          return this.width -= e, "ltr" === i ? this.right -= e : this.left += e, this.height -= n, this.bottom -= n, this;
        }
      }], [{
        key: "getDomRangeRects",
        value: function getDomRangeRects(t) {
          var e = [],
              n = Array.from(t.getClientRects());

          if (n.length) {
            var _iteratorNormalCompletion75 = true;
            var _didIteratorError75 = false;
            var _iteratorError75 = undefined;

            try {
              for (var _iterator75 = n[Symbol.iterator](), _step75; !(_iteratorNormalCompletion75 = (_step75 = _iterator75.next()).done); _iteratorNormalCompletion75 = true) {
                var _t63 = _step75.value;
                e.push(new Ps(_t63));
              }
            } catch (err) {
              _didIteratorError75 = true;
              _iteratorError75 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion75 && _iterator75.return != null) {
                  _iterator75.return();
                }
              } finally {
                if (_didIteratorError75) {
                  throw _iteratorError75;
                }
              }
            }
          } else {
            var _n64 = t.startContainer;
            jo(_n64) && (_n64 = _n64.parentNode);

            var _i47 = new Ps(_n64.getBoundingClientRect());

            _i47.right = _i47.left, _i47.width = 0, e.push(_i47);
          }

          return e;
        }
      }]);

      return Ps;
    }();

    function Ss(t, e) {
      var _iteratorNormalCompletion76 = true;
      var _didIteratorError76 = false;
      var _iteratorError76 = undefined;

      try {
        for (var _iterator76 = Cs[Symbol.iterator](), _step76; !(_iteratorNormalCompletion76 = (_step76 = _iterator76.next()).done); _iteratorNormalCompletion76 = true) {
          var _n65 = _step76.value;
          t[_n65] = e[_n65];
        }
      } catch (err) {
        _didIteratorError76 = true;
        _iteratorError76 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion76 && _iterator76.return != null) {
            _iterator76.return();
          }
        } finally {
          if (_didIteratorError76) {
            throw _iteratorError76;
          }
        }
      }
    }

    function Ms(t) {
      return !!Yn(t) && t === t.ownerDocument.body;
    }

    function Es(_ref16) {
      var t = _ref16.target,
          _ref16$viewportOffset = _ref16.viewportOffset,
          e = _ref16$viewportOffset === void 0 ? 0 : _ref16$viewportOffset;
      var n = js(t);
      var i = n,
          o = null;

      for (; i;) {
        var _r10 = void 0;

        _r10 = Vs(i == n ? t : o), Ns(_r10, function () {
          return zs(t, i);
        });

        var _s8 = zs(t, i);

        if (Is(i, _s8, e), i.parent != i) {
          if (o = i.frameElement, i = i.parent, !o) return;
        } else i = null;
      }
    }

    function Is(t, e, n) {
      var i = e.clone().moveBy(0, n),
          o = e.clone().moveBy(0, -n),
          r = new Ps(t).excludeScrollbarsAndBorders();

      if (![o, i].every(function (t) {
        return r.contains(t);
      })) {
        var _s9 = t.scrollX,
            _a7 = t.scrollY;
        Rs(o, r) ? _a7 -= r.top - e.top + n : Os(i, r) && (_a7 += e.bottom - r.bottom + n), Ds(e, r) ? _s9 -= r.left - e.left + n : Ls(e, r) && (_s9 += e.right - r.right + n), t.scrollTo(_s9, _a7);
      }
    }

    function Ns(t, e) {
      var n = js(t);
      var i, o;

      for (; t != n.document.body;) {
        o = e(), i = new Ps(t).excludeScrollbarsAndBorders(), i.contains(o) || (Rs(o, i) ? t.scrollTop -= i.top - o.top : Os(o, i) && (t.scrollTop += o.bottom - i.bottom), Ds(o, i) ? t.scrollLeft -= i.left - o.left : Ls(o, i) && (t.scrollLeft += o.right - i.right)), t = t.parentNode;
      }
    }

    function Os(t, e) {
      return t.bottom > e.bottom;
    }

    function Rs(t, e) {
      return t.top < e.top;
    }

    function Ds(t, e) {
      return t.left < e.left;
    }

    function Ls(t, e) {
      return t.right > e.right;
    }

    function js(t) {
      return As(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
    }

    function Vs(t) {
      if (As(t)) {
        var _e65 = t.commonAncestorContainer;
        return jo(_e65) && (_e65 = _e65.parentNode), _e65;
      }

      return t.parentNode;
    }

    function zs(t, e) {
      var n = js(t),
          i = new Ps(t);
      if (n === e) return i;
      {
        var _t64 = n;

        for (; _t64 != e;) {
          var _e66 = _t64.frameElement,
              _n66 = new Ps(_e66).excludeScrollbarsAndBorders();

          i.moveBy(_n66.left, _n66.top), _t64 = _t64.parent;
        }
      }
      return i;
    }

    Object.assign({}, {
      scrollViewportToShowTarget: Es,
      scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(t) {
        Ns(Vs(t), function () {
          return new Ps(t);
        });
      }
    });

    var Bs =
    /*#__PURE__*/
    function () {
      function Bs() {
        var _this37 = this;

        _classCallCheck(this, Bs);

        this.document = new so(), this.domConverter = new ar(), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this._renderer = new Xo(this.domConverter, this.document.selection), this._renderer.bind("isFocused").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new Po(this.document), this.addObserver(es), this.addObserver(_s), this.addObserver(vs), this.addObserver(os), this.addObserver(ks), this.addObserver(ys), mo.isAndroid && this.addObserver(xs), this.document.on("keydown", Wo), Ao(this), this.on("render", function () {
          _this37._render(), _this37.document.fire("layoutChanged"), _this37._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", function () {
          _this37._hasChangedSinceTheLastRendering = !0;
        });
      }

      _createClass(Bs, [{
        key: "attachDomRoot",
        value: function attachDomRoot(t) {
          var _this38 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          var n = this.document.getRoot(e);
          n._name = t.tagName.toLowerCase();
          var i = {};

          for (var _i48 = 0, _Array$from2 = Array.from(t.attributes); _i48 < _Array$from2.length; _i48++) {
            var _ref18 = _Array$from2[_i48];
            var _e67 = _ref18.name;
            var _o29 = _ref18.value;
            i[_e67] = _o29, "class" === _e67 ? this._writer.addClass(_o29.split(" "), n) : this._writer.setAttribute(_e67, _o29, n);
          }

          this._initialDomRootAttributes.set(t, i);

          var o = function o() {
            _this38._writer.setAttribute("contenteditable", !n.isReadOnly, n), n.isReadOnly ? _this38._writer.addClass("ck-read-only", n) : _this38._writer.removeClass("ck-read-only", n);
          };

          o(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", function (t, e) {
            return _this38._renderer.markToSync("children", e);
          }), n.on("change:attributes", function (t, e) {
            return _this38._renderer.markToSync("attributes", e);
          }), n.on("change:text", function (t, e) {
            return _this38._renderer.markToSync("text", e);
          }), n.on("change:isReadOnly", function () {
            return _this38.change(o);
          }), n.on("change", function () {
            _this38._hasChangedSinceTheLastRendering = !0;
          });
          var _iteratorNormalCompletion77 = true;
          var _didIteratorError77 = false;
          var _iteratorError77 = undefined;

          try {
            for (var _iterator77 = this._observers.values()[Symbol.iterator](), _step77; !(_iteratorNormalCompletion77 = (_step77 = _iterator77.next()).done); _iteratorNormalCompletion77 = true) {
              var _n67 = _step77.value;

              _n67.observe(t, e);
            }
          } catch (err) {
            _didIteratorError77 = true;
            _iteratorError77 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion77 && _iterator77.return != null) {
                _iterator77.return();
              }
            } finally {
              if (_didIteratorError77) {
                throw _iteratorError77;
              }
            }
          }
        }
      }, {
        key: "detachDomRoot",
        value: function detachDomRoot(t) {
          var e = this.domRoots.get(t);
          Array.from(e.attributes).forEach(function (_ref19) {
            var t = _ref19.name;
            return e.removeAttribute(t);
          });

          var n = this._initialDomRootAttributes.get(e);

          for (var _t65 in n) {
            e.setAttribute(_t65, n[_t65]);
          }

          this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
        }
      }, {
        key: "getDomRoot",
        value: function getDomRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.domRoots.get(t);
        }
      }, {
        key: "addObserver",
        value: function addObserver(t) {
          var e = this._observers.get(t);

          if (e) return e;
          e = new t(this), this._observers.set(t, e);
          var _iteratorNormalCompletion78 = true;
          var _didIteratorError78 = false;
          var _iteratorError78 = undefined;

          try {
            for (var _iterator78 = this.domRoots[Symbol.iterator](), _step78; !(_iteratorNormalCompletion78 = (_step78 = _iterator78.next()).done); _iteratorNormalCompletion78 = true) {
              var _ref22 = _step78.value;

              var _ref21 = _slicedToArray(_ref22, 2);

              var _t66 = _ref21[0];
              var _n68 = _ref21[1];
              e.observe(_n68, _t66);
            }
          } catch (err) {
            _didIteratorError78 = true;
            _iteratorError78 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion78 && _iterator78.return != null) {
                _iterator78.return();
              }
            } finally {
              if (_didIteratorError78) {
                throw _iteratorError78;
              }
            }
          }

          return e.enable(), e;
        }
      }, {
        key: "getObserver",
        value: function getObserver(t) {
          return this._observers.get(t);
        }
      }, {
        key: "disableObservers",
        value: function disableObservers() {
          var _iteratorNormalCompletion79 = true;
          var _didIteratorError79 = false;
          var _iteratorError79 = undefined;

          try {
            for (var _iterator79 = this._observers.values()[Symbol.iterator](), _step79; !(_iteratorNormalCompletion79 = (_step79 = _iterator79.next()).done); _iteratorNormalCompletion79 = true) {
              var _t67 = _step79.value;

              _t67.disable();
            }
          } catch (err) {
            _didIteratorError79 = true;
            _iteratorError79 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion79 && _iterator79.return != null) {
                _iterator79.return();
              }
            } finally {
              if (_didIteratorError79) {
                throw _iteratorError79;
              }
            }
          }
        }
      }, {
        key: "enableObservers",
        value: function enableObservers() {
          var _iteratorNormalCompletion80 = true;
          var _didIteratorError80 = false;
          var _iteratorError80 = undefined;

          try {
            for (var _iterator80 = this._observers.values()[Symbol.iterator](), _step80; !(_iteratorNormalCompletion80 = (_step80 = _iterator80.next()).done); _iteratorNormalCompletion80 = true) {
              var _t68 = _step80.value;

              _t68.enable();
            }
          } catch (err) {
            _didIteratorError80 = true;
            _iteratorError80 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion80 && _iterator80.return != null) {
                _iterator80.return();
              }
            } finally {
              if (_didIteratorError80) {
                throw _iteratorError80;
              }
            }
          }
        }
      }, {
        key: "scrollToTheSelection",
        value: function scrollToTheSelection() {
          var t = this.document.selection.getFirstRange();
          t && Es({
            target: this.domConverter.viewRangeToDom(t),
            viewportOffset: 20
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          if (!this.document.isFocused) {
            var _t69 = this.document.selection.editableElement;
            _t69 && (this.domConverter.focus(_t69), this.forceRender());
          }
        }
      }, {
        key: "change",
        value: function change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress) throw new Qn.b("cannot-change-view-tree: Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. This may cause some unexpected behavior and inconsistency between the DOM and the view.", this);

          try {
            if (this._ongoingChange) return t(this._writer);
            this._ongoingChange = !0;

            var _e68 = t(this._writer);

            return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), _e68;
          } catch (t) {
            Qn.b.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "forceRender",
        value: function forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion81 = true;
          var _didIteratorError81 = false;
          var _iteratorError81 = undefined;

          try {
            for (var _iterator81 = this._observers.values()[Symbol.iterator](), _step81; !(_iteratorNormalCompletion81 = (_step81 = _iterator81.next()).done); _iteratorNormalCompletion81 = true) {
              var _t70 = _step81.value;

              _t70.destroy();
            }
          } catch (err) {
            _didIteratorError81 = true;
            _iteratorError81 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion81 && _iterator81.return != null) {
                _iterator81.return();
              }
            } finally {
              if (_didIteratorError81) {
                throw _iteratorError81;
              }
            }
          }

          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Xi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Xi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Xi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new to(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return to._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return to._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new io(t, e, n);
        }
      }, {
        key: "_disableRendering",
        value: function _disableRendering(t) {
          this._renderingDisabled = t, 0 == t && this.change(function () {});
        }
      }, {
        key: "_render",
        value: function _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }]);

      return Bs;
    }();

    function Fs(t) {
      return T(t) ? pi(t) : new Map(t);
    }

    li(Bs, Ui);

    var Us =
    /*#__PURE__*/
    function () {
      function Us(t) {
        _classCallCheck(this, Us);

        this.parent = null, this._attrs = Fs(t);
      }

      _createClass(Us, [{
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;

          for (; e.parent;) {
            t.unshift(e.startOffset), e = e.parent;
          }

          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
              i = t.getAncestors(e);
          var o = 0;

          for (; n[o] == i[o] && n[o];) {
            o++;
          }

          return 0 === o ? null : n[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
              n = t.getPath(),
              i = di(e, n);

          switch (i) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return e[i] < n[i];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = {};
          return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce(function (t, e) {
            return t[e[0]] = e[1], t;
          }, {})), t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" == t || "model:node" == t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Us(this._attrs);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._attrs.set(t, e);
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          this._attrs = Fs(t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._attrs.delete(t);
        }
      }, {
        key: "_clearAttributes",
        value: function _clearAttributes() {
          this._attrs.clear();
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildIndex(this))) throw new Qn.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "startOffset",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildStartOffset(this))) throw new Qn.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return 1;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;

          for (; t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "document",
        get: function get() {
          return this.root == this ? null : this.root.document || null;
        }
      }]);

      return Us;
    }();

    var Hs =
    /*#__PURE__*/
    function (_Us) {
      _inherits(Hs, _Us);

      function Hs(t, e) {
        var _this39;

        _classCallCheck(this, Hs);

        _this39 = _possibleConstructorReturn(this, _getPrototypeOf(Hs).call(this, e)), _this39._data = t || "";
        return _this39;
      }

      _createClass(Hs, [{
        key: "is",
        value: function is(t) {
          return "text" == t || "model:text" == t || _get(_getPrototypeOf(Hs.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Hs.prototype), "toJSON", this).call(this);

          return t.data = this.data, t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Hs(this.data, this.getAttributes());
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new Hs(t.data, t.attributes);
        }
      }]);

      return Hs;
    }(Us);

    var qs =
    /*#__PURE__*/
    function () {
      function qs(t, e, n) {
        _classCallCheck(this, qs);

        if (this.textNode = t, e < 0 || e > t.offsetSize) throw new Qn.b("model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
        if (n < 0 || e + n > t.offsetSize) throw new Qn.b("model-textproxy-wrong-length: Given length value is incorrect.", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }

      _createClass(qs, [{
        key: "is",
        value: function is(t) {
          return "textProxy" == t || "model:textProxy" == t;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = this.textNode.getPath();
          return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this.textNode.hasAttribute(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this.textNode.getAttribute(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this.textNode.getAttributes();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }, {
        key: "startOffset",
        get: function get() {
          return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);

      return qs;
    }();

    var Ws =
    /*#__PURE__*/
    function () {
      function Ws(t) {
        _classCallCheck(this, Ws);

        this._nodes = [], t && this._insertNodes(0, t);
      }

      _createClass(Ws, [{
        key: Symbol.iterator,
        value: function value() {
          return this._nodes[Symbol.iterator]();
        }
      }, {
        key: "getNode",
        value: function getNode(t) {
          return this._nodes[t] || null;
        }
      }, {
        key: "getNodeIndex",
        value: function getNodeIndex(t) {
          var e = this._nodes.indexOf(t);

          return -1 == e ? null : e;
        }
      }, {
        key: "getNodeStartOffset",
        value: function getNodeStartOffset(t) {
          var e = this.getNodeIndex(t);
          return null === e ? null : this._nodes.slice(0, e).reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }, {
        key: "indexToOffset",
        value: function indexToOffset(t) {
          if (t == this._nodes.length) return this.maxOffset;
          var e = this._nodes[t];
          if (!e) throw new Qn.b("model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.", this);
          return this.getNodeStartOffset(e);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          var e = 0;
          var _iteratorNormalCompletion82 = true;
          var _didIteratorError82 = false;
          var _iteratorError82 = undefined;

          try {
            for (var _iterator82 = this._nodes[Symbol.iterator](), _step82; !(_iteratorNormalCompletion82 = (_step82 = _iterator82.next()).done); _iteratorNormalCompletion82 = true) {
              var _n69 = _step82.value;
              if (t >= e && t < e + _n69.offsetSize) return this.getNodeIndex(_n69);
              e += _n69.offsetSize;
            }
          } catch (err) {
            _didIteratorError82 = true;
            _iteratorError82 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion82 && _iterator82.return != null) {
                _iterator82.return();
              }
            } finally {
              if (_didIteratorError82) {
                throw _iteratorError82;
              }
            }
          }

          if (e != t) throw new Qn.b("model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.", this, {
            offset: t,
            nodeList: this
          });
          return this.length;
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(t, e) {
          var _this$_nodes;

          var _iteratorNormalCompletion83 = true;
          var _didIteratorError83 = false;
          var _iteratorError83 = undefined;

          try {
            for (var _iterator83 = e[Symbol.iterator](), _step83; !(_iteratorNormalCompletion83 = (_step83 = _iterator83.next()).done); _iteratorNormalCompletion83 = true) {
              var _t71 = _step83.value;
              if (!(_t71 instanceof Us)) throw new Qn.b("model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.", this);
            }
          } catch (err) {
            _didIteratorError83 = true;
            _iteratorError83 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion83 && _iterator83.return != null) {
                _iterator83.return();
              }
            } finally {
              if (_didIteratorError83) {
                throw _iteratorError83;
              }
            }
          }

          (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [t, 0].concat(_toConsumableArray(e)));
        }
      }, {
        key: "_removeNodes",
        value: function _removeNodes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return this._nodes.splice(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this._nodes.map(function (t) {
            return t.toJSON();
          });
        }
      }, {
        key: "length",
        get: function get() {
          return this._nodes.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._nodes.reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }]);

      return Ws;
    }();

    var Ys =
    /*#__PURE__*/
    function (_Us2) {
      _inherits(Ys, _Us2);

      function Ys(t, e, n) {
        var _this40;

        _classCallCheck(this, Ys);

        _this40 = _possibleConstructorReturn(this, _getPrototypeOf(Ys).call(this, e)), _this40.name = t, _this40._children = new Ws(), n && _this40._insertChild(0, n);
        return _this40;
      }

      _createClass(Ys, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^model:/, "");
          return e ? "element" == n && e == this.name : "element" == n || n == this.name || _get(_getPrototypeOf(Ys.prototype), "is", this).call(this, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iteratorNormalCompletion84 = true;
          var _didIteratorError84 = false;
          var _iteratorError84 = undefined;

          try {
            for (var _iterator84 = t[Symbol.iterator](), _step84; !(_iteratorNormalCompletion84 = (_step84 = _iterator84.next()).done); _iteratorNormalCompletion84 = true) {
              var _n70 = _step84.value;
              e = e.getChild(e.offsetToIndex(_n70));
            }
          } catch (err) {
            _didIteratorError84 = true;
            _iteratorError84 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion84 && _iterator84.return != null) {
                _iterator84.return();
              }
            } finally {
              if (_didIteratorError84) {
                throw _iteratorError84;
              }
            }
          }

          return e;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Ys.prototype), "toJSON", this).call(this);

          if (t.name = this.name, this._children.length > 0) {
            t.children = [];
            var _iteratorNormalCompletion85 = true;
            var _didIteratorError85 = false;
            var _iteratorError85 = undefined;

            try {
              for (var _iterator85 = this._children[Symbol.iterator](), _step85; !(_iteratorNormalCompletion85 = (_step85 = _iterator85.next()).done); _iteratorNormalCompletion85 = true) {
                var _e69 = _step85.value;
                t.children.push(_e69.toJSON());
              }
            } catch (err) {
              _didIteratorError85 = true;
              _iteratorError85 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion85 && _iterator85.return != null) {
                  _iterator85.return();
                }
              } finally {
                if (_didIteratorError85) {
                  throw _iteratorError85;
                }
              }
            }
          }

          return t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = t ? Array.from(this._children).map(function (t) {
            return t._clone(!0);
          }) : null;
          return new Ys(this.name, this.getAttributes(), e);
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new Hs(t)];
            bi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new Hs(t) : t instanceof qs ? new Hs(t.data, t.getAttributes()) : t;
            });
          }(e);

          var _iteratorNormalCompletion86 = true;
          var _didIteratorError86 = false;
          var _iteratorError86 = undefined;

          try {
            for (var _iterator86 = n[Symbol.iterator](), _step86; !(_iteratorNormalCompletion86 = (_step86 = _iterator86.next()).done); _iteratorNormalCompletion86 = true) {
              var _t72 = _step86.value;
              null !== _t72.parent && _t72._remove(), _t72.parent = this;
            }
          } catch (err) {
            _didIteratorError86 = true;
            _iteratorError86 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion86 && _iterator86.return != null) {
                _iterator86.return();
              }
            } finally {
              if (_didIteratorError86) {
                throw _iteratorError86;
              }
            }
          }

          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var n = this._children._removeNodes(t, e);

          var _iteratorNormalCompletion87 = true;
          var _didIteratorError87 = false;
          var _iteratorError87 = undefined;

          try {
            for (var _iterator87 = n[Symbol.iterator](), _step87; !(_iteratorNormalCompletion87 = (_step87 = _iterator87.next()).done); _iteratorNormalCompletion87 = true) {
              var _t73 = _step87.value;
              _t73.parent = null;
            }
          } catch (err) {
            _didIteratorError87 = true;
            _iteratorError87 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion87 && _iterator87.return != null) {
                _iterator87.return();
              }
            } finally {
              if (_didIteratorError87) {
                throw _iteratorError87;
              }
            }
          }

          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = null;

          if (t.children) {
            e = [];
            var _iteratorNormalCompletion88 = true;
            var _didIteratorError88 = false;
            var _iteratorError88 = undefined;

            try {
              for (var _iterator88 = t.children[Symbol.iterator](), _step88; !(_iteratorNormalCompletion88 = (_step88 = _iterator88.next()).done); _iteratorNormalCompletion88 = true) {
                var _n71 = _step88.value;
                _n71.name ? e.push(Ys.fromJSON(_n71)) : e.push(Hs.fromJSON(_n71));
              }
            } catch (err) {
              _didIteratorError88 = true;
              _iteratorError88 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion88 && _iterator88.return != null) {
                  _iterator88.return();
                }
              } finally {
                if (_didIteratorError88) {
                  throw _iteratorError88;
                }
              }
            }
          }

          return new Ys(t.name, t.attributes, e);
        }
      }]);

      return Ys;
    }(Us);

    var $s =
    /*#__PURE__*/
    function () {
      function $s() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, $s);

        if (!t.boundaries && !t.startPosition) throw new Qn.b("model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
        var e = t.direction || "forward";
        if ("forward" != e && "backward" != e) throw new Qn.b("model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", t, {
          direction: e
        });
        this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this.position = t.startPosition.clone() : this.position = Ks._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }

      _createClass($s, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, i, o;

          do {
            var _this$next2;

            i = this.position, o = this._visitedParent, (_this$next2 = this.next(), e = _this$next2.done, n = _this$next2.value, _this$next2);
          } while (!e && t(n));

          e || (this.position = i, this._visitedParent = o);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position,
              e = this.position.clone(),
              n = this._visitedParent;
          if (null === n.parent && e.offset === n.maxOffset) return {
            done: !0
          };
          if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var i = e.textNode ? e.textNode : e.nodeAfter;
          if (i instanceof Ys) return this.shallow ? e.offset++ : (e.path.push(0), this._visitedParent = i), this.position = e, Gs("elementStart", i, t, e, 1);

          if (i instanceof Hs) {
            var _o30;

            if (this.singleCharacters) _o30 = 1;else {
              var _t74 = i.endOffset;
              this._boundaryEndParent == n && this.boundaries.end.offset < _t74 && (_t74 = this.boundaries.end.offset), _o30 = _t74 - e.offset;
            }

            var _r11 = e.offset - i.startOffset,
                _s10 = new qs(i, _r11, _o30);

            return e.offset += _o30, this.position = e, Gs("text", _s10, t, e, _o30);
          }

          return e.path.pop(), e.offset++, this.position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : Gs("elementEnd", n, t, e);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position,
              e = this.position.clone(),
              n = this._visitedParent;
          if (null === n.parent && 0 === e.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var i = e.textNode ? e.textNode : e.nodeBefore;
          if (i instanceof Ys) return e.offset--, this.shallow ? (this.position = e, Gs("elementStart", i, t, e, 1)) : (e.path.push(i.maxOffset), this.position = e, this._visitedParent = i, this.ignoreElementEnd ? this._previous() : Gs("elementEnd", i, t, e));

          if (i instanceof Hs) {
            var _o31;

            if (this.singleCharacters) _o31 = 1;else {
              var _t75 = i.startOffset;
              this._boundaryStartParent == n && this.boundaries.start.offset > _t75 && (_t75 = this.boundaries.start.offset), _o31 = e.offset - _t75;
            }

            var _r12 = e.offset - i.startOffset,
                _s11 = new qs(i, _r12 - _o31, _o31);

            return e.offset -= _o31, this.position = e, Gs("text", _s11, t, e, _o31);
          }

          return e.path.pop(), this.position = e, this._visitedParent = n.parent, Gs("elementStart", n, t, e, 1);
        }
      }]);

      return $s;
    }();

    function Gs(t, e, n, i, o) {
      return {
        done: !1,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: i,
          length: o
        }
      };
    }

    var Qs = function Qs(t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };

    var Ks =
    /*#__PURE__*/
    function () {
      function Ks(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, Ks);

        if (!t.is("element") && !t.is("documentFragment")) throw new Qn.b("model-position-root-invalid: Position root invalid.", t);
        if (!(e instanceof Array) || 0 === e.length) throw new Qn.b("model-position-path-incorrect-format: Position path must be an array with at least one item.", t, {
          path: e
        });
        e = t.getPath().concat(e), t = t.root, this.root = t, this.path = e, this.stickiness = n;
      }

      _createClass(Ks, [{
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root != t.root) return "different";
          var e = di(this.path, t.path);

          switch (e) {
            case "same":
              return "same";

            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return this.path[e] < t.path[e] ? "before" : "after";
          }
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new $s(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          return this.path.slice(0, -1);
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonPath",
        value: function getCommonPath(t) {
          if (this.root != t.root) return [];
          var e = di(this.path, t.path),
              n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
          return this.path.slice(0, n);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
              n = t.getAncestors();
          var i = 0;

          for (; e[i] == n[i] && e[i];) {
            i++;
          }

          return 0 === i ? null : e[i - 1];
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = this.clone(),
              n = e.offset + t;
          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return "same" == this.compareWith(t);
        }
      }, {
        key: "isTouching",
        value: function isTouching(t) {
          var e = null,
              n = null;

          switch (this.compareWith(t)) {
            case "same":
              return !0;

            case "before":
              e = Ks._createAt(this), n = Ks._createAt(t);
              break;

            case "after":
              e = Ks._createAt(t), n = Ks._createAt(this);
              break;

            default:
              return !1;
          }

          var i = e.parent;

          for (; e.path.length + n.path.length;) {
            if (e.isEqual(n)) return !0;

            if (e.path.length > n.path.length) {
              if (e.offset !== i.maxOffset) return !1;
              e.path = e.path.slice(0, -1), i = i.parent, e.offset++;
            } else {
              if (0 !== n.offset) return !1;
              n.path = n.path.slice(0, -1);
            }
          }
        }
      }, {
        key: "is",
        value: function is(t) {
          return "position" == t || "model:position" == t;
        }
      }, {
        key: "hasSameParentAs",
        value: function hasSameParentAs(t) {
          if (this.root !== t.root) return !1;
          return "same" == di(this.getParentPath(), t.getParentPath());
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          var e;

          switch (t.type) {
            case "insert":
              e = this._getTransformedByInsertOperation(t);
              break;

            case "move":
            case "remove":
            case "reinsert":
              e = this._getTransformedByMoveOperation(t);
              break;

            case "split":
              e = this._getTransformedBySplitOperation(t);
              break;

            case "merge":
              e = this._getTransformedByMergeOperation(t);
              break;

            default:
              e = Ks._createAt(this);
          }

          return e;
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = t.movedRange;
          return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          var e = t.movedRange;
          var n;
          return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? Ks._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = Ks._createAt(this);

          if (this.root != t.root) return n;

          if ("same" == di(t.getParentPath(), this.getParentPath())) {
            if (t.offset < this.offset) {
              if (t.offset + e > this.offset) return null;
              n.offset -= e;
            }
          } else if ("prefix" == di(t.getParentPath(), this.getParentPath())) {
            var _i49 = t.path.length - 1;

            if (t.offset <= this.path[_i49]) {
              if (t.offset + e > this.path[_i49]) return null;
              n.path[_i49] -= e;
            }
          }

          return n;
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = Ks._createAt(this);

          if (this.root != t.root) return n;
          if ("same" == di(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == di(t.getParentPath(), this.getParentPath())) {
            var _i50 = t.path.length - 1;

            t.offset <= this.path[_i50] && (n.path[_i50] += e);
          }
          return n;
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return Ks._createAt(this);

          var i = this._getTransformedByDeletion(t, n);

          return null === i || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : i._getTransformedByInsertion(e, n);
        }
      }, {
        key: "_getCombined",
        value: function _getCombined(t, e) {
          var n = t.path.length - 1,
              i = Ks._createAt(e);

          return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - t.offset, i.path = i.path.concat(this.path.slice(n + 1)), i;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
      }, {
        key: "offset",
        get: function get() {
          return Qs(this.path);
        },
        set: function set(t) {
          this.path[this.path.length - 1] = t;
        }
      }, {
        key: "parent",
        get: function get() {
          var t = this.root;

          for (var _e70 = 0; _e70 < this.path.length - 1; _e70++) {
            if (t = t.getChild(t.offsetToIndex(this.path[_e70])), !t) throw new Qn.b("model-position-path-incorrect: The position's path is incorrect.", this, {
              position: this
            });
          }

          if (t.is("text")) throw new Qn.b("model-position-path-incorrect: The position's path is incorrect.", this, {
            position: this
          });
          return t;
        }
      }, {
        key: "index",
        get: function get() {
          return this.parent.offsetToIndex(this.offset);
        }
      }, {
        key: "textNode",
        get: function get() {
          var t = this.parent.getChild(this.index);
          return t instanceof Hs && t.startOffset < this.offset ? t : null;
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return null === this.textNode ? this.parent.getChild(this.index) : null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return null === this.textNode ? this.parent.getChild(this.index - 1) : null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          return this.offset == this.parent.maxOffset;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
          if (t instanceof Ks) return new Ks(t.root, t.path, t.stickiness);
          {
            var _i51 = t;
            if ("end" == e) e = _i51.maxOffset;else {
              if ("before" == e) return this._createBefore(_i51, n);
              if ("after" == e) return this._createAfter(_i51, n);
              if (0 !== e && !e) throw new Qn.b("model-createPositionAt-offset-required: Model#createPositionAt() requires the offset when the first parameter is a model item.", [this, t]);
            }
            if (!_i51.is("element") && !_i51.is("documentFragment")) throw new Qn.b("model-position-parent-incorrect: Position parent have to be a element or document fragment.", [this, t]);

            var _o32 = _i51.getPath();

            return _o32.push(e), new this(_i51.root, _o32, n);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t, e) {
          if (!t.parent) throw new Qn.b("model-position-after-root: You cannot make a position after root.", [this, t], {
            root: t
          });
          return this._createAt(t.parent, t.endOffset, e);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t, e) {
          if (!t.parent) throw new Qn.b("model-position-before-root: You cannot make a position before root.", t, {
            root: t
          });
          return this._createAt(t.parent, t.startOffset, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if ("$graveyard" === t.root) {
            var _n72 = new Ks(e.graveyard, t.path);

            return _n72.stickiness = t.stickiness, _n72;
          }

          if (!e.getRoot(t.root)) throw new Qn.b("model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.", e, {
            rootName: t.root
          });
          return new Ks(e.getRoot(t.root), t.path, t.stickiness);
        }
      }]);

      return Ks;
    }();

    var Js =
    /*#__PURE__*/
    function () {
      function Js(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Js);

        this.start = Ks._createAt(t), this.end = e ? Ks._createAt(e) : Ks._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }

      _createClass(Js, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  return _context11.delegateYield(new $s({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
              i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && i;
        }
      }, {
        key: "containsItem",
        value: function containsItem(t) {
          var e = Ks._createBefore(t);

          return this.containsPosition(e) || this.start.isEqual(e);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "range" == t || "model:range" == t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Js(this.start, t.start)), this.containsPosition(t.end) && e.push(new Js(t.end, this.end))) : e.push(new Js(this.start, this.end)), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e71 = this.start,
                _n73 = this.end;
            return this.containsPosition(t.start) && (_e71 = t.start), this.containsPosition(t.end) && (_n73 = t.end), new Js(_e71, _n73);
          }

          return null;
        }
      }, {
        key: "getMinimalFlatRanges",
        value: function getMinimalFlatRanges() {
          var t = [],
              e = this.start.getCommonPath(this.end).length,
              n = Ks._createAt(this.start);

          var i = n.parent;

          for (; n.path.length > e + 1;) {
            var _e72 = i.maxOffset - n.offset;

            0 !== _e72 && t.push(new Js(n, n.getShiftedBy(_e72))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
          }

          for (; n.path.length <= this.end.path.length;) {
            var _e73 = this.end.path[n.path.length - 1],
                _i52 = _e73 - n.offset;

            0 !== _i52 && t.push(new Js(n, n.getShiftedBy(_i52))), n.offset = _e73, n.path.push(0);
          }

          return t;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new $s(t);
        }
      }, {
        key: "getItems",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getItems() {
          var t,
              e,
              _iteratorNormalCompletion89,
              _didIteratorError89,
              _iteratorError89,
              _iterator89,
              _step89,
              _t76,
              _args12 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
                  t.boundaries = this, t.ignoreElementEnd = !0;
                  e = new $s(t);
                  _iteratorNormalCompletion89 = true;
                  _didIteratorError89 = false;
                  _iteratorError89 = undefined;
                  _context12.prev = 6;
                  _iterator89 = e[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion89 = (_step89 = _iterator89.next()).done) {
                    _context12.next = 15;
                    break;
                  }

                  _t76 = _step89.value;
                  _context12.next = 12;
                  return _t76.item;

                case 12:
                  _iteratorNormalCompletion89 = true;
                  _context12.next = 8;
                  break;

                case 15:
                  _context12.next = 21;
                  break;

                case 17:
                  _context12.prev = 17;
                  _context12.t0 = _context12["catch"](6);
                  _didIteratorError89 = true;
                  _iteratorError89 = _context12.t0;

                case 21:
                  _context12.prev = 21;
                  _context12.prev = 22;

                  if (!_iteratorNormalCompletion89 && _iterator89.return != null) {
                    _iterator89.return();
                  }

                case 24:
                  _context12.prev = 24;

                  if (!_didIteratorError89) {
                    _context12.next = 27;
                    break;
                  }

                  throw _iteratorError89;

                case 27:
                  return _context12.finish(24);

                case 28:
                  return _context12.finish(21);

                case 29:
                case "end":
                  return _context12.stop();
              }
            }
          }, getItems, this, [[6, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "getPositions",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getPositions() {
          var t,
              e,
              _iteratorNormalCompletion90,
              _didIteratorError90,
              _iteratorError90,
              _iterator90,
              _step90,
              _t77,
              _args13 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  t = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
                  t.boundaries = this;
                  e = new $s(t);
                  _context13.next = 5;
                  return e.position;

                case 5:
                  _iteratorNormalCompletion90 = true;
                  _didIteratorError90 = false;
                  _iteratorError90 = undefined;
                  _context13.prev = 8;
                  _iterator90 = e[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion90 = (_step90 = _iterator90.next()).done) {
                    _context13.next = 17;
                    break;
                  }

                  _t77 = _step90.value;
                  _context13.next = 14;
                  return _t77.nextPosition;

                case 14:
                  _iteratorNormalCompletion90 = true;
                  _context13.next = 10;
                  break;

                case 17:
                  _context13.next = 23;
                  break;

                case 19:
                  _context13.prev = 19;
                  _context13.t0 = _context13["catch"](8);
                  _didIteratorError90 = true;
                  _iteratorError90 = _context13.t0;

                case 23:
                  _context13.prev = 23;
                  _context13.prev = 24;

                  if (!_iteratorNormalCompletion90 && _iterator90.return != null) {
                    _iterator90.return();
                  }

                case 26:
                  _context13.prev = 26;

                  if (!_didIteratorError90) {
                    _context13.next = 29;
                    break;
                  }

                  throw _iteratorError90;

                case 29:
                  return _context13.finish(26);

                case 30:
                  return _context13.finish(23);

                case 31:
                case "end":
                  return _context13.stop();
              }
            }
          }, getPositions, this, [[8, 19, 23, 31], [24,, 26, 30]]);
        })
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          switch (t.type) {
            case "insert":
              return this._getTransformedByInsertOperation(t);

            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(t);

            case "split":
              return [this._getTransformedBySplitOperation(t)];

            case "merge":
              return [this._getTransformedByMergeOperation(t)];
          }

          return [new Js(this.start, this.end)];
        }
      }, {
        key: "getTransformedByOperations",
        value: function getTransformedByOperations(t) {
          var e = [new Js(this.start, this.end)];
          var _iteratorNormalCompletion91 = true;
          var _didIteratorError91 = false;
          var _iteratorError91 = undefined;

          try {
            for (var _iterator91 = t[Symbol.iterator](), _step91; !(_iteratorNormalCompletion91 = (_step91 = _iterator91.next()).done); _iteratorNormalCompletion91 = true) {
              var _n75 = _step91.value;

              for (var _t80 = 0; _t80 < e.length; _t80++) {
                var _i54 = e[_t80].getTransformedByOperation(_n75);

                e.splice.apply(e, [_t80, 1].concat(_toConsumableArray(_i54))), _t80 += _i54.length - 1;
              }
            }
          } catch (err) {
            _didIteratorError91 = true;
            _iteratorError91 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion91 && _iterator91.return != null) {
                _iterator91.return();
              }
            } finally {
              if (_didIteratorError91) {
                throw _iteratorError91;
              }
            }
          }

          for (var _t78 = 0; _t78 < e.length; _t78++) {
            var _n74 = e[_t78];

            for (var _i53 = _t78 + 1; _i53 < e.length; _i53++) {
              var _t79 = e[_i53];
              (_n74.containsRange(_t79) || _t79.containsRange(_n74) || _n74.isEqual(_t79)) && e.splice(_i53, 1);
            }
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.start, this.end);
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return this._getTransformedByInsertion(t.position, t.howMany, e);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.sourcePosition,
              i = t.howMany,
              o = t.targetPosition;
          return this._getTransformedByMove(n, o, i, e);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = this.start._getTransformedBySplitOperation(t);

          var n = this.end._getTransformedBySplitOperation(t);

          return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new Js(e, n);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new Js(this.start);

          var e = this.start._getTransformedByMergeOperation(t),
              n = this.end._getTransformedByMergeOperation(t);

          return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = Ks._createAt(n), e.offset = 0) : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new Js(e, n)) : new Js(e, n);
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (n && this.containsPosition(t)) return [new Js(this.start, t), new Js(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
          {
            var _n76 = new Js(this.start, this.end);

            return _n76.start = _n76.start._getTransformedByInsertion(t, e), _n76.end = _n76.end._getTransformedByInsertion(t, e), [_n76];
          }
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          if (this.isCollapsed) {
            var _i55 = this.start._getTransformedByMove(t, e, n);

            return [new Js(_i55)];
          }

          var o = Js._createFromPositionAndShift(t, n),
              r = e._getTransformedByDeletion(t, n);

          if (this.containsPosition(e) && !i && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
            var _i56 = this.start._getTransformedByMove(t, e, n),
                _o33 = this.end._getTransformedByMove(t, e, n);

            return [new Js(_i56, _o33)];
          }

          var s;
          var a = this.getDifference(o);
          var c = null;
          var l = this.getIntersection(o);

          if (1 == a.length ? c = new Js(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (c = new Js(this.start, this.end._getTransformedByDeletion(t, n))), s = c ? c._getTransformedByInsertion(r, n, null !== l || i) : [], l) {
            var _t81 = new Js(l.start._getCombined(o.start, r), l.end._getCombined(o.start, r));

            2 == s.length ? s.splice(1, 0, _t81) : s.push(_t81);
          }

          return s;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = this.start._getTransformedByDeletion(t, e),
              i = this.end._getTransformedByDeletion(t, e);

          return null == n && null == i ? null : (null == n && (n = t), null == i && (i = t), new Js(n, i));
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return "same" == di(this.start.getParentPath(), this.end.getParentPath());
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
              i = t.getShiftedBy(e);
          return e > 0 ? new this(n, i) : new this(i, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return new this(Ks._createAt(t, 0), Ks._createAt(t, t.maxOffset));
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          return this._createFromPositionAndShift(Ks._createBefore(t), t.offsetSize);
        }
      }, {
        key: "_createFromRanges",
        value: function _createFromRanges(t) {
          if (0 === t.length) throw new Qn.b("range-create-from-ranges-empty-array: At least one range has to be passed.", null);
          if (1 == t.length) return t[0].clone();
          var e = t[0];
          t.sort(function (t, e) {
            return t.start.isAfter(e.start) ? 1 : -1;
          });
          var n = t.indexOf(e),
              i = new this(e.start, e.end);
          if (n > 0) for (var _e74 = n - 1; t[_e74].end.isEqual(i.start); _e74++) {
            i.start = Ks._createAt(t[_e74].start);
          }

          for (var _e75 = n + 1; _e75 < t.length && t[_e75].start.isEqual(i.end); _e75++) {
            i.end = Ks._createAt(t[_e75].end);
          }

          return i;
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new this(Ks.fromJSON(t.start, e), Ks.fromJSON(t.end, e));
        }
      }]);

      return Js;
    }();

    var Zs =
    /*#__PURE__*/
    function () {
      function Zs() {
        var _this41 = this;

        _classCallCheck(this, Zs);

        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", function (t, e) {
          if (e.viewPosition) return;

          var n = _this41._modelToViewMapping.get(e.modelPosition.parent);

          e.viewPosition = _this41._findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", function (t, e) {
          if (e.modelPosition) return;

          var n = _this41.findMappedViewAncestor(e.viewPosition),
              i = _this41._viewToModelMapping.get(n),
              o = _this41._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);

          e.modelPosition = Ks._createAt(i, o);
        }, {
          priority: "low"
        });
      }

      _createClass(Zs, [{
        key: "bindElements",
        value: function bindElements(t, e) {
          this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
        }
      }, {
        key: "unbindViewElement",
        value: function unbindViewElement(t) {
          var e = this.toModelElement(t);

          if (this._viewToModelMapping.delete(t), this._elementToMarkerNames.has(t)) {
            var _iteratorNormalCompletion92 = true;
            var _didIteratorError92 = false;
            var _iteratorError92 = undefined;

            try {
              for (var _iterator92 = this._elementToMarkerNames.get(t)[Symbol.iterator](), _step92; !(_iteratorNormalCompletion92 = (_step92 = _iterator92.next()).done); _iteratorNormalCompletion92 = true) {
                var _e76 = _step92.value;

                this._unboundMarkerNames.add(_e76);
              }
            } catch (err) {
              _didIteratorError92 = true;
              _iteratorError92 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion92 && _iterator92.return != null) {
                  _iterator92.return();
                }
              } finally {
                if (_didIteratorError92) {
                  throw _iteratorError92;
                }
              }
            }
          }

          this._modelToViewMapping.get(e) == t && this._modelToViewMapping.delete(e);
        }
      }, {
        key: "unbindModelElement",
        value: function unbindModelElement(t) {
          var e = this.toViewElement(t);
          this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
        }
      }, {
        key: "bindElementToMarker",
        value: function bindElementToMarker(t, e) {
          var n = this._markerNameToElements.get(e) || new Set();
          n.add(t);
          var i = this._elementToMarkerNames.get(t) || new Set();
          i.add(e), this._markerNameToElements.set(e, n), this._elementToMarkerNames.set(t, i);
        }
      }, {
        key: "unbindElementFromMarkerName",
        value: function unbindElementFromMarkerName(t, e) {
          var n = this._markerNameToElements.get(e);

          n && (n.delete(t), 0 == n.size && this._markerNameToElements.delete(e));

          var i = this._elementToMarkerNames.get(t);

          i && (i.delete(e), 0 == i.size && this._elementToMarkerNames.delete(t));
        }
      }, {
        key: "flushUnboundMarkerNames",
        value: function flushUnboundMarkerNames() {
          var t = Array.from(this._unboundMarkerNames);
          return this._unboundMarkerNames.clear(), t;
        }
      }, {
        key: "clearBindings",
        value: function clearBindings() {
          this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set();
        }
      }, {
        key: "toModelElement",
        value: function toModelElement(t) {
          return this._viewToModelMapping.get(t);
        }
      }, {
        key: "toViewElement",
        value: function toViewElement(t) {
          return this._modelToViewMapping.get(t);
        }
      }, {
        key: "toModelRange",
        value: function toModelRange(t) {
          return new Js(this.toModelPosition(t.start), this.toModelPosition(t.end));
        }
      }, {
        key: "toViewRange",
        value: function toViewRange(t) {
          return new to(this.toViewPosition(t.start), this.toViewPosition(t.end));
        }
      }, {
        key: "toModelPosition",
        value: function toModelPosition(t) {
          var e = {
            viewPosition: t,
            mapper: this
          };
          return this.fire("viewToModelPosition", e), e.modelPosition;
        }
      }, {
        key: "toViewPosition",
        value: function toViewPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            isPhantom: !1
          };
          var n = {
            modelPosition: t,
            mapper: this,
            isPhantom: e.isPhantom
          };
          return this.fire("modelToViewPosition", n), n.viewPosition;
        }
      }, {
        key: "markerNameToElements",
        value: function markerNameToElements(t) {
          var e = this._markerNameToElements.get(t);

          if (!e) return null;
          var n = new Set();
          var _iteratorNormalCompletion93 = true;
          var _didIteratorError93 = false;
          var _iteratorError93 = undefined;

          try {
            for (var _iterator93 = e[Symbol.iterator](), _step93; !(_iteratorNormalCompletion93 = (_step93 = _iterator93.next()).done); _iteratorNormalCompletion93 = true) {
              var _t82 = _step93.value;

              if (_t82.is("attributeElement")) {
                var _iteratorNormalCompletion94 = true;
                var _didIteratorError94 = false;
                var _iteratorError94 = undefined;

                try {
                  for (var _iterator94 = _t82.getElementsWithSameId()[Symbol.iterator](), _step94; !(_iteratorNormalCompletion94 = (_step94 = _iterator94.next()).done); _iteratorNormalCompletion94 = true) {
                    var _e77 = _step94.value;
                    n.add(_e77);
                  }
                } catch (err) {
                  _didIteratorError94 = true;
                  _iteratorError94 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion94 && _iterator94.return != null) {
                      _iterator94.return();
                    }
                  } finally {
                    if (_didIteratorError94) {
                      throw _iteratorError94;
                    }
                  }
                }
              } else n.add(_t82);
            }
          } catch (err) {
            _didIteratorError93 = true;
            _iteratorError93 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion93 && _iterator93.return != null) {
                _iterator93.return();
              }
            } finally {
              if (_didIteratorError93) {
                throw _iteratorError93;
              }
            }
          }

          return n;
        }
      }, {
        key: "registerViewToModelLength",
        value: function registerViewToModelLength(t, e) {
          this._viewToModelLengthCallbacks.set(t, e);
        }
      }, {
        key: "findMappedViewAncestor",
        value: function findMappedViewAncestor(t) {
          var e = t.parent;

          for (; !this._viewToModelMapping.has(e);) {
            e = e.parent;
          }

          return e;
        }
      }, {
        key: "_toModelOffset",
        value: function _toModelOffset(t, e, n) {
          if (n != t) {
            return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
          }

          if (t.is("text")) return e;
          var i = 0;

          for (var _n77 = 0; _n77 < e; _n77++) {
            i += this.getModelLength(t.getChild(_n77));
          }

          return i;
        }
      }, {
        key: "getModelLength",
        value: function getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name)) {
            return this._viewToModelLengthCallbacks.get(t.name)(t);
          }

          if (this._viewToModelMapping.has(t)) return 1;
          if (t.is("text")) return t.data.length;
          if (t.is("uiElement")) return 0;
          {
            var _e78 = 0;
            var _iteratorNormalCompletion95 = true;
            var _didIteratorError95 = false;
            var _iteratorError95 = undefined;

            try {
              for (var _iterator95 = t.getChildren()[Symbol.iterator](), _step95; !(_iteratorNormalCompletion95 = (_step95 = _iterator95.next()).done); _iteratorNormalCompletion95 = true) {
                var _n78 = _step95.value;
                _e78 += this.getModelLength(_n78);
              }
            } catch (err) {
              _didIteratorError95 = true;
              _iteratorError95 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion95 && _iterator95.return != null) {
                  _iterator95.return();
                }
              } finally {
                if (_didIteratorError95) {
                  throw _iteratorError95;
                }
              }
            }

            return _e78;
          }
        }
      }, {
        key: "_findPositionIn",
        value: function _findPositionIn(t, e) {
          var n,
              i = 0,
              o = 0,
              r = 0;
          if (t.is("text")) return new Xi(t, e);

          for (; o < e;) {
            n = t.getChild(r), i = this.getModelLength(n), o += i, r++;
          }

          return o == e ? this._moveViewPositionToTextNode(new Xi(t, r)) : this._findPositionIn(n, e - (o - i));
        }
      }, {
        key: "_moveViewPositionToTextNode",
        value: function _moveViewPositionToTextNode(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          return e instanceof gi ? new Xi(e, e.data.length) : n instanceof gi ? new Xi(n, 0) : t;
        }
      }]);

      return Zs;
    }();

    li(Zs, ni);

    var Xs =
    /*#__PURE__*/
    function () {
      function Xs() {
        _classCallCheck(this, Xs);

        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }

      _createClass(Xs, [{
        key: "add",
        value: function add(t, e) {
          e = ta(e), t instanceof qs && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return e = ta(e), t instanceof qs && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
        }
      }, {
        key: "test",
        value: function test(t, e) {
          e = ta(e), t instanceof qs && (t = this._getSymbolForTextProxy(t));

          var n = this._consumable.get(t);

          if (void 0 === n) return null;
          var i = n.get(e);
          return void 0 === i ? null : i;
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          e = ta(e), t instanceof qs && (t = this._getSymbolForTextProxy(t));
          var n = this.test(t, e);
          return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
        }
      }, {
        key: "_getSymbolForTextProxy",
        value: function _getSymbolForTextProxy(t) {
          var e = null;

          var n = this._textProxyRegistry.get(t.startOffset);

          if (n) {
            var _i57 = n.get(t.endOffset);

            _i57 && (e = _i57.get(t.parent));
          }

          return e || (e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent)), e;
        }
      }, {
        key: "_addSymbolForTextProxy",
        value: function _addSymbolForTextProxy(t, e, n) {
          var i = Symbol("textProxySymbol");
          var o, r;
          return o = this._textProxyRegistry.get(t), o || (o = new Map(), this._textProxyRegistry.set(t, o)), r = o.get(e), r || (r = new Map(), o.set(e, r)), r.set(n, i), i;
        }
      }]);

      return Xs;
    }();

    function ta(t) {
      var e = t.split(":");
      return e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }

    var ea =
    /*#__PURE__*/
    function () {
      function ea(t) {
        _classCallCheck(this, ea);

        this.conversionApi = ji({
          dispatcher: this
        }, t);
      }

      _createClass(ea, [{
        key: "convertChanges",
        value: function convertChanges(t, e, n) {
          var _iteratorNormalCompletion96 = true;
          var _didIteratorError96 = false;
          var _iteratorError96 = undefined;

          try {
            for (var _iterator96 = t.getMarkersToRemove()[Symbol.iterator](), _step96; !(_iteratorNormalCompletion96 = (_step96 = _iterator96.next()).done); _iteratorNormalCompletion96 = true) {
              var _e79 = _step96.value;
              this.convertMarkerRemove(_e79.name, _e79.range, n);
            }
          } catch (err) {
            _didIteratorError96 = true;
            _iteratorError96 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion96 && _iterator96.return != null) {
                _iterator96.return();
              }
            } finally {
              if (_didIteratorError96) {
                throw _iteratorError96;
              }
            }
          }

          var _iteratorNormalCompletion97 = true;
          var _didIteratorError97 = false;
          var _iteratorError97 = undefined;

          try {
            for (var _iterator97 = t.getChanges()[Symbol.iterator](), _step97; !(_iteratorNormalCompletion97 = (_step97 = _iterator97.next()).done); _iteratorNormalCompletion97 = true) {
              var _e80 = _step97.value;
              "insert" == _e80.type ? this.convertInsert(Js._createFromPositionAndShift(_e80.position, _e80.length), n) : "remove" == _e80.type ? this.convertRemove(_e80.position, _e80.length, _e80.name, n) : this.convertAttribute(_e80.range, _e80.attributeKey, _e80.attributeOldValue, _e80.attributeNewValue, n);
            }
          } catch (err) {
            _didIteratorError97 = true;
            _iteratorError97 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion97 && _iterator97.return != null) {
                _iterator97.return();
              }
            } finally {
              if (_didIteratorError97) {
                throw _iteratorError97;
              }
            }
          }

          var _iteratorNormalCompletion98 = true;
          var _didIteratorError98 = false;
          var _iteratorError98 = undefined;

          try {
            for (var _iterator98 = this.conversionApi.mapper.flushUnboundMarkerNames()[Symbol.iterator](), _step98; !(_iteratorNormalCompletion98 = (_step98 = _iterator98.next()).done); _iteratorNormalCompletion98 = true) {
              var _t83 = _step98.value;

              var _i58 = e.get(_t83).getRange();

              this.convertMarkerRemove(_t83, _i58, n), this.convertMarkerAdd(_t83, _i58, n);
            }
          } catch (err) {
            _didIteratorError98 = true;
            _iteratorError98 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion98 && _iterator98.return != null) {
                _iterator98.return();
              }
            } finally {
              if (_didIteratorError98) {
                throw _iteratorError98;
              }
            }
          }

          var _iteratorNormalCompletion99 = true;
          var _didIteratorError99 = false;
          var _iteratorError99 = undefined;

          try {
            for (var _iterator99 = t.getMarkersToAdd()[Symbol.iterator](), _step99; !(_iteratorNormalCompletion99 = (_step99 = _iterator99.next()).done); _iteratorNormalCompletion99 = true) {
              var _e81 = _step99.value;
              this.convertMarkerAdd(_e81.name, _e81.range, n);
            }
          } catch (err) {
            _didIteratorError99 = true;
            _iteratorError99 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion99 && _iterator99.return != null) {
                _iterator99.return();
              }
            } finally {
              if (_didIteratorError99) {
                throw _iteratorError99;
              }
            }
          }
        }
      }, {
        key: "convertInsert",
        value: function convertInsert(t, e) {
          this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(t);
          var _iteratorNormalCompletion100 = true;
          var _didIteratorError100 = false;
          var _iteratorError100 = undefined;

          try {
            for (var _iterator100 = t[Symbol.iterator](), _step100; !(_iteratorNormalCompletion100 = (_step100 = _iterator100.next()).done); _iteratorNormalCompletion100 = true) {
              var _e82 = _step100.value;
              var _t84 = _e82.item,
                  _n79 = {
                item: _t84,
                range: Js._createFromPositionAndShift(_e82.previousPosition, _e82.length)
              };

              this._testAndFire("insert", _n79);

              var _iteratorNormalCompletion101 = true;
              var _didIteratorError101 = false;
              var _iteratorError101 = undefined;

              try {
                for (var _iterator101 = _t84.getAttributeKeys()[Symbol.iterator](), _step101; !(_iteratorNormalCompletion101 = (_step101 = _iterator101.next()).done); _iteratorNormalCompletion101 = true) {
                  var _e83 = _step101.value;
                  _n79.attributeKey = _e83, _n79.attributeOldValue = null, _n79.attributeNewValue = _t84.getAttribute(_e83), this._testAndFire("attribute:".concat(_e83), _n79);
                }
              } catch (err) {
                _didIteratorError101 = true;
                _iteratorError101 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion101 && _iterator101.return != null) {
                    _iterator101.return();
                  }
                } finally {
                  if (_didIteratorError101) {
                    throw _iteratorError101;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError100 = true;
            _iteratorError100 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion100 && _iterator100.return != null) {
                _iterator100.return();
              }
            } finally {
              if (_didIteratorError100) {
                throw _iteratorError100;
              }
            }
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertRemove",
        value: function convertRemove(t, e, n, i) {
          this.conversionApi.writer = i, this.fire("remove:" + n, {
            position: t,
            length: e
          }, this.conversionApi), this._clearConversionApi();
        }
      }, {
        key: "convertAttribute",
        value: function convertAttribute(t, e, n, i, o) {
          this.conversionApi.writer = o, this.conversionApi.consumable = this._createConsumableForRange(t, "attribute:".concat(e));
          var _iteratorNormalCompletion102 = true;
          var _didIteratorError102 = false;
          var _iteratorError102 = undefined;

          try {
            for (var _iterator102 = t[Symbol.iterator](), _step102; !(_iteratorNormalCompletion102 = (_step102 = _iterator102.next()).done); _iteratorNormalCompletion102 = true) {
              var _o34 = _step102.value;
              var _t85 = {
                item: _o34.item,
                range: Js._createFromPositionAndShift(_o34.previousPosition, _o34.length),
                attributeKey: e,
                attributeOldValue: n,
                attributeNewValue: i
              };

              this._testAndFire("attribute:".concat(e), _t85);
            }
          } catch (err) {
            _didIteratorError102 = true;
            _iteratorError102 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion102 && _iterator102.return != null) {
                _iterator102.return();
              }
            } finally {
              if (_didIteratorError102) {
                throw _iteratorError102;
              }
            }
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertSelection",
        value: function convertSelection(t, e, n) {
          var i = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));

          if (this.conversionApi.writer = n, this.conversionApi.consumable = this._createSelectionConsumable(t, i), this.fire("selection", {
            selection: t
          }, this.conversionApi), t.isCollapsed) {
            var _iteratorNormalCompletion103 = true;
            var _didIteratorError103 = false;
            var _iteratorError103 = undefined;

            try {
              for (var _iterator103 = i[Symbol.iterator](), _step103; !(_iteratorNormalCompletion103 = (_step103 = _iterator103.next()).done); _iteratorNormalCompletion103 = true) {
                var _e84 = _step103.value;

                var _n80 = _e84.getRange();

                if (!na(t.getFirstPosition(), _e84, this.conversionApi.mapper)) continue;
                var _i59 = {
                  item: t,
                  markerName: _e84.name,
                  markerRange: _n80
                };
                this.conversionApi.consumable.test(t, "addMarker:" + _e84.name) && this.fire("addMarker:" + _e84.name, _i59, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError103 = true;
              _iteratorError103 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion103 && _iterator103.return != null) {
                  _iterator103.return();
                }
              } finally {
                if (_didIteratorError103) {
                  throw _iteratorError103;
                }
              }
            }

            var _iteratorNormalCompletion104 = true;
            var _didIteratorError104 = false;
            var _iteratorError104 = undefined;

            try {
              for (var _iterator104 = t.getAttributeKeys()[Symbol.iterator](), _step104; !(_iteratorNormalCompletion104 = (_step104 = _iterator104.next()).done); _iteratorNormalCompletion104 = true) {
                var _e85 = _step104.value;
                var _n81 = {
                  item: t,
                  range: t.getFirstRange(),
                  attributeKey: _e85,
                  attributeOldValue: null,
                  attributeNewValue: t.getAttribute(_e85)
                };
                this.conversionApi.consumable.test(t, "attribute:" + _n81.attributeKey) && this.fire("attribute:" + _n81.attributeKey + ":$text", _n81, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError104 = true;
              _iteratorError104 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion104 && _iterator104.return != null) {
                  _iterator104.return();
                }
              } finally {
                if (_didIteratorError104) {
                  throw _iteratorError104;
                }
              }
            }

            this._clearConversionApi();
          }
        }
      }, {
        key: "convertMarkerAdd",
        value: function convertMarkerAdd(t, e, n) {
          if (!e.root.document || "$graveyard" == e.root.rootName) return;
          this.conversionApi.writer = n;
          var i = "addMarker:" + t,
              o = new Xs();

          if (o.add(e, i), this.conversionApi.consumable = o, this.fire(i, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), o.test(e, i)) {
            this.conversionApi.consumable = this._createConsumableForRange(e, i);
            var _iteratorNormalCompletion105 = true;
            var _didIteratorError105 = false;
            var _iteratorError105 = undefined;

            try {
              for (var _iterator105 = e.getItems()[Symbol.iterator](), _step105; !(_iteratorNormalCompletion105 = (_step105 = _iterator105.next()).done); _iteratorNormalCompletion105 = true) {
                var _n82 = _step105.value;
                if (!this.conversionApi.consumable.test(_n82, i)) continue;
                var _o35 = {
                  item: _n82,
                  range: Js._createOn(_n82),
                  markerName: t,
                  markerRange: e
                };
                this.fire(i, _o35, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError105 = true;
              _iteratorError105 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion105 && _iterator105.return != null) {
                  _iterator105.return();
                }
              } finally {
                if (_didIteratorError105) {
                  throw _iteratorError105;
                }
              }
            }

            this._clearConversionApi();
          }
        }
      }, {
        key: "convertMarkerRemove",
        value: function convertMarkerRemove(t, e, n) {
          e.root.document && "$graveyard" != e.root.rootName && (this.conversionApi.writer = n, this.fire("removeMarker:" + t, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), this._clearConversionApi());
        }
      }, {
        key: "_createInsertConsumable",
        value: function _createInsertConsumable(t) {
          var e = new Xs();
          var _iteratorNormalCompletion106 = true;
          var _didIteratorError106 = false;
          var _iteratorError106 = undefined;

          try {
            for (var _iterator106 = t[Symbol.iterator](), _step106; !(_iteratorNormalCompletion106 = (_step106 = _iterator106.next()).done); _iteratorNormalCompletion106 = true) {
              var _n83 = _step106.value;
              var _t86 = _n83.item;
              e.add(_t86, "insert");
              var _iteratorNormalCompletion107 = true;
              var _didIteratorError107 = false;
              var _iteratorError107 = undefined;

              try {
                for (var _iterator107 = _t86.getAttributeKeys()[Symbol.iterator](), _step107; !(_iteratorNormalCompletion107 = (_step107 = _iterator107.next()).done); _iteratorNormalCompletion107 = true) {
                  var _n84 = _step107.value;
                  e.add(_t86, "attribute:" + _n84);
                }
              } catch (err) {
                _didIteratorError107 = true;
                _iteratorError107 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion107 && _iterator107.return != null) {
                    _iterator107.return();
                  }
                } finally {
                  if (_didIteratorError107) {
                    throw _iteratorError107;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError106 = true;
            _iteratorError106 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion106 && _iterator106.return != null) {
                _iterator106.return();
              }
            } finally {
              if (_didIteratorError106) {
                throw _iteratorError106;
              }
            }
          }

          return e;
        }
      }, {
        key: "_createConsumableForRange",
        value: function _createConsumableForRange(t, e) {
          var n = new Xs();
          var _iteratorNormalCompletion108 = true;
          var _didIteratorError108 = false;
          var _iteratorError108 = undefined;

          try {
            for (var _iterator108 = t.getItems()[Symbol.iterator](), _step108; !(_iteratorNormalCompletion108 = (_step108 = _iterator108.next()).done); _iteratorNormalCompletion108 = true) {
              var _i60 = _step108.value;
              n.add(_i60, e);
            }
          } catch (err) {
            _didIteratorError108 = true;
            _iteratorError108 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion108 && _iterator108.return != null) {
                _iterator108.return();
              }
            } finally {
              if (_didIteratorError108) {
                throw _iteratorError108;
              }
            }
          }

          return n;
        }
      }, {
        key: "_createSelectionConsumable",
        value: function _createSelectionConsumable(t, e) {
          var n = new Xs();
          n.add(t, "selection");
          var _iteratorNormalCompletion109 = true;
          var _didIteratorError109 = false;
          var _iteratorError109 = undefined;

          try {
            for (var _iterator109 = e[Symbol.iterator](), _step109; !(_iteratorNormalCompletion109 = (_step109 = _iterator109.next()).done); _iteratorNormalCompletion109 = true) {
              var _i61 = _step109.value;
              n.add(t, "addMarker:" + _i61.name);
            }
          } catch (err) {
            _didIteratorError109 = true;
            _iteratorError109 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion109 && _iterator109.return != null) {
                _iterator109.return();
              }
            } finally {
              if (_didIteratorError109) {
                throw _iteratorError109;
              }
            }
          }

          var _iteratorNormalCompletion110 = true;
          var _didIteratorError110 = false;
          var _iteratorError110 = undefined;

          try {
            for (var _iterator110 = t.getAttributeKeys()[Symbol.iterator](), _step110; !(_iteratorNormalCompletion110 = (_step110 = _iterator110.next()).done); _iteratorNormalCompletion110 = true) {
              var _e86 = _step110.value;
              n.add(t, "attribute:" + _e86);
            }
          } catch (err) {
            _didIteratorError110 = true;
            _iteratorError110 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion110 && _iterator110.return != null) {
                _iterator110.return();
              }
            } finally {
              if (_didIteratorError110) {
                throw _iteratorError110;
              }
            }
          }

          return n;
        }
      }, {
        key: "_testAndFire",
        value: function _testAndFire(t, e) {
          if (!this.conversionApi.consumable.test(e.item, t)) return;
          var n = e.item.name || "$text";
          this.fire(t + ":" + n, e, this.conversionApi);
        }
      }, {
        key: "_clearConversionApi",
        value: function _clearConversionApi() {
          delete this.conversionApi.writer, delete this.conversionApi.consumable;
        }
      }]);

      return ea;
    }();

    function na(t, e, n) {
      var i = e.getRange(),
          o = Array.from(t.getAncestors());
      return o.shift(), o.reverse(), !o.some(function (t) {
        if (i.containsItem(t)) {
          return !!n.toViewElement(t).getCustomProperty("addHighlight");
        }
      });
    }

    li(ea, ni);

    var ia =
    /*#__PURE__*/
    function () {
      function ia(t, e, n) {
        _classCallCheck(this, ia);

        this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), t && this.setTo(t, e, n);
      }

      _createClass(ia, [{
        key: "isEqual",
        value: function isEqual(t) {
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
          var _iteratorNormalCompletion111 = true;
          var _didIteratorError111 = false;
          var _iteratorError111 = undefined;

          try {
            for (var _iterator111 = this._ranges[Symbol.iterator](), _step111; !(_iteratorNormalCompletion111 = (_step111 = _iterator111.next()).done); _iteratorNormalCompletion111 = true) {
              var _e87 = _step111.value;

              var _n85 = !1;

              var _iteratorNormalCompletion112 = true;
              var _didIteratorError112 = false;
              var _iteratorError112 = undefined;

              try {
                for (var _iterator112 = t._ranges[Symbol.iterator](), _step112; !(_iteratorNormalCompletion112 = (_step112 = _iterator112.next()).done); _iteratorNormalCompletion112 = true) {
                  var _i62 = _step112.value;

                  if (_e87.isEqual(_i62)) {
                    _n85 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError112 = true;
                _iteratorError112 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion112 && _iterator112.return != null) {
                    _iterator112.return();
                  }
                } finally {
                  if (_didIteratorError112) {
                    throw _iteratorError112;
                  }
                }
              }

              if (!_n85) return !1;
            }
          } catch (err) {
            _didIteratorError111 = true;
            _iteratorError111 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion111 && _iterator111.return != null) {
                _iterator111.return();
              }
            } finally {
              if (_didIteratorError111) {
                throw _iteratorError111;
              }
            }
          }

          return !0;
        }
      }, {
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          var _iteratorNormalCompletion113, _didIteratorError113, _iteratorError113, _iterator113, _step113, _t87;

          return _regeneratorRuntime.wrap(function getRanges$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _iteratorNormalCompletion113 = true;
                  _didIteratorError113 = false;
                  _iteratorError113 = undefined;
                  _context14.prev = 3;
                  _iterator113 = this._ranges[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion113 = (_step113 = _iterator113.next()).done) {
                    _context14.next = 12;
                    break;
                  }

                  _t87 = _step113.value;
                  _context14.next = 9;
                  return new Js(_t87.start, _t87.end);

                case 9:
                  _iteratorNormalCompletion113 = true;
                  _context14.next = 5;
                  break;

                case 12:
                  _context14.next = 18;
                  break;

                case 14:
                  _context14.prev = 14;
                  _context14.t0 = _context14["catch"](3);
                  _didIteratorError113 = true;
                  _iteratorError113 = _context14.t0;

                case 18:
                  _context14.prev = 18;
                  _context14.prev = 19;

                  if (!_iteratorNormalCompletion113 && _iterator113.return != null) {
                    _iterator113.return();
                  }

                case 21:
                  _context14.prev = 21;

                  if (!_didIteratorError113) {
                    _context14.next = 24;
                    break;
                  }

                  throw _iteratorError113;

                case 24:
                  return _context14.finish(21);

                case 25:
                  return _context14.finish(18);

                case 26:
                case "end":
                  return _context14.stop();
              }
            }
          }, getRanges, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iteratorNormalCompletion114 = true;
          var _didIteratorError114 = false;
          var _iteratorError114 = undefined;

          try {
            for (var _iterator114 = this._ranges[Symbol.iterator](), _step114; !(_iteratorNormalCompletion114 = (_step114 = _iterator114.next()).done); _iteratorNormalCompletion114 = true) {
              var _e88 = _step114.value;
              t && !_e88.start.isBefore(t.start) || (t = _e88);
            }
          } catch (err) {
            _didIteratorError114 = true;
            _iteratorError114 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion114 && _iterator114.return != null) {
                _iterator114.return();
              }
            } finally {
              if (_didIteratorError114) {
                throw _iteratorError114;
              }
            }
          }

          return t ? new Js(t.start, t.end) : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iteratorNormalCompletion115 = true;
          var _didIteratorError115 = false;
          var _iteratorError115 = undefined;

          try {
            for (var _iterator115 = this._ranges[Symbol.iterator](), _step115; !(_iteratorNormalCompletion115 = (_step115 = _iterator115.next()).done); _iteratorNormalCompletion115 = true) {
              var _e89 = _step115.value;
              t && !_e89.end.isAfter(t.end) || (t = _e89);
            }
          } catch (err) {
            _didIteratorError115 = true;
            _iteratorError115 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion115 && _iterator115.return != null) {
                _iterator115.return();
              }
            } finally {
              if (_didIteratorError115) {
                throw _iteratorError115;
              }
            }
          }

          return t ? new Js(t.start, t.end) : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]);else if (t instanceof ia) this._setRanges(t.getRanges(), t.isBackward);else if (t && "function" == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof Js) this._setRanges([t], !!e && !!e.backward);else if (t instanceof Ks) this._setRanges([new Js(t)]);else if (t instanceof Us) {
            var _i63 = !!n && !!n.backward;

            var _o36;

            if ("in" == e) _o36 = Js._createIn(t);else if ("on" == e) _o36 = Js._createOn(t);else {
              if (void 0 === e) throw new Qn.b("model-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", [this, t]);
              _o36 = new Js(Ks._createAt(t, e));
            }

            this._setRanges([_o36], _i63);
          } else {
            if (!bi(t)) throw new Qn.b("model-selection-setTo-not-selectable: Cannot set the selection to the given place.", [this, t]);

            this._setRanges(t, e && !!e.backward);
          }
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var _this42 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = (t = Array.from(t)).some(function (e) {
            if (!(e instanceof Js)) throw new Qn.b("model-selection-set-ranges-not-range: Selection range set to an object that is not an instance of model.Range.", [_this42, t]);
            return _this42._ranges.every(function (t) {
              return !t.isEqual(e);
            });
          });

          if (t.length !== this._ranges.length || n) {
            this._removeAllRanges();

            var _iteratorNormalCompletion116 = true;
            var _didIteratorError116 = false;
            var _iteratorError116 = undefined;

            try {
              for (var _iterator116 = t[Symbol.iterator](), _step116; !(_iteratorNormalCompletion116 = (_step116 = _iterator116.next()).done); _iteratorNormalCompletion116 = true) {
                var _e90 = _step116.value;

                this._pushRange(_e90);
              }
            } catch (err) {
              _didIteratorError116 = true;
              _iteratorError116 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion116 && _iterator116.return != null) {
                  _iterator116.return();
                }
              } finally {
                if (_didIteratorError116) {
                  throw _iteratorError116;
                }
              }
            }

            this._lastRangeBackward = !!e, this.fire("change:range", {
              directChange: !0
            });
          }
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new Qn.b("model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", [this, t]);

          var n = Ks._createAt(t, e);

          if ("same" == n.compareWith(this.focus)) return;
          var i = this.anchor;
          this._ranges.length && this._popRange(), "before" == n.compareWith(i) ? (this._pushRange(new Js(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new Js(i, n)), this._lastRangeBackward = !1), this.fire("change:range", {
            directChange: !0
          });
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (1 !== this.rangeCount) return null;
          var t = this.getFirstRange(),
              e = t.start.nodeAfter,
              n = t.end.nodeBefore;
          return e instanceof Ys && e == n ? e : null;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "model:selection" == t;
        }
      }, {
        key: "getSelectedBlocks",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getSelectedBlocks() {
          var t, _iteratorNormalCompletion117, _didIteratorError117, _iteratorError117, _iterator117, _step117, _e91, _n86, _iteratorNormalCompletion118, _didIteratorError118, _iteratorError118, _iterator118, _step118, _n87, _i65, _i64;

          return _regeneratorRuntime.wrap(function getSelectedBlocks$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  t = new WeakSet();
                  _iteratorNormalCompletion117 = true;
                  _didIteratorError117 = false;
                  _iteratorError117 = undefined;
                  _context15.prev = 4;
                  _iterator117 = this.getRanges()[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion117 = (_step117 = _iterator117.next()).done) {
                    _context15.next = 50;
                    break;
                  }

                  _e91 = _step117.value;
                  _n86 = sa(_e91.start, t);
                  _context15.t0 = _n86 && aa(_n86, _e91);

                  if (!_context15.t0) {
                    _context15.next = 13;
                    break;
                  }

                  _context15.next = 13;
                  return _n86;

                case 13:
                  _iteratorNormalCompletion118 = true;
                  _didIteratorError118 = false;
                  _iteratorError118 = undefined;
                  _context15.prev = 16;
                  _iterator118 = _e91.getWalker()[Symbol.iterator]();

                case 18:
                  if (_iteratorNormalCompletion118 = (_step118 = _iterator118.next()).done) {
                    _context15.next = 28;
                    break;
                  }

                  _n87 = _step118.value;
                  _i65 = _n87.item;
                  _context15.t1 = "elementEnd" == _n87.type && ra(_i65, t, _e91);

                  if (!_context15.t1) {
                    _context15.next = 25;
                    break;
                  }

                  _context15.next = 25;
                  return _i65;

                case 25:
                  _iteratorNormalCompletion118 = true;
                  _context15.next = 18;
                  break;

                case 28:
                  _context15.next = 34;
                  break;

                case 30:
                  _context15.prev = 30;
                  _context15.t2 = _context15["catch"](16);
                  _didIteratorError118 = true;
                  _iteratorError118 = _context15.t2;

                case 34:
                  _context15.prev = 34;
                  _context15.prev = 35;

                  if (!_iteratorNormalCompletion118 && _iterator118.return != null) {
                    _iterator118.return();
                  }

                case 37:
                  _context15.prev = 37;

                  if (!_didIteratorError118) {
                    _context15.next = 40;
                    break;
                  }

                  throw _iteratorError118;

                case 40:
                  return _context15.finish(37);

                case 41:
                  return _context15.finish(34);

                case 42:
                  _i64 = sa(_e91.end, t);
                  _context15.t3 = _i64 && !_e91.end.isTouching(Ks._createAt(_i64, 0)) && aa(_i64, _e91);

                  if (!_context15.t3) {
                    _context15.next = 47;
                    break;
                  }

                  _context15.next = 47;
                  return _i64;

                case 47:
                  _iteratorNormalCompletion117 = true;
                  _context15.next = 6;
                  break;

                case 50:
                  _context15.next = 56;
                  break;

                case 52:
                  _context15.prev = 52;
                  _context15.t4 = _context15["catch"](4);
                  _didIteratorError117 = true;
                  _iteratorError117 = _context15.t4;

                case 56:
                  _context15.prev = 56;
                  _context15.prev = 57;

                  if (!_iteratorNormalCompletion117 && _iterator117.return != null) {
                    _iterator117.return();
                  }

                case 59:
                  _context15.prev = 59;

                  if (!_didIteratorError117) {
                    _context15.next = 62;
                    break;
                  }

                  throw _iteratorError117;

                case 62:
                  return _context15.finish(59);

                case 63:
                  return _context15.finish(56);

                case 64:
                case "end":
                  return _context15.stop();
              }
            }
          }, getSelectedBlocks, this, [[4, 52, 56, 64], [16, 30, 34, 42], [35,, 37, 41], [57,, 59, 63]]);
        })
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;

          var e = Ks._createAt(t, 0),
              n = Ks._createAt(t, "end");

          return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          this._checkRange(t), this._ranges.push(new Js(t.start, t.end));
        }
      }, {
        key: "_checkRange",
        value: function _checkRange(t) {
          for (var _e92 = 0; _e92 < this._ranges.length; _e92++) {
            if (t.isIntersecting(this._ranges[_e92])) throw new Qn.b("model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.", [this, t], {
              addedRange: t,
              intersectingRange: this._ranges[_e92]
            });
          }
        }
      }, {
        key: "_removeAllRanges",
        value: function _removeAllRanges() {
          for (; this._ranges.length > 0;) {
            this._popRange();
          }
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop();
        }
      }, {
        key: "anchor",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t88 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t88.end : _t88.start;
          }

          return null;
        }
      }, {
        key: "focus",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t89 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t89.start : _t89.end;
          }

          return null;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this._ranges.length && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }]);

      return ia;
    }();

    function oa(t, e) {
      return !e.has(t) && (e.add(t), t.document.model.schema.isBlock(t) && t.parent);
    }

    function ra(t, e, n) {
      return oa(t, e) && aa(t, n);
    }

    function sa(t, e) {
      var n = t.parent.document.model.schema,
          i = t.parent.getAncestors({
        parentFirst: !0,
        includeSelf: !0
      });
      var o = !1;
      var r = i.find(function (t) {
        return !o && (o = n.isLimit(t), !o && oa(t, e));
      });
      return i.forEach(function (t) {
        return e.add(t);
      }), r;
    }

    function aa(t, e) {
      var n = function (t) {
        var e = t.document.model.schema;
        var n = t.parent;

        for (; n;) {
          if (e.isBlock(n)) return n;
          n = n.parent;
        }
      }(t);

      return !n || !e.containsRange(Js._createOn(n), !0);
    }

    li(ia, ni);

    var ca =
    /*#__PURE__*/
    function (_Js) {
      _inherits(ca, _Js);

      function ca(t, e) {
        var _this43;

        _classCallCheck(this, ca);

        _this43 = _possibleConstructorReturn(this, _getPrototypeOf(ca).call(this, t, e)), la.call(_assertThisInitialized(_this43));
        return _this43;
      }

      _createClass(ca, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "liveRange" == t || "model:liveRange" == t || _get(_getPrototypeOf(ca.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toRange",
        value: function toRange() {
          return new Js(this.start, this.end);
        }
      }], [{
        key: "fromRange",
        value: function fromRange(t) {
          return new ca(t.start, t.end);
        }
      }]);

      return ca;
    }(Js);

    function la() {
      var _this44 = this;

      this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
        var n = e[0];
        n.isDocumentOperation && da.call(_this44, n);
      }, {
        priority: "low"
      });
    }

    function da(t) {
      var e = this.getTransformedByOperation(t),
          n = Js._createFromRanges(e),
          i = !n.isEqual(this),
          o = function (t, e) {
        switch (e.type) {
          case "insert":
            return t.containsPosition(e.position);

          case "move":
          case "remove":
          case "reinsert":
          case "merge":
            return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);

          case "split":
            return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
        }

        return !1;
      }(this, t);

      var r = null;

      if (i) {
        "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);

        var _e93 = this.toRange();

        this.start = n.start, this.end = n.end, this.fire("change:range", _e93, {
          deletionPosition: r
        });
      } else o && this.fire("change:content", this.toRange(), {
        deletionPosition: r
      });
    }

    li(ca, ni);
    var ha = "selection:";

    var ua =
    /*#__PURE__*/
    function () {
      function ua(t) {
        _classCallCheck(this, ua);

        this._selection = new fa(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this);
      }

      _createClass(ua, [{
        key: "getRanges",
        value: function getRanges() {
          return this._selection.getRanges();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getSelectedBlocks",
        value: function getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent(t) {
          return this._selection.containsEntireContent(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._selection.destroy();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._selection.getAttributes();
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._selection.getAttribute(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._selection.hasAttribute(t);
        }
      }, {
        key: "refresh",
        value: function refresh() {
          this._selection._updateMarkers(), this._selection._updateAttributes(!1);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "model:selection" == t || "documentSelection" == t || "model:documentSelection" == t;
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._selection.setAttribute(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          this._selection.removeAttribute(t);
        }
      }, {
        key: "_getStoredAttributes",
        value: function _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          return this._selection.overrideGravity();
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity(t) {
          this._selection.restoreGravity(t);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._selection.hasOwnRange;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return this._selection.isGravityOverridden;
        }
      }, {
        key: "markers",
        get: function get() {
          return this._selection.markers;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }], [{
        key: "_getStoreAttributeKey",
        value: function _getStoreAttributeKey(t) {
          return ha + t;
        }
      }, {
        key: "_isStoreAttributeKey",
        value: function _isStoreAttributeKey(t) {
          return t.startsWith(ha);
        }
      }]);

      return ua;
    }();

    li(ua, ni);

    var fa =
    /*#__PURE__*/
    function (_ia) {
      _inherits(fa, _ia);

      function fa(t) {
        var _this45;

        _classCallCheck(this, fa);

        _this45 = _possibleConstructorReturn(this, _getPrototypeOf(fa).call(this)), _this45.markers = new ro({
          idProperty: "name"
        }), _this45._model = t.model, _this45._document = t, _this45._attributePriority = new Map(), _this45._fixGraveyardRangesData = [], _this45._hasChangedRange = !1, _this45._overriddenGravityRegister = new Set(), _this45.listenTo(_this45._model, "applyOperation", function (t, e) {
          var n = e[0];

          if (n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type) {
            for (; _this45._fixGraveyardRangesData.length;) {
              var _this45$_fixGraveyard = _this45._fixGraveyardRangesData.shift(),
                  _t90 = _this45$_fixGraveyard.liveRange,
                  _e94 = _this45$_fixGraveyard.sourcePosition;

              _this45._fixGraveyardSelection(_t90, _e94);
            }

            _this45._hasChangedRange && (_this45._hasChangedRange = !1, _this45.fire("change:range", {
              directChange: !1
            }));
          }
        }, {
          priority: "lowest"
        }), _this45.on("change:range", function () {
          var _iteratorNormalCompletion119 = true;
          var _didIteratorError119 = false;
          var _iteratorError119 = undefined;

          try {
            for (var _iterator119 = _this45.getRanges()[Symbol.iterator](), _step119; !(_iteratorNormalCompletion119 = (_step119 = _iterator119.next()).done); _iteratorNormalCompletion119 = true) {
              var _t91 = _step119.value;
              if (!_this45._document._validateSelectionRange(_t91)) throw new Qn.b("document-selection-wrong-position: Range from document selection starts or ends at incorrect position.", _assertThisInitialized(_this45), {
                range: _t91
              });
            }
          } catch (err) {
            _didIteratorError119 = true;
            _iteratorError119 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion119 && _iterator119.return != null) {
                _iterator119.return();
              }
            } finally {
              if (_didIteratorError119) {
                throw _iteratorError119;
              }
            }
          }
        }), _this45.listenTo(_this45._model.markers, "update", function () {
          return _this45._updateMarkers();
        }), _this45.listenTo(_this45._document, "change", function (t, e) {
          !function (t, e) {
            var n = t.document.differ;
            var _iteratorNormalCompletion120 = true;
            var _didIteratorError120 = false;
            var _iteratorError120 = undefined;

            try {
              var _loop2 = function _loop2() {
                var i = _step120.value;
                if ("insert" != i.type) return "continue";
                var n = i.position.parent;
                i.length === n.maxOffset && t.enqueueChange(e, function (t) {
                  var e = Array.from(n.getAttributeKeys()).filter(function (t) {
                    return t.startsWith(ha);
                  });
                  var _iteratorNormalCompletion121 = true;
                  var _didIteratorError121 = false;
                  var _iteratorError121 = undefined;

                  try {
                    for (var _iterator121 = e[Symbol.iterator](), _step121; !(_iteratorNormalCompletion121 = (_step121 = _iterator121.next()).done); _iteratorNormalCompletion121 = true) {
                      var _i66 = _step121.value;
                      t.removeAttribute(_i66, n);
                    }
                  } catch (err) {
                    _didIteratorError121 = true;
                    _iteratorError121 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion121 && _iterator121.return != null) {
                        _iterator121.return();
                      }
                    } finally {
                      if (_didIteratorError121) {
                        throw _iteratorError121;
                      }
                    }
                  }
                });
              };

              for (var _iterator120 = n.getChanges()[Symbol.iterator](), _step120; !(_iteratorNormalCompletion120 = (_step120 = _iterator120.next()).done); _iteratorNormalCompletion120 = true) {
                var _ret = _loop2();

                if (_ret === "continue") continue;
              }
            } catch (err) {
              _didIteratorError120 = true;
              _iteratorError120 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion120 && _iterator120.return != null) {
                  _iterator120.return();
                }
              } finally {
                if (_didIteratorError120) {
                  throw _iteratorError120;
                }
              }
            }
          }(_this45._model, e);
        });
        return _this45;
      }

      _createClass(fa, [{
        key: "destroy",
        value: function destroy() {
          for (var _t92 = 0; _t92 < this._ranges.length; _t92++) {
            this._ranges[_t92].detach();
          }

          this.stopListening();
        }
      }, {
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (!this._ranges.length) {
                    _context16.next = 4;
                    break;
                  }

                  return _context16.delegateYield(_get(_getPrototypeOf(fa.prototype), "getRanges", this).call(this), "t0", 2);

                case 2:
                  _context16.next = 6;
                  break;

                case 4:
                  _context16.next = 6;
                  return this._document._getDefaultRange();

                case 6:
                case "end":
                  return _context16.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return _get(_getPrototypeOf(fa.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return _get(_getPrototypeOf(fa.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          _get(_getPrototypeOf(fa.prototype), "setTo", this).call(this, t, e, n), this._updateAttributes(!0);
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          _get(_getPrototypeOf(fa.prototype), "setFocus", this).call(this, t, e), this._updateAttributes(!0);
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          if (this._setAttribute(t, e)) {
            var _e95 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e95,
              directChange: !0
            });
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          if (this._removeAttribute(t)) {
            var _e96 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e96,
              directChange: !0
            });
          }
        }
      }, {
        key: "overrideGravity",
        value: function overrideGravity() {
          var t = Zn();
          return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
        }
      }, {
        key: "restoreGravity",
        value: function restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t)) throw new Qn.b("document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.", this, {
            uid: t
          });
          this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop().detach();
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var e = this._prepareRange(t);

          e && this._ranges.push(e);
        }
      }, {
        key: "_prepareRange",
        value: function _prepareRange(t) {
          var _this46 = this;

          if (this._checkRange(t), t.root == this._document.graveyard) return;
          var e = ca.fromRange(t);
          return e.on("change:range", function (t, n, i) {
            _this46._hasChangedRange = !0, e.root == _this46._document.graveyard && _this46._fixGraveyardRangesData.push({
              liveRange: e,
              sourcePosition: i.deletionPosition
            });
          }), e;
        }
      }, {
        key: "_updateMarkers",
        value: function _updateMarkers() {
          var t = [];
          var _iteratorNormalCompletion122 = true;
          var _didIteratorError122 = false;
          var _iteratorError122 = undefined;

          try {
            for (var _iterator122 = this._model.markers[Symbol.iterator](), _step122; !(_iteratorNormalCompletion122 = (_step122 = _iterator122.next()).done); _iteratorNormalCompletion122 = true) {
              var _e97 = _step122.value;

              var _n88 = _e97.getRange();

              var _iteratorNormalCompletion123 = true;
              var _didIteratorError123 = false;
              var _iteratorError123 = undefined;

              try {
                for (var _iterator123 = this.getRanges()[Symbol.iterator](), _step123; !(_iteratorNormalCompletion123 = (_step123 = _iterator123.next()).done); _iteratorNormalCompletion123 = true) {
                  var _i69 = _step123.value;
                  _n88.containsRange(_i69, !_i69.isCollapsed) && t.push(_e97);
                }
              } catch (err) {
                _didIteratorError123 = true;
                _iteratorError123 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion123 && _iterator123.return != null) {
                    _iterator123.return();
                  }
                } finally {
                  if (_didIteratorError123) {
                    throw _iteratorError123;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError122 = true;
            _iteratorError122 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion122 && _iterator122.return != null) {
                _iterator122.return();
              }
            } finally {
              if (_didIteratorError122) {
                throw _iteratorError122;
              }
            }
          }

          for (var _i67 = 0, _t93 = t; _i67 < _t93.length; _i67++) {
            var _e98 = _t93[_i67];
            this.markers.has(_e98) || this.markers.add(_e98);
          }

          for (var _i68 = 0, _Array$from3 = Array.from(this.markers); _i68 < _Array$from3.length; _i68++) {
            var _e99 = _Array$from3[_i68];
            t.includes(_e99) || this.markers.remove(_e99);
          }
        }
      }, {
        key: "_updateAttributes",
        value: function _updateAttributes(t) {
          var e = Fs(this._getSurroundingAttributes()),
              n = Fs(this.getAttributes());
          if (t) this._attributePriority = new Map(), this._attrs = new Map();else {
            var _iteratorNormalCompletion124 = true;
            var _didIteratorError124 = false;
            var _iteratorError124 = undefined;

            try {
              for (var _iterator124 = this._attributePriority[Symbol.iterator](), _step124; !(_iteratorNormalCompletion124 = (_step124 = _iterator124.next()).done); _iteratorNormalCompletion124 = true) {
                var _ref25 = _step124.value;

                var _ref24 = _slicedToArray(_ref25, 2);

                var _t94 = _ref24[0];
                var _e100 = _ref24[1];
                "low" == _e100 && (this._attrs.delete(_t94), this._attributePriority.delete(_t94));
              }
            } catch (err) {
              _didIteratorError124 = true;
              _iteratorError124 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion124 && _iterator124.return != null) {
                  _iterator124.return();
                }
              } finally {
                if (_didIteratorError124) {
                  throw _iteratorError124;
                }
              }
            }
          }

          this._setAttributesTo(e);

          var i = [];
          var _iteratorNormalCompletion125 = true;
          var _didIteratorError125 = false;
          var _iteratorError125 = undefined;

          try {
            for (var _iterator125 = this.getAttributes()[Symbol.iterator](), _step125; !(_iteratorNormalCompletion125 = (_step125 = _iterator125.next()).done); _iteratorNormalCompletion125 = true) {
              var _ref30 = _step125.value;

              var _ref27 = _slicedToArray(_ref30, 2);

              var _t95 = _ref27[0];
              var _e101 = _ref27[1];
              n.has(_t95) && n.get(_t95) === _e101 || i.push(_t95);
            }
          } catch (err) {
            _didIteratorError125 = true;
            _iteratorError125 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion125 && _iterator125.return != null) {
                _iterator125.return();
              }
            } finally {
              if (_didIteratorError125) {
                throw _iteratorError125;
              }
            }
          }

          var _iteratorNormalCompletion126 = true;
          var _didIteratorError126 = false;
          var _iteratorError126 = undefined;

          try {
            for (var _iterator126 = n[Symbol.iterator](), _step126; !(_iteratorNormalCompletion126 = (_step126 = _iterator126.next()).done); _iteratorNormalCompletion126 = true) {
              var _ref31 = _step126.value;

              var _ref29 = _slicedToArray(_ref31, 1);

              var _t96 = _ref29[0];
              this.hasAttribute(_t96) || i.push(_t96);
            }
          } catch (err) {
            _didIteratorError126 = true;
            _iteratorError126 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion126 && _iterator126.return != null) {
                _iterator126.return();
              }
            } finally {
              if (_didIteratorError126) {
                throw _iteratorError126;
              }
            }
          }

          i.length > 0 && this.fire("change:attribute", {
            attributeKeys: i,
            directChange: !1
          });
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          var i = n ? "normal" : "low";
          return ("low" != i || "normal" != this._attributePriority.get(t)) && _get(_getPrototypeOf(fa.prototype), "getAttribute", this).call(this, t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, i), !0);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var n = e ? "normal" : "low";
          return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!_get(_getPrototypeOf(fa.prototype), "hasAttribute", this).call(this, t) && (this._attrs.delete(t), !0));
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          var e = new Set();
          var _iteratorNormalCompletion127 = true;
          var _didIteratorError127 = false;
          var _iteratorError127 = undefined;

          try {
            for (var _iterator127 = this.getAttributes()[Symbol.iterator](), _step127; !(_iteratorNormalCompletion127 = (_step127 = _iterator127.next()).done); _iteratorNormalCompletion127 = true) {
              var _ref36 = _step127.value;

              var _ref33 = _slicedToArray(_ref36, 2);

              var _e102 = _ref33[0];
              var _n89 = _ref33[1];
              t.get(_e102) !== _n89 && this._removeAttribute(_e102, !1);
            }
          } catch (err) {
            _didIteratorError127 = true;
            _iteratorError127 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion127 && _iterator127.return != null) {
                _iterator127.return();
              }
            } finally {
              if (_didIteratorError127) {
                throw _iteratorError127;
              }
            }
          }

          var _iteratorNormalCompletion128 = true;
          var _didIteratorError128 = false;
          var _iteratorError128 = undefined;

          try {
            for (var _iterator128 = t[Symbol.iterator](), _step128; !(_iteratorNormalCompletion128 = (_step128 = _iterator128.next()).done); _iteratorNormalCompletion128 = true) {
              var _ref37 = _step128.value;

              var _ref35 = _slicedToArray(_ref37, 2);

              var _n90 = _ref35[0];
              var _i70 = _ref35[1];
              this._setAttribute(_n90, _i70, !1) && e.add(_n90);
            }
          } catch (err) {
            _didIteratorError128 = true;
            _iteratorError128 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion128 && _iterator128.return != null) {
                _iterator128.return();
              }
            } finally {
              if (_didIteratorError128) {
                throw _iteratorError128;
              }
            }
          }

          return e;
        }
      }, {
        key: "_getStoredAttributes",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _getStoredAttributes() {
          var t, _iteratorNormalCompletion129, _didIteratorError129, _iteratorError129, _iterator129, _step129, _e103, _n91;

          return _regeneratorRuntime.wrap(function _getStoredAttributes$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  t = this.getFirstPosition().parent;

                  if (!(this.isCollapsed && t.isEmpty)) {
                    _context17.next = 30;
                    break;
                  }

                  _iteratorNormalCompletion129 = true;
                  _didIteratorError129 = false;
                  _iteratorError129 = undefined;
                  _context17.prev = 5;
                  _iterator129 = t.getAttributeKeys()[Symbol.iterator]();

                case 7:
                  if (_iteratorNormalCompletion129 = (_step129 = _iterator129.next()).done) {
                    _context17.next = 16;
                    break;
                  }

                  _e103 = _step129.value;

                  if (!_e103.startsWith(ha)) {
                    _context17.next = 13;
                    break;
                  }

                  _n91 = _e103.substr(ha.length);
                  _context17.next = 13;
                  return [_n91, t.getAttribute(_e103)];

                case 13:
                  _iteratorNormalCompletion129 = true;
                  _context17.next = 7;
                  break;

                case 16:
                  _context17.next = 22;
                  break;

                case 18:
                  _context17.prev = 18;
                  _context17.t0 = _context17["catch"](5);
                  _didIteratorError129 = true;
                  _iteratorError129 = _context17.t0;

                case 22:
                  _context17.prev = 22;
                  _context17.prev = 23;

                  if (!_iteratorNormalCompletion129 && _iterator129.return != null) {
                    _iterator129.return();
                  }

                case 25:
                  _context17.prev = 25;

                  if (!_didIteratorError129) {
                    _context17.next = 28;
                    break;
                  }

                  throw _iteratorError129;

                case 28:
                  return _context17.finish(25);

                case 29:
                  return _context17.finish(22);

                case 30:
                case "end":
                  return _context17.stop();
              }
            }
          }, _getStoredAttributes, this, [[5, 18, 22, 30], [23,, 25, 29]]);
        })
      }, {
        key: "_getSurroundingAttributes",
        value: function _getSurroundingAttributes() {
          var t = this.getFirstPosition(),
              e = this._model.schema;
          var n = null;

          if (this.isCollapsed) {
            var _e104 = t.textNode ? t.textNode : t.nodeBefore,
                _i71 = t.textNode ? t.textNode : t.nodeAfter;

            if (this.isGravityOverridden || (n = ga(_e104)), n || (n = ga(_i71)), !this.isGravityOverridden && !n) {
              var _t97 = _e104;

              for (; _t97 && !n;) {
                _t97 = _t97.previousSibling, n = ga(_t97);
              }
            }

            if (!n) {
              var _t98 = _i71;

              for (; _t98 && !n;) {
                _t98 = _t98.nextSibling, n = ga(_t98);
              }
            }

            n || (n = this._getStoredAttributes());
          } else {
            var _t99 = this.getFirstRange();

            var _iteratorNormalCompletion130 = true;
            var _didIteratorError130 = false;
            var _iteratorError130 = undefined;

            try {
              for (var _iterator130 = _t99[Symbol.iterator](), _step130; !(_iteratorNormalCompletion130 = (_step130 = _iterator130.next()).done); _iteratorNormalCompletion130 = true) {
                var _i72 = _step130.value;
                if (_i72.item.is("element") && e.isObject(_i72.item)) break;

                if ("text" == _i72.type) {
                  n = _i72.item.getAttributes();
                  break;
                }
              }
            } catch (err) {
              _didIteratorError130 = true;
              _iteratorError130 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion130 && _iterator130.return != null) {
                  _iterator130.return();
                }
              } finally {
                if (_didIteratorError130) {
                  throw _iteratorError130;
                }
              }
            }
          }

          return n;
        }
      }, {
        key: "_fixGraveyardSelection",
        value: function _fixGraveyardSelection(t, e) {
          var n = e.clone(),
              i = this._model.schema.getNearestSelectionRange(n),
              o = this._ranges.indexOf(t);

          if (this._ranges.splice(o, 1), t.detach(), i) {
            var _t100 = this._prepareRange(i);

            this._ranges.splice(o, 0, _t100);
          }
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(fa.prototype), "isCollapsed", this);
        }
      }, {
        key: "anchor",
        get: function get() {
          return _get(_getPrototypeOf(fa.prototype), "anchor", this) || this._document._getDefaultRange().start;
        }
      }, {
        key: "focus",
        get: function get() {
          return _get(_getPrototypeOf(fa.prototype), "focus", this) || this._document._getDefaultRange().end;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length ? this._ranges.length : 1;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._ranges.length > 0;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return !!this._overriddenGravityRegister.size;
        }
      }]);

      return fa;
    }(ia);

    function ga(t) {
      return t instanceof qs || t instanceof Hs ? t.getAttributes() : null;
    }

    var ma =
    /*#__PURE__*/
    function () {
      function ma(t) {
        _classCallCheck(this, ma);

        this._dispatchers = t;
      }

      _createClass(ma, [{
        key: "add",
        value: function add(t) {
          var _iteratorNormalCompletion131 = true;
          var _didIteratorError131 = false;
          var _iteratorError131 = undefined;

          try {
            for (var _iterator131 = this._dispatchers[Symbol.iterator](), _step131; !(_iteratorNormalCompletion131 = (_step131 = _iterator131.next()).done); _iteratorNormalCompletion131 = true) {
              var _e105 = _step131.value;
              t(_e105);
            }
          } catch (err) {
            _didIteratorError131 = true;
            _iteratorError131 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion131 && _iterator131.return != null) {
                _iterator131.return();
              }
            } finally {
              if (_didIteratorError131) {
                throw _iteratorError131;
              }
            }
          }

          return this;
        }
      }]);

      return ma;
    }();

    var pa = 1,
        ba = 4;

    var wa = function wa(t) {
      return Un(t, pa | ba);
    };

    var ka =
    /*#__PURE__*/
    function (_ma) {
      _inherits(ka, _ma);

      function ka() {
        _classCallCheck(this, ka);

        return _possibleConstructorReturn(this, _getPrototypeOf(ka).apply(this, arguments));
      }

      _createClass(ka, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(function (t) {
            return (t = wa(t)).view = va(t.view, "container"), function (e) {
              e.on("insert:" + t.model, function (t) {
                return function (e, n, i) {
                  var o = t(n.item, i.writer);
                  if (!o) return;
                  if (!i.consumable.consume(n.item, "insert")) return;
                  var r = i.mapper.toViewPosition(n.range.start);
                  i.mapper.bindElements(n.item, o), i.writer.insert(r, o);
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          return this.add(function (t) {
            var e = "attribute:" + ((t = wa(t)).model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);

            if (t.model.values) {
              var _iteratorNormalCompletion132 = true;
              var _didIteratorError132 = false;
              var _iteratorError132 = undefined;

              try {
                for (var _iterator132 = t.model.values[Symbol.iterator](), _step132; !(_iteratorNormalCompletion132 = (_step132 = _iterator132.next()).done); _iteratorNormalCompletion132 = true) {
                  var _e106 = _step132.value;
                  t.view[_e106] = va(t.view[_e106], "attribute");
                }
              } catch (err) {
                _didIteratorError132 = true;
                _iteratorError132 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion132 && _iterator132.return != null) {
                    _iterator132.return();
                  }
                } finally {
                  if (_didIteratorError132) {
                    throw _iteratorError132;
                  }
                }
              }
            } else t.view = va(t.view, "attribute");

            var n = ya(t);
            return function (i) {
              i.on(e, function (t) {
                return function (e, n, i) {
                  var o = t(n.attributeOldValue, i.writer),
                      r = t(n.attributeNewValue, i.writer);
                  if (!o && !r) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var s = i.writer,
                      a = s.document.selection;
                  if (n.item instanceof ia || n.item instanceof ua) s.wrap(a.getFirstRange(), r);else {
                    var _t101 = i.mapper.toViewRange(n.range);

                    null !== n.attributeOldValue && o && (_t101 = s.unwrap(_t101, o)), null !== n.attributeNewValue && r && s.wrap(_t101, r);
                  }
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            var e = "attribute:" + ((t = wa(t)).model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);

            if (t.model.values) {
              var _iteratorNormalCompletion133 = true;
              var _didIteratorError133 = false;
              var _iteratorError133 = undefined;

              try {
                for (var _iterator133 = t.model.values[Symbol.iterator](), _step133; !(_iteratorNormalCompletion133 = (_step133 = _iterator133.next()).done); _iteratorNormalCompletion133 = true) {
                  var _e107 = _step133.value;
                  t.view[_e107] = xa(t.view[_e107]);
                }
              } catch (err) {
                _didIteratorError133 = true;
                _iteratorError133 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion133 && _iterator133.return != null) {
                    _iterator133.return();
                  }
                } finally {
                  if (_didIteratorError133) {
                    throw _iteratorError133;
                  }
                }
              }
            } else t.view = xa(t.view);

            var n = ya(t);
            return function (i) {
              i.on(e, function (t) {
                return function (e, n, i) {
                  var o = t(n.attributeOldValue, n),
                      r = t(n.attributeNewValue, n);
                  if (!o && !r) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var s = i.mapper.toViewElement(n.item),
                      a = i.writer;
                  if (!s) throw new Qn.b("conversion-attribute-to-attribute-on-text: Trying to convert text node's attribute with attribute-to-attribute converter.", [n, i]);
                  if (null !== n.attributeOldValue && o) if ("class" == o.key) {
                    var _t102 = Array.isArray(o.value) ? o.value : [o.value];

                    var _iteratorNormalCompletion134 = true;
                    var _didIteratorError134 = false;
                    var _iteratorError134 = undefined;

                    try {
                      for (var _iterator134 = _t102[Symbol.iterator](), _step134; !(_iteratorNormalCompletion134 = (_step134 = _iterator134.next()).done); _iteratorNormalCompletion134 = true) {
                        var _e108 = _step134.value;
                        a.removeClass(_e108, s);
                      }
                    } catch (err) {
                      _didIteratorError134 = true;
                      _iteratorError134 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion134 && _iterator134.return != null) {
                          _iterator134.return();
                        }
                      } finally {
                        if (_didIteratorError134) {
                          throw _iteratorError134;
                        }
                      }
                    }
                  } else if ("style" == o.key) {
                    var _t103 = Object.keys(o.value);

                    for (var _i73 = 0, _t104 = _t103; _i73 < _t104.length; _i73++) {
                      var _e109 = _t104[_i73];
                      a.removeStyle(_e109, s);
                    }
                  } else a.removeAttribute(o.key, s);
                  if (null !== n.attributeNewValue && r) if ("class" == r.key) {
                    var _t105 = Array.isArray(r.value) ? r.value : [r.value];

                    var _iteratorNormalCompletion135 = true;
                    var _didIteratorError135 = false;
                    var _iteratorError135 = undefined;

                    try {
                      for (var _iterator135 = _t105[Symbol.iterator](), _step135; !(_iteratorNormalCompletion135 = (_step135 = _iterator135.next()).done); _iteratorNormalCompletion135 = true) {
                        var _e110 = _step135.value;
                        a.addClass(_e110, s);
                      }
                    } catch (err) {
                      _didIteratorError135 = true;
                      _iteratorError135 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion135 && _iterator135.return != null) {
                          _iterator135.return();
                        }
                      } finally {
                        if (_didIteratorError135) {
                          throw _iteratorError135;
                        }
                      }
                    }
                  } else if ("style" == r.key) {
                    var _t106 = Object.keys(r.value);

                    for (var _i74 = 0, _t107 = _t106; _i74 < _t107.length; _i74++) {
                      var _e111 = _t107[_i74];
                      a.setStyle(_e111, r.value[_e111], s);
                    }
                  } else a.setAttribute(r.key, r.value, s);
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToElement",
        value: function markerToElement(t) {
          return this.add(function (t) {
            return (t = wa(t)).view = va(t.view, "ui"), function (e) {
              e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  n.isOpening = !0;
                  var o = t(n, i.writer);
                  n.isOpening = !1;
                  var r = t(n, i.writer);
                  if (!o || !r) return;
                  var s = n.markerRange;
                  if (s.isCollapsed && !i.consumable.consume(s, e.name)) return;
                  var _iteratorNormalCompletion136 = true;
                  var _didIteratorError136 = false;
                  var _iteratorError136 = undefined;

                  try {
                    for (var _iterator136 = s[Symbol.iterator](), _step136; !(_iteratorNormalCompletion136 = (_step136 = _iterator136.next()).done); _iteratorNormalCompletion136 = true) {
                      var _t108 = _step136.value;
                      if (!i.consumable.consume(_t108.item, e.name)) return;
                    }
                  } catch (err) {
                    _didIteratorError136 = true;
                    _iteratorError136 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion136 && _iterator136.return != null) {
                        _iterator136.return();
                      }
                    } finally {
                      if (_didIteratorError136) {
                        throw _iteratorError136;
                      }
                    }
                  }

                  var a = i.mapper,
                      c = i.writer;
                  c.insert(a.toViewPosition(s.start), o), i.mapper.bindElementToMarker(o, n.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), i.mapper.bindElementToMarker(r, n.markerName)), e.stop();
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, (t.view, function (t, e, n) {
                var i = n.mapper.markerNameToElements(e.markerName);

                if (i) {
                  var _iteratorNormalCompletion137 = true;
                  var _didIteratorError137 = false;
                  var _iteratorError137 = undefined;

                  try {
                    for (var _iterator137 = i[Symbol.iterator](), _step137; !(_iteratorNormalCompletion137 = (_step137 = _iterator137.next()).done); _iteratorNormalCompletion137 = true) {
                      var _t109 = _step137.value;
                      n.mapper.unbindElementFromMarkerName(_t109, e.markerName), n.writer.clear(n.writer.createRangeOn(_t109), _t109);
                    }
                  } catch (err) {
                    _didIteratorError137 = true;
                    _iteratorError137 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion137 && _iterator137.return != null) {
                        _iterator137.return();
                      }
                    } finally {
                      if (_didIteratorError137) {
                        throw _iteratorError137;
                      }
                    }
                  }

                  n.writer.clearClonedElementsGroup(e.markerName), t.stop();
                }
              }), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToHighlight",
        value: function markerToHighlight(t) {
          return this.add(function (t) {
            return function (e) {
              e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (!n.item) return;
                  if (!(n.item instanceof ia || n.item instanceof ua || n.item.is("textProxy"))) return;
                  var o = Aa(t, n, i);
                  if (!o) return;
                  if (!i.consumable.consume(n.item, e.name)) return;

                  var r = _a(o),
                      s = i.writer,
                      a = s.document.selection;

                  if (n.item instanceof ia || n.item instanceof ua) s.wrap(a.getFirstRange(), r, a);else {
                    var _t110 = i.mapper.toViewRange(n.range),
                        _e112 = s.wrap(_t110, r);

                    var _iteratorNormalCompletion138 = true;
                    var _didIteratorError138 = false;
                    var _iteratorError138 = undefined;

                    try {
                      for (var _iterator138 = _e112.getItems()[Symbol.iterator](), _step138; !(_iteratorNormalCompletion138 = (_step138 = _iterator138.next()).done); _iteratorNormalCompletion138 = true) {
                        var _t111 = _step138.value;

                        if (_t111.is("attributeElement") && _t111.isSimilar(r)) {
                          i.mapper.bindElementToMarker(_t111, n.markerName);
                          break;
                        }
                      }
                    } catch (err) {
                      _didIteratorError138 = true;
                      _iteratorError138 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion138 && _iterator138.return != null) {
                          _iterator138.return();
                        }
                      } finally {
                        if (_didIteratorError138) {
                          throw _iteratorError138;
                        }
                      }
                    }
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (!n.item) return;
                  if (!(n.item instanceof Ys)) return;
                  var o = Aa(t, n, i);
                  if (!o) return;
                  if (!i.consumable.test(n.item, e.name)) return;
                  var r = i.mapper.toViewElement(n.item);

                  if (r && r.getCustomProperty("addHighlight")) {
                    i.consumable.consume(n.item, e.name);
                    var _iteratorNormalCompletion139 = true;
                    var _didIteratorError139 = false;
                    var _iteratorError139 = undefined;

                    try {
                      for (var _iterator139 = Js._createIn(n.item)[Symbol.iterator](), _step139; !(_iteratorNormalCompletion139 = (_step139 = _iterator139.next()).done); _iteratorNormalCompletion139 = true) {
                        var _t112 = _step139.value;
                        i.consumable.consume(_t112.item, e.name);
                      }
                    } catch (err) {
                      _didIteratorError139 = true;
                      _iteratorError139 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion139 && _iterator139.return != null) {
                          _iterator139.return();
                        }
                      } finally {
                        if (_didIteratorError139) {
                          throw _iteratorError139;
                        }
                      }
                    }

                    r.getCustomProperty("addHighlight")(r, o, i.writer), i.mapper.bindElementToMarker(r, n.markerName);
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (n.markerRange.isCollapsed) return;
                  var o = Aa(t, n, i);
                  if (!o) return;

                  var r = _a(o),
                      s = i.mapper.markerNameToElements(n.markerName);

                  if (s) {
                    var _iteratorNormalCompletion140 = true;
                    var _didIteratorError140 = false;
                    var _iteratorError140 = undefined;

                    try {
                      for (var _iterator140 = s[Symbol.iterator](), _step140; !(_iteratorNormalCompletion140 = (_step140 = _iterator140.next()).done); _iteratorNormalCompletion140 = true) {
                        var _t113 = _step140.value;
                        i.mapper.unbindElementFromMarkerName(_t113, n.markerName), _t113.is("attributeElement") ? i.writer.unwrap(i.writer.createRangeOn(_t113), r) : _t113.getCustomProperty("removeHighlight")(_t113, o.id, i.writer);
                      }
                    } catch (err) {
                      _didIteratorError140 = true;
                      _iteratorError140 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion140 && _iterator140.return != null) {
                          _iterator140.return();
                        }
                      } finally {
                        if (_didIteratorError140) {
                          throw _iteratorError140;
                        }
                      }
                    }

                    i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }]);

      return ka;
    }(ma);

    function _a(t) {
      var e = new co("span", t.attributes);
      return t.classes && e._addClass(t.classes), t.priority && (e._priority = t.priority), e._id = t.id, e;
    }

    function va(t, e) {
      return "function" == typeof t ? t : function (n, i) {
        return function (t, e, n) {
          "string" == typeof t && (t = {
            name: t
          });
          var i;
          var o = Object.assign({}, t.attributes);
          if ("container" == n) i = e.createContainerElement(t.name, o);else if ("attribute" == n) {
            var _n92 = {
              priority: t.priority || co.DEFAULT_PRIORITY
            };
            i = e.createAttributeElement(t.name, o, _n92);
          } else i = e.createUIElement(t.name, o);

          if (t.styles) {
            var _n93 = Object.keys(t.styles);

            for (var _i75 = 0, _n94 = _n93; _i75 < _n94.length; _i75++) {
              var _o37 = _n94[_i75];
              e.setStyle(_o37, t.styles[_o37], i);
            }
          }

          if (t.classes) {
            var _n95 = t.classes;
            if ("string" == typeof _n95) e.addClass(_n95, i);else {
              var _iteratorNormalCompletion141 = true;
              var _didIteratorError141 = false;
              var _iteratorError141 = undefined;

              try {
                for (var _iterator141 = _n95[Symbol.iterator](), _step141; !(_iteratorNormalCompletion141 = (_step141 = _iterator141.next()).done); _iteratorNormalCompletion141 = true) {
                  var _t114 = _step141.value;
                  e.addClass(_t114, i);
                }
              } catch (err) {
                _didIteratorError141 = true;
                _iteratorError141 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion141 && _iterator141.return != null) {
                    _iterator141.return();
                  }
                } finally {
                  if (_didIteratorError141) {
                    throw _iteratorError141;
                  }
                }
              }
            }
          }

          return i;
        }(t, i, e);
      };
    }

    function ya(t) {
      return t.model.values ? function (e, n) {
        var i = t.view[e];
        return i ? i(e, n) : null;
      } : t.view;
    }

    function xa(t) {
      return "string" == typeof t ? function (e) {
        return {
          key: t,
          value: e
        };
      } : "object" == typeof t ? t.value ? function () {
        return t;
      } : function (e) {
        return {
          key: t.key,
          value: e
        };
      } : t;
    }

    function Aa(t, e, n) {
      var i = "function" == typeof t ? t(e, n) : t;
      return i ? (i.priority || (i.priority = 10), i.id || (i.id = e.markerName), i) : null;
    }

    var Ta =
    /*#__PURE__*/
    function (_ma2) {
      _inherits(Ta, _ma2);

      function Ta() {
        _classCallCheck(this, Ta);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ta).apply(this, arguments));
      }

      _createClass(Ta, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(Ca(t));
        }
      }, {
        key: "elementToAttribute",
        value: function elementToAttribute(t) {
          return this.add(function (t) {
            Sa(t = wa(t));
            var e = Ma(t, !1),
                n = Pa(t.view),
                i = n ? "element:" + n : "element";
            return function (n) {
              n.on(i, e, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            t = wa(t);
            var e = null;
            ("string" == typeof t.view || t.view.key) && (e = function (t) {
              "string" == typeof t.view && (t.view = {
                key: t.view
              });
              var e = t.view.key;
              var n;

              if ("class" == e || "style" == e) {
                n = _defineProperty({}, "class" == e ? "classes" : "styles", t.view.value);
              } else {
                var _i76 = void 0 === t.view.value ? /[\s\S]*/ : t.view.value;

                n = {
                  attributes: _defineProperty({}, e, _i76)
                };
              }

              t.view.name && (n.name = t.view.name);
              return t.view = n, e;
            }(t));
            Sa(t, e);
            var n = Ma(t, !0);
            return function (e) {
              e.on("element", n, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "elementToMarker",
        value: function elementToMarker(t) {
          return this.add(function (t) {
            return function (t) {
              var e = t.model;

              t.model = function (t, n) {
                var i = "string" == typeof e ? e : e(t);
                return n.createElement("$marker", {
                  "data-name": i
                });
              };
            }(t = wa(t)), Ca(t);
          }(t));
        }
      }]);

      return Ta;
    }(ma);

    function Ca(t) {
      var e = function (t) {
        var e = t.view ? new wi(t.view) : null;
        return function (n, i, o) {
          var r = {};

          if (e) {
            var _t115 = e.match(i.viewItem);

            if (!_t115) return;
            r = _t115.match;
          }

          r.name = !0;

          var s = function (t, e, n) {
            return t instanceof Function ? t(e, n) : n.createElement(t);
          }(t.model, i.viewItem, o.writer);

          if (!s) return;
          if (!o.consumable.test(i.viewItem, r)) return;
          var a = o.splitToAllowedParent(s, i.modelCursor);
          if (!a) return;
          o.writer.insert(s, a.position), o.convertChildren(i.viewItem, o.writer.createPositionAt(s, 0)), o.consumable.consume(i.viewItem, r);
          var c = o.getSplitParts(s);
          i.modelRange = new Js(o.writer.createPositionBefore(s), o.writer.createPositionAfter(c[c.length - 1])), a.cursorParent ? i.modelCursor = o.writer.createPositionAt(a.cursorParent, 0) : i.modelCursor = i.modelRange.end;
        };
      }(t = wa(t)),
          n = Pa(t.view),
          i = n ? "element:" + n : "element";

      return function (n) {
        n.on(i, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }

    function Pa(t) {
      return "string" == typeof t ? t : "object" == typeof t && "string" == typeof t.name ? t.name : null;
    }

    function Sa(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var n = null === e || function (t) {
        return t.getAttribute(e);
      },
          i = "object" != typeof t.model ? t.model : t.model.key,
          o = "object" != typeof t.model || void 0 === t.model.value ? n : t.model.value;

      t.model = {
        key: i,
        value: o
      };
    }

    function Ma(t, e) {
      var n = new wi(t.view);
      return function (i, o, r) {
        var s = n.match(o.viewItem);
        if (!s) return;
        var a = t.model.key,
            c = "function" == typeof t.model.value ? t.model.value(o.viewItem) : t.model.value;
        null !== c && (!function (t, e) {
          var n = "function" == typeof t ? t(e) : t;
          if ("object" == typeof n && !Pa(n)) return !1;
          return !n.classes && !n.attributes && !n.styles;
        }(t.view, o.viewItem) ? delete s.match.name : s.match.name = !0, r.consumable.test(o.viewItem, s.match) && (o.modelRange || (o = Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor))), function (t, e, n, i) {
          var o = !1;

          for (var _i77 = 0, _Array$from4 = Array.from(t.getItems({
            shallow: n
          })); _i77 < _Array$from4.length; _i77++) {
            var _r13 = _Array$from4[_i77];
            i.schema.checkAttribute(_r13, e.key) && (i.writer.setAttribute(e.key, e.value, _r13), o = !0);
          }

          return o;
        }(o.modelRange, {
          key: a,
          value: c
        }, e, r) && r.consumable.consume(o.viewItem, s.match)));
      };
    }

    var Ea =
    /*#__PURE__*/
    function () {
      function Ea(t) {
        var _this47 = this;

        _classCallCheck(this, Ea);

        this.model = t, this.view = new Bs(), this.mapper = new Zs(), this.downcastDispatcher = new ea({
          mapper: this.mapper
        });
        var e = this.model.document,
            n = e.selection,
            i = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", function () {
          _this47.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", function () {
          _this47.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(e, "change", function () {
          _this47.view.change(function (t) {
            _this47.downcastDispatcher.convertChanges(e.differ, i, t), _this47.downcastDispatcher.convertSelection(n, i, t);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
          return function (n, i) {
            var o = i.newSelection,
                r = new ia(),
                s = [];
            var _iteratorNormalCompletion142 = true;
            var _didIteratorError142 = false;
            var _iteratorError142 = undefined;

            try {
              for (var _iterator142 = o.getRanges()[Symbol.iterator](), _step142; !(_iteratorNormalCompletion142 = (_step142 = _iterator142.next()).done); _iteratorNormalCompletion142 = true) {
                var _t116 = _step142.value;
                s.push(e.toModelRange(_t116));
              }
            } catch (err) {
              _didIteratorError142 = true;
              _iteratorError142 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion142 && _iterator142.return != null) {
                  _iterator142.return();
                }
              } finally {
                if (_didIteratorError142) {
                  throw _iteratorError142;
                }
              }
            }

            r.setTo(s, {
              backward: o.isBackward
            }), r.isEqual(t.document.selection) || t.change(function (t) {
              t.setSelection(r);
            });
          };
        }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var i = n.writer,
              o = n.mapper.toViewPosition(e.range.start),
              r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", function (t, e, n) {
          var i = n.mapper.toViewPosition(e.position),
              o = e.position.getShiftedBy(e.length),
              r = n.mapper.toViewPosition(o, {
            isPhantom: !0
          }),
              s = n.writer.createRange(i, r),
              a = n.writer.remove(s.getTrimmed());
          var _iteratorNormalCompletion143 = true;
          var _didIteratorError143 = false;
          var _iteratorError143 = undefined;

          try {
            for (var _iterator143 = n.writer.createRangeIn(a).getItems()[Symbol.iterator](), _step143; !(_iteratorNormalCompletion143 = (_step143 = _iterator143.next()).done); _iteratorNormalCompletion143 = true) {
              var _t117 = _step143.value;
              n.mapper.unbindViewElement(_t117);
            }
          } catch (err) {
            _didIteratorError143 = true;
            _iteratorError143 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion143 && _iterator143.return != null) {
                _iterator143.return();
              }
            } finally {
              if (_didIteratorError143) {
                throw _iteratorError143;
              }
            }
          }
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = n.writer,
              o = i.document.selection;
          var _iteratorNormalCompletion144 = true;
          var _didIteratorError144 = false;
          var _iteratorError144 = undefined;

          try {
            for (var _iterator144 = o.getRanges()[Symbol.iterator](), _step144; !(_iteratorNormalCompletion144 = (_step144 = _iterator144.next()).done); _iteratorNormalCompletion144 = true) {
              var _t118 = _step144.value;
              _t118.isCollapsed && _t118.end.parent.document && n.writer.mergeAttributes(_t118.start);
            }
          } catch (err) {
            _didIteratorError144 = true;
            _iteratorError144 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion144 && _iterator144.return != null) {
                _iterator144.return();
              }
            } finally {
              if (_didIteratorError144) {
                throw _iteratorError144;
              }
            }
          }

          i.setSelection(null);
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = e.selection;
          if (i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          var o = [];
          var _iteratorNormalCompletion145 = true;
          var _didIteratorError145 = false;
          var _iteratorError145 = undefined;

          try {
            for (var _iterator145 = i.getRanges()[Symbol.iterator](), _step145; !(_iteratorNormalCompletion145 = (_step145 = _iterator145.next()).done); _iteratorNormalCompletion145 = true) {
              var _t119 = _step145.value;

              var _e113 = n.mapper.toViewRange(_t119);

              o.push(_e113);
            }
          } catch (err) {
            _didIteratorError145 = true;
            _iteratorError145 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion145 && _iterator145.return != null) {
                _iterator145.return();
              }
            } finally {
              if (_didIteratorError145) {
                throw _iteratorError145;
              }
            }
          }

          n.writer.setSelection(o, {
            backward: i.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = e.selection;
          if (!i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          var o = n.writer,
              r = i.getFirstPosition(),
              s = n.mapper.toViewPosition(r),
              a = o.breakAttributes(s);
          o.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(function (t) {
          if ("$graveyard" == t.rootName) return null;
          var e = new Ji(t.name);
          return e.rootName = t.rootName, e._document = _this47.view.document, _this47.mapper.bindElements(t, e), e;
        });
      }

      _createClass(Ea, [{
        key: "destroy",
        value: function destroy() {
          this.view.destroy(), this.stopListening();
        }
      }]);

      return Ea;
    }();

    li(Ea, Ui);

    var Ia =
    /*#__PURE__*/
    function () {
      function Ia(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, Ia);

        this._editor = t, this._availablePlugins = new Map(), this._plugins = new Map();
        var _iteratorNormalCompletion146 = true;
        var _didIteratorError146 = false;
        var _iteratorError146 = undefined;

        try {
          for (var _iterator146 = e[Symbol.iterator](), _step146; !(_iteratorNormalCompletion146 = (_step146 = _iterator146.next()).done); _iteratorNormalCompletion146 = true) {
            var _t120 = _step146.value;
            this._availablePlugins.set(_t120, _t120), _t120.pluginName && this._availablePlugins.set(_t120.pluginName, _t120);
          }
        } catch (err) {
          _didIteratorError146 = true;
          _iteratorError146 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion146 && _iterator146.return != null) {
              _iterator146.return();
            }
          } finally {
            if (_didIteratorError146) {
              throw _iteratorError146;
            }
          }
        }
      }

      _createClass(Ia, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          var _iteratorNormalCompletion147, _didIteratorError147, _iteratorError147, _iterator147, _step147, _t121;

          return _regeneratorRuntime.wrap(function value$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _iteratorNormalCompletion147 = true;
                  _didIteratorError147 = false;
                  _iteratorError147 = undefined;
                  _context18.prev = 3;
                  _iterator147 = this._plugins[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion147 = (_step147 = _iterator147.next()).done) {
                    _context18.next = 14;
                    break;
                  }

                  _t121 = _step147.value;
                  _context18.t0 = "function" == typeof _t121[0];

                  if (!_context18.t0) {
                    _context18.next = 11;
                    break;
                  }

                  _context18.next = 11;
                  return _t121;

                case 11:
                  _iteratorNormalCompletion147 = true;
                  _context18.next = 5;
                  break;

                case 14:
                  _context18.next = 20;
                  break;

                case 16:
                  _context18.prev = 16;
                  _context18.t1 = _context18["catch"](3);
                  _didIteratorError147 = true;
                  _iteratorError147 = _context18.t1;

                case 20:
                  _context18.prev = 20;
                  _context18.prev = 21;

                  if (!_iteratorNormalCompletion147 && _iterator147.return != null) {
                    _iterator147.return();
                  }

                case 23:
                  _context18.prev = 23;

                  if (!_didIteratorError147) {
                    _context18.next = 26;
                    break;
                  }

                  throw _iteratorError147;

                case 26:
                  return _context18.finish(23);

                case 27:
                  return _context18.finish(20);

                case 28:
                case "end":
                  return _context18.stop();
              }
            }
          }, value, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "get",
        value: function get(t) {
          var e = this._plugins.get(t);

          if (!e) {
            var _e114 = "plugincollection-plugin-not-loaded: The requested plugin is not loaded.";
            var _n97 = t;
            throw "function" == typeof t && (_n97 = t.pluginName || t.name), new Qn.b(_e114, this._editor, {
              plugin: _n97
            });
          }

          return e;
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._plugins.has(t);
        }
      }, {
        key: "init",
        value: function init(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          var n = this,
              i = this._editor,
              o = new Set(),
              r = [],
              s = u(t),
              a = u(e),
              c = function (t) {
            var e = [];
            var _iteratorNormalCompletion148 = true;
            var _didIteratorError148 = false;
            var _iteratorError148 = undefined;

            try {
              for (var _iterator148 = t[Symbol.iterator](), _step148; !(_iteratorNormalCompletion148 = (_step148 = _iterator148.next()).done); _iteratorNormalCompletion148 = true) {
                var _n98 = _step148.value;
                h(_n98) || e.push(_n98);
              }
            } catch (err) {
              _didIteratorError148 = true;
              _iteratorError148 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion148 && _iterator148.return != null) {
                  _iterator148.return();
                }
              } finally {
                if (_didIteratorError148) {
                  throw _iteratorError148;
                }
              }
            }

            return e.length ? e : null;
          }(t);

          if (c) {
            var _t122 = "plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.";
            return console.error(Object(Qn.a)(_t122), {
              plugins: c
            }), Promise.reject(new Qn.b(_t122, this._editor, {
              plugins: c
            }));
          }

          return Promise.all(s.map(l)).then(function () {
            return d(r, "init");
          }).then(function () {
            return d(r, "afterInit");
          }).then(function () {
            return r;
          });

          function l(t) {
            if (!a.includes(t) && !n._plugins.has(t) && !o.has(t)) return function (t) {
              return new Promise(function (s) {
                o.add(t), t.requires && t.requires.forEach(function (n) {
                  var o = h(n);
                  if (e.includes(o)) throw new Qn.b("plugincollection-required: Cannot load a plugin because one of its dependencies is listed inthe `removePlugins` option.", i, {
                    plugin: o,
                    requiredBy: t
                  });
                  l(o);
                });
                var a = new t(i);
                n._add(t, a), r.push(a), s();
              });
            }(t).catch(function (e) {
              throw console.error(Object(Qn.a)("plugincollection-load: It was not possible to load the plugin."), {
                plugin: t
              }), e;
            });
          }

          function d(t, e) {
            return t.reduce(function (t, n) {
              return n[e] ? t.then(n[e].bind(n)) : t;
            }, Promise.resolve());
          }

          function h(t) {
            return "function" == typeof t ? t : n._availablePlugins.get(t);
          }

          function u(t) {
            return t.map(function (t) {
              return h(t);
            }).filter(function (t) {
              return !!t;
            });
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = Array.from(this).map(function (_ref38) {
            var _ref39 = _slicedToArray(_ref38, 2),
                t = _ref39[1];

            return t;
          }).filter(function (t) {
            return "function" == typeof t.destroy;
          }).map(function (t) {
            return t.destroy();
          });
          return Promise.all(t);
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          this._plugins.set(t, e);

          var n = t.pluginName;

          if (n) {
            if (this._plugins.has(n)) throw new Qn.b("plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.", null, {
              pluginName: n,
              plugin1: this._plugins.get(n).constructor,
              plugin2: t
            });

            this._plugins.set(n, e);
          }
        }
      }]);

      return Ia;
    }();

    li(Ia, ni);

    var Na =
    /*#__PURE__*/
    function () {
      function Na() {
        _classCallCheck(this, Na);

        this._commands = new Map();
      }

      _createClass(Na, [{
        key: "add",
        value: function add(t, e) {
          this._commands.set(t, e);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._commands.get(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var n = this.get(t);
          if (!n) throw new Qn.b("commandcollection-command-not-found: Command does not exist.", this, {
            commandName: t
          });

          for (var _len16 = arguments.length, e = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
            e[_key16 - 1] = arguments[_key16];
          }

          n.execute.apply(n, e);
        }
      }, {
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          return _regeneratorRuntime.wrap(function names$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  return _context19.delegateYield(this._commands.keys(), "t0", 1);

                case 1:
                case "end":
                  return _context19.stop();
              }
            }
          }, names, this);
        })
      }, {
        key: "commands",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function commands() {
          return _regeneratorRuntime.wrap(function commands$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  return _context20.delegateYield(this._commands.values(), "t0", 1);

                case 1:
                case "end":
                  return _context20.stop();
              }
            }
          }, commands, this);
        })
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._commands[Symbol.iterator]();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion149 = true;
          var _didIteratorError149 = false;
          var _iteratorError149 = undefined;

          try {
            for (var _iterator149 = this.commands()[Symbol.iterator](), _step149; !(_iteratorNormalCompletion149 = (_step149 = _iterator149.next()).done); _iteratorNormalCompletion149 = true) {
              var _t123 = _step149.value;

              _t123.destroy();
            }
          } catch (err) {
            _didIteratorError149 = true;
            _iteratorError149 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion149 && _iterator149.return != null) {
                _iterator149.return();
              }
            } finally {
              if (_didIteratorError149) {
                throw _iteratorError149;
              }
            }
          }
        }
      }]);

      return Na;
    }();

    function Oa(t, e) {
      var n = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
      return 1 === n && (t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]), 0 !== n && function (t, e) {
        return t in window.CKEDITOR_TRANSLATIONS && e in window.CKEDITOR_TRANSLATIONS[t];
      }(t, e) ? window.CKEDITOR_TRANSLATIONS[t][e].replace(/ \[context: [^\]]+\]$/, "") : e.replace(/ \[context: [^\]]+\]$/, "");
    }

    window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
    var Ra = ["ar", "fa", "he", "ku", "ug"];

    var Da =
    /*#__PURE__*/
    function () {
      function Da() {
        var _this48 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Da);

        this.uiLanguage = t.uiLanguage || "en", this.contentLanguage = t.contentLanguage || this.uiLanguage, this.uiLanguageDirection = La(this.uiLanguage), this.contentLanguageDirection = La(this.contentLanguage), this.t = function () {
          return _this48._t.apply(_this48, arguments);
        };
      }

      _createClass(Da, [{
        key: "_t",
        value: function _t(t, e) {
          var n = Oa(this.uiLanguage, t);
          return e && (n = n.replace(/%(\d+)/g, function (t, n) {
            return n < e.length ? e[n] : t;
          })), n;
        }
      }, {
        key: "language",
        get: function get() {
          return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
        }
      }]);

      return Da;
    }();

    function La(t) {
      return Ra.includes(t) ? "rtl" : "ltr";
    }

    var ja =
    /*#__PURE__*/
    function () {
      function ja() {
        _classCallCheck(this, ja);

        this._consumables = new Map();
      }

      _createClass(ja, [{
        key: "add",
        value: function add(t, e) {
          var n;
          t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new Va(), this._consumables.set(t, n)), n.add(e));
        }
      }, {
        key: "test",
        value: function test(t, e) {
          var n = this._consumables.get(t);

          return void 0 === n ? null : t.is("text") || t.is("documentFragment") ? n : n.test(e);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return !!this.test(t, e) && (t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          var n = this._consumables.get(t);

          void 0 !== n && (t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
        }
      }], [{
        key: "consumablesFromElement",
        value: function consumablesFromElement(t) {
          var e = {
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
              n = t.getAttributeKeys();
          var _iteratorNormalCompletion150 = true;
          var _didIteratorError150 = false;
          var _iteratorError150 = undefined;

          try {
            for (var _iterator150 = n[Symbol.iterator](), _step150; !(_iteratorNormalCompletion150 = (_step150 = _iterator150.next()).done); _iteratorNormalCompletion150 = true) {
              var _t124 = _step150.value;
              "style" != _t124 && "class" != _t124 && e.attributes.push(_t124);
            }
          } catch (err) {
            _didIteratorError150 = true;
            _iteratorError150 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion150 && _iterator150.return != null) {
                _iterator150.return();
              }
            } finally {
              if (_didIteratorError150) {
                throw _iteratorError150;
              }
            }
          }

          var i = t.getClassNames();
          var _iteratorNormalCompletion151 = true;
          var _didIteratorError151 = false;
          var _iteratorError151 = undefined;

          try {
            for (var _iterator151 = i[Symbol.iterator](), _step151; !(_iteratorNormalCompletion151 = (_step151 = _iterator151.next()).done); _iteratorNormalCompletion151 = true) {
              var _t125 = _step151.value;
              e.classes.push(_t125);
            }
          } catch (err) {
            _didIteratorError151 = true;
            _iteratorError151 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion151 && _iterator151.return != null) {
                _iterator151.return();
              }
            } finally {
              if (_didIteratorError151) {
                throw _iteratorError151;
              }
            }
          }

          var o = t.getStyleNames();
          var _iteratorNormalCompletion152 = true;
          var _didIteratorError152 = false;
          var _iteratorError152 = undefined;

          try {
            for (var _iterator152 = o[Symbol.iterator](), _step152; !(_iteratorNormalCompletion152 = (_step152 = _iterator152.next()).done); _iteratorNormalCompletion152 = true) {
              var _t126 = _step152.value;
              e.styles.push(_t126);
            }
          } catch (err) {
            _didIteratorError152 = true;
            _iteratorError152 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion152 && _iterator152.return != null) {
                _iterator152.return();
              }
            } finally {
              if (_didIteratorError152) {
                throw _iteratorError152;
              }
            }
          }

          return e;
        }
      }, {
        key: "createFrom",
        value: function createFrom(t, e) {
          if (e || (e = new ja()), t.is("text")) return e.add(t), e;
          t.is("element") && e.add(t, ja.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);
          var _iteratorNormalCompletion153 = true;
          var _didIteratorError153 = false;
          var _iteratorError153 = undefined;

          try {
            for (var _iterator153 = t.getChildren()[Symbol.iterator](), _step153; !(_iteratorNormalCompletion153 = (_step153 = _iterator153.next()).done); _iteratorNormalCompletion153 = true) {
              var _n99 = _step153.value;
              e = ja.createFrom(_n99, e);
            }
          } catch (err) {
            _didIteratorError153 = true;
            _iteratorError153 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion153 && _iterator153.return != null) {
                _iterator153.return();
              }
            } finally {
              if (_didIteratorError153) {
                throw _iteratorError153;
              }
            }
          }

          return e;
        }
      }]);

      return ja;
    }();

    var Va =
    /*#__PURE__*/
    function () {
      function Va() {
        _classCallCheck(this, Va);

        this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }

      _createClass(Va, [{
        key: "add",
        value: function add(t) {
          t.name && (this._canConsumeName = !0);

          for (var _e115 in this._consumables) {
            _e115 in t && this._add(_e115, t[_e115]);
          }
        }
      }, {
        key: "test",
        value: function test(t) {
          if (t.name && !this._canConsumeName) return this._canConsumeName;

          for (var _e116 in this._consumables) {
            if (_e116 in t) {
              var _n100 = this._test(_e116, t[_e116]);

              if (!0 !== _n100) return _n100;
            }
          }

          return !0;
        }
      }, {
        key: "consume",
        value: function consume(t) {
          t.name && (this._canConsumeName = !1);

          for (var _e117 in this._consumables) {
            _e117 in t && this._consume(_e117, t[_e117]);
          }
        }
      }, {
        key: "revert",
        value: function revert(t) {
          t.name && (this._canConsumeName = !0);

          for (var _e118 in this._consumables) {
            _e118 in t && this._revert(_e118, t[_e118]);
          }
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          var n = Yt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion154 = true;
          var _didIteratorError154 = false;
          var _iteratorError154 = undefined;

          try {
            for (var _iterator154 = n[Symbol.iterator](), _step154; !(_iteratorNormalCompletion154 = (_step154 = _iterator154.next()).done); _iteratorNormalCompletion154 = true) {
              var _e119 = _step154.value;
              if ("attributes" === t && ("class" === _e119 || "style" === _e119)) throw new Qn.b("viewconsumable-invalid-attribute: Classes and styles should be handled separately.", this);
              i.set(_e119, !0);
            }
          } catch (err) {
            _didIteratorError154 = true;
            _iteratorError154 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion154 && _iterator154.return != null) {
                _iterator154.return();
              }
            } finally {
              if (_didIteratorError154) {
                throw _iteratorError154;
              }
            }
          }
        }
      }, {
        key: "_test",
        value: function _test(t, e) {
          var n = Yt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion155 = true;
          var _didIteratorError155 = false;
          var _iteratorError155 = undefined;

          try {
            for (var _iterator155 = n[Symbol.iterator](), _step155; !(_iteratorNormalCompletion155 = (_step155 = _iterator155.next()).done); _iteratorNormalCompletion155 = true) {
              var _e120 = _step155.value;

              if ("attributes" !== t || "class" !== _e120 && "style" !== _e120) {
                var _t127 = i.get(_e120);

                if (void 0 === _t127) return null;
                if (!_t127) return !1;
              } else {
                var _t128 = "class" == _e120 ? "classes" : "styles",
                    _n101 = this._test(_t128, _toConsumableArray(this._consumables[_t128].keys()));

                if (!0 !== _n101) return _n101;
              }
            }
          } catch (err) {
            _didIteratorError155 = true;
            _iteratorError155 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion155 && _iterator155.return != null) {
                _iterator155.return();
              }
            } finally {
              if (_didIteratorError155) {
                throw _iteratorError155;
              }
            }
          }

          return !0;
        }
      }, {
        key: "_consume",
        value: function _consume(t, e) {
          var n = Yt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion156 = true;
          var _didIteratorError156 = false;
          var _iteratorError156 = undefined;

          try {
            for (var _iterator156 = n[Symbol.iterator](), _step156; !(_iteratorNormalCompletion156 = (_step156 = _iterator156.next()).done); _iteratorNormalCompletion156 = true) {
              var _e121 = _step156.value;
              if ("attributes" !== t || "class" !== _e121 && "style" !== _e121) i.set(_e121, !1);else {
                var _t129 = "class" == _e121 ? "classes" : "styles";

                this._consume(_t129, _toConsumableArray(this._consumables[_t129].keys()));
              }
            }
          } catch (err) {
            _didIteratorError156 = true;
            _iteratorError156 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion156 && _iterator156.return != null) {
                _iterator156.return();
              }
            } finally {
              if (_didIteratorError156) {
                throw _iteratorError156;
              }
            }
          }
        }
      }, {
        key: "_revert",
        value: function _revert(t, e) {
          var n = Yt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion157 = true;
          var _didIteratorError157 = false;
          var _iteratorError157 = undefined;

          try {
            for (var _iterator157 = n[Symbol.iterator](), _step157; !(_iteratorNormalCompletion157 = (_step157 = _iterator157.next()).done); _iteratorNormalCompletion157 = true) {
              var _e122 = _step157.value;

              if ("attributes" !== t || "class" !== _e122 && "style" !== _e122) {
                !1 === i.get(_e122) && i.set(_e122, !0);
              } else {
                var _t130 = "class" == _e122 ? "classes" : "styles";

                this._revert(_t130, _toConsumableArray(this._consumables[_t130].keys()));
              }
            }
          } catch (err) {
            _didIteratorError157 = true;
            _iteratorError157 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion157 && _iterator157.return != null) {
                _iterator157.return();
              }
            } finally {
              if (_didIteratorError157) {
                throw _iteratorError157;
              }
            }
          }
        }
      }]);

      return Va;
    }();

    var za =
    /*#__PURE__*/
    function () {
      function za() {
        var _this49 = this;

        _classCallCheck(this, za);

        this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (t, e) {
          e[0] = new Ba(e[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", function (t, e) {
          e[0] = new Ba(e[0]), e[1] = _this49.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }

      _createClass(za, [{
        key: "register",
        value: function register(t, e) {
          if (this._sourceDefinitions[t]) throw new Qn.b("schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.", this, {
            itemName: t
          });
          this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (!this._sourceDefinitions[t]) throw new Qn.b("schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.", this, {
            itemName: t
          });
          this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
        }
      }, {
        key: "getDefinitions",
        value: function getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
      }, {
        key: "getDefinition",
        value: function getDefinition(t) {
          var e;
          return e = "string" == typeof t ? t : t.is && (t.is("text") || t.is("textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
        }
      }, {
        key: "isRegistered",
        value: function isRegistered(t) {
          return !!this.getDefinition(t);
        }
      }, {
        key: "isBlock",
        value: function isBlock(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isBlock);
        }
      }, {
        key: "isLimit",
        value: function isLimit(t) {
          var e = this.getDefinition(t);
          return !!e && !(!e.isLimit && !e.isObject);
        }
      }, {
        key: "isObject",
        value: function isObject(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isObject);
        }
      }, {
        key: "isInline",
        value: function isInline(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isInline);
        }
      }, {
        key: "checkChild",
        value: function checkChild(t, e) {
          return !!e && this._checkContextMatch(e, t);
        }
      }, {
        key: "checkAttribute",
        value: function checkAttribute(t, e) {
          var n = this.getDefinition(t.last);
          return !!n && n.allowAttributes.includes(e);
        }
      }, {
        key: "checkMerge",
        value: function checkMerge(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          if (t instanceof Ks) {
            var _e123 = t.nodeBefore,
                _n102 = t.nodeAfter;
            if (!(_e123 instanceof Ys)) throw new Qn.b("schema-check-merge-no-element-before: The node before the merge position must be an element.", this);
            if (!(_n102 instanceof Ys)) throw new Qn.b("schema-check-merge-no-element-after: The node after the merge position must be an element.", this);
            return this.checkMerge(_e123, _n102);
          }

          var _iteratorNormalCompletion158 = true;
          var _didIteratorError158 = false;
          var _iteratorError158 = undefined;

          try {
            for (var _iterator158 = e.getChildren()[Symbol.iterator](), _step158; !(_iteratorNormalCompletion158 = (_step158 = _iterator158.next()).done); _iteratorNormalCompletion158 = true) {
              var _n103 = _step158.value;
              if (!this.checkChild(t, _n103)) return !1;
            }
          } catch (err) {
            _didIteratorError158 = true;
            _iteratorError158 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion158 && _iterator158.return != null) {
                _iterator158.return();
              }
            } finally {
              if (_didIteratorError158) {
                throw _iteratorError158;
              }
            }
          }

          return !0;
        }
      }, {
        key: "addChildCheck",
        value: function addChildCheck(t) {
          this.on("checkChild", function (e, _ref40) {
            var _ref41 = _slicedToArray(_ref40, 2),
                n = _ref41[0],
                i = _ref41[1];

            if (!i) return;
            var o = t(n, i);
            "boolean" == typeof o && (e.stop(), e.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "addAttributeCheck",
        value: function addAttributeCheck(t) {
          this.on("checkAttribute", function (e, _ref42) {
            var _ref43 = _slicedToArray(_ref42, 2),
                n = _ref43[0],
                i = _ref43[1];

            var o = t(n, i);
            "boolean" == typeof o && (e.stop(), e.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "setAttributeProperties",
        value: function setAttributeProperties(t, e) {
          this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
        }
      }, {
        key: "getAttributeProperties",
        value: function getAttributeProperties(t) {
          return this._attributeProperties[t] || {};
        }
      }, {
        key: "getLimitElement",
        value: function getLimitElement(t) {
          var e;
          if (t instanceof Ks) e = t.parent;else {
            e = (t instanceof Js ? [t] : Array.from(t.getRanges())).reduce(function (t, e) {
              var n = e.getCommonAncestor();
              return t ? t.getCommonAncestor(n, {
                includeSelf: !0
              }) : n;
            }, null);
          }

          for (; !this.isLimit(e) && e.parent;) {
            e = e.parent;
          }

          return e;
        }
      }, {
        key: "checkAttributeInSelection",
        value: function checkAttributeInSelection(t, e) {
          if (t.isCollapsed) {
            var _n104 = [].concat(_toConsumableArray(t.getFirstPosition().getAncestors()), [new Hs("", t.getAttributes())]);

            return this.checkAttribute(_n104, e);
          }

          {
            var _n105 = t.getRanges();

            var _iteratorNormalCompletion159 = true;
            var _didIteratorError159 = false;
            var _iteratorError159 = undefined;

            try {
              for (var _iterator159 = _n105[Symbol.iterator](), _step159; !(_iteratorNormalCompletion159 = (_step159 = _iterator159.next()).done); _iteratorNormalCompletion159 = true) {
                var _t131 = _step159.value;
                var _iteratorNormalCompletion160 = true;
                var _didIteratorError160 = false;
                var _iteratorError160 = undefined;

                try {
                  for (var _iterator160 = _t131[Symbol.iterator](), _step160; !(_iteratorNormalCompletion160 = (_step160 = _iterator160.next()).done); _iteratorNormalCompletion160 = true) {
                    var _n106 = _step160.value;
                    if (this.checkAttribute(_n106.item, e)) return !0;
                  }
                } catch (err) {
                  _didIteratorError160 = true;
                  _iteratorError160 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion160 && _iterator160.return != null) {
                      _iterator160.return();
                    }
                  } finally {
                    if (_didIteratorError160) {
                      throw _iteratorError160;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError159 = true;
              _iteratorError159 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion159 && _iterator159.return != null) {
                  _iterator159.return();
                }
              } finally {
                if (_didIteratorError159) {
                  throw _iteratorError159;
                }
              }
            }
          }
          return !1;
        }
      }, {
        key: "getValidRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getValidRanges(t, e) {
          var _iteratorNormalCompletion162, _didIteratorError162, _iteratorError162, _iterator162, _step162, _n107;

          return _regeneratorRuntime.wrap(function getValidRanges$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  t =
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(t) {
                    var _iteratorNormalCompletion161, _didIteratorError161, _iteratorError161, _iterator161, _step161, _e124;

                    return _regeneratorRuntime.wrap(function _callee$(_context21) {
                      while (1) {
                        switch (_context21.prev = _context21.next) {
                          case 0:
                            _iteratorNormalCompletion161 = true;
                            _didIteratorError161 = false;
                            _iteratorError161 = undefined;
                            _context21.prev = 3;
                            _iterator161 = t[Symbol.iterator]();

                          case 5:
                            if (_iteratorNormalCompletion161 = (_step161 = _iterator161.next()).done) {
                              _context21.next = 11;
                              break;
                            }

                            _e124 = _step161.value;
                            return _context21.delegateYield(_e124.getMinimalFlatRanges(), "t0", 8);

                          case 8:
                            _iteratorNormalCompletion161 = true;
                            _context21.next = 5;
                            break;

                          case 11:
                            _context21.next = 17;
                            break;

                          case 13:
                            _context21.prev = 13;
                            _context21.t1 = _context21["catch"](3);
                            _didIteratorError161 = true;
                            _iteratorError161 = _context21.t1;

                          case 17:
                            _context21.prev = 17;
                            _context21.prev = 18;

                            if (!_iteratorNormalCompletion161 && _iterator161.return != null) {
                              _iterator161.return();
                            }

                          case 20:
                            _context21.prev = 20;

                            if (!_didIteratorError161) {
                              _context21.next = 23;
                              break;
                            }

                            throw _iteratorError161;

                          case 23:
                            return _context21.finish(20);

                          case 24:
                            return _context21.finish(17);

                          case 25:
                          case "end":
                            return _context21.stop();
                        }
                      }
                    }, _callee, null, [[3, 13, 17, 25], [18,, 20, 24]]);
                  })(t);
                  _iteratorNormalCompletion162 = true;
                  _didIteratorError162 = false;
                  _iteratorError162 = undefined;
                  _context22.prev = 4;
                  _iterator162 = t[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion162 = (_step162 = _iterator162.next()).done) {
                    _context22.next = 12;
                    break;
                  }

                  _n107 = _step162.value;
                  return _context22.delegateYield(this._getValidRangesForRange(_n107, e), "t0", 9);

                case 9:
                  _iteratorNormalCompletion162 = true;
                  _context22.next = 6;
                  break;

                case 12:
                  _context22.next = 18;
                  break;

                case 14:
                  _context22.prev = 14;
                  _context22.t1 = _context22["catch"](4);
                  _didIteratorError162 = true;
                  _iteratorError162 = _context22.t1;

                case 18:
                  _context22.prev = 18;
                  _context22.prev = 19;

                  if (!_iteratorNormalCompletion162 && _iterator162.return != null) {
                    _iterator162.return();
                  }

                case 21:
                  _context22.prev = 21;

                  if (!_didIteratorError162) {
                    _context22.next = 24;
                    break;
                  }

                  throw _iteratorError162;

                case 24:
                  return _context22.finish(21);

                case 25:
                  return _context22.finish(18);

                case 26:
                case "end":
                  return _context22.stop();
              }
            }
          }, getValidRanges, this, [[4, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getNearestSelectionRange",
        value: function getNearestSelectionRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
          if (this.checkChild(t, "$text")) return new Js(t);
          var n, i;
          "both" != e && "backward" != e || (n = new $s({
            startPosition: t,
            direction: "backward"
          })), "both" != e && "forward" != e || (i = new $s({
            startPosition: t
          }));
          var _iteratorNormalCompletion163 = true;
          var _didIteratorError163 = false;
          var _iteratorError163 = undefined;

          try {
            for (var _iterator163 =
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(t, e) {
              var n, _e126, _t133;

              return _regeneratorRuntime.wrap(function _callee2$(_context23) {
                while (1) {
                  switch (_context23.prev = _context23.next) {
                    case 0:
                      n = !1;

                    case 1:
                      if (n) {
                        _context23.next = 18;
                        break;
                      }

                      if (!(n = !0, t)) {
                        _context23.next = 9;
                        break;
                      }

                      _e126 = t.next();
                      _context23.t0 = _e126.done;

                      if (_context23.t0) {
                        _context23.next = 9;
                        break;
                      }

                      n = !1;
                      _context23.next = 9;
                      return {
                        walker: t,
                        value: _e126.value
                      };

                    case 9:
                      if (!e) {
                        _context23.next = 16;
                        break;
                      }

                      _t133 = e.next();
                      _context23.t1 = _t133.done;

                      if (_context23.t1) {
                        _context23.next = 16;
                        break;
                      }

                      n = !1;
                      _context23.next = 16;
                      return {
                        walker: e,
                        value: _t133.value
                      };

                    case 16:
                      _context23.next = 1;
                      break;

                    case 18:
                    case "end":
                      return _context23.stop();
                  }
                }
              }, _callee2);
            })(n, i)[Symbol.iterator](), _step163; !(_iteratorNormalCompletion163 = (_step163 = _iterator163.next()).done); _iteratorNormalCompletion163 = true) {
              var _t132 = _step163.value;

              var _e125 = _t132.walker == n ? "elementEnd" : "elementStart",
                  _i78 = _t132.value;

              if (_i78.type == _e125 && this.isObject(_i78.item)) return Js._createOn(_i78.item);
              if (this.checkChild(_i78.nextPosition, "$text")) return new Js(_i78.nextPosition);
            }
          } catch (err) {
            _didIteratorError163 = true;
            _iteratorError163 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion163 && _iterator163.return != null) {
                _iterator163.return();
              }
            } finally {
              if (_didIteratorError163) {
                throw _iteratorError163;
              }
            }
          }

          return null;
        }
      }, {
        key: "findAllowedParent",
        value: function findAllowedParent(t, e) {
          var n = t.parent;

          for (; n;) {
            if (this.checkChild(n, e)) return n;
            if (this.isLimit(n)) return null;
            n = n.parent;
          }

          return null;
        }
      }, {
        key: "removeDisallowedAttributes",
        value: function removeDisallowedAttributes(t, e) {
          var _iteratorNormalCompletion164 = true;
          var _didIteratorError164 = false;
          var _iteratorError164 = undefined;

          try {
            for (var _iterator164 = t[Symbol.iterator](), _step164; !(_iteratorNormalCompletion164 = (_step164 = _iterator164.next()).done); _iteratorNormalCompletion164 = true) {
              var _n108 = _step164.value;
              if (_n108.is("text")) Ja(this, _n108, e);else {
                var _t134 = Js._createIn(_n108).getPositions();

                var _iteratorNormalCompletion165 = true;
                var _didIteratorError165 = false;
                var _iteratorError165 = undefined;

                try {
                  for (var _iterator165 = _t134[Symbol.iterator](), _step165; !(_iteratorNormalCompletion165 = (_step165 = _iterator165.next()).done); _iteratorNormalCompletion165 = true) {
                    var _n109 = _step165.value;
                    Ja(this, _n109.nodeBefore || _n109.parent, e);
                  }
                } catch (err) {
                  _didIteratorError165 = true;
                  _iteratorError165 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion165 && _iterator165.return != null) {
                      _iterator165.return();
                    }
                  } finally {
                    if (_didIteratorError165) {
                      throw _iteratorError165;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError164 = true;
            _iteratorError164 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion164 && _iterator164.return != null) {
                _iterator164.return();
              }
            } finally {
              if (_didIteratorError164) {
                throw _iteratorError164;
              }
            }
          }
        }
      }, {
        key: "createContext",
        value: function createContext(t) {
          return new Ba(t);
        }
      }, {
        key: "_clearCache",
        value: function _clearCache() {
          this._compiledDefinitions = null;
        }
      }, {
        key: "_compile",
        value: function _compile() {
          var t = {},
              e = this._sourceDefinitions,
              n = Object.keys(e);

          for (var _i79 = 0, _n110 = n; _i79 < _n110.length; _i79++) {
            var _i84 = _n110[_i79];
            t[_i84] = Fa(e[_i84], _i84);
          }

          for (var _i80 = 0, _n111 = n; _i80 < _n111.length; _i80++) {
            var _e127 = _n111[_i80];
            Ua(t, _e127);
          }

          for (var _i81 = 0, _n112 = n; _i81 < _n112.length; _i81++) {
            var _e128 = _n112[_i81];
            Ha(t, _e128);
          }

          for (var _i82 = 0, _n113 = n; _i82 < _n113.length; _i82++) {
            var _e129 = _n113[_i82];
            qa(t, _e129), Wa(t, _e129);
          }

          for (var _i83 = 0, _n114 = n; _i83 < _n114.length; _i83++) {
            var _e130 = _n114[_i83];
            Ya(t, _e130), $a(t, _e130);
          }

          this._compiledDefinitions = t;
        }
      }, {
        key: "_checkContextMatch",
        value: function _checkContextMatch(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
          var i = e.getItem(n);

          if (t.allowIn.includes(i.name)) {
            if (0 == n) return !0;
            {
              var _t135 = this.getDefinition(i);

              return this._checkContextMatch(_t135, e, n - 1);
            }
          }

          return !1;
        }
      }, {
        key: "_getValidRangesForRange",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _getValidRangesForRange(t, e) {
          var n, i, _iteratorNormalCompletion166, _didIteratorError166, _iteratorError166, _iterator166, _step166, _o38;

          return _regeneratorRuntime.wrap(function _getValidRangesForRange$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  n = t.start, i = t.start;
                  _iteratorNormalCompletion166 = true;
                  _didIteratorError166 = false;
                  _iteratorError166 = undefined;
                  _context24.prev = 4;
                  _iterator166 = t.getItems({
                    shallow: !0
                  })[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion166 = (_step166 = _iterator166.next()).done) {
                    _context24.next = 22;
                    break;
                  }

                  _o38 = _step166.value;
                  _context24.t0 = _o38.is("element");

                  if (!_context24.t0) {
                    _context24.next = 11;
                    break;
                  }

                  return _context24.delegateYield(this._getValidRangesForRange(Js._createIn(_o38), e), "t1", 11);

                case 11:
                  _context24.t2 = this.checkAttribute(_o38, e);

                  if (_context24.t2) {
                    _context24.next = 18;
                    break;
                  }

                  _context24.t3 = n.isEqual(i);

                  if (_context24.t3) {
                    _context24.next = 17;
                    break;
                  }

                  _context24.next = 17;
                  return new Js(n, i);

                case 17:
                  n = Ks._createAfter(_o38);

                case 18:
                  i = Ks._createAfter(_o38);

                case 19:
                  _iteratorNormalCompletion166 = true;
                  _context24.next = 6;
                  break;

                case 22:
                  _context24.next = 28;
                  break;

                case 24:
                  _context24.prev = 24;
                  _context24.t4 = _context24["catch"](4);
                  _didIteratorError166 = true;
                  _iteratorError166 = _context24.t4;

                case 28:
                  _context24.prev = 28;
                  _context24.prev = 29;

                  if (!_iteratorNormalCompletion166 && _iterator166.return != null) {
                    _iterator166.return();
                  }

                case 31:
                  _context24.prev = 31;

                  if (!_didIteratorError166) {
                    _context24.next = 34;
                    break;
                  }

                  throw _iteratorError166;

                case 34:
                  return _context24.finish(31);

                case 35:
                  return _context24.finish(28);

                case 36:
                  _context24.t5 = n.isEqual(i);

                  if (_context24.t5) {
                    _context24.next = 40;
                    break;
                  }

                  _context24.next = 40;
                  return new Js(n, i);

                case 40:
                case "end":
                  return _context24.stop();
              }
            }
          }, _getValidRangesForRange, this, [[4, 24, 28, 36], [29,, 31, 35]]);
        })
      }]);

      return za;
    }();

    li(za, Ui);

    var Ba =
    /*#__PURE__*/
    function () {
      function Ba(t) {
        _classCallCheck(this, Ba);

        if (t instanceof Ba) return t;
        "string" == typeof t ? t = [t] : Array.isArray(t) || (t = t.getAncestors({
          includeSelf: !0
        })), t[0] && "string" != typeof t[0] && t[0].is("documentFragment") && t.shift(), this._items = t.map(Ka);
      }

      _createClass(Ba, [{
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "push",
        value: function push(t) {
          var e = new Ba([t]);
          return e._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(e._items)), e;
        }
      }, {
        key: "getItem",
        value: function getItem(t) {
          return this._items[t];
        }
      }, {
        key: "getNames",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getNames() {
          return _regeneratorRuntime.wrap(function getNames$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  return _context25.delegateYield(this._items.map(function (t) {
                    return t.name;
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context25.stop();
              }
            }
          }, getNames, this);
        })
      }, {
        key: "endsWith",
        value: function endsWith(t) {
          return Array.from(this.getNames()).join(" ").endsWith(t);
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this._items.length - 1];
        }
      }]);

      return Ba;
    }();

    function Fa(t, e) {
      var n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        inheritTypesFrom: []
      };
      return function (t, e) {
        var _iteratorNormalCompletion167 = true;
        var _didIteratorError167 = false;
        var _iteratorError167 = undefined;

        try {
          for (var _iterator167 = t[Symbol.iterator](), _step167; !(_iteratorNormalCompletion167 = (_step167 = _iterator167.next()).done); _iteratorNormalCompletion167 = true) {
            var _n115 = _step167.value;

            var _t136 = Object.keys(_n115).filter(function (t) {
              return t.startsWith("is");
            });

            var _iteratorNormalCompletion168 = true;
            var _didIteratorError168 = false;
            var _iteratorError168 = undefined;

            try {
              for (var _iterator168 = _t136[Symbol.iterator](), _step168; !(_iteratorNormalCompletion168 = (_step168 = _iterator168.next()).done); _iteratorNormalCompletion168 = true) {
                var _i85 = _step168.value;
                e[_i85] = _n115[_i85];
              }
            } catch (err) {
              _didIteratorError168 = true;
              _iteratorError168 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion168 && _iterator168.return != null) {
                  _iterator168.return();
                }
              } finally {
                if (_didIteratorError168) {
                  throw _iteratorError168;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError167 = true;
          _iteratorError167 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion167 && _iterator167.return != null) {
              _iterator167.return();
            }
          } finally {
            if (_didIteratorError167) {
              throw _iteratorError167;
            }
          }
        }
      }(t, n), Ga(t, n, "allowIn"), Ga(t, n, "allowContentOf"), Ga(t, n, "allowWhere"), Ga(t, n, "allowAttributes"), Ga(t, n, "allowAttributesOf"), Ga(t, n, "inheritTypesFrom"), function (t, e) {
        var _iteratorNormalCompletion169 = true;
        var _didIteratorError169 = false;
        var _iteratorError169 = undefined;

        try {
          for (var _iterator169 = t[Symbol.iterator](), _step169; !(_iteratorNormalCompletion169 = (_step169 = _iterator169.next()).done); _iteratorNormalCompletion169 = true) {
            var _n116 = _step169.value;
            var _t137 = _n116.inheritAllFrom;
            _t137 && (e.allowContentOf.push(_t137), e.allowWhere.push(_t137), e.allowAttributesOf.push(_t137), e.inheritTypesFrom.push(_t137));
          }
        } catch (err) {
          _didIteratorError169 = true;
          _iteratorError169 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion169 && _iterator169.return != null) {
              _iterator169.return();
            }
          } finally {
            if (_didIteratorError169) {
              throw _iteratorError169;
            }
          }
        }
      }(t, n), n;
    }

    function Ua(t, e) {
      var _iteratorNormalCompletion170 = true;
      var _didIteratorError170 = false;
      var _iteratorError170 = undefined;

      try {
        for (var _iterator170 = t[e].allowContentOf[Symbol.iterator](), _step170; !(_iteratorNormalCompletion170 = (_step170 = _iterator170.next()).done); _iteratorNormalCompletion170 = true) {
          var _n117 = _step170.value;

          if (t[_n117]) {
            Qa(t, _n117).forEach(function (t) {
              t.allowIn.push(e);
            });
          }
        }
      } catch (err) {
        _didIteratorError170 = true;
        _iteratorError170 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion170 && _iterator170.return != null) {
            _iterator170.return();
          }
        } finally {
          if (_didIteratorError170) {
            throw _iteratorError170;
          }
        }
      }

      delete t[e].allowContentOf;
    }

    function Ha(t, e) {
      var _iteratorNormalCompletion171 = true;
      var _didIteratorError171 = false;
      var _iteratorError171 = undefined;

      try {
        for (var _iterator171 = t[e].allowWhere[Symbol.iterator](), _step171; !(_iteratorNormalCompletion171 = (_step171 = _iterator171.next()).done); _iteratorNormalCompletion171 = true) {
          var _n118 = _step171.value;
          var _i86 = t[_n118];

          if (_i86) {
            var _t$e$allowIn;

            var _n119 = _i86.allowIn;

            (_t$e$allowIn = t[e].allowIn).push.apply(_t$e$allowIn, _toConsumableArray(_n119));
          }
        }
      } catch (err) {
        _didIteratorError171 = true;
        _iteratorError171 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion171 && _iterator171.return != null) {
            _iterator171.return();
          }
        } finally {
          if (_didIteratorError171) {
            throw _iteratorError171;
          }
        }
      }

      delete t[e].allowWhere;
    }

    function qa(t, e) {
      var _iteratorNormalCompletion172 = true;
      var _didIteratorError172 = false;
      var _iteratorError172 = undefined;

      try {
        for (var _iterator172 = t[e].allowAttributesOf[Symbol.iterator](), _step172; !(_iteratorNormalCompletion172 = (_step172 = _iterator172.next()).done); _iteratorNormalCompletion172 = true) {
          var _n120 = _step172.value;
          var _i87 = t[_n120];

          if (_i87) {
            var _t$e$allowAttributes;

            var _n121 = _i87.allowAttributes;

            (_t$e$allowAttributes = t[e].allowAttributes).push.apply(_t$e$allowAttributes, _toConsumableArray(_n121));
          }
        }
      } catch (err) {
        _didIteratorError172 = true;
        _iteratorError172 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion172 && _iterator172.return != null) {
            _iterator172.return();
          }
        } finally {
          if (_didIteratorError172) {
            throw _iteratorError172;
          }
        }
      }

      delete t[e].allowAttributesOf;
    }

    function Wa(t, e) {
      var n = t[e];
      var _iteratorNormalCompletion173 = true;
      var _didIteratorError173 = false;
      var _iteratorError173 = undefined;

      try {
        for (var _iterator173 = n.inheritTypesFrom[Symbol.iterator](), _step173; !(_iteratorNormalCompletion173 = (_step173 = _iterator173.next()).done); _iteratorNormalCompletion173 = true) {
          var _e131 = _step173.value;
          var _i88 = t[_e131];

          if (_i88) {
            var _t138 = Object.keys(_i88).filter(function (t) {
              return t.startsWith("is");
            });

            var _iteratorNormalCompletion174 = true;
            var _didIteratorError174 = false;
            var _iteratorError174 = undefined;

            try {
              for (var _iterator174 = _t138[Symbol.iterator](), _step174; !(_iteratorNormalCompletion174 = (_step174 = _iterator174.next()).done); _iteratorNormalCompletion174 = true) {
                var _e132 = _step174.value;
                _e132 in n || (n[_e132] = _i88[_e132]);
              }
            } catch (err) {
              _didIteratorError174 = true;
              _iteratorError174 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion174 && _iterator174.return != null) {
                  _iterator174.return();
                }
              } finally {
                if (_didIteratorError174) {
                  throw _iteratorError174;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError173 = true;
        _iteratorError173 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion173 && _iterator173.return != null) {
            _iterator173.return();
          }
        } finally {
          if (_didIteratorError173) {
            throw _iteratorError173;
          }
        }
      }

      delete n.inheritTypesFrom;
    }

    function Ya(t, e) {
      var n = t[e],
          i = n.allowIn.filter(function (e) {
        return t[e];
      });
      n.allowIn = Array.from(new Set(i));
    }

    function $a(t, e) {
      var n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }

    function Ga(t, e, n) {
      var _iteratorNormalCompletion175 = true;
      var _didIteratorError175 = false;
      var _iteratorError175 = undefined;

      try {
        for (var _iterator175 = t[Symbol.iterator](), _step175; !(_iteratorNormalCompletion175 = (_step175 = _iterator175.next()).done); _iteratorNormalCompletion175 = true) {
          var _e$n;

          var _i89 = _step175.value;
          "string" == typeof _i89[n] ? e[n].push(_i89[n]) : Array.isArray(_i89[n]) && (_e$n = e[n]).push.apply(_e$n, _toConsumableArray(_i89[n]));
        }
      } catch (err) {
        _didIteratorError175 = true;
        _iteratorError175 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion175 && _iterator175.return != null) {
            _iterator175.return();
          }
        } finally {
          if (_didIteratorError175) {
            throw _iteratorError175;
          }
        }
      }
    }

    function Qa(t, e) {
      var n = t[e];
      return (i = t, Object.keys(i).map(function (t) {
        return i[t];
      })).filter(function (t) {
        return t.allowIn.includes(n.name);
      });
      var i;
    }

    function Ka(t) {
      return "string" == typeof t ? {
        name: t,
        getAttributeKeys:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                case "end":
                  return _context26.stop();
              }
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute() {}
      } : {
        name: t.is("element") ? t.name : "$text",
        getAttributeKeys:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  return _context27.delegateYield(t.getAttributeKeys(), "t0", 1);

                case 1:
                case "end":
                  return _context27.stop();
              }
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute(e) {
          return t.getAttribute(e);
        }
      };
    }

    function Ja(t, e, n) {
      var _iteratorNormalCompletion176 = true;
      var _didIteratorError176 = false;
      var _iteratorError176 = undefined;

      try {
        for (var _iterator176 = e.getAttributeKeys()[Symbol.iterator](), _step176; !(_iteratorNormalCompletion176 = (_step176 = _iterator176.next()).done); _iteratorNormalCompletion176 = true) {
          var _i90 = _step176.value;
          t.checkAttribute(e, _i90) || n.removeAttribute(_i90, e);
        }
      } catch (err) {
        _didIteratorError176 = true;
        _iteratorError176 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion176 && _iterator176.return != null) {
            _iterator176.return();
          }
        } finally {
          if (_didIteratorError176) {
            throw _iteratorError176;
          }
        }
      }
    }

    var Za =
    /*#__PURE__*/
    function () {
      function Za() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Za);

        this._splitParts = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, t), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
      }

      _createClass(Za, [{
        key: "convert",
        value: function convert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
          this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
            var n;
            var _iteratorNormalCompletion177 = true;
            var _didIteratorError177 = false;
            var _iteratorError177 = undefined;

            try {
              for (var _iterator177 = new Ba(t)[Symbol.iterator](), _step177; !(_iteratorNormalCompletion177 = (_step177 = _iterator177.next()).done); _iteratorNormalCompletion177 = true) {
                var _i91 = _step177.value;
                var _t139 = {};
                var _iteratorNormalCompletion178 = true;
                var _didIteratorError178 = false;
                var _iteratorError178 = undefined;

                try {
                  for (var _iterator178 = _i91.getAttributeKeys()[Symbol.iterator](), _step178; !(_iteratorNormalCompletion178 = (_step178 = _iterator178.next()).done); _iteratorNormalCompletion178 = true) {
                    var _e133 = _step178.value;
                    _t139[_e133] = _i91.getAttribute(_e133);
                  }
                } catch (err) {
                  _didIteratorError178 = true;
                  _iteratorError178 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion178 && _iterator178.return != null) {
                      _iterator178.return();
                    }
                  } finally {
                    if (_didIteratorError178) {
                      throw _iteratorError178;
                    }
                  }
                }

                var _o39 = e.createElement(_i91.name, _t139);

                n && e.append(_o39, n), n = Ks._createAt(_o39, 0);
              }
            } catch (err) {
              _didIteratorError177 = true;
              _iteratorError177 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion177 && _iterator177.return != null) {
                  _iterator177.return();
                }
              } finally {
                if (_didIteratorError177) {
                  throw _iteratorError177;
                }
              }
            }

            return n;
          }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = ja.createFrom(t), this.conversionApi.store = {};

          var _this$_convertItem = this._convertItem(t, this._modelCursor),
              i = _this$_convertItem.modelRange,
              o = e.createDocumentFragment();

          if (i) {
            this._removeEmptyElements();

            for (var _i92 = 0, _Array$from5 = Array.from(this._modelCursor.parent.getChildren()); _i92 < _Array$from5.length; _i92++) {
              var _t142 = _Array$from5[_i92];
              e.append(_t142, o);
            }

            o.markers = function (t, e) {
              var n = new Set(),
                  i = new Map(),
                  o = Js._createIn(t).getItems();

              var _iteratorNormalCompletion179 = true;
              var _didIteratorError179 = false;
              var _iteratorError179 = undefined;

              try {
                for (var _iterator179 = o[Symbol.iterator](), _step179; !(_iteratorNormalCompletion179 = (_step179 = _iterator179.next()).done); _iteratorNormalCompletion179 = true) {
                  var _t140 = _step179.value;
                  "$marker" == _t140.name && n.add(_t140);
                }
              } catch (err) {
                _didIteratorError179 = true;
                _iteratorError179 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion179 && _iterator179.return != null) {
                    _iterator179.return();
                  }
                } finally {
                  if (_didIteratorError179) {
                    throw _iteratorError179;
                  }
                }
              }

              var _iteratorNormalCompletion180 = true;
              var _didIteratorError180 = false;
              var _iteratorError180 = undefined;

              try {
                for (var _iterator180 = n[Symbol.iterator](), _step180; !(_iteratorNormalCompletion180 = (_step180 = _iterator180.next()).done); _iteratorNormalCompletion180 = true) {
                  var _t141 = _step180.value;

                  var _n122 = _t141.getAttribute("data-name"),
                      _o40 = e.createPositionBefore(_t141);

                  i.has(_n122) ? i.get(_n122).end = _o40.clone() : i.set(_n122, new Js(_o40.clone())), e.remove(_t141);
                }
              } catch (err) {
                _didIteratorError180 = true;
                _iteratorError180 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion180 && _iterator180.return != null) {
                    _iterator180.return();
                  }
                } finally {
                  if (_didIteratorError180) {
                    throw _iteratorError180;
                  }
                }
              }

              return i;
            }(o, e);
          }

          return this._modelCursor = null, this._splitParts.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
        }
      }, {
        key: "_convertItem",
        value: function _convertItem(t, e) {
          var n = Object.assign({
            viewItem: t,
            modelCursor: e,
            modelRange: null
          });
          if (t.is("element") ? this.fire("element:" + t.name, n, this.conversionApi) : t.is("text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof Js)) throw new Qn.b("view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.", this);
          return {
            modelRange: n.modelRange,
            modelCursor: n.modelCursor
          };
        }
      }, {
        key: "_convertChildren",
        value: function _convertChildren(t, e) {
          var n = new Js(e);
          var i = e;

          for (var _i93 = 0, _Array$from6 = Array.from(t.getChildren()); _i93 < _Array$from6.length; _i93++) {
            var _e134 = _Array$from6[_i93];

            var _t143 = this._convertItem(_e134, i);

            _t143.modelRange instanceof Js && (n.end = _t143.modelRange.end, i = _t143.modelCursor);
          }

          return {
            modelRange: n,
            modelCursor: i
          };
        }
      }, {
        key: "_splitToAllowedParent",
        value: function _splitToAllowedParent(t, e) {
          var n = this.conversionApi.schema.findAllowedParent(e, t);
          if (!n) return null;
          if (n === e.parent) return {
            position: e
          };
          if (this._modelCursor.parent.getAncestors().includes(n)) return null;
          var i = this.conversionApi.writer.split(e, n),
              o = [];
          var _iteratorNormalCompletion181 = true;
          var _didIteratorError181 = false;
          var _iteratorError181 = undefined;

          try {
            for (var _iterator181 = i.range.getWalker()[Symbol.iterator](), _step181; !(_iteratorNormalCompletion181 = (_step181 = _iterator181.next()).done); _iteratorNormalCompletion181 = true) {
              var _t144 = _step181.value;
              if ("elementEnd" == _t144.type) o.push(_t144.item);else {
                var _e135 = o.pop(),
                    _n123 = _t144.item;

                this._registerSplitPair(_e135, _n123);
              }
            }
          } catch (err) {
            _didIteratorError181 = true;
            _iteratorError181 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion181 && _iterator181.return != null) {
                _iterator181.return();
              }
            } finally {
              if (_didIteratorError181) {
                throw _iteratorError181;
              }
            }
          }

          return {
            position: i.position,
            cursorParent: i.range.end.parent
          };
        }
      }, {
        key: "_registerSplitPair",
        value: function _registerSplitPair(t, e) {
          this._splitParts.has(t) || this._splitParts.set(t, [t]);

          var n = this._splitParts.get(t);

          this._splitParts.set(e, n), n.push(e);
        }
      }, {
        key: "_getSplitParts",
        value: function _getSplitParts(t) {
          var e;
          return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t], e;
        }
      }, {
        key: "_removeEmptyElements",
        value: function _removeEmptyElements() {
          var t = !1;
          var _iteratorNormalCompletion182 = true;
          var _didIteratorError182 = false;
          var _iteratorError182 = undefined;

          try {
            for (var _iterator182 = this._splitParts.keys()[Symbol.iterator](), _step182; !(_iteratorNormalCompletion182 = (_step182 = _iterator182.next()).done); _iteratorNormalCompletion182 = true) {
              var _e136 = _step182.value;
              _e136.isEmpty && (this.conversionApi.writer.remove(_e136), this._splitParts.delete(_e136), t = !0);
            }
          } catch (err) {
            _didIteratorError182 = true;
            _iteratorError182 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion182 && _iterator182.return != null) {
                _iterator182.return();
              }
            } finally {
              if (_didIteratorError182) {
                throw _iteratorError182;
              }
            }
          }

          t && this._removeEmptyElements();
        }
      }]);

      return Za;
    }();

    li(Za, ni);

    var Xa =
    /*#__PURE__*/
    function () {
      function Xa(t, e) {
        var _this50 = this;

        _classCallCheck(this, Xa);

        this.model = t, this.processor = e, this.mapper = new Zs(), this.downcastDispatcher = new ea({
          mapper: this.mapper
        }), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var i = n.writer,
              o = n.mapper.toViewPosition(e.range.start),
              r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new Za({
          schema: t.schema
        }), this.upcastDispatcher.on("text", function (t, e, n) {
          if (n.schema.checkChild(e.modelCursor, "$text") && n.consumable.consume(e.viewItem)) {
            var _t145 = n.writer.createText(e.viewItem.data);

            n.writer.insert(_t145, e.modelCursor), e.modelRange = Js._createFromPositionAndShift(e.modelCursor, _t145.offsetSize), e.modelCursor = e.modelRange.end;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren = n.convertChildren(e.viewItem, e.modelCursor),
                _t146 = _n$convertChildren.modelRange,
                _i94 = _n$convertChildren.modelCursor;

            e.modelRange = _t146, e.modelCursor = _i94;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren2 = n.convertChildren(e.viewItem, e.modelCursor),
                _t147 = _n$convertChildren2.modelRange,
                _i95 = _n$convertChildren2.modelCursor;

            e.modelRange = _t147, e.modelCursor = _i95;
          }
        }, {
          priority: "lowest"
        }), this.decorate("init"), this.on("init", function () {
          _this50.fire("ready");
        }, {
          priority: "lowest"
        });
      }

      _createClass(Xa, [{
        key: "get",
        value: function get(t) {
          var _ref44 = t || {},
              _ref44$rootName = _ref44.rootName,
              e = _ref44$rootName === void 0 ? "main" : _ref44$rootName,
              _ref44$trim = _ref44.trim,
              n = _ref44$trim === void 0 ? "empty" : _ref44$trim;

          if (!this._checkIfRootsExists([e])) throw new Qn.b("datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.", this);
          var i = this.model.document.getRoot(e);
          return "empty" !== n || this.model.hasContent(i, {
            ignoreWhitespaces: !0
          }) ? this.stringify(i) : "";
        }
      }, {
        key: "stringify",
        value: function stringify(t) {
          var e = this.toView(t);
          return this.processor.toData(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          this.mapper.clearBindings();

          var e = Js._createIn(t),
              n = new Co(),
              i = new Po(new so());

          if (this.mapper.bindElements(t, n), this.downcastDispatcher.convertInsert(e, i), !t.is("documentFragment")) {
            var _e137 = function (t) {
              var e = [],
                  n = t.root.document;
              if (!n) return [];

              var i = Js._createIn(t);

              var _iteratorNormalCompletion183 = true;
              var _didIteratorError183 = false;
              var _iteratorError183 = undefined;

              try {
                for (var _iterator183 = n.model.markers[Symbol.iterator](), _step183; !(_iteratorNormalCompletion183 = (_step183 = _iterator183.next()).done); _iteratorNormalCompletion183 = true) {
                  var _t148 = _step183.value;

                  var _n124 = i.getIntersection(_t148.getRange());

                  _n124 && e.push([_t148.name, _n124]);
                }
              } catch (err) {
                _didIteratorError183 = true;
                _iteratorError183 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion183 && _iterator183.return != null) {
                    _iterator183.return();
                  }
                } finally {
                  if (_didIteratorError183) {
                    throw _iteratorError183;
                  }
                }
              }

              return e;
            }(t);

            var _iteratorNormalCompletion184 = true;
            var _didIteratorError184 = false;
            var _iteratorError184 = undefined;

            try {
              for (var _iterator184 = _e137[Symbol.iterator](), _step184; !(_iteratorNormalCompletion184 = (_step184 = _iterator184.next()).done); _iteratorNormalCompletion184 = true) {
                var _ref47 = _step184.value;

                var _ref46 = _slicedToArray(_ref47, 2);

                var _t149 = _ref46[0];
                var _n125 = _ref46[1];
                this.downcastDispatcher.convertMarkerAdd(_t149, _n125, i);
              }
            } catch (err) {
              _didIteratorError184 = true;
              _iteratorError184 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion184 && _iterator184.return != null) {
                  _iterator184.return();
                }
              } finally {
                if (_didIteratorError184) {
                  throw _iteratorError184;
                }
              }
            }
          }

          return n;
        }
      }, {
        key: "init",
        value: function init(t) {
          var _this51 = this;

          if (this.model.document.version) throw new Qn.b("datacontroller-init-document-not-empty: Trying to set initial data to not empty document.", this);
          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new Qn.b("datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.", this);
          return this.model.enqueueChange("transparent", function (t) {
            for (var _i96 = 0, _Object$keys = Object.keys(e); _i96 < _Object$keys.length; _i96++) {
              var _n126 = _Object$keys[_i96];

              var _i97 = _this51.model.document.getRoot(_n126);

              t.insert(_this51.parse(e[_n126], _i97), _i97, 0);
            }
          }), Promise.resolve();
        }
      }, {
        key: "set",
        value: function set(t) {
          var _this52 = this;

          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new Qn.b("datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.", this);
          this.model.enqueueChange("transparent", function (t) {
            t.setSelection(null), t.removeSelectionAttribute(_this52.model.document.selection.getAttributeKeys());

            for (var _i98 = 0, _Object$keys2 = Object.keys(e); _i98 < _Object$keys2.length; _i98++) {
              var _n127 = _Object$keys2[_i98];

              var _i99 = _this52.model.document.getRoot(_n127);

              t.remove(t.createRangeIn(_i99)), t.insert(_this52.parse(e[_n127], _i99), _i99, 0);
            }
          });
        }
      }, {
        key: "parse",
        value: function parse(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          var n = this.processor.toView(t);
          return this.toModel(n, e);
        }
      }, {
        key: "toModel",
        value: function toModel(t) {
          var _this53 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          return this.model.change(function (n) {
            return _this53.upcastDispatcher.convert(t, n, e);
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_checkIfRootsExists",
        value: function _checkIfRootsExists(t) {
          var _iteratorNormalCompletion185 = true;
          var _didIteratorError185 = false;
          var _iteratorError185 = undefined;

          try {
            for (var _iterator185 = t[Symbol.iterator](), _step185; !(_iteratorNormalCompletion185 = (_step185 = _iterator185.next()).done); _iteratorNormalCompletion185 = true) {
              var _e138 = _step185.value;
              if (!this.model.document.getRootNames().includes(_e138)) return !1;
            }
          } catch (err) {
            _didIteratorError185 = true;
            _iteratorError185 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion185 && _iterator185.return != null) {
                _iterator185.return();
              }
            } finally {
              if (_didIteratorError185) {
                throw _iteratorError185;
              }
            }
          }

          return !0;
        }
      }]);

      return Xa;
    }();

    li(Xa, Ui);

    var tc =
    /*#__PURE__*/
    function () {
      function tc(t, e) {
        _classCallCheck(this, tc);

        this._helpers = new Map(), this._downcast = Array.isArray(t) ? t : [t], this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = Array.isArray(e) ? e : [e], this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }

      _createClass(tc, [{
        key: "addAlias",
        value: function addAlias(t, e) {
          var n = this._downcast.includes(e);

          if (!this._upcast.includes(e) && !n) throw new Qn.b("conversion-add-alias-dispatcher-not-registered: Trying to register and alias for a dispatcher that nas not been registered.", this);

          this._createConversionHelpers({
            name: t,
            dispatchers: [e],
            isDowncast: n
          });
        }
      }, {
        key: "for",
        value: function _for(t) {
          if (!this._helpers.has(t)) throw new Qn.b("conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.", this);
          return this._helpers.get(t);
        }
      }, {
        key: "elementToElement",
        value: function elementToElement(t) {
          this.for("downcast").elementToElement(t);
          var _iteratorNormalCompletion186 = true;
          var _didIteratorError186 = false;
          var _iteratorError186 = undefined;

          try {
            for (var _iterator186 = ec(t)[Symbol.iterator](), _step186; !(_iteratorNormalCompletion186 = (_step186 = _iterator186.next()).done); _iteratorNormalCompletion186 = true) {
              var _ref49 = _step186.value;
              var _e139 = _ref49.model;
              var _n128 = _ref49.view;
              this.for("upcast").elementToElement({
                model: _e139,
                view: _n128,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _didIteratorError186 = true;
            _iteratorError186 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion186 && _iterator186.return != null) {
                _iterator186.return();
              }
            } finally {
              if (_didIteratorError186) {
                throw _iteratorError186;
              }
            }
          }
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          this.for("downcast").attributeToElement(t);
          var _iteratorNormalCompletion187 = true;
          var _didIteratorError187 = false;
          var _iteratorError187 = undefined;

          try {
            for (var _iterator187 = ec(t)[Symbol.iterator](), _step187; !(_iteratorNormalCompletion187 = (_step187 = _iterator187.next()).done); _iteratorNormalCompletion187 = true) {
              var _ref51 = _step187.value;
              var _e140 = _ref51.model;
              var _n129 = _ref51.view;
              this.for("upcast").elementToAttribute({
                view: _n129,
                model: _e140,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _didIteratorError187 = true;
            _iteratorError187 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion187 && _iterator187.return != null) {
                _iterator187.return();
              }
            } finally {
              if (_didIteratorError187) {
                throw _iteratorError187;
              }
            }
          }
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          this.for("downcast").attributeToAttribute(t);
          var _iteratorNormalCompletion188 = true;
          var _didIteratorError188 = false;
          var _iteratorError188 = undefined;

          try {
            for (var _iterator188 = ec(t)[Symbol.iterator](), _step188; !(_iteratorNormalCompletion188 = (_step188 = _iterator188.next()).done); _iteratorNormalCompletion188 = true) {
              var _ref53 = _step188.value;
              var _e141 = _ref53.model;
              var _n130 = _ref53.view;
              this.for("upcast").attributeToAttribute({
                view: _n130,
                model: _e141
              });
            }
          } catch (err) {
            _didIteratorError188 = true;
            _iteratorError188 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion188 && _iterator188.return != null) {
                _iterator188.return();
              }
            } finally {
              if (_didIteratorError188) {
                throw _iteratorError188;
              }
            }
          }
        }
      }, {
        key: "_createConversionHelpers",
        value: function _createConversionHelpers(_ref54) {
          var t = _ref54.name,
              e = _ref54.dispatchers,
              n = _ref54.isDowncast;
          if (this._helpers.has(t)) throw new Qn.b("conversion-group-exists: Trying to register a group name that has already been registered.", this);
          var i = n ? new ka(e) : new Ta(e);

          this._helpers.set(t, i);
        }
      }]);

      return tc;
    }();

    function ec(t) {
      var _iteratorNormalCompletion189, _didIteratorError189, _iteratorError189, _iterator189, _step189, _e142, _n131, _i100, _o41;

      return _regeneratorRuntime.wrap(function ec$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              if (!t.model.values) {
                _context28.next = 29;
                break;
              }

              _iteratorNormalCompletion189 = true;
              _didIteratorError189 = false;
              _iteratorError189 = undefined;
              _context28.prev = 4;
              _iterator189 = t.model.values[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion189 = (_step189 = _iterator189.next()).done) {
                _context28.next = 13;
                break;
              }

              _e142 = _step189.value;
              _n131 = {
                key: t.model.key,
                value: _e142
              }, _i100 = t.view[_e142], _o41 = t.upcastAlso ? t.upcastAlso[_e142] : void 0;
              return _context28.delegateYield(nc(_n131, _i100, _o41), "t0", 10);

            case 10:
              _iteratorNormalCompletion189 = true;
              _context28.next = 6;
              break;

            case 13:
              _context28.next = 19;
              break;

            case 15:
              _context28.prev = 15;
              _context28.t1 = _context28["catch"](4);
              _didIteratorError189 = true;
              _iteratorError189 = _context28.t1;

            case 19:
              _context28.prev = 19;
              _context28.prev = 20;

              if (!_iteratorNormalCompletion189 && _iterator189.return != null) {
                _iterator189.return();
              }

            case 22:
              _context28.prev = 22;

              if (!_didIteratorError189) {
                _context28.next = 25;
                break;
              }

              throw _iteratorError189;

            case 25:
              return _context28.finish(22);

            case 26:
              return _context28.finish(19);

            case 27:
              _context28.next = 30;
              break;

            case 29:
              return _context28.delegateYield(nc(t.model, t.view, t.upcastAlso), "t2", 30);

            case 30:
            case "end":
              return _context28.stop();
          }
        }
      }, _marked, null, [[4, 15, 19, 27], [20,, 22, 26]]);
    }

    function nc(t, e, n) {
      var _iteratorNormalCompletion190, _didIteratorError190, _iteratorError190, _iterator190, _step190, _e143;

      return _regeneratorRuntime.wrap(function nc$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return {
                model: t,
                view: e
              };

            case 2:
              if (!n) {
                _context29.next = 30;
                break;
              }

              n = Array.isArray(n) ? n : [n];
              _iteratorNormalCompletion190 = true;
              _didIteratorError190 = false;
              _iteratorError190 = undefined;
              _context29.prev = 7;
              _iterator190 = n[Symbol.iterator]();

            case 9:
              if (_iteratorNormalCompletion190 = (_step190 = _iterator190.next()).done) {
                _context29.next = 16;
                break;
              }

              _e143 = _step190.value;
              _context29.next = 13;
              return {
                model: t,
                view: _e143
              };

            case 13:
              _iteratorNormalCompletion190 = true;
              _context29.next = 9;
              break;

            case 16:
              _context29.next = 22;
              break;

            case 18:
              _context29.prev = 18;
              _context29.t0 = _context29["catch"](7);
              _didIteratorError190 = true;
              _iteratorError190 = _context29.t0;

            case 22:
              _context29.prev = 22;
              _context29.prev = 23;

              if (!_iteratorNormalCompletion190 && _iterator190.return != null) {
                _iterator190.return();
              }

            case 25:
              _context29.prev = 25;

              if (!_didIteratorError190) {
                _context29.next = 28;
                break;
              }

              throw _iteratorError190;

            case 28:
              return _context29.finish(25);

            case 29:
              return _context29.finish(22);

            case 30:
            case "end":
              return _context29.stop();
          }
        }
      }, _marked2, null, [[7, 18, 22, 30], [23,, 25, 29]]);
    }

    var ic =
    /*#__PURE__*/
    function () {
      function ic() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";

        _classCallCheck(this, ic);

        this.operations = [], this.type = t;
      }

      _createClass(ic, [{
        key: "addOperation",
        value: function addOperation(t) {
          return t.batch = this, this.operations.push(t), t;
        }
      }, {
        key: "baseVersion",
        get: function get() {
          var _iteratorNormalCompletion191 = true;
          var _didIteratorError191 = false;
          var _iteratorError191 = undefined;

          try {
            for (var _iterator191 = this.operations[Symbol.iterator](), _step191; !(_iteratorNormalCompletion191 = (_step191 = _iterator191.next()).done); _iteratorNormalCompletion191 = true) {
              var _t150 = _step191.value;
              if (null !== _t150.baseVersion) return _t150.baseVersion;
            }
          } catch (err) {
            _didIteratorError191 = true;
            _iteratorError191 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion191 && _iterator191.return != null) {
                _iterator191.return();
              }
            } finally {
              if (_didIteratorError191) {
                throw _iteratorError191;
              }
            }
          }

          return null;
        }
      }]);

      return ic;
    }();

    var oc =
    /*#__PURE__*/
    function () {
      function oc(t) {
        _classCallCheck(this, oc);

        this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }

      _createClass(oc, [{
        key: "_validate",
        value: function _validate() {}
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = Object.assign({}, this);
          return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new this(t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "Operation";
        }
      }]);

      return oc;
    }();

    var rc =
    /*#__PURE__*/
    function () {
      function rc(t) {
        _classCallCheck(this, rc);

        this.markers = new Map(), this._children = new Ws(), t && this._insertChild(0, t);
      }

      _createClass(rc, [{
        key: Symbol.iterator,
        value: function value() {
          return this.getChildren();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" == t || "model:documentFragment" == t;
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "getPath",
        value: function getPath() {
          return [];
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iteratorNormalCompletion192 = true;
          var _didIteratorError192 = false;
          var _iteratorError192 = undefined;

          try {
            for (var _iterator192 = t[Symbol.iterator](), _step192; !(_iteratorNormalCompletion192 = (_step192 = _iterator192.next()).done); _iteratorNormalCompletion192 = true) {
              var _n132 = _step192.value;
              e = e.getChild(e.offsetToIndex(_n132));
            }
          } catch (err) {
            _didIteratorError192 = true;
            _iteratorError192 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion192 && _iterator192.return != null) {
                _iterator192.return();
              }
            } finally {
              if (_didIteratorError192) {
                throw _iteratorError192;
              }
            }
          }

          return e;
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = [];
          var _iteratorNormalCompletion193 = true;
          var _didIteratorError193 = false;
          var _iteratorError193 = undefined;

          try {
            for (var _iterator193 = this._children[Symbol.iterator](), _step193; !(_iteratorNormalCompletion193 = (_step193 = _iterator193.next()).done); _iteratorNormalCompletion193 = true) {
              var _e144 = _step193.value;
              t.push(_e144.toJSON());
            }
          } catch (err) {
            _didIteratorError193 = true;
            _iteratorError193 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion193 && _iterator193.return != null) {
                _iterator193.return();
              }
            } finally {
              if (_didIteratorError193) {
                throw _iteratorError193;
              }
            }
          }

          return t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new Hs(t)];
            bi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new Hs(t) : t instanceof qs ? new Hs(t.data, t.getAttributes()) : t;
            });
          }(e);

          var _iteratorNormalCompletion194 = true;
          var _didIteratorError194 = false;
          var _iteratorError194 = undefined;

          try {
            for (var _iterator194 = n[Symbol.iterator](), _step194; !(_iteratorNormalCompletion194 = (_step194 = _iterator194.next()).done); _iteratorNormalCompletion194 = true) {
              var _t151 = _step194.value;
              null !== _t151.parent && _t151._remove(), _t151.parent = this;
            }
          } catch (err) {
            _didIteratorError194 = true;
            _iteratorError194 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion194 && _iterator194.return != null) {
                _iterator194.return();
              }
            } finally {
              if (_didIteratorError194) {
                throw _iteratorError194;
              }
            }
          }

          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var n = this._children._removeNodes(t, e);

          var _iteratorNormalCompletion195 = true;
          var _didIteratorError195 = false;
          var _iteratorError195 = undefined;

          try {
            for (var _iterator195 = n[Symbol.iterator](), _step195; !(_iteratorNormalCompletion195 = (_step195 = _iterator195.next()).done); _iteratorNormalCompletion195 = true) {
              var _t152 = _step195.value;
              _t152.parent = null;
            }
          } catch (err) {
            _didIteratorError195 = true;
            _iteratorError195 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion195 && _iterator195.return != null) {
                _iterator195.return();
              }
            } finally {
              if (_didIteratorError195) {
                throw _iteratorError195;
              }
            }
          }

          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = [];
          var _iteratorNormalCompletion196 = true;
          var _didIteratorError196 = false;
          var _iteratorError196 = undefined;

          try {
            for (var _iterator196 = t[Symbol.iterator](), _step196; !(_iteratorNormalCompletion196 = (_step196 = _iterator196.next()).done); _iteratorNormalCompletion196 = true) {
              var _n133 = _step196.value;
              _n133.name ? e.push(Ys.fromJSON(_n133)) : e.push(Hs.fromJSON(_n133));
            }
          } catch (err) {
            _didIteratorError196 = true;
            _iteratorError196 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion196 && _iterator196.return != null) {
                _iterator196.return();
              }
            } finally {
              if (_didIteratorError196) {
                throw _iteratorError196;
              }
            }
          }

          return new rc(e);
        }
      }]);

      return rc;
    }();

    function sc(t, e) {
      var n = (e = lc(e)).reduce(function (t, e) {
        return t + e.offsetSize;
      }, 0),
          i = t.parent;
      hc(t);
      var o = t.index;
      return i._insertChild(o, e), dc(i, o + e.length), dc(i, o), new Js(t, t.getShiftedBy(n));
    }

    function ac(t) {
      if (!t.isFlat) throw new Qn.b("operation-utils-remove-range-not-flat: Trying to remove a range which starts and ends in different element.", this);
      var e = t.start.parent;
      hc(t.start), hc(t.end);

      var n = e._removeChildren(t.start.index, t.end.index - t.start.index);

      return dc(e, t.start.index), n;
    }

    function cc(t, e) {
      if (!t.isFlat) throw new Qn.b("operation-utils-move-range-not-flat: Trying to move a range which starts and ends in different element.", this);
      var n = ac(t);
      return sc(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
    }

    function lc(t) {
      var e = [];
      t instanceof Array || (t = [t]);

      for (var _n134 = 0; _n134 < t.length; _n134++) {
        if ("string" == typeof t[_n134]) e.push(new Hs(t[_n134]));else if (t[_n134] instanceof qs) e.push(new Hs(t[_n134].data, t[_n134].getAttributes()));else if (t[_n134] instanceof rc || t[_n134] instanceof Ws) {
          var _iteratorNormalCompletion197 = true;
          var _didIteratorError197 = false;
          var _iteratorError197 = undefined;

          try {
            for (var _iterator197 = t[_n134][Symbol.iterator](), _step197; !(_iteratorNormalCompletion197 = (_step197 = _iterator197.next()).done); _iteratorNormalCompletion197 = true) {
              var _i101 = _step197.value;
              e.push(_i101);
            }
          } catch (err) {
            _didIteratorError197 = true;
            _iteratorError197 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion197 && _iterator197.return != null) {
                _iterator197.return();
              }
            } finally {
              if (_didIteratorError197) {
                throw _iteratorError197;
              }
            }
          }
        } else t[_n134] instanceof Us && e.push(t[_n134]);
      }

      for (var _t153 = 1; _t153 < e.length; _t153++) {
        var _n135 = e[_t153],
            _i102 = e[_t153 - 1];
        _n135 instanceof Hs && _i102 instanceof Hs && uc(_n135, _i102) && (e.splice(_t153 - 1, 2, new Hs(_i102.data + _n135.data, _i102.getAttributes())), _t153--);
      }

      return e;
    }

    function dc(t, e) {
      var n = t.getChild(e - 1),
          i = t.getChild(e);

      if (n && i && n.is("text") && i.is("text") && uc(n, i)) {
        var _o42 = new Hs(n.data + i.data, n.getAttributes());

        t._removeChildren(e - 1, 2), t._insertChild(e - 1, _o42);
      }
    }

    function hc(t) {
      var e = t.textNode,
          n = t.parent;

      if (e) {
        var _i103 = t.offset - e.startOffset,
            _o43 = e.index;

        n._removeChildren(_o43, 1);

        var _r14 = new Hs(e.data.substr(0, _i103), e.getAttributes()),
            _s12 = new Hs(e.data.substr(_i103), e.getAttributes());

        n._insertChild(_o43, [_r14, _s12]);
      }
    }

    function uc(t, e) {
      var n = t.getAttributes(),
          i = e.getAttributes();
      var _iteratorNormalCompletion198 = true;
      var _didIteratorError198 = false;
      var _iteratorError198 = undefined;

      try {
        for (var _iterator198 = n[Symbol.iterator](), _step198; !(_iteratorNormalCompletion198 = (_step198 = _iterator198.next()).done); _iteratorNormalCompletion198 = true) {
          var _t154 = _step198.value;
          if (_t154[1] !== e.getAttribute(_t154[0])) return !1;
          i.next();
        }
      } catch (err) {
        _didIteratorError198 = true;
        _iteratorError198 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion198 && _iterator198.return != null) {
            _iterator198.return();
          }
        } finally {
          if (_didIteratorError198) {
            throw _iteratorError198;
          }
        }
      }

      return i.next().done;
    }

    var fc = function fc(t, e) {
      return Xr(t, e);
    };

    var gc =
    /*#__PURE__*/
    function (_oc) {
      _inherits(gc, _oc);

      function gc(t, e, n, i, o) {
        var _this54;

        _classCallCheck(this, gc);

        _this54 = _possibleConstructorReturn(this, _getPrototypeOf(gc).call(this, o)), _this54.range = t.clone(), _this54.key = e, _this54.oldValue = void 0 === n ? null : n, _this54.newValue = void 0 === i ? null : i;
        return _this54;
      }

      _createClass(gc, [{
        key: "clone",
        value: function clone() {
          return new gc(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new gc(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(gc.prototype), "toJSON", this).call(this);

          return t.range = this.range.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (!this.range.isFlat) throw new Qn.b("attribute-operation-range-not-flat: The range to change is not flat.", this);
          var _iteratorNormalCompletion199 = true;
          var _didIteratorError199 = false;
          var _iteratorError199 = undefined;

          try {
            for (var _iterator199 = this.range.getItems({
              shallow: !0
            })[Symbol.iterator](), _step199; !(_iteratorNormalCompletion199 = (_step199 = _iterator199.next()).done); _iteratorNormalCompletion199 = true) {
              var _t155 = _step199.value;
              if (null !== this.oldValue && !fc(_t155.getAttribute(this.key), this.oldValue)) throw new Qn.b("attribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, {
                item: _t155,
                key: this.key,
                value: this.oldValue
              });
              if (null === this.oldValue && null !== this.newValue && _t155.hasAttribute(this.key)) throw new Qn.b("attribute-operation-attribute-exists: The attribute with given key already exists.", this, {
                node: _t155,
                key: this.key
              });
            }
          } catch (err) {
            _didIteratorError199 = true;
            _iteratorError199 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion199 && _iterator199.return != null) {
                _iterator199.return();
              }
            } finally {
              if (_didIteratorError199) {
                throw _iteratorError199;
              }
            }
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          fc(this.oldValue, this.newValue) || function (t, e, n) {
            hc(t.start), hc(t.end);
            var _iteratorNormalCompletion200 = true;
            var _didIteratorError200 = false;
            var _iteratorError200 = undefined;

            try {
              for (var _iterator200 = t.getItems({
                shallow: !0
              })[Symbol.iterator](), _step200; !(_iteratorNormalCompletion200 = (_step200 = _iterator200.next()).done); _iteratorNormalCompletion200 = true) {
                var _i104 = _step200.value;

                var _t156 = _i104.is("textProxy") ? _i104.textNode : _i104;

                null !== n ? _t156._setAttribute(e, n) : _t156._removeAttribute(e), dc(_t156.parent, _t156.index);
              }
            } catch (err) {
              _didIteratorError200 = true;
              _iteratorError200 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion200 && _iterator200.return != null) {
                  _iterator200.return();
                }
              } finally {
                if (_didIteratorError200) {
                  throw _iteratorError200;
                }
              }
            }

            dc(t.end.parent, t.end.index);
          }(this.range, this.key, this.newValue);
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new gc(Js.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "AttributeOperation";
        }
      }]);

      return gc;
    }(oc);

    var mc =
    /*#__PURE__*/
    function (_oc2) {
      _inherits(mc, _oc2);

      function mc(t, e) {
        var _this55;

        _classCallCheck(this, mc);

        _this55 = _possibleConstructorReturn(this, _getPrototypeOf(mc).call(this, null)), _this55.sourcePosition = t.clone(), _this55.howMany = e;
        return _this55;
      }

      _createClass(mc, [{
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(mc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = this.sourcePosition.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.sourcePosition.root.document) throw new Qn.b("detach-operation-on-document-node: Cannot detach document node.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          ac(Js._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
      }, {
        key: "type",
        get: function get() {
          return "detach";
        }
      }], [{
        key: "className",
        get: function get() {
          return "DetachOperation";
        }
      }]);

      return mc;
    }(oc);

    var pc =
    /*#__PURE__*/
    function (_oc3) {
      _inherits(pc, _oc3);

      function pc(t, e, n, i) {
        var _this56;

        _classCallCheck(this, pc);

        _this56 = _possibleConstructorReturn(this, _getPrototypeOf(pc).call(this, i)), _this56.sourcePosition = t.clone(), _this56.sourcePosition.stickiness = "toNext", _this56.howMany = e, _this56.targetPosition = n.clone(), _this56.targetPosition.stickiness = "toNone";
        return _this56;
      }

      _createClass(pc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
      }, {
        key: "getMovedRangeStart",
        value: function getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);

          return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
              e = this.targetPosition.parent,
              n = this.sourcePosition.offset,
              i = this.targetPosition.offset;
          if (n + this.howMany > t.maxOffset) throw new Qn.b("move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.", this);
          if (t === e && n < i && i < n + this.howMany) throw new Qn.b("move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.", this);

          if (this.sourcePosition.root == this.targetPosition.root && "prefix" == di(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
            var _t157 = this.sourcePosition.path.length - 1;

            if (this.targetPosition.path[_t157] >= n && this.targetPosition.path[_t157] < n + this.howMany) throw new Qn.b("move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          cc(Js._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(pc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Ks.fromJSON(t.sourcePosition, e),
              i = Ks.fromJSON(t.targetPosition, e);
          return new this(n, t.howMany, i, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MoveOperation";
        }
      }]);

      return pc;
    }(oc);

    var bc =
    /*#__PURE__*/
    function (_oc4) {
      _inherits(bc, _oc4);

      function bc(t, e, n) {
        var _this57;

        _classCallCheck(this, bc);

        _this57 = _possibleConstructorReturn(this, _getPrototypeOf(bc).call(this, n)), _this57.position = t.clone(), _this57.position.stickiness = "toNone", _this57.nodes = new Ws(lc(e)), _this57.shouldReceiveAttributes = !1;
        return _this57;
      }

      _createClass(bc, [{
        key: "clone",
        value: function clone() {
          var t = new Ws(_toConsumableArray(this.nodes).map(function (t) {
            return t._clone(!0);
          })),
              e = new bc(this.position, t, this.baseVersion);
          return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.position.root.document.graveyard,
              e = new Ks(t, [0]);
          return new pc(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.parent;
          if (!t || t.maxOffset < this.position.offset) throw new Qn.b("insert-operation-position-invalid: Insertion position is invalid.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.nodes;
          this.nodes = new Ws(_toConsumableArray(t).map(function (t) {
            return t._clone(!0);
          })), sc(this.position, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(bc.prototype), "toJSON", this).call(this);

          return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "insert";
        }
      }, {
        key: "howMany",
        get: function get() {
          return this.nodes.maxOffset;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = [];
          var _iteratorNormalCompletion201 = true;
          var _didIteratorError201 = false;
          var _iteratorError201 = undefined;

          try {
            for (var _iterator201 = t.nodes[Symbol.iterator](), _step201; !(_iteratorNormalCompletion201 = (_step201 = _iterator201.next()).done); _iteratorNormalCompletion201 = true) {
              var _e145 = _step201.value;
              _e145.name ? n.push(Ys.fromJSON(_e145)) : n.push(Hs.fromJSON(_e145));
            }
          } catch (err) {
            _didIteratorError201 = true;
            _iteratorError201 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion201 && _iterator201.return != null) {
                _iterator201.return();
              }
            } finally {
              if (_didIteratorError201) {
                throw _iteratorError201;
              }
            }
          }

          var i = new bc(Ks.fromJSON(t.position, e), n, t.baseVersion);
          return i.shouldReceiveAttributes = t.shouldReceiveAttributes, i;
        }
      }, {
        key: "className",
        get: function get() {
          return "InsertOperation";
        }
      }]);

      return bc;
    }(oc);

    var wc =
    /*#__PURE__*/
    function (_oc5) {
      _inherits(wc, _oc5);

      function wc(t, e, n, i, o, r) {
        var _this58;

        _classCallCheck(this, wc);

        _this58 = _possibleConstructorReturn(this, _getPrototypeOf(wc).call(this, r)), _this58.name = t, _this58.oldRange = e ? e.clone() : null, _this58.newRange = n ? n.clone() : null, _this58.affectsData = o, _this58._markers = i;
        return _this58;
      }

      _createClass(wc, [{
        key: "clone",
        value: function clone() {
          return new wc(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new wc(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.newRange ? "_set" : "_remove";

          this._markers[t](this.name, this.newRange, !0, this.affectsData);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(wc.prototype), "toJSON", this).call(this);

          return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
        }
      }, {
        key: "type",
        get: function get() {
          return "marker";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new wc(t.name, t.oldRange ? Js.fromJSON(t.oldRange, e) : null, t.newRange ? Js.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MarkerOperation";
        }
      }]);

      return wc;
    }(oc);

    var kc =
    /*#__PURE__*/
    function (_oc6) {
      _inherits(kc, _oc6);

      function kc(t, e, n, i) {
        var _this59;

        _classCallCheck(this, kc);

        _this59 = _possibleConstructorReturn(this, _getPrototypeOf(kc).call(this, i)), _this59.position = t, _this59.position.stickiness = "toNext", _this59.oldName = e, _this59.newName = n;
        return _this59;
      }

      _createClass(kc, [{
        key: "clone",
        value: function clone() {
          return new kc(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new kc(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.nodeAfter;
          if (!(t instanceof Ys)) throw new Qn.b("rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.", this);
          if (t.name !== this.oldName) throw new Qn.b("rename-operation-wrong-name: Element to change has different name than operation's old name.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          this.position.nodeAfter.name = this.newName;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(kc.prototype), "toJSON", this).call(this);

          return t.position = this.position.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "rename";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new kc(Ks.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RenameOperation";
        }
      }]);

      return kc;
    }(oc);

    var _c =
    /*#__PURE__*/
    function (_oc7) {
      _inherits(_c, _oc7);

      function _c(t, e, n, i, o) {
        var _this60;

        _classCallCheck(this, _c);

        _this60 = _possibleConstructorReturn(this, _getPrototypeOf(_c).call(this, o)), _this60.root = t, _this60.key = e, _this60.oldValue = n, _this60.newValue = i;
        return _this60;
      }

      _createClass(_c, [{
        key: "clone",
        value: function clone() {
          return new _c(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new _c(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment")) throw new Qn.b("rootattribute-operation-not-a-root: The element to change is not a root element.", this, {
            root: this.root,
            key: this.key
          });
          if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new Qn.b("rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, {
            root: this.root,
            key: this.key
          });
          if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new Qn.b("rootattribute-operation-attribute-exists: The attribute with given key already exists.", this, {
            root: this.root,
            key: this.key
          });
        }
      }, {
        key: "_execute",
        value: function _execute() {
          null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(_c.prototype), "toJSON", this).call(this);

          return t.root = this.root.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if (!e.getRoot(t.root)) throw new Qn.b("rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.", this, {
            rootName: t.root
          });
          return new _c(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RootAttributeOperation";
        }
      }]);

      return _c;
    }(oc);

    var vc =
    /*#__PURE__*/
    function (_oc8) {
      _inherits(vc, _oc8);

      function vc(t, e, n, i, o) {
        var _this61;

        _classCallCheck(this, vc);

        _this61 = _possibleConstructorReturn(this, _getPrototypeOf(vc).call(this, o)), _this61.sourcePosition = t.clone(), _this61.sourcePosition.stickiness = "toPrevious", _this61.howMany = e, _this61.targetPosition = n.clone(), _this61.targetPosition.stickiness = "toNext", _this61.graveyardPosition = i.clone();
        return _this61;
      }

      _createClass(vc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.targetPosition._getTransformedByMergeOperation(this),
              e = this.sourcePosition.path.slice(0, -1),
              n = new Ks(this.sourcePosition.root, e)._getTransformedByMergeOperation(this),
              i = new yc(t, this.howMany, this.graveyardPosition, this.baseVersion + 1);

          return i.insertionPosition = n, i;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
              e = this.targetPosition.parent;
          if (!t.parent) throw new Qn.b("merge-operation-source-position-invalid: Merge source position is invalid.", this);
          if (!e.parent) throw new Qn.b("merge-operation-target-position-invalid: Merge target position is invalid.", this);
          if (this.howMany != t.maxOffset) throw new Qn.b("merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.sourcePosition.parent;
          cc(Js._createIn(t), this.targetPosition), cc(Js._createOn(t), this.graveyardPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(vc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "merge";
        }
      }, {
        key: "deletionPosition",
        get: function get() {
          return new Ks(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new Js(this.sourcePosition, t);
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Ks.fromJSON(t.sourcePosition, e),
              i = Ks.fromJSON(t.targetPosition, e),
              o = Ks.fromJSON(t.graveyardPosition, e);
          return new this(n, t.howMany, i, o, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MergeOperation";
        }
      }]);

      return vc;
    }(oc);

    var yc =
    /*#__PURE__*/
    function (_oc9) {
      _inherits(yc, _oc9);

      function yc(t, e, n, i) {
        var _this62;

        _classCallCheck(this, yc);

        _this62 = _possibleConstructorReturn(this, _getPrototypeOf(yc).call(this, i)), _this62.splitPosition = t.clone(), _this62.splitPosition.stickiness = "toNext", _this62.howMany = e, _this62.insertionPosition = yc.getInsertionPosition(t), _this62.insertionPosition.stickiness = "toNone", _this62.graveyardPosition = n ? n.clone() : null, _this62.graveyardPosition && (_this62.graveyardPosition.stickiness = "toNext");
        return _this62;
      }

      _createClass(yc, [{
        key: "clone",
        value: function clone() {
          var t = new this.constructor(this.splitPosition, this.howMany, this.graveyardPosition, this.baseVersion);
          return t.insertionPosition = this.insertionPosition, t;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.splitPosition.root.document.graveyard,
              e = new Ks(t, [0]);
          return new vc(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.splitPosition.parent,
              e = this.splitPosition.offset;
          if (!t || t.maxOffset < e) throw new Qn.b("split-operation-position-invalid: Split position is invalid.", this);
          if (!t.parent) throw new Qn.b("split-operation-split-in-root: Cannot split root element.", this);
          if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new Qn.b("split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new Qn.b("split-operation-graveyard-position-invalid: Graveyard position invalid.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.splitPosition.parent;
          if (this.graveyardPosition) cc(Js._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
            var _e146 = t._clone();

            sc(this.insertionPosition, _e146);
          }
          cc(new Js(Ks._createAt(t, this.splitPosition.offset), Ks._createAt(t, t.maxOffset)), this.moveTargetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(yc.prototype), "toJSON", this).call(this);

          return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "split";
        }
      }, {
        key: "moveTargetPosition",
        get: function get() {
          var t = this.insertionPosition.path.slice();
          return t.push(0), new Ks(this.insertionPosition.root, t);
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new Js(this.splitPosition, t);
        }
      }], [{
        key: "getInsertionPosition",
        value: function getInsertionPosition(t) {
          var e = t.path.slice(0, -1);
          return e[e.length - 1]++, new Ks(t.root, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Ks.fromJSON(t.splitPosition, e),
              i = Ks.fromJSON(t.insertionPosition, e),
              o = t.graveyardPosition ? Ks.fromJSON(t.graveyardPosition, e) : null,
              r = new this(n, t.howMany, o, t.baseVersion);
          return r.insertionPosition = i, r;
        }
      }, {
        key: "className",
        get: function get() {
          return "SplitOperation";
        }
      }]);

      return yc;
    }(oc);

    var xc =
    /*#__PURE__*/
    function (_Ys) {
      _inherits(xc, _Ys);

      function xc(t, e) {
        var _this63;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";

        _classCallCheck(this, xc);

        _this63 = _possibleConstructorReturn(this, _getPrototypeOf(xc).call(this, e)), _this63._doc = t, _this63.rootName = n;
        return _this63;
      }

      _createClass(xc, [{
        key: "is",
        value: function is(t, e) {
          var n = t.replace("model:", "");
          return e ? "rootElement" == n && e == this.name || _get(_getPrototypeOf(xc.prototype), "is", this).call(this, t, e) : "rootElement" == n || _get(_getPrototypeOf(xc.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this.rootName;
        }
      }, {
        key: "document",
        get: function get() {
          return this._doc;
        }
      }]);

      return xc;
    }(Ys);

    var Ac =
    /*#__PURE__*/
    function () {
      function Ac(t, e) {
        _classCallCheck(this, Ac);

        this.model = t, this.batch = e;
      }

      _createClass(Ac, [{
        key: "createText",
        value: function createText(t, e) {
          return new Hs(t, e);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e) {
          return new Ys(t, e);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment() {
          return new rc();
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          if (this._assertWriterUsedCorrectly(), t instanceof Hs && "" == t.data) return;

          var i = Ks._createAt(e, n);

          if (t.parent) {
            if (Mc(t.root, i.root)) return void this.move(Js._createOn(t), i);
            if (t.root.document) throw new Qn.b("model-writer-insert-forbidden-move: Cannot move a node from a document to a different tree. It is forbidden to move a node that was already in a document outside of it.", this);
            this.remove(t);
          }

          var o = i.root.document ? i.root.document.version : null,
              r = new bc(i, t, o);

          if (t instanceof Hs && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof rc) {
            var _iteratorNormalCompletion202 = true;
            var _didIteratorError202 = false;
            var _iteratorError202 = undefined;

            try {
              for (var _iterator202 = t.markers[Symbol.iterator](), _step202; !(_iteratorNormalCompletion202 = (_step202 = _iterator202.next()).done); _iteratorNormalCompletion202 = true) {
                var _ref57 = _step202.value;

                var _ref56 = _slicedToArray(_ref57, 2);

                var _e147 = _ref56[0];
                var _n136 = _ref56[1];

                var _t158 = Ks._createAt(_n136.root, 0),
                    _o44 = {
                  range: new Js(_n136.start._getCombined(_t158, i), _n136.end._getCombined(_t158, i)),
                  usingOperation: !0,
                  affectsData: !0
                };

                this.model.markers.has(_e147) ? this.updateMarker(_e147, _o44) : this.addMarker(_e147, _o44);
              }
            } catch (err) {
              _didIteratorError202 = true;
              _iteratorError202 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion202 && _iterator202.return != null) {
                  _iterator202.return();
                }
              } finally {
                if (_didIteratorError202) {
                  throw _iteratorError202;
                }
              }
            }
          }
        }
      }, {
        key: "insertText",
        value: function insertText(t, e, n, i) {
          e instanceof rc || e instanceof Ys || e instanceof Ks ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, i);
        }
      }, {
        key: "insertElement",
        value: function insertElement(t, e, n, i) {
          e instanceof rc || e instanceof Ys || e instanceof Ks ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, i);
        }
      }, {
        key: "append",
        value: function append(t, e) {
          this.insert(t, e, "end");
        }
      }, {
        key: "appendText",
        value: function appendText(t, e, n) {
          e instanceof rc || e instanceof Ys ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
        }
      }, {
        key: "appendElement",
        value: function appendElement(t, e, n) {
          e instanceof rc || e instanceof Ys ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          if (this._assertWriterUsedCorrectly(), n instanceof Js) {
            var _i105 = n.getMinimalFlatRanges();

            var _iteratorNormalCompletion203 = true;
            var _didIteratorError203 = false;
            var _iteratorError203 = undefined;

            try {
              for (var _iterator203 = _i105[Symbol.iterator](), _step203; !(_iteratorNormalCompletion203 = (_step203 = _iterator203.next()).done); _iteratorNormalCompletion203 = true) {
                var _n137 = _step203.value;
                Tc(this, t, e, _n137);
              }
            } catch (err) {
              _didIteratorError203 = true;
              _iteratorError203 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion203 && _iterator203.return != null) {
                  _iterator203.return();
                }
              } finally {
                if (_didIteratorError203) {
                  throw _iteratorError203;
                }
              }
            }
          } else Cc(this, t, e, n);
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(t, e) {
          var _iteratorNormalCompletion204 = true;
          var _didIteratorError204 = false;
          var _iteratorError204 = undefined;

          try {
            for (var _iterator204 = Fs(t)[Symbol.iterator](), _step204; !(_iteratorNormalCompletion204 = (_step204 = _iterator204.next()).done); _iteratorNormalCompletion204 = true) {
              var _ref60 = _step204.value;

              var _ref59 = _slicedToArray(_ref60, 2);

              var _n138 = _ref59[0];
              var _i106 = _ref59[1];
              this.setAttribute(_n138, _i106, e);
            }
          } catch (err) {
            _didIteratorError204 = true;
            _iteratorError204 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion204 && _iterator204.return != null) {
                _iterator204.return();
              }
            } finally {
              if (_didIteratorError204) {
                throw _iteratorError204;
              }
            }
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), e instanceof Js) {
            var _n139 = e.getMinimalFlatRanges();

            var _iteratorNormalCompletion205 = true;
            var _didIteratorError205 = false;
            var _iteratorError205 = undefined;

            try {
              for (var _iterator205 = _n139[Symbol.iterator](), _step205; !(_iteratorNormalCompletion205 = (_step205 = _iterator205.next()).done); _iteratorNormalCompletion205 = true) {
                var _e148 = _step205.value;
                Tc(this, t, null, _e148);
              }
            } catch (err) {
              _didIteratorError205 = true;
              _iteratorError205 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion205 && _iterator205.return != null) {
                  _iterator205.return();
                }
              } finally {
                if (_didIteratorError205) {
                  throw _iteratorError205;
                }
              }
            }
          } else Cc(this, t, null, e);
        }
      }, {
        key: "clearAttributes",
        value: function clearAttributes(t) {
          var _this64 = this;

          this._assertWriterUsedCorrectly();

          var e = function e(t) {
            var _iteratorNormalCompletion206 = true;
            var _didIteratorError206 = false;
            var _iteratorError206 = undefined;

            try {
              for (var _iterator206 = t.getAttributeKeys()[Symbol.iterator](), _step206; !(_iteratorNormalCompletion206 = (_step206 = _iterator206.next()).done); _iteratorNormalCompletion206 = true) {
                var _e149 = _step206.value;

                _this64.removeAttribute(_e149, t);
              }
            } catch (err) {
              _didIteratorError206 = true;
              _iteratorError206 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion206 && _iterator206.return != null) {
                  _iterator206.return();
                }
              } finally {
                if (_didIteratorError206) {
                  throw _iteratorError206;
                }
              }
            }
          };

          if (t instanceof Js) {
            var _iteratorNormalCompletion207 = true;
            var _didIteratorError207 = false;
            var _iteratorError207 = undefined;

            try {
              for (var _iterator207 = t.getItems()[Symbol.iterator](), _step207; !(_iteratorNormalCompletion207 = (_step207 = _iterator207.next()).done); _iteratorNormalCompletion207 = true) {
                var _n140 = _step207.value;
                e(_n140);
              }
            } catch (err) {
              _didIteratorError207 = true;
              _iteratorError207 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion207 && _iterator207.return != null) {
                  _iterator207.return();
                }
              } finally {
                if (_didIteratorError207) {
                  throw _iteratorError207;
                }
              }
            }
          } else e(t);
        }
      }, {
        key: "move",
        value: function move(t, e, n) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof Js)) throw new Qn.b("writer-move-invalid-range: Invalid range to move.", this);
          if (!t.isFlat) throw new Qn.b("writer-move-range-not-flat: Range to move is not flat.", this);

          var i = Ks._createAt(e, n);

          if (i.isEqual(t.start)) return;
          if (this._addOperationForAffectedMarkers("move", t), !Mc(t.root, i.root)) throw new Qn.b("writer-move-different-document: Range is going to be moved between different documents.", this);
          var o = t.root.document ? t.root.document.version : null,
              r = new pc(t.start, t.end.offset - t.start.offset, i, o);
          this.batch.addOperation(r), this.model.applyOperation(r);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._assertWriterUsedCorrectly();

          var e = (t instanceof Js ? t : Js._createOn(t)).getMinimalFlatRanges().reverse();
          var _iteratorNormalCompletion208 = true;
          var _didIteratorError208 = false;
          var _iteratorError208 = undefined;

          try {
            for (var _iterator208 = e[Symbol.iterator](), _step208; !(_iteratorNormalCompletion208 = (_step208 = _iterator208.next()).done); _iteratorNormalCompletion208 = true) {
              var _t159 = _step208.value;
              this._addOperationForAffectedMarkers("move", _t159), Sc(_t159.start, _t159.end.offset - _t159.start.offset, this.batch, this.model);
            }
          } catch (err) {
            _didIteratorError208 = true;
            _iteratorError208 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion208 && _iterator208.return != null) {
                _iterator208.return();
              }
            } finally {
              if (_didIteratorError208) {
                throw _iteratorError208;
              }
            }
          }
        }
      }, {
        key: "merge",
        value: function merge(t) {
          this._assertWriterUsedCorrectly();

          var e = t.nodeBefore,
              n = t.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof Ys)) throw new Qn.b("writer-merge-no-element-before: Node before merge position must be an element.", this);
          if (!(n instanceof Ys)) throw new Qn.b("writer-merge-no-element-after: Node after merge position must be an element.", this);
          t.root.document ? this._merge(t) : this._mergeDetached(t);
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return this.model.createPositionFromPath(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return this.model.createPositionAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return this.model.createPositionAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return this.model.createPositionBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return this.model.createRange(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return this.model.createRangeIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return this.model.createRangeOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return this.model.createSelection(t, e, n);
        }
      }, {
        key: "_mergeDetached",
        value: function _mergeDetached(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          this.move(Js._createIn(n), Ks._createAt(e, "end")), this.remove(n);
        }
      }, {
        key: "_merge",
        value: function _merge(t) {
          var e = Ks._createAt(t.nodeBefore, "end"),
              n = Ks._createAt(t.nodeAfter, 0),
              i = t.root.document.graveyard,
              o = new Ks(i, [0]),
              r = t.root.document.version,
              s = new vc(n, t.nodeAfter.maxOffset, e, o, r);

          this.batch.addOperation(s), this.model.applyOperation(s);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof Ys)) throw new Qn.b("writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.", this);
          var n = t.root.document ? t.root.document.version : null,
              i = new kc(Ks._createBefore(t), t.name, e, n);
          this.batch.addOperation(i), this.model.applyOperation(i);
        }
      }, {
        key: "split",
        value: function split(t, e) {
          this._assertWriterUsedCorrectly();

          var n,
              i,
              o = t.parent;
          if (!o.parent) throw new Qn.b("writer-split-element-no-parent: Element with no parent can not be split.", this);
          if (e || (e = o.parent), !t.parent.getAncestors({
            includeSelf: !0
          }).includes(e)) throw new Qn.b("writer-split-invalid-limit-element: Limit element is not a position ancestor.", this);

          do {
            var _e150 = o.root.document ? o.root.document.version : null,
                _r15 = o.maxOffset - t.offset,
                _s13 = new yc(t, _r15, null, _e150);

            this.batch.addOperation(_s13), this.model.applyOperation(_s13), n || i || (n = o, i = t.parent.nextSibling), o = (t = this.createPositionAfter(t.parent)).parent;
          } while (o !== e);

          return {
            position: t,
            range: new Js(Ks._createAt(n, "end"), Ks._createAt(i, 0))
          };
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new Qn.b("writer-wrap-range-not-flat: Range to wrap is not flat.", this);
          var n = e instanceof Ys ? e : new Ys(e);
          if (n.childCount > 0) throw new Qn.b("writer-wrap-element-not-empty: Element to wrap with is not empty.", this);
          if (null !== n.parent) throw new Qn.b("writer-wrap-element-attached: Element to wrap with is already attached to tree model.", this);
          this.insert(n, t.start);
          var i = new Js(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
          this.move(i, Ks._createAt(n, 0));
        }
      }, {
        key: "unwrap",
        value: function unwrap(t) {
          if (this._assertWriterUsedCorrectly(), null === t.parent) throw new Qn.b("writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.", this);
          this.move(Js._createIn(t), this.createPositionAfter(t)), this.remove(t);
        }
      }, {
        key: "addMarker",
        value: function addMarker(t, e) {
          if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new Qn.b("writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.", this);
          var n = e.usingOperation,
              i = e.range,
              o = void 0 !== e.affectsData && e.affectsData;
          if (this.model.markers.has(t)) throw new Qn.b("writer-addMarker-marker-exists: Marker with provided name already exists.", this);
          if (!i) throw new Qn.b("writer-addMarker-no-range: Range parameter is required when adding a new marker.", this);
          return n ? (Pc(this, t, null, i, o), this.model.markers.get(t)) : this.model.markers._set(t, i, n, o);
        }
      }, {
        key: "updateMarker",
        value: function updateMarker(t, e) {
          this._assertWriterUsedCorrectly();

          var n = "string" == typeof t ? t : t.name,
              i = this.model.markers.get(n);
          if (!i) throw new Qn.b("writer-updateMarker-marker-not-exists: Marker with provided name does not exists.", this);
          if (!e) return void this.model.markers._refresh(i);
          var o = "boolean" == typeof e.usingOperation,
              r = "boolean" == typeof e.affectsData,
              s = r ? e.affectsData : i.affectsData;
          if (!o && !e.range && !r) throw new Qn.b("writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.", this);
          var a = i.getRange(),
              c = e.range ? e.range : a;
          o && e.usingOperation !== i.managedUsingOperations ? e.usingOperation ? Pc(this, n, null, c, s) : (Pc(this, n, a, null, s), this.model.markers._set(n, c, void 0, s)) : i.managedUsingOperations ? Pc(this, n, a, c, s) : this.model.markers._set(n, c, void 0, s);
        }
      }, {
        key: "removeMarker",
        value: function removeMarker(t) {
          this._assertWriterUsedCorrectly();

          var e = "string" == typeof t ? t : t.name;
          if (!this.model.markers.has(e)) throw new Qn.b("writer-removeMarker-no-marker: Trying to remove marker which does not exist.", this);
          var n = this.model.markers.get(e);
          n.managedUsingOperations ? Pc(this, e, n.getRange(), null, n.affectsData) : this.model.markers._remove(e);
        }
      }, {
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
        }
      }, {
        key: "setSelectionAttribute",
        value: function setSelectionAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else {
            var _iteratorNormalCompletion209 = true;
            var _didIteratorError209 = false;
            var _iteratorError209 = undefined;

            try {
              for (var _iterator209 = Fs(t)[Symbol.iterator](), _step209; !(_iteratorNormalCompletion209 = (_step209 = _iterator209.next()).done); _iteratorNormalCompletion209 = true) {
                var _ref63 = _step209.value;

                var _ref62 = _slicedToArray(_ref63, 2);

                var _e151 = _ref62[0];
                var _n141 = _ref62[1];

                this._setSelectionAttribute(_e151, _n141);
              }
            } catch (err) {
              _didIteratorError209 = true;
              _iteratorError209 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion209 && _iterator209.return != null) {
                  _iterator209.return();
                }
              } finally {
                if (_didIteratorError209) {
                  throw _iteratorError209;
                }
              }
            }
          }
        }
      }, {
        key: "removeSelectionAttribute",
        value: function removeSelectionAttribute(t) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else {
            var _iteratorNormalCompletion210 = true;
            var _didIteratorError210 = false;
            var _iteratorError210 = undefined;

            try {
              for (var _iterator210 = t[Symbol.iterator](), _step210; !(_iteratorNormalCompletion210 = (_step210 = _iterator210.next()).done); _iteratorNormalCompletion210 = true) {
                var _e152 = _step210.value;

                this._removeSelectionAttribute(_e152);
              }
            } catch (err) {
              _didIteratorError210 = true;
              _iteratorError210 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion210 && _iterator210.return != null) {
                  _iterator210.return();
                }
              } finally {
                if (_didIteratorError210) {
                  throw _iteratorError210;
                }
              }
            }
          }
        }
      }, {
        key: "overrideSelectionGravity",
        value: function overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
      }, {
        key: "restoreSelectionGravity",
        value: function restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t);
        }
      }, {
        key: "_setSelectionAttribute",
        value: function _setSelectionAttribute(t, e) {
          var n = this.model.document.selection;

          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            var _i107 = ua._getStoreAttributeKey(t);

            this.setAttribute(_i107, e, n.anchor.parent);
          }

          n._setAttribute(t, e);
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute(t) {
          var e = this.model.document.selection;

          if (e.isCollapsed && e.anchor.parent.isEmpty) {
            var _n142 = ua._getStoreAttributeKey(t);

            this.removeAttribute(_n142, e.anchor.parent);
          }

          e._removeAttribute(t);
        }
      }, {
        key: "_assertWriterUsedCorrectly",
        value: function _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) throw new Qn.b("writer-incorrect-use: Trying to use a writer outside the change() block.", this);
        }
      }, {
        key: "_addOperationForAffectedMarkers",
        value: function _addOperationForAffectedMarkers(t, e) {
          var _iteratorNormalCompletion211 = true;
          var _didIteratorError211 = false;
          var _iteratorError211 = undefined;

          try {
            for (var _iterator211 = this.model.markers[Symbol.iterator](), _step211; !(_iteratorNormalCompletion211 = (_step211 = _iterator211.next()).done); _iteratorNormalCompletion211 = true) {
              var _n143 = _step211.value;
              if (!_n143.managedUsingOperations) continue;

              var _i108 = _n143.getRange();

              var _o45 = !1;

              if ("move" == t) _o45 = e.containsPosition(_i108.start) || e.start.isEqual(_i108.start) || e.containsPosition(_i108.end) || e.end.isEqual(_i108.end);else {
                var _t160 = e.nodeBefore,
                    _n144 = e.nodeAfter,
                    _r16 = _i108.start.parent == _t160 && _i108.start.isAtEnd,
                    _s14 = _i108.end.parent == _n144 && 0 == _i108.end.offset,
                    _a8 = _i108.end.nodeAfter == _n144,
                    _c3 = _i108.start.nodeAfter == _n144;

                _o45 = _r16 || _s14 || _a8 || _c3;
              }
              _o45 && this.updateMarker(_n143.name, {
                range: _i108
              });
            }
          } catch (err) {
            _didIteratorError211 = true;
            _iteratorError211 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion211 && _iterator211.return != null) {
                _iterator211.return();
              }
            } finally {
              if (_didIteratorError211) {
                throw _iteratorError211;
              }
            }
          }
        }
      }]);

      return Ac;
    }();

    function Tc(t, e, n, i) {
      var o = t.model,
          r = o.document;
      var s,
          a,
          c,
          l = i.start;
      var _iteratorNormalCompletion212 = true;
      var _didIteratorError212 = false;
      var _iteratorError212 = undefined;

      try {
        for (var _iterator212 = i.getWalker({
          shallow: !0
        })[Symbol.iterator](), _step212; !(_iteratorNormalCompletion212 = (_step212 = _iterator212.next()).done); _iteratorNormalCompletion212 = true) {
          var _t161 = _step212.value;
          c = _t161.item.getAttribute(e), s && a != c && (a != n && d(), l = s), s = _t161.nextPosition, a = c;
        }
      } catch (err) {
        _didIteratorError212 = true;
        _iteratorError212 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion212 && _iterator212.return != null) {
            _iterator212.return();
          }
        } finally {
          if (_didIteratorError212) {
            throw _iteratorError212;
          }
        }
      }

      function d() {
        var i = new Js(l, s),
            c = i.root.document ? r.version : null,
            d = new gc(i, e, a, n, c);
        t.batch.addOperation(d), o.applyOperation(d);
      }

      s instanceof Ks && s != l && a != n && d();
    }

    function Cc(t, e, n, i) {
      var o = t.model,
          r = o.document,
          s = i.getAttribute(e);
      var a, c;

      if (s != n) {
        if (i.root === i) {
          var _t162 = i.document ? r.version : null;

          c = new _c(i, e, s, n, _t162);
        } else {
          a = new Js(Ks._createBefore(i), t.createPositionAfter(i));

          var _o46 = a.root.document ? r.version : null;

          c = new gc(a, e, s, n, _o46);
        }

        t.batch.addOperation(c), o.applyOperation(c);
      }
    }

    function Pc(t, e, n, i, o) {
      var r = t.model,
          s = r.document,
          a = new wc(e, n, i, r.markers, o, s.version);
      t.batch.addOperation(a), r.applyOperation(a);
    }

    function Sc(t, e, n, i) {
      var o;

      if (t.root.document) {
        var _n145 = i.document,
            _r17 = new Ks(_n145.graveyard, [0]);

        o = new pc(t, e, _r17, _n145.version);
      } else o = new mc(t, e);

      n.addOperation(o), i.applyOperation(o);
    }

    function Mc(t, e) {
      return t === e || t instanceof xc && e instanceof xc;
    }

    var Ec =
    /*#__PURE__*/
    function () {
      function Ec(t) {
        _classCallCheck(this, Ec);

        this._markerCollection = t, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
      }

      _createClass(Ec, [{
        key: "refreshItem",
        value: function refreshItem(t) {
          if (this._isInInsertedElement(t.parent)) return;
          this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize);

          var e = Js._createOn(t);

          var _iteratorNormalCompletion213 = true;
          var _didIteratorError213 = false;
          var _iteratorError213 = undefined;

          try {
            for (var _iterator213 = this._markerCollection.getMarkersIntersectingRange(e)[Symbol.iterator](), _step213; !(_iteratorNormalCompletion213 = (_step213 = _iterator213.next()).done); _iteratorNormalCompletion213 = true) {
              var _t163 = _step213.value;

              var _e153 = _t163.getRange();

              this.bufferMarkerChange(_t163.name, _e153, _e153, _t163.affectsData);
            }
          } catch (err) {
            _didIteratorError213 = true;
            _iteratorError213 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion213 && _iterator213.return != null) {
                _iterator213.return();
              }
            } finally {
              if (_didIteratorError213) {
                throw _iteratorError213;
              }
            }
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferOperation",
        value: function bufferOperation(t) {
          switch (t.type) {
            case "insert":
              if (this._isInInsertedElement(t.position.parent)) return;

              this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);

              break;

            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              var _iteratorNormalCompletion214 = true;
              var _didIteratorError214 = false;
              var _iteratorError214 = undefined;

              try {
                for (var _iterator214 = t.range.getItems({
                  shallow: !0
                })[Symbol.iterator](), _step214; !(_iteratorNormalCompletion214 = (_step214 = _iterator214.next()).done); _iteratorNormalCompletion214 = true) {
                  var _e154 = _step214.value;
                  this._isInInsertedElement(_e154.parent) || this._markAttribute(_e154);
                }
              } catch (err) {
                _didIteratorError214 = true;
                _iteratorError214 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion214 && _iterator214.return != null) {
                    _iterator214.return();
                  }
                } finally {
                  if (_didIteratorError214) {
                    throw _iteratorError214;
                  }
                }
              }

              break;

            case "remove":
            case "move":
            case "reinsert":
              {
                if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;

                var _e155 = this._isInInsertedElement(t.sourcePosition.parent),
                    _n146 = this._isInInsertedElement(t.targetPosition.parent);

                _e155 || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), _n146 || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                break;
              }

            case "rename":
              {
                if (this._isInInsertedElement(t.position.parent)) return;
                this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);

                var _e156 = Js._createFromPositionAndShift(t.position, 1);

                var _iteratorNormalCompletion215 = true;
                var _didIteratorError215 = false;
                var _iteratorError215 = undefined;

                try {
                  for (var _iterator215 = this._markerCollection.getMarkersIntersectingRange(_e156)[Symbol.iterator](), _step215; !(_iteratorNormalCompletion215 = (_step215 = _iterator215.next()).done); _iteratorNormalCompletion215 = true) {
                    var _t164 = _step215.value;

                    var _e157 = _t164.getRange();

                    this.bufferMarkerChange(_t164.name, _e157, _e157, _t164.affectsData);
                  }
                } catch (err) {
                  _didIteratorError215 = true;
                  _iteratorError215 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion215 && _iterator215.return != null) {
                      _iterator215.return();
                    }
                  } finally {
                    if (_didIteratorError215) {
                      throw _iteratorError215;
                    }
                  }
                }

                break;
              }

            case "split":
              {
                var _e158 = t.splitPosition.parent;
                this._isInInsertedElement(_e158) || this._markRemove(_e158, t.splitPosition.offset, t.howMany), this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                break;
              }

            case "merge":
              {
                var _e159 = t.sourcePosition.parent;
                this._isInInsertedElement(_e159.parent) || this._markRemove(_e159.parent, _e159.startOffset, 1);
                var _n147 = t.graveyardPosition.parent;

                this._markInsert(_n147, t.graveyardPosition.offset, 1);

                var _i109 = t.targetPosition.parent;
                this._isInInsertedElement(_i109) || this._markInsert(_i109, t.targetPosition.offset, _e159.maxOffset);
                break;
              }
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferMarkerChange",
        value: function bufferMarkerChange(t, e, n, i) {
          var o = this._changedMarkers.get(t);

          o ? (o.newRange = n, o.affectsData = i, null == o.oldRange && null == o.newRange && this._changedMarkers.delete(t)) : this._changedMarkers.set(t, {
            oldRange: e,
            newRange: n,
            affectsData: i
          });
        }
      }, {
        key: "getMarkersToRemove",
        value: function getMarkersToRemove() {
          var t = [];
          var _iteratorNormalCompletion216 = true;
          var _didIteratorError216 = false;
          var _iteratorError216 = undefined;

          try {
            for (var _iterator216 = this._changedMarkers[Symbol.iterator](), _step216; !(_iteratorNormalCompletion216 = (_step216 = _iterator216.next()).done); _iteratorNormalCompletion216 = true) {
              var _ref66 = _step216.value;

              var _ref65 = _slicedToArray(_ref66, 2);

              var _e160 = _ref65[0];
              var _n148 = _ref65[1];
              null != _n148.oldRange && t.push({
                name: _e160,
                range: _n148.oldRange
              });
            }
          } catch (err) {
            _didIteratorError216 = true;
            _iteratorError216 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion216 && _iterator216.return != null) {
                _iterator216.return();
              }
            } finally {
              if (_didIteratorError216) {
                throw _iteratorError216;
              }
            }
          }

          return t;
        }
      }, {
        key: "getMarkersToAdd",
        value: function getMarkersToAdd() {
          var t = [];
          var _iteratorNormalCompletion217 = true;
          var _didIteratorError217 = false;
          var _iteratorError217 = undefined;

          try {
            for (var _iterator217 = this._changedMarkers[Symbol.iterator](), _step217; !(_iteratorNormalCompletion217 = (_step217 = _iterator217.next()).done); _iteratorNormalCompletion217 = true) {
              var _ref69 = _step217.value;

              var _ref68 = _slicedToArray(_ref69, 2);

              var _e161 = _ref68[0];
              var _n149 = _ref68[1];
              null != _n149.newRange && t.push({
                name: _e161,
                range: _n149.newRange
              });
            }
          } catch (err) {
            _didIteratorError217 = true;
            _iteratorError217 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion217 && _iterator217.return != null) {
                _iterator217.return();
              }
            } finally {
              if (_didIteratorError217) {
                throw _iteratorError217;
              }
            }
          }

          return t;
        }
      }, {
        key: "getChangedMarkers",
        value: function getChangedMarkers() {
          return Array.from(this._changedMarkers).map(function (t) {
            return {
              name: t[0],
              data: {
                oldRange: t[1].oldRange,
                newRange: t[1].newRange
              }
            };
          });
        }
      }, {
        key: "hasDataChanges",
        value: function hasDataChanges() {
          var _iteratorNormalCompletion218 = true;
          var _didIteratorError218 = false;
          var _iteratorError218 = undefined;

          try {
            for (var _iterator218 = this._changedMarkers[Symbol.iterator](), _step218; !(_iteratorNormalCompletion218 = (_step218 = _iterator218.next()).done); _iteratorNormalCompletion218 = true) {
              var _ref72 = _step218.value;

              var _ref71 = _slicedToArray(_ref72, 2);

              var _t165 = _ref71[1];
              if (_t165.affectsData) return !0;
            }
          } catch (err) {
            _didIteratorError218 = true;
            _iteratorError218 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion218 && _iterator218.return != null) {
                _iterator218.return();
              }
            } finally {
              if (_didIteratorError218) {
                throw _iteratorError218;
              }
            }
          }

          return this._changesInElement.size > 0;
        }
      }, {
        key: "getChanges",
        value: function getChanges() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeChangesInGraveyard: !1
          };
          if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          var e = [];
          var _iteratorNormalCompletion219 = true;
          var _didIteratorError219 = false;
          var _iteratorError219 = undefined;

          try {
            for (var _iterator219 = this._changesInElement.keys()[Symbol.iterator](), _step219; !(_iteratorNormalCompletion219 = (_step219 = _iterator219.next()).done); _iteratorNormalCompletion219 = true) {
              var _t167 = _step219.value;

              var _n151 = this._changesInElement.get(_t167).sort(function (t, e) {
                return t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1;
              }),
                  _i112 = this._elementSnapshots.get(_t167),
                  _o48 = Ic(_t167.getChildren()),
                  _r19 = Nc(_i112.length, _n151);

              var _s16 = 0,
                  _a9 = 0;
              var _iteratorNormalCompletion220 = true;
              var _didIteratorError220 = false;
              var _iteratorError220 = undefined;

              try {
                for (var _iterator220 = _r19[Symbol.iterator](), _step220; !(_iteratorNormalCompletion220 = (_step220 = _iterator220.next()).done); _iteratorNormalCompletion220 = true) {
                  var _n152 = _step220.value;
                  if ("i" === _n152) e.push(this._getInsertDiff(_t167, _s16, _o48[_s16].name)), _s16++;else if ("r" === _n152) e.push(this._getRemoveDiff(_t167, _s16, _i112[_a9].name)), _a9++;else if ("a" === _n152) {
                    var _n153 = _o48[_s16].attributes,
                        _r20 = _i112[_a9].attributes;

                    var _c4 = void 0;

                    if ("$text" == _o48[_s16].name) _c4 = new Js(Ks._createAt(_t167, _s16), Ks._createAt(_t167, _s16 + 1));else {
                      var _e163 = _t167.offsetToIndex(_s16);

                      _c4 = new Js(Ks._createAt(_t167, _s16), Ks._createAt(_t167.getChild(_e163), 0));
                    }
                    e.push.apply(e, _toConsumableArray(this._getAttributesDiff(_c4, _r20, _n153))), _s16++, _a9++;
                  } else _s16++, _a9++;
                }
              } catch (err) {
                _didIteratorError220 = true;
                _iteratorError220 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion220 && _iterator220.return != null) {
                    _iterator220.return();
                  }
                } finally {
                  if (_didIteratorError220) {
                    throw _iteratorError220;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError219 = true;
            _iteratorError219 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion219 && _iterator219.return != null) {
                _iterator219.return();
              }
            } finally {
              if (_didIteratorError219) {
                throw _iteratorError219;
              }
            }
          }

          e.sort(function (t, e) {
            return t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1;
          });

          for (var _t166 = 1; _t166 < e.length; _t166++) {
            var _n150 = e[_t166 - 1],
                _i110 = e[_t166],
                _o47 = "remove" == _n150.type && "remove" == _i110.type && "$text" == _n150.name && "$text" == _i110.name && _n150.position.isEqual(_i110.position),
                _r18 = "insert" == _n150.type && "insert" == _i110.type && "$text" == _n150.name && "$text" == _i110.name && _n150.position.parent == _i110.position.parent && _n150.position.offset + _n150.length == _i110.position.offset,
                _s15 = "attribute" == _n150.type && "attribute" == _i110.type && _n150.position.parent == _i110.position.parent && _n150.range.isFlat && _i110.range.isFlat && _n150.position.offset + _n150.length == _i110.position.offset && _n150.attributeKey == _i110.attributeKey && _n150.attributeOldValue == _i110.attributeOldValue && _n150.attributeNewValue == _i110.attributeNewValue;

            (_o47 || _r18 || _s15) && (e[_t166 - 1].length++, _s15 && (e[_t166 - 1].range.end = e[_t166 - 1].range.end.getShiftedBy(1)), e.splice(_t166, 1), _t166--);
          }

          for (var _i111 = 0, _e162 = e; _i111 < _e162.length; _i111++) {
            var _t168 = _e162[_i111];
            delete _t168.changeCount, "attribute" == _t168.type && (delete _t168.position, delete _t168.length);
          }

          return this._changeCount = 0, this._cachedChangesWithGraveyard = e.slice(), this._cachedChanges = e.slice().filter(Oc), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
        }
      }, {
        key: "_markInsert",
        value: function _markInsert(t, e, n) {
          var i = {
            type: "insert",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };

          this._markChange(t, i);
        }
      }, {
        key: "_markRemove",
        value: function _markRemove(t, e, n) {
          var i = {
            type: "remove",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, i), this._removeAllNestedChanges(t, e, n);
        }
      }, {
        key: "_markAttribute",
        value: function _markAttribute(t) {
          var e = {
            type: "attribute",
            offset: t.startOffset,
            howMany: t.offsetSize,
            count: this._changeCount++
          };

          this._markChange(t.parent, e);
        }
      }, {
        key: "_markChange",
        value: function _markChange(t, e) {
          this._makeSnapshot(t);

          var n = this._getChangesForElement(t);

          this._handleChange(e, n), n.push(e);

          for (var _t169 = 0; _t169 < n.length; _t169++) {
            n[_t169].howMany < 1 && (n.splice(_t169, 1), _t169--);
          }
        }
      }, {
        key: "_getChangesForElement",
        value: function _getChangesForElement(t) {
          var e;
          return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
        }
      }, {
        key: "_makeSnapshot",
        value: function _makeSnapshot(t) {
          this._elementSnapshots.has(t) || this._elementSnapshots.set(t, Ic(t.getChildren()));
        }
      }, {
        key: "_handleChange",
        value: function _handleChange(t, e) {
          t.nodesToHandle = t.howMany;
          var _iteratorNormalCompletion221 = true;
          var _didIteratorError221 = false;
          var _iteratorError221 = undefined;

          try {
            for (var _iterator221 = e[Symbol.iterator](), _step221; !(_iteratorNormalCompletion221 = (_step221 = _iterator221.next()).done); _iteratorNormalCompletion221 = true) {
              var _n154 = _step221.value;

              var _i113 = t.offset + t.howMany,
                  _o49 = _n154.offset + _n154.howMany;

              if ("insert" == t.type && ("insert" == _n154.type && (t.offset <= _n154.offset ? _n154.offset += t.howMany : t.offset < _o49 && (_n154.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == _n154.type && t.offset < _n154.offset && (_n154.offset += t.howMany), "attribute" == _n154.type)) if (t.offset <= _n154.offset) _n154.offset += t.howMany;else if (t.offset < _o49) {
                var _o50 = _n154.howMany;
                _n154.howMany = t.offset - _n154.offset, e.unshift({
                  type: "attribute",
                  offset: _i113,
                  howMany: _o50 - _n154.howMany,
                  count: this._changeCount++
                });
              }

              if ("remove" == t.type) {
                if ("insert" == _n154.type) if (_i113 <= _n154.offset) _n154.offset -= t.howMany;else if (_i113 <= _o49) {
                  if (t.offset < _n154.offset) {
                    var _e164 = _i113 - _n154.offset;

                    _n154.offset = t.offset, _n154.howMany -= _e164, t.nodesToHandle -= _e164;
                  } else _n154.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
                } else if (t.offset <= _n154.offset) t.nodesToHandle -= _n154.howMany, _n154.howMany = 0;else if (t.offset < _o49) {
                  var _e165 = _o49 - t.offset;

                  _n154.howMany -= _e165, t.nodesToHandle -= _e165;
                }
                if ("remove" == _n154.type && (_i113 <= _n154.offset ? _n154.offset -= t.howMany : t.offset < _n154.offset && (t.nodesToHandle += _n154.howMany, _n154.howMany = 0)), "attribute" == _n154.type) if (_i113 <= _n154.offset) _n154.offset -= t.howMany;else if (t.offset < _n154.offset) {
                  var _e166 = _i113 - _n154.offset;

                  _n154.offset = t.offset, _n154.howMany -= _e166;
                } else if (t.offset < _o49) if (_i113 <= _o49) {
                  var _i114 = _n154.howMany;
                  _n154.howMany = t.offset - _n154.offset;

                  var _o51 = _i114 - _n154.howMany - t.nodesToHandle;

                  e.unshift({
                    type: "attribute",
                    offset: t.offset,
                    howMany: _o51,
                    count: this._changeCount++
                  });
                } else _n154.howMany -= _o49 - t.offset;
              }

              if ("attribute" == t.type) {
                if ("insert" == _n154.type) if (t.offset < _n154.offset && _i113 > _n154.offset) {
                  if (_i113 > _o49) {
                    var _t170 = {
                      type: "attribute",
                      offset: _o49,
                      howMany: _i113 - _o49,
                      count: this._changeCount++
                    };
                    this._handleChange(_t170, e), e.push(_t170);
                  }

                  t.nodesToHandle = _n154.offset - t.offset, t.howMany = t.nodesToHandle;
                } else t.offset >= _n154.offset && t.offset < _o49 && (_i113 > _o49 ? (t.nodesToHandle = _i113 - _o49, t.offset = _o49) : t.nodesToHandle = 0);

                if ("remove" == _n154.type && t.offset < _n154.offset && _i113 > _n154.offset) {
                  var _o52 = {
                    type: "attribute",
                    offset: _n154.offset,
                    howMany: _i113 - _n154.offset,
                    count: this._changeCount++
                  };
                  this._handleChange(_o52, e), e.push(_o52), t.nodesToHandle = _n154.offset - t.offset, t.howMany = t.nodesToHandle;
                }

                "attribute" == _n154.type && (t.offset >= _n154.offset && _i113 <= _o49 ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= _n154.offset && _i113 >= _o49 && (_n154.howMany = 0));
              }
            }
          } catch (err) {
            _didIteratorError221 = true;
            _iteratorError221 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion221 && _iterator221.return != null) {
                _iterator221.return();
              }
            } finally {
              if (_didIteratorError221) {
                throw _iteratorError221;
              }
            }
          }

          t.howMany = t.nodesToHandle, delete t.nodesToHandle;
        }
      }, {
        key: "_getInsertDiff",
        value: function _getInsertDiff(t, e, n) {
          return {
            type: "insert",
            position: Ks._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getRemoveDiff",
        value: function _getRemoveDiff(t, e, n) {
          return {
            type: "remove",
            position: Ks._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getAttributesDiff",
        value: function _getAttributesDiff(t, e, n) {
          var i = [];
          n = new Map(n);
          var _iteratorNormalCompletion222 = true;
          var _didIteratorError222 = false;
          var _iteratorError222 = undefined;

          try {
            for (var _iterator222 = e[Symbol.iterator](), _step222; !(_iteratorNormalCompletion222 = (_step222 = _iterator222.next()).done); _iteratorNormalCompletion222 = true) {
              var _ref77 = _step222.value;

              var _ref74 = _slicedToArray(_ref77, 2);

              var _o53 = _ref74[0];
              var _r21 = _ref74[1];

              var _e167 = n.has(_o53) ? n.get(_o53) : null;

              _e167 !== _r21 && i.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _o53,
                attributeOldValue: _r21,
                attributeNewValue: _e167,
                changeCount: this._changeCount++
              }), n.delete(_o53);
            }
          } catch (err) {
            _didIteratorError222 = true;
            _iteratorError222 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion222 && _iterator222.return != null) {
                _iterator222.return();
              }
            } finally {
              if (_didIteratorError222) {
                throw _iteratorError222;
              }
            }
          }

          var _iteratorNormalCompletion223 = true;
          var _didIteratorError223 = false;
          var _iteratorError223 = undefined;

          try {
            for (var _iterator223 = n[Symbol.iterator](), _step223; !(_iteratorNormalCompletion223 = (_step223 = _iterator223.next()).done); _iteratorNormalCompletion223 = true) {
              var _ref78 = _step223.value;

              var _ref76 = _slicedToArray(_ref78, 2);

              var _e168 = _ref76[0];
              var _o54 = _ref76[1];
              i.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _e168,
                attributeOldValue: null,
                attributeNewValue: _o54,
                changeCount: this._changeCount++
              });
            }
          } catch (err) {
            _didIteratorError223 = true;
            _iteratorError223 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion223 && _iterator223.return != null) {
                _iterator223.return();
              }
            } finally {
              if (_didIteratorError223) {
                throw _iteratorError223;
              }
            }
          }

          return i;
        }
      }, {
        key: "_isInInsertedElement",
        value: function _isInInsertedElement(t) {
          var e = t.parent;
          if (!e) return !1;

          var n = this._changesInElement.get(e),
              i = t.startOffset;

          if (n) {
            var _iteratorNormalCompletion224 = true;
            var _didIteratorError224 = false;
            var _iteratorError224 = undefined;

            try {
              for (var _iterator224 = n[Symbol.iterator](), _step224; !(_iteratorNormalCompletion224 = (_step224 = _iterator224.next()).done); _iteratorNormalCompletion224 = true) {
                var _t171 = _step224.value;
                if ("insert" == _t171.type && i >= _t171.offset && i < _t171.offset + _t171.howMany) return !0;
              }
            } catch (err) {
              _didIteratorError224 = true;
              _iteratorError224 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion224 && _iterator224.return != null) {
                  _iterator224.return();
                }
              } finally {
                if (_didIteratorError224) {
                  throw _iteratorError224;
                }
              }
            }
          }

          return this._isInInsertedElement(e);
        }
      }, {
        key: "_removeAllNestedChanges",
        value: function _removeAllNestedChanges(t, e, n) {
          var i = new Js(Ks._createAt(t, e), Ks._createAt(t, e + n));
          var _iteratorNormalCompletion225 = true;
          var _didIteratorError225 = false;
          var _iteratorError225 = undefined;

          try {
            for (var _iterator225 = i.getItems({
              shallow: !0
            })[Symbol.iterator](), _step225; !(_iteratorNormalCompletion225 = (_step225 = _iterator225.next()).done); _iteratorNormalCompletion225 = true) {
              var _t172 = _step225.value;
              _t172.is("element") && (this._elementSnapshots.delete(_t172), this._changesInElement.delete(_t172), this._removeAllNestedChanges(_t172, 0, _t172.maxOffset));
            }
          } catch (err) {
            _didIteratorError225 = true;
            _iteratorError225 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion225 && _iterator225.return != null) {
                _iterator225.return();
              }
            } finally {
              if (_didIteratorError225) {
                throw _iteratorError225;
              }
            }
          }
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
        }
      }]);

      return Ec;
    }();

    function Ic(t) {
      var e = [];
      var _iteratorNormalCompletion226 = true;
      var _didIteratorError226 = false;
      var _iteratorError226 = undefined;

      try {
        for (var _iterator226 = t[Symbol.iterator](), _step226; !(_iteratorNormalCompletion226 = (_step226 = _iterator226.next()).done); _iteratorNormalCompletion226 = true) {
          var _n155 = _step226.value;
          if (_n155.is("text")) for (var _t173 = 0; _t173 < _n155.data.length; _t173++) {
            e.push({
              name: "$text",
              attributes: new Map(_n155.getAttributes())
            });
          } else e.push({
            name: _n155.name,
            attributes: new Map(_n155.getAttributes())
          });
        }
      } catch (err) {
        _didIteratorError226 = true;
        _iteratorError226 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion226 && _iterator226.return != null) {
            _iterator226.return();
          }
        } finally {
          if (_didIteratorError226) {
            throw _iteratorError226;
          }
        }
      }

      return e;
    }

    function Nc(t, e) {
      var n = [];
      var i = 0,
          o = 0;
      var _iteratorNormalCompletion227 = true;
      var _didIteratorError227 = false;
      var _iteratorError227 = undefined;

      try {
        for (var _iterator227 = e[Symbol.iterator](), _step227; !(_iteratorNormalCompletion227 = (_step227 = _iterator227.next()).done); _iteratorNormalCompletion227 = true) {
          var _t174 = _step227.value;

          if (_t174.offset > i) {
            for (var _e170 = 0; _e170 < _t174.offset - i; _e170++) {
              n.push("e");
            }

            o += _t174.offset - i;
          }

          if ("insert" == _t174.type) {
            for (var _e171 = 0; _e171 < _t174.howMany; _e171++) {
              n.push("i");
            }

            i = _t174.offset + _t174.howMany;
          } else if ("remove" == _t174.type) {
            for (var _e172 = 0; _e172 < _t174.howMany; _e172++) {
              n.push("r");
            }

            i = _t174.offset, o += _t174.howMany;
          } else n.push.apply(n, _toConsumableArray("a".repeat(_t174.howMany).split(""))), i = _t174.offset + _t174.howMany, o += _t174.howMany;
        }
      } catch (err) {
        _didIteratorError227 = true;
        _iteratorError227 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion227 && _iterator227.return != null) {
            _iterator227.return();
          }
        } finally {
          if (_didIteratorError227) {
            throw _iteratorError227;
          }
        }
      }

      if (o < t) for (var _e169 = 0; _e169 < t - o - i; _e169++) {
        n.push("e");
      }
      return n;
    }

    function Oc(t) {
      var e = t.position && "$graveyard" == t.position.root.rootName,
          n = t.range && "$graveyard" == t.range.root.rootName;
      return !e && !n;
    }

    var Rc =
    /*#__PURE__*/
    function () {
      function Rc() {
        _classCallCheck(this, Rc);

        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
      }

      _createClass(Rc, [{
        key: "addOperation",
        value: function addOperation(t) {
          this._operations.includes(t) || this._operations.push(t);
        }
      }, {
        key: "getOperations",
        value: function getOperations() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
          return t < 0 ? [] : this._operations.slice(t, e);
        }
      }, {
        key: "getOperation",
        value: function getOperation(t) {
          return this._operations[t];
        }
      }, {
        key: "setOperationAsUndone",
        value: function setOperationAsUndone(t, e) {
          this._undoPairs.set(e, t), this._undoneOperations.add(t);
        }
      }, {
        key: "isUndoingOperation",
        value: function isUndoingOperation(t) {
          return this._undoPairs.has(t);
        }
      }, {
        key: "isUndoneOperation",
        value: function isUndoneOperation(t) {
          return this._undoneOperations.has(t);
        }
      }, {
        key: "getUndoneOperation",
        value: function getUndoneOperation(t) {
          return this._undoPairs.get(t);
        }
      }]);

      return Rc;
    }();

    function Dc(t, e) {
      return !!(n = t.charAt(e - 1)) && 1 == n.length && /[\ud800-\udbff]/.test(n) && function (t) {
        return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
      }(t.charAt(e));
      var n;
    }

    function Lc(t, e) {
      return !!(n = t.charAt(e)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
      var n;
    }

    var jc = "$graveyard";

    var Vc =
    /*#__PURE__*/
    function () {
      function Vc(t) {
        var _this65 = this;

        _classCallCheck(this, Vc);

        this.model = t, this.version = 0, this.history = new Rc(this), this.selection = new ua(this), this.roots = new ro({
          idProperty: "rootName"
        }), this.differ = new Ec(t.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", jc), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation && n.baseVersion !== _this65.version) throw new Qn.b("model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.", _this65, {
            operation: n
          });
        }, {
          priority: "highest"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && _this65.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && (_this65.version++, _this65.history.addOperation(n));
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", function () {
          _this65._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(t.markers, "update", function (t, e, n, i) {
          _this65.differ.bufferMarkerChange(e.name, n, i, e.affectsData), null === n && e.on("change", function (t, n) {
            _this65.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData);
          });
        });
      }

      _createClass(Vc, [{
        key: "createRoot",
        value: function createRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          if (this.roots.get(e)) throw new Qn.b("model-document-createRoot-name-exists: Root with specified name already exists.", this, {
            name: e
          });
          var n = new xc(this, t, e);
          return this.roots.add(n), n;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.selection.destroy(), this.stopListening();
        }
      }, {
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "getRootNames",
        value: function getRootNames() {
          return Array.from(this.roots, function (t) {
            return t.rootName;
          }).filter(function (t) {
            return t != jc;
          });
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = ui(this);
          return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
        }
      }, {
        key: "_handleChangeBlock",
        value: function _handleChangeBlock(t) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
      }, {
        key: "_hasDocumentChangedFromTheLastChangeBlock",
        value: function _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
      }, {
        key: "_getDefaultRoot",
        value: function _getDefaultRoot() {
          var _iteratorNormalCompletion228 = true;
          var _didIteratorError228 = false;
          var _iteratorError228 = undefined;

          try {
            for (var _iterator228 = this.roots[Symbol.iterator](), _step228; !(_iteratorNormalCompletion228 = (_step228 = _iterator228.next()).done); _iteratorNormalCompletion228 = true) {
              var _t175 = _step228.value;
              if (_t175 !== this.graveyard) return _t175;
            }
          } catch (err) {
            _didIteratorError228 = true;
            _iteratorError228 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion228 && _iterator228.return != null) {
                _iterator228.return();
              }
            } finally {
              if (_didIteratorError228) {
                throw _iteratorError228;
              }
            }
          }

          return this.graveyard;
        }
      }, {
        key: "_getDefaultRange",
        value: function _getDefaultRange() {
          var t = this._getDefaultRoot(),
              e = this.model,
              n = e.schema,
              i = e.createPositionFromPath(t, [0]);

          return n.getNearestSelectionRange(i) || e.createRange(i);
        }
      }, {
        key: "_validateSelectionRange",
        value: function _validateSelectionRange(t) {
          return zc(t.start) && zc(t.end);
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;

          do {
            var _iteratorNormalCompletion229 = true;
            var _didIteratorError229 = false;
            var _iteratorError229 = undefined;

            try {
              for (var _iterator229 = this._postFixers[Symbol.iterator](), _step229; !(_iteratorNormalCompletion229 = (_step229 = _iterator229.next()).done); _iteratorNormalCompletion229 = true) {
                var _n156 = _step229.value;
                if (this.selection.refresh(), e = _n156(t), e) break;
              }
            } catch (err) {
              _didIteratorError229 = true;
              _iteratorError229 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion229 && _iterator229.return != null) {
                  _iterator229.return();
                }
              } finally {
                if (_didIteratorError229) {
                  throw _iteratorError229;
                }
              }
            }
          } while (e);
        }
      }, {
        key: "graveyard",
        get: function get() {
          return this.getRoot(jc);
        }
      }]);

      return Vc;
    }();

    function zc(t) {
      var e = t.textNode;

      if (e) {
        var _n157 = e.data,
            _i115 = t.offset - e.startOffset;

        return !Dc(_n157, _i115) && !Lc(_n157, _i115);
      }

      return !0;
    }

    li(Vc, ni);

    var Bc =
    /*#__PURE__*/
    function () {
      function Bc() {
        _classCallCheck(this, Bc);

        this._markers = new Map();
      }

      _createClass(Bc, [{
        key: Symbol.iterator,
        value: function value() {
          return this._markers.values();
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._markers.has(t);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._markers.get(t) || null;
        }
      }, {
        key: "_set",
        value: function _set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          var o = t instanceof Fc ? t.name : t,
              r = this._markers.get(o);

          if (r) {
            var _t176 = r.getRange();

            var _s17 = !1;

            return _t176.isEqual(e) || (r._attachLiveRange(ca.fromRange(e)), _s17 = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, _s17 = !0), "boolean" == typeof i && i != r.affectsData && (r._affectsData = i, _s17 = !0), _s17 && this.fire("update:" + o, r, _t176, e), r;
          }

          var s = ca.fromRange(e),
              a = new Fc(o, s, n, i);
          return this._markers.set(o, a), this.fire("update:" + o, a, null, e), a;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e = t instanceof Fc ? t.name : t,
              n = this._markers.get(e);

          return !!n && (this._markers.delete(e), this.fire("update:" + e, n, n.getRange(), null), this._destroyMarker(n), !0);
        }
      }, {
        key: "_refresh",
        value: function _refresh(t) {
          var e = t instanceof Fc ? t.name : t,
              n = this._markers.get(e);

          if (!n) throw new Qn.b("markercollection-refresh-marker-not-exists: Marker with provided name does not exists.", this);
          var i = n.getRange();
          this.fire("update:" + e, n, i, i, n.managedUsingOperations, n.affectsData);
        }
      }, {
        key: "getMarkersAtPosition",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersAtPosition(t) {
          var _iteratorNormalCompletion230, _didIteratorError230, _iteratorError230, _iterator230, _step230, _e173;

          return _regeneratorRuntime.wrap(function getMarkersAtPosition$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  _iteratorNormalCompletion230 = true;
                  _didIteratorError230 = false;
                  _iteratorError230 = undefined;
                  _context30.prev = 3;
                  _iterator230 = this[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion230 = (_step230 = _iterator230.next()).done) {
                    _context30.next = 14;
                    break;
                  }

                  _e173 = _step230.value;
                  _context30.t0 = _e173.getRange().containsPosition(t);

                  if (!_context30.t0) {
                    _context30.next = 11;
                    break;
                  }

                  _context30.next = 11;
                  return _e173;

                case 11:
                  _iteratorNormalCompletion230 = true;
                  _context30.next = 5;
                  break;

                case 14:
                  _context30.next = 20;
                  break;

                case 16:
                  _context30.prev = 16;
                  _context30.t1 = _context30["catch"](3);
                  _didIteratorError230 = true;
                  _iteratorError230 = _context30.t1;

                case 20:
                  _context30.prev = 20;
                  _context30.prev = 21;

                  if (!_iteratorNormalCompletion230 && _iterator230.return != null) {
                    _iterator230.return();
                  }

                case 23:
                  _context30.prev = 23;

                  if (!_didIteratorError230) {
                    _context30.next = 26;
                    break;
                  }

                  throw _iteratorError230;

                case 26:
                  return _context30.finish(23);

                case 27:
                  return _context30.finish(20);

                case 28:
                case "end":
                  return _context30.stop();
              }
            }
          }, getMarkersAtPosition, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "getMarkersIntersectingRange",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersIntersectingRange(t) {
          var _iteratorNormalCompletion231, _didIteratorError231, _iteratorError231, _iterator231, _step231, _e174;

          return _regeneratorRuntime.wrap(function getMarkersIntersectingRange$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  _iteratorNormalCompletion231 = true;
                  _didIteratorError231 = false;
                  _iteratorError231 = undefined;
                  _context31.prev = 3;
                  _iterator231 = this[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion231 = (_step231 = _iterator231.next()).done) {
                    _context31.next = 14;
                    break;
                  }

                  _e174 = _step231.value;
                  _context31.t0 = null !== _e174.getRange().getIntersection(t);

                  if (!_context31.t0) {
                    _context31.next = 11;
                    break;
                  }

                  _context31.next = 11;
                  return _e174;

                case 11:
                  _iteratorNormalCompletion231 = true;
                  _context31.next = 5;
                  break;

                case 14:
                  _context31.next = 20;
                  break;

                case 16:
                  _context31.prev = 16;
                  _context31.t1 = _context31["catch"](3);
                  _didIteratorError231 = true;
                  _iteratorError231 = _context31.t1;

                case 20:
                  _context31.prev = 20;
                  _context31.prev = 21;

                  if (!_iteratorNormalCompletion231 && _iterator231.return != null) {
                    _iterator231.return();
                  }

                case 23:
                  _context31.prev = 23;

                  if (!_didIteratorError231) {
                    _context31.next = 26;
                    break;
                  }

                  throw _iteratorError231;

                case 26:
                  return _context31.finish(23);

                case 27:
                  return _context31.finish(20);

                case 28:
                case "end":
                  return _context31.stop();
              }
            }
          }, getMarkersIntersectingRange, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion232 = true;
          var _didIteratorError232 = false;
          var _iteratorError232 = undefined;

          try {
            for (var _iterator232 = this._markers.values()[Symbol.iterator](), _step232; !(_iteratorNormalCompletion232 = (_step232 = _iterator232.next()).done); _iteratorNormalCompletion232 = true) {
              var _t177 = _step232.value;

              this._destroyMarker(_t177);
            }
          } catch (err) {
            _didIteratorError232 = true;
            _iteratorError232 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion232 && _iterator232.return != null) {
                _iterator232.return();
              }
            } finally {
              if (_didIteratorError232) {
                throw _iteratorError232;
              }
            }
          }

          this._markers = null, this.stopListening();
        }
      }, {
        key: "getMarkersGroup",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersGroup(t) {
          var _iteratorNormalCompletion233, _didIteratorError233, _iteratorError233, _iterator233, _step233, _e175;

          return _regeneratorRuntime.wrap(function getMarkersGroup$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  _iteratorNormalCompletion233 = true;
                  _didIteratorError233 = false;
                  _iteratorError233 = undefined;
                  _context32.prev = 3;
                  _iterator233 = this._markers.values()[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion233 = (_step233 = _iterator233.next()).done) {
                    _context32.next = 14;
                    break;
                  }

                  _e175 = _step233.value;
                  _context32.t0 = _e175.name.startsWith(t + ":");

                  if (!_context32.t0) {
                    _context32.next = 11;
                    break;
                  }

                  _context32.next = 11;
                  return _e175;

                case 11:
                  _iteratorNormalCompletion233 = true;
                  _context32.next = 5;
                  break;

                case 14:
                  _context32.next = 20;
                  break;

                case 16:
                  _context32.prev = 16;
                  _context32.t1 = _context32["catch"](3);
                  _didIteratorError233 = true;
                  _iteratorError233 = _context32.t1;

                case 20:
                  _context32.prev = 20;
                  _context32.prev = 21;

                  if (!_iteratorNormalCompletion233 && _iterator233.return != null) {
                    _iterator233.return();
                  }

                case 23:
                  _context32.prev = 23;

                  if (!_didIteratorError233) {
                    _context32.next = 26;
                    break;
                  }

                  throw _iteratorError233;

                case 26:
                  return _context32.finish(23);

                case 27:
                  return _context32.finish(20);

                case 28:
                case "end":
                  return _context32.stop();
              }
            }
          }, getMarkersGroup, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "_destroyMarker",
        value: function _destroyMarker(t) {
          t.stopListening(), t._detachLiveRange();
        }
      }]);

      return Bc;
    }();

    li(Bc, ni);

    var Fc =
    /*#__PURE__*/
    function () {
      function Fc(t, e, n, i) {
        _classCallCheck(this, Fc);

        this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = i;
      }

      _createClass(Fc, [{
        key: "getStart",
        value: function getStart() {
          if (!this._liveRange) throw new Qn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.start.clone();
        }
      }, {
        key: "getEnd",
        value: function getEnd() {
          if (!this._liveRange) throw new Qn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.end.clone();
        }
      }, {
        key: "getRange",
        value: function getRange() {
          if (!this._liveRange) throw new Qn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.toRange();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "marker" == t || "model:marker" == t;
        }
      }, {
        key: "_attachLiveRange",
        value: function _attachLiveRange(t) {
          return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
        }
      }, {
        key: "_detachLiveRange",
        value: function _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }, {
        key: "managedUsingOperations",
        get: function get() {
          if (!this._liveRange) throw new Qn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._managedUsingOperations;
        }
      }, {
        key: "affectsData",
        get: function get() {
          if (!this._liveRange) throw new Qn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._affectsData;
        }
      }]);

      return Fc;
    }();

    li(Fc, ni);

    var Uc =
    /*#__PURE__*/
    function (_Ks) {
      _inherits(Uc, _Ks);

      function Uc(t, e) {
        var _this66;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, Uc);

        if (_this66 = _possibleConstructorReturn(this, _getPrototypeOf(Uc).call(this, t, e, n)), !_this66.root.is("rootElement")) throw new Qn.b("model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.", t);
        Hc.call(_assertThisInitialized(_this66));
        return _possibleConstructorReturn(_this66);
      }

      _createClass(Uc, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "livePosition" == t || "model:livePosition" == t || _get(_getPrototypeOf(Uc.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toPosition",
        value: function toPosition() {
          return new Ks(this.root, this.path.slice(), this.stickiness);
        }
      }], [{
        key: "fromPosition",
        value: function fromPosition(t, e) {
          return new this(t.root, t.path.slice(), e || t.stickiness);
        }
      }]);

      return Uc;
    }(Ks);

    function Hc() {
      var _this67 = this;

      this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
        var n = e[0];
        n.isDocumentOperation && qc.call(_this67, n);
      }, {
        priority: "low"
      });
    }

    function qc(t) {
      var e = this.getTransformedByOperation(t);

      if (!this.isEqual(e)) {
        var _t178 = this.toPosition();

        this.path = e.path, this.root = e.root, this.fire("change", _t178);
      }
    }

    li(Uc, ni);

    var Wc =
    /*#__PURE__*/
    function () {
      function Wc(t, e, n) {
        _classCallCheck(this, Wc);

        this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
      }

      _createClass(Wc, [{
        key: "handleNodes",
        value: function handleNodes(t, e) {
          t = Array.from(t);

          for (var _n158 = 0; _n158 < t.length; _n158++) {
            var _i116 = t[_n158];

            this._handleNode(_i116, {
              isFirst: 0 === _n158 && e.isFirst,
              isLast: _n158 === t.length - 1 && e.isLast
            });
          }

          this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
      }, {
        key: "getSelectionRange",
        value: function getSelectionRange() {
          return this.nodeToSelect ? Js._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
      }, {
        key: "getAffectedRange",
        value: function getAffectedRange() {
          return this._affectedStart ? new Js(this._affectedStart, this._affectedEnd) : null;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
      }, {
        key: "_handleNode",
        value: function _handleNode(t, e) {
          if (this.schema.isObject(t)) return void this._handleObject(t, e);
          this._checkAndSplitToAllowedPosition(t, e) ? (this._insert(t), this._mergeSiblingsOf(t, e)) : this._handleDisallowedNode(t, e);
        }
      }, {
        key: "_handleObject",
        value: function _handleObject(t, e) {
          this._checkAndSplitToAllowedPosition(t) ? this._insert(t) : this._tryAutoparagraphing(t, e);
        }
      }, {
        key: "_handleDisallowedNode",
        value: function _handleDisallowedNode(t, e) {
          t.is("element") ? this.handleNodes(t.getChildren(), e) : this._tryAutoparagraphing(t, e);
        }
      }, {
        key: "_insert",
        value: function _insert(t) {
          if (!this.schema.checkChild(this.position, t)) throw new Qn.b("insertcontent-wrong-position: Given node cannot be inserted on the given position.", this, {
            node: t,
            position: this.position
          });
          var e = Uc.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this.writer.insert(t, this.position), this.position = e.toPosition(), e.detach(), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = t : this.nodeToSelect = null, this._filterAttributesOf.push(t);
        }
      }, {
        key: "_setAffectedBoundaries",
        value: function _setAffectedBoundaries(t) {
          this._affectedStart || (this._affectedStart = Uc.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Uc.fromPosition(t, "toNext"));
        }
      }, {
        key: "_mergeSiblingsOf",
        value: function _mergeSiblingsOf(t, e) {
          if (!(t instanceof Ys)) return;

          var n = this._canMergeLeft(t, e),
              i = this._canMergeRight(t, e),
              o = Uc._createBefore(t);

          o.stickiness = "toNext";

          var r = Uc._createAfter(t);

          if (r.stickiness = "toNext", n) {
            var _t179 = Uc.fromPosition(this.position);

            _t179.stickiness = "toNext", this._affectedStart.isEqual(o) && (this._affectedStart.detach(), this._affectedStart = Uc._createAt(o.nodeBefore, "end", "toPrevious")), this.writer.merge(o), o.isEqual(this._affectedEnd) && e.isLast && (this._affectedEnd.detach(), this._affectedEnd = Uc._createAt(o.nodeBefore, "end", "toNext")), this.position = _t179.toPosition(), _t179.detach();
          }

          if (i) {
            if (!this.position.isEqual(r)) throw new Qn.b("insertcontent-invalid-insertion-position", this);
            this.position = Ks._createAt(r.nodeBefore, "end");

            var _t180 = Uc.fromPosition(this.position, "toPrevious");

            this._affectedEnd.isEqual(r) && (this._affectedEnd.detach(), this._affectedEnd = Uc._createAt(r.nodeBefore, "end", "toNext")), this.writer.merge(r), r.getShiftedBy(-1).isEqual(this._affectedStart) && e.isFirst && (this._affectedStart.detach(), this._affectedStart = Uc._createAt(r.nodeBefore, 0, "toPrevious")), this.position = _t180.toPosition(), _t180.detach();
          }

          (n || i) && this._filterAttributesOf.push(this.position.parent), o.detach(), r.detach();
        }
      }, {
        key: "_canMergeLeft",
        value: function _canMergeLeft(t, e) {
          var n = t.previousSibling;
          return e.isFirst && n instanceof Ys && this.canMergeWith.has(n) && this.model.schema.checkMerge(n, t);
        }
      }, {
        key: "_canMergeRight",
        value: function _canMergeRight(t, e) {
          var n = t.nextSibling;
          return e.isLast && n instanceof Ys && this.canMergeWith.has(n) && this.model.schema.checkMerge(t, n);
        }
      }, {
        key: "_tryAutoparagraphing",
        value: function _tryAutoparagraphing(t, e) {
          var n = this.writer.createElement("paragraph");
          this._getAllowedIn(n, this.position.parent) && this.schema.checkChild(n, t) && (n._appendChild(t), this._handleNode(n, e));
        }
      }, {
        key: "_checkAndSplitToAllowedPosition",
        value: function _checkAndSplitToAllowedPosition(t) {
          var e = this._getAllowedIn(t, this.position.parent);

          if (!e) return !1;

          for (; e != this.position.parent;) {
            if (this.schema.isLimit(this.position.parent)) return !1;

            if (this.position.isAtStart) {
              var _t181 = this.position.parent;
              this.position = this.writer.createPositionBefore(_t181), _t181.isEmpty && _t181.parent === e && this.writer.remove(_t181);
            } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
              var _t182 = this.writer.createPositionAfter(this.position.parent);

              this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _t182, this.canMergeWith.add(this.position.nodeAfter);
            }
          }

          return !0;
        }
      }, {
        key: "_getAllowedIn",
        value: function _getAllowedIn(t, e) {
          return this.schema.checkChild(e, t) ? e : e.parent ? this._getAllowedIn(t, e.parent) : null;
        }
      }]);

      return Wc;
    }();

    function Yc(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (e.isCollapsed) return;
      var i = e.getFirstRange();
      if ("$graveyard" == i.root.rootName) return;
      var o = t.schema;
      t.change(function (t) {
        if (!n.doNotResetEntireContent && function (t, e) {
          var n = t.getLimitElement(e);
          if (!e.containsEntireContent(n)) return !1;
          var i = e.getFirstRange();
          if (i.start.parent == i.end.parent) return !1;
          return t.checkChild(n, "paragraph");
        }(o, e)) return void function (t, e) {
          var n = t.model.schema.getLimitElement(e);
          t.remove(t.createRangeIn(n)), $c(t, t.createPositionAt(n, 0), e);
        }(t, e);
        var r = i.start,
            s = Uc.fromPosition(i.end, "toNext");

        if (i.start.isTouching(i.end) || t.remove(i), n.leaveUnmerged || (!function t(e, n, i) {
          var o = n.parent,
              r = i.parent;
          if (o == r) return;
          if (e.model.schema.isLimit(o) || e.model.schema.isLimit(r)) return;
          if (!function (t, e, n) {
            var i = new Js(t, e);
            var _iteratorNormalCompletion234 = true;
            var _didIteratorError234 = false;
            var _iteratorError234 = undefined;

            try {
              for (var _iterator234 = i.getWalker()[Symbol.iterator](), _step234; !(_iteratorNormalCompletion234 = (_step234 = _iterator234.next()).done); _iteratorNormalCompletion234 = true) {
                var _t183 = _step234.value;
                if (n.isLimit(_t183.item)) return !1;
              }
            } catch (err) {
              _didIteratorError234 = true;
              _iteratorError234 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion234 && _iterator234.return != null) {
                  _iterator234.return();
                }
              } finally {
                if (_didIteratorError234) {
                  throw _iteratorError234;
                }
              }
            }

            return !0;
          }(n, i, e.model.schema)) return;
          n = e.createPositionAfter(o), (i = e.createPositionBefore(r)).isEqual(n) || e.insert(r, n);
          e.merge(n);

          for (; i.parent.isEmpty;) {
            var _t184 = i.parent;
            i = e.createPositionBefore(_t184), e.remove(_t184);
          }

          t(e, n, i);
        }(t, r, s), o.removeDisallowedAttributes(r.parent.getChildren(), t)), Gc(t, e, r), function (t, e) {
          var n = t.checkChild(e, "$text"),
              i = t.checkChild(e, "paragraph");
          return !n && i;
        }(o, r)) {
          var _i117 = o.getNearestSelectionRange(r);

          n.doNotAutoparagraph && _i117 ? Gc(t, e, _i117) : $c(t, r, e);
        }

        s.detach();
      });
    }

    function $c(t, e, n) {
      var i = t.createElement("paragraph");
      t.insert(i, e), Gc(t, n, t.createPositionAt(i, 0));
    }

    function Gc(t, e, n) {
      e instanceof ua ? t.setSelection(n) : e.setTo(n);
    }

    var Qc = ' ,.?!:;"-()';

    function Kc(t, e) {
      if ("text" == e.type) return "word" === t.unit ? function (t, e) {
        var n = t.position.textNode;

        if (n) {
          var _i118 = t.position.offset - n.startOffset;

          for (; !Zc(n.data, _i118, e) && !Xc(n, _i118, e);) {
            t.next();

            var _o55 = e ? t.position.nodeAfter : t.position.nodeBefore;

            if (_o55 && _o55.is("text")) {
              var _i119 = _o55.data.charAt(e ? 0 : _o55.data.length - 1);

              Qc.includes(_i119) || (t.next(), n = t.position.textNode);
            }

            _i118 = t.position.offset - n.startOffset;
          }
        }

        return t.position;
      }(t.walker, t.isForward) : function (t, e) {
        var n = t.position.textNode;

        if (n) {
          var _i120 = n.data;

          var _o56 = t.position.offset - n.startOffset;

          for (; Dc(_i120, _o56) || "character" == e && Lc(_i120, _o56);) {
            t.next(), _o56 = t.position.offset - n.startOffset;
          }
        }

        return t.position;
      }(t.walker, t.unit, t.isForward);

      if (e.type == (t.isForward ? "elementStart" : "elementEnd")) {
        if (t.schema.isObject(e.item)) return Ks._createAt(e.item, t.isForward ? "after" : "before");
        if (t.schema.checkChild(e.nextPosition, "$text")) return e.nextPosition;
      } else {
        if (t.schema.isLimit(e.item)) return void t.walker.skip(function () {
          return !0;
        });
        if (t.schema.checkChild(e.nextPosition, "$text")) return e.nextPosition;
      }
    }

    function Jc(t, e) {
      var n = t.root,
          i = Ks._createAt(n, e ? "end" : 0);

      return e ? new Js(t, i) : new Js(i, t);
    }

    function Zc(t, e, n) {
      var i = e + (n ? 0 : -1);
      return Qc.includes(t.charAt(i));
    }

    function Xc(t, e, n) {
      return e === (n ? t.endOffset : 0);
    }

    function tl(t, e) {
      var n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(function (t) {
        return e.createRangeOn(t);
      }).filter(function (e) {
        return (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
      }).forEach(function (t) {
        n.push(t.start.parent), e.remove(t);
      }), n.forEach(function (t) {
        var n = t;

        for (; n.parent && n.isEmpty;) {
          var _t185 = e.createRangeOn(n);

          n = n.parent, e.remove(_t185);
        }
      });
    }

    function el(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.selection,
              i = e.schema,
              o = [];
          var r = !1;
          var _iteratorNormalCompletion235 = true;
          var _didIteratorError235 = false;
          var _iteratorError235 = undefined;

          try {
            for (var _iterator235 = n.getRanges()[Symbol.iterator](), _step235; !(_iteratorNormalCompletion235 = (_step235 = _iterator235.next()).done); _iteratorNormalCompletion235 = true) {
              var _t187 = _step235.value;

              var _e177 = nl(_t187, i);

              _e177 ? (o.push(_e177), r = !0) : o.push(_t187);
            }
          } catch (err) {
            _didIteratorError235 = true;
            _iteratorError235 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion235 && _iterator235.return != null) {
                _iterator235.return();
              }
            } finally {
              if (_didIteratorError235) {
                throw _iteratorError235;
              }
            }
          }

          if (r) {
            var _e176 = o;

            if (o.length > 1) {
              var _t186 = o[0].start,
                  _n159 = o[o.length - 1].end;
              _e176 = [new Js(_t186, _n159)];
            }

            t.setSelection(_e176, {
              backward: n.isBackward
            });
          }
        }(e, t);
      });
    }

    function nl(t, e) {
      return t.isCollapsed ? function (t, e) {
        var n = t.start,
            i = e.getNearestSelectionRange(n);
        if (!i) return null;
        var o = i.start;
        if (n.isEqual(o)) return null;
        if (o.nodeAfter && e.isLimit(o.nodeAfter)) return new Js(o, Ks._createAfter(o.nodeAfter));
        return new Js(o);
      }(t, e) : function (t, e) {
        var n = t.start,
            i = t.end,
            o = e.checkChild(n, "$text"),
            r = e.checkChild(i, "$text"),
            s = e.getLimitElement(n),
            a = e.getLimitElement(i);

        if (s === a) {
          if (o && r) return null;

          if (function (t, e, n) {
            var i = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
                o = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
            return i || o;
          }(n, i, e)) {
            var _t188 = n.nodeAfter && e.isObject(n.nodeAfter) ? null : e.getNearestSelectionRange(n, "forward"),
                _o57 = i.nodeBefore && e.isObject(i.nodeBefore) ? null : e.getNearestSelectionRange(i, "backward"),
                _r22 = _t188 ? _t188.start : n,
                _s18 = _o57 ? _o57.start : i;

            return new Js(_r22, _s18);
          }
        }

        var c = s && !s.is("rootElement"),
            l = a && !a.is("rootElement");

        if (c || l) {
          var _t189 = n.nodeAfter && i.nodeBefore && n.nodeAfter.parent === i.nodeBefore.parent,
              _o58 = c && (!_t189 || !ol(n.nodeAfter, e)),
              _r23 = l && (!_t189 || !ol(i.nodeBefore, e));

          var _d2 = n,
              _h2 = i;
          return _o58 && (_d2 = Ks._createBefore(il(s, e))), _r23 && (_h2 = Ks._createAfter(il(a, e))), new Js(_d2, _h2);
        }

        return null;
      }(t, e);
    }

    function il(t, e) {
      var n = t,
          i = n;

      for (; e.isLimit(i) && i.parent;) {
        n = i, i = i.parent;
      }

      return n;
    }

    function ol(t, e) {
      return t && e.isObject(t);
    }

    var rl =
    /*#__PURE__*/
    function () {
      function rl() {
        var _this68 = this;

        _classCallCheck(this, rl);

        this.markers = new Bc(), this.document = new Vc(this), this.schema = new za(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (t) {
          return _this68.decorate(t);
        }), this.on("applyOperation", function (t, e) {
          e[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$block", {
          allowIn: "$root",
          isBlock: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          isLimit: !0
        }), this.schema.extend("$text", {
          allowIn: "$clipboardHolder"
        }), this.schema.register("$marker"), this.schema.addChildCheck(function (t, e) {
          if ("$marker" === e.name) return !0;
        }), el(this);
      }

      _createClass(rl, [{
        key: "change",
        value: function change(t) {
          try {
            return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
              batch: new ic(),
              callback: t
            }), this._runPendingChanges()[0]) : t(this._currentWriter);
          } catch (t) {
            Qn.b.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "enqueueChange",
        value: function enqueueChange(t, e) {
          try {
            "string" == typeof t ? t = new ic(t) : "function" == typeof t && (e = t, t = new ic()), this._pendingChanges.push({
              batch: t,
              callback: e
            }), 1 == this._pendingChanges.length && this._runPendingChanges();
          } catch (t) {
            Qn.b.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "applyOperation",
        value: function applyOperation(t) {
          t._execute();
        }
      }, {
        key: "insertContent",
        value: function insertContent(t, e, n) {
          return function (t, e, n, i) {
            return t.change(function (o) {
              var r;
              r = n ? n instanceof ia || n instanceof ua ? n : o.createSelection(n, i) : t.document.selection;
              var s = r.getFirstPosition();
              r.isCollapsed || t.deleteContent(r, {
                doNotAutoparagraph: !0
              });
              var a = new Wc(t, o, s);
              var c;
              c = e.is("documentFragment") ? e.getChildren() : [e], a.handleNodes(c, {
                isFirst: !0,
                isLast: !0
              });
              var l = a.getSelectionRange();
              l && (r instanceof ua ? o.setSelection(l) : r.setTo(l));
              var d = a.getAffectedRange() || t.createRange(s);
              return a.destroy(), d;
            });
          }(this, t, e, n);
        }
      }, {
        key: "deleteContent",
        value: function deleteContent(t, e) {
          Yc(this, t, e);
        }
      }, {
        key: "modifySelection",
        value: function modifySelection(t, e) {
          !function (t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = t.schema,
                o = "backward" != n.direction,
                r = n.unit ? n.unit : "character",
                s = e.focus,
                a = new $s({
              boundaries: Jc(s, o),
              singleCharacters: !0,
              direction: o ? "forward" : "backward"
            }),
                c = {
              walker: a,
              schema: i,
              isForward: o,
              unit: r
            };
            var l;

            var _loop3 = function _loop3() {
              if (l.done) return {
                v: void 0
              };
              var n = Kc(c, l.value);
              if (n) return {
                v: void (e instanceof ua ? t.change(function (t) {
                  t.setSelectionFocus(n);
                }) : e.setFocus(n))
              };
            };

            for (; l = a.next();) {
              var _ret2 = _loop3();

              if (typeof _ret2 === "object") return _ret2.v;
            }
          }(this, t, e);
        }
      }, {
        key: "getSelectedContent",
        value: function getSelectedContent(t) {
          return function (t, e) {
            return t.change(function (t) {
              var n = t.createDocumentFragment(),
                  i = e.getFirstRange();
              if (!i || i.isCollapsed) return n;
              var o = i.start.root,
                  r = i.start.getCommonPath(i.end),
                  s = o.getNodeByPath(r);
              var a;
              a = i.start.parent == i.end.parent ? i : t.createRange(t.createPositionAt(s, i.start.path[r.length]), t.createPositionAt(s, i.end.path[r.length] + 1));
              var c = a.end.offset - a.start.offset;
              var _iteratorNormalCompletion236 = true;
              var _didIteratorError236 = false;
              var _iteratorError236 = undefined;

              try {
                for (var _iterator236 = a.getItems({
                  shallow: !0
                })[Symbol.iterator](), _step236; !(_iteratorNormalCompletion236 = (_step236 = _iterator236.next()).done); _iteratorNormalCompletion236 = true) {
                  var _e179 = _step236.value;
                  _e179.is("textProxy") ? t.appendText(_e179.data, _e179.getAttributes(), n) : t.append(_e179._clone(!0), n);
                }
              } catch (err) {
                _didIteratorError236 = true;
                _iteratorError236 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion236 && _iterator236.return != null) {
                    _iterator236.return();
                  }
                } finally {
                  if (_didIteratorError236) {
                    throw _iteratorError236;
                  }
                }
              }

              if (a != i) {
                var _e178 = i._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0],
                    _o59 = t.createRange(t.createPositionAt(n, 0), _e178.start);

                tl(t.createRange(_e178.end, t.createPositionAt(n, "end")), t), tl(_o59, t);
              }

              return n;
            });
          }(this, t);
        }
      }, {
        key: "hasContent",
        value: function hasContent(t, e) {
          var n = t instanceof Ys ? Js._createIn(t) : t;
          if (n.isCollapsed) return !1;
          var _iteratorNormalCompletion237 = true;
          var _didIteratorError237 = false;
          var _iteratorError237 = undefined;

          try {
            for (var _iterator237 = this.markers.getMarkersIntersectingRange(n)[Symbol.iterator](), _step237; !(_iteratorNormalCompletion237 = (_step237 = _iterator237.next()).done); _iteratorNormalCompletion237 = true) {
              var _t190 = _step237.value;
              if (_t190.affectsData) return !0;
            }
          } catch (err) {
            _didIteratorError237 = true;
            _iteratorError237 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion237 && _iterator237.return != null) {
                _iterator237.return();
              }
            } finally {
              if (_didIteratorError237) {
                throw _iteratorError237;
              }
            }
          }

          var _ref79 = e || {},
              _ref79$ignoreWhitespa = _ref79.ignoreWhitespaces,
              i = _ref79$ignoreWhitespa === void 0 ? !1 : _ref79$ignoreWhitespa;

          var _iteratorNormalCompletion238 = true;
          var _didIteratorError238 = false;
          var _iteratorError238 = undefined;

          try {
            for (var _iterator238 = n.getItems()[Symbol.iterator](), _step238; !(_iteratorNormalCompletion238 = (_step238 = _iterator238.next()).done); _iteratorNormalCompletion238 = true) {
              var _t191 = _step238.value;

              if (_t191.is("textProxy")) {
                if (!i) return !0;
                if (-1 !== _t191.data.search(/\S/)) return !0;
              } else if (this.schema.isObject(_t191)) return !0;
            }
          } catch (err) {
            _didIteratorError238 = true;
            _iteratorError238 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion238 && _iterator238.return != null) {
                _iterator238.return();
              }
            } finally {
              if (_didIteratorError238) {
                throw _iteratorError238;
              }
            }
          }

          return !1;
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return new Ks(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Ks._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Ks._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Ks._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Js(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Js._createIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Js._createOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new ia(t, e, n);
        }
      }, {
        key: "createBatch",
        value: function createBatch(t) {
          return new ic(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "_runPendingChanges",
        value: function _runPendingChanges() {
          var t = [];

          for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
            var _e180 = this._pendingChanges[0].batch;
            this._currentWriter = new Ac(this, _e180);

            var _n160 = this._pendingChanges[0].callback(this._currentWriter);

            t.push(_n160), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }

          return this.fire("_afterChanges"), t;
        }
      }]);

      return rl;
    }();

    li(rl, Ui);

    var sl =
    /*#__PURE__*/
    function () {
      function sl() {
        _classCallCheck(this, sl);

        this._listener = Object.create(ur);
      }

      _createClass(sl, [{
        key: "listenTo",
        value: function listenTo(t) {
          var _this69 = this;

          this._listener.listenTo(t, "keydown", function (t, e) {
            _this69._listener.fire("_keydown:" + ko(e), e);
          });
        }
      }, {
        key: "set",
        value: function set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          var i = _o(t),
              o = n.priority;

          this._listener.listenTo(this._listener, "_keydown:" + i, function (t, n) {
            e(n, function () {
              n.preventDefault(), n.stopPropagation(), t.stop();
            }), t.return = !0;
          }, {
            priority: o
          });
        }
      }, {
        key: "press",
        value: function press(t) {
          return !!this._listener.fire("_keydown:" + ko(t), t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._listener.stopListening();
        }
      }]);

      return sl;
    }();

    var al =
    /*#__PURE__*/
    function (_sl) {
      _inherits(al, _sl);

      function al(t) {
        var _this70;

        _classCallCheck(this, al);

        _this70 = _possibleConstructorReturn(this, _getPrototypeOf(al).call(this)), _this70.editor = t;
        return _this70;
      }

      _createClass(al, [{
        key: "set",
        value: function set(t, e) {
          var _this71 = this;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if ("string" == typeof e) {
            var _t192 = e;

            e = function e(_e181, n) {
              _this71.editor.execute(_t192), n();
            };
          }

          _get(_getPrototypeOf(al.prototype), "set", this).call(this, t, e, n);
        }
      }]);

      return al;
    }(sl);

    var cl =
    /*#__PURE__*/
    function () {
      function cl(t) {
        var _this72 = this;

        _classCallCheck(this, cl);

        var e = this.constructor.builtinPlugins;
        this.config = new $n(t, this.constructor.defaultConfig), this.config.define("plugins", e), this.plugins = new Ia(this, e), this.commands = new Na();
        var n = this.config.get("language") || {};
        this.locale = new Da({
          uiLanguage: "string" == typeof n ? n : n.ui,
          contentLanguage: this.config.get("language.content")
        }), this.t = this.locale.t, this.set("state", "initializing"), this.once("ready", function () {
          return _this72.state = "ready";
        }, {
          priority: "high"
        }), this.once("destroy", function () {
          return _this72.state = "destroyed";
        }, {
          priority: "high"
        }), this.set("isReadOnly", !1), this.model = new rl(), this.data = new Xa(this.model), this.editing = new Ea(this.model), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new tc([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new al(this), this.keystrokes.listenTo(this.editing.view.document);
      }

      _createClass(cl, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config,
              e = t.get("plugins") || [],
              n = t.get("removePlugins") || [],
              i = t.get("extraPlugins") || [];
          return this.plugins.init(e.concat(i), n);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this73 = this;

          var t = Promise.resolve();
          return "initializing" == this.state && (t = new Promise(function (t) {
            return _this73.once("ready", t);
          })), t.then(function () {
            _this73.fire("destroy"), _this73.stopListening(), _this73.commands.destroy();
          }).then(function () {
            return _this73.plugins.destroy();
          }).then(function () {
            _this73.model.destroy(), _this73.data.destroy(), _this73.editing.destroy(), _this73.keystrokes.destroy();
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          try {
            var _this$commands;

            (_this$commands = this.commands).execute.apply(_this$commands, arguments);
          } catch (t) {
            Qn.b.rethrowUnexpectedError(t, this);
          }
        }
      }]);

      return cl;
    }();

    li(cl, Ui);
    var ll = {
      setData: function setData(t) {
        this.data.set(t);
      },
      getData: function getData(t) {
        return this.data.get(t);
      }
    };
    var dl = {
      updateSourceElement: function updateSourceElement() {
        if (!this.sourceElement) throw new Qn.b("editor-missing-sourceelement: Cannot update the source element of a detached editor.", this);
        var t, e;
        t = this.sourceElement, e = this.data.get(), t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
      }
    };

    var hl =
    /*#__PURE__*/
    function () {
      function hl() {
        _classCallCheck(this, hl);
      }

      _createClass(hl, [{
        key: "getHtml",
        value: function getHtml(t) {
          var e = document.implementation.createHTMLDocument("").createElement("div");
          return e.appendChild(t), e.innerHTML;
        }
      }]);

      return hl;
    }();

    var ul =
    /*#__PURE__*/
    function () {
      function ul() {
        _classCallCheck(this, ul);

        this._domParser = new DOMParser(), this._domConverter = new ar({
          blockFillerMode: "nbsp"
        }), this._htmlWriter = new hl();
      }

      _createClass(ul, [{
        key: "toData",
        value: function toData(t) {
          var e = this._domConverter.viewToDom(t, document);

          return this._htmlWriter.getHtml(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          var e = this._toDom(t);

          return this._domConverter.domToView(e);
        }
      }, {
        key: "_toDom",
        value: function _toDom(t) {
          var e = this._domParser.parseFromString(t, "text/html"),
              n = e.createDocumentFragment(),
              i = e.body.childNodes;

          for (; i.length > 0;) {
            n.appendChild(i[0]);
          }

          return n;
        }
      }]);

      return ul;
    }();

    var fl =
    /*#__PURE__*/
    function () {
      function fl(t) {
        _classCallCheck(this, fl);

        this.editor = t, this._components = new Map();
      }

      _createClass(fl, [{
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          var _iteratorNormalCompletion239, _didIteratorError239, _iteratorError239, _iterator239, _step239, _t193;

          return _regeneratorRuntime.wrap(function names$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  _iteratorNormalCompletion239 = true;
                  _didIteratorError239 = false;
                  _iteratorError239 = undefined;
                  _context33.prev = 3;
                  _iterator239 = this._components.values()[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion239 = (_step239 = _iterator239.next()).done) {
                    _context33.next = 12;
                    break;
                  }

                  _t193 = _step239.value;
                  _context33.next = 9;
                  return _t193.originalName;

                case 9:
                  _iteratorNormalCompletion239 = true;
                  _context33.next = 5;
                  break;

                case 12:
                  _context33.next = 18;
                  break;

                case 14:
                  _context33.prev = 14;
                  _context33.t0 = _context33["catch"](3);
                  _didIteratorError239 = true;
                  _iteratorError239 = _context33.t0;

                case 18:
                  _context33.prev = 18;
                  _context33.prev = 19;

                  if (!_iteratorNormalCompletion239 && _iterator239.return != null) {
                    _iterator239.return();
                  }

                case 21:
                  _context33.prev = 21;

                  if (!_didIteratorError239) {
                    _context33.next = 24;
                    break;
                  }

                  throw _iteratorError239;

                case 24:
                  return _context33.finish(21);

                case 25:
                  return _context33.finish(18);

                case 26:
                case "end":
                  return _context33.stop();
              }
            }
          }, names, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "add",
        value: function add(t, e) {
          if (this.has(t)) throw new Qn.b("componentfactory-item-exists: The item already exists in the component factory.", this, {
            name: t
          });

          this._components.set(gl(t), {
            callback: e,
            originalName: t
          });
        }
      }, {
        key: "create",
        value: function create(t) {
          if (!this.has(t)) throw new Qn.b("componentfactory-item-missing: The required component is not registered in the factory.", this, {
            name: t
          });
          return this._components.get(gl(t)).callback(this.editor.locale);
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._components.has(gl(t));
        }
      }]);

      return fl;
    }();

    function gl(t) {
      return String(t).toLowerCase();
    }

    var ml =
    /*#__PURE__*/
    function () {
      function ml() {
        _classCallCheck(this, ml);

        this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
      }

      _createClass(ml, [{
        key: "add",
        value: function add(t) {
          var _this74 = this;

          if (this._elements.has(t)) throw new Qn.b("focusTracker-add-element-already-exist", this);
          this.listenTo(t, "focus", function () {
            return _this74._focus(t);
          }, {
            useCapture: !0
          }), this.listenTo(t, "blur", function () {
            return _this74._blur();
          }, {
            useCapture: !0
          }), this._elements.add(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          t === this.focusedElement && this._blur(t), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
        }
      }, {
        key: "_blur",
        value: function _blur() {
          var _this75 = this;

          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
            _this75.focusedElement = null, _this75.isFocused = !1;
          }, 0);
        }
      }]);

      return ml;
    }();

    li(ml, ur), li(ml, Ui);

    var pl =
    /*#__PURE__*/
    function () {
      function pl(t) {
        var _this76 = this;

        _classCallCheck(this, pl);

        this.editor = t, this.componentFactory = new fl(t), this.focusTracker = new ml(), this._editableElementsMap = new Map(), this.listenTo(t.editing.view.document, "layoutChanged", function () {
          return _this76.update();
        });
      }

      _createClass(pl, [{
        key: "update",
        value: function update() {
          this.fire("update");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this.focusTracker.destroy();
          var _iteratorNormalCompletion240 = true;
          var _didIteratorError240 = false;
          var _iteratorError240 = undefined;

          try {
            for (var _iterator240 = this._editableElementsMap.values()[Symbol.iterator](), _step240; !(_iteratorNormalCompletion240 = (_step240 = _iterator240.next()).done); _iteratorNormalCompletion240 = true) {
              var _t194 = _step240.value;
              _t194.ckeditorInstance = null;
            }
          } catch (err) {
            _didIteratorError240 = true;
            _iteratorError240 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion240 && _iterator240.return != null) {
                _iterator240.return();
              }
            } finally {
              if (_didIteratorError240) {
                throw _iteratorError240;
              }
            }
          }

          this._editableElementsMap = new Map();
        }
      }, {
        key: "setEditableElement",
        value: function setEditableElement(t, e) {
          this._editableElementsMap.set(t, e), e.ckeditorInstance || (e.ckeditorInstance = this.editor);
        }
      }, {
        key: "getEditableElement",
        value: function getEditableElement() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this._editableElementsMap.get(t);
        }
      }, {
        key: "getEditableElementsNames",
        value: function getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
      }, {
        key: "element",
        get: function get() {
          return null;
        }
      }, {
        key: "_editableElements",
        get: function get() {
          return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
            editorUI: this
          }), this._editableElementsMap;
        }
      }]);

      return pl;
    }();

    li(pl, ni);
    n(13);
    var bl = new WeakMap();

    function wl(t) {
      var e = t.view,
          n = t.element,
          i = t.text,
          _t$isDirectHost = t.isDirectHost,
          o = _t$isDirectHost === void 0 ? !0 : _t$isDirectHost,
          r = e.document;
      bl.has(r) || (bl.set(r, new Map()), r.registerPostFixer(function (t) {
        return _l(r, t);
      })), bl.get(r).set(n, {
        text: i,
        isDirectHost: o
      }), e.change(function (t) {
        return _l(r, t);
      });
    }

    function kl(t, e) {
      return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
    }

    function _l(t, e) {
      var n = bl.get(t);
      var i = !1;
      var _iteratorNormalCompletion241 = true;
      var _didIteratorError241 = false;
      var _iteratorError241 = undefined;

      try {
        for (var _iterator241 = n[Symbol.iterator](), _step241; !(_iteratorNormalCompletion241 = (_step241 = _iterator241.next()).done); _iteratorNormalCompletion241 = true) {
          var _ref82 = _step241.value;

          var _ref81 = _slicedToArray(_ref82, 2);

          var _t195 = _ref81[0];
          var _o60 = _ref81[1];
          vl(e, _t195, _o60) && (i = !0);
        }
      } catch (err) {
        _didIteratorError241 = true;
        _iteratorError241 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion241 && _iterator241.return != null) {
            _iterator241.return();
          }
        } finally {
          if (_didIteratorError241) {
            throw _iteratorError241;
          }
        }
      }

      return i;
    }

    function vl(t, e, n) {
      var i = n.text,
          o = n.isDirectHost,
          r = o ? e : function (t) {
        if (1 === t.childCount) {
          var _e182 = t.getChild(0);

          if (_e182.is("element") && !_e182.is("uiElement")) return _e182;
        }

        return null;
      }(e);
      var s = !1;
      return !!r && (n.hostElement = r, r.getAttribute("data-placeholder") !== i && (t.setAttribute("data-placeholder", i, r), s = !0), !function (t) {
        var e = t.document;
        if (!e) return !1;
        var n = !Array.from(t.getChildren()).some(function (t) {
          return !t.is("uiElement");
        });
        if (!e.isFocused && n) return !0;
        var i = e.selection.anchor;
        return !(!n || !i || i.parent === t);
      }(r) ? kl(t, r) && (s = !0) : function (t, e) {
        return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
      }(t, r) && (s = !0), s);
    }

    var yl =
    /*#__PURE__*/
    function () {
      function yl() {
        _classCallCheck(this, yl);

        this._replacedElements = [];
      }

      _createClass(yl, [{
        key: "replace",
        value: function replace(t, e) {
          this._replacedElements.push({
            element: t,
            newElement: e
          }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
        }
      }, {
        key: "restore",
        value: function restore() {
          this._replacedElements.forEach(function (_ref83) {
            var t = _ref83.element,
                e = _ref83.newElement;
            t.style.display = "", e && e.remove();
          }), this._replacedElements = [];
        }
      }]);

      return yl;
    }();

    var xl =
    /*#__PURE__*/
    function (_pl) {
      _inherits(xl, _pl);

      function xl(t, e) {
        var _this77;

        _classCallCheck(this, xl);

        var n;
        _this77 = _possibleConstructorReturn(this, _getPrototypeOf(xl).call(this, t)), _this77.view = e, _this77._toolbarConfig = (n = t.config.get("toolbar"), Array.isArray(n) ? {
          items: n
        } : n ? Object.assign({
          items: []
        }, n) : {
          items: []
        }), _this77._elementReplacer = new yl();
        return _this77;
      }

      _createClass(xl, [{
        key: "init",
        value: function init(t) {
          var e = this.editor,
              n = this.view,
              i = e.editing.view,
              o = n.editable,
              r = i.document.getRoot();
          o.name = r.rootName, n.render();
          var s = o.element;
          this.setEditableElement(o.name, s), this.focusTracker.add(s), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.view,
              e = this.editor.editing.view;
          this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy(), _get(_getPrototypeOf(xl.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var t = this.editor,
              e = this.view,
              n = t.editing.view;
          e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), e.stickyPanel.limiterElement = e.element, this._toolbarConfig.viewportTopOffset && (e.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset), e.toolbar.fillFromConfig(this._toolbarConfig.items, this.componentFactory), function (_ref84) {
            var t = _ref84.origin,
                e = _ref84.originKeystrokeHandler,
                n = _ref84.originFocusTracker,
                i = _ref84.toolbar,
                o = _ref84.beforeFocus,
                r = _ref84.afterBlur;
            n.add(i.element), e.set("Alt+F10", function (t, e) {
              n.isFocused && !i.focusTracker.isFocused && (o && o(), i.focus(), e());
            }), i.keystrokes.set("Esc", function (e, n) {
              i.focusTracker.isFocused && (t.focus(), r && r(), n());
            });
          }({
            origin: n,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: t.keystrokes,
            toolbar: e.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document.getRoot(),
              i = t.sourceElement,
              o = t.config.get("placeholder") || i && "textarea" === i.tagName.toLowerCase() && i.getAttribute("placeholder");
          o && wl({
            view: e,
            element: n,
            text: o,
            isDirectHost: !1
          });
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }]);

      return xl;
    }(pl);

    var Al =
    /*#__PURE__*/
    function (_ro) {
      _inherits(Al, _ro);

      function Al(t) {
        var _this78;

        _classCallCheck(this, Al);

        _this78 = _possibleConstructorReturn(this, _getPrototypeOf(Al).call(this, {
          idProperty: "viewUid"
        })), _this78.on("add", function (t, e, n) {
          e.isRendered || e.render(), e.element && _this78._parentElement && _this78._parentElement.insertBefore(e.element, _this78._parentElement.children[n]);
        }), _this78.on("remove", function (t, e) {
          e.element && _this78._parentElement && e.element.remove();
        }), _this78.locale = t, _this78._parentElement = null;
        return _this78;
      }

      _createClass(Al, [{
        key: "destroy",
        value: function destroy() {
          this.map(function (t) {
            return t.destroy();
          });
        }
      }, {
        key: "setParent",
        value: function setParent(t) {
          this._parentElement = t;
        }
      }, {
        key: "delegate",
        value: function delegate() {
          var _this79 = this;

          for (var _len17 = arguments.length, t = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            t[_key17] = arguments[_key17];
          }

          if (!t.length || !t.every(function (t) {
            return "string" == typeof t;
          })) throw new Qn.b("ui-viewcollection-delegate-wrong-events: All event names must be strings.", this);
          return {
            to: function to(e) {
              var _iteratorNormalCompletion242 = true;
              var _didIteratorError242 = false;
              var _iteratorError242 = undefined;

              try {
                for (var _iterator242 = _this79[Symbol.iterator](), _step242; !(_iteratorNormalCompletion242 = (_step242 = _iterator242.next()).done); _iteratorNormalCompletion242 = true) {
                  var _n163 = _step242.value;
                  var _iteratorNormalCompletion245 = true;
                  var _didIteratorError245 = false;
                  var _iteratorError245 = undefined;

                  try {
                    for (var _iterator245 = t[Symbol.iterator](), _step245; !(_iteratorNormalCompletion245 = (_step245 = _iterator245.next()).done); _iteratorNormalCompletion245 = true) {
                      var _i121 = _step245.value;

                      _n163.delegate(_i121).to(e);
                    }
                  } catch (err) {
                    _didIteratorError245 = true;
                    _iteratorError245 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion245 && _iterator245.return != null) {
                        _iterator245.return();
                      }
                    } finally {
                      if (_didIteratorError245) {
                        throw _iteratorError245;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError242 = true;
                _iteratorError242 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion242 && _iterator242.return != null) {
                    _iterator242.return();
                  }
                } finally {
                  if (_didIteratorError242) {
                    throw _iteratorError242;
                  }
                }
              }

              _this79.on("add", function (n, i) {
                var _iteratorNormalCompletion243 = true;
                var _didIteratorError243 = false;
                var _iteratorError243 = undefined;

                try {
                  for (var _iterator243 = t[Symbol.iterator](), _step243; !(_iteratorNormalCompletion243 = (_step243 = _iterator243.next()).done); _iteratorNormalCompletion243 = true) {
                    var _n161 = _step243.value;
                    i.delegate(_n161).to(e);
                  }
                } catch (err) {
                  _didIteratorError243 = true;
                  _iteratorError243 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion243 && _iterator243.return != null) {
                      _iterator243.return();
                    }
                  } finally {
                    if (_didIteratorError243) {
                      throw _iteratorError243;
                    }
                  }
                }
              }), _this79.on("remove", function (n, i) {
                var _iteratorNormalCompletion244 = true;
                var _didIteratorError244 = false;
                var _iteratorError244 = undefined;

                try {
                  for (var _iterator244 = t[Symbol.iterator](), _step244; !(_iteratorNormalCompletion244 = (_step244 = _iterator244.next()).done); _iteratorNormalCompletion244 = true) {
                    var _n162 = _step244.value;
                    i.stopDelegating(_n162, e);
                  }
                } catch (err) {
                  _didIteratorError244 = true;
                  _iteratorError244 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion244 && _iterator244.return != null) {
                      _iterator244.return();
                    }
                  } finally {
                    if (_didIteratorError244) {
                      throw _iteratorError244;
                    }
                  }
                }
              });
            }
          };
        }
      }]);

      return Al;
    }(ro);

    var Tl = "http://www.w3.org/1999/xhtml";

    var Cl =
    /*#__PURE__*/
    function () {
      function Cl(t) {
        _classCallCheck(this, Cl);

        Object.assign(this, Ll(Dl(t))), this._isRendered = !1, this._revertData = null;
      }

      _createClass(Cl, [{
        key: "render",
        value: function render() {
          var t = this._renderNode({
            intoFragment: !0
          });

          return this._isRendered = !0, t;
        }
      }, {
        key: "apply",
        value: function apply(t) {
          return this._revertData = {
            children: [],
            bindings: [],
            attributes: {}
          }, this._renderNode({
            node: t,
            isApplying: !0,
            revertData: this._revertData
          }), t;
        }
      }, {
        key: "revert",
        value: function revert(t) {
          if (!this._revertData) throw new Qn.b("ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.", [this, t]);

          this._revertTemplateFromNode(t, this._revertData);
        }
      }, {
        key: "getViews",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getViews() {
          return _regeneratorRuntime.wrap(function getViews$(_context35) {
            while (1) {
              switch (_context35.prev = _context35.next) {
                case 0:
                  return _context35.delegateYield(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function t(e) {
                    var _iteratorNormalCompletion246, _didIteratorError246, _iteratorError246, _iterator246, _step246, _n164;

                    return _regeneratorRuntime.wrap(function t$(_context34) {
                      while (1) {
                        switch (_context34.prev = _context34.next) {
                          case 0:
                            if (!e.children) {
                              _context34.next = 33;
                              break;
                            }

                            _iteratorNormalCompletion246 = true;
                            _didIteratorError246 = false;
                            _iteratorError246 = undefined;
                            _context34.prev = 4;
                            _iterator246 = e.children[Symbol.iterator]();

                          case 6:
                            if (_iteratorNormalCompletion246 = (_step246 = _iterator246.next()).done) {
                              _context34.next = 19;
                              break;
                            }

                            _n164 = _step246.value;

                            if (!Fl(_n164)) {
                              _context34.next = 13;
                              break;
                            }

                            _context34.next = 11;
                            return _n164;

                          case 11:
                            _context34.next = 16;
                            break;

                          case 13:
                            _context34.t0 = Ul(_n164);

                            if (!_context34.t0) {
                              _context34.next = 16;
                              break;
                            }

                            return _context34.delegateYield(t(_n164), "t1", 16);

                          case 16:
                            _iteratorNormalCompletion246 = true;
                            _context34.next = 6;
                            break;

                          case 19:
                            _context34.next = 25;
                            break;

                          case 21:
                            _context34.prev = 21;
                            _context34.t2 = _context34["catch"](4);
                            _didIteratorError246 = true;
                            _iteratorError246 = _context34.t2;

                          case 25:
                            _context34.prev = 25;
                            _context34.prev = 26;

                            if (!_iteratorNormalCompletion246 && _iterator246.return != null) {
                              _iterator246.return();
                            }

                          case 28:
                            _context34.prev = 28;

                            if (!_didIteratorError246) {
                              _context34.next = 31;
                              break;
                            }

                            throw _iteratorError246;

                          case 31:
                            return _context34.finish(28);

                          case 32:
                            return _context34.finish(25);

                          case 33:
                          case "end":
                            return _context34.stop();
                        }
                      }
                    }, t, null, [[4, 21, 25, 33], [26,, 28, 32]]);
                  })(this), "t0", 1);

                case 1:
                case "end":
                  return _context35.stop();
              }
            }
          }, getViews, this);
        })
      }, {
        key: "_renderNode",
        value: function _renderNode(t) {
          var e;
          if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text, e) throw new Qn.b('ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.', this);
          return this.text ? this._renderText(t) : this._renderElement(t);
        }
      }, {
        key: "_renderElement",
        value: function _renderElement(t) {
          var e = t.node;
          return e || (e = t.node = document.createElementNS(this.ns || Tl, this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
        }
      }, {
        key: "_renderText",
        value: function _renderText(t) {
          var e = t.node;
          return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), El(this.text) ? this._bindToObservable({
            schema: this.text,
            updater: Nl(e),
            data: t
          }) : e.textContent = this.text.join(""), e;
        }
      }, {
        key: "_renderAttributes",
        value: function _renderAttributes(t) {
          var e, n, i, o;
          if (!this.attributes) return;
          var r = t.node,
              s = t.revertData;

          for (e in this.attributes) {
            if (i = r.getAttribute(e), n = this.attributes[e], s && (s.attributes[e] = i), o = B(n[0]) && n[0].ns ? n[0].ns : null, El(n)) {
              var _a10 = o ? n[0].value : n;

              s && ql(e) && _a10.unshift(i), this._bindToObservable({
                schema: _a10,
                updater: Ol(r, e, o),
                data: t
              });
            } else "style" == e && "string" != typeof n[0] ? this._renderStyleAttribute(n[0], t) : (s && i && ql(e) && n.unshift(i), n = n.map(function (t) {
              return t && t.value || t;
            }).reduce(function (t, e) {
              return t.concat(e);
            }, []).reduce(Vl, ""), Bl(n) || r.setAttributeNS(o, e, n));
          }
        }
      }, {
        key: "_renderStyleAttribute",
        value: function _renderStyleAttribute(t, e) {
          var n = e.node;

          for (var _i122 in t) {
            var _o61 = t[_i122];
            El(_o61) ? this._bindToObservable({
              schema: [_o61],
              updater: Rl(n, _i122),
              data: e
            }) : n.style[_i122] = _o61;
          }
        }
      }, {
        key: "_renderElementChildren",
        value: function _renderElementChildren(t) {
          var e = t.node,
              n = t.intoFragment ? document.createDocumentFragment() : e,
              i = t.isApplying;
          var o = 0;
          var _iteratorNormalCompletion247 = true;
          var _didIteratorError247 = false;
          var _iteratorError247 = undefined;

          try {
            for (var _iterator247 = this.children[Symbol.iterator](), _step247; !(_iteratorNormalCompletion247 = (_step247 = _iterator247.next()).done); _iteratorNormalCompletion247 = true) {
              var _r24 = _step247.value;

              if (Hl(_r24)) {
                if (!i) {
                  _r24.setParent(e);

                  var _iteratorNormalCompletion248 = true;
                  var _didIteratorError248 = false;
                  var _iteratorError248 = undefined;

                  try {
                    for (var _iterator248 = _r24[Symbol.iterator](), _step248; !(_iteratorNormalCompletion248 = (_step248 = _iterator248.next()).done); _iteratorNormalCompletion248 = true) {
                      var _t196 = _step248.value;
                      n.appendChild(_t196.element);
                    }
                  } catch (err) {
                    _didIteratorError248 = true;
                    _iteratorError248 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion248 && _iterator248.return != null) {
                        _iterator248.return();
                      }
                    } finally {
                      if (_didIteratorError248) {
                        throw _iteratorError248;
                      }
                    }
                  }
                }
              } else if (Fl(_r24)) i || (_r24.isRendered || _r24.render(), n.appendChild(_r24.element));else if (Zo(_r24)) n.appendChild(_r24);else if (i) {
                var _e183 = {
                  children: [],
                  bindings: [],
                  attributes: {}
                };
                t.revertData.children.push(_e183), _r24._renderNode({
                  node: n.childNodes[o++],
                  isApplying: !0,
                  revertData: _e183
                });
              } else n.appendChild(_r24.render());
            }
          } catch (err) {
            _didIteratorError247 = true;
            _iteratorError247 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion247 && _iterator247.return != null) {
                _iterator247.return();
              }
            } finally {
              if (_didIteratorError247) {
                throw _iteratorError247;
              }
            }
          }

          t.intoFragment && e.appendChild(n);
        }
      }, {
        key: "_setUpListeners",
        value: function _setUpListeners(t) {
          var _this80 = this;

          if (this.eventListeners) {
            var _loop4 = function _loop4(_e184) {
              var n = _this80.eventListeners[_e184].map(function (n) {
                var _e184$split = _e184.split("@"),
                    _e184$split2 = _slicedToArray(_e184$split, 2),
                    i = _e184$split2[0],
                    o = _e184$split2[1];

                return n.activateDomEventListener(i, o, t);
              });

              t.revertData && t.revertData.bindings.push(n);
            };

            for (var _e184 in this.eventListeners) {
              _loop4(_e184);
            }
          }
        }
      }, {
        key: "_bindToObservable",
        value: function _bindToObservable(_ref85) {
          var t = _ref85.schema,
              e = _ref85.updater,
              n = _ref85.data;
          var i = n.revertData;
          Il(t, e, n);
          var o = t.filter(function (t) {
            return !Bl(t);
          }).filter(function (t) {
            return t.observable;
          }).map(function (i) {
            return i.activateAttributeListener(t, e, n);
          });
          i && i.bindings.push(o);
        }
      }, {
        key: "_revertTemplateFromNode",
        value: function _revertTemplateFromNode(t, e) {
          var _iteratorNormalCompletion249 = true;
          var _didIteratorError249 = false;
          var _iteratorError249 = undefined;

          try {
            for (var _iterator249 = e.bindings[Symbol.iterator](), _step249; !(_iteratorNormalCompletion249 = (_step249 = _iterator249.next()).done); _iteratorNormalCompletion249 = true) {
              var _t197 = _step249.value;
              var _iteratorNormalCompletion250 = true;
              var _didIteratorError250 = false;
              var _iteratorError250 = undefined;

              try {
                for (var _iterator250 = _t197[Symbol.iterator](), _step250; !(_iteratorNormalCompletion250 = (_step250 = _iterator250.next()).done); _iteratorNormalCompletion250 = true) {
                  var _e185 = _step250.value;

                  _e185();
                }
              } catch (err) {
                _didIteratorError250 = true;
                _iteratorError250 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion250 && _iterator250.return != null) {
                    _iterator250.return();
                  }
                } finally {
                  if (_didIteratorError250) {
                    throw _iteratorError250;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError249 = true;
            _iteratorError249 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion249 && _iterator249.return != null) {
                _iterator249.return();
              }
            } finally {
              if (_didIteratorError249) {
                throw _iteratorError249;
              }
            }
          }

          if (e.text) t.textContent = e.text;else {
            for (var _n165 in e.attributes) {
              var _i123 = e.attributes[_n165];
              null === _i123 ? t.removeAttribute(_n165) : t.setAttribute(_n165, _i123);
            }

            for (var _n166 = 0; _n166 < e.children.length; ++_n166) {
              this._revertTemplateFromNode(t.childNodes[_n166], e.children[_n166]);
            }
          }
        }
      }], [{
        key: "bind",
        value: function bind(t, e) {
          return {
            to: function to(n, i) {
              return new Sl({
                eventNameOrFunction: n,
                attribute: n,
                observable: t,
                emitter: e,
                callback: i
              });
            },
            if: function _if(n, i, o) {
              return new Ml({
                observable: t,
                emitter: e,
                attribute: n,
                valueIfTrue: i,
                callback: o
              });
            }
          };
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (t._isRendered) throw new Qn.b("template-extend-render: Attempting to extend a template which has already been rendered.", [this, t]);
          !function t(e, n) {
            var _e$text;

            n.attributes && (e.attributes || (e.attributes = {}), zl(e.attributes, n.attributes));
            n.eventListeners && (e.eventListeners || (e.eventListeners = {}), zl(e.eventListeners, n.eventListeners));
            n.text && (_e$text = e.text).push.apply(_e$text, _toConsumableArray(n.text));

            if (n.children && n.children.length) {
              if (e.children.length != n.children.length) throw new Qn.b("ui-template-extend-children-mismatch: The number of children in extended definition does not match.", e);
              var _i124 = 0;
              var _iteratorNormalCompletion251 = true;
              var _didIteratorError251 = false;
              var _iteratorError251 = undefined;

              try {
                for (var _iterator251 = n.children[Symbol.iterator](), _step251; !(_iteratorNormalCompletion251 = (_step251 = _iterator251.next()).done); _iteratorNormalCompletion251 = true) {
                  var _o62 = _step251.value;
                  t(e.children[_i124++], _o62);
                }
              } catch (err) {
                _didIteratorError251 = true;
                _iteratorError251 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion251 && _iterator251.return != null) {
                    _iterator251.return();
                  }
                } finally {
                  if (_didIteratorError251) {
                    throw _iteratorError251;
                  }
                }
              }
            }
          }(t, Ll(Dl(e)));
        }
      }]);

      return Cl;
    }();

    li(Cl, ni);

    var Pl =
    /*#__PURE__*/
    function () {
      function Pl(t) {
        _classCallCheck(this, Pl);

        Object.assign(this, t);
      }

      _createClass(Pl, [{
        key: "getValue",
        value: function getValue(t) {
          var e = this.observable[this.attribute];
          return this.callback ? this.callback(e, t) : e;
        }
      }, {
        key: "activateAttributeListener",
        value: function activateAttributeListener(t, e, n) {
          var _this81 = this;

          var i = function i() {
            return Il(t, e, n);
          };

          return this.emitter.listenTo(this.observable, "change:" + this.attribute, i), function () {
            _this81.emitter.stopListening(_this81.observable, "change:" + _this81.attribute, i);
          };
        }
      }]);

      return Pl;
    }();

    var Sl =
    /*#__PURE__*/
    function (_Pl) {
      _inherits(Sl, _Pl);

      function Sl() {
        _classCallCheck(this, Sl);

        return _possibleConstructorReturn(this, _getPrototypeOf(Sl).apply(this, arguments));
      }

      _createClass(Sl, [{
        key: "activateDomEventListener",
        value: function activateDomEventListener(t, e, n) {
          var _this82 = this;

          var i = function i(t, n) {
            e && !n.target.matches(e) || ("function" == typeof _this82.eventNameOrFunction ? _this82.eventNameOrFunction(n) : _this82.observable.fire(_this82.eventNameOrFunction, n));
          };

          return this.emitter.listenTo(n.node, t, i), function () {
            _this82.emitter.stopListening(n.node, t, i);
          };
        }
      }]);

      return Sl;
    }(Pl);

    var Ml =
    /*#__PURE__*/
    function (_Pl2) {
      _inherits(Ml, _Pl2);

      function Ml() {
        _classCallCheck(this, Ml);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ml).apply(this, arguments));
      }

      _createClass(Ml, [{
        key: "getValue",
        value: function getValue(t) {
          return !Bl(_get(_getPrototypeOf(Ml.prototype), "getValue", this).call(this, t)) && (this.valueIfTrue || !0);
        }
      }]);

      return Ml;
    }(Pl);

    function El(t) {
      return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(El) : t instanceof Pl);
    }

    function Il(t, e, _ref86) {
      var n = _ref86.node;

      var i = function (t, e) {
        return t.map(function (t) {
          return t instanceof Pl ? t.getValue(e) : t;
        });
      }(t, n);

      i = 1 == t.length && t[0] instanceof Ml ? i[0] : i.reduce(Vl, ""), Bl(i) ? e.remove() : e.set(i);
    }

    function Nl(t) {
      return {
        set: function set(e) {
          t.textContent = e;
        },
        remove: function remove() {
          t.textContent = "";
        }
      };
    }

    function Ol(t, e, n) {
      return {
        set: function set(i) {
          t.setAttributeNS(n, e, i);
        },
        remove: function remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }

    function Rl(t, e) {
      return {
        set: function set(n) {
          t.style[e] = n;
        },
        remove: function remove() {
          t.style[e] = null;
        }
      };
    }

    function Dl(t) {
      return Wn(t, function (t) {
        if (t && (t instanceof Pl || Ul(t) || Fl(t) || Hl(t))) return t;
      });
    }

    function Ll(t) {
      if ("string" == typeof t ? t = function (t) {
        return {
          text: [t]
        };
      }(t) : t.text && function (t) {
        Array.isArray(t.text) || (t.text = [t.text]);
      }(t), t.on && (t.eventListeners = function (t) {
        for (var _e186 in t) {
          jl(t, _e186);
        }

        return t;
      }(t.on), delete t.on), !t.text) {
        t.attributes && function (t) {
          for (var _e188 in t) {
            t[_e188].value && (t[_e188].value = [].concat(t[_e188].value)), jl(t, _e188);
          }
        }(t.attributes);
        var _e187 = [];
        if (t.children) if (Hl(t.children)) _e187.push(t.children);else {
          var _iteratorNormalCompletion252 = true;
          var _didIteratorError252 = false;
          var _iteratorError252 = undefined;

          try {
            for (var _iterator252 = t.children[Symbol.iterator](), _step252; !(_iteratorNormalCompletion252 = (_step252 = _iterator252.next()).done); _iteratorNormalCompletion252 = true) {
              var _n167 = _step252.value;
              Ul(_n167) || Fl(_n167) || Zo(_n167) ? _e187.push(_n167) : _e187.push(new Cl(_n167));
            }
          } catch (err) {
            _didIteratorError252 = true;
            _iteratorError252 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion252 && _iterator252.return != null) {
                _iterator252.return();
              }
            } finally {
              if (_didIteratorError252) {
                throw _iteratorError252;
              }
            }
          }
        }
        t.children = _e187;
      }

      return t;
    }

    function jl(t, e) {
      Array.isArray(t[e]) || (t[e] = [t[e]]);
    }

    function Vl(t, e) {
      return Bl(e) ? t : Bl(t) ? e : "".concat(t, " ").concat(e);
    }

    function zl(t, e) {
      for (var _n168 in e) {
        var _t$_n;

        t[_n168] ? (_t$_n = t[_n168]).push.apply(_t$_n, _toConsumableArray(e[_n168])) : t[_n168] = e[_n168];
      }
    }

    function Bl(t) {
      return !t && 0 !== t;
    }

    function Fl(t) {
      return t instanceof Wl;
    }

    function Ul(t) {
      return t instanceof Cl;
    }

    function Hl(t) {
      return t instanceof Al;
    }

    function ql(t) {
      return "class" == t || "style" == t;
    }

    n(15);

    var Wl =
    /*#__PURE__*/
    function () {
      function Wl(t) {
        _classCallCheck(this, Wl);

        this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new ro(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (e, n) {
          n.locale = t;
        }), this.decorate("render");
      }

      _createClass(Wl, [{
        key: "createCollection",
        value: function createCollection() {
          var t = new Al();
          return this._viewCollections.add(t), t;
        }
      }, {
        key: "registerChild",
        value: function registerChild(t) {
          bi(t) || (t = [t]);
          var _iteratorNormalCompletion253 = true;
          var _didIteratorError253 = false;
          var _iteratorError253 = undefined;

          try {
            for (var _iterator253 = t[Symbol.iterator](), _step253; !(_iteratorNormalCompletion253 = (_step253 = _iterator253.next()).done); _iteratorNormalCompletion253 = true) {
              var _e189 = _step253.value;

              this._unboundChildren.add(_e189);
            }
          } catch (err) {
            _didIteratorError253 = true;
            _iteratorError253 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion253 && _iterator253.return != null) {
                _iterator253.return();
              }
            } finally {
              if (_didIteratorError253) {
                throw _iteratorError253;
              }
            }
          }
        }
      }, {
        key: "deregisterChild",
        value: function deregisterChild(t) {
          bi(t) || (t = [t]);
          var _iteratorNormalCompletion254 = true;
          var _didIteratorError254 = false;
          var _iteratorError254 = undefined;

          try {
            for (var _iterator254 = t[Symbol.iterator](), _step254; !(_iteratorNormalCompletion254 = (_step254 = _iterator254.next()).done); _iteratorNormalCompletion254 = true) {
              var _e190 = _step254.value;

              this._unboundChildren.remove(_e190);
            }
          } catch (err) {
            _didIteratorError254 = true;
            _iteratorError254 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion254 && _iterator254.return != null) {
                _iterator254.return();
              }
            } finally {
              if (_didIteratorError254) {
                throw _iteratorError254;
              }
            }
          }
        }
      }, {
        key: "setTemplate",
        value: function setTemplate(t) {
          this.template = new Cl(t);
        }
      }, {
        key: "extendTemplate",
        value: function extendTemplate(t) {
          Cl.extend(this.template, t);
        }
      }, {
        key: "render",
        value: function render() {
          if (this.isRendered) throw new Qn.b("ui-view-render-already-rendered: This View has already been rendered.", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this._viewCollections.map(function (t) {
            return t.destroy();
          }), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }, {
        key: "bindTemplate",
        get: function get() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Cl.bind(this, this);
        }
      }]);

      return Wl;
    }();

    li(Wl, ur), li(Wl, Ui);
    n(17);

    var Yl =
    /*#__PURE__*/
    function (_Wl) {
      _inherits(Yl, _Wl);

      function Yl(t) {
        var _this83;

        _classCallCheck(this, Yl);

        _this83 = _possibleConstructorReturn(this, _getPrototypeOf(Yl).call(this, t)), _this83.body = _this83.createCollection();
        return _this83;
      }

      _createClass(Yl, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Yl.prototype), "render", this).call(this), this._renderBodyCollection();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._bodyCollectionContainer.remove(), _get(_getPrototypeOf(Yl.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_renderBodyCollection",
        value: function _renderBodyCollection() {
          var t = this.locale,
              e = this._bodyCollectionContainer = new Cl({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
              dir: t.uiLanguageDirection
            },
            children: this.body
          }).render();
          document.body.appendChild(e);
        }
      }]);

      return Yl;
    }(Wl);

    n(19);

    var $l =
    /*#__PURE__*/
    function (_Wl2) {
      _inherits($l, _Wl2);

      function $l(t) {
        var _this84;

        _classCallCheck(this, $l);

        _this84 = _possibleConstructorReturn(this, _getPrototypeOf($l).call(this, t)), _this84.set("text"), _this84.set("for");
        var e = _this84.bindTemplate;

        _this84.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });

        return _this84;
      }

      return $l;
    }(Wl);

    var Gl =
    /*#__PURE__*/
    function (_Yl) {
      _inherits(Gl, _Yl);

      function Gl(t) {
        var _this85;

        _classCallCheck(this, Gl);

        _this85 = _possibleConstructorReturn(this, _getPrototypeOf(Gl).call(this, t));
        var e = Zn();
        _this85.top = _this85.createCollection(), _this85.main = _this85.createCollection(), _this85._voiceLabelView = _this85._createVoiceLabel(e), _this85.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: t.uiLanguageDirection,
            lang: t.uiLanguage,
            "aria-labelledby": "ck-editor__aria-label_".concat(e)
          },
          children: [_this85._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: _this85.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: _this85.main
          }]
        });
        return _this85;
      }

      _createClass(Gl, [{
        key: "_createVoiceLabel",
        value: function _createVoiceLabel(t) {
          var e = this.t,
              n = new $l();
          return n.text = e("bl"), n.extendTemplate({
            attributes: {
              id: "ck-editor__aria-label_".concat(t),
              class: "ck-voice-label"
            }
          }), n;
        }
      }]);

      return Gl;
    }(Yl);

    var Ql =
    /*#__PURE__*/
    function (_Wl3) {
      _inherits(Ql, _Wl3);

      function Ql(t, e, n) {
        var _this86;

        _classCallCheck(this, Ql);

        _this86 = _possibleConstructorReturn(this, _getPrototypeOf(Ql).call(this, t)), _this86.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: t.contentLanguage,
            dir: t.contentLanguageDirection
          }
        }), _this86.name = null, _this86.set("isFocused", !1), _this86._editableElement = n, _this86._hasExternalElement = !!_this86._editableElement, _this86._editingView = e;
        return _this86;
      }

      _createClass(Ql, [{
        key: "render",
        value: function render() {
          var _this87 = this;

          _get(_getPrototypeOf(Ql.prototype), "render", this).call(this), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
            return _this87._updateIsFocusedClasses();
          }), this._updateIsFocusedClasses();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), _get(_getPrototypeOf(Ql.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_updateIsFocusedClasses",
        value: function _updateIsFocusedClasses() {
          var t = this._editingView;

          function e(e) {
            t.change(function (n) {
              var i = t.document.getRoot(e.name);
              n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", i), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", i);
            });
          }

          t.isRenderingInProgress ? function n(i) {
            t.once("change:isRenderingInProgress", function (t, o, r) {
              r ? n(i) : e(i);
            });
          }(this) : e(this);
        }
      }]);

      return Ql;
    }(Wl);

    var Kl =
    /*#__PURE__*/
    function (_Ql) {
      _inherits(Kl, _Ql);

      function Kl(t, e, n) {
        var _this88;

        _classCallCheck(this, Kl);

        _this88 = _possibleConstructorReturn(this, _getPrototypeOf(Kl).call(this, t, e, n)), _this88.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        });
        return _this88;
      }

      _createClass(Kl, [{
        key: "render",
        value: function render() {
          var _this89 = this;

          _get(_getPrototypeOf(Kl.prototype), "render", this).call(this);

          var t = this._editingView,
              e = this.t;
          t.change(function (n) {
            var i = t.document.getRoot(_this89.name);
            n.setAttribute("aria-label", e("bu", [_this89.name]), i);
          });
        }
      }]);

      return Kl;
    }(Ql);

    function Jl(t) {
      return function (e) {
        return e + t;
      };
    }

    n(21);
    var Zl = Jl("px");

    var Xl =
    /*#__PURE__*/
    function (_Wl4) {
      _inherits(Xl, _Wl4);

      function Xl(t) {
        var _this90;

        _classCallCheck(this, Xl);

        _this90 = _possibleConstructorReturn(this, _getPrototypeOf(Xl).call(this, t));
        var e = _this90.bindTemplate;
        _this90.set("isActive", !1), _this90.set("isSticky", !1), _this90.set("limiterElement", null), _this90.set("limiterBottomOffset", 50), _this90.set("viewportTopOffset", 0), _this90.set("_marginLeft", null), _this90.set("_isStickyToTheLimiter", !1), _this90.set("_hasViewportTopOffset", !1), _this90.content = _this90.createCollection(), _this90._contentPanelPlaceholder = new Cl({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", function (t) {
                return t ? "block" : "none";
              }),
              height: e.to("isSticky", function (t) {
                return t ? Zl(_this90._panelRect.height) : null;
              })
            }
          }
        }).render(), _this90._contentPanel = new Cl({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", function (t) {
                return t ? Zl(_this90._contentPanelPlaceholder.getBoundingClientRect().width) : null;
              }),
              top: e.to("_hasViewportTopOffset", function (t) {
                return t ? Zl(_this90.viewportTopOffset) : null;
              }),
              bottom: e.to("_isStickyToTheLimiter", function (t) {
                return t ? Zl(_this90.limiterBottomOffset) : null;
              }),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: _this90.content
        }).render(), _this90.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [_this90._contentPanelPlaceholder, _this90._contentPanel]
        });
        return _this90;
      }

      _createClass(Xl, [{
        key: "render",
        value: function render() {
          var _this91 = this;

          _get(_getPrototypeOf(Xl.prototype), "render", this).call(this), this._checkIfShouldBeSticky(), this.listenTo(ir.window, "scroll", function () {
            _this91._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", function () {
            _this91._checkIfShouldBeSticky();
          });
        }
      }, {
        key: "_checkIfShouldBeSticky",
        value: function _checkIfShouldBeSticky() {
          var t = this._panelRect = this._contentPanel.getBoundingClientRect();

          var e;
          this.limiterElement ? (e = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : Zl(-ir.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }]);

      return Xl;
    }(Wl);

    var td =
    /*#__PURE__*/
    function () {
      function td(t) {
        var _this92 = this;

        _classCallCheck(this, td);

        if (Object.assign(this, t), t.actions && t.keystrokeHandler) {
          var _loop5 = function _loop5(_e191) {
            var n = t.actions[_e191];
            "string" == typeof n && (n = [n]);
            var _iteratorNormalCompletion255 = true;
            var _didIteratorError255 = false;
            var _iteratorError255 = undefined;

            try {
              for (var _iterator255 = n[Symbol.iterator](), _step255; !(_iteratorNormalCompletion255 = (_step255 = _iterator255.next()).done); _iteratorNormalCompletion255 = true) {
                var _i125 = _step255.value;
                t.keystrokeHandler.set(_i125, function (t, n) {
                  _this92[_e191](), n();
                });
              }
            } catch (err) {
              _didIteratorError255 = true;
              _iteratorError255 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion255 && _iterator255.return != null) {
                  _iterator255.return();
                }
              } finally {
                if (_didIteratorError255) {
                  throw _iteratorError255;
                }
              }
            }
          };

          for (var _e191 in t.actions) {
            _loop5(_e191);
          }
        }
      }

      _createClass(td, [{
        key: "focusFirst",
        value: function focusFirst() {
          this._focus(this.first);
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focus(this.last);
        }
      }, {
        key: "focusNext",
        value: function focusNext() {
          this._focus(this.next);
        }
      }, {
        key: "focusPrevious",
        value: function focusPrevious() {
          this._focus(this.previous);
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          t && t.focus();
        }
      }, {
        key: "_getFocusableItem",
        value: function _getFocusableItem(t) {
          var e = this.current,
              n = this.focusables.length;
          if (!n) return null;
          if (null === e) return this[1 === t ? "first" : "last"];
          var i = (e + n + t) % n;

          do {
            var _e192 = this.focusables.get(i);

            if (ed(_e192)) return _e192;
            i = (i + n + t) % n;
          } while (i !== e);

          return null;
        }
      }, {
        key: "first",
        get: function get() {
          return this.focusables.find(ed) || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this.focusables.filter(ed).slice(-1)[0] || null;
        }
      }, {
        key: "next",
        get: function get() {
          return this._getFocusableItem(1);
        }
      }, {
        key: "previous",
        get: function get() {
          return this._getFocusableItem(-1);
        }
      }, {
        key: "current",
        get: function get() {
          var _this93 = this;

          var t = null;
          return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (e, n) {
            var i = e.element === _this93.focusTracker.focusedElement;
            return i && (t = n), i;
          }), t);
        }
      }]);

      return td;
    }();

    function ed(t) {
      return !(!t.focus || "none" == ir.window.getComputedStyle(t.element).display);
    }

    var nd =
    /*#__PURE__*/
    function (_Wl5) {
      _inherits(nd, _Wl5);

      function nd(t) {
        var _this94;

        _classCallCheck(this, nd);

        _this94 = _possibleConstructorReturn(this, _getPrototypeOf(nd).call(this, t)), _this94.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
        return _this94;
      }

      return nd;
    }(Wl);

    var id = 100;

    var od =
    /*#__PURE__*/
    function () {
      function od(t) {
        _classCallCheck(this, od);

        this._callback = t, this._elements = new Set(), this._previousRects = new Map(), this._periodicCheckTimeout = null;
      }

      _createClass(od, [{
        key: "observe",
        value: function observe(t) {
          this._elements.add(t), 1 === this._elements.size && this._startPeriodicCheck();
        }
      }, {
        key: "unobserve",
        value: function unobserve(t) {
          this._elements.delete(t), this._previousRects.delete(t), this._elements.size || this._stopPeriodicCheck();
        }
      }, {
        key: "disconnect",
        value: function disconnect() {
          var _this95 = this;

          this._elements.forEach(function (t) {
            return _this95.unobserve(t);
          });
        }
      }, {
        key: "_startPeriodicCheck",
        value: function _startPeriodicCheck() {
          var _this96 = this;

          var t = function t() {
            _this96._checkElementRectsAndExecuteCallback(), _this96._periodicCheckTimeout = setTimeout(t, id);
          };

          this.listenTo(ir.window, "resize", function () {
            _this96._checkElementRectsAndExecuteCallback();
          }), t();
        }
      }, {
        key: "_stopPeriodicCheck",
        value: function _stopPeriodicCheck() {
          clearTimeout(this._periodicCheckTimeout), this.stopListening(), this._previousRects.clear();
        }
      }, {
        key: "_checkElementRectsAndExecuteCallback",
        value: function _checkElementRectsAndExecuteCallback() {
          var t = [];
          var _iteratorNormalCompletion256 = true;
          var _didIteratorError256 = false;
          var _iteratorError256 = undefined;

          try {
            for (var _iterator256 = this._elements[Symbol.iterator](), _step256; !(_iteratorNormalCompletion256 = (_step256 = _iterator256.next()).done); _iteratorNormalCompletion256 = true) {
              var _e193 = _step256.value;
              this._hasRectChanged(_e193) && t.push({
                target: _e193,
                contentRect: this._previousRects.get(_e193)
              });
            }
          } catch (err) {
            _didIteratorError256 = true;
            _iteratorError256 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion256 && _iterator256.return != null) {
                _iterator256.return();
              }
            } finally {
              if (_didIteratorError256) {
                throw _iteratorError256;
              }
            }
          }

          t.length && this._callback(t);
        }
      }, {
        key: "_hasRectChanged",
        value: function _hasRectChanged(t) {
          if (!t.ownerDocument.body.contains(t)) return !1;

          var e = new Ps(t),
              n = this._previousRects.get(t),
              i = !n || !n.isEqual(e);

          return this._previousRects.set(t, e), i;
        }
      }]);

      return od;
    }();

    li(od, ur);

    var rd =
    /*#__PURE__*/
    function (_Wl6) {
      _inherits(rd, _Wl6);

      function rd(t) {
        var _this97;

        _classCallCheck(this, rd);

        _this97 = _possibleConstructorReturn(this, _getPrototypeOf(rd).call(this, t));
        var e = _this97.bindTemplate;
        _this97.set("isVisible", !1), _this97.set("position", "se"), _this97.children = _this97.createCollection(), _this97.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", function (t) {
              return "ck-dropdown__panel_".concat(t);
            }), e.if("isVisible", "ck-dropdown__panel-visible")]
          },
          children: _this97.children,
          on: {
            selectstart: e.to(function (t) {
              return t.preventDefault();
            })
          }
        });
        return _this97;
      }

      _createClass(rd, [{
        key: "focus",
        value: function focus() {
          this.children.length && this.children.first.focus();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          if (this.children.length) {
            var _t198 = this.children.last;
            "function" == typeof _t198.focusLast ? _t198.focusLast() : _t198.focus();
          }
        }
      }]);

      return rd;
    }(Wl);

    n(23);

    function sd(_ref87) {
      var t = _ref87.element,
          e = _ref87.target,
          n = _ref87.positions,
          i = _ref87.limiter,
          o = _ref87.fitInViewport;
      Y(e) && (e = e()), Y(i) && (i = i());

      var r = function (t) {
        for (; t && "html" != t.tagName.toLowerCase();) {
          if ("static" != ir.window.getComputedStyle(t).position) return t;
          t = t.parentElement;
        }

        return null;
      }(t.parentElement),
          s = new Ps(t),
          a = new Ps(e);

      var c, l;

      if (i || o) {
        var _t199 = i && new Ps(i).getVisible(),
            _e194 = o && new Ps(ir.window);

        var _ref88 = function (t, e, n, i, o) {
          var r,
              s,
              a = 0,
              c = 0;
          var l = n.getArea();
          return t.some(function (t) {
            var _ad = ad(t, e, n),
                _ad2 = _slicedToArray(_ad, 2),
                d = _ad2[0],
                h = _ad2[1];

            var u, f;
            if (i) if (o) {
              var _t200 = i.getIntersection(o);

              u = _t200 ? _t200.getIntersectionArea(h) : 0;
            } else u = i.getIntersectionArea(h);

            function g() {
              c = f, a = u, r = h, s = d;
            }

            return o && (f = o.getIntersectionArea(h)), o && !i ? f > c && g() : !o && i ? u > a && g() : f > c && u >= a ? g() : f >= c && u > a && g(), u === l;
          }), r ? [s, r] : null;
        }(n, a, s, _t199, _e194) || ad(n[0], a, s);

        var _ref89 = _slicedToArray(_ref88, 2);

        l = _ref89[0];
        c = _ref89[1];
      } else {
        var _ad3 = ad(n[0], a, s);

        var _ad4 = _slicedToArray(_ad3, 2);

        l = _ad4[0];
        c = _ad4[1];
      }

      var _cd = cd(c),
          d = _cd.left,
          h = _cd.top;

      if (r) {
        var _t201 = cd(new Ps(r)),
            _e195 = Ts(r);

        d -= _t201.left, h -= _t201.top, d += r.scrollLeft, h += r.scrollTop, d -= _e195.left, h -= _e195.top;
      }

      return {
        left: d,
        top: h,
        name: l
      };
    }

    function ad(t, e, n) {
      var _t202 = t(e, n),
          i = _t202.left,
          o = _t202.top,
          r = _t202.name;

      return [r, n.clone().moveTo(i, o)];
    }

    function cd(_ref90) {
      var t = _ref90.left,
          e = _ref90.top;
      var _ir$window2 = ir.window,
          n = _ir$window2.scrollX,
          i = _ir$window2.scrollY;
      return {
        left: t + n,
        top: e + i
      };
    }

    var ld =
    /*#__PURE__*/
    function (_Wl7) {
      _inherits(ld, _Wl7);

      function ld(t, e, n) {
        var _this98;

        _classCallCheck(this, ld);

        _this98 = _possibleConstructorReturn(this, _getPrototypeOf(ld).call(this, t));
        var i = _this98.bindTemplate;
        _this98.buttonView = e, _this98.panelView = n, _this98.set("isOpen", !1), _this98.set("isEnabled", !0), _this98.set("class"), _this98.set("panelPosition", "auto"), _this98.focusTracker = new ml(), _this98.keystrokes = new sl(), _this98.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            })]
          },
          children: [e, n]
        }), e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"]
          }
        });
        return _this98;
      }

      _createClass(ld, [{
        key: "render",
        value: function render() {
          var _this99 = this;

          _get(_getPrototypeOf(ld.prototype), "render", this).call(this), this.listenTo(this.buttonView, "open", function () {
            _this99.isOpen = !_this99.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
            _this99.isOpen && ("auto" === _this99.panelPosition ? _this99.panelView.position = ld._getOptimalPosition({
              element: _this99.panelView.element,
              target: _this99.buttonView.element,
              fitInViewport: !0,
              positions: _this99._panelPositions
            }).name : _this99.panelView.position = _this99.panelPosition);
          }), this.keystrokes.listenTo(this.element), this.focusTracker.add(this.element);

          var t = function t(_t203, e) {
            _this99.isOpen && (_this99.buttonView.focus(), _this99.isOpen = !1, e());
          };

          this.keystrokes.set("arrowdown", function (t, e) {
            _this99.buttonView.isEnabled && !_this99.isOpen && (_this99.isOpen = !0, e());
          }), this.keystrokes.set("arrowright", function (t, e) {
            _this99.isOpen && e();
          }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }, {
        key: "_panelPositions",
        get: function get() {
          var _ld$defaultPanelPosit = ld.defaultPanelPositions,
              t = _ld$defaultPanelPosit.southEast,
              e = _ld$defaultPanelPosit.southWest,
              n = _ld$defaultPanelPosit.northEast,
              i = _ld$defaultPanelPosit.northWest;
          return "ltr" === this.locale.uiLanguageDirection ? [t, e, n, i] : [e, t, i, n];
        }
      }]);

      return ld;
    }(Wl);

    ld.defaultPanelPositions = {
      southEast: function southEast(t) {
        return {
          top: t.bottom,
          left: t.left,
          name: "se"
        };
      },
      southWest: function southWest(t, e) {
        return {
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        };
      },
      northEast: function northEast(t, e) {
        return {
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        };
      },
      northWest: function northWest(t, e) {
        return {
          top: t.bottom - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        };
      }
    }, ld._getOptimalPosition = sd;
    n(25);

    var dd =
    /*#__PURE__*/
    function (_Wl8) {
      _inherits(dd, _Wl8);

      function dd() {
        var _this100;

        _classCallCheck(this, dd);

        _this100 = _possibleConstructorReturn(this, _getPrototypeOf(dd).call(this));
        var t = _this100.bindTemplate;
        _this100.set("content", ""), _this100.set("viewBox", "0 0 20 20"), _this100.set("fillColor", ""), _this100.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon"],
            viewBox: t.to("viewBox")
          }
        });
        return _this100;
      }

      _createClass(dd, [{
        key: "render",
        value: function render() {
          var _this101 = this;

          _get(_getPrototypeOf(dd.prototype), "render", this).call(this), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
            _this101._updateXMLContent(), _this101._colorFillPaths();
          }), this.on("change:fillColor", function () {
            _this101._colorFillPaths();
          });
        }
      }, {
        key: "_updateXMLContent",
        value: function _updateXMLContent() {
          if (this.content) {
            var _t204 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
                _e196 = _t204.getAttribute("viewBox");

            for (_e196 && (this.viewBox = _e196), this.element.innerHTML = ""; _t204.childNodes.length > 0;) {
              this.element.appendChild(_t204.childNodes[0]);
            }
          }
        }
      }, {
        key: "_colorFillPaths",
        value: function _colorFillPaths() {
          var _this102 = this;

          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (t) {
            t.style.fill = _this102.fillColor;
          });
        }
      }]);

      return dd;
    }(Wl);

    n(27);

    var hd =
    /*#__PURE__*/
    function (_Wl9) {
      _inherits(hd, _Wl9);

      function hd(t) {
        var _this103;

        _classCallCheck(this, hd);

        _this103 = _possibleConstructorReturn(this, _getPrototypeOf(hd).call(this, t)), _this103.set("text", ""), _this103.set("position", "s");
        var e = _this103.bindTemplate;

        _this103.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip", e.to("position", function (t) {
              return "ck-tooltip_" + t;
            }), e.if("text", "ck-hidden", function (t) {
              return !t.trim();
            })]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: e.to("text")
            }]
          }]
        });

        return _this103;
      }

      return hd;
    }(Wl);

    n(29);

    var ud =
    /*#__PURE__*/
    function (_Wl10) {
      _inherits(ud, _Wl10);

      function ud(t) {
        var _this104;

        _classCallCheck(this, ud);

        _this104 = _possibleConstructorReturn(this, _getPrototypeOf(ud).call(this, t));
        var e = _this104.bindTemplate,
            n = Zn();
        _this104.set("class"), _this104.set("labelStyle"), _this104.set("icon"), _this104.set("isEnabled", !0), _this104.set("isOn", !1), _this104.set("isVisible", !0), _this104.set("isToggleable", !1), _this104.set("keystroke"), _this104.set("label"), _this104.set("tabindex", -1), _this104.set("tooltip"), _this104.set("tooltipPosition", "s"), _this104.set("type", "button"), _this104.set("withText", !1), _this104.set("withKeystroke", !1), _this104.children = _this104.createCollection(), _this104.tooltipView = _this104._createTooltipView(), _this104.labelView = _this104._createLabelView(n), _this104.iconView = new dd(), _this104.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), _this104.keystrokeView = _this104._createKeystrokeView(), _this104.bind("_tooltipString").to(_assertThisInitialized(_this104), "tooltip", _assertThisInitialized(_this104), "label", _assertThisInitialized(_this104), "keystroke", _this104._getTooltipString.bind(_assertThisInitialized(_this104))), _this104.setTemplate({
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), e.to("isOn", function (t) {
              return t ? "ck-on" : "ck-off";
            }), e.if("withText", "ck-button_with-text"), e.if("withKeystroke", "ck-button_with-keystroke")],
            type: e.to("type", function (t) {
              return t || "button";
            }),
            tabindex: e.to("tabindex"),
            "aria-labelledby": "ck-editor__aria-label_".concat(n),
            "aria-disabled": e.if("isEnabled", !0, function (t) {
              return !t;
            }),
            "aria-pressed": e.to("isOn", function (t) {
              return !!_this104.isToggleable && String(t);
            })
          },
          children: _this104.children,
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function (t) {
              _this104.isEnabled ? _this104.fire("execute") : t.preventDefault();
            })
          }
        });
        return _this104;
      }

      _createClass(ud, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(ud.prototype), "render", this).call(this), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView), this.withKeystroke && this.children.add(this.keystrokeView);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_createTooltipView",
        value: function _createTooltipView() {
          var t = new hd();
          return t.bind("text").to(this, "_tooltipString"), t.bind("position").to(this, "tooltipPosition"), t;
        }
      }, {
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new Wl(),
              n = this.bindTemplate;
          return e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__label"],
              style: n.to("labelStyle"),
              id: "ck-editor__aria-label_".concat(t)
            },
            children: [{
              text: this.bindTemplate.to("label")
            }]
          }), e;
        }
      }, {
        key: "_createKeystrokeView",
        value: function _createKeystrokeView() {
          var t = new Wl();
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__keystroke"]
            },
            children: [{
              text: this.bindTemplate.to("keystroke", function (t) {
                return vo(t);
              })
            }]
          }), t;
        }
      }, {
        key: "_getTooltipString",
        value: function _getTooltipString(t, e, n) {
          return t ? "string" == typeof t ? t : (n && (n = vo(n)), t instanceof Function ? t(e, n) : "".concat(e).concat(n ? " (".concat(n, ")") : "")) : "";
        }
      }]);

      return ud;
    }(Wl);

    var fd = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';

    var gd =
    /*#__PURE__*/
    function (_ud) {
      _inherits(gd, _ud);

      function gd(t) {
        var _this105;

        _classCallCheck(this, gd);

        _this105 = _possibleConstructorReturn(this, _getPrototypeOf(gd).call(this, t)), _this105.arrowView = _this105._createArrowView(), _this105.extendTemplate({
          attributes: {
            "aria-haspopup": !0
          }
        }), _this105.delegate("execute").to(_assertThisInitialized(_this105), "open");
        return _this105;
      }

      _createClass(gd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(gd.prototype), "render", this).call(this), this.children.add(this.arrowView);
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new dd();
          return t.content = fd, t.extendTemplate({
            attributes: {
              class: "ck-dropdown__arrow"
            }
          }), t;
        }
      }]);

      return gd;
    }(ud);

    n(31);

    var md =
    /*#__PURE__*/
    function (_Wl11) {
      _inherits(md, _Wl11);

      function md() {
        var _this106;

        _classCallCheck(this, md);

        _this106 = _possibleConstructorReturn(this, _getPrototypeOf(md).call(this)), _this106.items = _this106.createCollection(), _this106.focusTracker = new ml(), _this106.keystrokes = new sl(), _this106._focusCycler = new td({
          focusables: _this106.items,
          focusTracker: _this106.focusTracker,
          keystrokeHandler: _this106.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), _this106.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"]
          },
          children: _this106.items
        });
        return _this106;
      }

      _createClass(md, [{
        key: "render",
        value: function render() {
          var _this107 = this;

          _get(_getPrototypeOf(md.prototype), "render", this).call(this);

          var _iteratorNormalCompletion257 = true;
          var _didIteratorError257 = false;
          var _iteratorError257 = undefined;

          try {
            for (var _iterator257 = this.items[Symbol.iterator](), _step257; !(_iteratorNormalCompletion257 = (_step257 = _iterator257.next()).done); _iteratorNormalCompletion257 = true) {
              var _t205 = _step257.value;
              this.focusTracker.add(_t205.element);
            }
          } catch (err) {
            _didIteratorError257 = true;
            _iteratorError257 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion257 && _iterator257.return != null) {
                _iterator257.return();
              }
            } finally {
              if (_didIteratorError257) {
                throw _iteratorError257;
              }
            }
          }

          this.items.on("add", function (t, e) {
            _this107.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this107.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }]);

      return md;
    }(Wl);

    var pd =
    /*#__PURE__*/
    function (_Wl12) {
      _inherits(pd, _Wl12);

      function pd(t) {
        var _this108;

        _classCallCheck(this, pd);

        _this108 = _possibleConstructorReturn(this, _getPrototypeOf(pd).call(this, t)), _this108.children = _this108.createCollection(), _this108.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item"]
          },
          children: _this108.children
        });
        return _this108;
      }

      _createClass(pd, [{
        key: "focus",
        value: function focus() {
          this.children.first.focus();
        }
      }]);

      return pd;
    }(Wl);

    var bd =
    /*#__PURE__*/
    function (_Wl13) {
      _inherits(bd, _Wl13);

      function bd(t) {
        var _this109;

        _classCallCheck(this, bd);

        _this109 = _possibleConstructorReturn(this, _getPrototypeOf(bd).call(this, t)), _this109.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
        return _this109;
      }

      return bd;
    }(Wl);

    n(33);

    var wd =
    /*#__PURE__*/
    function (_ud2) {
      _inherits(wd, _ud2);

      function wd(t) {
        var _this110;

        _classCallCheck(this, wd);

        _this110 = _possibleConstructorReturn(this, _getPrototypeOf(wd).call(this, t)), _this110.isToggleable = !0, _this110.toggleSwitchView = _this110._createToggleView(), _this110.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
        return _this110;
      }

      _createClass(wd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(wd.prototype), "render", this).call(this), this.children.add(this.toggleSwitchView);
        }
      }, {
        key: "_createToggleView",
        value: function _createToggleView() {
          var t = new Wl();
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle"]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle__inner"]
              }
            }]
          }), t;
        }
      }]);

      return wd;
    }(ud);

    function kd(_ref91) {
      var t = _ref91.emitter,
          e = _ref91.activator,
          n = _ref91.callback,
          i = _ref91.contextElements;
      t.listenTo(document, "mousedown", function (t, _ref92) {
        var o = _ref92.target;

        if (e()) {
          var _iteratorNormalCompletion258 = true;
          var _didIteratorError258 = false;
          var _iteratorError258 = undefined;

          try {
            for (var _iterator258 = i[Symbol.iterator](), _step258; !(_iteratorNormalCompletion258 = (_step258 = _iterator258.next()).done); _iteratorNormalCompletion258 = true) {
              var _t206 = _step258.value;
              if (_t206.contains(o)) return;
            }
          } catch (err) {
            _didIteratorError258 = true;
            _iteratorError258 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion258 && _iterator258.return != null) {
                _iterator258.return();
              }
            } finally {
              if (_didIteratorError258) {
                throw _iteratorError258;
              }
            }
          }

          n();
        }
      });
    }

    n(35), n(37);

    function _d(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gd;
      var n = new e(t),
          i = new rd(t),
          o = new ld(t, n, i);
      return n.bind("isEnabled").to(o), n instanceof gd ? n.bind("isOn").to(o, "isOpen") : n.arrowView.bind("isOn").to(o, "isOpen"), function (t) {
        (function (t) {
          t.on("render", function () {
            kd({
              emitter: t,
              activator: function activator() {
                return t.isOpen;
              },
              callback: function callback() {
                t.isOpen = !1;
              },
              contextElements: [t.element]
            });
          });
        })(t), function (t) {
          t.on("execute", function (e) {
            e.source instanceof wd || (t.isOpen = !1);
          });
        }(t), function (t) {
          t.keystrokes.set("arrowdown", function (e, n) {
            t.isOpen && (t.panelView.focus(), n());
          }), t.keystrokes.set("arrowup", function (e, n) {
            t.isOpen && (t.panelView.focusLast(), n());
          });
        }(t);
      }(o), o;
    }

    function vd(t, e) {
      var n = t.locale,
          i = t.listView = new md(n);
      i.items.bindTo(e).using(function (_ref93) {
        var t = _ref93.type,
            e = _ref93.model;
        if ("separator" === t) return new bd(n);

        if ("button" === t || "switchbutton" === t) {
          var _o64;

          var _i126 = new pd(n);

          var _o63;

          return _o63 = "button" === t ? new ud(n) : new wd(n), (_o64 = _o63).bind.apply(_o64, _toConsumableArray(Object.keys(e))).to(e), _o63.delegate("execute").to(_i126), _i126.children.add(_o63), _i126;
        }
      }), t.panelView.children.add(i), i.items.delegate("execute").to(t);
    }

    var yd = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>\n';
    n(39);

    var xd =
    /*#__PURE__*/
    function (_Wl14) {
      _inherits(xd, _Wl14);

      function xd(t, e) {
        var _this111;

        _classCallCheck(this, xd);

        _this111 = _possibleConstructorReturn(this, _getPrototypeOf(xd).call(this, t));
        var n = _this111.bindTemplate,
            i = _this111.t;
        var o;
        _this111.options = e || {}, _this111.set("ariaLabel", i("bq")), _this111.items = _this111.createCollection(), _this111.focusTracker = new ml(), _this111.keystrokes = new sl(), _this111.set("class"), _this111.itemsView = new Ad(t), _this111.children = _this111.createCollection(), _this111.children.add(_this111.itemsView), _this111.focusables = _this111.createCollection(), _this111._focusCycler = new td({
          focusables: _this111.focusables,
          focusTracker: _this111.focusTracker,
          keystrokeHandler: _this111.keystrokes,
          actions: {
            focusPrevious: ["arrowleft", "arrowup"],
            focusNext: ["arrowright", "arrowdown"]
          }
        }), _this111.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar", n.to("class")],
            role: "toolbar",
            "aria-label": n.to("ariaLabel")
          },
          children: _this111.children,
          on: {
            mousedown: (o = _assertThisInitialized(_this111), o.bindTemplate.to(function (t) {
              t.target === o.element && t.preventDefault();
            }))
          }
        }), _this111._behavior = _this111.options.shouldGroupWhenFull ? new Cd(_assertThisInitialized(_this111)) : new Td(_assertThisInitialized(_this111));
        return _this111;
      }

      _createClass(xd, [{
        key: "render",
        value: function render() {
          var _this112 = this;

          _get(_getPrototypeOf(xd.prototype), "render", this).call(this);

          var _iteratorNormalCompletion259 = true;
          var _didIteratorError259 = false;
          var _iteratorError259 = undefined;

          try {
            for (var _iterator259 = this.items[Symbol.iterator](), _step259; !(_iteratorNormalCompletion259 = (_step259 = _iterator259.next()).done); _iteratorNormalCompletion259 = true) {
              var _t207 = _step259.value;
              this.focusTracker.add(_t207.element);
            }
          } catch (err) {
            _didIteratorError259 = true;
            _iteratorError259 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion259 && _iterator259.return != null) {
                _iterator259.return();
              }
            } finally {
              if (_didIteratorError259) {
                throw _iteratorError259;
              }
            }
          }

          this.items.on("add", function (t, e) {
            _this112.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this112.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._behavior.destroy(), _get(_getPrototypeOf(xd.prototype), "destroy", this).call(this);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "fillFromConfig",
        value: function fillFromConfig(t, e) {
          var _this113 = this;

          t.map(function (t) {
            "|" == t ? _this113.items.add(new nd()) : e.has(t) ? _this113.items.add(e.create(t)) : console.warn(Object(Qn.a)("toolbarview-item-unavailable: The requested toolbar item is unavailable."), {
              name: t
            });
          });
        }
      }]);

      return xd;
    }(Wl);

    var Ad =
    /*#__PURE__*/
    function (_Wl15) {
      _inherits(Ad, _Wl15);

      function Ad(t) {
        var _this114;

        _classCallCheck(this, Ad);

        _this114 = _possibleConstructorReturn(this, _getPrototypeOf(Ad).call(this, t)), _this114.children = _this114.createCollection(), _this114.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: _this114.children
        });
        return _this114;
      }

      return Ad;
    }(Wl);

    var Td =
    /*#__PURE__*/
    function () {
      function Td(t) {
        _classCallCheck(this, Td);

        var e = t.bindTemplate;
        t.set("isVertical", !1), t.itemsView.children.bindTo(t.items).using(function (t) {
          return t;
        }), t.focusables.bindTo(t.items).using(function (t) {
          return t;
        }), t.extendTemplate({
          attributes: {
            class: [e.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }

      _createClass(Td, [{
        key: "render",
        value: function render() {}
      }, {
        key: "destroy",
        value: function destroy() {}
      }]);

      return Td;
    }();

    var Cd =
    /*#__PURE__*/
    function () {
      function Cd(t) {
        var _this115 = this;

        _classCallCheck(this, Cd);

        this.viewChildren = t.children, this.viewFocusables = t.focusables, this.viewItemsView = t.itemsView, this.viewFocusTracker = t.focusTracker, this.viewLocale = t.locale, this.ungroupedItems = t.createCollection(), this.groupedItems = t.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), this.resizeObserver = null, this.cachedPadding = null, t.itemsView.children.bindTo(this.ungroupedItems).using(function (t) {
          return t;
        }), this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this)), this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this)), t.children.on("add", this._updateFocusCycleableItems.bind(this)), t.children.on("remove", this._updateFocusCycleableItems.bind(this)), t.items.on("add", function (t, e, n) {
          n > _this115.ungroupedItems.length ? _this115.groupedItems.add(e, n - _this115.ungroupedItems.length) : _this115.ungroupedItems.add(e, n), _this115._updateGrouping();
        }), t.items.on("remove", function (t, e, n) {
          n > _this115.ungroupedItems.length ? _this115.groupedItems.remove(e) : _this115.ungroupedItems.remove(e), _this115._updateGrouping();
        }), t.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }

      _createClass(Cd, [{
        key: "render",
        value: function render(t) {
          this.viewElement = t.element, this._enableGroupingOnResize();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.groupedItemsDropdown.destroy(), this.resizeObserver.disconnect();
        }
      }, {
        key: "_updateGrouping",
        value: function _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
          var t;

          for (; this._areItemsOverflowing;) {
            this._groupLastItem(), t = !0;
          }

          if (!t && this.groupedItems.length) {
            for (; this.groupedItems.length && !this._areItemsOverflowing;) {
              this._ungroupFirstItem();
            }

            this._areItemsOverflowing && this._groupLastItem();
          }
        }
      }, {
        key: "_enableGroupingOnResize",
        value: function _enableGroupingOnResize() {
          var _this116 = this;

          var t;
          var e;
          this.resizeObserver = (e = function e(_ref94) {
            var _ref95 = _slicedToArray(_ref94, 1),
                e = _ref95[0];

            t && t === e.contentRect.width || (_this116._updateGrouping(), t = e.contentRect.width);
          }, "function" == typeof ir.window.ResizeObserver ? new ir.window.ResizeObserver(e) : new od(e)), this.resizeObserver.observe(this.viewElement), this._updateGrouping();
        }
      }, {
        key: "_groupLastItem",
        value: function _groupLastItem() {
          this.groupedItems.length || (this.viewChildren.add(new nd()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
        }
      }, {
        key: "_ungroupFirstItem",
        value: function _ungroupFirstItem() {
          this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
        }
      }, {
        key: "_createGroupedItemsDropdown",
        value: function _createGroupedItemsDropdown() {
          var t = this.viewLocale,
              e = t.t,
              n = _d(t);

          return n.class = "ck-toolbar__grouped-dropdown", n.panelPosition = "ltr" === t.uiLanguageDirection ? "sw" : "se", function (t, e) {
            var n = t.locale,
                i = n.t,
                o = t.toolbarView = new xd(n);
            o.set("ariaLabel", i("bm")), t.extendTemplate({
              attributes: {
                class: ["ck-toolbar-dropdown"]
              }
            }), e.map(function (t) {
              return o.items.add(t);
            }), t.panelView.children.add(o), o.items.delegate("execute").to(t);
          }(n, []), n.buttonView.set({
            label: e("br"),
            tooltip: !0,
            icon: yd
          }), n.toolbarView.items.bindTo(this.groupedItems).using(function (t) {
            return t;
          }), n;
        }
      }, {
        key: "_updateFocusCycleableItems",
        value: function _updateFocusCycleableItems() {
          var _this117 = this;

          this.viewFocusables.clear(), this.ungroupedItems.map(function (t) {
            _this117.viewFocusables.add(t);
          }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
        }
      }, {
        key: "_areItemsOverflowing",
        get: function get() {
          if (!this.ungroupedItems.length) return !1;
          var t = this.viewElement,
              e = this.viewLocale.uiLanguageDirection,
              n = new Ps(t.lastChild),
              i = new Ps(t);

          if (!this.cachedPadding) {
            var _n169 = ir.window.getComputedStyle(t),
                _i127 = "ltr" === e ? "paddingRight" : "paddingLeft";

            this.cachedPadding = Number.parseInt(_n169[_i127]);
          }

          return "ltr" === e ? n.right > i.right - this.cachedPadding : n.left < i.left + this.cachedPadding;
        }
      }]);

      return Cd;
    }();

    n(41);

    var Pd =
    /*#__PURE__*/
    function (_Gl) {
      _inherits(Pd, _Gl);

      function Pd(t, e) {
        var _this118;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, Pd);

        _this118 = _possibleConstructorReturn(this, _getPrototypeOf(Pd).call(this, t)), _this118.stickyPanel = new Xl(t), _this118.toolbar = new xd(t, {
          shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
        }), _this118.editable = new Kl(t, e);
        return _this118;
      }

      _createClass(Pd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Pd.prototype), "render", this).call(this), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }]);

      return Pd;
    }(Gl);

    var Sd =
    /*#__PURE__*/
    function (_cl) {
      _inherits(Sd, _cl);

      function Sd(t, e) {
        var _this119;

        _classCallCheck(this, Sd);

        _this119 = _possibleConstructorReturn(this, _getPrototypeOf(Sd).call(this, e)), Yn(t) && (_this119.sourceElement = t), _this119.data.processor = new ul(), _this119.model.document.createRoot();
        var n = !_this119.config.get("toolbar.shouldNotGroupWhenFull"),
            i = new Pd(_this119.locale, _this119.editing.view, {
          shouldToolbarGroupWhenFull: n
        });
        _this119.ui = new xl(_assertThisInitialized(_this119), i), function (t) {
          if (!Y(t.updateSourceElement)) throw new Qn.b("attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.", t);
          var e = t.sourceElement;

          if (e && "textarea" === e.tagName.toLowerCase() && e.form) {
            var _n170;

            var _i128 = e.form,
                _o65 = function _o65() {
              return t.updateSourceElement();
            };

            Y(_i128.submit) && (_n170 = _i128.submit, _i128.submit = function () {
              _o65(), _n170.apply(_i128);
            }), _i128.addEventListener("submit", _o65), t.on("destroy", function () {
              _i128.removeEventListener("submit", _o65), _n170 && (_i128.submit = _n170);
            });
          }
        }(_assertThisInitialized(_this119));
        return _this119;
      }

      _createClass(Sd, [{
        key: "destroy",
        value: function destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _get(_getPrototypeOf(Sd.prototype), "destroy", this).call(this);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this120 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (n) {
            var i = new _this120(t, e);
            n(i.initPlugins().then(function () {
              return i.ui.init(Yn(t) ? t : null);
            }).then(function () {
              if (!Yn(t) && e.initialData) throw new Qn.b("editor-create-initial-data: The config.initialData option cannot be used together with initial data passed in Editor.create().", null);

              var n = e.initialData || function (t) {
                return Yn(t) ? (e = t, e instanceof HTMLTextAreaElement ? e.value : e.innerHTML) : t;
                var e;
              }(t);

              return i.data.init(n);
            }).then(function () {
              return i.fire("ready");
            }).then(function () {
              return i;
            }));
          });
        }
      }]);

      return Sd;
    }(cl);

    li(Sd, ll), li(Sd, dl);

    var Md =
    /*#__PURE__*/
    function () {
      function Md(t) {
        _classCallCheck(this, Md);

        this.editor = t;
      }

      _createClass(Md, [{
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return Md;
    }();

    li(Md, Ui);

    var Ed =
    /*#__PURE__*/
    function () {
      function Ed(t) {
        _classCallCheck(this, Ed);

        this.files = function (t) {
          var e = t.files ? Array.from(t.files) : [],
              n = t.items ? Array.from(t.items) : [];
          if (e.length) return e;
          return n.filter(function (t) {
            return "file" === t.kind;
          }).map(function (t) {
            return t.getAsFile();
          });
        }(t), this._native = t;
      }

      _createClass(Ed, [{
        key: "getData",
        value: function getData(t) {
          return this._native.getData(t);
        }
      }, {
        key: "setData",
        value: function setData(t, e) {
          this._native.setData(t, e);
        }
      }, {
        key: "types",
        get: function get() {
          return this._native.types;
        }
      }]);

      return Ed;
    }();

    var Id =
    /*#__PURE__*/
    function (_is5) {
      _inherits(Id, _is5);

      function Id(t) {
        var _this121;

        _classCallCheck(this, Id);

        _this121 = _possibleConstructorReturn(this, _getPrototypeOf(Id).call(this, t));
        var e = _this121.document;

        function n(t, n) {
          n.preventDefault();
          var i = n.dropRange ? [n.dropRange] : Array.from(e.selection.getRanges()),
              o = new Jn(e, "clipboardInput");
          e.fire(o, {
            dataTransfer: n.dataTransfer,
            targetRanges: i
          }), o.stop.called && n.stopPropagation();
        }

        _this121.domEventType = ["paste", "copy", "cut", "drop", "dragover"], _this121.listenTo(e, "paste", n, {
          priority: "low"
        }), _this121.listenTo(e, "drop", n, {
          priority: "low"
        });
        return _this121;
      }

      _createClass(Id, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          var e = {
            dataTransfer: new Ed(t.clipboardData ? t.clipboardData : t.dataTransfer)
          };
          "drop" == t.type && (e.dropRange = function (t, e) {
            var n = e.target.ownerDocument,
                i = e.clientX,
                o = e.clientY;
            var r;
            n.caretRangeFromPoint && n.caretRangeFromPoint(i, o) ? r = n.caretRangeFromPoint(i, o) : e.rangeParent && (r = n.createRange(), r.setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
            return r ? t.domConverter.domRangeToView(r) : t.document.selection.getFirstRange();
          }(this.view, t)), this.fire(t.type, t, e);
        }
      }]);

      return Id;
    }(is);

    var Nd = ["figcaption", "li"];

    var Od =
    /*#__PURE__*/
    function (_Md) {
      _inherits(Od, _Md);

      function Od() {
        _classCallCheck(this, Od);

        return _possibleConstructorReturn(this, _getPrototypeOf(Od).apply(this, arguments));
      }

      _createClass(Od, [{
        key: "init",
        value: function init() {
          var _this122 = this;

          var t = this.editor,
              e = t.model.document,
              n = t.editing.view,
              i = n.document;

          function o(n, o) {
            var r = o.dataTransfer;
            o.preventDefault();
            var s = t.data.toView(t.model.getSelectedContent(e.selection));
            i.fire("clipboardOutput", {
              dataTransfer: r,
              content: s,
              method: n.name
            });
          }

          this._htmlDataProcessor = new ul(), n.addObserver(Id), this.listenTo(i, "clipboardInput", function (e) {
            t.isReadOnly && e.stop();
          }, {
            priority: "highest"
          }), this.listenTo(i, "clipboardInput", function (t, e) {
            var i = e.dataTransfer;
            var o = "";
            i.getData("text/html") ? o = function (t) {
              return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
                return 1 == e.length ? " " : e;
              });
            }(i.getData("text/html")) : i.getData("text/plain") && (o = function (t) {
              return (t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "</p><p>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).indexOf("</p><p>") > -1 && (t = "<p>".concat(t, "</p>")), t;
            }(i.getData("text/plain"))), o = _this122._htmlDataProcessor.toView(o), _this122.fire("inputTransformation", {
              content: o,
              dataTransfer: i
            }), n.scrollToTheSelection();
          }, {
            priority: "low"
          }), this.listenTo(this, "inputTransformation", function (t, e) {
            if (!e.content.isEmpty) {
              var _t208 = _this122.editor.data,
                  _n171 = _this122.editor.model,
                  _i129 = _t208.toModel(e.content, "$clipboardHolder");

              if (0 == _i129.childCount) return;

              _n171.insertContent(_i129);
            }
          }, {
            priority: "low"
          }), this.listenTo(i, "copy", o, {
            priority: "low"
          }), this.listenTo(i, "cut", function (e, n) {
            t.isReadOnly ? n.preventDefault() : o(e, n);
          }, {
            priority: "low"
          }), this.listenTo(i, "clipboardOutput", function (n, i) {
            i.content.isEmpty || (i.dataTransfer.setData("text/html", _this122._htmlDataProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", function t(e) {
              var n = "";
              if (e.is("text") || e.is("textProxy")) n = e.data;else if (e.is("img") && e.hasAttribute("alt")) n = e.getAttribute("alt");else {
                var _i130 = null;
                var _iteratorNormalCompletion260 = true;
                var _didIteratorError260 = false;
                var _iteratorError260 = undefined;

                try {
                  for (var _iterator260 = e.getChildren()[Symbol.iterator](), _step260; !(_iteratorNormalCompletion260 = (_step260 = _iterator260.next()).done); _iteratorNormalCompletion260 = true) {
                    var _o66 = _step260.value;

                    var _e197 = t(_o66);

                    _i130 && (_i130.is("containerElement") || _o66.is("containerElement")) && (Nd.includes(_i130.name) || Nd.includes(_o66.name) ? n += "\n" : n += "\n\n"), n += _e197, _i130 = _o66;
                  }
                } catch (err) {
                  _didIteratorError260 = true;
                  _iteratorError260 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion260 && _iterator260.return != null) {
                      _iterator260.return();
                    }
                  } finally {
                    if (_didIteratorError260) {
                      throw _iteratorError260;
                    }
                  }
                }
              }
              return n;
            }(i.content))), "cut" == i.method && t.model.deleteContent(e.selection);
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Clipboard";
        }
      }]);

      return Od;
    }(Md);

    var Rd =
    /*#__PURE__*/
    function () {
      function Rd(t) {
        var _this123 = this;

        _classCallCheck(this, Rd);

        this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
          _this123.refresh();
        }), this.on("execute", function (t) {
          _this123.isEnabled || t.stop();
        }, {
          priority: "high"
        }), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
          n ? _this123.forceDisabled("readOnlyMode") : _this123.clearForceDisabled("readOnlyMode");
        });
      }

      _createClass(Rd, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = !0;
        }
      }, {
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", Dd, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", Dd), this.refresh());
        }
      }, {
        key: "execute",
        value: function execute() {}
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return Rd;
    }();

    function Dd(t) {
      t.return = !1, t.stop();
    }

    function Ld(t, e) {
      var _iteratorNormalCompletion261, _didIteratorError261, _iteratorError261, _iterator261, _step261, _n172;

      return _regeneratorRuntime.wrap(function Ld$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _iteratorNormalCompletion261 = true;
              _didIteratorError261 = false;
              _iteratorError261 = undefined;
              _context36.prev = 3;
              _iterator261 = e[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion261 = (_step261 = _iterator261.next()).done) {
                _context36.next = 14;
                break;
              }

              _n172 = _step261.value;
              _context36.t0 = _n172 && t.getAttributeProperties(_n172[0]).copyOnEnter;

              if (!_context36.t0) {
                _context36.next = 11;
                break;
              }

              _context36.next = 11;
              return _n172;

            case 11:
              _iteratorNormalCompletion261 = true;
              _context36.next = 5;
              break;

            case 14:
              _context36.next = 20;
              break;

            case 16:
              _context36.prev = 16;
              _context36.t1 = _context36["catch"](3);
              _didIteratorError261 = true;
              _iteratorError261 = _context36.t1;

            case 20:
              _context36.prev = 20;
              _context36.prev = 21;

              if (!_iteratorNormalCompletion261 && _iterator261.return != null) {
                _iterator261.return();
              }

            case 23:
              _context36.prev = 23;

              if (!_didIteratorError261) {
                _context36.next = 26;
                break;
              }

              throw _iteratorError261;

            case 26:
              return _context36.finish(23);

            case 27:
              return _context36.finish(20);

            case 28:
            case "end":
              return _context36.stop();
          }
        }
      }, _marked3, null, [[3, 16, 20, 28], [21,, 23, 27]]);
    }

    li(Rd, Ui);

    var jd =
    /*#__PURE__*/
    function (_Rd) {
      _inherits(jd, _Rd);

      function jd() {
        _classCallCheck(this, jd);

        return _possibleConstructorReturn(this, _getPrototypeOf(jd).apply(this, arguments));
      }

      _createClass(jd, [{
        key: "execute",
        value: function execute() {
          var _this124 = this;

          var t = this.editor.model,
              e = t.document;
          t.change(function (n) {
            !function (t, e, n, i) {
              var o = n.isCollapsed,
                  r = n.getFirstRange(),
                  s = r.start.parent,
                  a = r.end.parent;
              if (i.isLimit(s) || i.isLimit(a)) return void (o || s != a || t.deleteContent(n));

              if (o) {
                var _t209 = Ld(e.model.schema, n.getAttributes());

                Vd(e, r.start), e.setSelectionAttribute(_t209);
              } else {
                var _i131 = !(r.start.isAtStart && r.end.isAtEnd),
                    _o67 = s == a;

                t.deleteContent(n, {
                  leaveUnmerged: _i131
                }), _i131 && (_o67 ? Vd(e, n.focus) : e.setSelection(a, 0));
              }
            }(_this124.editor.model, n, e.selection, t.schema), _this124.fire("afterExecute", {
              writer: n
            });
          });
        }
      }]);

      return jd;
    }(Rd);

    function Vd(t, e) {
      t.split(e), t.setSelection(e.parent.nextSibling, 0);
    }

    var zd =
    /*#__PURE__*/
    function (_mr5) {
      _inherits(zd, _mr5);

      function zd(t) {
        var _this125;

        _classCallCheck(this, zd);

        _this125 = _possibleConstructorReturn(this, _getPrototypeOf(zd).call(this, t));
        var e = _this125.document;
        e.on("keydown", function (t, n) {
          if (_this125.isEnabled && n.keyCode == wo.enter) {
            var _i132;

            e.once("enter", function (t) {
              return _i132 = t;
            }, {
              priority: "highest"
            }), e.fire("enter", new ns(e, n.domEvent, {
              isSoft: n.shiftKey
            })), _i132 && _i132.stop.called && t.stop();
          }
        });
        return _this125;
      }

      _createClass(zd, [{
        key: "observe",
        value: function observe() {}
      }]);

      return zd;
    }(mr);

    var Bd =
    /*#__PURE__*/
    function (_Md2) {
      _inherits(Bd, _Md2);

      function Bd() {
        _classCallCheck(this, Bd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Bd).apply(this, arguments));
      }

      _createClass(Bd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document;
          e.addObserver(zd), t.commands.add("enter", new jd(t)), this.listenTo(n, "enter", function (n, i) {
            i.preventDefault(), i.isSoft || (t.execute("enter"), e.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Enter";
        }
      }]);

      return Bd;
    }(Md);

    var Fd =
    /*#__PURE__*/
    function (_Rd2) {
      _inherits(Fd, _Rd2);

      function Fd() {
        _classCallCheck(this, Fd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Fd).apply(this, arguments));
      }

      _createClass(Fd, [{
        key: "execute",
        value: function execute() {
          var _this126 = this;

          var t = this.editor.model,
              e = t.document;
          t.change(function (n) {
            !function (t, e, n) {
              var i = n.isCollapsed,
                  o = n.getFirstRange(),
                  r = o.start.parent,
                  s = o.end.parent,
                  a = r == s;

              if (i) {
                var _i133 = Ld(t.schema, n.getAttributes());

                Ud(e, o.end), e.removeSelectionAttribute(n.getAttributeKeys()), e.setSelectionAttribute(_i133);
              } else {
                var _i134 = !(o.start.isAtStart && o.end.isAtEnd);

                t.deleteContent(n, {
                  leaveUnmerged: _i134
                }), a ? Ud(e, n.focus) : _i134 && e.setSelection(s, 0);
              }
            }(t, n, e.selection), _this126.fire("afterExecute", {
              writer: n
            });
          });
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;

          this.isEnabled = function (t, e) {
            if (e.rangeCount > 1) return !1;
            var n = e.anchor;
            if (!n || !t.checkChild(n, "softBreak")) return !1;
            var i = e.getFirstRange(),
                o = i.start.parent,
                r = i.end.parent;
            if ((Hd(o, t) || Hd(r, t)) && o !== r) return !1;
            return !0;
          }(t.schema, e.selection);
        }
      }]);

      return Fd;
    }(Rd);

    function Ud(t, e) {
      var n = t.createElement("softBreak");
      t.insert(n, e), t.setSelection(n, "after");
    }

    function Hd(t, e) {
      return !t.is("rootElement") && (e.isLimit(t) || Hd(t.parent, e));
    }

    var qd =
    /*#__PURE__*/
    function (_Md3) {
      _inherits(qd, _Md3);

      function qd() {
        _classCallCheck(this, qd);

        return _possibleConstructorReturn(this, _getPrototypeOf(qd).apply(this, arguments));
      }

      _createClass(qd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.conversion,
              i = t.editing.view,
              o = i.document;
          e.register("softBreak", {
            allowWhere: "$text",
            isInline: !0
          }), n.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
          }), n.for("downcast").elementToElement({
            model: "softBreak",
            view: function view(t, e) {
              return e.createEmptyElement("br");
            }
          }), i.addObserver(zd), t.commands.add("shiftEnter", new Fd(t)), this.listenTo(o, "enter", function (e, n) {
            n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), i.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ShiftEnter";
        }
      }]);

      return qd;
    }(Md);

    var Wd =
    /*#__PURE__*/
    function () {
      function Wd(t) {
        var _this127 = this;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        _classCallCheck(this, Wd);

        this.model = t, this.size = 0, this.limit = e, this.isLocked = !1, this._changeCallback = function (t, e) {
          "transparent" != e.type && e !== _this127._batch && _this127._reset(!0);
        }, this._selectionChangeCallback = function () {
          _this127._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }

      _createClass(Wd, [{
        key: "input",
        value: function input(t) {
          this.size += t, this.size >= this.limit && this._reset(!0);
        }
      }, {
        key: "lock",
        value: function lock() {
          this.isLocked = !0;
        }
      }, {
        key: "unlock",
        value: function unlock() {
          this.isLocked = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
      }, {
        key: "_reset",
        value: function _reset(t) {
          this.isLocked && !t || (this._batch = null, this.size = 0);
        }
      }, {
        key: "batch",
        get: function get() {
          return this._batch || (this._batch = this.model.createBatch()), this._batch;
        }
      }]);

      return Wd;
    }();

    var Yd =
    /*#__PURE__*/
    function (_Rd3) {
      _inherits(Yd, _Rd3);

      function Yd(t, e) {
        var _this128;

        _classCallCheck(this, Yd);

        _this128 = _possibleConstructorReturn(this, _getPrototypeOf(Yd).call(this, t)), _this128._buffer = new Wd(t.model, e), _this128._batches = new WeakSet();
        return _this128;
      }

      _createClass(Yd, [{
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Yd.prototype), "destroy", this).call(this), this._buffer.destroy();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this129 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document,
              i = t.text || "",
              o = i.length,
              r = t.range || n.selection.getFirstRange(),
              s = t.resultRange;
          e.enqueueChange(this._buffer.batch, function (t) {
            var a = r.isCollapsed;
            _this129._buffer.lock(), e.deleteContent(e.createSelection(r)), i && e.insertContent(t.createText(i, n.selection.getAttributes()), r.start), s ? t.setSelection(s) : a && t.setSelection(r.start.getShiftedBy(o)), _this129._buffer.unlock(), _this129._buffer.input(o), _this129._batches.add(_this129._buffer.batch);
          });
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);

      return Yd;
    }(Rd);

    function $d(t) {
      var e = null;
      var n = t.model,
          i = t.editing.view,
          o = t.commands.get("input");

      function r(t) {
        var r = n.document,
            a = i.document.isComposing,
            c = e && e.isEqual(r.selection);
        e = null, o.isEnabled && (function (t) {
          if (t.ctrlKey) return !0;
          return Gd.includes(t.keyCode);
        }(t) || r.selection.isCollapsed || a && 229 === t.keyCode || !a && 229 === t.keyCode && c || s());
      }

      function s() {
        var t = o.buffer;
        t.lock(), n.enqueueChange(t.batch, function () {
          n.deleteContent(n.document.selection);
        }), t.unlock();
      }

      mo.isAndroid ? i.document.on("beforeinput", function (t, e) {
        return r(e);
      }, {
        priority: "lowest"
      }) : i.document.on("keydown", function (t, e) {
        return r(e);
      }, {
        priority: "lowest"
      }), i.document.on("compositionstart", function () {
        var t = n.document,
            e = 1 !== t.selection.rangeCount || t.selection.getFirstRange().isFlat;
        if (t.selection.isCollapsed || e) return;
        s();
      }, {
        priority: "lowest"
      }), i.document.on("compositionend", function () {
        e = n.createSelection(n.document.selection);
      }, {
        priority: "lowest"
      });
    }

    var Gd = [ko("arrowUp"), ko("arrowRight"), ko("arrowDown"), ko("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];

    for (var _t210 = 112; _t210 <= 135; _t210++) {
      Gd.push(_t210);
    }

    function Qd(t) {
      if (t.newChildren.length - t.oldChildren.length != 1) return;

      var e = function (t, e) {
        var n = [];
        var i,
            o = 0;
        return t.forEach(function (t) {
          "equal" == t ? (r(), o++) : "insert" == t ? (s("insert") ? i.values.push(e[o]) : (r(), i = {
            type: "insert",
            index: o,
            values: [e[o]]
          }), o++) : s("delete") ? i.howMany++ : (r(), i = {
            type: "delete",
            index: o,
            howMany: 1
          });
        }), r(), n;

        function r() {
          i && (n.push(i), i = null);
        }

        function s(t) {
          return i && i.type == t;
        }
      }(Qo(t.oldChildren, t.newChildren, Kd), t.newChildren);

      if (e.length > 1) return;
      var n = e[0];
      return n.values[0] && n.values[0].is("text") ? n : void 0;
    }

    function Kd(t, e) {
      return t && t.is("text") && e && e.is("text") ? t.data === e.data : t === e;
    }

    var Jd =
    /*#__PURE__*/
    function () {
      function Jd(t) {
        _classCallCheck(this, Jd);

        this.editor = t, this.editing = this.editor.editing;
      }

      _createClass(Jd, [{
        key: "handle",
        value: function handle(t, e) {
          if (function (t) {
            if (0 == t.length) return !1;
            var _iteratorNormalCompletion262 = true;
            var _didIteratorError262 = false;
            var _iteratorError262 = undefined;

            try {
              for (var _iterator262 = t[Symbol.iterator](), _step262; !(_iteratorNormalCompletion262 = (_step262 = _iterator262.next()).done); _iteratorNormalCompletion262 = true) {
                var _e198 = _step262.value;
                if ("children" === _e198.type && !Qd(_e198)) return !0;
              }
            } catch (err) {
              _didIteratorError262 = true;
              _iteratorError262 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion262 && _iterator262.return != null) {
                  _iterator262.return();
                }
              } finally {
                if (_didIteratorError262) {
                  throw _iteratorError262;
                }
              }
            }

            return !1;
          }(t)) this._handleContainerChildrenMutations(t, e);else {
            var _iteratorNormalCompletion263 = true;
            var _didIteratorError263 = false;
            var _iteratorError263 = undefined;

            try {
              for (var _iterator263 = t[Symbol.iterator](), _step263; !(_iteratorNormalCompletion263 = (_step263 = _iterator263.next()).done); _iteratorNormalCompletion263 = true) {
                var _n173 = _step263.value;
                this._handleTextMutation(_n173, e), this._handleTextNodeInsertion(_n173);
              }
            } catch (err) {
              _didIteratorError263 = true;
              _iteratorError263 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion263 && _iterator263.return != null) {
                  _iterator263.return();
                }
              } finally {
                if (_didIteratorError263) {
                  throw _iteratorError263;
                }
              }
            }
          }
        }
      }, {
        key: "_handleContainerChildrenMutations",
        value: function _handleContainerChildrenMutations(t, e) {
          var n = function (t) {
            var e = t.map(function (t) {
              return t.node;
            }).reduce(function (t, e) {
              return t.getCommonAncestor(e, {
                includeSelf: !0
              });
            });
            if (!e) return;
            return e.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            }).find(function (t) {
              return t.is("containerElement") || t.is("rootElement");
            });
          }(t);

          if (!n) return;
          var i = this.editor.editing.view.domConverter.mapViewToDom(n),
              o = new ar(),
              r = this.editor.data.toModel(o.domToView(i)).getChild(0),
              s = this.editor.editing.mapper.toModelElement(n);
          if (!s) return;
          var a = Array.from(r.getChildren()),
              c = Array.from(s.getChildren()),
              l = a[a.length - 1],
              d = c[c.length - 1];
          l && l.is("softBreak") && d && !d.is("softBreak") && a.pop();
          var h = this.editor.model.schema;
          if (!Zd(a, h) || !Zd(c, h)) return;
          var u = a.map(function (t) {
            return t.is("text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " "),
              f = c.map(function (t) {
            return t.is("text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " ");
          if (f === u) return;

          var g = Qo(f, u),
              _Xd = Xd(g),
              m = _Xd.firstChangeAt,
              p = _Xd.insertions,
              b = _Xd.deletions;

          var w = null;
          e && (w = this.editing.mapper.toModelRange(e.getFirstRange()));

          var k = u.substr(m, p),
              _ = this.editor.model.createRange(this.editor.model.createPositionAt(s, m), this.editor.model.createPositionAt(s, m + b));

          this.editor.execute("input", {
            text: k,
            range: _,
            resultRange: w
          });
        }
      }, {
        key: "_handleTextMutation",
        value: function _handleTextMutation(t, e) {
          if ("text" != t.type) return;
          var n = t.newText.replace(/\u00A0/g, " "),
              i = t.oldText.replace(/\u00A0/g, " ");
          if (i === n) return;

          var o = Qo(i, n),
              _Xd2 = Xd(o),
              r = _Xd2.firstChangeAt,
              s = _Xd2.insertions,
              a = _Xd2.deletions;

          var c = null;
          e && (c = this.editing.mapper.toModelRange(e.getFirstRange()));
          var l = this.editing.view.createPositionAt(t.node, r),
              d = this.editing.mapper.toModelPosition(l),
              h = this.editor.model.createRange(d, d.getShiftedBy(a)),
              u = n.substr(r, s);
          this.editor.execute("input", {
            text: u,
            range: h,
            resultRange: c
          });
        }
      }, {
        key: "_handleTextNodeInsertion",
        value: function _handleTextNodeInsertion(t) {
          if ("children" != t.type) return;
          var e = Qd(t),
              n = this.editing.view.createPositionAt(t.node, e.index),
              i = this.editing.mapper.toModelPosition(n),
              o = e.values[0].data;
          this.editor.execute("input", {
            text: o.replace(/\u00A0/g, " "),
            range: this.editor.model.createRange(i)
          });
        }
      }]);

      return Jd;
    }();

    function Zd(t, e) {
      return t.every(function (t) {
        return e.isInline(t);
      });
    }

    function Xd(t) {
      var e = null,
          n = null;

      for (var _i135 = 0; _i135 < t.length; _i135++) {
        "equal" != t[_i135] && (e = null === e ? _i135 : e, n = _i135);
      }

      var i = 0,
          o = 0;

      for (var _r25 = e; _r25 <= n; _r25++) {
        "insert" != t[_r25] && i++, "delete" != t[_r25] && o++;
      }

      return {
        insertions: o,
        deletions: i,
        firstChangeAt: e
      };
    }

    var th =
    /*#__PURE__*/
    function (_Md4) {
      _inherits(th, _Md4);

      function th() {
        _classCallCheck(this, th);

        return _possibleConstructorReturn(this, _getPrototypeOf(th).apply(this, arguments));
      }

      _createClass(th, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = new Yd(t, t.config.get("typing.undoStep") || 20);
          t.commands.add("input", e), $d(t), function (t) {
            t.editing.view.document.on("mutations", function (e, n, i) {
              new Jd(t).handle(n, i);
            });
          }(t);
        }
      }, {
        key: "isInput",
        value: function isInput(t) {
          return this.editor.commands.get("input")._batches.has(t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Input";
        }
      }]);

      return th;
    }(Md);

    var eh =
    /*#__PURE__*/
    function (_Rd4) {
      _inherits(eh, _Rd4);

      function eh(t, e) {
        var _this130;

        _classCallCheck(this, eh);

        _this130 = _possibleConstructorReturn(this, _getPrototypeOf(eh).call(this, t)), _this130.direction = e, _this130._buffer = new Wd(t.model, t.config.get("typing.undoStep"));
        return _this130;
      }

      _createClass(eh, [{
        key: "execute",
        value: function execute() {
          var _this131 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document;
          e.enqueueChange(this._buffer.batch, function (i) {
            _this131._buffer.lock();

            var o = i.createSelection(t.selection || n.selection),
                r = o.isCollapsed;
            if (o.isCollapsed && e.modifySelection(o, {
              direction: _this131.direction,
              unit: t.unit
            }), _this131._shouldEntireContentBeReplacedWithParagraph(t.sequence || 1)) return void _this131._replaceEntireContentWithParagraph(i);
            if (o.isCollapsed) return;
            var s = 0;
            o.getFirstRange().getMinimalFlatRanges().forEach(function (t) {
              s += no(t.getWalker({
                singleCharacters: !0,
                ignoreElementEnd: !0,
                shallow: !0
              }));
            }), e.deleteContent(o, {
              doNotResetEntireContent: r
            }), _this131._buffer.input(s), i.setSelection(o), _this131._buffer.unlock();
          });
        }
      }, {
        key: "_shouldEntireContentBeReplacedWithParagraph",
        value: function _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1) return !1;
          var e = this.editor.model,
              n = e.document.selection,
              i = e.schema.getLimitElement(n);
          if (!(n.isCollapsed && n.containsEntireContent(i))) return !1;
          if (!e.schema.checkChild(i, "paragraph")) return !1;
          var o = i.getChild(0);
          return !o || "paragraph" !== o.name;
        }
      }, {
        key: "_replaceEntireContentWithParagraph",
        value: function _replaceEntireContentWithParagraph(t) {
          var e = this.editor.model,
              n = e.document.selection,
              i = e.schema.getLimitElement(n),
              o = t.createElement("paragraph");
          t.remove(t.createRangeIn(i)), t.insert(o, i), t.setSelection(o, 0);
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);

      return eh;
    }(Rd);

    var nh =
    /*#__PURE__*/
    function (_mr6) {
      _inherits(nh, _mr6);

      function nh(t) {
        var _this132;

        _classCallCheck(this, nh);

        _this132 = _possibleConstructorReturn(this, _getPrototypeOf(nh).call(this, t));
        var e = t.document;
        var n = 0;

        function i(t, n, i) {
          var o;
          e.once("delete", function (t) {
            return o = t;
          }, {
            priority: Number.POSITIVE_INFINITY
          }), e.fire("delete", new ns(e, n, i)), o && o.stop.called && t.stop();
        }

        e.on("keyup", function (t, e) {
          e.keyCode != wo.delete && e.keyCode != wo.backspace || (n = 0);
        }), e.on("keydown", function (t, e) {
          var o = {};
          if (e.keyCode == wo.delete) o.direction = "forward", o.unit = "character";else {
            if (e.keyCode != wo.backspace) return;
            o.direction = "backward", o.unit = "codePoint";
          }
          var r = mo.isMac ? e.altKey : e.ctrlKey;
          o.unit = r ? "word" : o.unit, o.sequence = ++n, i(t, e.domEvent, o);
        }), mo.isAndroid && e.on("beforeinput", function (e, n) {
          if ("deleteContentBackward" != n.domEvent.inputType) return;
          var o = {
            unit: "codepoint",
            direction: "backward",
            sequence: 1
          },
              r = n.domTarget.ownerDocument.defaultView.getSelection();
          r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (o.selectionToRemove = t.domConverter.domSelectionToView(r)), i(e, n.domEvent, o);
        });
        return _this132;
      }

      _createClass(nh, [{
        key: "observe",
        value: function observe() {}
      }]);

      return nh;
    }(mr);

    var ih =
    /*#__PURE__*/
    function (_Md5) {
      _inherits(ih, _Md5);

      function ih() {
        _classCallCheck(this, ih);

        return _possibleConstructorReturn(this, _getPrototypeOf(ih).apply(this, arguments));
      }

      _createClass(ih, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document;

          if (e.addObserver(nh), t.commands.add("forwardDelete", new eh(t, "forward")), t.commands.add("delete", new eh(t, "backward")), this.listenTo(n, "delete", function (n, i) {
            var o = {
              unit: i.unit,
              sequence: i.sequence
            };

            if (i.selectionToRemove) {
              var _e199 = t.model.createSelection(),
                  _n174 = [];

              var _iteratorNormalCompletion264 = true;
              var _didIteratorError264 = false;
              var _iteratorError264 = undefined;

              try {
                for (var _iterator264 = i.selectionToRemove.getRanges()[Symbol.iterator](), _step264; !(_iteratorNormalCompletion264 = (_step264 = _iterator264.next()).done); _iteratorNormalCompletion264 = true) {
                  var _e200 = _step264.value;

                  _n174.push(t.editing.mapper.toModelRange(_e200));
                }
              } catch (err) {
                _didIteratorError264 = true;
                _iteratorError264 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion264 && _iterator264.return != null) {
                    _iterator264.return();
                  }
                } finally {
                  if (_didIteratorError264) {
                    throw _iteratorError264;
                  }
                }
              }

              _e199.setTo(_n174), o.selection = _e199;
            }

            t.execute("forward" == i.direction ? "forwardDelete" : "delete", o), i.preventDefault(), e.scrollToTheSelection();
          }), mo.isAndroid) {
            var _t211 = null;
            this.listenTo(n, "delete", function (e, n) {
              var i = n.domTarget.ownerDocument.defaultView.getSelection();
              _t211 = {
                anchorNode: i.anchorNode,
                anchorOffset: i.anchorOffset,
                focusNode: i.focusNode,
                focusOffset: i.focusOffset
              };
            }, {
              priority: "lowest"
            }), this.listenTo(n, "keyup", function (e, n) {
              if (_t211) {
                var _e201 = n.domTarget.ownerDocument.defaultView.getSelection();

                _e201.collapse(_t211.anchorNode, _t211.anchorOffset), _e201.extend(_t211.focusNode, _t211.focusOffset), _t211 = null;
              }
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Delete";
        }
      }]);

      return ih;
    }(Md);

    var oh =
    /*#__PURE__*/
    function (_Md6) {
      _inherits(oh, _Md6);

      function oh() {
        _classCallCheck(this, oh);

        return _possibleConstructorReturn(this, _getPrototypeOf(oh).apply(this, arguments));
      }

      _createClass(oh, null, [{
        key: "requires",
        get: function get() {
          return [th, ih];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Typing";
        }
      }]);

      return oh;
    }(Md);

    var rh =
    /*#__PURE__*/
    function (_oc10) {
      _inherits(rh, _oc10);

      function rh() {
        _classCallCheck(this, rh);

        return _possibleConstructorReturn(this, _getPrototypeOf(rh).apply(this, arguments));
      }

      _createClass(rh, [{
        key: "clone",
        value: function clone() {
          return new rh(this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new rh(this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {}
      }, {
        key: "type",
        get: function get() {
          return "noop";
        }
      }], [{
        key: "className",
        get: function get() {
          return "NoOperation";
        }
      }]);

      return rh;
    }(oc);

    var sh = new Map();

    function ah(t, e, n) {
      var i = sh.get(t);
      i || (i = new Map(), sh.set(t, i)), i.set(e, n);
    }

    function ch(t) {
      return [t];
    }

    function lh(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var i = function (t, e) {
        var n = sh.get(t);
        return n && n.has(e) ? n.get(e) : ch;
      }(t.constructor, e.constructor);

      try {
        return i(t = t.clone(), e, n);
      } catch (t) {
        throw t;
      }
    }

    function dh(t, e, n) {
      t = t.slice(), e = e.slice();
      var i = new hh(n.document, n.useRelations, n.forceWeakRemove);
      i.setOriginalOperations(t), i.setOriginalOperations(e);
      var o = i.originalOperations;
      if (0 == t.length || 0 == e.length) return {
        operationsA: t,
        operationsB: e,
        originalOperations: o
      };
      var r = new WeakMap();
      var _iteratorNormalCompletion265 = true;
      var _didIteratorError265 = false;
      var _iteratorError265 = undefined;

      try {
        for (var _iterator265 = t[Symbol.iterator](), _step265; !(_iteratorNormalCompletion265 = (_step265 = _iterator265.next()).done); _iteratorNormalCompletion265 = true) {
          var _e203 = _step265.value;
          r.set(_e203, 0);
        }
      } catch (err) {
        _didIteratorError265 = true;
        _iteratorError265 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion265 && _iterator265.return != null) {
            _iterator265.return();
          }
        } finally {
          if (_didIteratorError265) {
            throw _iteratorError265;
          }
        }
      }

      var s = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      };
      var a = 0;

      for (; a < t.length;) {
        var _t212, _e202;

        var _n175 = t[a],
            _o68 = r.get(_n175);

        if (_o68 == e.length) {
          a++;
          continue;
        }

        var _s19 = e[_o68],
            _c5 = lh(_n175, _s19, i.getContext(_n175, _s19, !0)),
            _l2 = lh(_s19, _n175, i.getContext(_s19, _n175, !1));

        i.updateRelation(_n175, _s19), i.setOriginalOperations(_c5, _n175), i.setOriginalOperations(_l2, _s19);
        var _iteratorNormalCompletion266 = true;
        var _didIteratorError266 = false;
        var _iteratorError266 = undefined;

        try {
          for (var _iterator266 = _c5[Symbol.iterator](), _step266; !(_iteratorNormalCompletion266 = (_step266 = _iterator266.next()).done); _iteratorNormalCompletion266 = true) {
            var _t213 = _step266.value;
            r.set(_t213, _o68 + _l2.length);
          }
        } catch (err) {
          _didIteratorError266 = true;
          _iteratorError266 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion266 && _iterator266.return != null) {
              _iterator266.return();
            }
          } finally {
            if (_didIteratorError266) {
              throw _iteratorError266;
            }
          }
        }

        (_t212 = t).splice.apply(_t212, [a, 1].concat(_toConsumableArray(_c5))), (_e202 = e).splice.apply(_e202, [_o68, 1].concat(_toConsumableArray(_l2)));
      }

      if (n.padWithNoOps) {
        var _n176 = t.length - s.originalOperationsACount,
            _i136 = e.length - s.originalOperationsBCount;

        fh(t, _i136 - _n176), fh(e, _n176 - _i136);
      }

      return uh(t, s.nextBaseVersionB), uh(e, s.nextBaseVersionA), {
        operationsA: t,
        operationsB: e,
        originalOperations: o
      };
    }

    var hh =
    /*#__PURE__*/
    function () {
      function hh(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

        _classCallCheck(this, hh);

        this.originalOperations = new Map(), this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._relations = new Map();
      }

      _createClass(hh, [{
        key: "setOriginalOperations",
        value: function setOriginalOperations(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = e ? this.originalOperations.get(e) : null;
          var _iteratorNormalCompletion267 = true;
          var _didIteratorError267 = false;
          var _iteratorError267 = undefined;

          try {
            for (var _iterator267 = t[Symbol.iterator](), _step267; !(_iteratorNormalCompletion267 = (_step267 = _iterator267.next()).done); _iteratorNormalCompletion267 = true) {
              var _e204 = _step267.value;
              this.originalOperations.set(_e204, n || _e204);
            }
          } catch (err) {
            _didIteratorError267 = true;
            _iteratorError267 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion267 && _iterator267.return != null) {
                _iterator267.return();
              }
            } finally {
              if (_didIteratorError267) {
                throw _iteratorError267;
              }
            }
          }
        }
      }, {
        key: "updateRelation",
        value: function updateRelation(t, e) {
          switch (t.constructor) {
            case pc:
              switch (e.constructor) {
                case vc:
                  t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter");
                  break;

                case pc:
                  t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter");
              }

              break;

            case yc:
              switch (e.constructor) {
                case vc:
                  t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");
                  break;

                case pc:
                  (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) && this._setRelation(t, e, "splitBefore");
              }

              break;

            case vc:
              switch (e.constructor) {
                case vc:
                  t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement");
                  break;

                case yc:
                  t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource");
              }

              break;

            case wc:
              {
                var _n177 = t.newRange;
                if (!_n177) return;

                switch (e.constructor) {
                  case pc:
                    {
                      var _i137 = Js._createFromPositionAndShift(e.sourcePosition, e.howMany),
                          _o69 = _i137.containsPosition(_n177.start) || _i137.start.isEqual(_n177.start),
                          _r26 = _i137.containsPosition(_n177.end) || _i137.end.isEqual(_n177.end);

                      !_o69 && !_r26 || _i137.containsRange(_n177) || this._setRelation(t, e, {
                        side: _o69 ? "left" : "right",
                        path: _o69 ? _n177.start.path.slice() : _n177.end.path.slice()
                      });
                      break;
                    }

                  case vc:
                    {
                      var _i138 = _n177.start.isEqual(e.targetPosition),
                          _o70 = _n177.start.isEqual(e.deletionPosition),
                          _r27 = _n177.end.isEqual(e.deletionPosition),
                          _s20 = _n177.end.isEqual(e.sourcePosition);

                      (_i138 || _o70 || _r27 || _s20) && this._setRelation(t, e, {
                        wasInLeftElement: _i138,
                        wasStartBeforeMergedElement: _o70,
                        wasEndBeforeMergedElement: _r27,
                        wasInRightElement: _s20
                      });
                      break;
                    }
                }

                break;
              }
          }
        }
      }, {
        key: "getContext",
        value: function getContext(t, e, n) {
          return {
            aIsStrong: n,
            aWasUndone: this._wasUndone(t),
            bWasUndone: this._wasUndone(e),
            abRelation: this._useRelations ? this._getRelation(t, e) : null,
            baRelation: this._useRelations ? this._getRelation(e, t) : null,
            forceWeakRemove: this._forceWeakRemove
          };
        }
      }, {
        key: "_wasUndone",
        value: function _wasUndone(t) {
          var e = this.originalOperations.get(t);
          return e.wasUndone || this._history.isUndoneOperation(e);
        }
      }, {
        key: "_getRelation",
        value: function _getRelation(t, e) {
          var n = this.originalOperations.get(e),
              i = this._history.getUndoneOperation(n);

          if (!i) return null;

          var o = this.originalOperations.get(t),
              r = this._relations.get(o);

          return r && r.get(i) || null;
        }
      }, {
        key: "_setRelation",
        value: function _setRelation(t, e, n) {
          var i = this.originalOperations.get(t),
              o = this.originalOperations.get(e);

          var r = this._relations.get(i);

          r || (r = new Map(), this._relations.set(i, r)), r.set(o, n);
        }
      }]);

      return hh;
    }();

    function uh(t, e) {
      var _iteratorNormalCompletion268 = true;
      var _didIteratorError268 = false;
      var _iteratorError268 = undefined;

      try {
        for (var _iterator268 = t[Symbol.iterator](), _step268; !(_iteratorNormalCompletion268 = (_step268 = _iterator268.next()).done); _iteratorNormalCompletion268 = true) {
          var _n178 = _step268.value;
          _n178.baseVersion = e++;
        }
      } catch (err) {
        _didIteratorError268 = true;
        _iteratorError268 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion268 && _iterator268.return != null) {
            _iterator268.return();
          }
        } finally {
          if (_didIteratorError268) {
            throw _iteratorError268;
          }
        }
      }
    }

    function fh(t, e) {
      for (var _n179 = 0; _n179 < e; _n179++) {
        t.push(new rh(0));
      }
    }

    function gh(t, e, n) {
      var i = t.nodes.getNode(0).getAttribute(e);
      if (i == n) return null;
      var o = new Js(t.position, t.position.getShiftedBy(t.howMany));
      return new gc(o, e, i, n, 0);
    }

    function mh(t, e) {
      return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
    }

    function ph(t, e) {
      var n = [];

      for (var _i139 = 0; _i139 < t.length; _i139++) {
        var _o71 = t[_i139],
            _r28 = new pc(_o71.start, _o71.end.offset - _o71.start.offset, e, 0);

        n.push(_r28);

        for (var _e205 = _i139 + 1; _e205 < t.length; _e205++) {
          t[_e205] = t[_e205]._getTransformedByMove(_r28.sourcePosition, _r28.targetPosition, _r28.howMany)[0];
        }

        e = e._getTransformedByMove(_r28.sourcePosition, _r28.targetPosition, _r28.howMany);
      }

      return n;
    }

    ah(gc, gc, function (t, e, n) {
      if (t.key === e.key) {
        var _i140 = t.range.getDifference(e.range).map(function (e) {
          return new gc(e, t.key, t.oldValue, t.newValue, 0);
        }),
            _o72 = t.range.getIntersection(e.range);

        return _o72 && n.aIsStrong && _i140.push(new gc(_o72, e.key, e.newValue, t.newValue, 0)), 0 == _i140.length ? [new rh(0)] : _i140;
      }

      return [t];
    }), ah(gc, bc, function (t, e) {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        var _n180 = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(function (e) {
          return new gc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });

        if (e.shouldReceiveAttributes) {
          var _i141 = gh(e, t.key, t.oldValue);

          _i141 && _n180.unshift(_i141);
        }

        return _n180;
      }

      return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
    }), ah(gc, vc, function (t, e) {
      var n = [];
      t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(Js._createFromPositionAndShift(e.graveyardPosition, 1));

      var i = t.range._getTransformedByMergeOperation(e);

      return i.isCollapsed || n.push(i), n.map(function (e) {
        return new gc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), ah(gc, pc, function (t, e) {
      return function (t, e) {
        var n = Js._createFromPositionAndShift(e.sourcePosition, e.howMany);

        var i = null,
            o = [];
        n.containsRange(t, !0) ? i = t : t.start.hasSameParentAs(n.start) ? (o = t.getDifference(n), i = t.getIntersection(n)) : o = [t];
        var r = [];
        var _iteratorNormalCompletion269 = true;
        var _didIteratorError269 = false;
        var _iteratorError269 = undefined;

        try {
          for (var _iterator269 = o[Symbol.iterator](), _step269; !(_iteratorNormalCompletion269 = (_step269 = _iterator269.next()).done); _iteratorNormalCompletion269 = true) {
            var _t214 = _step269.value;
            _t214 = _t214._getTransformedByDeletion(e.sourcePosition, e.howMany);

            var _n181 = e.getMovedRangeStart(),
                _i142 = _t214.start.hasSameParentAs(_n181);

            _t214 = _t214._getTransformedByInsertion(_n181, e.howMany, _i142), r.push.apply(r, _toConsumableArray(_t214));
          }
        } catch (err) {
          _didIteratorError269 = true;
          _iteratorError269 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion269 && _iterator269.return != null) {
              _iterator269.return();
            }
          } finally {
            if (_didIteratorError269) {
              throw _iteratorError269;
            }
          }
        }

        i && r.push(i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
        return r;
      }(t.range, e).map(function (e) {
        return new gc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), ah(gc, yc, function (t, e) {
      if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];

      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        var _n182 = t.clone();

        return _n182.range = new Js(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, _n182];
      }

      return t.range = t.range._getTransformedBySplitOperation(e), [t];
    }), ah(bc, gc, function (t, e) {
      var n = [t];

      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        var _i143 = gh(t, e.key, e.newValue);

        _i143 && n.push(_i143);
      }

      return n;
    }), ah(bc, bc, function (t, e, n) {
      return t.position.isEqual(e.position) && n.aIsStrong ? [t] : (t.position = t.position._getTransformedByInsertOperation(e), [t]);
    }), ah(bc, pc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), ah(bc, yc, function (t, e) {
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), ah(bc, vc, function (t, e) {
      return t.position = t.position._getTransformedByMergeOperation(e), [t];
    }), ah(wc, bc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t];
    }), ah(wc, wc, function (t, e, n) {
      if (t.name == e.name) {
        if (!n.aIsStrong) return [new rh(0)];
        t.oldRange = e.newRange ? e.newRange.clone() : null;
      }

      return [t];
    }), ah(wc, vc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t];
    }), ah(wc, pc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = Js._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
        if (n.abRelation) {
          var _i144 = Js._createFromRanges(t.newRange._getTransformedByMoveOperation(e));

          if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.start.path = n.abRelation.path, t.newRange.end = _i144.end, [t];
          if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = _i144.start, t.newRange.end.path = n.abRelation.path, [t];
        }

        t.newRange = Js._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }

      return [t];
    }), ah(wc, yc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
        if (n.abRelation) {
          var _i145 = t.newRange._getTransformedBySplitOperation(e);

          return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = Ks._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = Ks._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = Ks._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = Ks._createAt(e.insertionPosition) : t.newRange.end = _i145.end, [t];
        }

        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }

      return [t];
    }), ah(vc, bc, function (t, e) {
      return t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t];
    }), ah(vc, vc, function (t, e, n) {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (n.bWasUndone) {
          var _n183 = e.graveyardPosition.path.slice();

          return _n183.push(0), t.sourcePosition = new Ks(e.graveyardPosition.root, _n183), t.howMany = 0, [t];
        }

        return [new rh(0)];
      }

      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        var _i146 = "$graveyard" == t.targetPosition.root.rootName,
            _o73 = "$graveyard" == e.targetPosition.root.rootName,
            _r29 = _i146 && !_o73;

        if (_o73 && !_i146 || !_r29 && n.aIsStrong) {
          var _n184 = e.targetPosition._getTransformedByMergeOperation(e),
              _i147 = t.targetPosition._getTransformedByMergeOperation(e);

          return [new pc(_n184, t.howMany, _i147, 0)];
        }

        return [new rh(0)];
      }

      return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), ah(vc, pc, function (t, e, n) {
      var i = Js._createFromPositionAndShift(e.sourcePosition, e.howMany);

      return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.sourcePosition) ? [new rh(0)] : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
    }), ah(vc, yc, function (t, e, n) {
      if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
        var _i148 = 0 != e.howMany,
            _o74 = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);

        if (_i148 || _o74 || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
      }

      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }

      return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
    }), ah(pc, bc, function (t, e) {
      var n = Js._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];

      return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
    }), ah(pc, pc, function (t, e, n) {
      var i = Js._createFromPositionAndShift(t.sourcePosition, t.howMany),
          o = Js._createFromPositionAndShift(e.sourcePosition, e.howMany);

      var r,
          s = n.aIsStrong,
          a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), mh(t, e) && mh(e, t)) return [e.getReversed()];
      if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0)) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), ph([i], r);
      if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0)) return i.start = i.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), i.end = i.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), ph([i], r);
      var c = di(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if ("prefix" == c || "extension" == c) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), ph([i], r);
      "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      var l = [],
          d = i.getDifference(o);
      var _iteratorNormalCompletion270 = true;
      var _didIteratorError270 = false;
      var _iteratorError270 = undefined;

      try {
        for (var _iterator270 = d[Symbol.iterator](), _step270; !(_iteratorNormalCompletion270 = (_step270 = _iterator270.next()).done); _iteratorNormalCompletion270 = true) {
          var _t215 = _step270.value;
          _t215.start = _t215.start._getTransformedByDeletion(e.sourcePosition, e.howMany), _t215.end = _t215.end._getTransformedByDeletion(e.sourcePosition, e.howMany);

          var _n185 = "same" == di(_t215.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
              _i149 = _t215._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, _n185);

          l.push.apply(l, _toConsumableArray(_i149));
        }
      } catch (err) {
        _didIteratorError270 = true;
        _iteratorError270 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion270 && _iterator270.return != null) {
            _iterator270.return();
          }
        } finally {
          if (_didIteratorError270) {
            throw _iteratorError270;
          }
        }
      }

      var h = i.getIntersection(o);
      return null !== h && s && (h.start = h.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), h.end = h.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === l.length ? l.push(h) : 1 == l.length ? o.start.isBefore(i.start) || o.start.isEqual(i.start) ? l.unshift(h) : l.push(h) : l.splice(1, 0, h)), 0 === l.length ? [new rh(t.baseVersion)] : ph(l, r);
    }), ah(pc, yc, function (t, e, n) {
      var i = t.targetPosition.clone();
      t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (i = t.targetPosition._getTransformedBySplitOperation(e));

      var o = Js._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (o.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = i, [t];

      if (o.start.hasSameParentAs(e.splitPosition) && o.containsPosition(e.splitPosition)) {
        var _t216 = new Js(e.splitPosition, o.end);

        return _t216 = _t216._getTransformedBySplitOperation(e), ph([new Js(o.start, e.splitPosition), _t216], i);
      }

      t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (i = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (i = t.targetPosition);
      var r = [o._getTransformedBySplitOperation(e)];

      if (e.graveyardPosition) {
        var _i150 = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);

        t.howMany > 1 && _i150 && !n.aWasUndone && r.push(Js._createFromPositionAndShift(e.insertionPosition, 1));
      }

      return ph(r, i);
    }), ah(pc, vc, function (t, e, n) {
      var i = Js._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
        if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new rh(0)];
      } else if (!n.aWasUndone) {
        var _n186 = [];

        var _i151 = e.graveyardPosition.clone(),
            _o75 = e.targetPosition._getTransformedByMergeOperation(e);

        t.howMany > 1 && (_n186.push(new pc(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), _i151 = _i151._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), _o75 = _o75._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));

        var _r30 = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
            _s21 = new pc(_i151, 1, _r30, 0),
            _a11 = _s21.getMovedRangeStart().path.slice();

        _a11.push(0);

        var _c6 = new Ks(_s21.targetPosition.root, _a11);

        _o75 = _o75._getTransformedByMove(_i151, _r30, 1);

        var _l3 = new pc(_o75, e.howMany, _c6, 0);

        return _n186.push(_s21), _n186.push(_l3), _n186;
      }

      var o = Js._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);

      return t.sourcePosition = o.start, t.howMany = o.end.offset - o.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
    }), ah(kc, bc, function (t, e) {
      return t.position = t.position._getTransformedByInsertOperation(e), [t];
    }), ah(kc, vc, function (t, e) {
      return t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t]);
    }), ah(kc, pc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), ah(kc, kc, function (t, e, n) {
      if (t.position.isEqual(e.position)) {
        if (!n.aIsStrong) return [new rh(0)];
        t.oldName = e.newName;
      }

      return [t];
    }), ah(kc, yc, function (t, e) {
      if ("same" == di(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
        var _e206 = new kc(t.position.getShiftedBy(1), t.oldName, t.newName, 0);

        return [t, _e206];
      }

      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), ah(_c, _c, function (t, e, n) {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) return [new rh(0)];
        t.oldValue = e.newValue;
      }

      return [t];
    }), ah(yc, bc, function (t, e) {
      return t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = yc.getInsertionPosition(t.splitPosition), [t];
    }), ah(yc, vc, function (t, e, n) {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        var _n187 = e.graveyardPosition.path.slice();

        _n187.push(0);

        var _i152 = new Ks(e.graveyardPosition.root, _n187),
            _o76 = yc.getInsertionPosition(new Ks(e.graveyardPosition.root, _n187)),
            _r31 = new yc(_i152, 0, null, 0);

        return _r31.insertionPosition = _o76, t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = yc.getInsertionPosition(t.splitPosition), t.graveyardPosition = _r31.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [_r31, t];
      }

      return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = yc.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), ah(yc, pc, function (t, e, n) {
      var i = Js._createFromPositionAndShift(e.sourcePosition, e.howMany);

      if (t.graveyardPosition) {
        var _o77 = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);

        if (!n.bWasUndone && _o77) {
          var _n188 = t.splitPosition._getTransformedByMoveOperation(e),
              _i153 = t.graveyardPosition._getTransformedByMoveOperation(e),
              _o78 = _i153.path.slice();

          _o78.push(0);

          var _r32 = new Ks(_i153.root, _o78);

          return [new pc(_n188, t.howMany, _r32, 0)];
        }

        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }

      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.splitPosition)) {
        var _n189 = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);

        return t.howMany -= _n189, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = yc.getInsertionPosition(t.splitPosition), [t];
      }

      return !t.splitPosition.isEqual(e.targetPosition) || "insertAtSource" != n.baRelation && "splitBefore" != n.abRelation ? (e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = yc.getInsertionPosition(t.splitPosition), [t]) : (t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = yc.getInsertionPosition(t.splitPosition), [t]);
    }), ah(yc, yc, function (t, e, n) {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) return [new rh(0)];
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new rh(0)];
        if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
      }

      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        var _i154 = "$graveyard" == t.splitPosition.root.rootName,
            _o79 = "$graveyard" == e.splitPosition.root.rootName,
            _r33 = _i154 && !_o79;

        if (_o79 && !_i154 || !_r33 && n.aIsStrong) {
          var _n190 = [];
          return e.howMany && _n190.push(new pc(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && _n190.push(new pc(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), _n190;
        }

        return [new rh(0)];
      }

      if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];

      if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
        var _n191 = e.insertionPosition.path.slice();

        _n191.push(0);

        var _i155 = new Ks(e.insertionPosition.root, _n191);

        return [t, new pc(t.insertionPosition, 1, _i155, 0)];
      }

      return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = yc.getInsertionPosition(t.splitPosition), [t];
    });

    var bh =
    /*#__PURE__*/
    function (_Rd5) {
      _inherits(bh, _Rd5);

      function bh(t) {
        var _this133;

        _classCallCheck(this, bh);

        _this133 = _possibleConstructorReturn(this, _getPrototypeOf(bh).call(this, t)), _this133._stack = [], _this133._createdBatches = new WeakSet(), _this133.refresh();
        return _this133;
      }

      _createClass(bh, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._stack.length > 0;
        }
      }, {
        key: "addBatch",
        value: function addBatch(t) {
          var e = this.editor.model.document.selection,
              n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          };
          this._stack.push({
            batch: t,
            selection: n
          }), this.refresh();
        }
      }, {
        key: "clearStack",
        value: function clearStack() {
          this._stack = [], this.refresh();
        }
      }, {
        key: "_restoreSelection",
        value: function _restoreSelection(t, e, n) {
          var i = this.editor.model,
              o = i.document,
              r = [];
          var _iteratorNormalCompletion271 = true;
          var _didIteratorError271 = false;
          var _iteratorError271 = undefined;

          try {
            for (var _iterator271 = t[Symbol.iterator](), _step271; !(_iteratorNormalCompletion271 = (_step271 = _iterator271.next()).done); _iteratorNormalCompletion271 = true) {
              var _e207 = _step271.value;

              var _t217 = wh(_e207, n).find(function (t) {
                return t.start.root != o.graveyard;
              });

              _t217 && r.push(_t217);
            }
          } catch (err) {
            _didIteratorError271 = true;
            _iteratorError271 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion271 && _iterator271.return != null) {
                _iterator271.return();
              }
            } finally {
              if (_didIteratorError271) {
                throw _iteratorError271;
              }
            }
          }

          r.length && i.change(function (t) {
            t.setSelection(r, {
              backward: e
            });
          });
        }
      }, {
        key: "_undo",
        value: function _undo(t, e) {
          var n = this.editor.model,
              i = n.document;

          this._createdBatches.add(e);

          var o = t.operations.slice().filter(function (t) {
            return t.isDocumentOperation;
          });
          o.reverse();
          var _iteratorNormalCompletion272 = true;
          var _didIteratorError272 = false;
          var _iteratorError272 = undefined;

          try {
            for (var _iterator272 = o[Symbol.iterator](), _step272; !(_iteratorNormalCompletion272 = (_step272 = _iterator272.next()).done); _iteratorNormalCompletion272 = true) {
              var _t218 = _step272.value;

              var _o80 = _t218.baseVersion + 1,
                  _r34 = Array.from(i.history.getOperations(_o80)),
                  _s22 = dh([_t218.getReversed()], _r34, {
                useRelations: !0,
                document: this.editor.model.document,
                padWithNoOps: !1,
                forceWeakRemove: !0
              }).operationsA;

              var _iteratorNormalCompletion273 = true;
              var _didIteratorError273 = false;
              var _iteratorError273 = undefined;

              try {
                for (var _iterator273 = _s22[Symbol.iterator](), _step273; !(_iteratorNormalCompletion273 = (_step273 = _iterator273.next()).done); _iteratorNormalCompletion273 = true) {
                  var _o81 = _step273.value;
                  e.addOperation(_o81), n.applyOperation(_o81), i.history.setOperationAsUndone(_t218, _o81);
                }
              } catch (err) {
                _didIteratorError273 = true;
                _iteratorError273 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion273 && _iterator273.return != null) {
                    _iterator273.return();
                  }
                } finally {
                  if (_didIteratorError273) {
                    throw _iteratorError273;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError272 = true;
            _iteratorError272 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion272 && _iterator272.return != null) {
                _iterator272.return();
              }
            } finally {
              if (_didIteratorError272) {
                throw _iteratorError272;
              }
            }
          }
        }
      }]);

      return bh;
    }(Rd);

    function wh(t, e) {
      var n = t.getTransformedByOperations(e);
      n.sort(function (t, e) {
        return t.start.isBefore(e.start) ? -1 : 1;
      });

      for (var _t219 = 1; _t219 < n.length; _t219++) {
        var _e208 = n[_t219 - 1],
            _i156 = n[_t219];
        _e208.end.isTouching(_i156.start) && (_e208.end = _i156.end, n.splice(_t219, 1), _t219--);
      }

      return n;
    }

    var kh =
    /*#__PURE__*/
    function (_bh) {
      _inherits(kh, _bh);

      function kh() {
        _classCallCheck(this, kh);

        return _possibleConstructorReturn(this, _getPrototypeOf(kh).apply(this, arguments));
      }

      _createClass(kh, [{
        key: "execute",
        value: function execute() {
          var _this134 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          var e = t ? this._stack.findIndex(function (e) {
            return e.batch == t;
          }) : this._stack.length - 1,
              n = this._stack.splice(e, 1)[0],
              i = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(i, function () {
            _this134._undo(n.batch, i);

            var t = _this134.editor.model.document.history.getOperations(n.batch.baseVersion);

            _this134._restoreSelection(n.selection.ranges, n.selection.isBackward, t), _this134.fire("revert", n.batch, i);
          }), this.refresh();
        }
      }]);

      return kh;
    }(bh);

    var _h =
    /*#__PURE__*/
    function (_bh2) {
      _inherits(_h, _bh2);

      function _h() {
        _classCallCheck(this, _h);

        return _possibleConstructorReturn(this, _getPrototypeOf(_h).apply(this, arguments));
      }

      _createClass(_h, [{
        key: "execute",
        value: function execute() {
          var _this135 = this;

          var t = this._stack.pop(),
              e = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(e, function () {
            var n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
                i = _this135.editor.model.document.history.getOperations(n);

            _this135._restoreSelection(t.selection.ranges, t.selection.isBackward, i), _this135._undo(t.batch, e);
          }), this.refresh();
        }
      }]);

      return _h;
    }(bh);

    var vh =
    /*#__PURE__*/
    function (_Md7) {
      _inherits(vh, _Md7);

      _createClass(vh, null, [{
        key: "pluginName",
        get: function get() {
          return "UndoEditing";
        }
      }]);

      function vh(t) {
        var _this136;

        _classCallCheck(this, vh);

        _this136 = _possibleConstructorReturn(this, _getPrototypeOf(vh).call(this, t)), _this136._batchRegistry = new WeakSet();
        return _this136;
      }

      _createClass(vh, [{
        key: "init",
        value: function init() {
          var _this137 = this;

          var t = this.editor;
          this._undoCommand = new kh(t), this._redoCommand = new _h(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", function (t, e) {
            var n = e[0];
            if (!n.isDocumentOperation) return;

            var i = n.batch,
                o = _this137._redoCommand._createdBatches.has(i),
                r = _this137._undoCommand._createdBatches.has(i);

            _this137._batchRegistry.has(i) || "transparent" == i.type && !o && !r || (o ? _this137._undoCommand.addBatch(i) : r || (_this137._undoCommand.addBatch(i), _this137._redoCommand.clearStack()), _this137._batchRegistry.add(i));
          }, {
            priority: "highest"
          }), this.listenTo(this._undoCommand, "revert", function (t, e, n) {
            _this137._redoCommand.addBatch(n);
          }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }]);

      return vh;
    }(Md);

    var yh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
        xh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';

    var Ah =
    /*#__PURE__*/
    function (_Md8) {
      _inherits(Ah, _Md8);

      function Ah() {
        _classCallCheck(this, Ah);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ah).apply(this, arguments));
      }

      _createClass(Ah, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.locale,
              n = t.t,
              i = "ltr" == e.uiLanguageDirection ? yh : xh,
              o = "ltr" == e.uiLanguageDirection ? xh : yh;
          this._addButton("undo", n("bs"), "CTRL+Z", i), this._addButton("redo", n("bt"), "CTRL+Y", o);
        }
      }, {
        key: "_addButton",
        value: function _addButton(t, e, n, i) {
          var _this138 = this;

          var o = this.editor;
          o.ui.componentFactory.add(t, function (r) {
            var s = o.commands.get(t),
                a = new ud(r);
            return a.set({
              label: e,
              icon: i,
              keystroke: n,
              tooltip: !0
            }), a.bind("isEnabled").to(s, "isEnabled"), _this138.listenTo(a, "execute", function () {
              return o.execute(t);
            }), a;
          });
        }
      }]);

      return Ah;
    }(Md);

    var Th =
    /*#__PURE__*/
    function (_Md9) {
      _inherits(Th, _Md9);

      function Th() {
        _classCallCheck(this, Th);

        return _possibleConstructorReturn(this, _getPrototypeOf(Th).apply(this, arguments));
      }

      _createClass(Th, null, [{
        key: "requires",
        get: function get() {
          return [vh, Ah];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Undo";
        }
      }]);

      return Th;
    }(Md);

    var Ch =
    /*#__PURE__*/
    function (_Md10) {
      _inherits(Ch, _Md10);

      function Ch() {
        _classCallCheck(this, Ch);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ch).apply(this, arguments));
      }

      _createClass(Ch, [{
        key: "init",
        value: function init() {
          this.set("hasAny", !1), this._actions = new ro({
            idProperty: "_id"
          }), this._actions.delegate("add", "remove").to(this);
        }
      }, {
        key: "add",
        value: function add(t) {
          if ("string" != typeof t) throw new Qn.b("pendingactions-add-invalid-message: The message must be a string.", this);
          var e = Object.create(Ui);
          return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._actions.remove(t), this.hasAny = !!this._actions.length;
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._actions[Symbol.iterator]();
        }
      }, {
        key: "first",
        get: function get() {
          return this._actions.get(0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PendingActions";
        }
      }]);

      return Ch;
    }(Md);

    var Ph =
    /*#__PURE__*/
    function () {
      function Ph() {
        var _this139 = this;

        _classCallCheck(this, Ph);

        var t = new window.FileReader();
        this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = function (t) {
          _this139.loaded = t.loaded;
        };
      }

      _createClass(Ph, [{
        key: "read",
        value: function read(t) {
          var _this140 = this;

          var e = this._reader;
          return this.total = t.size, new Promise(function (n, i) {
            e.onload = function () {
              var t = e.result;
              _this140._data = t, n(t);
            }, e.onerror = function () {
              i("error");
            }, e.onabort = function () {
              i("aborted");
            }, _this140._reader.readAsDataURL(t);
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this._reader.abort();
        }
      }, {
        key: "error",
        get: function get() {
          return this._reader.error;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }]);

      return Ph;
    }();

    li(Ph, Ui);

    var Sh =
    /*#__PURE__*/
    function (_Md11) {
      _inherits(Sh, _Md11);

      function Sh() {
        _classCallCheck(this, Sh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Sh).apply(this, arguments));
      }

      _createClass(Sh, [{
        key: "init",
        value: function init() {
          var _this141 = this;

          this.loaders = new ro(), this.loaders.on("add", function () {
            return _this141._updatePendingAction();
          }), this.loaders.on("remove", function () {
            return _this141._updatePendingAction();
          }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
            return e ? t / e * 100 : 0;
          });
        }
      }, {
        key: "getLoader",
        value: function getLoader(t) {
          return this._loadersMap.get(t) || null;
        }
      }, {
        key: "createLoader",
        value: function createLoader(t) {
          var _this142 = this;

          if (!this.createUploadAdapter) return console.warn(Object(Qn.a)("filerepository-no-upload-adapter: Upload adapter is not defined.")), null;
          var e = new Mh(Promise.resolve(t), this.createUploadAdapter);
          return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(function (t) {
            _this142._loadersMap.set(t, e);
          }).catch(function () {}), e.on("change:uploaded", function () {
            var t = 0;
            var _iteratorNormalCompletion274 = true;
            var _didIteratorError274 = false;
            var _iteratorError274 = undefined;

            try {
              for (var _iterator274 = _this142.loaders[Symbol.iterator](), _step274; !(_iteratorNormalCompletion274 = (_step274 = _iterator274.next()).done); _iteratorNormalCompletion274 = true) {
                var _e209 = _step274.value;
                t += _e209.uploaded;
              }
            } catch (err) {
              _didIteratorError274 = true;
              _iteratorError274 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion274 && _iterator274.return != null) {
                  _iterator274.return();
                }
              } finally {
                if (_didIteratorError274) {
                  throw _iteratorError274;
                }
              }
            }

            _this142.uploaded = t;
          }), e.on("change:uploadTotal", function () {
            var t = 0;
            var _iteratorNormalCompletion275 = true;
            var _didIteratorError275 = false;
            var _iteratorError275 = undefined;

            try {
              for (var _iterator275 = _this142.loaders[Symbol.iterator](), _step275; !(_iteratorNormalCompletion275 = (_step275 = _iterator275.next()).done); _iteratorNormalCompletion275 = true) {
                var _e210 = _step275.value;
                _e210.uploadTotal && (t += _e210.uploadTotal);
              }
            } catch (err) {
              _didIteratorError275 = true;
              _iteratorError275 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion275 && _iterator275.return != null) {
                  _iterator275.return();
                }
              } finally {
                if (_didIteratorError275) {
                  throw _iteratorError275;
                }
              }
            }

            _this142.uploadTotal = t;
          }), e;
        }
      }, {
        key: "destroyLoader",
        value: function destroyLoader(t) {
          var _this143 = this;

          var e = t instanceof Mh ? t : this.getLoader(t);
          e._destroy(), this.loaders.remove(e), this._loadersMap.forEach(function (t, n) {
            t === e && _this143._loadersMap.delete(n);
          });
        }
      }, {
        key: "_updatePendingAction",
        value: function _updatePendingAction() {
          var t = this.editor.plugins.get(Ch);

          if (this.loaders.length) {
            if (!this._pendingAction) {
              var _e211 = this.editor.t,
                  _n192 = function _n192(t) {
                return "".concat(_e211("ay"), " ").concat(parseInt(t), "%.");
              };

              this._pendingAction = t.add(_n192(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _n192);
            }
          } else t.remove(this._pendingAction), this._pendingAction = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FileRepository";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Ch];
        }
      }]);

      return Sh;
    }(Md);

    li(Sh, Ui);

    var Mh =
    /*#__PURE__*/
    function () {
      function Mh(t, e) {
        _classCallCheck(this, Mh);

        this.id = Zn(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new Ph(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
          return e ? t / e * 100 : 0;
        }), this.set("uploadResponse", null);
      }

      _createClass(Mh, [{
        key: "read",
        value: function read() {
          var _this144 = this;

          if ("idle" != this.status) throw new Qn.b("filerepository-read-wrong-status: You cannot call read if the status is different than idle.", this);
          return this.status = "reading", this.file.then(function (t) {
            return _this144._reader.read(t);
          }).then(function (t) {
            if ("reading" !== _this144.status) throw _this144.status;
            return _this144.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === t) throw _this144.status = "aborted", "aborted";
            throw _this144.status = "error", _this144._reader.error ? _this144._reader.error : t;
          });
        }
      }, {
        key: "upload",
        value: function upload() {
          var _this145 = this;

          if ("idle" != this.status) throw new Qn.b("filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.", this);
          return this.status = "uploading", this.file.then(function () {
            return _this145._adapter.upload();
          }).then(function (t) {
            return _this145.uploadResponse = t, _this145.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === _this145.status) throw "aborted";
            throw _this145.status = "error", t;
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          var t = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(function () {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
        }
      }, {
        key: "_destroy",
        value: function _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
        }
      }, {
        key: "_createFilePromiseWrapper",
        value: function _createFilePromiseWrapper(t) {
          var e = {};
          return e.promise = new Promise(function (n, i) {
            e.rejecter = i, e.isFulfilled = !1, t.then(function (t) {
              e.isFulfilled = !0, n(t);
            }).catch(function (t) {
              e.isFulfilled = !0, i(t);
            });
          }), e;
        }
      }, {
        key: "file",
        get: function get() {
          var _this146 = this;

          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (t) {
            return _this146._filePromiseWrapper ? t : null;
          }) : Promise.resolve(null);
        }
      }, {
        key: "data",
        get: function get() {
          return this._reader.data;
        }
      }]);

      return Mh;
    }();

    li(Mh, Ui);
    var Eh = "ckCsrfToken",
        Ih = 40,
        Nh = "abcdefghijklmnopqrstuvwxyz0123456789";

    function Oh() {
      var t = function (t) {
        t = t.toLowerCase();
        var e = document.cookie.split(";");
        var _iteratorNormalCompletion276 = true;
        var _didIteratorError276 = false;
        var _iteratorError276 = undefined;

        try {
          for (var _iterator276 = e[Symbol.iterator](), _step276; !(_iteratorNormalCompletion276 = (_step276 = _iterator276.next()).done); _iteratorNormalCompletion276 = true) {
            var _n193 = _step276.value;

            var _e212 = _n193.split("=");

            if (decodeURIComponent(_e212[0].trim().toLowerCase()) === t) return decodeURIComponent(_e212[1]);
          }
        } catch (err) {
          _didIteratorError276 = true;
          _iteratorError276 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion276 && _iterator276.return != null) {
              _iterator276.return();
            }
          } finally {
            if (_didIteratorError276) {
              throw _iteratorError276;
            }
          }
        }

        return null;
      }(Eh);

      var e, n;
      return t && t.length == Ih || (t = function (t) {
        var e = "";
        var n = new Uint8Array(t);
        window.crypto.getRandomValues(n);

        for (var _t220 = 0; _t220 < n.length; _t220++) {
          var _i157 = Nh.charAt(n[_t220] % Nh.length);

          e += Math.random() > .5 ? _i157.toUpperCase() : _i157;
        }

        return e;
      }(Ih), e = Eh, n = t, document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(n) + ";path=/"), t;
    }

    var Rh =
    /*#__PURE__*/
    function (_Md12) {
      _inherits(Rh, _Md12);

      function Rh() {
        _classCallCheck(this, Rh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Rh).apply(this, arguments));
      }

      _createClass(Rh, [{
        key: "init",
        value: function init() {
          var _this147 = this;

          var t = this.editor.config.get("ckfinder.uploadUrl");
          t && (this.editor.plugins.get(Sh).createUploadAdapter = function (e) {
            return new Dh(e, t, _this147.editor.t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Sh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "CKFinderUploadAdapter";
        }
      }]);

      return Rh;
    }(Md);

    var Dh =
    /*#__PURE__*/
    function () {
      function Dh(t, e, n) {
        _classCallCheck(this, Dh);

        this.loader = t, this.url = e, this.t = n;
      }

      _createClass(Dh, [{
        key: "upload",
        value: function upload() {
          var _this148 = this;

          return this.loader.file.then(function (t) {
            return new Promise(function (e, n) {
              _this148._initRequest(), _this148._initListeners(e, n, t), _this148._sendRequest(t);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr && this.xhr.abort();
        }
      }, {
        key: "_initRequest",
        value: function _initRequest() {
          var t = this.xhr = new XMLHttpRequest();
          t.open("POST", this.url, !0), t.responseType = "json";
        }
      }, {
        key: "_initListeners",
        value: function _initListeners(t, e, n) {
          var i = this.xhr,
              o = this.loader,
              r = (0, this.t)("a") + " ".concat(n.name, ".");
          i.addEventListener("error", function () {
            return e(r);
          }), i.addEventListener("abort", function () {
            return e();
          }), i.addEventListener("load", function () {
            var n = i.response;
            if (!n || !n.uploaded) return e(n && n.error && n.error.message ? n.error.message : r);
            t({
              default: n.url
            });
          }), i.upload && i.upload.addEventListener("progress", function (t) {
            t.lengthComputable && (o.uploadTotal = t.total, o.uploaded = t.loaded);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest(t) {
          var e = new FormData();
          e.append("upload", t), e.append("ckCsrfToken", Oh()), this.xhr.send(e);
        }
      }]);

      return Dh;
    }();

    var Lh =
    /*#__PURE__*/
    function () {
      _createClass(Lh, null, [{
        key: "pluginName",
        get: function get() {
          return "BlockAutoformatEditing";
        }
      }]);

      function Lh(t, e, n) {
        _classCallCheck(this, Lh);

        var i,
            o = null;
        "function" == typeof n ? i = n : (o = t.commands.get(n), i = function i() {
          t.execute(n);
        }), t.model.document.on("change", function (n, r) {
          if (o && !o.isEnabled) return;
          if ("transparent" == r.type) return;
          var s = Array.from(t.model.document.differ.getChanges()),
              a = s[0];
          if (1 != s.length || "insert" !== a.type || "$text" != a.name || 1 != a.length) return;
          var c = a.position.parent;
          if (!c.is("paragraph") || 1 !== c.childCount) return;
          var l = e.exec(c.getChild(0).data);
          l && t.model.enqueueChange(function (t) {
            var e = t.createPositionAt(c, 0),
                n = t.createPositionAt(c, l[0].length),
                o = new ca(e, n);
            !1 !== i({
              match: l
            }) && t.remove(o), o.detach();
          });
        });
      }

      return Lh;
    }();

    var jh =
    /*#__PURE__*/
    function () {
      _createClass(jh, null, [{
        key: "pluginName",
        get: function get() {
          return "InlineAutoformatEditing";
        }
      }]);

      function jh(t, e, n) {
        _classCallCheck(this, jh);

        var i, o, r, s;
        e instanceof RegExp ? i = e : r = e, "string" == typeof n ? o = n : s = n, r = r || function (t) {
          var e;
          var n = [],
              o = [];

          for (; null !== (e = i.exec(t)) && !(e && e.length < 4);) {
            var _e213 = e,
                _t221 = _e213.index,
                _i158 = _e213[1],
                _r35 = _e213[2],
                _s23 = _e213[3];

            var _a12 = _i158 + _r35 + _s23;

            _t221 += e[0].length - _a12.length;
            var _c7 = [_t221, _t221 + _i158.length],
                _l4 = [_t221 + _i158.length + _r35.length, _t221 + _i158.length + _r35.length + _s23.length];
            n.push(_c7), n.push(_l4), o.push([_t221 + _i158.length, _t221 + _i158.length + _r35.length]);
          }

          return {
            remove: n,
            format: o
          };
        }, s = s || function (e, n) {
          var i = t.model.schema.getValidRanges(n, o);
          var _iteratorNormalCompletion277 = true;
          var _didIteratorError277 = false;
          var _iteratorError277 = undefined;

          try {
            for (var _iterator277 = i[Symbol.iterator](), _step277; !(_iteratorNormalCompletion277 = (_step277 = _iterator277.next()).done); _iteratorNormalCompletion277 = true) {
              var _t222 = _step277.value;
              e.setAttribute(o, !0, _t222);
            }
          } catch (err) {
            _didIteratorError277 = true;
            _iteratorError277 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion277 && _iterator277.return != null) {
                _iterator277.return();
              }
            } finally {
              if (_didIteratorError277) {
                throw _iteratorError277;
              }
            }
          }

          e.removeSelectionAttribute(o);
        }, t.model.document.on("change", function (e, n) {
          if ("transparent" == n.type) return;
          var i = t.model,
              o = i.document.selection;
          if (!o.isCollapsed) return;
          var a = Array.from(i.document.differ.getChanges()),
              c = a[0];
          if (1 != a.length || "insert" !== c.type || "$text" != c.name || 1 != c.length) return;

          var l = o.focus,
              d = l.parent,
              _ref96 = function (t, e) {
            var n = t.start;
            return {
              text: Array.from(t.getItems()).reduce(function (t, i) {
                return i.is("text") || i.is("textProxy") ? t + i.data : (n = e.createPositionAfter(i), "");
              }, ""),
              range: e.createRange(n, t.end)
            };
          }(i.createRange(i.createPositionAt(d, 0), l), i),
              h = _ref96.text,
              u = _ref96.range,
              f = r(h),
              g = Vh(u.start, f.format, i),
              m = Vh(u.start, f.remove, i);

          g.length && m.length && i.enqueueChange(function (t) {
            if (!1 !== s(t, g)) {
              var _iteratorNormalCompletion278 = true;
              var _didIteratorError278 = false;
              var _iteratorError278 = undefined;

              try {
                for (var _iterator278 = m.reverse()[Symbol.iterator](), _step278; !(_iteratorNormalCompletion278 = (_step278 = _iterator278.next()).done); _iteratorNormalCompletion278 = true) {
                  var _e214 = _step278.value;
                  t.remove(_e214);
                }
              } catch (err) {
                _didIteratorError278 = true;
                _iteratorError278 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion278 && _iterator278.return != null) {
                    _iterator278.return();
                  }
                } finally {
                  if (_didIteratorError278) {
                    throw _iteratorError278;
                  }
                }
              }
            }
          });
        });
      }

      return jh;
    }();

    function Vh(t, e, n) {
      return e.filter(function (t) {
        return void 0 !== t[0] && void 0 !== t[1];
      }).map(function (e) {
        return n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]));
      });
    }

    function zh(t, e) {
      return function (n, i) {
        if (!t.commands.get(e).isEnabled) return !1;
        var o = t.model.schema.getValidRanges(i, e);
        var _iteratorNormalCompletion279 = true;
        var _didIteratorError279 = false;
        var _iteratorError279 = undefined;

        try {
          for (var _iterator279 = o[Symbol.iterator](), _step279; !(_iteratorNormalCompletion279 = (_step279 = _iterator279.next()).done); _iteratorNormalCompletion279 = true) {
            var _t223 = _step279.value;
            n.setAttribute(e, !0, _t223);
          }
        } catch (err) {
          _didIteratorError279 = true;
          _iteratorError279 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion279 && _iterator279.return != null) {
              _iterator279.return();
            }
          } finally {
            if (_didIteratorError279) {
              throw _iteratorError279;
            }
          }
        }

        n.removeSelectionAttribute(e);
      };
    }

    var Bh =
    /*#__PURE__*/
    function (_Rd6) {
      _inherits(Bh, _Rd6);

      function Bh(t, e) {
        var _this149;

        _classCallCheck(this, Bh);

        _this149 = _possibleConstructorReturn(this, _getPrototypeOf(Bh).call(this, t)), _this149.attributeKey = e;
        return _this149;
      }

      _createClass(Bh, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this150 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document.selection,
              i = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (n.isCollapsed) i ? t.setSelectionAttribute(_this150.attributeKey, !0) : t.removeSelectionAttribute(_this150.attributeKey);else {
              var _o82 = e.schema.getValidRanges(n.getRanges(), _this150.attributeKey);

              var _iteratorNormalCompletion280 = true;
              var _didIteratorError280 = false;
              var _iteratorError280 = undefined;

              try {
                for (var _iterator280 = _o82[Symbol.iterator](), _step280; !(_iteratorNormalCompletion280 = (_step280 = _iterator280.next()).done); _iteratorNormalCompletion280 = true) {
                  var _e215 = _step280.value;
                  i ? t.setAttribute(_this150.attributeKey, i, _e215) : t.removeAttribute(_this150.attributeKey, _e215);
                }
              } catch (err) {
                _didIteratorError280 = true;
                _iteratorError280 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion280 && _iterator280.return != null) {
                    _iterator280.return();
                  }
                } finally {
                  if (_didIteratorError280) {
                    throw _iteratorError280;
                  }
                }
              }
            }
          });
        }
      }, {
        key: "_getValueFromFirstAllowedNode",
        value: function _getValueFromFirstAllowedNode() {
          var t = this.editor.model,
              e = t.schema,
              n = t.document.selection;
          if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
          var _iteratorNormalCompletion281 = true;
          var _didIteratorError281 = false;
          var _iteratorError281 = undefined;

          try {
            for (var _iterator281 = n.getRanges()[Symbol.iterator](), _step281; !(_iteratorNormalCompletion281 = (_step281 = _iterator281.next()).done); _iteratorNormalCompletion281 = true) {
              var _t224 = _step281.value;
              var _iteratorNormalCompletion282 = true;
              var _didIteratorError282 = false;
              var _iteratorError282 = undefined;

              try {
                for (var _iterator282 = _t224.getItems()[Symbol.iterator](), _step282; !(_iteratorNormalCompletion282 = (_step282 = _iterator282.next()).done); _iteratorNormalCompletion282 = true) {
                  var _n194 = _step282.value;
                  if (e.checkAttribute(_n194, this.attributeKey)) return _n194.hasAttribute(this.attributeKey);
                }
              } catch (err) {
                _didIteratorError282 = true;
                _iteratorError282 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion282 && _iterator282.return != null) {
                    _iterator282.return();
                  }
                } finally {
                  if (_didIteratorError282) {
                    throw _iteratorError282;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError281 = true;
            _iteratorError281 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion281 && _iterator281.return != null) {
                _iterator281.return();
              }
            } finally {
              if (_didIteratorError281) {
                throw _iteratorError281;
              }
            }
          }

          return !1;
        }
      }]);

      return Bh;
    }(Rd);

    var Fh = "bold";

    var Uh =
    /*#__PURE__*/
    function (_Md13) {
      _inherits(Uh, _Md13);

      function Uh() {
        _classCallCheck(this, Uh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Uh).apply(this, arguments));
      }

      _createClass(Uh, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: Fh
          }), t.model.schema.setAttributeProperties(Fh, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: Fh,
            view: "strong",
            upcastAlso: ["b", function (t) {
              var e = t.getStyle("font-weight");
              return e ? "bold" == e || Number(e) >= 600 ? {
                name: !0,
                styles: ["font-weight"]
              } : void 0 : null;
            }]
          }), t.commands.add(Fh, new Bh(t, Fh)), t.keystrokes.set("CTRL+B", Fh);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BoldEditing";
        }
      }]);

      return Uh;
    }(Md);

    var Hh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
    var qh = "bold";

    var Wh =
    /*#__PURE__*/
    function (_Md14) {
      _inherits(Wh, _Md14);

      function Wh() {
        _classCallCheck(this, Wh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Wh).apply(this, arguments));
      }

      _createClass(Wh, [{
        key: "init",
        value: function init() {
          var _this151 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(qh, function (n) {
            var i = t.commands.get(qh),
                o = new ud(n);
            return o.set({
              label: e("ag"),
              icon: Hh,
              keystroke: "CTRL+B",
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this151.listenTo(o, "execute", function () {
              return t.execute(qh);
            }), o;
          });
        }
      }]);

      return Wh;
    }(Md);

    var Yh = "italic";

    var $h =
    /*#__PURE__*/
    function (_Md15) {
      _inherits($h, _Md15);

      function $h() {
        _classCallCheck(this, $h);

        return _possibleConstructorReturn(this, _getPrototypeOf($h).apply(this, arguments));
      }

      _createClass($h, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: Yh
          }), t.model.schema.setAttributeProperties(Yh, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: Yh,
            view: "i",
            upcastAlso: ["em", {
              styles: {
                "font-style": "italic"
              }
            }]
          }), t.commands.add(Yh, new Bh(t, Yh)), t.keystrokes.set("CTRL+I", Yh);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ItalicEditing";
        }
      }]);

      return $h;
    }(Md);

    var Gh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
    var Qh = "italic";

    var Kh =
    /*#__PURE__*/
    function (_Md16) {
      _inherits(Kh, _Md16);

      function Kh() {
        _classCallCheck(this, Kh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Kh).apply(this, arguments));
      }

      _createClass(Kh, [{
        key: "init",
        value: function init() {
          var _this152 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(Qh, function (n) {
            var i = t.commands.get(Qh),
                o = new ud(n);
            return o.set({
              label: e("d"),
              icon: Gh,
              keystroke: "CTRL+I",
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this152.listenTo(o, "execute", function () {
              return t.execute(Qh);
            }), o;
          });
        }
      }]);

      return Kh;
    }(Md);

    function Jh(t) {
      var e = t.next();
      return e.done ? null : e.value;
    }

    var Zh =
    /*#__PURE__*/
    function (_Rd7) {
      _inherits(Zh, _Rd7);

      function Zh() {
        _classCallCheck(this, Zh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Zh).apply(this, arguments));
      }

      _createClass(Zh, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this153 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = Array.from(i.getSelectedBlocks()),
              r = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (r) {
              var _e216 = o.filter(function (t) {
                return Xh(t) || eu(n, t);
              });

              _this153._applyQuote(t, _e216);
            } else _this153._removeQuote(t, o.filter(Xh));
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = Jh(this.editor.model.document.selection.getSelectedBlocks());
          return !(!t || !Xh(t));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              n = Jh(t.getSelectedBlocks());
          return !!n && eu(e, n);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(t, e) {
          tu(t, e).reverse().forEach(function (e) {
            if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);

            if (e.start.isAtStart) {
              var _n195 = t.createPositionBefore(e.start.parent);

              return void t.move(e, _n195);
            }

            e.end.isAtEnd || t.split(e.end);
            var n = t.createPositionAfter(e.end.parent);
            t.move(e, n);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(t, e) {
          var n = [];
          tu(t, e).reverse().forEach(function (e) {
            var i = Xh(e.start);
            i || (i = t.createElement("blockQuote"), t.wrap(e, i)), n.push(i);
          }), n.reverse().reduce(function (e, n) {
            return e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n;
          });
        }
      }]);

      return Zh;
    }(Rd);

    function Xh(t) {
      return "blockQuote" == t.parent.name ? t.parent : null;
    }

    function tu(t, e) {
      var n,
          i = 0;
      var o = [];

      for (; i < e.length;) {
        var _r36 = e[i],
            _s24 = e[i + 1];
        n || (n = t.createPositionBefore(_r36)), _s24 && _r36.nextSibling == _s24 || (o.push(t.createRange(n, t.createPositionAfter(_r36))), n = null), i++;
      }

      return o;
    }

    function eu(t, e) {
      var n = t.checkChild(e.parent, "blockQuote"),
          i = t.checkChild(["$root", "blockQuote"], e);
      return n && i;
    }

    var nu =
    /*#__PURE__*/
    function (_Md17) {
      _inherits(nu, _Md17);

      function nu() {
        _classCallCheck(this, nu);

        return _possibleConstructorReturn(this, _getPrototypeOf(nu).apply(this, arguments));
      }

      _createClass(nu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema;
          t.commands.add("blockQuote", new Zh(t)), e.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          }), e.addChildCheck(function (t, e) {
            if (t.endsWith("blockQuote") && "blockQuote" == e.name) return !1;
          }), t.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          }), t.model.document.registerPostFixer(function (n) {
            var i = t.model.document.differ.getChanges();
            var _iteratorNormalCompletion283 = true;
            var _didIteratorError283 = false;
            var _iteratorError283 = undefined;

            try {
              for (var _iterator283 = i[Symbol.iterator](), _step283; !(_iteratorNormalCompletion283 = (_step283 = _iterator283.next()).done); _iteratorNormalCompletion283 = true) {
                var _t225 = _step283.value;

                if ("insert" == _t225.type) {
                  var _i159 = _t225.position.nodeAfter;
                  if (!_i159) continue;
                  if (_i159.is("blockQuote") && _i159.isEmpty) return n.remove(_i159), !0;
                  if (_i159.is("blockQuote") && !e.checkChild(_t225.position, _i159)) return n.unwrap(_i159), !0;

                  if (_i159.is("element")) {
                    var _t226 = n.createRangeIn(_i159);

                    var _iteratorNormalCompletion284 = true;
                    var _didIteratorError284 = false;
                    var _iteratorError284 = undefined;

                    try {
                      for (var _iterator284 = _t226.getItems()[Symbol.iterator](), _step284; !(_iteratorNormalCompletion284 = (_step284 = _iterator284.next()).done); _iteratorNormalCompletion284 = true) {
                        var _i160 = _step284.value;
                        if (_i160.is("blockQuote") && !e.checkChild(n.createPositionBefore(_i160), _i160)) return n.unwrap(_i160), !0;
                      }
                    } catch (err) {
                      _didIteratorError284 = true;
                      _iteratorError284 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion284 && _iterator284.return != null) {
                          _iterator284.return();
                        }
                      } finally {
                        if (_didIteratorError284) {
                          throw _iteratorError284;
                        }
                      }
                    }
                  }
                } else if ("remove" == _t225.type) {
                  var _e217 = _t225.position.parent;
                  if (_e217.is("blockQuote") && _e217.isEmpty) return n.remove(_e217), !0;
                }
              }
            } catch (err) {
              _didIteratorError283 = true;
              _iteratorError283 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion283 && _iterator283.return != null) {
                  _iterator283.return();
                }
              } finally {
                if (_didIteratorError283) {
                  throw _iteratorError283;
                }
              }
            }

            return !1;
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var _this154 = this;

          var t = this.editor.commands.get("blockQuote");
          this.listenTo(this.editor.editing.view.document, "enter", function (e, n) {
            var i = _this154.editor.model.document,
                o = i.selection.getLastPosition().parent;
            i.selection.isCollapsed && o.isEmpty && t.value && (_this154.editor.execute("blockQuote"), _this154.editor.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteEditing";
        }
      }]);

      return nu;
    }(Md);

    var iu = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
    n(43);

    var ou =
    /*#__PURE__*/
    function (_Md18) {
      _inherits(ou, _Md18);

      function ou() {
        _classCallCheck(this, ou);

        return _possibleConstructorReturn(this, _getPrototypeOf(ou).apply(this, arguments));
      }

      _createClass(ou, [{
        key: "init",
        value: function init() {
          var _this155 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("blockQuote", function (n) {
            var i = t.commands.get("blockQuote"),
                o = new ud(n);
            return o.set({
              label: e("h"),
              icon: iu,
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this155.listenTo(o, "execute", function () {
              return t.execute("blockQuote");
            }), o;
          });
        }
      }]);

      return ou;
    }(Md);

    var ru = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>';

    var su =
    /*#__PURE__*/
    function (_Md19) {
      _inherits(su, _Md19);

      function su() {
        _classCallCheck(this, su);

        return _possibleConstructorReturn(this, _getPrototypeOf(su).apply(this, arguments));
      }

      _createClass(su, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.ui.componentFactory,
              n = t.t;
          e.add("ckfinder", function (e) {
            var i = t.commands.get("ckfinder"),
                o = new ud(e);
            return o.set({
              label: n("g"),
              icon: ru,
              tooltip: !0
            }), o.bind("isEnabled").to(i), o.on("execute", function () {
              t.execute("ckfinder"), t.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderUI";
        }
      }]);

      return su;
    }(Md);

    var au =
    /*#__PURE__*/
    function (_mr7) {
      _inherits(au, _mr7);

      function au() {
        _classCallCheck(this, au);

        return _possibleConstructorReturn(this, _getPrototypeOf(au).apply(this, arguments));
      }

      _createClass(au, [{
        key: "observe",
        value: function observe(t) {
          var _this156 = this;

          this.listenTo(t, "load", function (t, e) {
            "IMG" == e.target.tagName && _this156._fireEvents(e);
          }, {
            useCapture: !0
          });
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(t) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
        }
      }]);

      return au;
    }(mr);

    function cu(t) {
      return function (n) {
        n.on("attribute:".concat(t, ":image"), e);
      };

      function e(t, e, n) {
        if (!n.consumable.consume(e.item, t.name)) return;
        var i = n.writer,
            o = n.mapper.toViewElement(e.item).getChild(0);
        null !== e.attributeNewValue ? i.setAttribute(e.attributeKey, e.attributeNewValue, o) : i.removeAttribute(e.attributeKey, o);
      }
    }

    var lu =
    /*#__PURE__*/
    function () {
      function lu() {
        _classCallCheck(this, lu);

        this._stack = [];
      }

      _createClass(lu, [{
        key: "add",
        value: function add(t, e) {
          var n = this._stack,
              i = n[0];

          this._insertDescriptor(t);

          var o = n[0];
          i === o || du(i, o) || this.fire("change:top", {
            oldDescriptor: i,
            newDescriptor: o,
            writer: e
          });
        }
      }, {
        key: "remove",
        value: function remove(t, e) {
          var n = this._stack,
              i = n[0];

          this._removeDescriptor(t);

          var o = n[0];
          i === o || du(i, o) || this.fire("change:top", {
            oldDescriptor: i,
            newDescriptor: o,
            writer: e
          });
        }
      }, {
        key: "_insertDescriptor",
        value: function _insertDescriptor(t) {
          var e = this._stack,
              n = e.findIndex(function (e) {
            return e.id === t.id;
          });
          if (du(t, e[n])) return;
          n > -1 && e.splice(n, 1);
          var i = 0;

          for (; e[i] && hu(e[i], t);) {
            i++;
          }

          e.splice(i, 0, t);
        }
      }, {
        key: "_removeDescriptor",
        value: function _removeDescriptor(t) {
          var e = this._stack,
              n = e.findIndex(function (e) {
            return e.id === t;
          });
          n > -1 && e.splice(n, 1);
        }
      }]);

      return lu;
    }();

    function du(t, e) {
      return t && e && t.priority == e.priority && uu(t.classes) == uu(e.classes);
    }

    function hu(t, e) {
      return t.priority > e.priority || !(t.priority < e.priority) && uu(t.classes) > uu(e.classes);
    }

    function uu(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }

    li(lu, ni);
    var fu = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
    var gu = "ck-widget",
        mu = "ck-widget_selected";

    function pu(t) {
      return !!t.is("element") && !!t.getCustomProperty("widget");
    }

    function bu(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return mo.isEdge || e.setAttribute("contenteditable", "false", t), e.addClass(gu, t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = vu, n.label && function (t, e, n) {
        n.setCustomProperty("widgetLabel", e, t);
      }(t, n.label, e), n.hasSelectionHandle && function (t, e) {
        var n = e.createUIElement("div", {
          class: "ck ck-widget__selection-handle"
        }, function (t) {
          var e = this.toDomElement(t),
              n = new dd();
          return n.set("content", fu), n.render(), e.appendChild(n.element), e;
        });
        e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handle"], t);
      }(t, e), function (t, e, n, i) {
        var o = new lu();
        o.on("change:top", function (e, o) {
          o.oldDescriptor && i(t, o.oldDescriptor, o.writer), o.newDescriptor && n(t, o.newDescriptor, o.writer);
        }), e.setCustomProperty("addHighlight", function (t, e, n) {
          return o.add(e, n);
        }, t), e.setCustomProperty("removeHighlight", function (t, e, n) {
          return o.remove(e, n);
        }, t);
      }(t, e, function (t, e, n) {
        return n.addClass(i(e.classes), t);
      }, function (t, e, n) {
        return n.removeClass(i(e.classes), t);
      }), t;

      function i(t) {
        return Array.isArray(t) ? t : [t];
      }
    }

    function wu(t) {
      var e = t.getCustomProperty("widgetLabel");
      return e ? "function" == typeof e ? e() : e : "";
    }

    function ku(t, e) {
      return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), mo.isEdge || (e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", function (n, i, o) {
        e.setAttribute("contenteditable", o ? "false" : "true", t);
      })), t.on("change:isFocused", function (n, i, o) {
        o ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
      }), t;
    }

    function _u(t, e) {
      var n = t.getSelectedElement();
      if (n && e.schema.isBlock(n)) return e.createPositionAfter(n);
      var i = t.getSelectedBlocks().next().value;

      if (i) {
        if (i.isEmpty) return e.createPositionAt(i, 0);

        var _n196 = e.createPositionAfter(i);

        return t.focus.isTouching(_n196) ? _n196 : e.createPositionBefore(i);
      }

      return t.focus;
    }

    function vu() {
      return null;
    }

    function yu(t) {
      var e = t.getSelectedElement();
      return e && function (t) {
        return !!t.getCustomProperty("image") && pu(t);
      }(e) ? e : null;
    }

    function xu(t) {
      return !!t && t.is("image");
    }

    function Au(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var i = t.createElement("image", n),
          o = _u(e.document.selection, e);

      e.insertContent(i, o), i.parent && t.setSelection(i, "on");
    }

    function Tu(t) {
      var e = t.schema,
          n = t.document.selection;
      return function (t, e, n) {
        var i = function (t, e) {
          var n = _u(t, e).parent;

          if (n.isEmpty && !n.is("$root")) return n.parent;
          return n;
        }(t, n);

        return e.checkChild(i, "image");
      }(n, e, t) && !function (t, e) {
        var n = t.getSelectedElement();
        return n && e.isObject(n);
      }(n, e) && function (t) {
        return _toConsumableArray(t.focus.getAncestors()).every(function (t) {
          return !t.is("image");
        });
      }(n);
    }

    var Cu =
    /*#__PURE__*/
    function (_Rd8) {
      _inherits(Cu, _Rd8);

      function Cu() {
        _classCallCheck(this, Cu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Cu).apply(this, arguments));
      }

      _createClass(Cu, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = Tu(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          e.change(function (n) {
            var i = Array.isArray(t.source) ? t.source : [t.source];
            var _iteratorNormalCompletion285 = true;
            var _didIteratorError285 = false;
            var _iteratorError285 = undefined;

            try {
              for (var _iterator285 = i[Symbol.iterator](), _step285; !(_iteratorNormalCompletion285 = (_step285 = _iterator285.next()).done); _iteratorNormalCompletion285 = true) {
                var _t227 = _step285.value;
                Au(n, e, {
                  src: _t227
                });
              }
            } catch (err) {
              _didIteratorError285 = true;
              _iteratorError285 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion285 && _iterator285.return != null) {
                  _iterator285.return();
                }
              } finally {
                if (_didIteratorError285) {
                  throw _iteratorError285;
                }
              }
            }
          });
        }
      }]);

      return Cu;
    }(Rd);

    var Pu =
    /*#__PURE__*/
    function (_Md20) {
      _inherits(Pu, _Md20);

      function Pu() {
        _classCallCheck(this, Pu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Pu).apply(this, arguments));
      }

      _createClass(Pu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.t,
              i = t.conversion;
          t.editing.view.addObserver(au), e.register("image", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["alt", "src", "srcset"]
          }), i.for("dataDowncast").elementToElement({
            model: "image",
            view: function view(t, e) {
              return Su(e);
            }
          }), i.for("editingDowncast").elementToElement({
            model: "image",
            view: function view(t, e) {
              return function (t, e, n) {
                return e.setCustomProperty("image", !0, t), bu(t, e, {
                  label: function label() {
                    var e = t.getChild(0).getAttribute("alt");
                    return e ? "".concat(e, " ").concat(n) : n;
                  }
                });
              }(Su(e), e, n("i"));
            }
          }), i.for("downcast").add(cu("src")).add(cu("alt")).add(function () {
            return function (e) {
              e.on("attribute:srcset:image", t);
            };

            function t(t, e, n) {
              if (!n.consumable.consume(e.item, t.name)) return;
              var i = n.writer,
                  o = n.mapper.toViewElement(e.item).getChild(0);

              if (null === e.attributeNewValue) {
                var _t228 = e.attributeOldValue;
                _t228.data && (i.removeAttribute("srcset", o), i.removeAttribute("sizes", o), _t228.width && i.removeAttribute("width", o));
              } else {
                var _t229 = e.attributeNewValue;
                _t229.data && (i.setAttribute("srcset", _t229.data, o), i.setAttribute("sizes", "100vw", o), _t229.width && i.setAttribute("width", _t229.width, o));
              }
            }
          }()), i.for("upcast").elementToElement({
            view: {
              name: "img",
              attributes: {
                src: !0
              }
            },
            model: function model(t, e) {
              return e.createElement("image", {
                src: t.getAttribute("src")
              });
            }
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "alt"
            },
            model: "alt"
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "srcset"
            },
            model: {
              key: "srcset",
              value: function value(t) {
                var e = {
                  data: t.getAttribute("srcset")
                };
                return t.hasAttribute("width") && (e.width = t.getAttribute("width")), e;
              }
            }
          }).add(function () {
            return function (e) {
              e.on("element:figure", t);
            };

            function t(t, e, n) {
              if (!n.consumable.test(e.viewItem, {
                name: !0,
                classes: "image"
              })) return;
              var i = Array.from(e.viewItem.getChildren()).find(function (t) {
                return t.is("img");
              });
              if (!i || !i.hasAttribute("src") || !n.consumable.test(i, {
                name: !0
              })) return;
              var o = n.convertItem(i, e.modelCursor),
                  r = Jh(o.modelRange.getItems());
              r && (n.convertChildren(e.viewItem, n.writer.createPositionAt(r, 0)), e.modelRange = o.modelRange, e.modelCursor = o.modelCursor);
            }
          }()), t.commands.add("imageInsert", new Cu(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageEditing";
        }
      }]);

      return Pu;
    }(Md);

    function Su(t) {
      var e = t.createEmptyElement("img"),
          n = t.createContainerElement("figure", {
        class: "image"
      });
      return t.insert(t.createPositionAt(n, 0), e), n;
    }

    function Mu(t, e, n) {
      return n.createRange(Eu(t, e, !0, n), Eu(t, e, !1, n));
    }

    function Eu(t, e, n, i) {
      var o = t.textNode || (n ? t.nodeBefore : t.nodeAfter),
          r = null;

      for (; o && o.getAttribute("linkHref") == e;) {
        r = o, o = n ? o.previousSibling : o.nextSibling;
      }

      return r ? i.createPositionAt(r, n ? "before" : "after") : t;
    }

    var Iu =
    /*#__PURE__*/
    function (_Rd9) {
      _inherits(Iu, _Rd9);

      function Iu(t) {
        var _this157;

        _classCallCheck(this, Iu);

        _this157 = _possibleConstructorReturn(this, _getPrototypeOf(Iu).call(this, t)), _this157.manualDecorators = new ro();
        return _this157;
      }

      _createClass(Iu, [{
        key: "restoreManualDecoratorStates",
        value: function restoreManualDecoratorStates() {
          var _iteratorNormalCompletion286 = true;
          var _didIteratorError286 = false;
          var _iteratorError286 = undefined;

          try {
            for (var _iterator286 = this.manualDecorators[Symbol.iterator](), _step286; !(_iteratorNormalCompletion286 = (_step286 = _iterator286.next()).done); _iteratorNormalCompletion286 = true) {
              var _t230 = _step286.value;
              _t230.value = this._getDecoratorStateFromModel(_t230.id);
            }
          } catch (err) {
            _didIteratorError286 = true;
            _iteratorError286 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion286 && _iterator286.return != null) {
                _iterator286.return();
              }
            } finally {
              if (_didIteratorError286) {
                throw _iteratorError286;
              }
            }
          }
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;
          this.value = e.selection.getAttribute("linkHref");
          var _iteratorNormalCompletion287 = true;
          var _didIteratorError287 = false;
          var _iteratorError287 = undefined;

          try {
            for (var _iterator287 = this.manualDecorators[Symbol.iterator](), _step287; !(_iteratorNormalCompletion287 = (_step287 = _iterator287.next()).done); _iteratorNormalCompletion287 = true) {
              var _t231 = _step287.value;
              _t231.value = this._getDecoratorStateFromModel(_t231.id);
            }
          } catch (err) {
            _didIteratorError287 = true;
            _iteratorError287 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion287 && _iterator287.return != null) {
                _iterator287.return();
              }
            } finally {
              if (_didIteratorError287) {
                throw _iteratorError287;
              }
            }
          }

          this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = n.document.selection,
              o = [],
              r = [];

          for (var _t232 in e) {
            e[_t232] ? o.push(_t232) : r.push(_t232);
          }

          n.change(function (e) {
            if (i.isCollapsed) {
              var _s25 = i.getFirstPosition();

              if (i.hasAttribute("linkHref")) {
                var _a13 = Mu(_s25, i.getAttribute("linkHref"), n);

                e.setAttribute("linkHref", t, _a13), o.forEach(function (t) {
                  e.setAttribute(t, !0, _a13);
                }), r.forEach(function (t) {
                  e.removeAttribute(t, _a13);
                }), e.setSelection(_a13);
              } else if ("" !== t) {
                var _r37 = Fs(i.getAttributes());

                _r37.set("linkHref", t), o.forEach(function (t) {
                  _r37.set(t, !0);
                });

                var _a14 = e.createText(t, _r37);

                n.insertContent(_a14, _s25), e.setSelection(e.createRangeOn(_a14));
              }
            } else {
              var _s26 = n.schema.getValidRanges(i.getRanges(), "linkHref");

              var _iteratorNormalCompletion288 = true;
              var _didIteratorError288 = false;
              var _iteratorError288 = undefined;

              try {
                var _loop6 = function _loop6() {
                  var n = _step288.value;
                  e.setAttribute("linkHref", t, n), o.forEach(function (t) {
                    e.setAttribute(t, !0, n);
                  }), r.forEach(function (t) {
                    e.removeAttribute(t, n);
                  });
                };

                for (var _iterator288 = _s26[Symbol.iterator](), _step288; !(_iteratorNormalCompletion288 = (_step288 = _iterator288.next()).done); _iteratorNormalCompletion288 = true) {
                  _loop6();
                }
              } catch (err) {
                _didIteratorError288 = true;
                _iteratorError288 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion288 && _iterator288.return != null) {
                    _iterator288.return();
                  }
                } finally {
                  if (_didIteratorError288) {
                    throw _iteratorError288;
                  }
                }
              }
            }
          });
        }
      }, {
        key: "_getDecoratorStateFromModel",
        value: function _getDecoratorStateFromModel(t) {
          return this.editor.model.document.selection.getAttribute(t) || !1;
        }
      }]);

      return Iu;
    }(Rd);

    var Nu =
    /*#__PURE__*/
    function (_Rd10) {
      _inherits(Nu, _Rd10);

      function Nu() {
        _classCallCheck(this, Nu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Nu).apply(this, arguments));
      }

      _createClass(Nu, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this.editor.model.document.selection.hasAttribute("linkHref");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = this.editor.model,
              n = e.document.selection,
              i = t.commands.get("link");
          e.change(function (t) {
            var o = n.isCollapsed ? [Mu(n.getFirstPosition(), n.getAttribute("linkHref"), e)] : n.getRanges();
            var _iteratorNormalCompletion289 = true;
            var _didIteratorError289 = false;
            var _iteratorError289 = undefined;

            try {
              for (var _iterator289 = o[Symbol.iterator](), _step289; !(_iteratorNormalCompletion289 = (_step289 = _iterator289.next()).done); _iteratorNormalCompletion289 = true) {
                var _e218 = _step289.value;

                if (t.removeAttribute("linkHref", _e218), i) {
                  var _iteratorNormalCompletion290 = true;
                  var _didIteratorError290 = false;
                  var _iteratorError290 = undefined;

                  try {
                    for (var _iterator290 = i.manualDecorators[Symbol.iterator](), _step290; !(_iteratorNormalCompletion290 = (_step290 = _iterator290.next()).done); _iteratorNormalCompletion290 = true) {
                      var _n197 = _step290.value;
                      t.removeAttribute(_n197.id, _e218);
                    }
                  } catch (err) {
                    _didIteratorError290 = true;
                    _iteratorError290 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion290 && _iterator290.return != null) {
                        _iterator290.return();
                      }
                    } finally {
                      if (_didIteratorError290) {
                        throw _iteratorError290;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError289 = true;
              _iteratorError289 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion289 && _iterator289.return != null) {
                  _iterator289.return();
                }
              } finally {
                if (_didIteratorError289) {
                  throw _iteratorError289;
                }
              }
            }
          });
        }
      }]);

      return Nu;
    }(Rd);

    var Ou = function Ou(t, e, n) {
      var i = -1,
          o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;

      for (var r = Array(o); ++i < o;) {
        r[i] = t[i + e];
      }

      return r;
    };

    var Ru = function Ru(t, e, n) {
      var i = t.length;
      return n = void 0 === n ? i : n, !e && n >= i ? t : Ou(t, e, n);
    },
        Du = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    var Lu = function Lu(t) {
      return Du.test(t);
    };

    var ju = function ju(t) {
      return t.split("");
    },
        Vu = "[\\ud800-\\udfff]",
        zu = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        Bu = "\\ud83c[\\udffb-\\udfff]",
        Fu = "[^\\ud800-\\udfff]",
        Uu = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        Hu = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        qu = "(?:" + zu + "|" + Bu + ")" + "?",
        Wu = "[\\ufe0e\\ufe0f]?" + qu + ("(?:\\u200d(?:" + [Fu, Uu, Hu].join("|") + ")[\\ufe0e\\ufe0f]?" + qu + ")*"),
        Yu = "(?:" + [Fu + zu + "?", zu, Uu, Hu, Vu].join("|") + ")",
        $u = RegExp(Bu + "(?=" + Bu + ")|" + Yu + Wu, "g");

    var Gu = function Gu(t) {
      return t.match($u) || [];
    };

    var Qu = function Qu(t) {
      return Lu(t) ? Gu(t) : ju(t);
    };

    var Ku = function Ku(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = Array(i); ++n < i;) {
        o[n] = e(t[n], n, t);
      }

      return o;
    },
        Ju = 1 / 0,
        Zu = o ? o.prototype : void 0,
        Xu = Zu ? Zu.toString : void 0;

    var tf = function t(e) {
      if ("string" == typeof e) return e;
      if (Yt(e)) return Ku(e, t) + "";
      if (as(e)) return Xu ? Xu.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -Ju ? "-0" : n;
    };

    var ef = function ef(t) {
      return null == t ? "" : tf(t);
    };

    var nf = function (t) {
      return function (e) {
        e = ef(e);
        var n = Lu(e) ? Qu(e) : void 0,
            i = n ? n[0] : e.charAt(0),
            o = n ? Ru(n, 1).join("") : e.slice(1);
        return i[t]() + o;
      };
    }("toUpperCase");

    var of = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
        rf = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;

    function sf(t, e) {
      var n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      return e.setCustomProperty("link", !0, n), n;
    }

    function af(t) {
      return function (t) {
        return t.replace(of, "").match(rf);
      }(t = String(t)) ? t : "#";
    }

    var cf =
    /*#__PURE__*/
    function () {
      function cf() {
        _classCallCheck(this, cf);

        this._definitions = new Set();
      }

      _createClass(cf, [{
        key: "add",
        value: function add(t) {
          var _this158 = this;

          Array.isArray(t) ? t.forEach(function (t) {
            return _this158._definitions.add(t);
          }) : this._definitions.add(t);
        }
      }, {
        key: "getDispatcher",
        value: function getDispatcher() {
          var _this159 = this;

          return function (t) {
            t.on("attribute:linkHref", function (t, e, n) {
              if (!n.consumable.test(e.item, "attribute:linkHref")) return;
              var i = n.writer,
                  o = i.document.selection;
              var _iteratorNormalCompletion291 = true;
              var _didIteratorError291 = false;
              var _iteratorError291 = undefined;

              try {
                for (var _iterator291 = _this159._definitions[Symbol.iterator](), _step291; !(_iteratorNormalCompletion291 = (_step291 = _iterator291.next()).done); _iteratorNormalCompletion291 = true) {
                  var _t233 = _step291.value;

                  var _r38 = i.createAttributeElement("a", _t233.attributes, {
                    priority: 5
                  });

                  i.setCustomProperty("link", !0, _r38), _t233.callback(e.attributeNewValue) ? e.item.is("selection") ? i.wrap(o.getFirstRange(), _r38) : i.wrap(n.mapper.toViewRange(e.range), _r38) : i.unwrap(n.mapper.toViewRange(e.range), _r38);
                }
              } catch (err) {
                _didIteratorError291 = true;
                _iteratorError291 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion291 && _iterator291.return != null) {
                    _iterator291.return();
                  }
                } finally {
                  if (_didIteratorError291) {
                    throw _iteratorError291;
                  }
                }
              }
            }, {
              priority: "high"
            });
          };
        }
      }, {
        key: "length",
        get: function get() {
          return this._definitions.size;
        }
      }]);

      return cf;
    }();

    var lf = function lf(_ref97) {
      var t = _ref97.id,
          e = _ref97.label,
          n = _ref97.attributes;

      _classCallCheck(this, lf);

      this.id = t, this.set("value"), this.label = e, this.attributes = n;
    };

    li(lf, Ui);

    var df =
    /*#__PURE__*/
    function () {
      function df(t, e, n) {
        var _this160 = this;

        _classCallCheck(this, df);

        this.model = t, this.attribute = n, this._modelSelection = t.document.selection, this._overrideUid = null, this._isNextGravityRestorationSkipped = !1, e.listenTo(this._modelSelection, "change:range", function (t, e) {
          _this160._isNextGravityRestorationSkipped ? _this160._isNextGravityRestorationSkipped = !1 : _this160._isGravityOverridden && (!e.directChange && hf(_this160._modelSelection.getFirstPosition(), n) || _this160._restoreGravity());
        });
      }

      _createClass(df, [{
        key: "handleForwardMovement",
        value: function handleForwardMovement(t, e) {
          var n = this.attribute;
          if (!(this._isGravityOverridden || t.isAtStart && this._hasSelectionAttribute)) return gf(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._removeSelectionAttribute(), !0) : uf(t, n) ? (this._preventCaretMovement(e), this._overrideGravity(), !0) : ff(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._overrideGravity(), !0) : void 0;
        }
      }, {
        key: "handleBackwardMovement",
        value: function handleBackwardMovement(t, e) {
          var n = this.attribute;
          return this._isGravityOverridden ? gf(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._restoreGravity(), this._removeSelectionAttribute(), !0) : (this._preventCaretMovement(e), this._restoreGravity(), t.isAtStart && this._removeSelectionAttribute(), !0) : gf(t, n) && !this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._setSelectionAttributeFromTheNodeBefore(t), !0) : t.isAtEnd && ff(t, n) ? this._hasSelectionAttribute ? void (mf(t, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity())) : (this._preventCaretMovement(e), this._setSelectionAttributeFromTheNodeBefore(t), !0) : t.isAtStart ? this._hasSelectionAttribute ? (this._removeSelectionAttribute(), this._preventCaretMovement(e), !0) : void 0 : void (mf(t, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity()));
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          this._overrideUid = this.model.change(function (t) {
            return t.overrideSelectionGravity();
          });
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity() {
          var _this161 = this;

          this.model.change(function (t) {
            t.restoreSelectionGravity(_this161._overrideUid), _this161._overrideUid = null;
          });
        }
      }, {
        key: "_preventCaretMovement",
        value: function _preventCaretMovement(t) {
          t.preventDefault();
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute() {
          var _this162 = this;

          this.model.change(function (t) {
            t.removeSelectionAttribute(_this162.attribute);
          });
        }
      }, {
        key: "_setSelectionAttributeFromTheNodeBefore",
        value: function _setSelectionAttributeFromTheNodeBefore(t) {
          var _this163 = this;

          var e = this.attribute;
          this.model.change(function (n) {
            n.setSelectionAttribute(_this163.attribute, t.nodeBefore.getAttribute(e));
          });
        }
      }, {
        key: "_skipNextAutomaticGravityRestoration",
        value: function _skipNextAutomaticGravityRestoration() {
          this._isNextGravityRestorationSkipped = !0;
        }
      }, {
        key: "_isGravityOverridden",
        get: function get() {
          return !!this._overrideUid;
        }
      }, {
        key: "_hasSelectionAttribute",
        get: function get() {
          return this._modelSelection.hasAttribute(this.attribute);
        }
      }]);

      return df;
    }();

    function hf(t, e) {
      return uf(t, e) || ff(t, e);
    }

    function uf(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e);
      return !!i && i.hasAttribute(e) && (!o || n.getAttribute(e) !== i.getAttribute(e));
    }

    function ff(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e),
          r = !!i && i.hasAttribute(e);
      return o && (!r || n.getAttribute(e) !== i.getAttribute(e));
    }

    function gf(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e);
      if (!!i && i.hasAttribute(e) && o) return i.getAttribute(e) !== n.getAttribute(e);
    }

    function mf(t, e) {
      return hf(t.getShiftedBy(-1), e);
    }

    n(45);
    var pf = "ck-link_selected",
        bf = "automatic",
        wf = "manual",
        kf = /^(https?:)?\/\//;

    var _f =
    /*#__PURE__*/
    function (_Md21) {
      _inherits(_f, _Md21);

      _createClass(_f, null, [{
        key: "pluginName",
        get: function get() {
          return "LinkEditing";
        }
      }]);

      function _f(t) {
        var _this164;

        _classCallCheck(this, _f);

        _this164 = _possibleConstructorReturn(this, _getPrototypeOf(_f).call(this, t)), t.config.define("link", {
          addTargetToExternalLinks: !1
        });
        return _this164;
      }

      _createClass(_f, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.locale;
          t.model.schema.extend("$text", {
            allowAttributes: "linkHref"
          }), t.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: sf
          }), t.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: function view(t, e) {
              return sf(af(t), e);
            }
          }), t.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              attributes: {
                href: !0
              }
            },
            model: {
              key: "linkHref",
              value: function value(t) {
                return t.getAttribute("href");
              }
            }
          }), t.commands.add("link", new Iu(t)), t.commands.add("unlink", new Nu(t));

          var n = function (t, e) {
            var n = {
              "Open in a new tab": t("az"),
              Downloadable: t("ba")
            };
            return e.forEach(function (t) {
              return t.label && n[t.label] && (t.label = n[t.label]), t;
            }), e;
          }(t.t, function (t) {
            var e = [];

            if (t) {
              for (var _i161 = 0, _Object$entries = Object.entries(t); _i161 < _Object$entries.length; _i161++) {
                var _ref100 = _Object$entries[_i161];

                var _ref99 = _slicedToArray(_ref100, 2);

                var _n198 = _ref99[0];
                var _i162 = _ref99[1];

                var _t234 = Object.assign({}, _i162, {
                  id: "link".concat(nf(_n198))
                });

                e.push(_t234);
              }
            }

            return e;
          }(t.config.get("link.decorators")));

          this._enableAutomaticDecorators(n.filter(function (t) {
            return t.mode === bf;
          })), this._enableManualDecorators(n.filter(function (t) {
            return t.mode === wf;
          })), function (_ref101) {
            var t = _ref101.view,
                e = _ref101.model,
                n = _ref101.emitter,
                i = _ref101.attribute,
                o = _ref101.locale;
            var r = new df(e, n, i),
                s = e.document.selection;
            n.listenTo(t.document, "keydown", function (t, e) {
              if (!s.isCollapsed) return;
              if (e.shiftKey || e.altKey || e.ctrlKey) return;
              var n = e.keyCode == wo.arrowright,
                  i = e.keyCode == wo.arrowleft;
              if (!n && !i) return;
              var a = s.getFirstPosition(),
                  c = o.contentLanguageDirection;
              var l;
              l = "ltr" === c && n || "rtl" === c && i ? r.handleForwardMovement(a, e) : r.handleBackwardMovement(a, e), l && t.stop();
            }, {
              priority: Xn.get("high") + 1
            });
          }({
            view: t.editing.view,
            model: t.model,
            emitter: this,
            attribute: "linkHref",
            locale: e
          }), this._setupLinkHighlight();
        }
      }, {
        key: "_enableAutomaticDecorators",
        value: function _enableAutomaticDecorators(t) {
          var e = this.editor,
              n = new cf();
          e.config.get("link.addTargetToExternalLinks") && n.add({
            id: "linkIsExternal",
            mode: bf,
            callback: function callback(t) {
              return kf.test(t);
            },
            attributes: {
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
        }
      }, {
        key: "_enableManualDecorators",
        value: function _enableManualDecorators(t) {
          if (!t.length) return;
          var e = this.editor,
              n = e.commands.get("link").manualDecorators;
          t.forEach(function (t) {
            e.model.schema.extend("$text", {
              allowAttributes: t.id
            }), n.add(new lf(t)), e.conversion.for("downcast").attributeToElement({
              model: t.id,
              view: function view(e, i) {
                if (e) {
                  var _e219 = n.get(t.id).attributes,
                      _o83 = i.createAttributeElement("a", _e219, {
                    priority: 5
                  });

                  return i.setCustomProperty("link", !0, _o83), _o83;
                }
              }
            }), e.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: n.get(t.id).attributes
              },
              model: {
                key: t.id
              }
            });
          });
        }
      }, {
        key: "_setupLinkHighlight",
        value: function _setupLinkHighlight() {
          var t = this.editor,
              e = t.editing.view,
              n = new Set();
          e.document.registerPostFixer(function (e) {
            var i = t.model.document.selection;
            var o = !1;

            if (i.hasAttribute("linkHref")) {
              var _r39 = Mu(i.getFirstPosition(), i.getAttribute("linkHref"), t.model),
                  _s27 = t.editing.mapper.toViewRange(_r39);

              var _iteratorNormalCompletion292 = true;
              var _didIteratorError292 = false;
              var _iteratorError292 = undefined;

              try {
                for (var _iterator292 = _s27.getItems()[Symbol.iterator](), _step292; !(_iteratorNormalCompletion292 = (_step292 = _iterator292.next()).done); _iteratorNormalCompletion292 = true) {
                  var _t235 = _step292.value;
                  _t235.is("a") && !_t235.hasClass(pf) && (e.addClass(pf, _t235), n.add(_t235), o = !0);
                }
              } catch (err) {
                _didIteratorError292 = true;
                _iteratorError292 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion292 && _iterator292.return != null) {
                    _iterator292.return();
                  }
                } finally {
                  if (_didIteratorError292) {
                    throw _iteratorError292;
                  }
                }
              }
            }

            return o;
          }), t.conversion.for("editingDowncast").add(function (t) {
            function i() {
              e.change(function (t) {
                var _iteratorNormalCompletion293 = true;
                var _didIteratorError293 = false;
                var _iteratorError293 = undefined;

                try {
                  for (var _iterator293 = n.values()[Symbol.iterator](), _step293; !(_iteratorNormalCompletion293 = (_step293 = _iterator293.next()).done); _iteratorNormalCompletion293 = true) {
                    var _e220 = _step293.value;
                    t.removeClass(pf, _e220), n.delete(_e220);
                  }
                } catch (err) {
                  _didIteratorError293 = true;
                  _iteratorError293 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion293 && _iterator293.return != null) {
                      _iterator293.return();
                    }
                  } finally {
                    if (_didIteratorError293) {
                      throw _iteratorError293;
                    }
                  }
                }
              });
            }

            t.on("insert", i, {
              priority: "highest"
            }), t.on("remove", i, {
              priority: "highest"
            }), t.on("attribute", i, {
              priority: "highest"
            }), t.on("selection", i, {
              priority: "highest"
            });
          });
        }
      }]);

      return _f;
    }(Md);

    var vf =
    /*#__PURE__*/
    function (_Md22) {
      _inherits(vf, _Md22);

      function vf() {
        _classCallCheck(this, vf);

        return _possibleConstructorReturn(this, _getPrototypeOf(vf).apply(this, arguments));
      }

      _createClass(vf, [{
        key: "init",
        value: function init() {
          this.on("show:warning", function (t, e) {
            window.alert(e.message);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "showSuccess",
        value: function showSuccess(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "success",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showInfo",
        value: function showInfo(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "info",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showWarning",
        value: function showWarning(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "warning",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "_showNotification",
        value: function _showNotification(t) {
          var e = "show:".concat(t.type) + (t.namespace ? ":".concat(t.namespace) : "");
          this.fire(e, {
            message: t.message,
            type: t.type,
            title: t.title || ""
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Notification";
        }
      }]);

      return vf;
    }(Md);

    var yf =
    /*#__PURE__*/
    function (_Rd11) {
      _inherits(yf, _Rd11);

      function yf(t) {
        var _this165;

        _classCallCheck(this, yf);

        _this165 = _possibleConstructorReturn(this, _getPrototypeOf(yf).call(this, t)), _this165.stopListening(_this165.editor.model.document, "change"), _this165.listenTo(_this165.editor.model.document, "change", function () {
          return _this165.refresh();
        }, {
          priority: "low"
        });
        return _this165;
      }

      _createClass(yf, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.commands.get("imageInsert"),
              e = this.editor.commands.get("link");
          this.isEnabled = t.isEnabled || e.isEnabled;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if ("popup" != e && "modal" != e) throw new Qn.b('ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".', t);
          var n = this.editor.config.get("ckfinder.options") || {};
          n.chooseFiles = !0;
          var i = n.onInit;
          n.language || (n.language = t.locale.uiLanguage), n.onInit = function (e) {
            i && i(e), e.on("files:choose", function (n) {
              var i = n.data.files.toArray(),
                  o = i.filter(function (t) {
                return !t.isImage();
              }),
                  r = i.filter(function (t) {
                return t.isImage();
              });
              var _iteratorNormalCompletion294 = true;
              var _didIteratorError294 = false;
              var _iteratorError294 = undefined;

              try {
                for (var _iterator294 = o[Symbol.iterator](), _step294; !(_iteratorNormalCompletion294 = (_step294 = _iterator294.next()).done); _iteratorNormalCompletion294 = true) {
                  var _e221 = _step294.value;
                  t.execute("link", _e221.getUrl());
                }
              } catch (err) {
                _didIteratorError294 = true;
                _iteratorError294 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion294 && _iterator294.return != null) {
                    _iterator294.return();
                  }
                } finally {
                  if (_didIteratorError294) {
                    throw _iteratorError294;
                  }
                }
              }

              var s = [];
              var _iteratorNormalCompletion295 = true;
              var _didIteratorError295 = false;
              var _iteratorError295 = undefined;

              try {
                for (var _iterator295 = r[Symbol.iterator](), _step295; !(_iteratorNormalCompletion295 = (_step295 = _iterator295.next()).done); _iteratorNormalCompletion295 = true) {
                  var _t236 = _step295.value;

                  var _n199 = _t236.getUrl();

                  s.push(_n199 || e.request("file:getProxyUrl", {
                    file: _t236
                  }));
                }
              } catch (err) {
                _didIteratorError295 = true;
                _iteratorError295 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion295 && _iterator295.return != null) {
                    _iterator295.return();
                  }
                } finally {
                  if (_didIteratorError295) {
                    throw _iteratorError295;
                  }
                }
              }

              s.length && xf(t, s);
            }), e.on("file:choose:resizedImage", function (e) {
              var n = e.data.resizedUrl;
              if (n) xf(t, [n]);else {
                var _e222 = t.plugins.get("Notification"),
                    _n200 = t.locale.t;

                _e222.showWarning(_n200("at"), {
                  title: _n200("au"),
                  namespace: "ckfinder"
                });
              }
            });
          }, window.CKFinder[e](n);
        }
      }]);

      return yf;
    }(Rd);

    function xf(t, e) {
      if (t.commands.get("imageInsert").isEnabled) t.execute("imageInsert", {
        source: e
      });else {
        var _e223 = t.plugins.get("Notification"),
            _n201 = t.locale.t;

        _e223.showWarning(_n201("av"), {
          title: _n201("aw"),
          namespace: "ckfinder"
        });
      }
    }

    var Af =
    /*#__PURE__*/
    function (_Md23) {
      _inherits(Af, _Md23);

      function Af() {
        _classCallCheck(this, Af);

        return _possibleConstructorReturn(this, _getPrototypeOf(Af).apply(this, arguments));
      }

      _createClass(Af, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("ckfinder", new yf(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [vf, Pu, _f];
        }
      }]);

      return Af;
    }(Md);

    var Tf = /^data:(\S*?);base64,/;

    var Cf =
    /*#__PURE__*/
    function () {
      function Cf(t, e, n) {
        _classCallCheck(this, Cf);

        if (!t) throw new Qn.b("fileuploader-missing-file: File must be provided as the first argument", null);
        if (!e) throw new Qn.b("fileuploader-missing-token: Token must be provided as the second argument.", null);
        if (!n) throw new Qn.b("fileuploader-missing-api-address: Api address must be provided as the third argument.", null);
        this.file = function (t) {
          if ("string" != typeof t) return !1;
          var e = t.match(Tf);
          return !(!e || !e.length);
        }(t) ? function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

          try {
            var _n202 = t.match(Tf)[1],
                _i163 = atob(t.replace(Tf, "")),
                _o84 = [];

            for (var _t237 = 0; _t237 < _i163.length; _t237 += e) {
              var _n203 = _i163.slice(_t237, _t237 + e),
                  _r40 = new Array(_n203.length);

              for (var _t238 = 0; _t238 < _n203.length; _t238++) {
                _r40[_t238] = _n203.charCodeAt(_t238);
              }

              _o84.push(new Uint8Array(_r40));
            }

            return new Blob(_o84, {
              type: _n202
            });
          } catch (t) {
            throw new Qn.b("fileuploader-decoding-image-data-error: Problem with decoding Base64 image data.", null);
          }
        }(t) : t, this._token = e, this._apiAddress = n;
      }

      _createClass(Cf, [{
        key: "onProgress",
        value: function onProgress(t) {
          return this.on("progress", function (e, n) {
            return t(n);
          }), this;
        }
      }, {
        key: "onError",
        value: function onError(t) {
          return this.once("error", function (e, n) {
            return t(n);
          }), this;
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr.abort();
        }
      }, {
        key: "send",
        value: function send() {
          return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
        }
      }, {
        key: "_prepareRequest",
        value: function _prepareRequest() {
          var t = new XMLHttpRequest();
          t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
        }
      }, {
        key: "_attachXHRListeners",
        value: function _attachXHRListeners() {
          var _this166 = this;

          var t = this,
              e = this.xhr;

          function n(e) {
            return function () {
              return t.fire("error", e);
            };
          }

          e.addEventListener("error", n("Network Error")), e.addEventListener("abort", n("Abort")), e.upload && e.upload.addEventListener("progress", function (t) {
            t.lengthComputable && _this166.fire("progress", {
              total: t.total,
              uploaded: t.loaded
            });
          }), e.addEventListener("load", function () {
            var t = e.status,
                n = e.response;
            if (t < 200 || t > 299) return _this166.fire("error", n.message || n.error);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest() {
          var _this167 = this;

          var t = new FormData(),
              e = this.xhr;
          return t.append("file", this.file), new Promise(function (n, i) {
            e.addEventListener("load", function () {
              var t = e.status,
                  o = e.response;
              return t < 200 || t > 299 ? o.message ? i(new Qn.b("fileuploader-uploading-data-failed: Uploading file failed.", _this167, {
                message: o.message
              })) : i(o.error) : n(o);
            }), e.addEventListener("error", function () {
              return i(new Error("Network Error"));
            }), e.addEventListener("abort", function () {
              return i(new Error("Abort"));
            }), e.send(t);
          });
        }
      }]);

      return Cf;
    }();

    li(Cf, ni);
    var Pf = {
      refreshInterval: 36e5,
      autoRefresh: !0
    };

    var Sf =
    /*#__PURE__*/
    function () {
      function Sf(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Pf;

        _classCallCheck(this, Sf);

        if (!t) throw new Qn.b("token-missing-token-url: A `tokenUrl` must be provided as the first constructor argument.", this);
        this.set("value", e.initValue), this._refresh = "function" == typeof t ? t : function () {
          return function (t) {
            return new Promise(function (e, n) {
              var i = new XMLHttpRequest();
              i.open("GET", t), i.addEventListener("load", function () {
                var t = i.status,
                    o = i.response;
                return t < 200 || t > 299 ? n(new Qn.b("token-cannot-download-new-token: Cannot download new token from the provided url.", null)) : e(o);
              }), i.addEventListener("error", function () {
                return n(new Error("Network Error"));
              }), i.addEventListener("abort", function () {
                return n(new Error("Abort"));
              }), i.send();
            });
          }(t);
        }, this._options = Object.assign({}, Pf, e);
      }

      _createClass(Sf, [{
        key: "init",
        value: function init() {
          var _this168 = this;

          return new Promise(function (t, e) {
            _this168._options.autoRefresh && _this168._startRefreshing(), _this168.value ? t(_this168) : _this168._refreshToken().then(t).catch(e);
          });
        }
      }, {
        key: "_refreshToken",
        value: function _refreshToken() {
          var _this169 = this;

          return this._refresh().then(function (t) {
            return _this169.set("value", t);
          }).then(function () {
            return _this169;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._stopRefreshing();
        }
      }, {
        key: "_startRefreshing",
        value: function _startRefreshing() {
          var _this170 = this;

          this._refreshInterval = setInterval(function () {
            return _this170._refreshToken();
          }, this._options.refreshInterval);
        }
      }, {
        key: "_stopRefreshing",
        value: function _stopRefreshing() {
          clearInterval(this._refreshInterval);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Pf;
          return new Sf(t, e).init();
        }
      }]);

      return Sf;
    }();

    li(Sf, Ui);
    var Mf = Sf;

    var Ef =
    /*#__PURE__*/
    function (_Md24) {
      _inherits(Ef, _Md24);

      function Ef() {
        _classCallCheck(this, Ef);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ef).apply(this, arguments));
      }

      _createClass(Ef, [{
        key: "init",
        value: function init() {
          var t = this.editor.config.get("cloudServices") || {};

          for (var _e224 in t) {
            this[_e224] = t[_e224];
          }

          if (this.tokenUrl) return this.token = new Ef.Token(this.tokenUrl), this.token.init();
          this.token = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CloudServices";
        }
      }]);

      return Ef;
    }(Md);

    Ef.Token = Mf;

    var If =
    /*#__PURE__*/
    function (_Md25) {
      _inherits(If, _Md25);

      function If() {
        _classCallCheck(this, If);

        return _possibleConstructorReturn(this, _getPrototypeOf(If).apply(this, arguments));
      }

      _createClass(If, [{
        key: "init",
        value: function init() {
          var _this171 = this;

          var t = this.editor,
              e = t.plugins.get(Ef),
              n = e.token,
              i = e.uploadUrl;
          n && (this._uploadGateway = new If._UploadGateway(n, i), t.plugins.get(Sh).createUploadAdapter = function (t) {
            return new Nf(_this171._uploadGateway, t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Sh, Ef];
        }
      }]);

      return If;
    }(Md);

    var Nf =
    /*#__PURE__*/
    function () {
      function Nf(t, e) {
        _classCallCheck(this, Nf);

        this.uploadGateway = t, this.loader = e;
      }

      _createClass(Nf, [{
        key: "upload",
        value: function upload() {
          var _this172 = this;

          return this.loader.file.then(function (t) {
            return _this172.fileUploader = _this172.uploadGateway.upload(t), _this172.fileUploader.on("progress", function (t, e) {
              _this172.loader.uploadTotal = e.total, _this172.loader.uploaded = e.uploaded;
            }), _this172.fileUploader.send();
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.fileUploader.abort();
        }
      }]);

      return Nf;
    }();

    If._UploadGateway =
    /*#__PURE__*/
    function () {
      function _class(t, e) {
        _classCallCheck(this, _class);

        if (!t) throw new Qn.b("uploadgateway-missing-token: Token must be provided.", null);
        if (!e) throw new Qn.b("uploadgateway-missing-api-address: Api address must be provided.", null);
        this._token = t, this._apiAddress = e;
      }

      _createClass(_class, [{
        key: "upload",
        value: function upload(t) {
          return new Cf(t, this._token, this._apiAddress);
        }
      }]);

      return _class;
    }();

    var Of =
    /*#__PURE__*/
    function (_is6) {
      _inherits(Of, _is6);

      function Of(t) {
        var _this173;

        _classCallCheck(this, Of);

        _this173 = _possibleConstructorReturn(this, _getPrototypeOf(Of).call(this, t)), _this173.domEventType = "mousedown";
        return _this173;
      }

      _createClass(Of, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return Of;
    }(is);

    n(47);

    var Rf = _o("Ctrl+A");

    var Df =
    /*#__PURE__*/
    function (_Md26) {
      _inherits(Df, _Md26);

      function Df() {
        _classCallCheck(this, Df);

        return _possibleConstructorReturn(this, _getPrototypeOf(Df).apply(this, arguments));
      }

      _createClass(Df, [{
        key: "init",
        value: function init() {
          var _this174 = this;

          var t = this.editor.editing.view,
              e = t.document;
          this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (t, e, n) {
            _this174._clearPreviouslySelectedWidgets(n.writer);

            var i = n.writer,
                o = i.document.selection,
                r = o.getSelectedElement();
            var s = null;
            var _iteratorNormalCompletion296 = true;
            var _didIteratorError296 = false;
            var _iteratorError296 = undefined;

            try {
              for (var _iterator296 = o.getRanges()[Symbol.iterator](), _step296; !(_iteratorNormalCompletion296 = (_step296 = _iterator296.next()).done); _iteratorNormalCompletion296 = true) {
                var _t239 = _step296.value;
                var _iteratorNormalCompletion297 = true;
                var _didIteratorError297 = false;
                var _iteratorError297 = undefined;

                try {
                  for (var _iterator297 = _t239[Symbol.iterator](), _step297; !(_iteratorNormalCompletion297 = (_step297 = _iterator297.next()).done); _iteratorNormalCompletion297 = true) {
                    var _e225 = _step297.value;
                    var _t240 = _e225.item;
                    pu(_t240) && !Lf(_t240, s) && (i.addClass(mu, _t240), _this174._previouslySelected.add(_t240), s = _t240, _t240 == r && i.setSelection(o.getRanges(), {
                      fake: !0,
                      label: wu(r)
                    }));
                  }
                } catch (err) {
                  _didIteratorError297 = true;
                  _iteratorError297 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion297 && _iterator297.return != null) {
                      _iterator297.return();
                    }
                  } finally {
                    if (_didIteratorError297) {
                      throw _iteratorError297;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError296 = true;
              _iteratorError296 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion296 && _iterator296.return != null) {
                  _iterator296.return();
                }
              } finally {
                if (_didIteratorError296) {
                  throw _iteratorError296;
                }
              }
            }
          }, {
            priority: "low"
          }), t.addObserver(Of), this.listenTo(e, "mousedown", function () {
            return _this174._onMousedown.apply(_this174, arguments);
          }), this.listenTo(e, "keydown", function () {
            return _this174._onKeydown.apply(_this174, arguments);
          }, {
            priority: "high"
          }), this.listenTo(e, "delete", function (t, e) {
            _this174._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_onMousedown",
        value: function _onMousedown(t, e) {
          var n = this.editor,
              i = n.editing.view,
              o = i.document;
          var r = e.target;

          if (function (t) {
            for (; t;) {
              if (t.is("editableElement") && !t.is("rootElement")) return !0;
              if (pu(t)) return !1;
              t = t.parent;
            }

            return !1;
          }(r)) {
            if (mo.isSafari && e.domEvent.detail >= 3) {
              var _t241 = n.editing.mapper.toModelElement(r);

              this.editor.model.change(function (n) {
                e.preventDefault(), n.setSelection(_t241, "in");
              });
            }

            return;
          }

          if (!pu(r) && (r = r.findAncestor(pu), !r)) return;
          e.preventDefault(), o.isFocused || i.focus();
          var s = n.editing.mapper.toModelElement(r);

          this._setSelectionOverElement(s);
        }
      }, {
        key: "_onKeydown",
        value: function _onKeydown(t, e) {
          var n = e.keyCode,
              i = "ltr" === this.editor.locale.contentLanguageDirection,
              o = n == wo.arrowdown || n == wo[i ? "arrowright" : "arrowleft"];
          var r = !1;
          !function (t) {
            return t == wo.arrowright || t == wo.arrowleft || t == wo.arrowup || t == wo.arrowdown;
          }(n) ? !function (t) {
            return ko(t) == Rf;
          }(e) ? n === wo.enter && (r = this._handleEnterKey(e.shiftKey)) : r = this._selectAllNestedEditableContent() || this._selectAllContent() : r = this._handleArrowKeys(o), r && (e.preventDefault(), t.stop());
        }
      }, {
        key: "_handleDelete",
        value: function _handleDelete(t) {
          var _this175 = this;

          if (this.editor.isReadOnly) return;
          var e = this.editor.model.document.selection;
          if (!e.isCollapsed) return;

          var n = this._getObjectElementNextToSelection(t);

          return n ? (this.editor.model.change(function (t) {
            var i = e.anchor.parent;

            for (; i.isEmpty;) {
              var _e226 = i;
              i = _e226.parent, t.remove(_e226);
            }

            _this175._setSelectionOverElement(n);
          }), !0) : void 0;
        }
      }, {
        key: "_handleArrowKeys",
        value: function _handleArrowKeys(t) {
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = i.getSelectedElement();

          if (o && n.isObject(o)) {
            var _o85 = t ? i.getLastPosition() : i.getFirstPosition(),
                _r41 = n.getNearestSelectionRange(_o85, t ? "forward" : "backward");

            return _r41 && e.change(function (t) {
              t.setSelection(_r41);
            }), !0;
          }

          if (!i.isCollapsed) return;

          var r = this._getObjectElementNextToSelection(t);

          return r && n.isObject(r) ? (this._setSelectionOverElement(r), !0) : void 0;
        }
      }, {
        key: "_handleEnterKey",
        value: function _handleEnterKey(t) {
          var e = this.editor.model,
              n = e.document.selection.getSelectedElement();
          if (i = n, o = e.schema, i && o.isObject(i) && !o.isInline(i)) return e.change(function (i) {
            var o = i.createPositionAt(n, t ? "before" : "after");
            var r = i.createElement("paragraph");

            if (e.schema.isBlock(n.parent)) {
              var _t242 = e.schema.findAllowedParent(o, r);

              o = i.split(o, _t242).position;
            }

            i.insert(r, o), i.setSelection(r, "in");
          }), !0;
          var i, o;
        }
      }, {
        key: "_selectAllNestedEditableContent",
        value: function _selectAllNestedEditableContent() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema.getLimitElement(e);
          return e.getFirstRange().root != n && (t.change(function (t) {
            t.setSelection(t.createRangeIn(n));
          }), !0);
        }
      }, {
        key: "_selectAllContent",
        value: function _selectAllContent() {
          var t = this.editor.model,
              e = this.editor.editing,
              n = e.view.document.selection.getSelectedElement();

          if (n && pu(n)) {
            var _i164 = e.mapper.toModelElement(n.parent);

            return t.change(function (t) {
              t.setSelection(t.createRangeIn(_i164));
            }), !0;
          }

          return !1;
        }
      }, {
        key: "_setSelectionOverElement",
        value: function _setSelectionOverElement(t) {
          this.editor.model.change(function (e) {
            e.setSelection(e.createRangeOn(t));
          });
        }
      }, {
        key: "_getObjectElementNextToSelection",
        value: function _getObjectElementNextToSelection(t) {
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = e.createSelection(i);
          e.modifySelection(o, {
            direction: t ? "forward" : "backward"
          });
          var r = t ? o.focus.nodeBefore : o.focus.nodeAfter;
          return r && n.isObject(r) ? r : null;
        }
      }, {
        key: "_clearPreviouslySelectedWidgets",
        value: function _clearPreviouslySelectedWidgets(t) {
          var _iteratorNormalCompletion298 = true;
          var _didIteratorError298 = false;
          var _iteratorError298 = undefined;

          try {
            for (var _iterator298 = this._previouslySelected[Symbol.iterator](), _step298; !(_iteratorNormalCompletion298 = (_step298 = _iterator298.next()).done); _iteratorNormalCompletion298 = true) {
              var _e227 = _step298.value;
              t.removeClass(mu, _e227);
            }
          } catch (err) {
            _didIteratorError298 = true;
            _iteratorError298 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion298 && _iterator298.return != null) {
                _iterator298.return();
              }
            } finally {
              if (_didIteratorError298) {
                throw _iteratorError298;
              }
            }
          }

          this._previouslySelected.clear();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Widget";
        }
      }]);

      return Df;
    }(Md);

    function Lf(t, e) {
      return !!e && Array.from(t.getAncestors()).includes(e);
    }

    var jf =
    /*#__PURE__*/
    function (_Rd12) {
      _inherits(jf, _Rd12);

      function jf() {
        _classCallCheck(this, jf);

        return _possibleConstructorReturn(this, _getPrototypeOf(jf).apply(this, arguments));
      }

      _createClass(jf, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = xu(t), xu(t) && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document.selection.getSelectedElement();
          e.change(function (e) {
            e.setAttribute("alt", t.newValue, n);
          });
        }
      }]);

      return jf;
    }(Rd);

    var Vf =
    /*#__PURE__*/
    function (_Md27) {
      _inherits(Vf, _Md27);

      function Vf() {
        _classCallCheck(this, Vf);

        return _possibleConstructorReturn(this, _getPrototypeOf(Vf).apply(this, arguments));
      }

      _createClass(Vf, [{
        key: "init",
        value: function init() {
          this.editor.commands.add("imageTextAlternative", new jf(this.editor));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeEditing";
        }
      }]);

      return Vf;
    }(Md);

    n(49);

    var zf =
    /*#__PURE__*/
    function (_Wl16) {
      _inherits(zf, _Wl16);

      function zf(t, e) {
        var _this176;

        _classCallCheck(this, zf);

        _this176 = _possibleConstructorReturn(this, _getPrototypeOf(zf).call(this, t));
        var n = "ck-input-".concat(Zn()),
            i = "ck-status-".concat(Zn());
        _this176.set("label"), _this176.set("value"), _this176.set("isReadOnly", !1), _this176.set("errorText", null), _this176.set("infoText", null), _this176.labelView = _this176._createLabelView(n), _this176.inputView = _this176._createInputView(e, n, i), _this176.statusView = _this176._createStatusView(i), _this176.bind("_statusText").to(_assertThisInitialized(_this176), "errorText", _assertThisInitialized(_this176), "infoText", function (t, e) {
          return t || e;
        });
        var o = _this176.bindTemplate;

        _this176.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-input", o.if("isReadOnly", "ck-disabled")]
          },
          children: [_this176.labelView, _this176.inputView, _this176.statusView]
        });

        return _this176;
      }

      _createClass(zf, [{
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new $l(this.locale);
          return e.for = t, e.bind("text").to(this, "label"), e;
        }
      }, {
        key: "_createInputView",
        value: function _createInputView(t, e, n) {
          var _this177 = this;

          var i = new t(this.locale, n);
          return i.id = e, i.ariaDescribedById = n, i.bind("value").to(this), i.bind("isReadOnly").to(this), i.bind("hasError").to(this, "errorText", function (t) {
            return !!t;
          }), i.on("input", function () {
            _this177.errorText = null;
          }), i;
        }
      }, {
        key: "_createStatusView",
        value: function _createStatusView(t) {
          var e = new Wl(this.locale),
              n = this.bindTemplate;
          return e.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-input__status", n.if("errorText", "ck-labeled-input__status_error"), n.if("_statusText", "ck-hidden", function (t) {
                return !t;
              })],
              id: t,
              role: n.if("errorText", "alert")
            },
            children: [{
              text: n.to("_statusText")
            }]
          }), e;
        }
      }, {
        key: "select",
        value: function select() {
          this.inputView.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.inputView.focus();
        }
      }]);

      return zf;
    }(Wl);

    n(51);

    var Bf =
    /*#__PURE__*/
    function (_Wl17) {
      _inherits(Bf, _Wl17);

      function Bf(t) {
        var _this178;

        _classCallCheck(this, Bf);

        _this178 = _possibleConstructorReturn(this, _getPrototypeOf(Bf).call(this, t)), _this178.set("value"), _this178.set("id"), _this178.set("placeholder"), _this178.set("isReadOnly", !1), _this178.set("hasError", !1), _this178.set("ariaDescribedById");
        var e = _this178.bindTemplate;

        _this178.setTemplate({
          tag: "input",
          attributes: {
            type: "text",
            class: ["ck", "ck-input", "ck-input-text", e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", !0),
            "aria-describedby": e.to("ariaDescribedById")
          },
          on: {
            input: e.to("input")
          }
        });

        return _this178;
      }

      _createClass(Bf, [{
        key: "render",
        value: function render() {
          var _this179 = this;

          _get(_getPrototypeOf(Bf.prototype), "render", this).call(this);

          var t = function t(_t243) {
            _this179.element.value = _t243 || 0 === _t243 ? _t243 : "";
          };

          t(this.value), this.on("change:value", function (e, n, i) {
            t(i);
          });
        }
      }, {
        key: "select",
        value: function select() {
          this.element.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }]);

      return Bf;
    }(Wl);

    function Ff(_ref102) {
      var t = _ref102.view;
      t.listenTo(t.element, "submit", function (e, n) {
        n.preventDefault(), t.fire("submit");
      }, {
        useCapture: !0
      });
    }

    var Uf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
        Hf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
    n(53);

    var qf =
    /*#__PURE__*/
    function (_Wl18) {
      _inherits(qf, _Wl18);

      function qf(t) {
        var _this180;

        _classCallCheck(this, qf);

        _this180 = _possibleConstructorReturn(this, _getPrototypeOf(qf).call(this, t));
        var e = _this180.locale.t;
        _this180.focusTracker = new ml(), _this180.keystrokes = new sl(), _this180.labeledInput = _this180._createLabeledInputView(), _this180.saveButtonView = _this180._createButton(e("bf"), Uf, "ck-button-save"), _this180.saveButtonView.type = "submit", _this180.cancelButtonView = _this180._createButton(e("bg"), Hf, "ck-button-cancel", "cancel"), _this180._focusables = new Al(), _this180._focusCycler = new td({
          focusables: _this180._focusables,
          focusTracker: _this180.focusTracker,
          keystrokeHandler: _this180.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this180.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form"],
            tabindex: "-1"
          },
          children: [_this180.labeledInput, _this180.saveButtonView, _this180.cancelButtonView]
        });
        return _this180;
      }

      _createClass(qf, [{
        key: "render",
        value: function render() {
          var _this181 = this;

          _get(_getPrototypeOf(qf.prototype), "render", this).call(this), this.keystrokes.listenTo(this.element), Ff({
            view: this
          }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this181._focusables.add(t), _this181.focusTracker.add(t.element);
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new ud(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "_createLabeledInputView",
        value: function _createLabeledInputView() {
          var t = this.locale.t,
              e = new zf(this.locale, Bf);
          return e.label = t("cd"), e.inputView.placeholder = t("cd"), e;
        }
      }]);

      return qf;
    }(Wl);

    n(55);
    var Wf = Jl("px"),
        Yf = ir.document.body;

    var $f =
    /*#__PURE__*/
    function (_Wl19) {
      _inherits($f, _Wl19);

      function $f(t) {
        var _this182;

        _classCallCheck(this, $f);

        _this182 = _possibleConstructorReturn(this, _getPrototypeOf($f).call(this, t));
        var e = _this182.bindTemplate;
        _this182.set("top", 0), _this182.set("left", 0), _this182.set("position", "arrow_nw"), _this182.set("isVisible", !1), _this182.set("withArrow", !0), _this182.set("class"), _this182.content = _this182.createCollection(), _this182.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", e.to("position", function (t) {
              return "ck-balloon-panel_".concat(t);
            }), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
            style: {
              top: e.to("top", Wf),
              left: e.to("left", Wf)
            }
          },
          children: _this182.content
        });
        return _this182;
      }

      _createClass($f, [{
        key: "show",
        value: function show() {
          this.isVisible = !0;
        }
      }, {
        key: "hide",
        value: function hide() {
          this.isVisible = !1;
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          this.show();

          var e = $f.defaultPositions,
              n = Object.assign({}, {
            element: this.element,
            positions: [e.southArrowNorth, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthWest, e.northArrowSouthEast],
            limiter: Yf,
            fitInViewport: !0
          }, t),
              i = $f._getOptimalPosition(n),
              o = parseInt(i.left),
              r = parseInt(i.top),
              s = i.name;

          Object.assign(this, {
            top: r,
            left: o,
            position: s
          });
        }
      }, {
        key: "pin",
        value: function pin(t) {
          var _this183 = this;

          this.unpin(), this._pinWhenIsVisibleCallback = function () {
            _this183.isVisible ? _this183._startPinning(t) : _this183._stopPinning();
          }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
      }, {
        key: "unpin",
        value: function unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
      }, {
        key: "_startPinning",
        value: function _startPinning(t) {
          var _this184 = this;

          this.attachTo(t);
          var e = Gf(t.target),
              n = t.limiter ? Gf(t.limiter) : Yf;
          this.listenTo(ir.document, "scroll", function (i, o) {
            var r = o.target,
                s = e && r.contains(e),
                a = n && r.contains(n);
            !s && !a && e && n || _this184.attachTo(t);
          }, {
            useCapture: !0
          }), this.listenTo(ir.window, "resize", function () {
            _this184.attachTo(t);
          });
        }
      }, {
        key: "_stopPinning",
        value: function _stopPinning() {
          this.stopListening(ir.document, "scroll"), this.stopListening(ir.window, "resize");
        }
      }]);

      return $f;
    }(Wl);

    function Gf(t) {
      return Yn(t) ? t : As(t) ? t.commonAncestorContainer : "function" == typeof t ? Gf(t()) : null;
    }

    function Qf(t, e) {
      return t.top - e.height - $f.arrowVerticalOffset;
    }

    function Kf(t) {
      return t.bottom + $f.arrowVerticalOffset;
    }

    $f.arrowHorizontalOffset = 25, $f.arrowVerticalOffset = 10, $f._getOptimalPosition = sd, $f.defaultPositions = {
      northArrowSouth: function northArrowSouth(t, e) {
        return {
          top: Qf(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s"
        };
      },
      northArrowSouthEast: function northArrowSouthEast(t, e) {
        return {
          top: Qf(t, e),
          left: t.left + t.width / 2 - e.width + $f.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northArrowSouthWest: function northArrowSouthWest(t, e) {
        return {
          top: Qf(t, e),
          left: t.left + t.width / 2 - $f.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouth: function northWestArrowSouth(t, e) {
        return {
          top: Qf(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s"
        };
      },
      northWestArrowSouthWest: function northWestArrowSouthWest(t, e) {
        return {
          top: Qf(t, e),
          left: t.left - $f.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouthEast: function northWestArrowSouthEast(t, e) {
        return {
          top: Qf(t, e),
          left: t.left - e.width + $f.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouth: function northEastArrowSouth(t, e) {
        return {
          top: Qf(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s"
        };
      },
      northEastArrowSouthEast: function northEastArrowSouthEast(t, e) {
        return {
          top: Qf(t, e),
          left: t.right - e.width + $f.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouthWest: function northEastArrowSouthWest(t, e) {
        return {
          top: Qf(t, e),
          left: t.right - $f.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      southArrowNorth: function southArrowNorth(t, e) {
        return {
          top: Kf(t),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n"
        };
      },
      southArrowNorthEast: function southArrowNorthEast(t, e) {
        return {
          top: Kf(t),
          left: t.left + t.width / 2 - e.width + $f.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southArrowNorthWest: function southArrowNorthWest(t, e) {
        return {
          top: Kf(t),
          left: t.left + t.width / 2 - $f.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorth: function southWestArrowNorth(t, e) {
        return {
          top: Kf(t),
          left: t.left - e.width / 2,
          name: "arrow_n"
        };
      },
      southWestArrowNorthWest: function southWestArrowNorthWest(t, e) {
        return {
          top: Kf(t),
          left: t.left - $f.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorthEast: function southWestArrowNorthEast(t, e) {
        return {
          top: Kf(t),
          left: t.left - e.width + $f.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorth: function southEastArrowNorth(t, e) {
        return {
          top: Kf(t),
          left: t.right - e.width / 2,
          name: "arrow_n"
        };
      },
      southEastArrowNorthEast: function southEastArrowNorthEast(t, e) {
        return {
          top: Kf(t),
          left: t.right - e.width + $f.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorthWest: function southEastArrowNorthWest(t, e) {
        return {
          top: Kf(t),
          left: t.right - $f.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      }
    };
    var Jf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z" /></svg>\n',
        Zf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>\n';
    n(57), n(59);
    var Xf = Jl("px");

    var tg =
    /*#__PURE__*/
    function (_Md28) {
      _inherits(tg, _Md28);

      _createClass(tg, null, [{
        key: "pluginName",
        get: function get() {
          return "ContextualBalloon";
        }
      }]);

      function tg(t) {
        var _this185;

        _classCallCheck(this, tg);

        _this185 = _possibleConstructorReturn(this, _getPrototypeOf(tg).call(this, t)), _this185.positionLimiter = function () {
          var t = _this185.editor.editing.view,
              e = t.document.selection.editableElement;
          return e ? t.domConverter.mapViewToDom(e.root) : null;
        }, _this185.set("visibleView", null), _this185.view = new $f(t.locale), t.ui.view.body.add(_this185.view), t.ui.focusTracker.add(_this185.view.element), _this185._viewToStack = new Map(), _this185._idToStack = new Map(), _this185.set("_numberOfStacks", 0), _this185.set("_singleViewMode", !1), _this185._rotatorView = _this185._createRotatorView(), _this185._fakePanelsView = _this185._createFakePanelsView();
        return _this185;
      }

      _createClass(tg, [{
        key: "hasView",
        value: function hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t);
        }
      }, {
        key: "add",
        value: function add(t) {
          if (this.hasView(t.view)) throw new Qn.b("contextualballoon-add-view-exist: Cannot add configuration of the same view twice.", [this, t]);
          var e = t.stackId || "main";
          if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));

          var n = this._idToStack.get(e);

          t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          if (!this.hasView(t)) throw new Qn.b("contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.", [this, t]);

          var e = this._viewToStack.get(t);

          this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
        }
      }, {
        key: "updatePosition",
        value: function updatePosition(t) {
          t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
      }, {
        key: "showStack",
        value: function showStack(t) {
          this.visibleStack = t;

          var e = this._idToStack.get(t);

          if (!e) throw new Qn.b("contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.", this);
          this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
        }
      }, {
        key: "_getStackId",
        value: function _getStackId(t) {
          return Array.from(this._idToStack.entries()).find(function (e) {
            return e[1] === t;
          })[0];
        }
      }, {
        key: "_showNextStack",
        value: function _showNextStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) + 1;
          t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_showPrevStack",
        value: function _showPrevStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) - 1;
          t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_createRotatorView",
        value: function _createRotatorView() {
          var _this186 = this;

          var t = new eg(this.editor.locale),
              e = this.editor.locale.t;
          return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t > 1;
          }), t.on("change:isNavigationVisible", function () {
            return _this186.updatePosition();
          }, {
            priority: "low"
          }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (t, n) {
            if (n < 2) return "";
            var i = Array.from(_this186._idToStack.values()).indexOf(_this186._visibleStack) + 1;
            return e("bn", [i, n]);
          }), t.buttonNextView.on("execute", function () {
            t.focusTracker.isFocused && _this186.editor.editing.view.focus(), _this186._showNextStack();
          }), t.buttonPrevView.on("execute", function () {
            t.focusTracker.isFocused && _this186.editor.editing.view.focus(), _this186._showPrevStack();
          }), t;
        }
      }, {
        key: "_createFakePanelsView",
        value: function _createFakePanelsView() {
          var t = new ng(this.editor.locale, this.view);
          return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t >= 2 ? Math.min(t - 1, 2) : 0;
          }), t.listenTo(this.view, "change:top", function () {
            return t.updatePosition();
          }), t.listenTo(this.view, "change:left", function () {
            return t.updatePosition();
          }), this.editor.ui.view.body.add(t), t;
        }
      }, {
        key: "_showView",
        value: function _showView(_ref103) {
          var t = _ref103.view,
              _ref103$balloonClassN = _ref103.balloonClassName,
              e = _ref103$balloonClassN === void 0 ? "" : _ref103$balloonClassN,
              _ref103$withArrow = _ref103.withArrow,
              n = _ref103$withArrow === void 0 ? !0 : _ref103$withArrow,
              _ref103$singleViewMod = _ref103.singleViewMode,
              i = _ref103$singleViewMod === void 0 ? !1 : _ref103$singleViewMod;
          this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
        }
      }, {
        key: "_getBalloonPosition",
        value: function _getBalloonPosition() {
          var t = Array.from(this._visibleStack.values()).pop().position;
          return t && !t.limiter && (t = Object.assign({}, t, {
            limiter: this.positionLimiter
          })), t;
        }
      }, {
        key: "_visibleStack",
        get: function get() {
          return this._viewToStack.get(this.visibleView);
        }
      }]);

      return tg;
    }(Md);

    var eg =
    /*#__PURE__*/
    function (_Wl20) {
      _inherits(eg, _Wl20);

      function eg(t) {
        var _this187;

        _classCallCheck(this, eg);

        _this187 = _possibleConstructorReturn(this, _getPrototypeOf(eg).call(this, t));
        var e = t.t,
            n = _this187.bindTemplate;
        _this187.set("isNavigationVisible", !0), _this187.focusTracker = new ml(), _this187.buttonPrevView = _this187._createButtonView(e("bo"), Jf), _this187.buttonNextView = _this187._createButtonView(e("bp"), Zf), _this187.content = _this187.createCollection(), _this187.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", function (t) {
                return t ? "" : "ck-hidden";
              })]
            },
            children: [_this187.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, _this187.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: _this187.content
          }]
        });
        return _this187;
      }

      _createClass(eg, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(eg.prototype), "render", this).call(this), this.focusTracker.add(this.element);
        }
      }, {
        key: "showView",
        value: function showView(t) {
          this.hideView(), this.content.add(t);
        }
      }, {
        key: "hideView",
        value: function hideView() {
          this.content.clear();
        }
      }, {
        key: "_createButtonView",
        value: function _createButtonView(t, e) {
          var n = new ud(this.locale);
          return n.set({
            label: t,
            icon: e,
            tooltip: !0
          }), n;
        }
      }]);

      return eg;
    }(Wl);

    var ng =
    /*#__PURE__*/
    function (_Wl21) {
      _inherits(ng, _Wl21);

      function ng(t, e) {
        var _this188;

        _classCallCheck(this, ng);

        _this188 = _possibleConstructorReturn(this, _getPrototypeOf(ng).call(this, t));
        var n = _this188.bindTemplate;
        _this188.set("top", 0), _this188.set("left", 0), _this188.set("height", 0), _this188.set("width", 0), _this188.set("numberOfPanels", 0), _this188.content = _this188.createCollection(), _this188._balloonPanelView = e, _this188.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", function (t) {
              return t ? "" : "ck-hidden";
            })],
            style: {
              top: n.to("top", Xf),
              left: n.to("left", Xf),
              width: n.to("width", Xf),
              height: n.to("height", Xf)
            }
          },
          children: _this188.content
        }), _this188.on("change:numberOfPanels", function (t, e, n, i) {
          n > i ? _this188._addPanels(n - i) : _this188._removePanels(i - n), _this188.updatePosition();
        });
        return _this188;
      }

      _createClass(ng, [{
        key: "_addPanels",
        value: function _addPanels(t) {
          for (; t--;) {
            var _t244 = new Wl();

            _t244.setTemplate({
              tag: "div"
            }), this.content.add(_t244), this.registerChild(_t244);
          }
        }
      }, {
        key: "_removePanels",
        value: function _removePanels(t) {
          for (; t--;) {
            var _t245 = this.content.last;
            this.content.remove(_t245), this.deregisterChild(_t245), _t245.destroy();
          }
        }
      }, {
        key: "updatePosition",
        value: function updatePosition() {
          if (this.numberOfPanels) {
            var _this$_balloonPanelVi = this._balloonPanelView,
                _t246 = _this$_balloonPanelVi.top,
                _e228 = _this$_balloonPanelVi.left,
                _ref104 = new Ps(this._balloonPanelView.element),
                _n204 = _ref104.width,
                _i165 = _ref104.height;

            Object.assign(this, {
              top: _t246,
              left: _e228,
              width: _n204,
              height: _i165
            });
          }
        }
      }]);

      return ng;
    }(Wl);

    var ig = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';

    function og(t) {
      var e = t.editing.view,
          n = $f.defaultPositions;
      return {
        target: e.domConverter.viewToDom(e.document.selection.getSelectedElement()),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast]
      };
    }

    var rg =
    /*#__PURE__*/
    function (_Md29) {
      _inherits(rg, _Md29);

      function rg() {
        _classCallCheck(this, rg);

        return _possibleConstructorReturn(this, _getPrototypeOf(rg).apply(this, arguments));
      }

      _createClass(rg, [{
        key: "init",
        value: function init() {
          this._createButton(), this._createForm();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(rg.prototype), "destroy", this).call(this), this._form.destroy();
        }
      }, {
        key: "_createButton",
        value: function _createButton() {
          var _this189 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("imageTextAlternative", function (n) {
            var i = t.commands.get("imageTextAlternative"),
                o = new ud(n);
            return o.set({
              label: e("bv"),
              icon: ig,
              tooltip: !0
            }), o.bind("isEnabled").to(i, "isEnabled"), _this189.listenTo(o, "execute", function () {
              return _this189._showForm();
            }), o;
          });
        }
      }, {
        key: "_createForm",
        value: function _createForm() {
          var _this190 = this;

          var t = this.editor,
              e = t.editing.view.document;
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new qf(t.locale), this._form.render(), this.listenTo(this._form, "submit", function () {
            t.execute("imageTextAlternative", {
              newValue: _this190._form.labeledInput.inputView.element.value
            }), _this190._hideForm(!0);
          }), this.listenTo(this._form, "cancel", function () {
            _this190._hideForm(!0);
          }), this._form.keystrokes.set("Esc", function (t, e) {
            _this190._hideForm(!0), e();
          }), this.listenTo(t.ui, "update", function () {
            yu(e.selection) ? _this190._isVisible && function (t) {
              var e = t.plugins.get("ContextualBalloon");

              if (yu(t.editing.view.document.selection)) {
                var _n205 = og(t);

                e.updatePosition(_n205);
              }
            }(t) : _this190._hideForm(!0);
          }), kd({
            emitter: this._form,
            activator: function activator() {
              return _this190._isVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this190._hideForm();
            }
          });
        }
      }, {
        key: "_showForm",
        value: function _showForm() {
          if (this._isVisible) return;
          var t = this.editor,
              e = t.commands.get("imageTextAlternative"),
              n = this._form.labeledInput;
          this._isInBalloon || this._balloon.add({
            view: this._form,
            position: og(t)
          }), n.value = n.inputView.element.value = e.value || "", this._form.labeledInput.select();
        }
      }, {
        key: "_hideForm",
        value: function _hideForm(t) {
          this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
        }
      }, {
        key: "_isVisible",
        get: function get() {
          return this._balloon.visibleView === this._form;
        }
      }, {
        key: "_isInBalloon",
        get: function get() {
          return this._balloon.hasView(this._form);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [tg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeUI";
        }
      }]);

      return rg;
    }(Md);

    var sg =
    /*#__PURE__*/
    function (_Md30) {
      _inherits(sg, _Md30);

      function sg() {
        _classCallCheck(this, sg);

        return _possibleConstructorReturn(this, _getPrototypeOf(sg).apply(this, arguments));
      }

      _createClass(sg, null, [{
        key: "requires",
        get: function get() {
          return [Vf, rg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternative";
        }
      }]);

      return sg;
    }(Md);

    n(61);

    var ag =
    /*#__PURE__*/
    function (_Md31) {
      _inherits(ag, _Md31);

      function ag() {
        _classCallCheck(this, ag);

        return _possibleConstructorReturn(this, _getPrototypeOf(ag).apply(this, arguments));
      }

      _createClass(ag, null, [{
        key: "requires",
        get: function get() {
          return [Pu, Df, sg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Image";
        }
      }]);

      return ag;
    }(Md);

    var cg =
    /*#__PURE__*/
    function (_Wl22) {
      _inherits(cg, _Wl22);

      function cg(t) {
        var _this191;

        _classCallCheck(this, cg);

        _this191 = _possibleConstructorReturn(this, _getPrototypeOf(cg).call(this, t)), _this191.buttonView = new ud(t), _this191._fileInputView = new lg(t), _this191._fileInputView.bind("acceptedType").to(_assertThisInitialized(_this191)), _this191._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_this191)), _this191._fileInputView.delegate("done").to(_assertThisInitialized(_this191)), _this191.setTemplate({
          tag: "span",
          attributes: {
            class: "ck-file-dialog-button"
          },
          children: [_this191.buttonView, _this191._fileInputView]
        }), _this191.buttonView.on("execute", function () {
          _this191._fileInputView.open();
        });
        return _this191;
      }

      _createClass(cg, [{
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);

      return cg;
    }(Wl);

    var lg =
    /*#__PURE__*/
    function (_Wl23) {
      _inherits(lg, _Wl23);

      function lg(t) {
        var _this192;

        _classCallCheck(this, lg);

        _this192 = _possibleConstructorReturn(this, _getPrototypeOf(lg).call(this, t)), _this192.set("acceptedType"), _this192.set("allowMultipleFiles", !1);
        var e = _this192.bindTemplate;

        _this192.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(function () {
              _this192.element && _this192.element.files && _this192.element.files.length && _this192.fire("done", _this192.element.files), _this192.element.value = "";
            })
          }
        });

        return _this192;
      }

      _createClass(lg, [{
        key: "open",
        value: function open() {
          this.element.click();
        }
      }]);

      return lg;
    }(Wl);

    var dg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';

    function hg(t) {
      var e = t.map(function (t) {
        return t.replace("+", "\\+");
      });
      return new RegExp("^image\\/(".concat(e.join("|"), ")$"));
    }

    function ug(t) {
      return new Promise(function (e, n) {
        var i = t.getAttribute("src");
        fetch(i).then(function (t) {
          return t.blob();
        }).then(function (t) {
          var o = function (t, e) {
            return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
          }(t, i),
              r = function (t, e, n) {
            try {
              return new File([t], e, {
                type: n
              });
            } catch (t) {
              return null;
            }
          }(t, "image.".concat(o.replace("image/", "")), o);

          r ? e(r) : n();
        }).catch(n);
      });
    }

    var fg =
    /*#__PURE__*/
    function (_Md32) {
      _inherits(fg, _Md32);

      function fg() {
        _classCallCheck(this, fg);

        return _possibleConstructorReturn(this, _getPrototypeOf(fg).apply(this, arguments));
      }

      _createClass(fg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("imageUpload", function (n) {
            var i = new cg(n),
                o = t.commands.get("imageUpload"),
                r = t.config.get("image.upload.types"),
                s = hg(r);
            return i.set({
              acceptedType: r.map(function (t) {
                return "image/".concat(t);
              }).join(","),
              allowMultipleFiles: !0
            }), i.buttonView.set({
              label: e("j"),
              icon: dg,
              tooltip: !0
            }), i.buttonView.bind("isEnabled").to(o), i.on("done", function (e, n) {
              var i = Array.from(n).filter(function (t) {
                return s.test(t.type);
              });
              i.length && t.execute("imageUpload", {
                file: i
              });
            }), i;
          });
        }
      }]);

      return fg;
    }(Md);

    var gg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
    n(63), n(65), n(67);

    var mg =
    /*#__PURE__*/
    function (_Md33) {
      _inherits(mg, _Md33);

      function mg(t) {
        var _this193;

        _classCallCheck(this, mg);

        _this193 = _possibleConstructorReturn(this, _getPrototypeOf(mg).call(this, t)), _this193.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent(gg);
        return _this193;
      }

      _createClass(mg, [{
        key: "init",
        value: function init() {
          var _this194 = this;

          this.editor.editing.downcastDispatcher.on("attribute:uploadStatus:image", function () {
            return _this194.uploadStatusChange.apply(_this194, arguments);
          });
        }
      }, {
        key: "uploadStatusChange",
        value: function uploadStatusChange(t, e, n) {
          var i = this.editor,
              o = e.item,
              r = o.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) return;
          var s = i.plugins.get(Sh),
              a = r ? e.attributeNewValue : null,
              c = this.placeholder,
              l = i.editing.mapper.toViewElement(o),
              d = n.writer;
          if ("reading" == a) return pg(l, d), void bg(c, l, d);

          if ("uploading" == a) {
            var _t247 = s.loaders.get(r);

            return pg(l, d), void (_t247 ? (wg(l, d), function (t, e, n, i) {
              var o = function (t) {
                var e = t.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return t.setCustomProperty("progressBar", !0, e), e;
              }(e);

              e.insert(e.createPositionAt(t, "end"), o), n.on("change:uploadedPercent", function (t, e, n) {
                i.change(function (t) {
                  t.setStyle("width", n + "%", o);
                });
              });
            }(l, d, _t247, i.editing.view), function (t, e, n) {
              if (n.data) {
                var _i166 = t.getChild(0);

                e.setAttribute("src", n.data, _i166);
              }
            }(l, d, _t247)) : bg(c, l, d));
          }

          "complete" == a && s.loaders.get(r) && !mo.isEdge && function (t, e, n) {
            var i = e.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            e.insert(e.createPositionAt(t, "end"), i), setTimeout(function () {
              n.change(function (t) {
                return t.remove(t.createRangeOn(i));
              });
            }, 3e3);
          }(l, d, i.editing.view), function (t, e) {
            _g(t, e, "progressBar");
          }(l, d), wg(l, d), function (t, e) {
            e.removeClass("ck-appear", t);
          }(l, d);
        }
      }]);

      return mg;
    }(Md);

    function pg(t, e) {
      t.hasClass("ck-appear") || e.addClass("ck-appear", t);
    }

    function bg(t, e, n) {
      e.hasClass("ck-image-upload-placeholder") || n.addClass("ck-image-upload-placeholder", e);
      var i = e.getChild(0);
      i.getAttribute("src") !== t && n.setAttribute("src", t, i), kg(e, "placeholder") || n.insert(n.createPositionAfter(i), function (t) {
        var e = t.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return t.setCustomProperty("placeholder", !0, e), e;
      }(n));
    }

    function wg(t, e) {
      t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), _g(t, e, "placeholder");
    }

    function kg(t, e) {
      var _iteratorNormalCompletion299 = true;
      var _didIteratorError299 = false;
      var _iteratorError299 = undefined;

      try {
        for (var _iterator299 = t.getChildren()[Symbol.iterator](), _step299; !(_iteratorNormalCompletion299 = (_step299 = _iterator299.next()).done); _iteratorNormalCompletion299 = true) {
          var _n206 = _step299.value;
          if (_n206.getCustomProperty(e)) return _n206;
        }
      } catch (err) {
        _didIteratorError299 = true;
        _iteratorError299 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion299 && _iterator299.return != null) {
            _iterator299.return();
          }
        } finally {
          if (_didIteratorError299) {
            throw _iteratorError299;
          }
        }
      }
    }

    function _g(t, e, n) {
      var i = kg(t, n);
      i && e.remove(e.createRangeOn(i));
    }

    var vg =
    /*#__PURE__*/
    function () {
      function vg() {
        _classCallCheck(this, vg);
      }

      _createClass(vg, [{
        key: "createDocumentFragment",
        value: function createDocumentFragment(t) {
          return new Co(t);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e, n) {
          return new _i(t, e, n);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new gi(t);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t._clone(e);
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, e) {
          return e._appendChild(t);
        }
      }, {
        key: "insertChild",
        value: function insertChild(t, e, n) {
          return n._insertChild(t, e);
        }
      }, {
        key: "removeChildren",
        value: function removeChildren(t, e, n) {
          return n._removeChildren(t, e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t.parent;
          return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
        }
      }, {
        key: "replace",
        value: function replace(t, e) {
          var n = t.parent;

          if (n) {
            var _i167 = n.getChildIndex(t);

            return this.removeChildren(_i167, 1, n), this.insertChild(_i167, e, n), !0;
          }

          return !1;
        }
      }, {
        key: "unwrapElement",
        value: function unwrapElement(t) {
          var e = t.parent;

          if (e) {
            var _n207 = e.getChildIndex(t);

            this.remove(t), this.insertChild(_n207, t.getChildren(), e);
          }
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new _i(t, e.getAttributes(), e.getChildren());
          return this.replace(e, n) ? n : null;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          T(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Xi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Xi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Xi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new to(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return to._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return to._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new io(t, e, n);
        }
      }]);

      return vg;
    }();

    var yg =
    /*#__PURE__*/
    function (_Rd13) {
      _inherits(yg, _Rd13);

      function yg() {
        _classCallCheck(this, yg);

        return _possibleConstructorReturn(this, _getPrototypeOf(yg).apply(this, arguments));
      }

      _createClass(yg, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = Tu(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor,
              n = e.model,
              i = e.plugins.get(Sh);
          n.change(function (e) {
            var o = Array.isArray(t.file) ? t.file : [t.file];
            var _iteratorNormalCompletion300 = true;
            var _didIteratorError300 = false;
            var _iteratorError300 = undefined;

            try {
              for (var _iterator300 = o[Symbol.iterator](), _step300; !(_iteratorNormalCompletion300 = (_step300 = _iterator300.next()).done); _iteratorNormalCompletion300 = true) {
                var _t248 = _step300.value;
                xg(e, n, i, _t248);
              }
            } catch (err) {
              _didIteratorError300 = true;
              _iteratorError300 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion300 && _iterator300.return != null) {
                  _iterator300.return();
                }
              } finally {
                if (_didIteratorError300) {
                  throw _iteratorError300;
                }
              }
            }
          });
        }
      }]);

      return yg;
    }(Rd);

    function xg(t, e, n, i) {
      var o = n.createLoader(i);
      o && Au(t, e, {
        uploadId: o.id
      });
    }

    var Ag =
    /*#__PURE__*/
    function (_Md34) {
      _inherits(Ag, _Md34);

      _createClass(Ag, null, [{
        key: "requires",
        get: function get() {
          return [Sh, vf, Od];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageUploadEditing";
        }
      }]);

      function Ag(t) {
        var _this195;

        _classCallCheck(this, Ag);

        _this195 = _possibleConstructorReturn(this, _getPrototypeOf(Ag).call(this, t)), t.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        });
        return _this195;
      }

      _createClass(Ag, [{
        key: "init",
        value: function init() {
          var _this196 = this;

          var t = this.editor,
              e = t.model.document,
              n = t.model.schema,
              i = t.conversion,
              o = t.plugins.get(Sh),
              r = hg(t.config.get("image.upload.types"));
          n.extend("image", {
            allowAttributes: ["uploadId", "uploadStatus"]
          }), t.commands.add("imageUpload", new yg(t)), i.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "uploadId"
            },
            model: "uploadId"
          }), this.listenTo(t.editing.view.document, "clipboardInput", function (e, n) {
            if (function (t) {
              return Array.from(t.types).includes("text/html") && "" !== t.getData("text/html");
            }(n.dataTransfer)) return;
            var i = Array.from(n.dataTransfer.files).filter(function (t) {
              return !!t && r.test(t.type);
            }),
                o = n.targetRanges.map(function (e) {
              return t.editing.mapper.toModelRange(e);
            });
            t.model.change(function (n) {
              n.setSelection(o), i.length && (e.stop(), t.model.enqueueChange("default", function () {
                t.execute("imageUpload", {
                  file: i
                });
              }));
            });
          }), this.listenTo(t.plugins.get(Od), "inputTransformation", function (e, n) {
            var i = Array.from(t.editing.view.createRangeIn(n.content)).filter(function (t) {
              return function (t) {
                return !(!t.is("element", "img") || !t.getAttribute("src")) && (t.getAttribute("src").match(/^data:image\/\w+;base64,/g) || t.getAttribute("src").match(/^blob:/g));
              }(t.item) && !t.item.getAttribute("uploadProcessed");
            }).map(function (t) {
              return {
                promise: ug(t.item),
                imageElement: t.item
              };
            });
            if (!i.length) return;
            var r = new vg();
            var _iteratorNormalCompletion301 = true;
            var _didIteratorError301 = false;
            var _iteratorError301 = undefined;

            try {
              for (var _iterator301 = i[Symbol.iterator](), _step301; !(_iteratorNormalCompletion301 = (_step301 = _iterator301.next()).done); _iteratorNormalCompletion301 = true) {
                var _t249 = _step301.value;
                r.setAttribute("uploadProcessed", !0, _t249.imageElement);

                var _e229 = o.createLoader(_t249.promise);

                _e229 && (r.setAttribute("src", "", _t249.imageElement), r.setAttribute("uploadId", _e229.id, _t249.imageElement));
              }
            } catch (err) {
              _didIteratorError301 = true;
              _iteratorError301 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion301 && _iterator301.return != null) {
                  _iterator301.return();
                }
              } finally {
                if (_didIteratorError301) {
                  throw _iteratorError301;
                }
              }
            }
          }), t.editing.view.document.on("dragover", function (t, e) {
            e.preventDefault();
          }), e.on("change", function () {
            var n = e.differ.getChanges({
              includeChangesInGraveyard: !0
            });
            var _iteratorNormalCompletion302 = true;
            var _didIteratorError302 = false;
            var _iteratorError302 = undefined;

            try {
              for (var _iterator302 = n[Symbol.iterator](), _step302; !(_iteratorNormalCompletion302 = (_step302 = _iterator302.next()).done); _iteratorNormalCompletion302 = true) {
                var _e230 = _step302.value;

                if ("insert" == _e230.type && "$text" != _e230.name) {
                  var _n208 = _e230.position.nodeAfter,
                      _i168 = "$graveyard" == _e230.position.root.rootName;

                  var _iteratorNormalCompletion303 = true;
                  var _didIteratorError303 = false;
                  var _iteratorError303 = undefined;

                  try {
                    for (var _iterator303 = Tg(t, _n208)[Symbol.iterator](), _step303; !(_iteratorNormalCompletion303 = (_step303 = _iterator303.next()).done); _iteratorNormalCompletion303 = true) {
                      var _e231 = _step303.value;

                      var _t250 = _e231.getAttribute("uploadId");

                      if (!_t250) continue;

                      var _n209 = o.loaders.get(_t250);

                      _n209 && (_i168 ? _n209.abort() : "idle" == _n209.status && _this196._readAndUpload(_n209, _e231));
                    }
                  } catch (err) {
                    _didIteratorError303 = true;
                    _iteratorError303 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion303 && _iterator303.return != null) {
                        _iterator303.return();
                      }
                    } finally {
                      if (_didIteratorError303) {
                        throw _iteratorError303;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError302 = true;
              _iteratorError302 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion302 && _iterator302.return != null) {
                  _iterator302.return();
                }
              } finally {
                if (_didIteratorError302) {
                  throw _iteratorError302;
                }
              }
            }
          });
        }
      }, {
        key: "_readAndUpload",
        value: function _readAndUpload(t, e) {
          var _this197 = this;

          var n = this.editor,
              i = n.model,
              o = n.locale.t,
              r = n.plugins.get(Sh),
              s = n.plugins.get(vf);
          return i.enqueueChange("transparent", function (t) {
            t.setAttribute("uploadStatus", "reading", e);
          }), t.read().then(function () {
            var o = t.upload();

            if (mo.isSafari) {
              var _t251 = n.editing.mapper.toViewElement(e).getChild(0);

              n.editing.view.once("render", function () {
                if (!_t251.parent) return;
                var e = n.editing.view.domConverter.mapViewToDom(_t251.parent);
                if (!e) return;
                var i = e.style.display;
                e.style.display = "none", e._ckHack = e.offsetHeight, e.style.display = i;
              });
            }

            return i.enqueueChange("transparent", function (t) {
              t.setAttribute("uploadStatus", "uploading", e);
            }), o;
          }).then(function (t) {
            i.enqueueChange("transparent", function (n) {
              n.setAttributes({
                uploadStatus: "complete",
                src: t.default
              }, e), _this197._parseAndSetSrcsetAttributeOnImage(t, e, n);
            }), a();
          }).catch(function (n) {
            if ("error" !== t.status && "aborted" !== t.status) throw n;
            "error" == t.status && n && s.showWarning(n, {
              title: o("an"),
              namespace: "upload"
            }), a(), i.enqueueChange("transparent", function (t) {
              t.remove(e);
            });
          });

          function a() {
            i.enqueueChange("transparent", function (t) {
              t.removeAttribute("uploadId", e), t.removeAttribute("uploadStatus", e);
            }), r.destroyLoader(t);
          }
        }
      }, {
        key: "_parseAndSetSrcsetAttributeOnImage",
        value: function _parseAndSetSrcsetAttributeOnImage(t, e, n) {
          var i = 0;
          var o = Object.keys(t).filter(function (t) {
            var e = parseInt(t, 10);
            if (!isNaN(e)) return i = Math.max(i, e), !0;
          }).map(function (e) {
            return "".concat(t[e], " ").concat(e, "w");
          }).join(", ");
          "" != o && n.setAttribute("srcset", {
            data: o,
            width: i
          }, e);
        }
      }]);

      return Ag;
    }(Md);

    function Tg(t, e) {
      return Array.from(t.model.createRangeOn(e)).filter(function (t) {
        return t.item.is("image");
      }).map(function (t) {
        return t.item;
      });
    }

    var Cg =
    /*#__PURE__*/
    function (_Md35) {
      _inherits(Cg, _Md35);

      function Cg() {
        _classCallCheck(this, Cg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Cg).apply(this, arguments));
      }

      _createClass(Cg, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUpload";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Ag, fg, mg];
        }
      }]);

      return Cg;
    }(Md);

    var Pg =
    /*#__PURE__*/
    function (_Rd14) {
      _inherits(Pg, _Rd14);

      function Pg() {
        _classCallCheck(this, Pg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Pg).apply(this, arguments));
      }

      _createClass(Pg, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = Jh(t.document.selection.getSelectedBlocks());
          this.value = !!e && e.is("paragraph"), this.isEnabled = !!e && Sg(e, t.schema);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document;
          e.change(function (i) {
            var o = (t.selection || n.selection).getSelectedBlocks();
            var _iteratorNormalCompletion304 = true;
            var _didIteratorError304 = false;
            var _iteratorError304 = undefined;

            try {
              for (var _iterator304 = o[Symbol.iterator](), _step304; !(_iteratorNormalCompletion304 = (_step304 = _iterator304.next()).done); _iteratorNormalCompletion304 = true) {
                var _t252 = _step304.value;
                !_t252.is("paragraph") && Sg(_t252, e.schema) && i.rename(_t252, "paragraph");
              }
            } catch (err) {
              _didIteratorError304 = true;
              _iteratorError304 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion304 && _iterator304.return != null) {
                  _iterator304.return();
                }
              } finally {
                if (_didIteratorError304) {
                  throw _iteratorError304;
                }
              }
            }
          });
        }
      }]);

      return Pg;
    }(Rd);

    function Sg(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }

    var Mg =
    /*#__PURE__*/
    function (_Md36) {
      _inherits(Mg, _Md36);

      function Mg() {
        _classCallCheck(this, Mg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Mg).apply(this, arguments));
      }

      _createClass(Mg, [{
        key: "init",
        value: function init() {
          var _this198 = this;

          var t = this.editor,
              e = t.model,
              n = t.data;
          t.commands.add("paragraph", new Pg(t)), e.schema.register("paragraph", {
            inheritAllFrom: "$block"
          }), t.conversion.elementToElement({
            model: "paragraph",
            view: "p"
          }), t.conversion.for("upcast").elementToElement({
            model: function model(t, e) {
              return Mg.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null;
            },
            converterPriority: "low"
          }), n.upcastDispatcher.on("element", function (t, e, n) {
            n.consumable.test(e.viewItem, {
              name: e.viewItem.name
            }) && Ig(e.viewItem, e.modelCursor, n.schema) && Object.assign(e, Eg(e.viewItem, e.modelCursor, n));
          }, {
            priority: "low"
          }), n.upcastDispatcher.on("text", function (t, e, n) {
            e.modelRange || Ig(e.viewItem, e.modelCursor, n.schema) && Object.assign(e, Eg(e.viewItem, e.modelCursor, n));
          }, {
            priority: "lowest"
          }), e.document.registerPostFixer(function (t) {
            return _this198._autoparagraphEmptyRoots(t);
          }), t.data.on("ready", function () {
            e.enqueueChange("transparent", function (t) {
              return _this198._autoparagraphEmptyRoots(t);
            });
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "_autoparagraphEmptyRoots",
        value: function _autoparagraphEmptyRoots(t) {
          var e = this.editor.model;
          var _iteratorNormalCompletion305 = true;
          var _didIteratorError305 = false;
          var _iteratorError305 = undefined;

          try {
            for (var _iterator305 = e.document.getRootNames()[Symbol.iterator](), _step305; !(_iteratorNormalCompletion305 = (_step305 = _iterator305.next()).done); _iteratorNormalCompletion305 = true) {
              var _n210 = _step305.value;

              var _i169 = e.document.getRoot(_n210);

              if (_i169.isEmpty && "$graveyard" != _i169.rootName && e.schema.checkChild(_i169, "paragraph")) return t.insertElement("paragraph", _i169), !0;
            }
          } catch (err) {
            _didIteratorError305 = true;
            _iteratorError305 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion305 && _iterator305.return != null) {
                _iterator305.return();
              }
            } finally {
              if (_didIteratorError305) {
                throw _iteratorError305;
              }
            }
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Paragraph";
        }
      }]);

      return Mg;
    }(Md);

    function Eg(t, e, n) {
      var i = n.writer.createElement("paragraph");
      return n.writer.insert(i, e), n.convertItem(t, n.writer.createPositionAt(i, 0));
    }

    function Ig(t, e, n) {
      var i = n.createContext(e);
      return !!n.checkChild(i, "paragraph") && !!n.checkChild(i.push("paragraph"), t);
    }

    Mg.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td"]);

    var Ng =
    /*#__PURE__*/
    function (_Rd15) {
      _inherits(Ng, _Rd15);

      function Ng(t, e) {
        var _this199;

        _classCallCheck(this, Ng);

        _this199 = _possibleConstructorReturn(this, _getPrototypeOf(Ng).call(this, t)), _this199.modelElements = e;
        return _this199;
      }

      _createClass(Ng, [{
        key: "refresh",
        value: function refresh() {
          var _this200 = this;

          var t = Jh(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(function (e) {
            return Og(t, e, _this200.editor.model.schema);
          });
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document,
              i = t.value;
          e.change(function (t) {
            var o = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return Og(t, i, e.schema);
            });
            var _iteratorNormalCompletion306 = true;
            var _didIteratorError306 = false;
            var _iteratorError306 = undefined;

            try {
              for (var _iterator306 = o[Symbol.iterator](), _step306; !(_iteratorNormalCompletion306 = (_step306 = _iterator306.next()).done); _iteratorNormalCompletion306 = true) {
                var _e232 = _step306.value;
                _e232.is(i) || t.rename(_e232, i);
              }
            } catch (err) {
              _didIteratorError306 = true;
              _iteratorError306 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion306 && _iterator306.return != null) {
                  _iterator306.return();
                }
              } finally {
                if (_didIteratorError306) {
                  throw _iteratorError306;
                }
              }
            }
          });
        }
      }]);

      return Ng;
    }(Rd);

    function Og(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }

    var Rg = "paragraph";

    var Dg =
    /*#__PURE__*/
    function (_Md37) {
      _inherits(Dg, _Md37);

      _createClass(Dg, null, [{
        key: "pluginName",
        get: function get() {
          return "HeadingEditing";
        }
      }]);

      function Dg(t) {
        var _this201;

        _classCallCheck(this, Dg);

        _this201 = _possibleConstructorReturn(this, _getPrototypeOf(Dg).call(this, t)), t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
        return _this201;
      }

      _createClass(Dg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.config.get("heading.options"),
              n = [];
          var _iteratorNormalCompletion307 = true;
          var _didIteratorError307 = false;
          var _iteratorError307 = undefined;

          try {
            for (var _iterator307 = e[Symbol.iterator](), _step307; !(_iteratorNormalCompletion307 = (_step307 = _iterator307.next()).done); _iteratorNormalCompletion307 = true) {
              var _i170 = _step307.value;
              _i170.model !== Rg && (t.model.schema.register(_i170.model, {
                inheritAllFrom: "$block"
              }), t.conversion.elementToElement(_i170), n.push(_i170.model));
            }
          } catch (err) {
            _didIteratorError307 = true;
            _iteratorError307 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion307 && _iterator307.return != null) {
                _iterator307.return();
              }
            } finally {
              if (_didIteratorError307) {
                throw _iteratorError307;
              }
            }
          }

          this._addDefaultH1Conversion(t), t.commands.add("heading", new Ng(t, n));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.commands.get("enter"),
              n = t.config.get("heading.options");
          e && this.listenTo(e, "afterExecute", function (e, i) {
            var o = t.model.document.selection.getFirstPosition().parent;
            n.some(function (t) {
              return o.is(t.model);
            }) && !o.is(Rg) && 0 === o.childCount && i.writer.rename(o, Rg);
          });
        }
      }, {
        key: "_addDefaultH1Conversion",
        value: function _addDefaultH1Conversion(t) {
          t.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: Xn.get("low") + 1
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Mg];
        }
      }]);

      return Dg;
    }(Md);

    var Lg = function Lg(t, e) {
      _classCallCheck(this, Lg);

      e && ji(this, e), t && this.set(t);
    };

    li(Lg, Ui);
    n(10);

    var jg =
    /*#__PURE__*/
    function (_Md38) {
      _inherits(jg, _Md38);

      function jg() {
        _classCallCheck(this, jg);

        return _possibleConstructorReturn(this, _getPrototypeOf(jg).apply(this, arguments));
      }

      _createClass(jg, [{
        key: "init",
        value: function init() {
          var _this202 = this;

          var t = this.editor,
              e = t.t,
              n = function (t) {
            var e = t.t,
                n = {
              Paragraph: e("bw"),
              "Heading 1": e("bx"),
              "Heading 2": e("by"),
              "Heading 3": e("bz"),
              "Heading 4": e("ca"),
              "Heading 5": e("cb"),
              "Heading 6": e("cc")
            };
            return t.config.get("heading.options").map(function (t) {
              var e = n[t.title];
              return e && e != t.title && (t.title = e), t;
            });
          }(t),
              i = e("e"),
              o = e("f");

          t.ui.componentFactory.add("heading", function (e) {
            var r = {},
                s = new ro(),
                a = t.commands.get("heading"),
                c = t.commands.get("paragraph"),
                l = [a];
            var _iteratorNormalCompletion308 = true;
            var _didIteratorError308 = false;
            var _iteratorError308 = undefined;

            try {
              var _loop7 = function _loop7() {
                var t = _step308.value;
                var e = {
                  type: "button",
                  model: new Lg({
                    label: t.title,
                    class: t.class,
                    withText: !0
                  })
                };
                "paragraph" === t.model ? (e.model.bind("isOn").to(c, "value"), e.model.set("commandName", "paragraph"), l.push(c)) : (e.model.bind("isOn").to(a, "value", function (e) {
                  return e === t.model;
                }), e.model.set({
                  commandName: "heading",
                  commandValue: t.model
                })), s.add(e), r[t.model] = t.title;
              };

              for (var _iterator308 = n[Symbol.iterator](), _step308; !(_iteratorNormalCompletion308 = (_step308 = _iterator308.next()).done); _iteratorNormalCompletion308 = true) {
                _loop7();
              }
            } catch (err) {
              _didIteratorError308 = true;
              _iteratorError308 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion308 && _iterator308.return != null) {
                  _iterator308.return();
                }
              } finally {
                if (_didIteratorError308) {
                  throw _iteratorError308;
                }
              }
            }

            var d = _d(e);

            return vd(d, s), d.buttonView.set({
              isOn: !1,
              withText: !0,
              tooltip: o
            }), d.extendTemplate({
              attributes: {
                class: ["ck-heading-dropdown"]
              }
            }), d.bind("isEnabled").toMany(l, "isEnabled", function () {
              for (var _len18 = arguments.length, t = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
                t[_key18] = arguments[_key18];
              }

              return t.some(function (t) {
                return t;
              });
            }), d.buttonView.bind("label").to(a, "value", c, "value", function (t, e) {
              var n = t || e && "paragraph";
              return r[n] ? r[n] : i;
            }), _this202.listenTo(d, "execute", function (e) {
              t.execute(e.source.commandName, e.source.commandValue ? {
                value: e.source.commandValue
              } : void 0), t.editing.view.focus();
            }), d;
          });
        }
      }]);

      return jg;
    }(Md);

    function Vg(t) {
      var _iteratorNormalCompletion309 = true;
      var _didIteratorError309 = false;
      var _iteratorError309 = undefined;

      try {
        for (var _iterator309 = t.getChildren()[Symbol.iterator](), _step309; !(_iteratorNormalCompletion309 = (_step309 = _iterator309.next()).done); _iteratorNormalCompletion309 = true) {
          var _e233 = _step309.value;
          if (_e233 && _e233.is("caption")) return _e233;
        }
      } catch (err) {
        _didIteratorError309 = true;
        _iteratorError309 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion309 && _iterator309.return != null) {
            _iterator309.return();
          }
        } finally {
          if (_didIteratorError309) {
            throw _iteratorError309;
          }
        }
      }

      return null;
    }

    function zg(t) {
      var e = t.parent;
      return "figcaption" == t.name && e && "figure" == e.name && e.hasClass("image") ? {
        name: !0
      } : null;
    }

    var Bg =
    /*#__PURE__*/
    function (_Md39) {
      _inherits(Bg, _Md39);

      function Bg() {
        _classCallCheck(this, Bg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Bg).apply(this, arguments));
      }

      _createClass(Bg, [{
        key: "init",
        value: function init() {
          var _this203 = this;

          var t = this.editor,
              e = t.editing.view,
              n = t.model.schema,
              i = t.data,
              o = t.editing,
              r = t.t;
          n.register("caption", {
            allowIn: "image",
            allowContentOf: "$block",
            isLimit: !0
          }), t.model.document.registerPostFixer(function (t) {
            return _this203._insertMissingModelCaptionElement(t);
          }), t.conversion.for("upcast").elementToElement({
            view: zg,
            model: "caption"
          });
          i.downcastDispatcher.on("insert:caption", Fg(function (t) {
            return t.createContainerElement("figcaption");
          }, !1));

          var s = function (t, e) {
            return function (n) {
              var i = n.createEditableElement("figcaption");
              return n.setCustomProperty("imageCaption", !0, i), wl({
                view: t,
                element: i,
                text: e
              }), ku(i, n);
            };
          }(e, r("am"));

          o.downcastDispatcher.on("insert:caption", Fg(s)), o.downcastDispatcher.on("insert", this._fixCaptionVisibility(function (t) {
            return t.item;
          }), {
            priority: "high"
          }), o.downcastDispatcher.on("remove", this._fixCaptionVisibility(function (t) {
            return t.position.parent;
          }), {
            priority: "high"
          }), e.document.registerPostFixer(function (t) {
            return _this203._updateCaptionVisibility(t);
          });
        }
      }, {
        key: "_updateCaptionVisibility",
        value: function _updateCaptionVisibility(t) {
          var e = this.editor.editing.mapper,
              n = this._lastSelectedCaption;
          var i;
          var o = this.editor.model.document.selection,
              r = o.getSelectedElement();

          if (r && r.is("image")) {
            var _t253 = Vg(r);

            i = e.toViewElement(_t253);
          }

          var s = Ug(o.getFirstPosition().parent);
          if (s && (i = e.toViewElement(s)), i) return n ? n === i ? qg(i, t) : (Hg(n, t), this._lastSelectedCaption = i, qg(i, t)) : (this._lastSelectedCaption = i, qg(i, t));

          if (n) {
            var _e234 = Hg(n, t);

            return this._lastSelectedCaption = null, _e234;
          }

          return !1;
        }
      }, {
        key: "_fixCaptionVisibility",
        value: function _fixCaptionVisibility(t) {
          var _this204 = this;

          return function (e, n, i) {
            var o = Ug(t(n)),
                r = _this204.editor.editing.mapper,
                s = i.writer;

            if (o) {
              var _t254 = r.toViewElement(o);

              _t254 && (o.childCount ? s.removeClass("ck-hidden", _t254) : s.addClass("ck-hidden", _t254));
            }
          };
        }
      }, {
        key: "_insertMissingModelCaptionElement",
        value: function _insertMissingModelCaptionElement(t) {
          var e = this.editor.model,
              n = e.document.differ.getChanges(),
              i = [];
          var _iteratorNormalCompletion310 = true;
          var _didIteratorError310 = false;
          var _iteratorError310 = undefined;

          try {
            for (var _iterator310 = n[Symbol.iterator](), _step310; !(_iteratorNormalCompletion310 = (_step310 = _iterator310.next()).done); _iteratorNormalCompletion310 = true) {
              var _t255 = _step310.value;

              if ("insert" == _t255.type && "$text" != _t255.name) {
                var _n211 = _t255.position.nodeAfter;

                if (_n211.is("image") && !Vg(_n211) && i.push(_n211), !_n211.is("image") && _n211.childCount) {
                  var _iteratorNormalCompletion311 = true;
                  var _didIteratorError311 = false;
                  var _iteratorError311 = undefined;

                  try {
                    for (var _iterator311 = e.createRangeIn(_n211).getItems()[Symbol.iterator](), _step311; !(_iteratorNormalCompletion311 = (_step311 = _iterator311.next()).done); _iteratorNormalCompletion311 = true) {
                      var _t256 = _step311.value;
                      _t256.is("image") && !Vg(_t256) && i.push(_t256);
                    }
                  } catch (err) {
                    _didIteratorError311 = true;
                    _iteratorError311 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion311 && _iterator311.return != null) {
                        _iterator311.return();
                      }
                    } finally {
                      if (_didIteratorError311) {
                        throw _iteratorError311;
                      }
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError310 = true;
            _iteratorError310 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion310 && _iterator310.return != null) {
                _iterator310.return();
              }
            } finally {
              if (_didIteratorError310) {
                throw _iteratorError310;
              }
            }
          }

          for (var _i172 = 0, _i171 = i; _i172 < _i171.length; _i172++) {
            var _e235 = _i171[_i172];
            t.appendElement("caption", _e235);
          }

          return !!i.length;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageCaptionEditing";
        }
      }]);

      return Bg;
    }(Md);

    function Fg(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return function (n, i, o) {
        var r = i.item;

        if ((r.childCount || e) && xu(r.parent)) {
          if (!o.consumable.consume(i.item, "insert")) return;

          var _e236 = o.mapper.toViewElement(i.range.start.parent),
              _n212 = t(o.writer),
              _s28 = o.writer;

          r.childCount || _s28.addClass("ck-hidden", _n212), function (t, e, n, i) {
            var o = i.writer.createPositionAt(n, "end");
            i.writer.insert(o, t), i.mapper.bindElements(e, t);
          }(_n212, i.item, _e236, o);
        }
      };
    }

    function Ug(t) {
      var e = t.getAncestors({
        includeSelf: !0
      }).find(function (t) {
        return "caption" == t.name;
      });
      return e && e.parent && "image" == e.parent.name ? e : null;
    }

    function Hg(t, e) {
      return !t.childCount && !t.hasClass("ck-hidden") && (e.addClass("ck-hidden", t), !0);
    }

    function qg(t, e) {
      return !!t.hasClass("ck-hidden") && (e.removeClass("ck-hidden", t), !0);
    }

    n(70);

    var Wg =
    /*#__PURE__*/
    function (_Rd16) {
      _inherits(Wg, _Rd16);

      function Wg(t, e) {
        var _this205;

        _classCallCheck(this, Wg);

        _this205 = _possibleConstructorReturn(this, _getPrototypeOf(Wg).call(this, t)), _this205.defaultStyle = !1, _this205.styles = e.reduce(function (t, e) {
          return t[e.name] = e, e.isDefault && (_this205.defaultStyle = e.name), t;
        }, {});
        return _this205;
      }

      _createClass(Wg, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          if (this.isEnabled = xu(t), t) {
            if (t.hasAttribute("imageStyle")) {
              var _e237 = t.getAttribute("imageStyle");

              this.value = !!this.styles[_e237] && _e237;
            } else this.value = this.defaultStyle;
          } else this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this206 = this;

          var e = t.value,
              n = this.editor.model,
              i = n.document.selection.getSelectedElement();
          n.change(function (t) {
            _this206.styles[e].isDefault ? t.removeAttribute("imageStyle", i) : t.setAttribute("imageStyle", e, i);
          });
        }
      }]);

      return Wg;
    }(Rd);

    function Yg(t, e) {
      var _iteratorNormalCompletion312 = true;
      var _didIteratorError312 = false;
      var _iteratorError312 = undefined;

      try {
        for (var _iterator312 = e[Symbol.iterator](), _step312; !(_iteratorNormalCompletion312 = (_step312 = _iterator312.next()).done); _iteratorNormalCompletion312 = true) {
          var _n213 = _step312.value;
          if (_n213.name === t) return _n213;
        }
      } catch (err) {
        _didIteratorError312 = true;
        _iteratorError312 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion312 && _iterator312.return != null) {
            _iterator312.return();
          }
        } finally {
          if (_didIteratorError312) {
            throw _iteratorError312;
          }
        }
      }
    }

    var $g = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>',
        Gg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>',
        Qg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>',
        Kg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
    var Jg = {
      full: {
        name: "full",
        title: "Full size image",
        icon: $g,
        isDefault: !0
      },
      side: {
        name: "side",
        title: "Side image",
        icon: Kg,
        className: "image-style-side"
      },
      alignLeft: {
        name: "alignLeft",
        title: "Left aligned image",
        icon: Gg,
        className: "image-style-align-left"
      },
      alignCenter: {
        name: "alignCenter",
        title: "Centered image",
        icon: Qg,
        className: "image-style-align-center"
      },
      alignRight: {
        name: "alignRight",
        title: "Right aligned image",
        icon: Kg,
        className: "image-style-align-right"
      }
    },
        Zg = {
      full: $g,
      left: Gg,
      right: Kg,
      center: Qg
    };

    function Xg() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return t.map(tm);
    }

    function tm(t) {
      if ("string" == typeof t) {
        var _e238 = t;
        Jg[_e238] ? t = Object.assign({}, Jg[_e238]) : (console.warn(Object(Qn.a)("image-style-not-found: There is no such image style of given name."), {
          name: _e238
        }), t = {
          name: _e238
        });
      } else if (Jg[t.name]) {
        var _e239 = Jg[t.name],
            _n214 = Object.assign({}, t);

        for (var _i173 in _e239) {
          t.hasOwnProperty(_i173) || (_n214[_i173] = _e239[_i173]);
        }

        t = _n214;
      }

      return "string" == typeof t.icon && Zg[t.icon] && (t.icon = Zg[t.icon]), t;
    }

    var em =
    /*#__PURE__*/
    function (_Md40) {
      _inherits(em, _Md40);

      function em() {
        _classCallCheck(this, em);

        return _possibleConstructorReturn(this, _getPrototypeOf(em).apply(this, arguments));
      }

      _createClass(em, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.data,
              i = t.editing;
          t.config.define("image.styles", ["full", "side"]);
          var o = Xg(t.config.get("image.styles"));
          e.extend("image", {
            allowAttributes: "imageStyle"
          });

          var r = function (t) {
            return function (e, n, i) {
              if (!i.consumable.consume(n.item, e.name)) return;
              var o = Yg(n.attributeNewValue, t),
                  r = Yg(n.attributeOldValue, t),
                  s = i.mapper.toViewElement(n.item),
                  a = i.writer;
              r && a.removeClass(r.className, s), o && a.addClass(o.className, s);
            };
          }(o);

          i.downcastDispatcher.on("attribute:imageStyle:image", r), n.downcastDispatcher.on("attribute:imageStyle:image", r), n.upcastDispatcher.on("element:figure", function (t) {
            var e = t.filter(function (t) {
              return !t.isDefault;
            });
            return function (t, n, i) {
              if (!n.modelRange) return;
              var o = n.viewItem,
                  r = Jh(n.modelRange.getItems());

              if (i.schema.checkAttribute(r, "imageStyle")) {
                var _iteratorNormalCompletion313 = true;
                var _didIteratorError313 = false;
                var _iteratorError313 = undefined;

                try {
                  for (var _iterator313 = e[Symbol.iterator](), _step313; !(_iteratorNormalCompletion313 = (_step313 = _iterator313.next()).done); _iteratorNormalCompletion313 = true) {
                    var _t257 = _step313.value;
                    i.consumable.consume(o, {
                      classes: _t257.className
                    }) && i.writer.setAttribute("imageStyle", _t257.name, r);
                  }
                } catch (err) {
                  _didIteratorError313 = true;
                  _iteratorError313 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion313 && _iterator313.return != null) {
                      _iterator313.return();
                    }
                  } finally {
                    if (_didIteratorError313) {
                      throw _iteratorError313;
                    }
                  }
                }
              }
            };
          }(o), {
            priority: "low"
          }), t.commands.add("imageStyle", new Wg(t, o));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleEditing";
        }
      }]);

      return em;
    }(Md);

    n(72);

    var nm =
    /*#__PURE__*/
    function (_Md41) {
      _inherits(nm, _Md41);

      function nm() {
        _classCallCheck(this, nm);

        return _possibleConstructorReturn(this, _getPrototypeOf(nm).apply(this, arguments));
      }

      _createClass(nm, [{
        key: "init",
        value: function init() {
          var t = function (t, e) {
            var _iteratorNormalCompletion314 = true;
            var _didIteratorError314 = false;
            var _iteratorError314 = undefined;

            try {
              for (var _iterator314 = t[Symbol.iterator](), _step314; !(_iteratorNormalCompletion314 = (_step314 = _iterator314.next()).done); _iteratorNormalCompletion314 = true) {
                var _n215 = _step314.value;
                e[_n215.title] && (_n215.title = e[_n215.title]);
              }
            } catch (err) {
              _didIteratorError314 = true;
              _iteratorError314 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion314 && _iterator314.return != null) {
                  _iterator314.return();
                }
              } finally {
                if (_didIteratorError314) {
                  throw _iteratorError314;
                }
              }
            }

            return t;
          }(Xg(this.editor.config.get("image.styles")), this.localizedDefaultStylesTitles);

          var _iteratorNormalCompletion315 = true;
          var _didIteratorError315 = false;
          var _iteratorError315 = undefined;

          try {
            for (var _iterator315 = t[Symbol.iterator](), _step315; !(_iteratorNormalCompletion315 = (_step315 = _iterator315.next()).done); _iteratorNormalCompletion315 = true) {
              var _e240 = _step315.value;

              this._createButton(_e240);
            }
          } catch (err) {
            _didIteratorError315 = true;
            _iteratorError315 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion315 && _iterator315.return != null) {
                _iterator315.return();
              }
            } finally {
              if (_didIteratorError315) {
                throw _iteratorError315;
              }
            }
          }
        }
      }, {
        key: "_createButton",
        value: function _createButton(t) {
          var _this207 = this;

          var e = this.editor,
              n = "imageStyle:".concat(t.name);
          e.ui.componentFactory.add(n, function (n) {
            var i = e.commands.get("imageStyle"),
                o = new ud(n);
            return o.set({
              label: t.title,
              icon: t.icon,
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", function (e) {
              return e === t.name;
            }), _this207.listenTo(o, "execute", function () {
              return e.execute("imageStyle", {
                value: t.name
              });
            }), o;
          });
        }
      }, {
        key: "localizedDefaultStylesTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            "Full size image": t("ah"),
            "Side image": t("ai"),
            "Left aligned image": t("aj"),
            "Centered image": t("ak"),
            "Right aligned image": t("al")
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleUI";
        }
      }]);

      return nm;
    }(Md);

    var im =
    /*#__PURE__*/
    function (_Md42) {
      _inherits(im, _Md42);

      function im() {
        _classCallCheck(this, im);

        return _possibleConstructorReturn(this, _getPrototypeOf(im).apply(this, arguments));
      }

      _createClass(im, [{
        key: "init",
        value: function init() {
          var _this208 = this;

          var t = this.editor;

          if (t.plugins.has("BalloonToolbar")) {
            var _e241 = t.plugins.get("BalloonToolbar");

            this.listenTo(_e241, "show", function (e) {
              (function (t) {
                var e = t.getSelectedElement();
                return !(!e || !pu(e));
              })(t.editing.view.document.selection) && e.stop();
            }, {
              priority: "high"
            });
          }

          this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.listenTo(t.ui, "update", function () {
            _this208._updateToolbarsVisibility();
          }), this.listenTo(t.ui.focusTracker, "change:isFocused", function () {
            _this208._updateToolbarsVisibility();
          }, {
            priority: "low"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(im.prototype), "destroy", this).call(this);

          var _iteratorNormalCompletion316 = true;
          var _didIteratorError316 = false;
          var _iteratorError316 = undefined;

          try {
            for (var _iterator316 = this._toolbarDefinitions.values()[Symbol.iterator](), _step316; !(_iteratorNormalCompletion316 = (_step316 = _iterator316.next()).done); _iteratorNormalCompletion316 = true) {
              var _t258 = _step316.value;

              _t258.view.destroy();
            }
          } catch (err) {
            _didIteratorError316 = true;
            _iteratorError316 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion316 && _iterator316.return != null) {
                _iterator316.return();
              }
            } finally {
              if (_didIteratorError316) {
                throw _iteratorError316;
              }
            }
          }
        }
      }, {
        key: "register",
        value: function register(t, _ref105) {
          var e = _ref105.ariaLabel,
              n = _ref105.items,
              i = _ref105.getRelatedElement,
              _ref105$balloonClassN = _ref105.balloonClassName,
              o = _ref105$balloonClassN === void 0 ? "ck-toolbar-container" : _ref105$balloonClassN;
          var r = this.editor,
              s = r.t,
              a = new xd(r.locale);
          if (a.ariaLabel = e || s("ax"), this._toolbarDefinitions.has(t)) throw new Qn.b("widget-toolbar-duplicated: Toolbar with the given id was already added.", this, {
            toolbarId: t
          });
          a.fillFromConfig(n, r.ui.componentFactory), this._toolbarDefinitions.set(t, {
            view: a,
            getRelatedElement: i,
            balloonClassName: o
          });
        }
      }, {
        key: "_updateToolbarsVisibility",
        value: function _updateToolbarsVisibility() {
          var t = 0,
              e = null,
              n = null;
          var _iteratorNormalCompletion317 = true;
          var _didIteratorError317 = false;
          var _iteratorError317 = undefined;

          try {
            for (var _iterator317 = this._toolbarDefinitions.values()[Symbol.iterator](), _step317; !(_iteratorNormalCompletion317 = (_step317 = _iterator317.next()).done); _iteratorNormalCompletion317 = true) {
              var _i174 = _step317.value;

              var _o86 = _i174.getRelatedElement(this.editor.editing.view.document.selection);

              if (this.editor.ui.focusTracker.isFocused) {
                if (_o86) {
                  var _r42 = _o86.getAncestors().length;

                  _r42 > t && (t = _r42, e = _o86, n = _i174);
                } else this._isToolbarInBalloon(_i174) && this._hideToolbar(_i174);
              } else this._isToolbarVisible(_i174) && this._hideToolbar(_i174);
            }
          } catch (err) {
            _didIteratorError317 = true;
            _iteratorError317 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion317 && _iterator317.return != null) {
                _iterator317.return();
              }
            } finally {
              if (_didIteratorError317) {
                throw _iteratorError317;
              }
            }
          }

          n && this._showToolbar(n, e);
        }
      }, {
        key: "_hideToolbar",
        value: function _hideToolbar(t) {
          this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
        }
      }, {
        key: "_showToolbar",
        value: function _showToolbar(t, e) {
          var _this209 = this;

          this._isToolbarVisible(t) ? om(this.editor, e) : this._isToolbarInBalloon(t) || (this._balloon.add({
            view: t.view,
            position: rm(this.editor, e),
            balloonClassName: t.balloonClassName
          }), this.listenTo(this._balloon, "change:visibleView", function () {
            var _iteratorNormalCompletion318 = true;
            var _didIteratorError318 = false;
            var _iteratorError318 = undefined;

            try {
              for (var _iterator318 = _this209._toolbarDefinitions.values()[Symbol.iterator](), _step318; !(_iteratorNormalCompletion318 = (_step318 = _iterator318.next()).done); _iteratorNormalCompletion318 = true) {
                var _t259 = _step318.value;

                if (_this209._isToolbarVisible(_t259)) {
                  var _e242 = _t259.getRelatedElement(_this209.editor.editing.view.document.selection);

                  om(_this209.editor, _e242);
                }
              }
            } catch (err) {
              _didIteratorError318 = true;
              _iteratorError318 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion318 && _iterator318.return != null) {
                  _iterator318.return();
                }
              } finally {
                if (_didIteratorError318) {
                  throw _iteratorError318;
                }
              }
            }
          }));
        }
      }, {
        key: "_isToolbarVisible",
        value: function _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view;
        }
      }, {
        key: "_isToolbarInBalloon",
        value: function _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [tg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "WidgetToolbarRepository";
        }
      }]);

      return im;
    }(Md);

    function om(t, e) {
      var n = t.plugins.get("ContextualBalloon"),
          i = rm(t, e);
      n.updatePosition(i);
    }

    function rm(t, e) {
      var n = t.editing.view,
          i = $f.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast]
      };
    }

    var sm =
    /*#__PURE__*/
    function (_Rd17) {
      _inherits(sm, _Rd17);

      function sm(t) {
        var _this210;

        _classCallCheck(this, sm);

        _this210 = _possibleConstructorReturn(this, _getPrototypeOf(sm).call(this, t)), _this210._childCommands = [];
        return _this210;
      }

      _createClass(sm, [{
        key: "refresh",
        value: function refresh() {}
      }, {
        key: "execute",
        value: function execute() {
          for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
            t[_key19] = arguments[_key19];
          }

          this._getFirstEnabledCommand().execute(t);
        }
      }, {
        key: "registerChildCommand",
        value: function registerChildCommand(t) {
          var _this211 = this;

          this._childCommands.push(t), t.on("change:isEnabled", function () {
            return _this211._checkEnabled();
          }), this._checkEnabled();
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand();
        }
      }, {
        key: "_getFirstEnabledCommand",
        value: function _getFirstEnabledCommand() {
          return this._childCommands.find(function (t) {
            return t.isEnabled;
          });
        }
      }]);

      return sm;
    }(Rd);

    var am =
    /*#__PURE__*/
    function (_Md43) {
      _inherits(am, _Md43);

      function am() {
        _classCallCheck(this, am);

        return _possibleConstructorReturn(this, _getPrototypeOf(am).apply(this, arguments));
      }

      _createClass(am, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("indent", new sm(t)), t.commands.add("outdent", new sm(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentEditing";
        }
      }]);

      return am;
    }(Md);

    var cm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5z"/><path d="M1.632 6.95L5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>\n',
        lm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5z"/><path d="M4.368 6.95L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>\n';

    var dm =
    /*#__PURE__*/
    function (_Md44) {
      _inherits(dm, _Md44);

      function dm() {
        _classCallCheck(this, dm);

        return _possibleConstructorReturn(this, _getPrototypeOf(dm).apply(this, arguments));
      }

      _createClass(dm, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.locale,
              n = t.t,
              i = "ltr" == e.uiLanguageDirection ? cm : lm,
              o = "ltr" == e.uiLanguageDirection ? lm : cm;
          this._defineButton("indent", n("k"), i), this._defineButton("outdent", n("l"), o);
        }
      }, {
        key: "_defineButton",
        value: function _defineButton(t, e, n) {
          var _this212 = this;

          var i = this.editor;
          i.ui.componentFactory.add(t, function (o) {
            var r = i.commands.get(t),
                s = new ud(o);
            return s.set({
              label: e,
              icon: n,
              tooltip: !0
            }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this212.listenTo(s, "execute", function () {
              return i.execute(t);
            }), s;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentUI";
        }
      }]);

      return dm;
    }(Md);

    var hm =
    /*#__PURE__*/
    function (_is7) {
      _inherits(hm, _is7);

      function hm(t) {
        var _this213;

        _classCallCheck(this, hm);

        _this213 = _possibleConstructorReturn(this, _getPrototypeOf(hm).call(this, t)), _this213.domEventType = "click";
        return _this213;
      }

      _createClass(hm, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return hm;
    }(is);

    n(74);

    var um =
    /*#__PURE__*/
    function (_Wl24) {
      _inherits(um, _Wl24);

      function um(t) {
        var _this214;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, um);

        _this214 = _possibleConstructorReturn(this, _getPrototypeOf(um).call(this, t));
        var n = t.t;
        _this214.focusTracker = new ml(), _this214.keystrokes = new sl(), _this214.urlInputView = _this214._createUrlInput(), _this214.saveButtonView = _this214._createButton(n("bf"), Uf, "ck-button-save"), _this214.saveButtonView.type = "submit", _this214.cancelButtonView = _this214._createButton(n("bg"), Hf, "ck-button-cancel", "cancel"), _this214._manualDecoratorSwitches = _this214._createManualDecoratorSwitches(e), _this214.children = _this214._createFormChildren(e), _this214._focusables = new Al(), _this214._focusCycler = new td({
          focusables: _this214._focusables,
          focusTracker: _this214.focusTracker,
          keystrokeHandler: _this214.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        var i = ["ck", "ck-link-form"];
        e.length && i.push("ck-link-form_layout-vertical"), _this214.setTemplate({
          tag: "form",
          attributes: {
            class: i,
            tabindex: "-1"
          },
          children: _this214.children
        });
        return _this214;
      }

      _createClass(um, [{
        key: "getDecoratorSwitchesState",
        value: function getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce(function (t, e) {
            return t[e.name] = e.isOn, t;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this215 = this;

          _get(_getPrototypeOf(um.prototype), "render", this).call(this), Ff({
            view: this
          }), [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]).forEach(function (t) {
            _this215._focusables.add(t), _this215.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var t = this.locale.t,
              e = new zf(this.locale, Bf);
          return e.label = t("bk"), e.inputView.placeholder = "https://example.com", e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new ud(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "_createManualDecoratorSwitches",
        value: function _createManualDecoratorSwitches(t) {
          var _this216 = this;

          var e = this.createCollection();
          var _iteratorNormalCompletion319 = true;
          var _didIteratorError319 = false;
          var _iteratorError319 = undefined;

          try {
            var _loop8 = function _loop8() {
              var n = _step319.value;
              var t = new wd(_this216.locale);
              t.set({
                name: n.id,
                label: n.label,
                withText: !0
              }), t.bind("isOn").to(n, "value"), t.on("execute", function () {
                n.set("value", !t.isOn);
              }), e.add(t);
            };

            for (var _iterator319 = t[Symbol.iterator](), _step319; !(_iteratorNormalCompletion319 = (_step319 = _iterator319.next()).done); _iteratorNormalCompletion319 = true) {
              _loop8();
            }
          } catch (err) {
            _didIteratorError319 = true;
            _iteratorError319 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion319 && _iterator319.return != null) {
                _iterator319.return();
              }
            } finally {
              if (_didIteratorError319) {
                throw _iteratorError319;
              }
            }
          }

          return e;
        }
      }, {
        key: "_createFormChildren",
        value: function _createFormChildren(t) {
          var e = this.createCollection();

          if (e.add(this.urlInputView), t.length) {
            var _t260 = new Wl();

            _t260.setTemplate({
              tag: "ul",
              children: this._manualDecoratorSwitches.map(function (t) {
                return {
                  tag: "li",
                  children: [t],
                  attributes: {
                    class: ["ck", "ck-list__item"]
                  }
                };
              }),
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              }
            }), e.add(_t260);
          }

          return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
        }
      }]);

      return um;
    }(Wl);

    var fm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>',
        gm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>';
    n(76);

    var mm =
    /*#__PURE__*/
    function (_Wl25) {
      _inherits(mm, _Wl25);

      function mm(t) {
        var _this217;

        _classCallCheck(this, mm);

        _this217 = _possibleConstructorReturn(this, _getPrototypeOf(mm).call(this, t));
        var e = t.t;
        _this217.focusTracker = new ml(), _this217.keystrokes = new sl(), _this217.previewButtonView = _this217._createPreviewButton(), _this217.unlinkButtonView = _this217._createButton(e("bb"), fm, "unlink"), _this217.editButtonView = _this217._createButton(e("bc"), gm, "edit"), _this217.set("href"), _this217._focusables = new Al(), _this217._focusCycler = new td({
          focusables: _this217._focusables,
          focusTracker: _this217.focusTracker,
          keystrokeHandler: _this217.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this217.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions"],
            tabindex: "-1"
          },
          children: [_this217.previewButtonView, _this217.editButtonView, _this217.unlinkButtonView]
        });
        return _this217;
      }

      _createClass(mm, [{
        key: "render",
        value: function render() {
          var _this218 = this;

          _get(_getPrototypeOf(mm.prototype), "render", this).call(this), [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(function (t) {
            _this218._focusables.add(t), _this218.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n) {
          var i = new ud(this.locale);
          return i.set({
            label: t,
            icon: e,
            tooltip: !0
          }), i.delegate("execute").to(this, n), i;
        }
      }, {
        key: "_createPreviewButton",
        value: function _createPreviewButton() {
          var t = new ud(this.locale),
              e = this.bindTemplate,
              n = this.t;
          return t.set({
            withText: !0,
            tooltip: n("bd")
          }), t.extendTemplate({
            attributes: {
              class: ["ck", "ck-link-actions__preview"],
              href: e.to("href", function (t) {
                return t && af(t);
              }),
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), t.bind("label").to(this, "href", function (t) {
            return t || n("be");
          }), t.bind("isEnabled").to(this, "href", function (t) {
            return !!t;
          }), t.template.tag = "a", t.template.eventListeners = {}, t;
        }
      }]);

      return mm;
    }(Wl);

    var pm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
    var bm = "Ctrl+K";

    var wm =
    /*#__PURE__*/
    function (_Md45) {
      _inherits(wm, _Md45);

      function wm() {
        _classCallCheck(this, wm);

        return _possibleConstructorReturn(this, _getPrototypeOf(wm).apply(this, arguments));
      }

      _createClass(wm, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.editing.view.addObserver(hm), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = t.plugins.get(tg), this._createToolbarLinkButton(), this._enableUserBalloonInteractions();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(wm.prototype), "destroy", this).call(this), this.formView.destroy();
        }
      }, {
        key: "_createActionsView",
        value: function _createActionsView() {
          var _this219 = this;

          var t = this.editor,
              e = new mm(t.locale),
              n = t.commands.get("link"),
              i = t.commands.get("unlink");
          return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(e, "edit", function () {
            _this219._addFormView();
          }), this.listenTo(e, "unlink", function () {
            t.execute("unlink"), _this219._hideUI();
          }), e.keystrokes.set("Esc", function (t, e) {
            _this219._hideUI(), e();
          }), e.keystrokes.set(bm, function (t, e) {
            _this219._addFormView(), e();
          }), e;
        }
      }, {
        key: "_createFormView",
        value: function _createFormView() {
          var _this220 = this;

          var t = this.editor,
              e = t.commands.get("link"),
              n = new um(t.locale, e.manualDecorators);
          return n.urlInputView.bind("value").to(e, "value"), n.urlInputView.bind("isReadOnly").to(e, "isEnabled", function (t) {
            return !t;
          }), n.saveButtonView.bind("isEnabled").to(e), this.listenTo(n, "submit", function () {
            t.execute("link", n.urlInputView.inputView.element.value, n.getDecoratorSwitchesState()), _this220._closeFormView();
          }), this.listenTo(n, "cancel", function () {
            _this220._closeFormView();
          }), n.keystrokes.set("Esc", function (t, e) {
            _this220._closeFormView(), e();
          }), n;
        }
      }, {
        key: "_createToolbarLinkButton",
        value: function _createToolbarLinkButton() {
          var _this221 = this;

          var t = this.editor,
              e = t.commands.get("link"),
              n = t.t;
          t.keystrokes.set(bm, function (t, n) {
            n(), e.isEnabled && _this221._showUI(!0);
          }), t.ui.componentFactory.add("link", function (t) {
            var i = new ud(t);
            return i.isEnabled = !0, i.label = n("as"), i.icon = pm, i.keystroke = bm, i.tooltip = !0, i.isToggleable = !0, i.bind("isEnabled").to(e, "isEnabled"), i.bind("isOn").to(e, "value", function (t) {
              return !!t;
            }), _this221.listenTo(i, "execute", function () {
              return _this221._showUI(!0);
            }), i;
          });
        }
      }, {
        key: "_enableUserBalloonInteractions",
        value: function _enableUserBalloonInteractions() {
          var _this222 = this;

          var t = this.editor.editing.view.document;
          this.listenTo(t, "click", function () {
            _this222._getSelectedLinkElement() && _this222._showUI();
          }), this.editor.keystrokes.set("Tab", function (t, e) {
            _this222._areActionsVisible && !_this222.actionsView.focusTracker.isFocused && (_this222.actionsView.focus(), e());
          }, {
            priority: "high"
          }), this.editor.keystrokes.set("Esc", function (t, e) {
            _this222._isUIVisible && (_this222._hideUI(), e());
          }), kd({
            emitter: this.formView,
            activator: function activator() {
              return _this222._isUIInPanel;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this222._hideUI();
            }
          });
        }
      }, {
        key: "_addActionsView",
        value: function _addActionsView() {
          this._areActionsInPanel || this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          });
        }
      }, {
        key: "_addFormView",
        value: function _addFormView() {
          if (this._isFormInPanel) return;
          var t = this.editor.commands.get("link");
          this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          }), this._balloon.visibleView === this.formView && this.formView.urlInputView.select(), this.formView.urlInputView.inputView.element.value = t.value || "";
        }
      }, {
        key: "_closeFormView",
        value: function _closeFormView() {
          var t = this.editor.commands.get("link");
          t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
        }
      }, {
        key: "_removeFormView",
        value: function _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus());
        }
      }, {
        key: "_showUI",
        value: function _showUI() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          this.editor.commands.get("link").isEnabled && (this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI());
        }
      }, {
        key: "_hideUI",
        value: function _hideUI() {
          if (!this._isUIInPanel) return;
          var t = this.editor;
          this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView);
        }
      }, {
        key: "_startUpdatingUI",
        value: function _startUpdatingUI() {
          var _this223 = this;

          var t = this.editor,
              e = t.editing.view.document;

          var n = this._getSelectedLinkElement(),
              i = r();

          var o = function o() {
            var t = _this223._getSelectedLinkElement(),
                e = r();

            n && !t || !n && e !== i ? _this223._hideUI() : _this223._isUIVisible && _this223._balloon.updatePosition(_this223._getBalloonPositionData()), n = t, i = e;
          };

          function r() {
            return e.selection.focus.getAncestors().reverse().find(function (t) {
              return t.is("element");
            });
          }

          this.listenTo(t.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
        }
      }, {
        key: "_getBalloonPositionData",
        value: function _getBalloonPositionData() {
          var t = this.editor.editing.view,
              e = t.document,
              n = this._getSelectedLinkElement();

          return {
            target: n ? t.domConverter.mapViewToDom(n) : t.domConverter.viewRangeToDom(e.selection.getFirstRange())
          };
        }
      }, {
        key: "_getSelectedLinkElement",
        value: function _getSelectedLinkElement() {
          var t = this.editor.editing.view,
              e = t.document.selection;
          if (e.isCollapsed) return km(e.getFirstPosition());
          {
            var _n216 = e.getFirstRange().getTrimmed(),
                _i175 = km(_n216.start),
                _o87 = km(_n216.end);

            return _i175 && _i175 == _o87 && t.createRangeIn(_i175).getTrimmed().isEqual(_n216) ? _i175 : null;
          }
        }
      }, {
        key: "_isFormInPanel",
        get: function get() {
          return this._balloon.hasView(this.formView);
        }
      }, {
        key: "_areActionsInPanel",
        get: function get() {
          return this._balloon.hasView(this.actionsView);
        }
      }, {
        key: "_areActionsVisible",
        get: function get() {
          return this._balloon.visibleView === this.actionsView;
        }
      }, {
        key: "_isUIInPanel",
        get: function get() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
      }], [{
        key: "requires",
        get: function get() {
          return [tg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "LinkUI";
        }
      }]);

      return wm;
    }(Md);

    function km(t) {
      return t.getAncestors().find(function (t) {
        return function (t) {
          return t.is("attributeElement") && !!t.getCustomProperty("link");
        }(t);
      });
    }

    var _m =
    /*#__PURE__*/
    function (_Rd18) {
      _inherits(_m, _Rd18);

      function _m(t, e) {
        var _this224;

        _classCallCheck(this, _m);

        _this224 = _possibleConstructorReturn(this, _getPrototypeOf(_m).call(this, t)), _this224.type = e;
        return _this224;
      }

      _createClass(_m, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this225 = this;

          var t = this.editor.model,
              e = t.document,
              n = Array.from(e.selection.getSelectedBlocks()).filter(function (e) {
            return ym(e, t.schema);
          }),
              i = !0 === this.value;
          t.change(function (t) {
            if (i) {
              var _e243 = n[n.length - 1].nextSibling,
                  _i176 = Number.POSITIVE_INFINITY,
                  _o88 = [];

              for (; _e243 && "listItem" == _e243.name && 0 !== _e243.getAttribute("listIndent");) {
                var _t261 = _e243.getAttribute("listIndent");

                _t261 < _i176 && (_i176 = _t261);

                var _n217 = _t261 - _i176;

                _o88.push({
                  element: _e243,
                  listIndent: _n217
                }), _e243 = _e243.nextSibling;
              }

              _o88 = _o88.reverse();
              var _iteratorNormalCompletion320 = true;
              var _didIteratorError320 = false;
              var _iteratorError320 = undefined;

              try {
                for (var _iterator320 = _o88[Symbol.iterator](), _step320; !(_iteratorNormalCompletion320 = (_step320 = _iterator320.next()).done); _iteratorNormalCompletion320 = true) {
                  var _e244 = _step320.value;
                  t.setAttribute("listIndent", _e244.listIndent, _e244.element);
                }
              } catch (err) {
                _didIteratorError320 = true;
                _iteratorError320 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion320 && _iterator320.return != null) {
                    _iterator320.return();
                  }
                } finally {
                  if (_didIteratorError320) {
                    throw _iteratorError320;
                  }
                }
              }
            }

            if (!i) {
              var _t262 = Number.POSITIVE_INFINITY;
              var _iteratorNormalCompletion321 = true;
              var _didIteratorError321 = false;
              var _iteratorError321 = undefined;

              try {
                for (var _iterator321 = n[Symbol.iterator](), _step321; !(_iteratorNormalCompletion321 = (_step321 = _iterator321.next()).done); _iteratorNormalCompletion321 = true) {
                  var _e245 = _step321.value;
                  _e245.is("listItem") && _e245.getAttribute("listIndent") < _t262 && (_t262 = _e245.getAttribute("listIndent"));
                }
              } catch (err) {
                _didIteratorError321 = true;
                _iteratorError321 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion321 && _iterator321.return != null) {
                    _iterator321.return();
                  }
                } finally {
                  if (_didIteratorError321) {
                    throw _iteratorError321;
                  }
                }
              }

              _t262 = 0 === _t262 ? 1 : _t262, vm(n, !0, _t262), vm(n, !1, _t262);
            }

            var _iteratorNormalCompletion322 = true;
            var _didIteratorError322 = false;
            var _iteratorError322 = undefined;

            try {
              for (var _iterator322 = n.reverse()[Symbol.iterator](), _step322; !(_iteratorNormalCompletion322 = (_step322 = _iterator322.next()).done); _iteratorNormalCompletion322 = true) {
                var _e246 = _step322.value;
                i && "listItem" == _e246.name ? t.rename(_e246, "paragraph") : i || "listItem" == _e246.name ? i || "listItem" != _e246.name || _e246.getAttribute("listType") == _this225.type || t.setAttribute("listType", _this225.type, _e246) : (t.setAttributes({
                  listType: _this225.type,
                  listIndent: 0
                }, _e246), t.rename(_e246, "listItem"));
              }
            } catch (err) {
              _didIteratorError322 = true;
              _iteratorError322 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion322 && _iterator322.return != null) {
                  _iterator322.return();
                }
              } finally {
                if (_didIteratorError322) {
                  throw _iteratorError322;
                }
              }
            }
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = Jh(this.editor.model.document.selection.getSelectedBlocks());
          return !!t && t.is("listItem") && t.getAttribute("listType") == this.type;
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              n = Jh(t.getSelectedBlocks());
          return !!n && ym(n, e);
        }
      }]);

      return _m;
    }(Rd);

    function vm(t, e, n) {
      var i = e ? t[0] : t[t.length - 1];

      if (i.is("listItem")) {
        var _o89 = i[e ? "previousSibling" : "nextSibling"],
            _r43 = i.getAttribute("listIndent");

        for (; _o89 && _o89.is("listItem") && _o89.getAttribute("listIndent") >= n;) {
          _r43 > _o89.getAttribute("listIndent") && (_r43 = _o89.getAttribute("listIndent")), _o89.getAttribute("listIndent") == _r43 && t[e ? "unshift" : "push"](_o89), _o89 = _o89[e ? "previousSibling" : "nextSibling"];
        }
      }
    }

    function ym(t, e) {
      return e.checkChild(t.parent, "listItem") && !e.isObject(t);
    }

    var xm =
    /*#__PURE__*/
    function (_Rd19) {
      _inherits(xm, _Rd19);

      function xm(t, e) {
        var _this226;

        _classCallCheck(this, xm);

        _this226 = _possibleConstructorReturn(this, _getPrototypeOf(xm).call(this, t)), _this226._indentBy = "forward" == e ? 1 : -1;
        return _this226;
      }

      _createClass(xm, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this227 = this;

          var t = this.editor.model,
              e = t.document;
          var n = Array.from(e.selection.getSelectedBlocks());
          t.change(function (t) {
            var e = n[n.length - 1];
            var i = e.nextSibling;

            for (; i && "listItem" == i.name && i.getAttribute("listIndent") > e.getAttribute("listIndent");) {
              n.push(i), i = i.nextSibling;
            }

            _this227._indentBy < 0 && (n = n.reverse());
            var _iteratorNormalCompletion323 = true;
            var _didIteratorError323 = false;
            var _iteratorError323 = undefined;

            try {
              for (var _iterator323 = n[Symbol.iterator](), _step323; !(_iteratorNormalCompletion323 = (_step323 = _iterator323.next()).done); _iteratorNormalCompletion323 = true) {
                var _e247 = _step323.value;

                var _n218 = _e247.getAttribute("listIndent") + _this227._indentBy;

                _n218 < 0 ? t.rename(_e247, "paragraph") : t.setAttribute("listIndent", _n218, _e247);
              }
            } catch (err) {
              _didIteratorError323 = true;
              _iteratorError323 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion323 && _iterator323.return != null) {
                  _iterator323.return();
                }
              } finally {
                if (_didIteratorError323) {
                  throw _iteratorError323;
                }
              }
            }
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var t = Jh(this.editor.model.document.selection.getSelectedBlocks());
          if (!t || !t.is("listItem")) return !1;

          if (this._indentBy > 0) {
            var _e248 = t.getAttribute("listIndent"),
                _n219 = t.getAttribute("listType");

            var _i177 = t.previousSibling;

            for (; _i177 && _i177.is("listItem") && _i177.getAttribute("listIndent") >= _e248;) {
              if (_i177.getAttribute("listIndent") == _e248) return _i177.getAttribute("listType") == _n219;
              _i177 = _i177.previousSibling;
            }

            return !1;
          }

          return !0;
        }
      }]);

      return xm;
    }(Rd);

    function Am(t, e) {
      var n = e.mapper,
          i = e.writer,
          o = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
          r = function (t) {
        var e = t.createContainerElement("li");
        return e.getFillerOffset = Em, e;
      }(i),
          s = i.createContainerElement(o, null);

      return i.insert(i.createPositionAt(s, 0), r), n.bindElements(t, r), r;
    }

    function Tm(t, e, n, i) {
      var o = e.parent,
          r = n.mapper,
          s = n.writer;
      var a = r.toViewPosition(i.createPositionBefore(t));
      var c = Sm(t.previousSibling, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: t.getAttribute("listIndent")
      }),
          l = t.previousSibling;

      if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
        var _t263 = r.toViewElement(c);

        a = s.breakContainer(s.createPositionAfter(_t263));
      } else a = l && "listItem" == l.name ? r.toViewPosition(i.createPositionAt(l, "end")) : r.toViewPosition(i.createPositionBefore(t));

      if (a = Pm(a), s.insert(a, o), l && "listItem" == l.name) {
        var _t264 = r.toViewElement(l),
            _n220 = s.createRange(s.createPositionAt(_t264, 0), a).getWalker({
          ignoreElementEnd: !0
        });

        var _iteratorNormalCompletion324 = true;
        var _didIteratorError324 = false;
        var _iteratorError324 = undefined;

        try {
          for (var _iterator324 = _n220[Symbol.iterator](), _step324; !(_iteratorNormalCompletion324 = (_step324 = _iterator324.next()).done); _iteratorNormalCompletion324 = true) {
            var _t265 = _step324.value;

            if (_t265.item.is("li")) {
              var _i178 = s.breakContainer(s.createPositionBefore(_t265.item)),
                  _o90 = _t265.item.parent,
                  _r44 = s.createPositionAt(e, "end");

              Cm(s, _r44.nodeBefore, _r44.nodeAfter), s.move(s.createRangeOn(_o90), _r44), _n220.position = _i178;
            }
          }
        } catch (err) {
          _didIteratorError324 = true;
          _iteratorError324 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion324 && _iterator324.return != null) {
              _iterator324.return();
            }
          } finally {
            if (_didIteratorError324) {
              throw _iteratorError324;
            }
          }
        }
      } else {
        var _n221 = o.nextSibling;

        if (_n221 && (_n221.is("ul") || _n221.is("ol"))) {
          var _i179 = null;
          var _iteratorNormalCompletion325 = true;
          var _didIteratorError325 = false;
          var _iteratorError325 = undefined;

          try {
            for (var _iterator325 = _n221.getChildren()[Symbol.iterator](), _step325; !(_iteratorNormalCompletion325 = (_step325 = _iterator325.next()).done); _iteratorNormalCompletion325 = true) {
              var _e249 = _step325.value;

              var _n222 = r.toModelElement(_e249);

              if (!(_n222 && _n222.getAttribute("listIndent") > t.getAttribute("listIndent"))) break;
              _i179 = _e249;
            }
          } catch (err) {
            _didIteratorError325 = true;
            _iteratorError325 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion325 && _iterator325.return != null) {
                _iterator325.return();
              }
            } finally {
              if (_didIteratorError325) {
                throw _iteratorError325;
              }
            }
          }

          _i179 && (s.breakContainer(s.createPositionAfter(_i179)), s.move(s.createRangeOn(_i179.parent), s.createPositionAt(e, "end")));
        }
      }

      Cm(s, o, o.nextSibling), Cm(s, o.previousSibling, o);
    }

    function Cm(t, e, n) {
      return !e || !n || "ul" != e.name && "ol" != e.name ? null : e.name != n.name || e.getAttribute("class") !== n.getAttribute("class") ? null : t.mergeContainers(t.createPositionAfter(e));
    }

    function Pm(t) {
      return t.getLastMatchingPosition(function (t) {
        return t.item.is("uiElement");
      });
    }

    function Sm(t, e) {
      var n = !!e.sameIndent,
          i = !!e.smallerIndent,
          o = e.listIndent;
      var r = t;

      for (; r && "listItem" == r.name;) {
        var _t266 = r.getAttribute("listIndent");

        if (n && o == _t266 || i && o > _t266) return r;
        r = r.previousSibling;
      }

      return null;
    }

    function Mm(t, e, n, i) {
      t.ui.componentFactory.add(e, function (o) {
        var r = t.commands.get(e),
            s = new ud(o);
        return s.set({
          label: n,
          icon: i,
          tooltip: !0,
          isToggleable: !0
        }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", function () {
          return t.execute(e);
        }), s;
      });
    }

    function Em() {
      var t = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
      return this.isEmpty || t ? 0 : Ai.call(this);
    }

    function Im(t) {
      return function (e, n, i) {
        var o = i.consumable;
        if (!o.test(n.item, "insert") || !o.test(n.item, "attribute:listType") || !o.test(n.item, "attribute:listIndent")) return;
        o.consume(n.item, "insert"), o.consume(n.item, "attribute:listType"), o.consume(n.item, "attribute:listIndent");
        var r = n.item;
        Tm(r, Am(r, i), i, t);
      };
    }

    function Nm(t, e, n) {
      if (!n.consumable.consume(e.item, "attribute:listType")) return;
      var i = n.mapper.toViewElement(e.item),
          o = n.writer;
      o.breakContainer(o.createPositionBefore(i)), o.breakContainer(o.createPositionAfter(i));
      var r = i.parent,
          s = "numbered" == e.attributeNewValue ? "ol" : "ul";
      o.rename(s, r);
    }

    function Om(t, e, n) {
      var i = n.mapper.toViewElement(e.item).parent,
          o = n.writer;
      Cm(o, i, i.nextSibling), Cm(o, i.previousSibling, i);
      var _iteratorNormalCompletion326 = true;
      var _didIteratorError326 = false;
      var _iteratorError326 = undefined;

      try {
        for (var _iterator326 = e.item.getChildren()[Symbol.iterator](), _step326; !(_iteratorNormalCompletion326 = (_step326 = _iterator326.next()).done); _iteratorNormalCompletion326 = true) {
          var _t267 = _step326.value;
          n.consumable.consume(_t267, "insert");
        }
      } catch (err) {
        _didIteratorError326 = true;
        _iteratorError326 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion326 && _iterator326.return != null) {
            _iterator326.return();
          }
        } finally {
          if (_didIteratorError326) {
            throw _iteratorError326;
          }
        }
      }
    }

    function Rm(t, e, n) {
      if ("listItem" != e.item.name) {
        var _t268 = n.mapper.toViewPosition(e.range.start);

        var _i180 = n.writer,
            _o91 = [];

        for (; ("ul" == _t268.parent.name || "ol" == _t268.parent.name) && (_t268 = _i180.breakContainer(_t268), "li" == _t268.parent.name);) {
          var _e250 = _t268,
              _n223 = _i180.createPositionAt(_t268.parent, "end");

          if (!_e250.isEqual(_n223)) {
            var _t269 = _i180.remove(_i180.createRange(_e250, _n223));

            _o91.push(_t269);
          }

          _t268 = _i180.createPositionAfter(_t268.parent);
        }

        if (_o91.length > 0) {
          for (var _e251 = 0; _e251 < _o91.length; _e251++) {
            var _n224 = _t268.nodeBefore;

            if (_t268 = _i180.insert(_t268, _o91[_e251]).end, _e251 > 0) {
              var _e252 = Cm(_i180, _n224, _n224.nextSibling);

              _e252 && _e252.parent == _n224 && _t268.offset--;
            }
          }

          Cm(_i180, _t268.nodeBefore, _t268.nodeAfter);
        }
      }
    }

    function Dm(t, e, n) {
      var i = n.mapper.toViewPosition(e.position),
          o = i.nodeBefore,
          r = i.nodeAfter;
      Cm(n.writer, o, r);
    }

    function Lm(t, e, n) {
      if (n.consumable.consume(e.viewItem, {
        name: !0
      })) {
        var _t270 = n.writer,
            _i181 = _t270.createElement("listItem"),
            _o92 = function (t) {
          var e = 0,
              n = t.parent;

          for (; n;) {
            if (n.is("li")) e++;else {
              var _t271 = n.previousSibling;
              _t271 && _t271.is("li") && e++;
            }
            n = n.parent;
          }

          return e;
        }(e.viewItem);

        _t270.setAttribute("listIndent", _o92, _i181);

        var _r45 = e.viewItem.parent && "ol" == e.viewItem.parent.name ? "numbered" : "bulleted";

        _t270.setAttribute("listType", _r45, _i181);

        var _s29 = n.splitToAllowedParent(_i181, e.modelCursor);

        if (!_s29) return;

        _t270.insert(_i181, _s29.position);

        var _a15 = function (t, e, n) {
          var i = n.writer,
              o = n.schema;
          var r = i.createPositionAfter(t);
          var _iteratorNormalCompletion327 = true;
          var _didIteratorError327 = false;
          var _iteratorError327 = undefined;

          try {
            for (var _iterator327 = e[Symbol.iterator](), _step327; !(_iteratorNormalCompletion327 = (_step327 = _iterator327.next()).done); _iteratorNormalCompletion327 = true) {
              var _s30 = _step327.value;
              if ("ul" == _s30.name || "ol" == _s30.name) r = n.convertItem(_s30, r).modelCursor;else {
                var _e253 = n.convertItem(_s30, i.createPositionAt(t, "end")),
                    _a16 = _e253.modelRange.start.nodeAfter;

                _a16 && _a16.is("element") && !o.checkChild(t, _a16.name) && (t = _e253.modelCursor.parent.is("listItem") ? _e253.modelCursor.parent : Fm(_e253.modelCursor), r = i.createPositionAfter(t));
              }
            }
          } catch (err) {
            _didIteratorError327 = true;
            _iteratorError327 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion327 && _iterator327.return != null) {
                _iterator327.return();
              }
            } finally {
              if (_didIteratorError327) {
                throw _iteratorError327;
              }
            }
          }

          return r;
        }(_i181, e.viewItem.getChildren(), n);

        e.modelRange = _t270.createRange(e.modelCursor, _a15), _s29.cursorParent ? e.modelCursor = _t270.createPositionAt(_s29.cursorParent, 0) : e.modelCursor = e.modelRange.end;
      }
    }

    function jm(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        var _t272 = Array.from(e.viewItem.getChildren());

        for (var _i182 = 0, _t273 = _t272; _i182 < _t273.length; _i182++) {
          var _e254 = _t273[_i182];
          !(_e254.is("li") || Hm(_e254)) && _e254._remove();
        }
      }
    }

    function Vm(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        if (0 === e.viewItem.childCount) return;

        var _t274 = _toConsumableArray(e.viewItem.getChildren());

        var _n225 = !1,
            _i183 = !0;

        var _iteratorNormalCompletion328 = true;
        var _didIteratorError328 = false;
        var _iteratorError328 = undefined;

        try {
          for (var _iterator328 = _t274[Symbol.iterator](), _step328; !(_iteratorNormalCompletion328 = (_step328 = _iterator328.next()).done); _iteratorNormalCompletion328 = true) {
            var _e255 = _step328.value;
            _n225 && !Hm(_e255) && _e255._remove(), _e255.is("text") ? (_i183 && (_e255._data = _e255.data.replace(/^\s+/, "")), _e255.nextSibling && !Hm(_e255.nextSibling) || (_e255._data = _e255.data.replace(/\s+$/, ""))) : Hm(_e255) && (_n225 = !0), _i183 = !1;
          }
        } catch (err) {
          _didIteratorError328 = true;
          _iteratorError328 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion328 && _iterator328.return != null) {
              _iterator328.return();
            }
          } finally {
            if (_didIteratorError328) {
              throw _iteratorError328;
            }
          }
        }
      }
    }

    function zm(t) {
      return function (e, n) {
        if (n.isPhantom) return;
        var i = n.modelPosition.nodeBefore;

        if (i && i.is("listItem")) {
          var _e256 = n.mapper.toViewElement(i),
              _o93 = _e256.getAncestors().find(Hm),
              _r46 = t.createPositionAt(_e256, 0).getWalker();

          var _iteratorNormalCompletion329 = true;
          var _didIteratorError329 = false;
          var _iteratorError329 = undefined;

          try {
            for (var _iterator329 = _r46[Symbol.iterator](), _step329; !(_iteratorNormalCompletion329 = (_step329 = _iterator329.next()).done); _iteratorNormalCompletion329 = true) {
              var _t275 = _step329.value;

              if ("elementStart" == _t275.type && _t275.item.is("li")) {
                n.viewPosition = _t275.previousPosition;
                break;
              }

              if ("elementEnd" == _t275.type && _t275.item == _o93) {
                n.viewPosition = _t275.nextPosition;
                break;
              }
            }
          } catch (err) {
            _didIteratorError329 = true;
            _iteratorError329 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion329 && _iterator329.return != null) {
                _iterator329.return();
              }
            } finally {
              if (_didIteratorError329) {
                throw _iteratorError329;
              }
            }
          }
        }
      };
    }

    function Bm(t, _ref106) {
      var _ref107 = _slicedToArray(_ref106, 2),
          e = _ref107[0],
          n = _ref107[1];

      var i,
          o = e.is("documentFragment") ? e.getChild(0) : e;

      if (i = n ? this.createSelection(n) : this.document.selection, o && o.is("listItem")) {
        var _t276 = i.getFirstPosition();

        var _e257 = null;

        if (_t276.parent.is("listItem") ? _e257 = _t276.parent : _t276.nodeBefore && _t276.nodeBefore.is("listItem") && (_e257 = _t276.nodeBefore), _e257) {
          var _t277 = _e257.getAttribute("listIndent");

          if (_t277 > 0) for (; o && o.is("listItem");) {
            o._setAttribute("listIndent", o.getAttribute("listIndent") + _t277), o = o.nextSibling;
          }
        }
      }
    }

    function Fm(t) {
      var e = new $s({
        startPosition: t
      });
      var n;

      do {
        n = e.next();
      } while (!n.value.item.is("listItem"));

      return n.value.item;
    }

    function Um(t, e, n, i, o, r) {
      var s = Sm(e.nodeBefore, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: t,
        foo: "b"
      }),
          a = o.mapper,
          c = o.writer,
          l = s ? s.getAttribute("listIndent") : null;
      var d;
      if (s) {
        if (l == t) {
          var _t278 = a.toViewElement(s).parent;
          d = c.createPositionAfter(_t278);
        } else {
          var _t279 = r.createPositionAt(s, "end");

          d = a.toViewPosition(_t279);
        }
      } else d = n;
      d = Pm(d);

      for (var _i184 = 0, _arr = _toConsumableArray(i.getChildren()); _i184 < _arr.length; _i184++) {
        var _t280 = _arr[_i184];
        Hm(_t280) && (d = c.move(c.createRangeOn(_t280), d).end, Cm(c, _t280, _t280.nextSibling), Cm(c, _t280.previousSibling, _t280));
      }
    }

    function Hm(t) {
      return t.is("ol") || t.is("ul");
    }

    var qm =
    /*#__PURE__*/
    function (_Md46) {
      _inherits(qm, _Md46);

      function qm() {
        _classCallCheck(this, qm);

        return _possibleConstructorReturn(this, _getPrototypeOf(qm).apply(this, arguments));
      }

      _createClass(qm, [{
        key: "init",
        value: function init() {
          var _this228 = this;

          var t = this.editor;
          t.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: ["listType", "listIndent"]
          });
          var e = t.data,
              n = t.editing;
          var i;
          t.model.document.registerPostFixer(function (e) {
            return function (t, e) {
              var n = t.document.differ.getChanges(),
                  i = new Map();
              var o = !1;
              var _iteratorNormalCompletion330 = true;
              var _didIteratorError330 = false;
              var _iteratorError330 = undefined;

              try {
                for (var _iterator330 = n[Symbol.iterator](), _step330; !(_iteratorNormalCompletion330 = (_step330 = _iterator330.next()).done); _iteratorNormalCompletion330 = true) {
                  var _i186 = _step330.value;
                  if ("insert" == _i186.type && "listItem" == _i186.name) r(_i186.position);else if ("insert" == _i186.type && "listItem" != _i186.name) {
                    if ("$text" != _i186.name) {
                      var _n227 = _i186.position.nodeAfter;
                      _n227.hasAttribute("listIndent") && (e.removeAttribute("listIndent", _n227), o = !0), _n227.hasAttribute("listType") && (e.removeAttribute("listType", _n227), o = !0);
                      var _iteratorNormalCompletion332 = true;
                      var _didIteratorError332 = false;
                      var _iteratorError332 = undefined;

                      try {
                        for (var _iterator332 = Array.from(t.createRangeIn(_n227)).filter(function (t) {
                          return t.item.is("listItem");
                        })[Symbol.iterator](), _step332; !(_iteratorNormalCompletion332 = (_step332 = _iterator332.next()).done); _iteratorNormalCompletion332 = true) {
                          var _e259 = _step332.value;
                          r(_e259.previousPosition);
                        }
                      } catch (err) {
                        _didIteratorError332 = true;
                        _iteratorError332 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion332 && _iterator332.return != null) {
                            _iterator332.return();
                          }
                        } finally {
                          if (_didIteratorError332) {
                            throw _iteratorError332;
                          }
                        }
                      }
                    }

                    r(_i186.position.getShiftedBy(_i186.length));
                  } else "remove" == _i186.type && "listItem" == _i186.name ? r(_i186.position) : "attribute" == _i186.type && "listIndent" == _i186.attributeKey ? r(_i186.range.start) : "attribute" == _i186.type && "listType" == _i186.attributeKey && r(_i186.range.start);
                }
              } catch (err) {
                _didIteratorError330 = true;
                _iteratorError330 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion330 && _iterator330.return != null) {
                    _iterator330.return();
                  }
                } finally {
                  if (_didIteratorError330) {
                    throw _iteratorError330;
                  }
                }
              }

              var _iteratorNormalCompletion331 = true;
              var _didIteratorError331 = false;
              var _iteratorError331 = undefined;

              try {
                for (var _iterator331 = i.values()[Symbol.iterator](), _step331; !(_iteratorNormalCompletion331 = (_step331 = _iterator331.next()).done); _iteratorNormalCompletion331 = true) {
                  var _t281 = _step331.value;
                  s(_t281), a(_t281);
                }
              } catch (err) {
                _didIteratorError331 = true;
                _iteratorError331 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion331 && _iterator331.return != null) {
                    _iterator331.return();
                  }
                } finally {
                  if (_didIteratorError331) {
                    throw _iteratorError331;
                  }
                }
              }

              return o;

              function r(t) {
                var e = t.nodeBefore;

                if (e && e.is("listItem")) {
                  var _n226 = e;
                  if (i.has(_n226)) return;

                  for (; _n226.previousSibling && _n226.previousSibling.is("listItem");) {
                    if (_n226 = _n226.previousSibling, i.has(_n226)) return;
                  }

                  i.set(t.nodeBefore, _n226);
                } else {
                  var _e258 = t.nodeAfter;
                  _e258 && _e258.is("listItem") && i.set(_e258, _e258);
                }
              }

              function s(t) {
                var n = 0,
                    i = null;

                for (; t && t.is("listItem");) {
                  var _r47 = t.getAttribute("listIndent");

                  if (_r47 > n) {
                    var _s31 = void 0;

                    null === i ? (i = _r47 - n, _s31 = n) : (i > _r47 && (i = _r47), _s31 = _r47 - i), e.setAttribute("listIndent", _s31, t), o = !0;
                  } else i = null, n = t.getAttribute("listIndent") + 1;

                  t = t.nextSibling;
                }
              }

              function a(t) {
                var n = [],
                    i = null;

                for (; t && t.is("listItem");) {
                  var _r48 = t.getAttribute("listIndent");

                  if (i && i.getAttribute("listIndent") > _r48 && (n = n.slice(0, _r48 + 1)), 0 != _r48) if (n[_r48]) {
                    var _i185 = n[_r48];
                    t.getAttribute("listType") != _i185 && (e.setAttribute("listType", _i185, t), o = !0);
                  } else n[_r48] = t.getAttribute("listType");
                  i = t, t = t.nextSibling;
                }
              }
            }(t.model, e);
          }), n.mapper.registerViewToModelLength("li", Wm), e.mapper.registerViewToModelLength("li", Wm), n.mapper.on("modelToViewPosition", zm(n.view)), n.mapper.on("viewToModelPosition", (i = t.model, function (t, e) {
            var n = e.viewPosition,
                o = n.parent,
                r = e.mapper;

            if ("ul" == o.name || "ol" == o.name) {
              if (n.isAtEnd) {
                var _t282 = r.toModelElement(n.nodeBefore),
                    _o94 = r.getModelLength(n.nodeBefore);

                e.modelPosition = i.createPositionBefore(_t282).getShiftedBy(_o94);
              } else {
                var _t283 = r.toModelElement(n.nodeAfter);

                e.modelPosition = i.createPositionBefore(_t283);
              }

              t.stop();
            } else if ("li" == o.name && n.nodeBefore && ("ul" == n.nodeBefore.name || "ol" == n.nodeBefore.name)) {
              var _s32 = r.toModelElement(o);

              var _a17 = 1,
                  _c8 = n.nodeBefore;

              for (; _c8 && Hm(_c8);) {
                _a17 += r.getModelLength(_c8), _c8 = _c8.previousSibling;
              }

              e.modelPosition = i.createPositionBefore(_s32).getShiftedBy(_a17), t.stop();
            }
          })), e.mapper.on("modelToViewPosition", zm(n.view)), t.conversion.for("editingDowncast").add(function (e) {
            e.on("insert", Rm, {
              priority: "high"
            }), e.on("insert:listItem", Im(t.model)), e.on("attribute:listType:listItem", Nm, {
              priority: "high"
            }), e.on("attribute:listType:listItem", Om, {
              priority: "low"
            }), e.on("attribute:listIndent:listItem", function (t) {
              return function (e, n, i) {
                if (!i.consumable.consume(n.item, "attribute:listIndent")) return;
                var o = i.mapper.toViewElement(n.item),
                    r = i.writer;
                r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
                var s = o.parent,
                    a = s.previousSibling,
                    c = r.createRangeOn(s);
                r.remove(c), a && a.nextSibling && Cm(r, a, a.nextSibling), Um(n.attributeOldValue + 1, n.range.start, c.start, o, i, t), Tm(n.item, o, i, t);
                var _iteratorNormalCompletion333 = true;
                var _didIteratorError333 = false;
                var _iteratorError333 = undefined;

                try {
                  for (var _iterator333 = n.item.getChildren()[Symbol.iterator](), _step333; !(_iteratorNormalCompletion333 = (_step333 = _iterator333.next()).done); _iteratorNormalCompletion333 = true) {
                    var _t284 = _step333.value;
                    i.consumable.consume(_t284, "insert");
                  }
                } catch (err) {
                  _didIteratorError333 = true;
                  _iteratorError333 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion333 && _iterator333.return != null) {
                      _iterator333.return();
                    }
                  } finally {
                    if (_didIteratorError333) {
                      throw _iteratorError333;
                    }
                  }
                }
              };
            }(t.model)), e.on("remove:listItem", function (t) {
              return function (e, n, i) {
                var o = i.mapper.toViewPosition(n.position).getLastMatchingPosition(function (t) {
                  return !t.item.is("li");
                }).nodeAfter,
                    r = i.writer;
                r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
                var s = o.parent,
                    a = s.previousSibling,
                    c = r.createRangeOn(s),
                    l = r.remove(c);
                a && a.nextSibling && Cm(r, a, a.nextSibling), Um(i.mapper.toModelElement(o).getAttribute("listIndent") + 1, n.position, c.start, o, i, t);
                var _iteratorNormalCompletion334 = true;
                var _didIteratorError334 = false;
                var _iteratorError334 = undefined;

                try {
                  for (var _iterator334 = r.createRangeIn(l).getItems()[Symbol.iterator](), _step334; !(_iteratorNormalCompletion334 = (_step334 = _iterator334.next()).done); _iteratorNormalCompletion334 = true) {
                    var _t285 = _step334.value;
                    i.mapper.unbindViewElement(_t285);
                  }
                } catch (err) {
                  _didIteratorError334 = true;
                  _iteratorError334 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion334 && _iterator334.return != null) {
                      _iterator334.return();
                    }
                  } finally {
                    if (_didIteratorError334) {
                      throw _iteratorError334;
                    }
                  }
                }

                e.stop();
              };
            }(t.model)), e.on("remove", Dm, {
              priority: "low"
            });
          }), t.conversion.for("dataDowncast").add(function (e) {
            e.on("insert", Rm, {
              priority: "high"
            }), e.on("insert:listItem", Im(t.model));
          }), t.conversion.for("upcast").add(function (t) {
            t.on("element:ul", jm, {
              priority: "high"
            }), t.on("element:ol", jm, {
              priority: "high"
            }), t.on("element:li", Vm, {
              priority: "high"
            }), t.on("element:li", Lm);
          }), t.model.on("insertContent", Bm, {
            priority: "high"
          }), t.commands.add("numberedList", new _m(t, "numbered")), t.commands.add("bulletedList", new _m(t, "bulleted")), t.commands.add("indentList", new xm(t, "forward")), t.commands.add("outdentList", new xm(t, "backward"));
          var o = n.view.document;
          this.listenTo(o, "enter", function (t, e) {
            var n = _this228.editor.model.document,
                i = n.selection.getLastPosition().parent;
            n.selection.isCollapsed && "listItem" == i.name && i.isEmpty && (_this228.editor.execute("outdentList"), e.preventDefault(), t.stop());
          }), this.listenTo(o, "delete", function (t, e) {
            if ("backward" !== e.direction) return;
            var n = _this228.editor.model.document.selection;
            if (!n.isCollapsed) return;
            var i = n.getFirstPosition();
            if (!i.isAtStart) return;
            var o = i.parent;
            "listItem" === o.name && (o.previousSibling && "listItem" === o.previousSibling.name || (_this228.editor.execute("outdentList"), e.preventDefault(), t.stop()));
          }, {
            priority: "high"
          });

          var r = function r(t) {
            return function (e, n) {
              _this228.editor.commands.get(t).isEnabled && (_this228.editor.execute(t), n());
            };
          };

          t.keystrokes.set("Tab", r("indentList")), t.keystrokes.set("Shift+Tab", r("outdentList"));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor.commands,
              e = t.get("indent"),
              n = t.get("outdent");
          e && e.registerChildCommand(t.get("indentList")), n && n.registerChildCommand(t.get("outdentList"));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ListEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Mg];
        }
      }]);

      return qm;
    }(Md);

    function Wm(t) {
      var e = 1;
      var _iteratorNormalCompletion335 = true;
      var _didIteratorError335 = false;
      var _iteratorError335 = undefined;

      try {
        for (var _iterator335 = t.getChildren()[Symbol.iterator](), _step335; !(_iteratorNormalCompletion335 = (_step335 = _iterator335.next()).done); _iteratorNormalCompletion335 = true) {
          var _n228 = _step335.value;

          if ("ul" == _n228.name || "ol" == _n228.name) {
            var _iteratorNormalCompletion336 = true;
            var _didIteratorError336 = false;
            var _iteratorError336 = undefined;

            try {
              for (var _iterator336 = _n228.getChildren()[Symbol.iterator](), _step336; !(_iteratorNormalCompletion336 = (_step336 = _iterator336.next()).done); _iteratorNormalCompletion336 = true) {
                var _t286 = _step336.value;
                e += Wm(_t286);
              }
            } catch (err) {
              _didIteratorError336 = true;
              _iteratorError336 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion336 && _iterator336.return != null) {
                  _iterator336.return();
                }
              } finally {
                if (_didIteratorError336) {
                  throw _iteratorError336;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError335 = true;
        _iteratorError335 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion335 && _iterator335.return != null) {
            _iterator335.return();
          }
        } finally {
          if (_didIteratorError335) {
            throw _iteratorError335;
          }
        }
      }

      return e;
    }

    var Ym = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
        $m = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';

    var Gm =
    /*#__PURE__*/
    function (_Md47) {
      _inherits(Gm, _Md47);

      function Gm() {
        _classCallCheck(this, Gm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Gm).apply(this, arguments));
      }

      _createClass(Gm, [{
        key: "init",
        value: function init() {
          var t = this.editor.t;
          Mm(this.editor, "numberedList", t("ae"), Ym), Mm(this.editor, "bulletedList", t("af"), $m);
        }
      }]);

      return Gm;
    }(Md);

    function Qm(t, e) {
      return function (t) {
        t.on("attribute:url:media", n);
      };

      function n(n, i, o) {
        if (!o.consumable.consume(i.item, n.name)) return;
        var r = i.attributeNewValue,
            s = o.writer,
            a = o.mapper.toViewElement(i.item);
        s.remove(s.createRangeIn(a));
        var c = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), c);
      }
    }

    function Km(t, e, n, i) {
      var o = t.createContainerElement("figure", {
        class: "media"
      });
      return o.getFillerOffset = Xm, t.insert(t.createPositionAt(o, 0), e.getMediaViewElement(t, n, i)), o;
    }

    function Jm(t) {
      var e = t.getSelectedElement();
      return e && e.is("media") ? e : null;
    }

    function Zm(t, e, n) {
      t.change(function (i) {
        var o = i.createElement("media", {
          url: e
        });
        t.insertContent(o, n), i.setSelection(o, "on");
      });
    }

    function Xm() {
      return null;
    }

    var tp =
    /*#__PURE__*/
    function (_Rd20) {
      _inherits(tp, _Rd20);

      function tp() {
        _classCallCheck(this, tp);

        return _possibleConstructorReturn(this, _getPrototypeOf(tp).apply(this, arguments));
      }

      _createClass(tp, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema,
              i = e.getFirstPosition(),
              o = Jm(e);
          var r = i.parent;
          r != r.root && (r = r.parent), this.value = o ? o.getAttribute("url") : null, this.isEnabled = n.checkChild(r, "media");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document.selection,
              i = Jm(n);
          if (i) e.change(function (e) {
            e.setAttribute("url", t, i);
          });else {
            var _i187 = _u(n, e);

            Zm(e, t, _i187);
          }
        }
      }]);

      return tp;
    }(Rd);

    var ep = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>';
    var np = "0 0 64 42";

    var ip =
    /*#__PURE__*/
    function () {
      function ip(t, e) {
        _classCallCheck(this, ip);

        var n = e.providers,
            i = e.extraProviders || [],
            o = new Set(e.removeProviders),
            r = n.concat(i).filter(function (t) {
          var e = t.name;
          return e ? !o.has(e) : (console.warn(Object(Qn.a)("media-embed-no-provider-name: The configured media provider has no name and cannot be used."), {
            provider: t
          }), !1);
        });
        this.locale = t, this.providerDefinitions = r;
      }

      _createClass(ip, [{
        key: "hasMedia",
        value: function hasMedia(t) {
          return !!this._getMedia(t);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(t, e, n) {
          return this._getMedia(e).getViewElement(t, n);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(t) {
          if (!t) return new op(this.locale);
          t = t.trim();
          var _iteratorNormalCompletion337 = true;
          var _didIteratorError337 = false;
          var _iteratorError337 = undefined;

          try {
            for (var _iterator337 = this.providerDefinitions[Symbol.iterator](), _step337; !(_iteratorNormalCompletion337 = (_step337 = _iterator337.next()).done); _iteratorNormalCompletion337 = true) {
              var _e260 = _step337.value;
              var _n229 = _e260.html;
              var _i188 = _e260.url;
              Array.isArray(_i188) || (_i188 = [_i188]);
              var _iteratorNormalCompletion338 = true;
              var _didIteratorError338 = false;
              var _iteratorError338 = undefined;

              try {
                for (var _iterator338 = _i188[Symbol.iterator](), _step338; !(_iteratorNormalCompletion338 = (_step338 = _iterator338.next()).done); _iteratorNormalCompletion338 = true) {
                  var _e261 = _step338.value;

                  var _i189 = this._getUrlMatches(t, _e261);

                  if (_i189) return new op(this.locale, t, _i189, _n229);
                }
              } catch (err) {
                _didIteratorError338 = true;
                _iteratorError338 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion338 && _iterator338.return != null) {
                    _iterator338.return();
                  }
                } finally {
                  if (_didIteratorError338) {
                    throw _iteratorError338;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError337 = true;
            _iteratorError337 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion337 && _iterator337.return != null) {
                _iterator337.return();
              }
            } finally {
              if (_didIteratorError337) {
                throw _iteratorError337;
              }
            }
          }

          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(t, e) {
          var n = t.match(e);
          if (n) return n;
          var i = t.replace(/^https?:\/\//, "");
          return n = i.match(e), n || (i = i.replace(/^www\./, ""), n = i.match(e), n || null);
        }
      }]);

      return ip;
    }();

    var op =
    /*#__PURE__*/
    function () {
      function op(t, e, n, i) {
        _classCallCheck(this, op);

        this.url = this._getValidUrl(e), this._t = t.t, this._match = n, this._previewRenderer = i;
      }

      _createClass(op, [{
        key: "getViewElement",
        value: function getViewElement(t, e) {
          var n = {};

          if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");

            var _i190 = this._getPreviewHtml(e);

            return t.createUIElement("div", n, function (t) {
              var e = this.toDomElement(t);
              return e.innerHTML = _i190, e;
            });
          }

          return this.url && (n.url = this.url), t.createEmptyElement("oembed", n);
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(t) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var t = new hd(),
              e = new dd();
          return t.text = this._t("Open media in new tab"), e.content = ep, e.viewBox = np, new Cl({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [e]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, t]
            }]
          }).render().outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(t) {
          return t ? t.match(/^https?/) ? t : "https://" + t : null;
        }
      }]);

      return op;
    }();

    n(78);

    var rp =
    /*#__PURE__*/
    function (_Md48) {
      _inherits(rp, _Md48);

      _createClass(rp, null, [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);

      function rp(t) {
        var _this229;

        _classCallCheck(this, rp);

        _this229 = _possibleConstructorReturn(this, _getPrototypeOf(rp).call(this, t)), t.config.define("mediaEmbed", {
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; ">' + "<iframe src=\"https://www.dailymotion.com/embed/video/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>';
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' + "<iframe src=\"https://open.spotify.com/embed/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>';
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://www.youtube.com/embed/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://player.vimeo.com/video/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: /^google\.com\/maps/
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), _this229.registry = new ip(t.locale, t.config.get("mediaEmbed"));
        return _this229;
      }

      _createClass(rp, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.t,
              i = t.conversion,
              o = t.config.get("mediaEmbed.previewsInData"),
              r = this.registry;
          t.commands.add("mediaEmbed", new tp(t)), e.register("media", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["url"]
          }), i.for("dataDowncast").elementToElement({
            model: "media",
            view: function view(t, e) {
              var n = t.getAttribute("url");
              return Km(e, r, n, {
                renderMediaPreview: n && o
              });
            }
          }), i.for("dataDowncast").add(Qm(r, {
            renderMediaPreview: o
          })), i.for("editingDowncast").elementToElement({
            model: "media",
            view: function view(t, e) {
              var i = t.getAttribute("url");
              return function (t, e, n) {
                return e.setCustomProperty("media", !0, t), bu(t, e, {
                  label: n
                });
              }(Km(e, r, i, {
                renderForEditingView: !0
              }), e, n("ar"));
            }
          }), i.for("editingDowncast").add(Qm(r, {
            renderForEditingView: !0
          })), i.for("upcast").elementToElement({
            view: {
              name: "oembed",
              attributes: {
                url: !0
              }
            },
            model: function model(t, e) {
              var n = t.getAttribute("url");
              if (r.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": !0
              }
            },
            model: function model(t, e) {
              var n = t.getAttribute("data-oembed-url");
              if (r.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          });
        }
      }]);

      return rp;
    }(Md);

    var sp = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;

    var ap =
    /*#__PURE__*/
    function (_Md49) {
      _inherits(ap, _Md49);

      _createClass(ap, null, [{
        key: "requires",
        get: function get() {
          return [Od, Th];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);

      function ap(t) {
        var _this230;

        _classCallCheck(this, ap);

        _this230 = _possibleConstructorReturn(this, _getPrototypeOf(ap).call(this, t)), _this230._timeoutId = null, _this230._positionToInsert = null;
        return _this230;
      }

      _createClass(ap, [{
        key: "init",
        value: function init() {
          var _this231 = this;

          var t = this.editor,
              e = t.model.document;
          this.listenTo(t.plugins.get(Od), "inputTransformation", function () {
            var t = e.selection.getFirstRange(),
                n = Uc.fromPosition(t.start);
            n.stickiness = "toPrevious";
            var i = Uc.fromPosition(t.end);
            i.stickiness = "toNext", e.once("change:data", function () {
              _this231._embedMediaBetweenPositions(n, i), n.detach(), i.detach();
            }, {
              priority: "high"
            });
          }), t.commands.get("undo").on("execute", function () {
            _this231._timeoutId && (ir.window.clearTimeout(_this231._timeoutId), _this231._positionToInsert.detach(), _this231._timeoutId = null, _this231._positionToInsert = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(t, e) {
          var _this232 = this;

          var n = this.editor,
              i = n.plugins.get(rp).registry,
              o = new ca(t, e),
              r = o.getWalker({
            ignoreElementEnd: !0
          });
          var s = "";
          var _iteratorNormalCompletion339 = true;
          var _didIteratorError339 = false;
          var _iteratorError339 = undefined;

          try {
            for (var _iterator339 = r[Symbol.iterator](), _step339; !(_iteratorNormalCompletion339 = (_step339 = _iterator339.next()).done); _iteratorNormalCompletion339 = true) {
              var _t287 = _step339.value;
              _t287.item.is("textProxy") && (s += _t287.item.data);
            }
          } catch (err) {
            _didIteratorError339 = true;
            _iteratorError339 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion339 && _iterator339.return != null) {
                _iterator339.return();
              }
            } finally {
              if (_didIteratorError339) {
                throw _iteratorError339;
              }
            }
          }

          if (s = s.trim(), !s.match(sp)) return;
          if (!i.hasMedia(s)) return;
          n.commands.get("mediaEmbed").isEnabled && (this._positionToInsert = Uc.fromPosition(t), this._timeoutId = ir.window.setTimeout(function () {
            n.model.change(function (t) {
              var e;
              _this232._timeoutId = null, t.remove(o), "$graveyard" !== _this232._positionToInsert.root.rootName && (e = _this232._positionToInsert), Zm(n.model, s, e), _this232._positionToInsert.detach(), _this232._positionToInsert = null;
            });
          }, 100));
        }
      }]);

      return ap;
    }(Md);

    n(80);

    var cp =
    /*#__PURE__*/
    function (_Wl26) {
      _inherits(cp, _Wl26);

      function cp(t, e) {
        var _this233;

        _classCallCheck(this, cp);

        _this233 = _possibleConstructorReturn(this, _getPrototypeOf(cp).call(this, e));
        var n = e.t;
        _this233.focusTracker = new ml(), _this233.keystrokes = new sl(), _this233.urlInputView = _this233._createUrlInput(), _this233.saveButtonView = _this233._createButton(n("bf"), Uf, "ck-button-save"), _this233.saveButtonView.type = "submit", _this233.cancelButtonView = _this233._createButton(n("bg"), Hf, "ck-button-cancel", "cancel"), _this233._focusables = new Al(), _this233._focusCycler = new td({
          focusables: _this233._focusables,
          focusTracker: _this233.focusTracker,
          keystrokeHandler: _this233.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this233._validators = t, _this233.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form"],
            tabindex: "-1"
          },
          children: [_this233.urlInputView, _this233.saveButtonView, _this233.cancelButtonView]
        });
        return _this233;
      }

      _createClass(cp, [{
        key: "render",
        value: function render() {
          var _this234 = this;

          _get(_getPrototypeOf(cp.prototype), "render", this).call(this), Ff({
            view: this
          }), [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this234._focusables.add(t), _this234.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);

          var t = function t(_t288) {
            return _t288.stopPropagation();
          };

          this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t), this.listenTo(this.urlInputView.element, "selectstart", function (t, e) {
            e.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();
          var _iteratorNormalCompletion340 = true;
          var _didIteratorError340 = false;
          var _iteratorError340 = undefined;

          try {
            for (var _iterator340 = this._validators[Symbol.iterator](), _step340; !(_iteratorNormalCompletion340 = (_step340 = _iterator340.next()).done); _iteratorNormalCompletion340 = true) {
              var _t289 = _step340.value;

              var _e262 = _t289(this);

              if (_e262) return this.urlInputView.errorText = _e262, !1;
            }
          } catch (err) {
            _didIteratorError340 = true;
            _iteratorError340 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion340 && _iterator340.return != null) {
                _iterator340.return();
              }
            } finally {
              if (_didIteratorError340) {
                throw _iteratorError340;
              }
            }
          }

          return !0;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this235 = this;

          var t = this.locale.t,
              e = new zf(this.locale, Bf),
              n = e.inputView;
          return this._urlInputViewInfoDefault = t("bh"), this._urlInputViewInfoTip = t("bi"), e.label = t("bj"), e.infoText = this._urlInputViewInfoDefault, n.placeholder = "https://example.com", n.on("input", function () {
            e.infoText = n.element.value ? _this235._urlInputViewInfoTip : _this235._urlInputViewInfoDefault;
          }), e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new ud(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.inputView.element.value.trim();
        },
        set: function set(t) {
          this.urlInputView.inputView.element.value = t.trim();
        }
      }]);

      return cp;
    }(Wl);

    var lp = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18.68 2.53c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.08c0-.58-.01-.55.6-.55h17.38zM15.77 14.5v-10H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 6.677a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V6.676z"/></svg>';

    var dp =
    /*#__PURE__*/
    function (_Md50) {
      _inherits(dp, _Md50);

      function dp() {
        _classCallCheck(this, dp);

        return _possibleConstructorReturn(this, _getPrototypeOf(dp).apply(this, arguments));
      }

      _createClass(dp, [{
        key: "init",
        value: function init() {
          var _this236 = this;

          var t = this.editor,
              e = t.commands.get("mediaEmbed"),
              n = t.plugins.get(rp).registry;
          this.form = new cp(function (t, e) {
            return [function (e) {
              if (!e.url.length) return t("ap");
            }, function (n) {
              if (!e.hasMedia(n.url)) return t("aq");
            }];
          }(t.t, n), t.locale), t.ui.componentFactory.add("mediaEmbed", function (n) {
            var i = _d(n);

            return _this236._setUpDropdown(i, _this236.form, e, t), _this236._setUpForm(_this236.form, i, e), i;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(t, e, n) {
          var i = this.editor,
              o = i.t,
              r = t.buttonView;

          function s() {
            i.editing.view.focus(), t.isOpen = !1;
          }

          t.bind("isEnabled").to(n), t.panelView.children.add(e), r.set({
            label: o("ao"),
            icon: lp,
            tooltip: !0
          }), r.on("open", function () {
            e.url = n.value || "", e.urlInputView.select(), e.focus();
          }, {
            priority: "low"
          }), t.on("submit", function () {
            e.isValid() && (i.execute("mediaEmbed", e.url), s());
          }), t.on("change:isOpen", function () {
            return e.resetFormStatus();
          }), t.on("cancel", function () {
            return s();
          });
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(t, e, n) {
          t.delegate("submit", "cancel").to(e), t.urlInputView.bind("value").to(n, "value"), t.urlInputView.bind("isReadOnly").to(n, "isEnabled", function (t) {
            return !t;
          }), t.saveButtonView.bind("isEnabled").to(n);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [rp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);

      return dp;
    }(Md);

    n(82);

    function hp(t, e) {
      if (!t.childCount) return;

      var n = new vg(),
          i = function (t, e) {
        var n = e.createRangeIn(t),
            i = new wi({
          name: /^p|h\d+$/,
          styles: {
            "mso-list": /.*/
          }
        }),
            o = [];
        var _iteratorNormalCompletion341 = true;
        var _didIteratorError341 = false;
        var _iteratorError341 = undefined;

        try {
          for (var _iterator341 = n[Symbol.iterator](), _step341; !(_iteratorNormalCompletion341 = (_step341 = _iterator341.next()).done); _iteratorNormalCompletion341 = true) {
            var _t290 = _step341.value;

            if ("elementStart" === _t290.type && i.match(_t290.item)) {
              var _e263 = up(_t290.item);

              o.push({
                element: _t290.item,
                id: _e263.id,
                order: _e263.order,
                indent: _e263.indent
              });
            }
          }
        } catch (err) {
          _didIteratorError341 = true;
          _iteratorError341 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion341 && _iterator341.return != null) {
              _iterator341.return();
            }
          } finally {
            if (_didIteratorError341) {
              throw _iteratorError341;
            }
          }
        }

        return o;
      }(t, n);

      if (!i.length) return;
      var o = null;
      i.forEach(function (t, r) {
        if (!o || function (t, e) {
          if (t.id !== e.id) return !0;
          var n = e.element.previousSibling;
          if (!n) return !0;
          return i = n, !(i.is("ol") || i.is("ul"));
          var i;
        }(i[r - 1], t)) {
          var _i191 = function (t, e) {
            var n = new RegExp("@list l".concat(t.id, ":level").concat(t.indent, "\\s*({[^}]*)"), "gi"),
                i = /mso-level-number-format:([^;]*);/gi,
                o = n.exec(e);
            var r = "decimal";

            if (o && o[1]) {
              var _t291 = i.exec(o[1]);

              _t291 && _t291[1] && (r = _t291[1].trim());
            }

            return {
              type: "bullet" !== r && "image" !== r ? "ol" : "ul",
              style: r
            };
          }(t, e);

          o = function (t, e, n) {
            var i = new _i(t.type),
                o = e.parent.getChildIndex(e);
            return n.insertChild(o, i, e.parent), i;
          }(_i191, t.element, n);
        }

        var s = function (t, e) {
          return function (t, e) {
            var n = new wi({
              name: "span",
              styles: {
                "mso-list": "Ignore"
              }
            }),
                i = e.createRangeIn(t);
            var _iteratorNormalCompletion342 = true;
            var _didIteratorError342 = false;
            var _iteratorError342 = undefined;

            try {
              for (var _iterator342 = i[Symbol.iterator](), _step342; !(_iteratorNormalCompletion342 = (_step342 = _iterator342.next()).done); _iteratorNormalCompletion342 = true) {
                var _t292 = _step342.value;
                "elementStart" === _t292.type && n.match(_t292.item) && e.remove(_t292.item);
              }
            } catch (err) {
              _didIteratorError342 = true;
              _iteratorError342 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion342 && _iterator342.return != null) {
                  _iterator342.return();
                }
              } finally {
                if (_didIteratorError342) {
                  throw _iteratorError342;
                }
              }
            }
          }(t, e), e.rename("li", t);
        }(t.element, n);

        n.appendChild(s, o);
      });
    }

    function up(t) {
      var e = {},
          n = t.getStyle("mso-list");

      if (n) {
        var _t293 = n.match(/(^|\s+)l(\d+)/i),
            _i192 = n.match(/\s*lfo(\d+)/i),
            _o95 = n.match(/\s*level(\d+)/i);

        _t293 && _i192 && _o95 && (e.id = _t293[2], e.order = _i192[1], e.indent = _o95[1]);
      }

      return e;
    }

    var fp = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;

    var gp =
    /*#__PURE__*/
    function () {
      function gp() {
        _classCallCheck(this, gp);
      }

      _createClass(gp, [{
        key: "isActive",
        value: function isActive(t) {
          return fp.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = new vg();
          !function (t, e) {
            var _iteratorNormalCompletion343 = true;
            var _didIteratorError343 = false;
            var _iteratorError343 = undefined;

            try {
              for (var _iterator343 = t.getChildren()[Symbol.iterator](), _step343; !(_iteratorNormalCompletion343 = (_step343 = _iterator343.next()).done); _iteratorNormalCompletion343 = true) {
                var _n230 = _step343.value;

                if (_n230.is("b") && "normal" === _n230.getStyle("font-weight")) {
                  var _i193 = t.getChildIndex(_n230);

                  e.remove(_n230), e.insertChild(_i193, _n230.getChildren(), t);
                }
              }
            } catch (err) {
              _didIteratorError343 = true;
              _iteratorError343 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion343 && _iterator343.return != null) {
                  _iterator343.return();
                }
              } finally {
                if (_didIteratorError343) {
                  throw _iteratorError343;
                }
              }
            }
          }(t.content, e), function (t, e) {
            var _iteratorNormalCompletion344 = true;
            var _didIteratorError344 = false;
            var _iteratorError344 = undefined;

            try {
              for (var _iterator344 = e.createRangeIn(t)[Symbol.iterator](), _step344; !(_iteratorNormalCompletion344 = (_step344 = _iterator344.next()).done); _iteratorNormalCompletion344 = true) {
                var _n231 = _step344.value;
                var _t294 = _n231.item;

                if (_t294.is("li")) {
                  var _n232 = _t294.getChild(0);

                  _n232.is("p") && e.unwrapElement(_n232);
                }
              }
            } catch (err) {
              _didIteratorError344 = true;
              _iteratorError344 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion344 && _iterator344.return != null) {
                  _iterator344.return();
                }
              } finally {
                if (_didIteratorError344) {
                  throw _iteratorError344;
                }
              }
            }
          }(t.content, e);
        }
      }]);

      return gp;
    }();

    function mp(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
        return 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length);
      });
    }

    function pp(t) {
      var e = new DOMParser(),
          n = function (t) {
        return mp(mp(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>(\s*[\r\n]\s*)</g, "><");
      }(function (t) {
        var e = t.match(/<\/body>(.*?)(<\/html>|$)/);
        e && e[1] && (t = t.slice(0, e.index) + t.slice(e.index).replace(e[1], ""));
        return t;
      }(t = t.replace(/<!--\[if gte vml 1]>/g, ""))),
          i = e.parseFromString(n, "text/html");

      !function (t) {
        t.querySelectorAll("span[style*=spacerun]").forEach(function (t) {
          var e = t.childNodes && t.childNodes[0] && t.childNodes[0].data && t.childNodes[0].data.length || 0;
          t.innerHTML = Array(e + 1).join("  ").substr(0, e);
        });
      }(i);

      var o = i.body.innerHTML,
          r = function (t) {
        var e = new ar({
          blockFillerMode: "nbsp"
        }),
            n = t.createDocumentFragment(),
            i = t.body.childNodes;

        for (; i.length > 0;) {
          n.appendChild(i[0]);
        }

        return e.domToView(n);
      }(i),
          s = function (t) {
        var e = [],
            n = [],
            i = Array.from(t.getElementsByTagName("style"));

        for (var _i195 = 0, _i194 = i; _i195 < _i194.length; _i195++) {
          var _t295 = _i194[_i195];
          _t295.sheet && _t295.sheet.cssRules && _t295.sheet.cssRules.length && (e.push(_t295.sheet), n.push(_t295.innerHTML));
        }

        return {
          styles: e,
          stylesString: n.join(" ")
        };
      }(i);

      return {
        body: r,
        bodyString: o,
        styles: s.styles,
        stylesString: s.stylesString
      };
    }

    function bp(t, e) {
      if (!t.childCount) return;
      var n = new vg();
      !function (t, e, n) {
        var i = n.createRangeIn(e),
            o = new wi({
          name: "img"
        }),
            r = [];
        var _iteratorNormalCompletion345 = true;
        var _didIteratorError345 = false;
        var _iteratorError345 = undefined;

        try {
          for (var _iterator345 = i[Symbol.iterator](), _step345; !(_iteratorNormalCompletion345 = (_step345 = _iterator345.next()).done); _iteratorNormalCompletion345 = true) {
            var _e264 = _step345.value;

            if (o.match(_e264.item)) {
              var _n233 = _e264.item,
                  _i197 = _n233.getAttribute("v:shapes") ? _n233.getAttribute("v:shapes").split(" ") : [];

              _i197.length && _i197.every(function (e) {
                return t.indexOf(e) > -1;
              }) ? r.push(_n233) : _n233.getAttribute("src") || r.push(_n233);
            }
          }
        } catch (err) {
          _didIteratorError345 = true;
          _iteratorError345 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion345 && _iterator345.return != null) {
              _iterator345.return();
            }
          } finally {
            if (_didIteratorError345) {
              throw _iteratorError345;
            }
          }
        }

        for (var _i196 = 0, _r49 = r; _i196 < _r49.length; _i196++) {
          var _t296 = _r49[_i196];
          n.remove(_t296);
        }
      }(function (t, e) {
        var n = e.createRangeIn(t),
            i = new wi({
          name: /v:(.+)/
        }),
            o = [];
        var _iteratorNormalCompletion346 = true;
        var _didIteratorError346 = false;
        var _iteratorError346 = undefined;

        try {
          for (var _iterator346 = n[Symbol.iterator](), _step346; !(_iteratorNormalCompletion346 = (_step346 = _iterator346.next()).done); _iteratorNormalCompletion346 = true) {
            var _t297 = _step346.value;

            var _e265 = _t297.item,
                _n234 = _e265.previousSibling && _e265.previousSibling.name || null;

            i.match(_e265) && _e265.getAttribute("o:gfxdata") && "v:shapetype" !== _n234 && o.push(_t297.item.getAttribute("id"));
          }
        } catch (err) {
          _didIteratorError346 = true;
          _iteratorError346 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion346 && _iterator346.return != null) {
              _iterator346.return();
            }
          } finally {
            if (_didIteratorError346) {
              throw _iteratorError346;
            }
          }
        }

        return o;
      }(t, n), t, n), function (t, e) {
        var n = e.createRangeIn(t),
            i = new wi({
          name: /v:(.+)/
        }),
            o = [];
        var _iteratorNormalCompletion347 = true;
        var _didIteratorError347 = false;
        var _iteratorError347 = undefined;

        try {
          for (var _iterator347 = n[Symbol.iterator](), _step347; !(_iteratorNormalCompletion347 = (_step347 = _iterator347.next()).done); _iteratorNormalCompletion347 = true) {
            var _t298 = _step347.value;
            i.match(_t298.item) && o.push(_t298.item);
          }
        } catch (err) {
          _didIteratorError347 = true;
          _iteratorError347 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion347 && _iterator347.return != null) {
              _iterator347.return();
            }
          } finally {
            if (_didIteratorError347) {
              throw _iteratorError347;
            }
          }
        }

        for (var _i198 = 0, _o96 = o; _i198 < _o96.length; _i198++) {
          var _t299 = _o96[_i198];
          e.remove(_t299);
        }
      }(t, n);

      var i = function (t, e) {
        var n = e.createRangeIn(t),
            i = new wi({
          name: "img"
        }),
            o = [];
        var _iteratorNormalCompletion348 = true;
        var _didIteratorError348 = false;
        var _iteratorError348 = undefined;

        try {
          for (var _iterator348 = n[Symbol.iterator](), _step348; !(_iteratorNormalCompletion348 = (_step348 = _iterator348.next()).done); _iteratorNormalCompletion348 = true) {
            var _t300 = _step348.value;
            i.match(_t300.item) && _t300.item.getAttribute("src").startsWith("file://") && o.push(_t300.item);
          }
        } catch (err) {
          _didIteratorError348 = true;
          _iteratorError348 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion348 && _iterator348.return != null) {
              _iterator348.return();
            }
          } finally {
            if (_didIteratorError348) {
              throw _iteratorError348;
            }
          }
        }

        return o;
      }(t, n);

      i.length && function (t, e, n) {
        if (t.length === e.length) for (var _o97 = 0; _o97 < t.length; _o97++) {
          var _r50 = "data:".concat(e[_o97].type, ";base64,").concat((i = e[_o97].hex, btoa(i.match(/\w{2}/g).map(function (t) {
            return String.fromCharCode(parseInt(t, 16));
          }).join(""))));

          n.setAttribute("src", _r50, t[_o97]);
        }
        var i;
      }(i, function (t) {
        if (!t) return [];
        var e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
            n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
            i = t.match(n),
            o = [];

        if (i) {
          var _iteratorNormalCompletion349 = true;
          var _didIteratorError349 = false;
          var _iteratorError349 = undefined;

          try {
            for (var _iterator349 = i[Symbol.iterator](), _step349; !(_iteratorNormalCompletion349 = (_step349 = _iterator349.next()).done); _iteratorNormalCompletion349 = true) {
              var _t301 = _step349.value;

              var _n235 = !1;

              _t301.includes("\\pngblip") ? _n235 = "image/png" : _t301.includes("\\jpegblip") && (_n235 = "image/jpeg"), _n235 && o.push({
                hex: _t301.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                type: _n235
              });
            }
          } catch (err) {
            _didIteratorError349 = true;
            _iteratorError349 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion349 && _iterator349.return != null) {
                _iterator349.return();
              }
            } finally {
              if (_didIteratorError349) {
                throw _iteratorError349;
              }
            }
          }
        }

        return o;
      }(e), n);
    }

    var wp = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
        kp = /xmlns:o="urn:schemas-microsoft-com/i;

    var _p =
    /*#__PURE__*/
    function () {
      function _p() {
        _classCallCheck(this, _p);
      }

      _createClass(_p, [{
        key: "isActive",
        value: function isActive(t) {
          return wp.test(t) || kp.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _pp = pp(t.dataTransfer.getData("text/html")),
              e = _pp.body,
              n = _pp.stylesString;

          hp(e, n), bp(e, t.dataTransfer.getData("text/rtf")), t.content = e;
        }
      }]);

      return _p;
    }();

    function vp(t, e) {
      var n = e.parent;

      for (; n;) {
        if (n.name === t) return n;
        n = n.parent;
      }
    }

    function yp(t, e, n, i) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      e > o ? i.setAttribute(t, e, n) : i.removeAttribute(t, n);
    }

    function xp(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.createElement("tableCell", n);
      t.insertElement("paragraph", i), t.insert(i, e);
    }

    function Ap() {
      return function (t) {
        t.on("element:table", function (t, e, n) {
          var i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;

          var _ref108 = function (t) {
            var e = {
              headingRows: 0,
              headingColumns: 0
            },
                n = [],
                i = [];
            var o;

            for (var _i199 = 0, _Array$from7 = Array.from(t.getChildren()); _i199 < _Array$from7.length; _i199++) {
              var _r51 = _Array$from7[_i199];

              if ("tbody" === _r51.name || "thead" === _r51.name || "tfoot" === _r51.name) {
                "thead" !== _r51.name || o || (o = _r51);

                var _t302 = Array.from(_r51.getChildren()).filter(function (t) {
                  return t.is("element", "tr");
                });

                var _iteratorNormalCompletion350 = true;
                var _didIteratorError350 = false;
                var _iteratorError350 = undefined;

                try {
                  for (var _iterator350 = _t302[Symbol.iterator](), _step350; !(_iteratorNormalCompletion350 = (_step350 = _iterator350.next()).done); _iteratorNormalCompletion350 = true) {
                    var _r52 = _step350.value;
                    if ("thead" === _r52.parent.name && _r52.parent === o) e.headingRows++, n.push(_r52);else {
                      i.push(_r52);

                      var _t303 = Cp(_r52);

                      _t303 > e.headingColumns && (e.headingColumns = _t303);
                    }
                  }
                } catch (err) {
                  _didIteratorError350 = true;
                  _iteratorError350 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion350 && _iterator350.return != null) {
                      _iterator350.return();
                    }
                  } finally {
                    if (_didIteratorError350) {
                      throw _iteratorError350;
                    }
                  }
                }
              }
            }

            return e.rows = [].concat(n, i), e;
          }(i),
              o = _ref108.rows,
              r = _ref108.headingRows,
              s = _ref108.headingColumns,
              a = {};

          s && (a.headingColumns = s), r && (a.headingRows = r);
          var c = n.writer.createElement("table", a),
              l = n.splitToAllowedParent(c, e.modelCursor);

          if (l) {
            if (n.writer.insert(c, l.position), n.consumable.consume(i, {
              name: !0
            }), o.length) o.forEach(function (t) {
              return n.convertItem(t, n.writer.createPositionAt(c, "end"));
            });else {
              var _t304 = n.writer.createElement("tableRow");

              n.writer.insert(_t304, n.writer.createPositionAt(c, "end")), xp(n.writer, n.writer.createPositionAt(_t304, "end"));
            }
            e.modelRange = n.writer.createRange(n.writer.createPositionBefore(c), n.writer.createPositionAfter(c)), l.cursorParent ? e.modelCursor = n.writer.createPositionAt(l.cursorParent, 0) : e.modelCursor = e.modelRange.end;
          }
        });
      };
    }

    function Tp(t) {
      return function (e) {
        e.on("element:".concat(t), function (t, e, n) {
          var i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;
          var o = n.writer.createElement("tableCell"),
              r = n.splitToAllowedParent(o, e.modelCursor);
          if (!r) return;
          n.writer.insert(o, r.position), n.consumable.consume(i, {
            name: !0
          });
          var s = n.writer.createPositionAt(o, 0);
          n.convertChildren(i, s), o.childCount || n.writer.insertElement("paragraph", s), e.modelRange = n.writer.createRange(n.writer.createPositionBefore(o), n.writer.createPositionAfter(o)), e.modelCursor = e.modelRange.end;
        });
      };
    }

    function Cp(t) {
      var e = 0,
          n = 0;
      var i = Array.from(t.getChildren()).filter(function (t) {
        return "th" === t.name || "td" === t.name;
      });

      for (; n < i.length && "th" === i[n].name;) {
        var _t305 = i[n];
        e += parseInt(_t305.getAttribute("colspan") || 1), n++;
      }

      return e;
    }

    var Pp =
    /*#__PURE__*/
    function () {
      function Pp(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Pp);

        this.table = t, this.startRow = e.startRow || 0, this.endRow = "number" == typeof e.endRow ? e.endRow : void 0, this.includeSpanned = !!e.includeSpanned, this.column = "number" == typeof e.column ? e.column : void 0, this._skipRows = new Set(), this._row = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }

      _createClass(Pp, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "next",
        value: function next() {
          var t = this.table.getChild(this._row);
          if (!t || this._isOverEndRow()) return {
            done: !0
          };
          var e, n, i;
          if (this._isSpanned(this._row, this._column)) e = this._getSpanned(this._row, this._column), n = !this.includeSpanned || this._shouldSkipRow() || this._shouldSkipColumn(), i = this._formatOutValue(e, this._column, !0);else {
            if (e = t.getChild(this._cellIndex), !e) return this._row++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();

            var _o98 = parseInt(e.getAttribute("colspan") || 1),
                _r53 = parseInt(e.getAttribute("rowspan") || 1);

            (_o98 > 1 || _r53 > 1) && this._recordSpans(this._row, this._column, _r53, _o98, e), this._nextCellAtColumn = this._column + _o98, n = this._shouldSkipRow() || this._shouldSkipColumn(), i = this._formatOutValue(e, this._column, !1, _r53, _o98);
          }
          return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, n ? this.next() : i;
        }
      }, {
        key: "skipRow",
        value: function skipRow(t) {
          this._skipRows.add(t);
        }
      }, {
        key: "_isOverEndRow",
        value: function _isOverEndRow() {
          return void 0 !== this.endRow && this._row > this.endRow;
        }
      }, {
        key: "_formatOutValue",
        value: function _formatOutValue(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
          var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
          return {
            done: !1,
            value: {
              cell: t,
              row: this._row,
              column: e,
              isSpanned: n,
              rowspan: i,
              colspan: o,
              cellIndex: this._cellIndex
            }
          };
        }
      }, {
        key: "_shouldSkipRow",
        value: function _shouldSkipRow() {
          var t = this._row < this.startRow,
              e = this._skipRows.has(this._row);

          return t || e;
        }
      }, {
        key: "_shouldSkipColumn",
        value: function _shouldSkipColumn() {
          return void 0 !== this.column && this.column != this._column;
        }
      }, {
        key: "_isSpanned",
        value: function _isSpanned(t, e) {
          if (!this._spannedCells.has(t)) return !1;
          return this._spannedCells.get(t).has(e);
        }
      }, {
        key: "_getSpanned",
        value: function _getSpanned(t, e) {
          return this._spannedCells.get(t).get(e);
        }
      }, {
        key: "_recordSpans",
        value: function _recordSpans(t, e, n, i, o) {
          for (var _n236 = e + 1; _n236 <= e + i - 1; _n236++) {
            this._markSpannedCell(t, _n236, o);
          }

          for (var _r54 = t + 1; _r54 < t + n; _r54++) {
            for (var _t306 = e; _t306 <= e + i - 1; _t306++) {
              this._markSpannedCell(_r54, _t306, o);
            }
          }
        }
      }, {
        key: "_markSpannedCell",
        value: function _markSpannedCell(t, e, n) {
          this._spannedCells.has(t) || this._spannedCells.set(t, new Map()), this._spannedCells.get(t).set(e, n);
        }
      }]);

      return Pp;
    }();

    function Sp(t) {
      return !!t.getCustomProperty("table") && pu(t);
    }

    function Mp(t) {
      var e = t.getSelectedElement();
      return e && Sp(e) ? e : null;
    }

    function Ep(t) {
      var e = vp("table", t.getFirstPosition());
      return e && Sp(e.parent) ? e.parent : null;
    }

    function Ip() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:table", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          i.consumable.consume(o, "attribute:headingRows:table"), i.consumable.consume(o, "attribute:headingColumns:table");
          var r = t && t.asWidget,
              s = i.writer.createContainerElement("figure", {
            class: "table"
          }),
              a = i.writer.createContainerElement("table");
          var c;
          i.writer.insert(i.writer.createPositionAt(s, 0), a), r && (c = function (t, e) {
            return e.setCustomProperty("table", !0, t), bu(t, e, {
              hasSelectionHandle: !0
            });
          }(s, i.writer));
          var l = new Pp(o),
              d = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              h = new Map();
          var _iteratorNormalCompletion351 = true;
          var _didIteratorError351 = false;
          var _iteratorError351 = undefined;

          try {
            for (var _iterator351 = l[Symbol.iterator](), _step351; !(_iteratorNormalCompletion351 = (_step351 = _iterator351.next()).done); _iteratorNormalCompletion351 = true) {
              var _e266 = _step351.value;

              var _n237 = _e266.row,
                  _r55 = _e266.cell,
                  _s33 = Up(Fp(_n237, d), a, i),
                  _c9 = o.getChild(_n237),
                  _l5 = h.get(_n237) || zp(_c9, _n237, _s33, i);

              h.set(_n237, _l5), i.consumable.consume(_r55, "insert"), Vp(_e266, d, i.writer.createPositionAt(_l5, "end"), i, t);
            }
          } catch (err) {
            _didIteratorError351 = true;
            _iteratorError351 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion351 && _iterator351.return != null) {
                _iterator351.return();
              }
            } finally {
              if (_didIteratorError351) {
                throw _iteratorError351;
              }
            }
          }

          var u = i.mapper.toViewPosition(n.range.start);
          i.mapper.bindElements(o, r ? c : s), i.writer.insert(u, r ? c : s);
        });
      };
    }

    function Np() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:tableRow", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          var r = o.parent,
              s = Yp(i.mapper.toViewElement(r)),
              a = r.getChildIndex(o),
              c = new Pp(r, {
            startRow: a,
            endRow: a
          }),
              l = {
            headingRows: r.getAttribute("headingRows") || 0,
            headingColumns: r.getAttribute("headingColumns") || 0
          },
              d = new Map();
          var _iteratorNormalCompletion352 = true;
          var _didIteratorError352 = false;
          var _iteratorError352 = undefined;

          try {
            for (var _iterator352 = c[Symbol.iterator](), _step352; !(_iteratorNormalCompletion352 = (_step352 = _iterator352.next()).done); _iteratorNormalCompletion352 = true) {
              var _e267 = _step352.value;

              var _n238 = Up(Fp(a, l), s, i),
                  _r56 = d.get(a) || zp(o, a, _n238, i);

              d.set(a, _r56), i.consumable.consume(_e267.cell, "insert"), Vp(_e267, l, i.writer.createPositionAt(_r56, "end"), i, t);
            }
          } catch (err) {
            _didIteratorError352 = true;
            _iteratorError352 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion352 && _iterator352.return != null) {
                _iterator352.return();
              }
            } finally {
              if (_didIteratorError352) {
                throw _iteratorError352;
              }
            }
          }
        });
      };
    }

    function Op() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:tableCell", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          var r = o.parent,
              s = r.parent,
              a = s.getChildIndex(r),
              c = new Pp(s, {
            startRow: a,
            endRow: a
          }),
              l = {
            headingRows: s.getAttribute("headingRows") || 0,
            headingColumns: s.getAttribute("headingColumns") || 0
          };
          var _iteratorNormalCompletion353 = true;
          var _didIteratorError353 = false;
          var _iteratorError353 = undefined;

          try {
            for (var _iterator353 = c[Symbol.iterator](), _step353; !(_iteratorNormalCompletion353 = (_step353 = _iterator353.next()).done); _iteratorNormalCompletion353 = true) {
              var _e268 = _step353.value;

              if (_e268.cell === o) {
                var _n239 = i.mapper.toViewElement(r);

                return void Vp(_e268, l, i.writer.createPositionAt(_n239, r.getChildIndex(o)), i, t);
              }
            }
          } catch (err) {
            _didIteratorError353 = true;
            _iteratorError353 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion353 && _iterator353.return != null) {
                _iterator353.return();
              }
            } finally {
              if (_didIteratorError353) {
                throw _iteratorError353;
              }
            }
          }
        });
      };
    }

    function Rp() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.asWidget;
      return function (t) {
        return t.on("attribute:headingRows:table", function (t, n, i) {
          var o = n.item;
          if (!i.consumable.consume(n.item, t.name)) return;
          var r = Yp(i.mapper.toViewElement(o)),
              s = n.attributeOldValue,
              a = n.attributeNewValue;

          if (a > s) {
            var _t307 = Array.from(o.getChildren()).filter(function (_ref109) {
              var t = _ref109.index;
              return c(t, s - 1, a);
            });

            Wp(_t307, Up("thead", r, i), i, "end");
            var _iteratorNormalCompletion354 = true;
            var _didIteratorError354 = false;
            var _iteratorError354 = undefined;

            try {
              for (var _iterator354 = _t307[Symbol.iterator](), _step354; !(_iteratorNormalCompletion354 = (_step354 = _iterator354.next()).done); _iteratorNormalCompletion354 = true) {
                var _n240 = _step354.value;
                var _iteratorNormalCompletion355 = true;
                var _didIteratorError355 = false;
                var _iteratorError355 = undefined;

                try {
                  for (var _iterator355 = _n240.getChildren()[Symbol.iterator](), _step355; !(_iteratorNormalCompletion355 = (_step355 = _iterator355.next()).done); _iteratorNormalCompletion355 = true) {
                    var _t308 = _step355.value;
                    Lp(_t308, "th", i, e);
                  }
                } catch (err) {
                  _didIteratorError355 = true;
                  _iteratorError355 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion355 && _iterator355.return != null) {
                      _iterator355.return();
                    }
                  } finally {
                    if (_didIteratorError355) {
                      throw _iteratorError355;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError354 = true;
              _iteratorError354 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion354 && _iterator354.return != null) {
                  _iterator354.return();
                }
              } finally {
                if (_didIteratorError354) {
                  throw _iteratorError354;
                }
              }
            }

            qp("tbody", r, i);
          } else {
            Wp(Array.from(o.getChildren()).filter(function (_ref110) {
              var t = _ref110.index;
              return c(t, a - 1, s);
            }).reverse(), Up("tbody", r, i), i, 0);

            var _t309 = new Pp(o, {
              startRow: a ? a - 1 : a,
              endRow: s - 1
            }),
                _n241 = {
              headingRows: o.getAttribute("headingRows") || 0,
              headingColumns: o.getAttribute("headingColumns") || 0
            };

            var _iteratorNormalCompletion356 = true;
            var _didIteratorError356 = false;
            var _iteratorError356 = undefined;

            try {
              for (var _iterator356 = _t309[Symbol.iterator](), _step356; !(_iteratorNormalCompletion356 = (_step356 = _iterator356.next()).done); _iteratorNormalCompletion356 = true) {
                var _o99 = _step356.value;
                jp(_o99, _n241, i, e);
              }
            } catch (err) {
              _didIteratorError356 = true;
              _iteratorError356 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion356 && _iterator356.return != null) {
                  _iterator356.return();
                }
              } finally {
                if (_didIteratorError356) {
                  throw _iteratorError356;
                }
              }
            }

            qp("thead", r, i);
          }

          function c(t, e, n) {
            return t > e && t < n;
          }
        });
      };
    }

    function Dp() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.asWidget;
      return function (t) {
        return t.on("attribute:headingColumns:table", function (t, n, i) {
          var o = n.item;
          if (!i.consumable.consume(n.item, t.name)) return;
          var r = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              s = n.attributeOldValue,
              a = n.attributeNewValue,
              c = (s > a ? s : a) - 1;
          var _iteratorNormalCompletion357 = true;
          var _didIteratorError357 = false;
          var _iteratorError357 = undefined;

          try {
            for (var _iterator357 = new Pp(o)[Symbol.iterator](), _step357; !(_iteratorNormalCompletion357 = (_step357 = _iterator357.next()).done); _iteratorNormalCompletion357 = true) {
              var _t310 = _step357.value;
              _t310.column > c || jp(_t310, r, i, e);
            }
          } catch (err) {
            _didIteratorError357 = true;
            _iteratorError357 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion357 && _iterator357.return != null) {
                _iterator357.return();
              }
            } finally {
              if (_didIteratorError357) {
                throw _iteratorError357;
              }
            }
          }
        });
      };
    }

    function Lp(t, e, n, i) {
      var o = n.writer,
          r = n.mapper.toViewElement(t);
      if (!r) return;
      var s;

      if (i) {
        s = ku(o.createEditableElement(e, r.getAttributes()), o), o.insert(o.createPositionAfter(r), s), o.move(o.createRangeIn(r), o.createPositionAt(s, 0)), o.remove(o.createRangeOn(r));
      } else s = o.rename(e, r);

      n.mapper.unbindViewElement(r), n.mapper.bindElements(t, s);
    }

    function jp(t, e, n, i) {
      var o = t.cell,
          r = Bp(t, e),
          s = n.mapper.toViewElement(o);
      s && s.name !== r && Lp(o, r, n, i);
    }

    function Vp(t, e, n, i, o) {
      var r = o && o.asWidget,
          s = Bp(t, e),
          a = r ? ku(i.writer.createEditableElement(s), i.writer) : i.writer.createContainerElement(s),
          c = t.cell,
          l = c.getChild(0),
          d = 1 === c.childCount && "paragraph" === l.name;

      if (i.writer.insert(n, a), d && !_toConsumableArray(l.getAttributeKeys()).length) {
        var _t311 = c.getChild(0),
            _e269 = i.writer.createPositionAt(a, "end");

        if (i.consumable.consume(_t311, "insert"), o.asWidget) {
          var _n242 = i.writer.createContainerElement("span");

          i.mapper.bindElements(_t311, _n242), i.writer.insert(_e269, _n242), i.mapper.bindElements(c, a);
        } else i.mapper.bindElements(c, a), i.mapper.bindElements(_t311, a);
      } else i.mapper.bindElements(c, a);
    }

    function zp(t, e, n, i) {
      i.consumable.consume(t, "insert");
      var o = i.writer.createContainerElement("tr");
      i.mapper.bindElements(t, o);
      var r = t.parent.getAttribute("headingRows") || 0,
          s = r > 0 && e >= r ? e - r : e,
          a = i.writer.createPositionAt(n, s);
      return i.writer.insert(a, o), o;
    }

    function Bp(t, e) {
      var n = t.row,
          i = t.column,
          o = e.headingColumns,
          r = e.headingRows;
      return r && r > n ? "th" : o && o > i ? "th" : "td";
    }

    function Fp(t, e) {
      return t < e.headingRows ? "thead" : "tbody";
    }

    function Up(t, e, n) {
      var i = Hp(t, e);
      return i || function (t, e, n) {
        var i = n.writer.createContainerElement(t),
            o = n.writer.createPositionAt(e, "tbody" == t ? "end" : 0);
        return n.writer.insert(o, i), i;
      }(t, e, n);
    }

    function Hp(t, e) {
      var _iteratorNormalCompletion358 = true;
      var _didIteratorError358 = false;
      var _iteratorError358 = undefined;

      try {
        for (var _iterator358 = e.getChildren()[Symbol.iterator](), _step358; !(_iteratorNormalCompletion358 = (_step358 = _iterator358.next()).done); _iteratorNormalCompletion358 = true) {
          var _n243 = _step358.value;
          if (_n243.name == t) return _n243;
        }
      } catch (err) {
        _didIteratorError358 = true;
        _iteratorError358 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion358 && _iterator358.return != null) {
            _iterator358.return();
          }
        } finally {
          if (_didIteratorError358) {
            throw _iteratorError358;
          }
        }
      }
    }

    function qp(t, e, n) {
      var i = Hp(t, e);
      i && 0 === i.childCount && n.writer.remove(n.writer.createRangeOn(i));
    }

    function Wp(t, e, n, i) {
      var _iteratorNormalCompletion359 = true;
      var _didIteratorError359 = false;
      var _iteratorError359 = undefined;

      try {
        for (var _iterator359 = t[Symbol.iterator](), _step359; !(_iteratorNormalCompletion359 = (_step359 = _iterator359.next()).done); _iteratorNormalCompletion359 = true) {
          var _o100 = _step359.value;

          var _t312 = n.mapper.toViewElement(_o100);

          _t312 && n.writer.move(n.writer.createRangeOn(_t312), n.writer.createPositionAt(e, i));
        }
      } catch (err) {
        _didIteratorError359 = true;
        _iteratorError359 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion359 && _iterator359.return != null) {
            _iterator359.return();
          }
        } finally {
          if (_didIteratorError359) {
            throw _iteratorError359;
          }
        }
      }
    }

    function Yp(t) {
      var _iteratorNormalCompletion360 = true;
      var _didIteratorError360 = false;
      var _iteratorError360 = undefined;

      try {
        for (var _iterator360 = t.getChildren()[Symbol.iterator](), _step360; !(_iteratorNormalCompletion360 = (_step360 = _iterator360.next()).done); _iteratorNormalCompletion360 = true) {
          var _e270 = _step360.value;
          if ("table" === _e270.name) return _e270;
        }
      } catch (err) {
        _didIteratorError360 = true;
        _iteratorError360 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion360 && _iterator360.return != null) {
            _iterator360.return();
          }
        } finally {
          if (_didIteratorError360) {
            throw _iteratorError360;
          }
        }
      }
    }

    var $p =
    /*#__PURE__*/
    function (_Rd21) {
      _inherits($p, _Rd21);

      function $p() {
        _classCallCheck(this, $p);

        return _possibleConstructorReturn(this, _getPrototypeOf($p).apply(this, arguments));
      }

      _createClass($p, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema,
              i = function (t) {
            var e = t.parent;
            return e === e.root ? e : e.parent;
          }(e.getFirstPosition());

          this.isEnabled = n.checkChild(i, "table");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var e = this.editor.model,
              n = e.document.selection,
              i = this.editor.plugins.get("TableUtils"),
              o = parseInt(t.rows) || 2,
              r = parseInt(t.columns) || 2,
              s = _u(n, e);

          e.change(function (t) {
            var n = i.createTable(t, o, r);
            e.insertContent(n, s), t.setSelection(t.createPositionAt(n.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }]);

      return $p;
    }(Rd);

    var Gp =
    /*#__PURE__*/
    function (_Rd22) {
      _inherits(Gp, _Rd22);

      function Gp(t) {
        var _this237;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Gp);

        _this237 = _possibleConstructorReturn(this, _getPrototypeOf(Gp).call(this, t)), _this237.order = e.order || "below";
        return _this237;
      }

      _createClass(Gp, [{
        key: "refresh",
        value: function refresh() {
          var t = vp("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = vp("tableCell", e.getFirstPosition()).parent,
              o = i.parent,
              r = o.getChildIndex(i),
              s = "below" === this.order ? r + 1 : r;
          n.insertRows(o, {
            rows: 1,
            at: s
          });
        }
      }]);

      return Gp;
    }(Rd);

    var Qp =
    /*#__PURE__*/
    function (_Rd23) {
      _inherits(Qp, _Rd23);

      function Qp(t) {
        var _this238;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Qp);

        _this238 = _possibleConstructorReturn(this, _getPrototypeOf(Qp).call(this, t)), _this238.order = e.order || "right";
        return _this238;
      }

      _createClass(Qp, [{
        key: "refresh",
        value: function refresh() {
          var t = vp("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = vp("tableCell", e.getFirstPosition()),
              o = i.parent.parent,
              _n$getCellLocation = n.getCellLocation(i),
              r = _n$getCellLocation.column,
              s = "right" === this.order ? r + 1 : r;

          n.insertColumns(o, {
            columns: 1,
            at: s
          });
        }
      }]);

      return Qp;
    }(Rd);

    var Kp =
    /*#__PURE__*/
    function (_Rd24) {
      _inherits(Kp, _Rd24);

      function Kp(t) {
        var _this239;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Kp);

        _this239 = _possibleConstructorReturn(this, _getPrototypeOf(Kp).call(this, t)), _this239.direction = e.direction || "horizontally";
        return _this239;
      }

      _createClass(Kp, [{
        key: "refresh",
        value: function refresh() {
          var t = vp("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = vp("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = "horizontally" === this.direction,
              n = this.editor.plugins.get("TableUtils");
          e ? n.splitCellHorizontally(t, 2) : n.splitCellVertically(t, 2);
        }
      }]);

      return Kp;
    }(Rd);

    var Jp =
    /*#__PURE__*/
    function (_Rd25) {
      _inherits(Jp, _Rd25);

      function Jp(t, e) {
        var _this240;

        _classCallCheck(this, Jp);

        _this240 = _possibleConstructorReturn(this, _getPrototypeOf(Jp).call(this, t)), _this240.direction = e.direction, _this240.isHorizontal = "right" == _this240.direction || "left" == _this240.direction;
        return _this240;
      }

      _createClass(Jp, [{
        key: "refresh",
        value: function refresh() {
          var t = this._getMergeableCell();

          this.value = t, this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this241 = this;

          var t = this.editor.model,
              e = vp("tableCell", t.document.selection.getFirstPosition()),
              n = this.value,
              i = this.direction;
          t.change(function (t) {
            var o = "right" == i || "down" == i,
                r = o ? e : n,
                s = o ? n : e,
                a = s.parent;
            !function (t, e, n) {
              Zp(t) || (Zp(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
              n.remove(t);
            }(s, r, t);
            var c = _this241.isHorizontal ? "colspan" : "rowspan",
                l = parseInt(e.getAttribute(c) || 1),
                d = parseInt(n.getAttribute(c) || 1);
            t.setAttribute(c, l + d, r), t.setSelection(t.createRangeIn(r)), a.childCount || function (t, e) {
              var n = t.parent,
                  i = n.getChildIndex(t);
              var _iteratorNormalCompletion361 = true;
              var _didIteratorError361 = false;
              var _iteratorError361 = undefined;

              try {
                for (var _iterator361 = new Pp(n, {
                  endRow: i
                })[Symbol.iterator](), _step361; !(_iteratorNormalCompletion361 = (_step361 = _iterator361.next()).done); _iteratorNormalCompletion361 = true) {
                  var _ref112 = _step361.value;
                  var _t313 = _ref112.cell;
                  var _o101 = _ref112.row;
                  var _r57 = _ref112.rowspan;
                  _o101 + _r57 - 1 >= i && yp("rowspan", _r57 - 1, _t313, e);
                }
              } catch (err) {
                _didIteratorError361 = true;
                _iteratorError361 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion361 && _iterator361.return != null) {
                    _iterator361.return();
                  }
                } finally {
                  if (_didIteratorError361) {
                    throw _iteratorError361;
                  }
                }
              }

              e.remove(t);
            }(a, t);
          });
        }
      }, {
        key: "_getMergeableCell",
        value: function _getMergeableCell() {
          var t = vp("tableCell", this.editor.model.document.selection.getFirstPosition());
          if (!t) return;
          var e = this.editor.plugins.get("TableUtils"),
              n = this.isHorizontal ? function (t, e, n) {
            var i = t.parent.parent,
                o = "right" == e ? t.nextSibling : t.previousSibling,
                r = i.getAttribute("headingColumns") || 0;
            if (!o) return;

            var s = "right" == e ? t : o,
                a = "right" == e ? o : t,
                _n$getCellLocation2 = n.getCellLocation(s),
                c = _n$getCellLocation2.column,
                _n$getCellLocation3 = n.getCellLocation(a),
                l = _n$getCellLocation3.column,
                d = parseInt(s.getAttribute("colspan") || 1),
                h = parseInt(a.getAttribute("colspan") || 1),
                u = "right" == e && l + h > r,
                f = "left" == e && c + d > r - 1;

            if (r && (u || f)) return;
            return c + d === l ? o : void 0;
          }(t, this.direction, e) : function (t, e) {
            var n = t.parent,
                i = n.parent,
                o = i.getChildIndex(n);
            if ("down" == e && o === i.childCount - 1 || "up" == e && 0 === o) return;
            var r = parseInt(t.getAttribute("rowspan") || 1),
                s = i.getAttribute("headingRows") || 0,
                a = "down" == e && o + r === s,
                c = "up" == e && o === s;
            if (s && (a || c)) return;

            var l = parseInt(t.getAttribute("rowspan") || 1),
                d = "down" == e ? o + l : o,
                h = _toConsumableArray(new Pp(i, {
              endRow: d
            })),
                u = h.find(function (e) {
              return e.cell === t;
            }).column,
                f = h.find(function (_ref113) {
              var t = _ref113.row,
                  n = _ref113.rowspan,
                  i = _ref113.column;
              return i === u && ("down" == e ? t === d : d === t + n);
            });

            return f && f.cell;
          }(t, this.direction);
          if (!n) return;
          var i = this.isHorizontal ? "rowspan" : "colspan",
              o = parseInt(t.getAttribute(i) || 1);
          return parseInt(n.getAttribute(i) || 1) === o ? n : void 0;
        }
      }]);

      return Jp;
    }(Rd);

    function Zp(t) {
      return 1 == t.childCount && t.getChild(0).is("paragraph") && t.getChild(0).isEmpty;
    }

    var Xp =
    /*#__PURE__*/
    function (_Rd26) {
      _inherits(Xp, _Rd26);

      function Xp() {
        _classCallCheck(this, Xp);

        return _possibleConstructorReturn(this, _getPrototypeOf(Xp).apply(this, arguments));
      }

      _createClass(Xp, [{
        key: "refresh",
        value: function refresh() {
          var t = vp("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t && t.parent.parent.childCount > 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = vp("tableCell", t.document.selection.getFirstPosition()).parent,
              n = e.parent,
              i = n.getChildIndex(e),
              o = n.getAttribute("headingRows") || 0;
          t.change(function (t) {
            o && i <= o && yp("headingRows", o - 1, n, t, 0);

            var r = _toConsumableArray(new Pp(n, {
              endRow: i
            })),
                s = new Map();

            r.filter(function (_ref114) {
              var t = _ref114.row,
                  e = _ref114.rowspan;
              return t === i && e > 1;
            }).forEach(function (_ref115) {
              var t = _ref115.column,
                  e = _ref115.cell,
                  n = _ref115.rowspan;
              return s.set(t, {
                cell: e,
                rowspanToSet: n - 1
              });
            }), r.filter(function (_ref116) {
              var t = _ref116.row,
                  e = _ref116.rowspan;
              return t <= i - 1 && t + e > i;
            }).forEach(function (_ref117) {
              var e = _ref117.cell,
                  n = _ref117.rowspan;
              return yp("rowspan", n - 1, e, t);
            });
            var a = i + 1,
                c = new Pp(n, {
              includeSpanned: !0,
              startRow: a,
              endRow: a
            });
            var l;

            for (var _i200 = 0, _arr2 = _toConsumableArray(c); _i200 < _arr2.length; _i200++) {
              var _ref119 = _arr2[_i200];
              var _e271 = _ref119.row;
              var _i201 = _ref119.column;
              var _o102 = _ref119.cell;

              if (s.has(_i201)) {
                var _s$get = s.get(_i201),
                    _o103 = _s$get.cell,
                    _r58 = _s$get.rowspanToSet,
                    _a18 = l ? t.createPositionAfter(l) : t.createPositionAt(n.getChild(_e271), 0);

                t.move(t.createRangeOn(_o103), _a18), yp("rowspan", _r58, _o103, t), l = _o103;
              } else l = _o102;
            }

            t.remove(e);
          });
        }
      }]);

      return Xp;
    }(Rd);

    var tb =
    /*#__PURE__*/
    function (_Rd27) {
      _inherits(tb, _Rd27);

      function tb() {
        _classCallCheck(this, tb);

        return _possibleConstructorReturn(this, _getPrototypeOf(tb).apply(this, arguments));
      }

      _createClass(tb, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = vp("tableCell", e.getFirstPosition());
          this.isEnabled = !!i && n.getColumns(i.parent.parent) > 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = vp("tableCell", t.document.selection.getFirstPosition()),
              n = e.parent,
              i = n.parent,
              o = i.getAttribute("headingColumns") || 0,
              r = i.getChildIndex(n),
              s = _toConsumableArray(new Pp(i)),
              a = s.find(function (t) {
            return t.cell === e;
          }).column;

          t.change(function (t) {
            o && r <= o && t.setAttribute("headingColumns", o - 1, i);
            var _iteratorNormalCompletion362 = true;
            var _didIteratorError362 = false;
            var _iteratorError362 = undefined;

            try {
              for (var _iterator362 = s[Symbol.iterator](), _step362; !(_iteratorNormalCompletion362 = (_step362 = _iterator362.next()).done); _iteratorNormalCompletion362 = true) {
                var _ref121 = _step362.value;
                var _e272 = _ref121.cell;
                var _n244 = _ref121.column;
                var _i202 = _ref121.colspan;
                _n244 <= a && _i202 > 1 && _n244 + _i202 > a ? yp("colspan", _i202 - 1, _e272, t) : _n244 === a && t.remove(_e272);
              }
            } catch (err) {
              _didIteratorError362 = true;
              _iteratorError362 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion362 && _iterator362.return != null) {
                  _iterator362.return();
                }
              } finally {
                if (_didIteratorError362) {
                  throw _iteratorError362;
                }
              }
            }
          });
        }
      }]);

      return tb;
    }(Rd);

    var eb =
    /*#__PURE__*/
    function (_Rd28) {
      _inherits(eb, _Rd28);

      function eb() {
        _classCallCheck(this, eb);

        return _possibleConstructorReturn(this, _getPrototypeOf(eb).apply(this, arguments));
      }

      _createClass(eb, [{
        key: "refresh",
        value: function refresh() {
          var t = vp("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = !!t;
          this.isEnabled = e, this.value = e && this._isInHeading(t, t.parent.parent);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = vp("tableCell", e.document.selection.getFirstPosition()).parent,
              i = n.parent,
              o = i.getAttribute("headingRows") || 0,
              r = n.index;
          if (t.forceValue === this.value) return;
          var s = this.value ? r : r + 1;
          e.change(function (t) {
            if (s) {
              var _e273 = function (t, e, n) {
                var i = [],
                    o = new Pp(t, {
                  startRow: e > n ? n : 0,
                  endRow: e - 1
                });
                var _iteratorNormalCompletion363 = true;
                var _didIteratorError363 = false;
                var _iteratorError363 = undefined;

                try {
                  for (var _iterator363 = o[Symbol.iterator](), _step363; !(_iteratorNormalCompletion363 = (_step363 = _iterator363.next()).done); _iteratorNormalCompletion363 = true) {
                    var _ref123 = _step363.value;
                    var _t314 = _ref123.row;
                    var _n245 = _ref123.rowspan;
                    var _r59 = _ref123.cell;
                    _n245 > 1 && _t314 + _n245 > e && i.push(_r59);
                  }
                } catch (err) {
                  _didIteratorError363 = true;
                  _iteratorError363 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion363 && _iterator363.return != null) {
                      _iterator363.return();
                    }
                  } finally {
                    if (_didIteratorError363) {
                      throw _iteratorError363;
                    }
                  }
                }

                return i;
              }(i, s, o);

              var _iteratorNormalCompletion364 = true;
              var _didIteratorError364 = false;
              var _iteratorError364 = undefined;

              try {
                for (var _iterator364 = _e273[Symbol.iterator](), _step364; !(_iteratorNormalCompletion364 = (_step364 = _iterator364.next()).done); _iteratorNormalCompletion364 = true) {
                  var _n246 = _step364.value;
                  nb(_n246, s, t);
                }
              } catch (err) {
                _didIteratorError364 = true;
                _iteratorError364 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion364 && _iterator364.return != null) {
                    _iterator364.return();
                  }
                } finally {
                  if (_didIteratorError364) {
                    throw _iteratorError364;
                  }
                }
              }
            }

            yp("headingRows", s, i, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingRows") || 0);
          return !!n && t.parent.index < n;
        }
      }]);

      return eb;
    }(Rd);

    function nb(t, e, n) {
      var i = t.parent,
          o = i.parent,
          r = e - i.index,
          s = {},
          a = parseInt(t.getAttribute("rowspan")) - r;
      a > 1 && (s.rowspan = a);
      var c = parseInt(t.getAttribute("colspan") || 1);
      c > 1 && (s.colspan = c);

      var l = o.getChildIndex(i),
          d = l + r,
          h = _toConsumableArray(new Pp(o, {
        startRow: l,
        endRow: d,
        includeSpanned: !0
      }));

      var u;
      var _iteratorNormalCompletion365 = true;
      var _didIteratorError365 = false;
      var _iteratorError365 = undefined;

      try {
        for (var _iterator365 = h[Symbol.iterator](), _step365; !(_iteratorNormalCompletion365 = (_step365 = _iterator365.next()).done); _iteratorNormalCompletion365 = true) {
          var _ref125 = _step365.value;
          var _e274 = _ref125.row;
          var _i203 = _ref125.column;
          var _r60 = _ref125.cell;
          var _a19 = _ref125.cellIndex;

          if (_r60 === t && void 0 === u && (u = _i203), void 0 !== u && u === _i203 && _e274 === d) {
            var _t315 = o.getChild(_e274),
                _i204 = n.createPositionAt(_t315, _a19);

            xp(n, _i204, s);
          }
        }
      } catch (err) {
        _didIteratorError365 = true;
        _iteratorError365 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion365 && _iterator365.return != null) {
            _iterator365.return();
          }
        } finally {
          if (_didIteratorError365) {
            throw _iteratorError365;
          }
        }
      }

      yp("rowspan", r, t, n);
    }

    var ib =
    /*#__PURE__*/
    function (_Rd29) {
      _inherits(ib, _Rd29);

      function ib() {
        _classCallCheck(this, ib);

        return _possibleConstructorReturn(this, _getPrototypeOf(ib).apply(this, arguments));
      }

      _createClass(ib, [{
        key: "refresh",
        value: function refresh() {
          var t = vp("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = !!t;
          this.isEnabled = e, this.value = e && this._isInHeading(t, t.parent.parent);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var e = this.editor.model,
              n = e.document.selection,
              i = this.editor.plugins.get("TableUtils"),
              o = vp("tableCell", n.getFirstPosition()),
              r = o.parent.parent,
              _i$getCellLocation = i.getCellLocation(o),
              s = _i$getCellLocation.column;

          if (t.forceValue === this.value) return;
          var a = this.value ? s : s + 1;
          e.change(function (t) {
            yp("headingColumns", a, r, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingColumns") || 0),
              i = this.editor.plugins.get("TableUtils"),
              _i$getCellLocation2 = i.getCellLocation(t),
              o = _i$getCellLocation2.column;

          return !!n && o < n;
        }
      }]);

      return ib;
    }(Rd);

    var ob =
    /*#__PURE__*/
    function (_Md51) {
      _inherits(ob, _Md51);

      function ob() {
        _classCallCheck(this, ob);

        return _possibleConstructorReturn(this, _getPrototypeOf(ob).apply(this, arguments));
      }

      _createClass(ob, [{
        key: "getCellLocation",
        value: function getCellLocation(t) {
          var e = t.parent,
              n = e.parent,
              i = n.getChildIndex(e),
              o = new Pp(n, {
            startRow: i,
            endRow: i
          });
          var _iteratorNormalCompletion366 = true;
          var _didIteratorError366 = false;
          var _iteratorError366 = undefined;

          try {
            for (var _iterator366 = o[Symbol.iterator](), _step366; !(_iteratorNormalCompletion366 = (_step366 = _iterator366.next()).done); _iteratorNormalCompletion366 = true) {
              var _ref127 = _step366.value;
              var _e275 = _ref127.cell;
              var _n247 = _ref127.row;
              var _i205 = _ref127.column;
              if (_e275 === t) return {
                row: _n247,
                column: _i205
              };
            }
          } catch (err) {
            _didIteratorError366 = true;
            _iteratorError366 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion366 && _iterator366.return != null) {
                _iterator366.return();
              }
            } finally {
              if (_didIteratorError366) {
                throw _iteratorError366;
              }
            }
          }
        }
      }, {
        key: "createTable",
        value: function createTable(t, e, n) {
          var i = t.createElement("table");
          return rb(t, i, 0, e, n), i;
        }
      }, {
        key: "insertRows",
        value: function insertRows(t) {
          var _this242 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = e.at || 0,
              o = e.rows || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingRows") || 0;
            if (n > i && e.setAttribute("headingRows", n + o, t), 0 === i || i === t.childCount) return void rb(e, t, i, o, _this242.getColumns(t));
            var r = new Pp(t, {
              endRow: i
            });
            var s = 0;
            var _iteratorNormalCompletion367 = true;
            var _didIteratorError367 = false;
            var _iteratorError367 = undefined;

            try {
              for (var _iterator367 = r[Symbol.iterator](), _step367; !(_iteratorNormalCompletion367 = (_step367 = _iterator367.next()).done); _iteratorNormalCompletion367 = true) {
                var _ref129 = _step367.value;
                var _t316 = _ref129.row;
                var _n248 = _ref129.rowspan;
                var _a20 = _ref129.colspan;
                var _c10 = _ref129.cell;

                var _r61 = _t316 + _n248 > i;

                _t316 < i && _r61 && e.setAttribute("rowspan", _n248 + o, _c10), _t316 === i && (s += _a20);
              }
            } catch (err) {
              _didIteratorError367 = true;
              _iteratorError367 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion367 && _iterator367.return != null) {
                  _iterator367.return();
                }
              } finally {
                if (_didIteratorError367) {
                  throw _iteratorError367;
                }
              }
            }

            rb(e, t, i, o, s);
          });
        }
      }, {
        key: "insertColumns",
        value: function insertColumns(t) {
          var _this243 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = e.at || 0,
              o = e.columns || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingColumns");
            i < n && e.setAttribute("headingColumns", n + o, t);

            var r = _this243.getColumns(t);

            if (0 === i || r === i) {
              var _iteratorNormalCompletion368 = true;
              var _didIteratorError368 = false;
              var _iteratorError368 = undefined;

              try {
                for (var _iterator368 = t.getChildren()[Symbol.iterator](), _step368; !(_iteratorNormalCompletion368 = (_step368 = _iterator368.next()).done); _iteratorNormalCompletion368 = true) {
                  var _n249 = _step368.value;
                  sb(o, e, e.createPositionAt(_n249, i ? "end" : 0));
                }
              } catch (err) {
                _didIteratorError368 = true;
                _iteratorError368 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion368 && _iterator368.return != null) {
                    _iterator368.return();
                  }
                } finally {
                  if (_didIteratorError368) {
                    throw _iteratorError368;
                  }
                }
              }

              return;
            }

            var s = new Pp(t, {
              column: i,
              includeSpanned: !0
            });
            var _iteratorNormalCompletion369 = true;
            var _didIteratorError369 = false;
            var _iteratorError369 = undefined;

            try {
              for (var _iterator369 = s[Symbol.iterator](), _step369; !(_iteratorNormalCompletion369 = (_step369 = _iterator369.next()).done); _iteratorNormalCompletion369 = true) {
                var _ref131 = _step369.value;
                var _n250 = _ref131.row;
                var _r62 = _ref131.cell;
                var _a21 = _ref131.cellIndex;

                var _c11 = parseInt(_r62.getAttribute("rowspan") || 1),
                    _l6 = parseInt(_r62.getAttribute("colspan") || 1);

                if (_r62.index !== i && _l6 > 1) {
                  if (e.setAttribute("colspan", _l6 + o, _r62), s.skipRow(_n250), _c11 > 1) for (var _t317 = _n250 + 1; _t317 < _n250 + _c11; _t317++) {
                    s.skipRow(_t317);
                  }
                } else {
                  var _i206 = e.createPositionAt(t.getChild(_n250), _a21);

                  sb(o, e, _i206);
                }
              }
            } catch (err) {
              _didIteratorError369 = true;
              _iteratorError369 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion369 && _iterator369.return != null) {
                  _iterator369.return();
                }
              } finally {
                if (_didIteratorError369) {
                  throw _iteratorError369;
                }
              }
            }
          });
        }
      }, {
        key: "splitCellVertically",
        value: function splitCellVertically(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
              i = t.parent.parent,
              o = parseInt(t.getAttribute("rowspan") || 1),
              r = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (r > 1) {
              var _ab = ab(r, e),
                  _i207 = _ab.newCellsSpan,
                  _s34 = _ab.updatedSpan;

              yp("colspan", _s34, t, n);
              var _a22 = {};
              _i207 > 1 && (_a22.colspan = _i207), o > 1 && (_a22.rowspan = o), sb(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), _a22);
            }

            if (r < e) {
              var _s35 = e - r,
                  _a23 = _toConsumableArray(new Pp(i)),
                  _a23$find = _a23.find(function (_ref132) {
                var e = _ref132.cell;
                return e === t;
              }),
                  _c12 = _a23$find.column,
                  _l7 = _a23.filter(function (_ref133) {
                var e = _ref133.cell,
                    n = _ref133.colspan,
                    i = _ref133.column;
                return e !== t && i === _c12 || i < _c12 && i + n > _c12;
              });

              var _iteratorNormalCompletion370 = true;
              var _didIteratorError370 = false;
              var _iteratorError370 = undefined;

              try {
                for (var _iterator370 = _l7[Symbol.iterator](), _step370; !(_iteratorNormalCompletion370 = (_step370 = _iterator370.next()).done); _iteratorNormalCompletion370 = true) {
                  var _ref135 = _step370.value;
                  var _t318 = _ref135.cell;
                  var _e276 = _ref135.colspan;
                  n.setAttribute("colspan", _e276 + _s35, _t318);
                }
              } catch (err) {
                _didIteratorError370 = true;
                _iteratorError370 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion370 && _iterator370.return != null) {
                    _iterator370.return();
                  }
                } finally {
                  if (_didIteratorError370) {
                    throw _iteratorError370;
                  }
                }
              }

              var _d3 = {};
              o > 1 && (_d3.rowspan = o), sb(_s35, n, n.createPositionAfter(t), _d3);

              var _h3 = i.getAttribute("headingColumns") || 0;

              _h3 > _c12 && yp("headingColumns", _h3 + _s35, i, n);
            }
          });
        }
      }, {
        key: "splitCellHorizontally",
        value: function splitCellHorizontally(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
              i = t.parent,
              o = i.parent,
              r = o.getChildIndex(i),
              s = parseInt(t.getAttribute("rowspan") || 1),
              a = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (s > 1) {
              var _i208 = _toConsumableArray(new Pp(o, {
                startRow: r,
                endRow: r + s - 1,
                includeSpanned: !0
              })),
                  _ab2 = ab(s, e),
                  _c13 = _ab2.newCellsSpan,
                  _l8 = _ab2.updatedSpan;

              yp("rowspan", _l8, t, n);

              var _i208$find = _i208.find(function (_ref136) {
                var e = _ref136.cell;
                return e === t;
              }),
                  _d4 = _i208$find.column,
                  _h4 = {};

              _c13 > 1 && (_h4.rowspan = _c13), a > 1 && (_h4.colspan = a);

              for (var _i210 = 0, _i209 = _i208; _i210 < _i209.length; _i210++) {
                var _ref138 = _i209[_i210];
                var _t319 = _ref138.column;
                var _e277 = _ref138.row;
                var _s36 = _ref138.cellIndex;

                var _i211 = _t319 === _d4,
                    _a24 = (_e277 + r + _l8) % _c13 == 0;

                if (_e277 >= r + _l8 && _i211 && _a24) {
                  var _t320 = n.createPositionAt(o.getChild(_e277), _s36);

                  sb(1, n, _t320, _h4);
                }
              }
            }

            if (s < e) {
              var _i212 = e - s,
                  _c14 = _toConsumableArray(new Pp(o, {
                startRow: 0,
                endRow: r
              }));

              var _iteratorNormalCompletion371 = true;
              var _didIteratorError371 = false;
              var _iteratorError371 = undefined;

              try {
                for (var _iterator371 = _c14[Symbol.iterator](), _step371; !(_iteratorNormalCompletion371 = (_step371 = _iterator371.next()).done); _iteratorNormalCompletion371 = true) {
                  var _ref140 = _step371.value;
                  var _e278 = _ref140.cell;
                  var _o104 = _ref140.rowspan;
                  var _s37 = _ref140.row;

                  if (_e278 !== t && _s37 + _o104 > r) {
                    var _t321 = _o104 + _i212;

                    n.setAttribute("rowspan", _t321, _e278);
                  }
                }
              } catch (err) {
                _didIteratorError371 = true;
                _iteratorError371 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion371 && _iterator371.return != null) {
                    _iterator371.return();
                  }
                } finally {
                  if (_didIteratorError371) {
                    throw _iteratorError371;
                  }
                }
              }

              var _l9 = {};
              a > 1 && (_l9.colspan = a), rb(n, o, r + 1, _i212, 1, _l9);

              var _d5 = o.getAttribute("headingRows") || 0;

              _d5 > r && yp("headingRows", _d5 + _i212, o, n);
            }
          });
        }
      }, {
        key: "getColumns",
        value: function getColumns(t) {
          return _toConsumableArray(t.getChild(0).getChildren()).reduce(function (t, e) {
            return t + parseInt(e.getAttribute("colspan") || 1);
          }, 0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUtils";
        }
      }]);

      return ob;
    }(Md);

    function rb(t, e, n, i, o) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      for (var _s38 = 0; _s38 < i; _s38++) {
        var _i213 = t.createElement("tableRow");

        t.insert(_i213, e, n), sb(o, t, t.createPositionAt(_i213, "end"), r);
      }
    }

    function sb(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      for (var _o105 = 0; _o105 < t; _o105++) {
        xp(e, n, i);
      }
    }

    function ab(t, e) {
      if (t < e) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      var n = Math.floor(t / e);
      return {
        newCellsSpan: n,
        updatedSpan: t - n * e + n
      };
    }

    function cb(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var i = !1;
          var o = new Set();
          var _iteratorNormalCompletion372 = true;
          var _didIteratorError372 = false;
          var _iteratorError372 = undefined;

          try {
            for (var _iterator372 = n[Symbol.iterator](), _step372; !(_iteratorNormalCompletion372 = (_step372 = _iterator372.next()).done); _iteratorNormalCompletion372 = true) {
              var _e279 = _step372.value;

              var _n251 = void 0;

              "table" == _e279.name && "insert" == _e279.type && (_n251 = _e279.position.nodeAfter), "tableRow" != _e279.name && "tableCell" != _e279.name || (_n251 = vp("table", _e279.position)), hb(_e279) && (_n251 = vp("table", _e279.range.start)), _n251 && !o.has(_n251) && (i = lb(_n251, t) || i, i = db(_n251, t) || i, o.add(_n251));
            }
          } catch (err) {
            _didIteratorError372 = true;
            _iteratorError372 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion372 && _iterator372.return != null) {
                _iterator372.return();
              }
            } finally {
              if (_didIteratorError372) {
                throw _iteratorError372;
              }
            }
          }

          return i;
        }(e, t);
      });
    }

    function lb(t, e) {
      var n = !1;

      var i = function (t) {
        var e = parseInt(t.getAttribute("headingRows") || 0),
            n = t.childCount,
            i = [];
        var _iteratorNormalCompletion373 = true;
        var _didIteratorError373 = false;
        var _iteratorError373 = undefined;

        try {
          for (var _iterator373 = new Pp(t)[Symbol.iterator](), _step373; !(_iteratorNormalCompletion373 = (_step373 = _iterator373.next()).done); _iteratorNormalCompletion373 = true) {
            var _ref142 = _step373.value;
            var _o106 = _ref142.row;
            var _r63 = _ref142.rowspan;
            var _s39 = _ref142.cell;
            if (_r63 < 2) continue;

            var _t322 = _o106 < e ? e : n;

            if (_o106 + _r63 > _t322) {
              var _e280 = _t322 - _o106;

              i.push({
                cell: _s39,
                rowspan: _e280
              });
            }
          }
        } catch (err) {
          _didIteratorError373 = true;
          _iteratorError373 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion373 && _iterator373.return != null) {
              _iterator373.return();
            }
          } finally {
            if (_didIteratorError373) {
              throw _iteratorError373;
            }
          }
        }

        return i;
      }(t);

      if (i.length) {
        n = !0;
        var _iteratorNormalCompletion374 = true;
        var _didIteratorError374 = false;
        var _iteratorError374 = undefined;

        try {
          for (var _iterator374 = i[Symbol.iterator](), _step374; !(_iteratorNormalCompletion374 = (_step374 = _iterator374.next()).done); _iteratorNormalCompletion374 = true) {
            var _t323 = _step374.value;
            yp("rowspan", _t323.rowspan, _t323.cell, e, 1);
          }
        } catch (err) {
          _didIteratorError374 = true;
          _iteratorError374 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion374 && _iterator374.return != null) {
              _iterator374.return();
            }
          } finally {
            if (_didIteratorError374) {
              throw _iteratorError374;
            }
          }
        }
      }

      return n;
    }

    function db(t, e) {
      var n = !1;

      var i = function (t) {
        var e = {};
        var _iteratorNormalCompletion375 = true;
        var _didIteratorError375 = false;
        var _iteratorError375 = undefined;

        try {
          for (var _iterator375 = new Pp(t, {
            includeSpanned: !0
          })[Symbol.iterator](), _step375; !(_iteratorNormalCompletion375 = (_step375 = _iterator375.next()).done); _iteratorNormalCompletion375 = true) {
            var _ref144 = _step375.value;
            var _n252 = _ref144.row;
            e[_n252] || (e[_n252] = 0), e[_n252] += 1;
          }
        } catch (err) {
          _didIteratorError375 = true;
          _iteratorError375 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion375 && _iterator375.return != null) {
              _iterator375.return();
            }
          } finally {
            if (_didIteratorError375) {
              throw _iteratorError375;
            }
          }
        }

        return e;
      }(t),
          o = i[0];

      if (!Object.values(i).every(function (t) {
        return t === o;
      })) {
        var _o107 = Object.values(i).reduce(function (t, e) {
          return e > t ? e : t;
        }, 0);

        for (var _i214 = 0, _Object$entries2 = Object.entries(i); _i214 < _Object$entries2.length; _i214++) {
          var _ref147 = _Object$entries2[_i214];

          var _ref146 = _slicedToArray(_ref147, 2);

          var _r64 = _ref146[0];
          var _s40 = _ref146[1];

          var _i215 = _o107 - _s40;

          if (_i215) {
            for (var _n253 = 0; _n253 < _i215; _n253++) {
              xp(e, e.createPositionAt(t.getChild(_r64), "end"));
            }

            n = !0;
          }
        }
      }

      return n;
    }

    function hb(t) {
      var e = "attribute" === t.type,
          n = t.attributeKey;
      return e && ("headingRows" === n || "colspan" === n || "rowspan" === n);
    }

    function ub(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var i = !1;
          var _iteratorNormalCompletion376 = true;
          var _didIteratorError376 = false;
          var _iteratorError376 = undefined;

          try {
            for (var _iterator376 = n[Symbol.iterator](), _step376; !(_iteratorNormalCompletion376 = (_step376 = _iterator376.next()).done); _iteratorNormalCompletion376 = true) {
              var _e281 = _step376.value;
              "insert" == _e281.type && "table" == _e281.name && (i = fb(_e281.position.nodeAfter, t) || i), "insert" == _e281.type && "tableRow" == _e281.name && (i = gb(_e281.position.nodeAfter, t) || i), "insert" == _e281.type && "tableCell" == _e281.name && (i = mb(_e281.position.nodeAfter, t) || i), pb(_e281) && (i = mb(_e281.position.parent, t) || i);
            }
          } catch (err) {
            _didIteratorError376 = true;
            _iteratorError376 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion376 && _iterator376.return != null) {
                _iterator376.return();
              }
            } finally {
              if (_didIteratorError376) {
                throw _iteratorError376;
              }
            }
          }

          return i;
        }(e, t);
      });
    }

    function fb(t, e) {
      var n = !1;
      var _iteratorNormalCompletion377 = true;
      var _didIteratorError377 = false;
      var _iteratorError377 = undefined;

      try {
        for (var _iterator377 = t.getChildren()[Symbol.iterator](), _step377; !(_iteratorNormalCompletion377 = (_step377 = _iterator377.next()).done); _iteratorNormalCompletion377 = true) {
          var _i216 = _step377.value;
          n = gb(_i216, e) || n;
        }
      } catch (err) {
        _didIteratorError377 = true;
        _iteratorError377 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion377 && _iterator377.return != null) {
            _iterator377.return();
          }
        } finally {
          if (_didIteratorError377) {
            throw _iteratorError377;
          }
        }
      }

      return n;
    }

    function gb(t, e) {
      var n = !1;
      var _iteratorNormalCompletion378 = true;
      var _didIteratorError378 = false;
      var _iteratorError378 = undefined;

      try {
        for (var _iterator378 = t.getChildren()[Symbol.iterator](), _step378; !(_iteratorNormalCompletion378 = (_step378 = _iterator378.next()).done); _iteratorNormalCompletion378 = true) {
          var _i217 = _step378.value;
          n = mb(_i217, e) || n;
        }
      } catch (err) {
        _didIteratorError378 = true;
        _iteratorError378 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion378 && _iterator378.return != null) {
            _iterator378.return();
          }
        } finally {
          if (_didIteratorError378) {
            throw _iteratorError378;
          }
        }
      }

      return n;
    }

    function mb(t, e) {
      if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
      var n = Array.from(t.getChildren()).filter(function (t) {
        return t.is("text");
      });
      var _iteratorNormalCompletion379 = true;
      var _didIteratorError379 = false;
      var _iteratorError379 = undefined;

      try {
        for (var _iterator379 = n[Symbol.iterator](), _step379; !(_iteratorNormalCompletion379 = (_step379 = _iterator379.next()).done); _iteratorNormalCompletion379 = true) {
          var _t324 = _step379.value;
          e.wrap(e.createRangeOn(_t324), "paragraph");
        }
      } catch (err) {
        _didIteratorError379 = true;
        _iteratorError379 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion379 && _iterator379.return != null) {
            _iterator379.return();
          }
        } finally {
          if (_didIteratorError379) {
            throw _iteratorError379;
          }
        }
      }

      return !!n.length;
    }

    function pb(t) {
      return !(!t.position || !t.position.parent.is("tableCell")) && ("insert" == t.type && "$text" == t.name || "remove" == t.type);
    }

    function bb(t) {
      t.document.registerPostFixer(function () {
        return function (t) {
          var e = t.document.differ,
              n = new Set();
          var _iteratorNormalCompletion380 = true;
          var _didIteratorError380 = false;
          var _iteratorError380 = undefined;

          try {
            for (var _iterator380 = e.getChanges()[Symbol.iterator](), _step380; !(_iteratorNormalCompletion380 = (_step380 = _iterator380.next()).done); _iteratorNormalCompletion380 = true) {
              var _t326 = _step380.value;

              var _e282 = "insert" == _t326.type || "remove" == _t326.type ? _t326.position.parent : _t326.range.start.parent;

              _e282.is("tableCell") && wb(_e282, _t326.type) && n.add(_e282);
            }
          } catch (err) {
            _didIteratorError380 = true;
            _iteratorError380 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion380 && _iterator380.return != null) {
                _iterator380.return();
              }
            } finally {
              if (_didIteratorError380) {
                throw _iteratorError380;
              }
            }
          }

          if (n.size) {
            var _iteratorNormalCompletion381 = true;
            var _didIteratorError381 = false;
            var _iteratorError381 = undefined;

            try {
              for (var _iterator381 = n.values()[Symbol.iterator](), _step381; !(_iteratorNormalCompletion381 = (_step381 = _iterator381.next()).done); _iteratorNormalCompletion381 = true) {
                var _t325 = _step381.value;
                e.refreshItem(_t325);
              }
            } catch (err) {
              _didIteratorError381 = true;
              _iteratorError381 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion381 && _iterator381.return != null) {
                  _iterator381.return();
                }
              } finally {
                if (_didIteratorError381) {
                  throw _iteratorError381;
                }
              }
            }

            return !0;
          }

          return !1;
        }(t);
      });
    }

    function wb(t, e) {
      if (!Array.from(t.getChildren()).some(function (t) {
        return t.is("paragraph");
      })) return !1;

      if ("attribute" == e) {
        var _e283 = Array.from(t.getChild(0).getAttributeKeys()).length;
        return 1 === t.childCount && _e283 < 2;
      }

      return t.childCount <= ("insert" == e ? 2 : 1);
    }

    n(84);

    var kb =
    /*#__PURE__*/
    function (_Md52) {
      _inherits(kb, _Md52);

      function kb() {
        _classCallCheck(this, kb);

        return _possibleConstructorReturn(this, _getPrototypeOf(kb).apply(this, arguments));
      }

      _createClass(kb, [{
        key: "init",
        value: function init() {
          var _this244 = this;

          var t = this.editor,
              e = t.model,
              n = e.schema,
              i = t.conversion;
          n.register("table", {
            allowWhere: "$block",
            allowAttributes: ["headingRows", "headingColumns"],
            isLimit: !0,
            isObject: !0,
            isBlock: !0
          }), n.register("tableRow", {
            allowIn: "table",
            isLimit: !0
          }), n.register("tableCell", {
            allowIn: "tableRow",
            allowAttributes: ["colspan", "rowspan"],
            isLimit: !0
          }), n.extend("$block", {
            allowIn: "tableCell"
          }), n.addChildCheck(function (t, e) {
            if ("table" == e.name && Array.from(t.getNames()).includes("table")) return !1;
          }), i.for("upcast").add(Ap()), i.for("editingDowncast").add(Ip({
            asWidget: !0
          })), i.for("dataDowncast").add(Ip()), i.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
          }), i.for("editingDowncast").add(Np({
            asWidget: !0
          })), i.for("dataDowncast").add(Np()), i.for("downcast").add(function (t) {
            return t.on("remove:tableRow", function (t, e, n) {
              t.stop();
              var i = n.writer,
                  o = n.mapper,
                  r = o.toViewPosition(e.position).getLastMatchingPosition(function (t) {
                return !t.item.is("tr");
              }).nodeAfter,
                  s = r.parent,
                  a = i.createRangeOn(r),
                  c = i.remove(a);
              var _iteratorNormalCompletion382 = true;
              var _didIteratorError382 = false;
              var _iteratorError382 = undefined;

              try {
                for (var _iterator382 = i.createRangeIn(c).getItems()[Symbol.iterator](), _step382; !(_iteratorNormalCompletion382 = (_step382 = _iterator382.next()).done); _iteratorNormalCompletion382 = true) {
                  var _t327 = _step382.value;
                  o.unbindViewElement(_t327);
                }
              } catch (err) {
                _didIteratorError382 = true;
                _iteratorError382 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion382 && _iterator382.return != null) {
                    _iterator382.return();
                  }
                } finally {
                  if (_didIteratorError382) {
                    throw _iteratorError382;
                  }
                }
              }

              s.childCount || i.remove(i.createRangeOn(s));
            }, {
              priority: "higher"
            });
          }), i.for("upcast").add(Tp("td")), i.for("upcast").add(Tp("th")), i.for("editingDowncast").add(Op({
            asWidget: !0
          })), i.for("dataDowncast").add(Op()), i.attributeToAttribute({
            model: "colspan",
            view: "colspan"
          }), i.attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
          }), i.for("editingDowncast").add(Dp({
            asWidget: !0
          })), i.for("dataDowncast").add(Dp()), i.for("editingDowncast").add(Rp({
            asWidget: !0
          })), i.for("dataDowncast").add(Rp()), t.commands.add("insertTable", new $p(t)), t.commands.add("insertTableRowAbove", new Gp(t, {
            order: "above"
          })), t.commands.add("insertTableRowBelow", new Gp(t, {
            order: "below"
          })), t.commands.add("insertTableColumnLeft", new Qp(t, {
            order: "left"
          })), t.commands.add("insertTableColumnRight", new Qp(t, {
            order: "right"
          })), t.commands.add("removeTableRow", new Xp(t)), t.commands.add("removeTableColumn", new tb(t)), t.commands.add("splitTableCellVertically", new Kp(t, {
            direction: "vertically"
          })), t.commands.add("splitTableCellHorizontally", new Kp(t, {
            direction: "horizontally"
          })), t.commands.add("mergeTableCellRight", new Jp(t, {
            direction: "right"
          })), t.commands.add("mergeTableCellLeft", new Jp(t, {
            direction: "left"
          })), t.commands.add("mergeTableCellDown", new Jp(t, {
            direction: "down"
          })), t.commands.add("mergeTableCellUp", new Jp(t, {
            direction: "up"
          })), t.commands.add("setTableColumnHeader", new ib(t)), t.commands.add("setTableRowHeader", new eb(t)), cb(e), bb(e), ub(e), this.editor.keystrokes.set("Tab", function () {
            return _this244._handleTabOnSelectedTable.apply(_this244, arguments);
          }, {
            priority: "low"
          }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
            priority: "low"
          }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
            priority: "low"
          });
        }
      }, {
        key: "_handleTabOnSelectedTable",
        value: function _handleTabOnSelectedTable(t, e) {
          var n = this.editor,
              i = n.model.document.selection;

          if (!i.isCollapsed && 1 === i.rangeCount && i.getFirstRange().isFlat) {
            var _t328 = i.getSelectedElement();

            if (!_t328 || !_t328.is("table")) return;
            e(), n.model.change(function (e) {
              e.setSelection(e.createRangeIn(_t328.getChild(0).getChild(0)));
            });
          }
        }
      }, {
        key: "_getTabHandler",
        value: function _getTabHandler(t) {
          var e = this.editor;
          return function (n, i) {
            var o = vp("tableCell", e.model.document.selection.getFirstPosition());
            if (!o) return;
            i();
            var r = o.parent,
                s = r.parent,
                a = s.getChildIndex(r),
                c = r.getChildIndex(o),
                l = 0 === c;
            if (!t && l && 0 === a) return;
            var d = c === r.childCount - 1,
                h = a === s.childCount - 1;
            if (t && h && d && (e.execute("insertTableRowBelow"), a === s.childCount - 1)) return;
            var u;

            if (t && d) {
              var _t329 = s.getChild(a + 1);

              u = _t329.getChild(0);
            } else if (!t && l) {
              var _t330 = s.getChild(a - 1);

              u = _t330.getChild(_t330.childCount - 1);
            } else u = r.getChild(c + (t ? 1 : -1));

            e.model.change(function (t) {
              t.setSelection(t.createRangeIn(u));
            });
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [ob];
        }
      }]);

      return kb;
    }(Md);

    n(86);

    var _b =
    /*#__PURE__*/
    function (_Wl27) {
      _inherits(_b, _Wl27);

      function _b(t) {
        var _this245;

        _classCallCheck(this, _b);

        _this245 = _possibleConstructorReturn(this, _getPrototypeOf(_b).call(this, t));
        var e = _this245.bindTemplate;
        _this245.items = _this245.createCollection(), _this245.set("rows", 0), _this245.set("columns", 0), _this245.bind("label").to(_assertThisInitialized(_this245), "columns", _assertThisInitialized(_this245), "rows", function (t, e) {
          return "".concat(e, " \xD7 ").concat(t);
        }), _this245.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            children: _this245.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__label"]
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function () {
              _this245.fire("execute");
            })
          }
        });

        var _loop9 = function _loop9(_t331) {
          var e = new vb();
          e.on("over", function () {
            var e = Math.floor(_t331 / 10),
                n = _t331 % 10;
            _this245.set("rows", e + 1), _this245.set("columns", n + 1);
          }), _this245.items.add(e);
        };

        for (var _t331 = 0; _t331 < 100; _t331++) {
          _loop9(_t331);
        }

        _this245.on("change:columns", function () {
          _this245._highlightGridBoxes();
        }), _this245.on("change:rows", function () {
          _this245._highlightGridBoxes();
        });
        return _this245;
      }

      _createClass(_b, [{
        key: "focus",
        value: function focus() {}
      }, {
        key: "focusLast",
        value: function focusLast() {}
      }, {
        key: "_highlightGridBoxes",
        value: function _highlightGridBoxes() {
          var t = this.rows,
              e = this.columns;
          this.items.map(function (n, i) {
            var o = Math.floor(i / 10) < t && i % 10 < e;
            n.set("isOn", o);
          });
        }
      }]);

      return _b;
    }(Wl);

    var vb =
    /*#__PURE__*/
    function (_Wl28) {
      _inherits(vb, _Wl28);

      function vb(t) {
        var _this246;

        _classCallCheck(this, vb);

        _this246 = _possibleConstructorReturn(this, _getPrototypeOf(vb).call(this, t));
        var e = _this246.bindTemplate;
        _this246.set("isOn", !1), _this246.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-insert-table-dropdown-grid-box", e.if("isOn", "ck-on")]
          },
          on: {
            mouseover: e.to("over")
          }
        });
        return _this246;
      }

      return vb;
    }(Wl);

    var yb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
        xb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>',
        Ab = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>',
        Tb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>';

    var Cb =
    /*#__PURE__*/
    function (_Md53) {
      _inherits(Cb, _Md53);

      function Cb() {
        _classCallCheck(this, Cb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Cb).apply(this, arguments));
      }

      _createClass(Cb, [{
        key: "init",
        value: function init() {
          var _this247 = this;

          var t = this.editor,
              e = this.editor.t,
              n = "ltr" === t.locale.contentLanguageDirection;
          t.ui.componentFactory.add("insertTable", function (n) {
            var i = t.commands.get("insertTable"),
                o = _d(n);

            o.bind("isEnabled").to(i), o.buttonView.set({
              icon: yb,
              label: e("m"),
              tooltip: !0
            });
            var r = new _b(n);
            return o.panelView.children.add(r), r.delegate("execute").to(o), o.buttonView.on("open", function () {
              r.rows = 0, r.columns = 0;
            }), o.on("execute", function () {
              t.execute("insertTable", {
                rows: r.rows,
                columns: r.columns
              }), t.editing.view.focus();
            }), o;
          }), t.ui.componentFactory.add("tableColumn", function (t) {
            var i = [{
              type: "switchbutton",
              model: {
                commandName: "setTableColumnHeader",
                label: e("n"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: n ? "insertTableColumnLeft" : "insertTableColumnRight",
                label: e("o")
              }
            }, {
              type: "button",
              model: {
                commandName: n ? "insertTableColumnRight" : "insertTableColumnLeft",
                label: e("p")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableColumn",
                label: e("q")
              }
            }];
            return _this247._prepareDropdown(e("r"), xb, i, t);
          }), t.ui.componentFactory.add("tableRow", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableRowHeader",
                label: e("s"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowBelow",
                label: e("t")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowAbove",
                label: e("u")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableRow",
                label: e("v")
              }
            }];
            return _this247._prepareDropdown(e("w"), Ab, n, t);
          }), t.ui.componentFactory.add("mergeTableCells", function (t) {
            var i = [{
              type: "button",
              model: {
                commandName: "mergeTableCellUp",
                label: e("x")
              }
            }, {
              type: "button",
              model: {
                commandName: n ? "mergeTableCellRight" : "mergeTableCellLeft",
                label: e("y")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellDown",
                label: e("z")
              }
            }, {
              type: "button",
              model: {
                commandName: n ? "mergeTableCellLeft" : "mergeTableCellRight",
                label: e("aa")
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellVertically",
                label: e("ab")
              }
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellHorizontally",
                label: e("ac")
              }
            }];
            return _this247._prepareDropdown(e("ad"), Tb, i, t);
          });
        }
      }, {
        key: "_prepareDropdown",
        value: function _prepareDropdown(t, e, n, i) {
          var o = this.editor,
              r = _d(i),
              s = [],
              a = new ro();

          var _iteratorNormalCompletion383 = true;
          var _didIteratorError383 = false;
          var _iteratorError383 = undefined;

          try {
            for (var _iterator383 = n[Symbol.iterator](), _step383; !(_iteratorNormalCompletion383 = (_step383 = _iterator383.next()).done); _iteratorNormalCompletion383 = true) {
              var _t332 = _step383.value;
              Pb(_t332, o, s, a);
            }
          } catch (err) {
            _didIteratorError383 = true;
            _iteratorError383 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion383 && _iterator383.return != null) {
                _iterator383.return();
              }
            } finally {
              if (_didIteratorError383) {
                throw _iteratorError383;
              }
            }
          }

          return vd(r, a), r.buttonView.set({
            label: t,
            icon: e,
            tooltip: !0
          }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
            for (var _len20 = arguments.length, t = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
              t[_key20] = arguments[_key20];
            }

            return t.some(function (t) {
              return t;
            });
          }), this.listenTo(r, "execute", function (t) {
            o.execute(t.source.commandName), o.editing.view.focus();
          }), r;
        }
      }]);

      return Cb;
    }(Md);

    function Pb(t, e, n, i) {
      var o = t.model = new Lg(t.model),
          _t$model = t.model,
          r = _t$model.commandName,
          s = _t$model.bindIsOn;

      if ("separator" !== t.type) {
        var _t333 = e.commands.get(r);

        n.push(_t333), o.set({
          commandName: r
        }), o.bind("isEnabled").to(_t333), s && o.bind("isOn").to(_t333, "value");
      }

      o.set({
        withText: !0
      }), i.add(t);
    }

    n(88);
    n.d(e, "default", function () {
      return Sb;
    });

    var Sb =
    /*#__PURE__*/
    function (_Sd) {
      _inherits(Sb, _Sd);

      function Sb() {
        _classCallCheck(this, Sb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Sb).apply(this, arguments));
      }

      return Sb;
    }(Sd);

    Sb.builtinPlugins = [
    /*#__PURE__*/
    function (_Md54) {
      _inherits(_class2, _Md54);

      function _class2() {
        _classCallCheck(this, _class2);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
      }

      _createClass(_class2, null, [{
        key: "requires",
        get: function get() {
          return [Od, Bd, qd, oh, Th];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Essentials";
        }
      }]);

      return _class2;
    }(Md), Rh,
    /*#__PURE__*/
    function (_Md55) {
      _inherits(_class3, _Md55);

      function _class3() {
        _classCallCheck(this, _class3);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
      }

      _createClass(_class3, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var t = this.editor.commands;
          t.get("bulletedList") && new Lh(this.editor, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && new Lh(this.editor, /^1[.|)]\s$/, "numberedList");
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var t = this.editor.commands;

          if (t.get("bold")) {
            var _t334 = zh(this.editor, "bold");

            new jh(this.editor, /(\*\*)([^*]+)(\*\*)$/g, _t334), new jh(this.editor, /(__)([^_]+)(__)$/g, _t334);
          }

          if (t.get("italic")) {
            var _t335 = zh(this.editor, "italic");

            new jh(this.editor, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, _t335), new jh(this.editor, /(?:^|[^_])(_)([^_]+)(_)$/g, _t335);
          }

          if (t.get("code")) {
            var _t336 = zh(this.editor, "code");

            new jh(this.editor, /(`)([^`]+)(`)$/g, _t336);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this248 = this;

          var t = this.editor.commands.get("heading");
          t && t.modelElements.filter(function (t) {
            return t.match(/^heading[1-6]$/);
          }).forEach(function (e) {
            var n = e[7],
                i = new RegExp("^(#{".concat(n, "})\\s$"));
            new Lh(_this248.editor, i, function () {
              if (!t.isEnabled) return !1;

              _this248.editor.execute("heading", {
                value: e
              });
            });
          });
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && new Lh(this.editor, /^>\s$/, "blockQuote");
        }
      }, {
        key: "_addCodeBlockAutoformats",
        value: function _addCodeBlockAutoformats() {
          this.editor.commands.get("codeBlock") && new Lh(this.editor, /^```$/, "codeBlock");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);

      return _class3;
    }(Md),
    /*#__PURE__*/
    function (_Md56) {
      _inherits(_class4, _Md56);

      function _class4() {
        _classCallCheck(this, _class4);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class4).apply(this, arguments));
      }

      _createClass(_class4, null, [{
        key: "requires",
        get: function get() {
          return [Uh, Wh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Bold";
        }
      }]);

      return _class4;
    }(Md),
    /*#__PURE__*/
    function (_Md57) {
      _inherits(_class5, _Md57);

      function _class5() {
        _classCallCheck(this, _class5);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class5).apply(this, arguments));
      }

      _createClass(_class5, null, [{
        key: "requires",
        get: function get() {
          return [$h, Kh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Italic";
        }
      }]);

      return _class5;
    }(Md),
    /*#__PURE__*/
    function (_Md58) {
      _inherits(_class6, _Md58);

      function _class6() {
        _classCallCheck(this, _class6);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class6).apply(this, arguments));
      }

      _createClass(_class6, null, [{
        key: "requires",
        get: function get() {
          return [nu, ou];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);

      return _class6;
    }(Md),
    /*#__PURE__*/
    function (_Md59) {
      _inherits(_class7, _Md59);

      function _class7() {
        _classCallCheck(this, _class7);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class7).apply(this, arguments));
      }

      _createClass(_class7, null, [{
        key: "pluginName",
        get: function get() {
          return "CKFinder";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Af, su, Rh];
        }
      }]);

      return _class7;
    }(Md),
    /*#__PURE__*/
    function (_Md60) {
      _inherits(_class8, _Md60);

      function _class8() {
        _classCallCheck(this, _class8);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class8).apply(this, arguments));
      }

      _createClass(_class8, null, [{
        key: "requires",
        get: function get() {
          return [If, ag, Cg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "EasyImage";
        }
      }]);

      return _class8;
    }(Md),
    /*#__PURE__*/
    function (_Md61) {
      _inherits(_class9, _Md61);

      function _class9() {
        _classCallCheck(this, _class9);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class9).apply(this, arguments));
      }

      _createClass(_class9, null, [{
        key: "requires",
        get: function get() {
          return [Dg, jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Heading";
        }
      }]);

      return _class9;
    }(Md), ag,
    /*#__PURE__*/
    function (_Md62) {
      _inherits(_class10, _Md62);

      function _class10() {
        _classCallCheck(this, _class10);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class10).apply(this, arguments));
      }

      _createClass(_class10, null, [{
        key: "requires",
        get: function get() {
          return [Bg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaption";
        }
      }]);

      return _class10;
    }(Md),
    /*#__PURE__*/
    function (_Md63) {
      _inherits(_class11, _Md63);

      function _class11() {
        _classCallCheck(this, _class11);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class11).apply(this, arguments));
      }

      _createClass(_class11, null, [{
        key: "requires",
        get: function get() {
          return [em, nm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyle";
        }
      }]);

      return _class11;
    }(Md),
    /*#__PURE__*/
    function (_Md64) {
      _inherits(_class12, _Md64);

      function _class12() {
        _classCallCheck(this, _class12);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class12).apply(this, arguments));
      }

      _createClass(_class12, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.t;
          t.plugins.get(im).register("image", {
            ariaLabel: e("b"),
            items: t.config.get("image.toolbar") || [],
            getRelatedElement: yu
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [im];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageToolbar";
        }
      }]);

      return _class12;
    }(Md), Cg,
    /*#__PURE__*/
    function (_Md65) {
      _inherits(_class13, _Md65);

      function _class13() {
        _classCallCheck(this, _class13);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class13).apply(this, arguments));
      }

      _createClass(_class13, null, [{
        key: "pluginName",
        get: function get() {
          return "Indent";
        }
      }, {
        key: "requires",
        get: function get() {
          return [am, dm];
        }
      }]);

      return _class13;
    }(Md),
    /*#__PURE__*/
    function (_Md66) {
      _inherits(_class14, _Md66);

      function _class14() {
        _classCallCheck(this, _class14);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class14).apply(this, arguments));
      }

      _createClass(_class14, null, [{
        key: "requires",
        get: function get() {
          return [_f, wm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Link";
        }
      }]);

      return _class14;
    }(Md),
    /*#__PURE__*/
    function (_Md67) {
      _inherits(_class15, _Md67);

      function _class15() {
        _classCallCheck(this, _class15);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class15).apply(this, arguments));
      }

      _createClass(_class15, null, [{
        key: "requires",
        get: function get() {
          return [qm, Gm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "List";
        }
      }]);

      return _class15;
    }(Md),
    /*#__PURE__*/
    function (_Md68) {
      _inherits(_class16, _Md68);

      function _class16() {
        _classCallCheck(this, _class16);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class16).apply(this, arguments));
      }

      _createClass(_class16, null, [{
        key: "requires",
        get: function get() {
          return [rp, dp, ap, Df];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);

      return _class16;
    }(Md), Mg,
    /*#__PURE__*/
    function (_Md69) {
      _inherits(_class17, _Md69);

      function _class17() {
        _classCallCheck(this, _class17);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class17).apply(this, arguments));
      }

      _createClass(_class17, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = [];
          e.push(new _p()), e.push(new gp()), t.plugins.get("Clipboard").on("inputTransformation", function (t, n) {
            if (n.isTransformedWithPasteFromOffice) return;
            var i = n.dataTransfer.getData("text/html"),
                o = e.find(function (t) {
              return t.isActive(i);
            });
            o && (o.execute(n), n.isTransformedWithPasteFromOffice = !0);
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Od];
        }
      }]);

      return _class17;
    }(Md),
    /*#__PURE__*/
    function (_Md70) {
      _inherits(_class18, _Md70);

      function _class18() {
        _classCallCheck(this, _class18);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class18).apply(this, arguments));
      }

      _createClass(_class18, null, [{
        key: "requires",
        get: function get() {
          return [kb, Cb, Df];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Table";
        }
      }]);

      return _class18;
    }(Md),
    /*#__PURE__*/
    function (_Md71) {
      _inherits(_class19, _Md71);

      function _class19() {
        _classCallCheck(this, _class19);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class19).apply(this, arguments));
      }

      _createClass(_class19, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.t,
              n = t.plugins.get(im),
              i = t.config.get("table.contentToolbar"),
              o = t.config.get("table.tableToolbar");
          i && n.register("tableContent", {
            ariaLabel: e("c"),
            items: i,
            getRelatedElement: Ep
          }), o && n.register("table", {
            ariaLabel: e("c"),
            items: o,
            getRelatedElement: Mp
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [im];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "TableToolbar";
        }
      }]);

      return _class19;
    }(Md)], Sb.defaultConfig = {
      toolbar: {
        items: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "imageUpload", "blockQuote", "insertTable", "mediaEmbed", "undo", "redo"]
      },
      image: {
        toolbar: ["imageStyle:full", "imageStyle:side", "|", "imageTextAlternative"]
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
      },
      language: "en"
    };
  }]).default;
});